(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ecCom"), require("antd"), require("mobx"), require("React"), require("comsMobx"), require("ReactDOM"), require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["ecCom", "antd", "mobx", "React", "comsMobx", "ReactDOM", "jQuery"], factory);
	else if(typeof exports === 'object')
		exports["weaHrm"] = factory(require("ecCom"), require("antd"), require("mobx"), require("React"), require("comsMobx"), require("ReactDOM"), require("jQuery"));
	else
		root["weaHrm"] = factory(root["ecCom"], root["antd"], root["mobx"], root["React"], root["comsMobx"], root["ReactDOM"], root["jQuery"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_48__, __WEBPACK_EXTERNAL_MODULE_545__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/spa/hrm/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 266);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(14);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(273), __esModule: true };

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(143);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(294);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(298);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(143);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onError", function() { return onError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observer", function() { return observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Observer", function() { return Observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderReporter", function() { return renderReporter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentByNodeRegistery", function() { return componentByNodeRegistery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trackComponents", function() { return trackComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStaticRendering", function() { return useStaticRendering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// These functions can be stubbed out in specific environments
var unstable_batchedUpdates$1 = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
    function EventEmitter() {
        classCallCheck(this, EventEmitter);
        this.listeners = [];
    }

    createClass(EventEmitter, [{
        key: "on",
        value: function on(cb) {
            var _this = this;

            this.listeners.push(cb);
            return function () {
                var index = _this.listeners.indexOf(cb);
                if (index !== -1) _this.listeners.splice(index, 1);
            };
        }
    }, {
        key: "emit",
        value: function emit(data) {
            this.listeners.forEach(function (fn) {
                return fn(data);
            });
        }
    }]);
    return EventEmitter;
}();

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
            rest[_key - 6] = arguments[_key];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else {
                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
            }
        });
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") {
        return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") {
        return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
    }

    return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
    if (Array.isArray(propValue)) {
        return "array";
    }
    if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
    }
    if (isSymbol(propType, propValue)) {
        return "symbol";
    }
    return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) {
            return "date";
        } else if (propValue instanceof RegExp) {
            return "regexp";
        }
    }
    return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker = void 0;
            switch (mobxType) {
                case "Array":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableArray"];
                    break;
                case "Object":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableObject"];
                    break;
                case "Map":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableMap"];
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
            rest[_key2 - 5] = arguments[_key2];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            }
            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
            if (error instanceof Error) return error;
            var propValue = props[propName];
            for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
            }
            return null;
        });
    });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
    mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
    contextTypes: {
        get: function get$$1() {
            return injectorContextTypes;
        },
        set: function set$$1(_) {
            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
        },
        configurable: true,
        enumerable: false
    },
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }

    /**
     * Store Injection
     */
};function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp2;

    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
    if (injectNames) displayName += "-with-" + injectNames;

    var Injector = (_temp2 = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            var _ref;

            var _temp, _this, _ret;

            classCallCheck(this, Injector);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(Injector, [{
            key: "render",
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key2 in additionalProps) {
                    newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                    newProps.ref = this.storeRef;
                }

                return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, newProps);
            }
        }]);
        return Injector;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = displayName, _temp2);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === "function") {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // supress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
        };
    }
}

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function findDOMNode$2(component) {
    if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
        } catch (e) {
            // findDOMNode will throw in react-test-renderer, see:
            // See https://github.com/mobxjs/mobx-react/issues/216
            // Is there a better heuristic?
            return null;
        }
    }
    return null;
}

function reportRendering(component) {
    var node = findDOMNode$2(component);
    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);

    renderReporter.emit({
        event: "render",
        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
        totalTime: Date.now() - component.__$mobRenderStart,
        component: component,
        node: node
    });
}

function trackComponents() {
    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillMount: function componentWillMount() {
        var _this = this;

        if (isUsingStaticRendering === true) return;
        // Generate friendly name for debugging
        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;

        /**
         * If props are shallowly modified, react will render anyway,
         * so atom.reportChanged() should not result in yet another re-render
         */
        var skipRender = false;
        /**
         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
         * so detect these changes
         */
        var isForcingUpdate = false;

        function makePropertyObservableReference(propName) {
            var valueHolder = this[propName];
            var atom = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Atom"]("reactive " + propName);
            Object.defineProperty(this, propName, {
                configurable: true,
                enumerable: true,
                get: function get$$1() {
                    atom.reportObserved();
                    return valueHolder;
                },
                set: function set$$1(v) {
                    if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
                        valueHolder = v;
                        skipRender = true;
                        atom.reportChanged();
                        skipRender = false;
                    } else {
                        valueHolder = v;
                    }
                }
            });
        }

        // make this.props an observable reference, see #124
        makePropertyObservableReference.call(this, "props");
        // make state an observable reference
        makePropertyObservableReference.call(this, "state");

        // wire up reactive render
        var baseRender = this.render.bind(this);
        var reaction = null;
        var isRenderingPending = false;

        var initialRender = function initialRender() {
            reaction = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Reaction"](initialName + "#" + rootNodeID + ".render()", function () {
                if (!isRenderingPending) {
                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                    // See #85 / Pull #44
                    isRenderingPending = true;
                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
                    if (_this.__$mobxIsUnmounted !== true) {
                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                        // However, people also claim this migth happen during unit tests..
                        var hasError = true;
                        try {
                            isForcingUpdate = true;
                            if (!skipRender) __WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.forceUpdate.call(_this);
                            hasError = false;
                        } finally {
                            isForcingUpdate = false;
                            if (hasError) reaction.dispose();
                        }
                    }
                }
            });
            reaction.reactComponent = _this;
            reactiveRender.$mobx = reaction;
            _this.render = reactiveRender;
            return reactiveRender();
        };

        var reactiveRender = function reactiveRender() {
            isRenderingPending = false;
            var exception = undefined;
            var rendering = undefined;
            reaction.track(function () {
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderStart = Date.now();
                }
                try {
                    rendering = __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].allowStateChanges(false, baseRender);
                } catch (e) {
                    exception = e;
                }
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderEnd = Date.now();
                }
            });
            if (exception) {
                errorsReporter.emit(exception);
                throw exception;
            }
            return rendering;
        };

        this.render = initialRender;
    },

    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) return;
        this.render.$mobx && this.render.$mobx.dispose();
        this.__$mobxIsUnmounted = true;
        if (isDevtoolsEnabled) {
            var node = findDOMNode$2(this);
            if (node && componentByNodeRegistery) {
                componentByNodeRegistery.delete(node);
            }
            renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
            });
        }
    },

    componentDidMount: function componentDidMount() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return !shallowEqual(this.props, nextProps);
    }

    /**
     * Observer function / decorator
     */
};function observer(arg1, arg2) {
    if (typeof arg1 === "string") {
        throw new Error("Store names should be provided as array");
    }
    if (Array.isArray(arg1)) {
        // component needs stores
        if (!warnedAboutObserverInjectDeprecation) {
            warnedAboutObserverInjectDeprecation = true;
            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
        }
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return observer(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(observer(arg2));
        }
    }
    var componentClass = arg1;

    if (componentClass.isMobxInjector === true) {
        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    }

    // Stateless function component:
    // If it is function but doesn't seem to be a react class constructor,
    // wrap it to a react class automatically
    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_1_react__["Component"].isPrototypeOf(componentClass)) {
        var _class, _temp;

        return observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: "render",
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    }

    if (!componentClass) {
        throw new Error("Please pass a valid component to 'observer'");
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    return componentClass;
}

function mixinLifecycleEvents(target) {
    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
        patch(target, funcName);
    });
    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    }
}

// TODO: support injection somehow as well?
var Observer = observer(function (_ref) {
    var children = _ref.children,
        observerInject = _ref.inject,
        render = _ref.render;

    var component = children || render;
    if (typeof component === "undefined") {
        return null;
    }
    if (!observerInject) {
        return component();
    }
    var InjectComponent = inject(observerInject)(component);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InjectComponent, null);
});

Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
    }

    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
        return;
    }
    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
    render: ObserverPropsCheck,
    children: ObserverPropsCheck
};

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
    inherits(Provider, _Component);

    function Provider() {
        classCallCheck(this, Provider);
        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    createClass(Provider, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) for (var key in baseStores) {
                stores[key] = baseStores[key];
            }
            // add own stores
            for (var _key in this.props) {
                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
            }return {
                mobxStores: stores
            };
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
            }
        }
    }]);
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.contextTypes = {
    mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
    mobxStores: objectOrObservableObject.isRequired
}, _temp);

if (!__WEBPACK_IMPORTED_MODULE_1_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_0_mobx__["extras"]) throw new Error("mobx-react requires mobx to be available");

if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].setReactionScheduler(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"]);else if (typeof unstable_batchedUpdates$1 === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].setReactionScheduler(unstable_batchedUpdates$1);

var onError = function onError(fn) {
    return errorsReporter.on(fn);
};

/* DevTool support */
// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
    var mobx$1 = { spy: __WEBPACK_IMPORTED_MODULE_0_mobx__["spy"], extras: __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"] };
    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
}




/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.i18n=undefined;var _defineProperty2=__webpack_require__(38);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _button,_confirm;var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var i18n=exports.i18n={module:{addressBook:function addressBook(){return getLabel(1515,'通讯录');},createResource:function createResource(){return getLabel(15005,'新建人员');},orgChart:function orgChart(){return getLabel(562,'组织图表');},trainRecord:function trainRecord(){return getLabel('816',"培训记录");},resourceChange:function resourceChange(){return getLabel('386396',"人员变动情况");}},label:{organization:function organization(){return getLabel(25332,'组织结构');},allCondition:function allCondition(){return getLabel(382085,'全部条件');},toBeSelected:function toBeSelected(){return getLabel(83302,'待选');},selected:function selected(){return getLabel(83303,'已选');},searchTemplateName:function searchTemplateName(){return getLabel(385087,'搜索模板名称');},commonConditions:function commonConditions(){return getLabel(32905,'常用条件');},pictureSizeSuggestedInfo:function pictureSizeSuggestedInfo(){return getLabel(386320,'建议使用的图片大小为:');},fillBasicInfo:function fillBasicInfo(){return getLabel(386322,'填写基本信息');},fillPrivateInfo:function fillPrivateInfo(){return getLabel(386323,'填写个人信息');},fillWorkInfo:function fillWorkInfo(){return getLabel(386324,'填写工作信息');},fillSysInfo:function fillSysInfo(){return getLabel(386325,'填写系统信息');},binding:function binding(){return getLabel(28032,'绑定');},dataNone:function dataNone(){return getLabel(84304,'暂无');},uploadPortrait:function uploadPortrait(){return getLabel(83080,'上传头像');},resourceCard:function resourceCard(){return getLabel(386343,'人员卡片');},fillSpecialtyIntroduction:function fillSpecialtyIntroduction(){return getLabel(386344,'请输入你的专长特点简要介绍');},specialtyIntroduction:function specialtyIntroduction(){return getLabel(383144,'专长介绍');},headImagePreview:function headImagePreview(){return getLabel(386349,'头像预览');},role:function role(){return getLabel(24055,'所属角色');},editRole:function editRole(){return getLabel(386351,'编辑所属角色');},addRole:function addRole(){return getLabel(386352,'添加所属角色');},securitySetting:function securitySetting(){return getLabel(32496,'安全设置');},all:function all(){return getLabel(82857,'全部');},today:function today(){return getLabel(130019,'今天');},yesterday:function yesterday(){return getLabel('82640',"昨天");},tswk:function tswk(){return getLabel(15539,'本周');},tsmth:function tsmth(){return getLabel(383428,'本月');},tssn:function tssn(){return getLabel(383465,'本季');},tsyr:function tsyr(){return getLabel(130017,'本年');},preMonth:function preMonth(){return getLabel(27347,'上个月');},preYear:function preYear(){return getLabel(81716,'上一年');},date:function date(){return getLabel(387106,'日期');},kqType:function kqType(){return getLabel(387107,'考勤类型');},dateRange:function dateRange(){return getLabel(32530,'指定日期范围');},sysManager:function sysManager(){return getLabel(16139,'系统管理员');},sysOpLog:function sysOpLog(){return getLabel(33258,'系统操作日志');},tokenNum:function tokenNum(){return getLabel(32897,"令牌序列号");},userKey:function userKey(){return getLabel(21597,"用户密钥");},autoEnable:function autoEnable(){return getLabel(131908,"自动启用");},enableDate:function enableDate(){return getLabel(31818,"启用日期");},enableMode:function enableMode(){return getLabel(131937,"启用方式");},sysInfo:function sysInfo(){return getLabel(15804,"系统信息");},sysLogiInfo:function sysLogiInfo(){return getLabel(130940,"系统登录信息");},weekSituation:function weekSituation(){return getLabel(130941,"一周情況");},ageStatus:function ageStatus(){return getLabel('386388',"年龄状况");},genderStatus:function genderStatus(){return getLabel('386389',"性别状况");},workingAgeStatus:function workingAgeStatus(){return getLabel('386390',"工龄状况");},eduStatus:function eduStatus(){return getLabel('386391',"学历状况");},maritalStatus:function maritalStatus(){return getLabel('469',"婚姻状况");},proTitleStatus:function proTitleStatus(){return getLabel('386392',"职称统计");},rankStatus:function rankStatus(){return getLabel('386393',"职级统计");},workNature:function workNature(){return getLabel('804',"用工性质");},stateStatistics:function stateStatistics(){return getLabel('386394',"状态统计");},securtitylevel:function securtitylevel(){return getLabel('683',"安全级别");},subordinated:function subordinated(){return getLabel(30805,'的下属');},trainingArrangements:function trainingArrangements(){return getLabel('6156',"培训安排");},ranking:function ranking(){return getLabel('19082',"排名");},newTypeOfContract:function newTypeOfContract(){return getLabel('382214',"新签合同种类");},specificInformation:function specificInformation(){return getLabel('15729',"具体信息");},intoStatistics:function intoStatistics(){return getLabel('386397',"调入统计");},outOfStatistics:function outOfStatistics(){return getLabel('386405',"调出统计");},lossStatistics:function lossStatistics(){return getLabel('386398',"流失统计");},turnoverStatistics:function turnoverStatistics(){return getLabel('386399',"离职统计");},dismissalStatistics:function dismissalStatistics(){return getLabel('15978',"解聘统计");},retirementStatistics:function retirementStatistics(){return getLabel('16031',"退休统计");},newSignStatistics:function newSignStatistics(){return getLabel('386400',"新签统计");},expiryStatistics:function expiryStatistics(){return getLabel('386401',"到期统计");},newSituation:function newSituation(){return getLabel('16565',"新增情况");},correction:function correction(){return getLabel('16566',"转正情况");},mobility:function mobility(){return getLabel('16564',"调动情况");},renewTheSituation:function renewTheSituation(){return getLabel('16567',"续签情况");},returnOnTheSituation:function returnOnTheSituation(){return getLabel('16568',"返聘情况");},lossOfPersonnel:function lossOfPersonnel(){return getLabel('382249',"人员流失情况");},contractSituation:function contractSituation(){return getLabel('16572',"合同情况");},customerInfo:function customerInfo(){return getLabel('17088',"自定义信息");},templateName:function templateName(){return getLabel('28050',"模板名称");},ageRange:function ageRange(){return getLabel('15860',"年龄区间");},workingAgeRange:function workingAgeRange(){return getLabel('15927',"工龄区间");},rankingInterval:function rankingInterval(){return getLabel('15871',"职级区间");},level:function level(){return getLabel('15872',"级");},year:function year(){return getLabel('26577',"年");},signInDetail:function signInDetail(){return getLabel('20241',"签到明细");},signOutDetail:function signOutDetail(){return getLabel('20242',"签退明细");},lateDetail:function lateDetail(){return getLabel('20088',"迟到明细");},absentlateDetail:function absentlateDetail(){return getLabel('383164',"缺勤明细");},earlyRetreatDetail:function earlyRetreatDetail(){return getLabel('20089',"早退明细");},absenteeismDetail:function absenteeismDetail(){return getLabel('20090',"旷工明细");},leakageOfSignatureDetail:function leakageOfSignatureDetail(){return getLabel('20091',"漏签明细");},leaveDetail:function leaveDetail(){return getLabel('20092',"请假明细");},businessTripDetail:function businessTripDetail(){return getLabel('20093',"出差明细");},publicDetail:function publicDetail(){return getLabel('20094',"公出明细");},overtimeWorkDetail:function overtimeWorkDetail(){return getLabel('33501',"加班明细");},attendanceAnomalyDetail:function attendanceAnomalyDetail(){return getLabel('386409',"考勤异常数据抵冲明细");},reportDate:function reportDate(){return getLabel('20087',"报表生成日期");},daytime:function daytime(){return getLabel(390,'日');},day:function day(){return getLabel(1925,'天');},hour:function hour(){return getLabel('391',"小时");},month:function month(){return getLabel(6076,'月');},monday:function monday(){return getLabel(392,'星期一');},tuesday:function tuesday(){return getLabel(393,'星期二');},wednesday:function wednesday(){return getLabel(394,'星期三');},thursday:function thursday(){return getLabel(395,'星期四');},friday:function friday(){return getLabel(396,'星期五');},saturday:function saturday(){return getLabel(397,'星期六');},sunday:function sunday(){return getLabel(398,'星期日');},preview:function preview(){return getLabel(221,'预览');},select:function select(){return getLabel(126832,'选择');},'15809':function _(){return getLabel('15809',"已设置");},'15808':function _(){return getLabel('15808',"未设置");},'26471':function _(){return getLabel('26471',"停用");},'388923':function _(){return getLabel('388923',"确定要停用该人员的二次验证密码吗？");},'388924':function _(){return getLabel('388924',"为确保账户安全，请及时通知该用户重置密码！");},importResult:function importResult(){return getLabel(82341,'导入结果');}},button:(_button={collect:function collect(){return getLabel(28111,'收藏');},log:function log(){return getLabel(83,'日志');},helper:function helper(){return getLabel(275,'帮助');},search:function search(){return getLabel(82529,'搜索');},research:function research(){return getLabel('364',"重新搜索");},reset:function reset(){return getLabel(27088,'重置');},ok:function ok(){return getLabel(33703,'确定');},cancel:function cancel(){return getLabel(32694,'取消');},create:function create(){return getLabel(365,'新建');},remove:function remove(){return getLabel(20230,'移除');},delete:function _delete(){return getLabel(131966,'删除');},modify:function modify(){return getLabel(93,'编辑');},transfer:function transfer(){return getLabel(80,'转移');},multiRemove:function multiRemove(){return getLabel(383696,'批量移除');},multiDelete:function multiDelete(){return getLabel(32136,'批量删除');},save:function save(){return getLabel(30986,'保存');},saveAs:function saveAs(){return getLabel(131623,'另存为');},done:function done(){return getLabel(555,'完成');},saveAsTemplate:function saveAsTemplate(){return getLabel(18418,'存为模板');},conditionDef:function conditionDef(){return getLabel(386317,'常用条件定制');},directSubordinates:function directSubordinates(){return getLabel(386318,'显示直接下属');},DisplaySubordinateSubordinates:function DisplaySubordinateSubordinates(){return getLabel(83783,'显示下级下属');},columnVisibleSetting:function columnVisibleSetting(){return getLabel(32535,'显示列定制');},saveAndCreate:function saveAndCreate(){return getLabel(32720,'保存并新建');},fullModle:function fullModle(){return getLabel(386321,'进入完整模式');},lastStep:function lastStep(){return getLabel(1876,'上一步');},nextStep:function nextStep(){return getLabel(1402,'下一步');},back:function back(){return getLabel(1290,'返回');},scanAddContacts:function scanAddContacts(){return getLabel(385903,'扫描添加联系人');},collapse:function collapse(){return getLabel(26985,'收起');},expand:function expand(){return getLabel(15315,'展开');},companyWechat:function companyWechat(){return getLabel(383148,'微信企业号绑定');},putOn:function putOn(){return getLabel(386345,'贴上');},zoomIn:function zoomIn(){return getLabel(22209,'缩小');},zoomOut:function zoomOut(){return getLabel(22208,'放大');},clickUpload:function clickUpload(){return getLabel(386346,'点击上传');},reUpload:function reUpload(){return getLabel(131107,'重新上传');},removeHeadImg:function removeHeadImg(){return getLabel(386347,'删除头像');},rotate:function rotate(){return getLabel(386348,'旋转');}},(0,_defineProperty3.default)(_button,'multiRemove',function multiRemove(){return getLabel(383696,'批量移除');}),(0,_defineProperty3.default)(_button,'multiDelete',function multiDelete(){return getLabel(32136,'批量删除');}),(0,_defineProperty3.default)(_button,'add',function add(){return getLabel(131201,'添加');}),(0,_defineProperty3.default)(_button,'clickSetting',function clickSetting(){return getLabel(386368,'点击设置');}),(0,_defineProperty3.default)(_button,'more',function more(){return getLabel(131654,'更多');}),(0,_defineProperty3.default)(_button,'saveAsImage',function saveAsImage(){return getLabel(385746,'另存为图片');}),(0,_defineProperty3.default)(_button,'import',function _import(){return getLabel(18596,'导入');}),(0,_defineProperty3.default)(_button,'export',function _export(){return getLabel(28343,'导出Excel');}),(0,_defineProperty3.default)(_button,'export1',function export1(){return getLabel(383381,'导出清单到Excel');}),(0,_defineProperty3.default)(_button,'refresh',function refresh(){return getLabel(354,'刷新');}),(0,_defineProperty3.default)(_button,'saveAndSetting',function saveAndSetting(){return getLabel(32159,'保存并进入详细设置');}),(0,_defineProperty3.default)(_button,'importHistoryQuery',function importHistoryQuery(){return getLabel(24644,'历史导入记录');}),(0,_defineProperty3.default)(_button,'submit',function submit(){return getLabel(615,'提交');}),(0,_defineProperty3.default)(_button,'verification',function verification(){return getLabel('15357',"验证");}),(0,_defineProperty3.default)(_button,'changeValidType',function changeValidType(){return getLabel('387341',"更换其他验证方式");}),(0,_defineProperty3.default)(_button,'resend',function resend(){return getLabel('22408',"重新发送");}),(0,_defineProperty3.default)(_button,'getImportLog',function getImportLog(){return getLabel(24835,'导入日志');}),_button),confirm:(_confirm={defaultTitle:function defaultTitle(){return getLabel(131329,'信息确认');},systemhints:function systemhints(){return getLabel(15172,'系统提示');},remove:function remove(){return getLabel(83449,'确定要移除吗？');},delete:function _delete(){return getLabel(83877,'确定要删除吗？');},removeSelected:function removeSelected(){return getLabel(385639,'确定要移除选择的记录吗？');},deleteSelected:function deleteSelected(){return getLabel(385625,'确定要删除选择的记录吗？');}},(0,_defineProperty3.default)(_confirm,'delete',function _delete(){return getLabel(83877,'确定要删除吗？');}),(0,_defineProperty3.default)(_confirm,'batchDeleteConfirm',function batchDeleteConfirm(){return getLabel(385625,'确定要删除选择的记录吗？');}),_confirm),message:{dataConstructError:function dataConstructError(){return getLabel(385643,'数据格式异常');},authFailed:function authFailed(){return getLabel(2012,'对不起，您暂时没有权限！');},actionError:function actionError(){return getLabel(132200,'操作失败！');},opSuccess:function opSuccess(){return getLabel(384136,'操作成功');},saveSuccess:function saveSuccess(){return getLabel(83551,'保存成功！');},saveFailed:function saveFailed(){return getLabel(84544,'保存失败！');},removeSuccess:function removeSuccess(){return getLabel(385950,'移除成功！');},deleteSuccess:function deleteSuccess(){return getLabel(83472,'删除成功！');},dataEmpty:function dataEmpty(){return getLabel(82241,'不能为空');},serverProcessing:function serverProcessing(){return getLabel(84041,'服务器正在处理，请稍候...');},dataNone:function dataNone(){return getLabel(83553,'暂无数据');},recordNotFound:function recordNotFound(){return getLabel(83781,'没有数据');},noMatchingData:function noMatchingData(){return getLabel(384284,'暂无匹配数据');},requireFieldNone:function requireFieldNone(){return getLabel(386319,'必填字段不完整！');},fillPrivateInfoAlarm:function fillPrivateInfoAlarm(){return getLabel(386326,'个人信息栏目未开放,如有需要请联系管理员开放!');},fillWorkInfoAlarm:function fillWorkInfoAlarm(){return getLabel(386327,'工作信息栏目未开放,如有需要请联系管理员开放!');},fillSysInfoAlarm:function fillSysInfoAlarm(){return getLabel(386328,'系统信息栏目未开放或者无权限,请联系管理员!');},noAvailableCheckoutMethod:function noAvailableCheckoutMethod(){return getLabel(386367,'没有可用的校验方式');},noAvailableCheckMode:function noAvailableCheckMode(){return getLabel(386369,'没有可用的校验方式，请点击设置！');},fillTelphoneNum:function fillTelphoneNum(){return getLabel(386370,'请填写手机号！');},fillAvailableTelphoneNum:function fillAvailableTelphoneNum(){return getLabel(386371,'请填写正确手机号！');},fillUserKey:function fillUserKey(){return getLabel(386372,'请填写用户密钥');},bindToken:function bindToken(){return getLabel(386373,'请绑定令牌序列号！');},tokenNumLen:function tokenNumLen(){return getLabel(83745,'令牌序列号必须为10位数字！');},tokenBinded:function tokenBinded(){return getLabel(386374,'令牌序列号已经绑定给{params}，不能重复绑定！');},htKey:function htKey(){return getLabel(83061,'您的浏览器不支持修改使用海泰key的账号密码，请使用IE浏览器');},pleaseUploadFile:function pleaseUploadFile(){return getLabel(384197,'请上传文件');},pleaseSelectDelRecord:function pleaseSelectDelRecord(){return getLabel(387095,'请选择要删除的记录');},checkPhoneVCode:function checkPhoneVCode(){return getLabel('387363',"手机验证码已发送到手机{params}");},checkMailVCode:function checkMailVCode(){return getLabel('387364',"随机验证码已发送到邮箱{params}");},checkVCode:function checkVCode(){return getLabel('125973',"请注意查收！");},doubleCheckPwdFaild:function doubleCheckPwdFaild(){return getLabel(81608,'密码验证不通过，请重新输入！');},vCodeExpired:function vCodeExpired(){return getLabel('387398',"验证码已过期");},pwdLen:function pwdLen(){return getLabel('20172',"密码长度不能小于");},pwdType:function pwdType(){return getLabel('31863',"新密码不符合要求，必须为字母大写、字母小写、数字组合！请重新输入！");},pwdType1:function pwdType1(){return getLabel('83716',"新密码不符合要求，必须为字母、数字、特殊字符组合！请重新输入！");},selectImportTempleteError:function selectImportTempleteError(){return getLabel(384059,'导入文件存在以下错误，请解决后重新上传！');}},smallType:{HRM_RSOURCE_CARD:1,//人员卡片
HRM_RSOURCE_CARD_BASE:2,//人员卡片基本信息
HRM_RSOURCE_CARD_PERSONAL:3,//人员卡片个人信息
HRM_RSOURCE_CARD_WORK:4,//人员卡片工作信息
HRM_RSOURCE_CARD_SYSTEM:5,//人员卡片系统信息
HRM_RSOURCE_CARD_GROUP:6,//人员卡片常用组
//HRM_RSOURCE_CARD_ROLE: 7,//人员卡片角色设置
HRM_RSOURCE_CARD_FINANCE:16,//人员卡片工资福利
HRM_RSOURCE_ADD:8,//新建人员
HRM_RSOURCE_ADD_BASE:8,//新建人员基本信息
HRM_RSOURCE_ADD_PERSONAL:10,//新建人员个人信息
HRM_RSOURCE_ADD_WORK:11,//新建人员工作信息
HRM_RSOURCE_ADD_SYSTEM:12,//新建人员系统信息
HRM_PASSWPRD:13,//密码设置
HRM_RSOURCEMANAGER:14,//管理员
HRM_RSOURCEMANAGER_SECURITYSETTING:15//管理员卡片安全设置
}};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(205),
    getTag = __webpack_require__(94),
    isArguments = __webpack_require__(151),
    isArray = __webpack_require__(29),
    isArrayLike = __webpack_require__(118),
    isBuffer = __webpack_require__(119),
    isPrototype = __webpack_require__(117),
    isTypedArray = __webpack_require__(153);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(275), __esModule: true };

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(561), __esModule: true };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.carousel=exports.GetUrlParam=exports.convertCalendarDate=exports.calFormHeight=exports.DateFormat=exports.createQRCode=exports.getFormParamValue=exports.validate=exports.getIconColor=exports.getIcon=undefined;var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _loadjs=__webpack_require__(148);var _loadjs2=_interopRequireDefault(_loadjs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;/**
  正常
  迟到
  早退
  旷工
  漏签
  请假
  出差
  公出
  加班
  异常数据抵扣
 */// NORMAL,BELATE,LEAVEEARLY,ABSENT,NOSIGN,LEAVE,EVECTION,OUTDAYS,OVERTIME,OTHER;
var getIcon=exports.getIcon=function getIcon(type){var res={};if(type=='LEAVE'){res.color='#2DB7F5';res.icon='icon-Human-resources-leave';}if(type=='EVECTION'){res.color='#48C651';res.icon='icon-Human-resources-business-travel';}if(type=='OUTDAYS'){res.color='#4F8CFF';res.icon='icon-Human-resources-work';}if(type=='OVERTIME'){res.color='#8D6BF3';res.icon='icon-Human-resources-overtime';}if(type=='OTHER'){res.color='#ABB4C1';res.icon='icon-Human-resources-abnormal-small2';}return res;};var getIconColor=exports.getIconColor=function getIconColor(type){var res={};if(type=='ALL'){res.color='#2DB7F5';res.name=getLabel(82857,'全部');res.icon='icon-Human-resources-all';}if(type=='NORMAL'){res.color='#2DB7F5';res.name=getLabel('225',"正常");res.icon='icon-Human-resources-normal';}if(type=='BELATE'){res.color='#FF8F00';res.name=getLabel('20081',"迟到");res.bcolor='#FFF6EB';res.icon='icon-Human-resources-late';}if(type=='LEAVEEARLY'){res.color='#7326FF';res.name=getLabel('20082',"早退");res.bcolor='#F1E9FF';res.icon='icon-Human-resources-Leave-early';}if(type=='ABSENT'){res.color='#FC4B6C';res.name=getLabel('20085',"旷工");res.bcolor='#FFE6EB';res.icon='icon-Human-resources-Absenteeism';}if(type=='NOSIGN'){res.color='#BD10E0';res.name=getLabel('20086',"漏签");res.bcolor='#FAECFD';res.icon='icon-Human-resources-check';}if(type=='LEAVE'){res.color='#2DB7F5';res.name=getLabel('670',"请假");res.bcolor='#EFFAFF';res.icon='icon-Human-resources-leave';}if(type=='EVECTION'){res.color='#30BE3A';res.name=getLabel('20084',"出差");res.bcolor='#EFFAF0';res.icon='icon-Human-resources-business-travel';}if(type=='OUTDAYS'){res.color='#4F8CFF';res.name=getLabel('24058',"公出");res.bcolor='#DFEBFF';res.icon='icon-Human-resources-work';}if(type=='OVERTIME'){res.color='#8D6BF3';res.name=getLabel('6151',"加班");res.bcolor='#FAECFD';res.icon='icon-Human-resources-overtime-small';}if(type=='OTHER'){res.color='#ABB4C1';res.name=getLabel('32104',"异常");res.title=getLabel('132031',"异常数据抵扣");res.bcolor='#F0F6FF';res.icon='icon-Human-resources-abnormal-small2';}return res;};var validate=exports.validate=function validate(conditions){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!(0,_isEmpty2.default)(conditions)){for(var i=0,leg=conditions.length;i<leg;i++){var cd=conditions[i];if(cd.hide)continue;for(var j=0,length=cd.items.length;j<length;j++){var c=cd.items[j];if(c){if(c.otherParams&&c.otherParams.hide)continue;var domkey=c.domkey[0];var viewAttr=c.viewAttr;if(c.conditionType=='BROWSER')viewAttr=c.browserConditionParam.viewAttr;if(viewAttr=='3'&&!params[domkey]){if(domkey=='managerid'||domkey=='belongto'){//直接上级 主账号不用校验
}else{//message.warning(domkey+'必要信息不完整！');
_antd.message.warning(getLabel('15859',"必要信息不完整！"));return false;}}}}}}return true;};var getFormParamValue=exports.getFormParamValue=function getFormParamValue(){var conditions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fieldname=arguments[1];var fieldvalue='';if(!(0,_isEmpty2.default)(conditions)){for(var i=0,leg=conditions.length;i<leg;i++){var cd=conditions[i];for(var j=0,length=cd.items.length;j<length;j++){var c=cd.items[j];if(c){var domkey=c.domkey[0];if(domkey==fieldname){fieldvalue=c.value;}}}}}return fieldvalue;};var createQRCode=exports.createQRCode=function createQRCode(data){//生成二维码
var txt="BEGIN:VCARD \n"+"VERSION:3.0 \n"+"N:"+data.lastname+" \n"+"TEL;CELL;VOICE:"+data.mobile+"\n"+"TEL;WORK;VOICE:"+data.telephone+"\n"+"EMAIL:"+data.email+" \n"+"TITLE:"+data.jobtitle+" \n"+"ROLE:"+data.department+"\n"+"ADR;WORK:"+data.locationname+" \n"+"END:VCARD";return utf16to8(txt);function utf16to8(str){var out,i,len,c;out="";len=str.length;for(i=0;i<len;i++){c=str.charCodeAt(i);if(c>=0x0001&&c<=0x007F){out+=str.charAt(i);}else if(c>0x07FF){out+=String.fromCharCode(0xE0|c>>12&0x0F);out+=String.fromCharCode(0x80|c>>6&0x3F);out+=String.fromCharCode(0x80|c>>0&0x3F);}else{out+=String.fromCharCode(0xC0|c>>6&0x1F);out+=String.fromCharCode(0x80|c>>0&0x3F);}}return out;}};// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
var DateFormat=exports.DateFormat=function DateFormat(date,fmt){if(date&&fmt){var _this=date;var type=Object.prototype.toString.call(date);if(type=="[object String]"){var dateArray=date.split(" "),d1=dateArray[0].split("-"),d2=dateArray[1]?dateArray[1].split(":"):[];_this=new Date((d1[0]||0)*1,(d1[1]||0)*1-1,(d1[2]||0)*1,(d2[0]||0)*1,(d2[1]||0)*1,(d2[2]||0)*1);}else if(type=="[object Date]"){}else{return"";}var o={"M+":_this.getMonth()+1,//月份
"d+":_this.getDate(),//日
"h+":_this.getHours()%12==0?12:_this.getHours()%12,//小时
"H+":_this.getHours(),//小时
"m+":_this.getMinutes(),//分
"s+":_this.getSeconds(),//秒
"q+":Math.floor((_this.getMonth()+3)/3),//季度
"S":_this.getMilliseconds()//毫秒
};var week={"0":'\\u65e5',"1":'\\u4e00',"2":'\\u4e8c',"3":'\\u4e09',"4":'\\u56db',"5":'\\u4e94',"6":'\\u516d'};if(/(y+)/.test(fmt)){fmt=fmt.replace(RegExp.$1,(_this.getFullYear()+"").substr(4-RegExp.$1.length));}if(/(E+)/.test(fmt)){var weekStr=(RegExp.$1.length>1?RegExp.$1.length>2?'\\u661f\\u671f':'\\u5468':"")+week[_this.getDay()+""];fmt=fmt.replace(RegExp.$1,Utils.GB2312UnicodeConverter.ToGB2312(weekStr));}for(var k in o){if(new RegExp("("+k+")").test(fmt)){fmt=fmt.replace(RegExp.$1,RegExp.$1.length==1?o[k]:("00"+o[k]).substr((""+o[k]).length));}}return fmt;}else{return"";}};var calFormHeight=exports.calFormHeight=function calFormHeight(groupLength,children){var childrenLength=0;children.map(function(c){if(c.colSpan!=null){childrenLength+=c.colSpan==2?1:2;}else childrenLength+=1;});var height=(childrenLength/2+childrenLength%2)*52+10;if(groupLength>1)height+=groupLength*45;if(height>300)return 300;return height;};var convertCalendarDate=exports.convertCalendarDate=function convertCalendarDate(date){var y=date.getYear();var d=date.getDayOfMonth();if(d<10)d='0'+d;var m=date.getMonth()+1;if(m<10)m='0'+m;return y+'-'+m+'-'+d;};var GetUrlParam=exports.GetUrlParam=function GetUrlParam(url,paraName){var arrObj=url.split("?");if(arrObj.length>1){var arrPara=arrObj[1].split("&");var arr=void 0;for(var i=0;i<arrPara.length;i++){arr=arrPara[i].split("=");if(arr!==null&&arr[0]===paraName){return arr[1];}}return"";}else{return"";}};var carousel=exports.carousel=function carousel(pic,index,parent){var imgPool=[];var indexNum=0;var clickImgUrl=pic;var clickImgId=GetUrlParam(clickImgUrl,"fileid");var dom='.'+parent+':eq('+index+') img';$(dom).each(function(index,img){imgPool.push(img.currentSrc?img.currentSrc:img.src);});for(var i=0;i<imgPool.length;i++){var imgid=GetUrlParam(imgPool[i],"fileid");if(clickImgId===imgid){break;}else{indexNum++;}}var isShowPicture=true;if(clickImgId===""){isShowPicture=false;}if(isShowPicture){if(window.IMCarousel){window.IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,window.top);}else{(0,_loadjs2.default)(["/social/js/drageasy/drageasy.js","/social/js/bootstrap/js/bootstrap.js?v=20171218","/social/im/js/IMUtil_wev8.js","/social/js/imcarousel/imcarousel.js"],function(){window.IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,window.top);});}}};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(133)();
}


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(137), __esModule: true };

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(9);
var factory = __webpack_require__(131);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.1';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.onNewRequest=exports.jumpToHrmContract=exports.jumpToHrmPost=exports.jumpToHrmSubCompany=exports.jumpToHrmDept=exports.jumpToHrmCard=exports.chkMail=exports.getUserName=exports.jsRewardsRecord2Detial=exports.jsHrmTrainApply=exports.jsTrainRecordShowDetail=exports.openWorkReport=exports.openFnaExpenseResourceDetail=exports.openFnaBudgetResourceDetail=exports.openHrmResourceView=exports.cptSearch=exports.openCRM=exports.doProjcSearch=exports.docSearch=exports.jsRequestView=exports.openFullWindowForXtable=exports.jsHrmResourceSystemView=exports.doAddWorkPlanByHrm=exports.addCoWork=exports.sendSmsMessage=exports.sendMail=exports.sendEmessage=undefined;exports.sendMsgToPC=sendMsgToPC;var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _i18n=__webpack_require__(11);var getLabel=_ecCom.WeaLocaleProvider.getLabel;var confirm=_antd.Modal.confirm;var sendMsg=_ecCom.WeaTools.sendMsg;//发消息、发起群聊
function sendEmessage(emessageId){var isGroup=false;if(!!emessageId){if(emessageId.indexOf(",")>-1){isGroup=true;}}if(!emessageId){_antd.message.warning(SystemEnv.getHtmlNoteName(4780,readCookie("languageidweaver")));return;}if(emessageId.match(/,$/)){emessageId=emessageId.substring(0,emessageId.length-1);}var openType=isGroup?"2":"0";if(isGroup){confirm({content:SystemEnv.getHtmlNoteName(4781,readCookie("languageidweaver")),onOk:function onOk(){sendMsgToPC(emessageId,openType,'','');},onCancel:function onCancel(){}});}else{sendMsgToPC(emessageId,openType,'','');}}/**
 * 调用e-message发起会话
 * @param conventioners
 * @param openType
 * @param groupName
 * @param extra
 */function sendMsgToPC(conventioners,openType,groupName,extra,successCallBack,errorCallBack){sendMsg(conventioners,openType,'','');// $.ajax({
//   url: '/social/im/SocialIMOperation.jsp?operation=openPCconversation',
//   data: {
//     conventioners,
//     openType,
//     groupName,
//     extra,
//   },
//   type: 'post',
//   dataType: 'json',
//   contentType: 'application/x-www-form-urlencoded; charset=utf-8',
//   success(data) {
//     if (data != null) {
//       if (data.pcStatus == 0 && data.webStatus == 0) {
//         // pc和web都不在
//         Modal.warning({
//           title: i18n.confirm.systemhints(),
//           content: getLabel('386482',"检查到您的web端和客户端的e-message不在线，请打开任意一端进行会话！"),
//         });
//       } else if (data.webStatus == 1) {
//         // web在线
//         if (window.top.$('#socialIMFrm').length > 0) {
//         } else {
//           if (!!window.ActiveXObject || 'ActiveXObject' in window) {
//             Modal.warning({
//               title: i18n.confirm.systemhints(),
//               content: getLabel('386483',"您发起的e-message聊天已经建立，<br>  请到主页进行消息发送！"),
//             });
//           }
//         }
//       } else {
//         // pc在线不作判断
//       }
//       typeof successCallBack === 'function' && successCallBack(data);
//     } else {
//       Modal.warning({
//         title: i18n.confirm.systemhints(),
//         content: getLabel('386484',"对话创建失败！"),
//       });
//       typeof errorCallBack === 'function' && errorCallBack();
//     }
//   },
//   error(XMLHttpRequest, textStatus, errorThrown) {
//     Modal.warning({
//       title: i18n.confirm.systemhints(),
//       content: getLabel('386485',"请求发送失败，请您检查当前网络！"),
//     });
//     typeof errorCallBack === 'function' && errorCallBack();
//   },
// });
}//发送邮件
function sendMail(id){//openFullWindowForXtable("/email/new/MailInBox.jsp?opNewEmail=1&amp;isInternal=1&amp;internalto&id="+id);
window.open('/spa/email/static/index.html#/main/email/new?isInternal=1&internaltonew=[{"id":'+id+',"type":"resource"}]');}//发送短信
function sendSmsMessage(id){//openFullWindowForXtable("/sms/SmsMessageEdit.jsp?hrmid="+id);
window.open('/spa/smallApp/static/index.html#/main/sms/SendSms?hrmid='+id);}//新建协作
function addCoWork(id){//openFullWindowForXtable("/cowork/AddCoWork.jsp?hrmid=" + id);
window.open('/spa/cowork/static/index.html#/main/cowork/main?hrmid='+id);}//新建日程
function doAddWorkPlanByHrm(id){//openFullWindowForXtable("/workplan/data/WorkPlan.jsp?resourceid="+id+"&add=1")
window.open('/spa/workplan/static/index.html#/main/wp/workPlanCreateSingle?type=create&selectedUser='+id);}//系统信息
function jsHrmResourceSystemView(id){//window.open(`/spa/hrm/index.html#/main/hrm/systeminfo${window.WeaHrm4Formal?'4Formal':''}/${id}`);
window.open('/spa/hrm/index_mobx.html#/main/hrm/systeminfo/'+id);}//我的下属--流程
function jsRequestView(id){// openFullWindowForXtable("/workflow/request/RequestView.jsp?resourceid=" + id);
window.open('/spa/workflow/index_mobx.jsp#/main/workflow/listDoing?resourceid='+id);}//我的下属--文档
function docSearch(id){// openFullWindowForXtable('/docs/search/DocSearchTemp.jsp?docstatus=6&hrmresid=' + id);
window.open('/spa/document/static/index.html#/main/document/search?doccreaterid='+id+'&viewcondition=2');}//我的下属--项目
function doProjcSearch(id){// openFullWindowForXtable("/proj/search/SearchOperation.jsp?member=" + id);
window.open('/spa/prj/index.html#/main/prj/mineProject?search_resourceid='+id);}//我的下属--客户
function openCRM(id){// openFullWindowForXtable('/CRM/search/SearchOperation.jsp?destination=myAccount&resourceid=' + id);
window.open('/spa/crm/mobx/index.html#/main/crm/customer/hrmView?searchHrmId='+id);}//我的下属--资产
function cptSearch(id){// openFullWindowForXtable('/cpt/search/SearchOperation.jsp?resourceid=' + id + '&isdata=2');
window.open('/spa/cpt/index.html#/main/cpt/mycapital?hrmid='+id);}//我的下属--下属
function openHrmResourceView(id){//openFullWindowForXtable("/hrm/HrmTab.jsp?_fromURL=HrmResourceView&id="+id+"&srcid="+id);
window.open('/spa/hrm/index_mobx.html#/main/hrm/underling/'+id);}//我的下属--预算
function openFnaBudgetResourceDetail(id){openFullWindowForXtable("/fna/report/budget/FnaBudgetResourceDetail.jsp?resourceid="+id);}//我的下属--收支
function openFnaExpenseResourceDetail(id){// openFullWindowForXtable("/fna/report/expense/FnaExpenseResourceDetail.jsp?resourceid=" + id);
window.open('/fna/cm/rpt/PersonalPayments.jsp?hrmResourceID='+id);}//我的下属--工作报告
function openWorkReport(id){openFullWindowForXtable("/spa/develop/index_mobx.html?#/main/develop/growuplist?userid="+id);}//培训记录--详细信息
function jsTrainRecordShowDetail(id){var dialog=new window.top.Dialog();dialog.currentWindow=window;var url="/hrm/HrmDialogTab.jsp?_fromURL=HrmResourceTrainRecordBasic&isdialog=1&id="+id;dialog.Title=getLabel('386486',"培训记录详细信息");dialog.Width=800;dialog.Height=503;dialog.Drag=true;dialog.URL=url;dialog.show();}//培训记录--培训安排--申请
function jsHrmTrainApply(trainplanid,applyworkflowid){openFullWindowForXtable("/workflow/request/AddRequest.jsp?workflowid="+applyworkflowid+"&TrainPlanId="+trainplanid);}//考核奖惩--奖惩情况--详细信息
function jsRewardsRecord2Detial(id){//openFullWindowForXtable("/hrm/HrmDialogTab.jsp?_fromURL=HrmAwardEdit&id="+id+"&cmd=showdetail");
var dialog=new window.top.Dialog();dialog.currentWindow=window;dialog.Title=getLabel('386487',"奖惩信息");var url="/hrm/HrmDialogTab.jsp?_fromURL=HrmAwardEdit&id="+id+"&cmd=showdetail";dialog.Width=800;dialog.Height=500;dialog.Drag=true;dialog.URL=url;dialog.show();}function openFullWindowForXtable(url){var redirectUrl=url;var width=screen.availWidth-10;var height=screen.availHeight-60;//if (height == 768 ) height -= 75 ;
//if (height == 600 ) height -= 60 ;
var szFeatures="top=0,";szFeatures+="left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";//channelmode
window.open(redirectUrl,"",szFeatures);}var openFullWindowHaveBar=function openFullWindowHaveBar(url){var redirectUrl=url;var width=screen.availWidth-10;var height=screen.availHeight-50;var szFeatures="top=0,";szFeatures+="left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,toolbar=no,location=no,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";//channelmode
window.open(redirectUrl,"",szFeatures);};function getUserName(){try{var _vbsserial="";var _hCard=htactx.OpenDevice(1);//打开设备
if(_hCard==0){_antd.message.warning(getLabel('21607',"请确认您已经正确地安装了驱动程序并插入了usb令牌"));return _vbsserial;}try{_vbsserial=htactx.GetUserName(_hCard);//获取用户名
htactx.CloseDevice(_hCard);return _vbsserial;}catch(e){_antd.message.warning(getLabel('21607',"请确认您已经正确地安装了驱动程序并插入了usb令牌")+'2');htactx.CloseDevice(_hCard);return _vbsserial;}}catch(e){_antd.message.warning(getLabel('21607',"请确认您已经正确地安装了驱动程序并插入了usb令牌"));htactx.CloseDevice(hCard);return vbsserial;}}function chkMail(email){if(email==''){return true;}var pattern=/^(?:[a-z\d]+[&\_\-\+\.]?)*[a-z\d]+@(?:([a-z\d]+\-?)*[a-z\d]+\.)+([a-z]{2,})+$/i;var chkFlag=pattern.test(email);if(chkFlag){return true;}else{_antd.message.warning(getLabel('24570',"邮箱地址的格式不正确"));return false;}}function jumpToHrmCard(id){//window.open(`/spa/hrm/index.html#/main/hrm/resource${window.WeaHrm4Formal?'4Formal':''}/HrmResourceBase${window.WeaHrm4Formal?'4Formal':''}/${id}`);
window.open('/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/'+id,'_blank');}function jumpToHrmDept(id){//window.open('/hrm/HrmTab.jsp?_fromURL=HrmDepartmentDsp&id=' + id);
window.open('/spa/hrm/engine.html#/hrmengine/organization?showTree=false&isView=1&type=department&id='+id,'_blank');}function jumpToHrmSubCompany(id){//window.open('/hrm/HrmTab.jsp?_fromURL=HrmSubCompanyDsp&id=' + id);
window.open('/spa/hrm/engine.html#/hrmengine/organization?showTree=false&isView=1&type=subcompany&id='+id,'_blank');}function jumpToHrmPost(id){// window.open('/hrm/HrmDialogTab.jsp?_fromURL=HrmJobTitlesEdit&id=' + id);
window.open('/spa/hrm/engine.html#/hrmengine/posts?id='+id,'_blank');}function jumpToHrmJob(id){window.open('/spa/hrm/engine.html#/hrmengine/singleJob?id='+id,'_blank');}function jumpToHrmContract(id){window.open('/hrm/contract/contract/HrmContractView.jsp?id='+id,'_blank');}//新建流程
function onNewRequest(params){var wfid=params.wfid||'';var f_weaver_belongto_userid=params.f_weaver_belongto_userid||'';var beagenter=params.beagenter||'';var isagent=params.isagent||'';//计数
jQuery.post('/workflow/request/AddWorkflowUseCount.jsp',{wfid:wfid});var paramstr='workflowid='+wfid+'&isagent='+isagent+'&beagenter='+beagenter+'&f_weaver_belongto_userid='+f_weaver_belongto_userid+'&f_weaver_belongto_usertype=0';openFullWindowHaveBar('/workflow/request/CreateRequestForward.jsp?'+paramstr);}var openFullWindowHaveBarForWFList=function openFullWindowHaveBarForWFList(url,requestid){try{document.getElementById("wflist_"+requestid+"span").innerHTML="";}catch(e){}var redirectUrl=url;var width=screen.availWidth-10;var height=screen.availHeight-50;var szFeatures="top=0,left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,status=yes,toolbar=no,location=no,";szFeatures+="menubar=no,scrollbars=yes,resizable=yes";window.open(redirectUrl,"",szFeatures);};var viewDepartment=function viewDepartment(departmentid){jumpToHrmDept(departmentid);};var viewSubCompany=function viewSubCompany(subcompanyid){jumpToHrmSubCompany(subcompanyid);};window.viewDepartment=viewDepartment;window.viewSubCompany=viewSubCompany;window.openFullWindowHaveBarForWFList=openFullWindowHaveBarForWFList;exports.sendEmessage=sendEmessage;exports.sendMail=sendMail;exports.sendSmsMessage=sendSmsMessage;exports.addCoWork=addCoWork;exports.doAddWorkPlanByHrm=doAddWorkPlanByHrm;exports.jsHrmResourceSystemView=jsHrmResourceSystemView;exports.openFullWindowForXtable=openFullWindowForXtable;exports.jsRequestView=jsRequestView;exports.docSearch=docSearch;exports.doProjcSearch=doProjcSearch;exports.openCRM=openCRM;exports.cptSearch=cptSearch;exports.openHrmResourceView=openHrmResourceView;exports.openFnaBudgetResourceDetail=openFnaBudgetResourceDetail;exports.openFnaExpenseResourceDetail=openFnaExpenseResourceDetail;exports.openWorkReport=openWorkReport;exports.jsTrainRecordShowDetail=jsTrainRecordShowDetail;exports.jsHrmTrainApply=jsHrmTrainApply;exports.jsRewardsRecord2Detial=jsRewardsRecord2Detial;exports.getUserName=getUserName;exports.chkMail=chkMail;exports.jumpToHrmCard=jumpToHrmCard;exports.jumpToHrmDept=jumpToHrmDept;exports.jumpToHrmSubCompany=jumpToHrmSubCompany;exports.jumpToHrmPost=jumpToHrmPost;exports.jumpToHrmContract=jumpToHrmContract;exports.onNewRequest=onNewRequest;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(316);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(90)('wks');
var uid = __webpack_require__(79);
var Symbol = __webpack_require__(25).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(25);
var core = __webpack_require__(20);
var ctx = __webpack_require__(53);
var hide = __webpack_require__(47);
var has = __webpack_require__(44);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(28);

var _Actions = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(43)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(14);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(35);
var IE8_DOM_DEFINE = __webpack_require__(113);
var toPrimitive = __webpack_require__(86);
var dP = Object.defineProperty;

exports.f = __webpack_require__(37) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(208);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var errorMap = {
  'MARKER_ID_CONFLICT': 'Marker 的 id 属性重复',
  'MARKER_ID_REQUIRED': '每一个 Marker 必需有一个 id 属性',
  'MAP_INSTANCE_REQUIRED': '没有地图实例；组件必须作为 Map 的子组件使用',
  'CIRCLE_INSTANCE_REQUIRED': '',
  'CIRCLE_CENTER_REQUIRED': 'Circle 组件必需设置 center 属性',
  'CIRCLE_RADIUS_REQUIRED': 'Circle 组件必需设置 radius 属性',
  'SRC_REQUIRED': 'GroundImage 组件必需设置 src 属性',
  'BOUNDS_REQUIRED': 'GroundImage 组件必需设置 bounds 属性',
  'WINDOW_POSITION_REQUIRED': 'InfoWindow 组件必需设置 position 属性',
  'INVALID_AMAP_PLUGIN': 'plugins 属性不正确；目前支持的插件有\'Scale\', \'ToolBar\', \'MapType\', \'OverView\''
};

var getMessage = function getMessage(key) {
  return key in errorMap ? errorMap[key] : key;
};

var log = {
  // 开发者必须修正的问题，否则会影响其他程序运行
  error: function error(key) {
    throw new Error(getMessage(key));
  },

  // 是一个错误，导致本插件无法运行，但是不会影响开发者的其他功能
  warning: function warning(key) {
    // console.log(`%c${getMessage(key)}`, 'color:#f66;border-left: 2px solid red;padding-left: 4px;');
    console.warn(getMessage(key));
  },

  // 不影响使用，但不是本插件理想的使用方式
  optimize: function optimize(key) {
    console.log('%c' + getMessage(key), 'color:#d4d483;border-left: 2px solid #d4d483;padding-left: 4px;');
  }
};

exports.default = log;

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(87);
var defined = __webpack_require__(77);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(211),
    baseEach = __webpack_require__(422),
    castFunction = __webpack_require__(427),
    isArray = __webpack_require__(29);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(39);
var createDesc = __webpack_require__(58);
module.exports = __webpack_require__(37) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_48__;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54),
    now = __webpack_require__(364),
    toNumber = __webpack_require__(224);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _toCapitalString = __webpack_require__(376);

var _toCapitalString2 = _interopRequireDefault(_toCapitalString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withPropsReactive(MapComponent) {
  return function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.instanceCreated = false;
      _this.myMapComponent = null;
      _this.registeredEvents = [];
      _this.onInstanceCreated = _this.onInstanceCreated.bind(_this);
      return _this;
    }

    _createClass(_class, [{
      key: 'onInstanceCreated',
      value: function onInstanceCreated() {
        this.instanceCreated = true;
        if ('events' in this.props) {
          var instance = this.myMapComponent.instance;

          if (this.props.events.created) {
            this.props.events.created(instance);
          }
        }
        this.reactivePropChange(this.props, false);
      }
    }, {
      key: 'createEventsProxy',
      value: function createEventsProxy(props) {
        var self = this;
        var instance = this.myMapComponent.instance;

        var evs = Object.keys(props.events || {});
        evs.length && evs.forEach(function (ev) {
          if (self.registeredEvents.indexOf(ev) === -1) {
            self.registeredEvents.push(ev);
            instance.on(ev, function (ev) {
              return function () {
                if (self.props.events && ev in self.props.events) {
                  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }

                  self.props.events[ev].apply(null, args);
                }
              };
            }(ev));
          }
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.reactivePropChange(nextProps, true);
      }
    }, {
      key: 'reactivePropChange',
      value: function reactivePropChange(nextProps) {
        var _this2 = this;

        var shouldDetectChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (!this.instanceCreated) {
          return false;
        }
        var _myMapComponent = this.myMapComponent,
            _myMapComponent$sette = _myMapComponent.setterMap,
            setterMap = _myMapComponent$sette === undefined ? {} : _myMapComponent$sette,
            _myMapComponent$conve = _myMapComponent.converterMap,
            converterMap = _myMapComponent$conve === undefined ? {} : _myMapComponent$conve,
            _myMapComponent$insta = _myMapComponent.instance,
            instance = _myMapComponent$insta === undefined ? {} : _myMapComponent$insta;

        var list = Object.keys(nextProps);
        list.length && list.forEach(function (key) {
          if (key === 'events') {
            return _this2.createEventsProxy(nextProps);
          }

          var willReactive = true;
          if (shouldDetectChange) {
            willReactive = _this2.detectPropChange(key, nextProps, _this2.props);
          }
          if (!willReactive) {
            return false;
          }
          var setterParam = nextProps[key];
          if (key in converterMap) {
            setterParam = converterMap[key](nextProps[key]);
          }
          if (key in setterMap) {
            setterMap[key](setterParam);
          } else {
            var trySetterName = 'set' + (0, _toCapitalString2.default)(key);
            if (trySetterName in instance) {
              instance[trySetterName](setterParam);
            }
          }
        });
      }
    }, {
      key: 'detectPropChange',
      value: function detectPropChange(key, nextProps, oldProps) {
        return nextProps[key] !== oldProps[key];
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        return _react2.default.createElement(MapComponent, _extends({
          onInstanceCreated: this.onInstanceCreated,
          ref: function ref(comp) {
            _this3.myMapComponent = comp;
          }
        }, this.props));
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var instance = this.myMapComponent.instance;

        if (!instance) return;
        if ('destroy' in instance) {
          setTimeout(function () {
            instance.destroy();
          }, 10);
        }
        if ('hide' in instance) {
          instance.hide();
        }
        if ('__map__' in this.props && 'setMap' in instance) {
          instance.setMap(null);
        }
      }
    }]);

    return _class;
  }(_react2.default.Component);
};

exports.default = withPropsReactive;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(76);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(223);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_8__RouteUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_9__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_11__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(108);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_13__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__["a"]; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(114);
var enumBugKeys = __webpack_require__(91);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(77);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(304),
    getValue = __webpack_require__(309);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasWindow = typeof window !== 'undefined';

/*
 * [lng, lat]
 * {lng, lat}
 * {longitude, latitude}
 */
var toLnglat = exports.toLnglat = function toLnglat(pos) {
  if (!pos) {
    return pos;
  }
  // 高德原生 AMap.LngLat 类
  if ('getLng' in pos && 'getLat' in pos) {
    return pos;
  }
  var lng = 0;
  var lat = 0;
  if ({}.toString.call(pos) === '[object Array]') {
    lng = pos[0];
    lat = pos[1];
  } else if ('lng' in pos && 'lat' in pos) {
    lng = pos.lng;
    lat = pos.lat;
  } else if ('longitude' in pos && 'latitude' in pos) {
    lng = pos.longitude;
    lat = pos.latitude;
  }
  return hasWindow ? new window.AMap.LngLat(lng, lat) : null;
};

var toPixel = exports.toPixel = function toPixel(ofst) {
  if (!ofst) {
    return ofst;
  }
  if ('getX' in ofst && 'getY' in ofst) {
    return ofst;
  }
  var x = 0;
  var y = 0;
  if ({}.toString.call(ofst) === '[object Array]') {
    x = ofst[0];
    y = ofst[1];
  }
  return hasWindow ? new window.AMap.Pixel(x, y) : null;
};

var toSize = exports.toSize = function toSize(size) {
  if (!size) {
    return size;
  }
  if ('getWidth' in size) {
    return size;
  }
  return hasWindow ? new window.AMap.Size(size.width, size.height) : null;
};

exports.default = {
  toLnglat: toLnglat,
  toPixel: toPixel,
  toSize: toSize
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.10';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    return key == '__proto__'
      ? undefined
      : object[key];
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(209), __webpack_require__(96)(module)))

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(27);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(185);

var _PathUtils = __webpack_require__(28);

var _runTransitionHook = __webpack_require__(70);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(51);

var _LocationUtils = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(34);

var _DOMUtils = __webpack_require__(52);

var _DOMStateStorage = __webpack_require__(109);

var _PathUtils = __webpack_require__(28);

var _ExecutionEnvironment = __webpack_require__(72);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(247);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(572), __esModule: true };

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(95),
    getRawTag = __webpack_require__(305),
    objectToString = __webpack_require__(306);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
var document = __webpack_require__(25).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(36);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(60);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(78);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(90)('keys');
var uid = __webpack_require__(79);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(20);
var global = __webpack_require__(25);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(61) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 91 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 92 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(279)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(200)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(303),
    Map = __webpack_require__(150),
    Promise = __webpack_require__(310),
    Set = __webpack_require__(311),
    WeakMap = __webpack_require__(312),
    baseGetTag = __webpack_require__(82),
    toSource = __webpack_require__(210);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(40);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(214),
    baseKeys = __webpack_require__(205),
    isArrayLike = __webpack_require__(118);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(125);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(6);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Item=_antd.Menu.Item;var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.state={showDrop:false};return _this;}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _this2=this;var showDrop=this.state.showDrop;var _props=this.props,icon=_props.icon,buttons=_props.buttons,buttonSpace=_props.buttonSpace,showDropIcon=_props.showDropIcon,dropMenuDatas=_props.dropMenuDatas;//isFixed:hrm-my-card-top是否固定
var menu=dropMenuDatas?React.createElement(_antd.Menu,{mode:'vertical',onClick:function onClick(o){dropMenuDatas.forEach(function(d){return d.key===o.key&&typeof d.onClick==='function'&&d.onClick(o.key);});}},dropMenuDatas&&dropMenuDatas.map(function(d,i){return React.createElement(Item,{key:d.key||i,disabled:d.disabled},React.createElement('span',{className:'wea-right-menu-icon'},d.icon),d.content);})):'';return React.createElement('div',{className:'hrm-my-card-top hrm-my-card-top-fixed'},buttons&&buttons.map(function(data){return React.createElement('span',{style:{display:'inline-block',lineHeight:'28px',verticalAlign:'middle',marginLeft:!!buttonSpace?buttonSpace:20}},data);}),showDropIcon&&buttons.length>0&&React.createElement('span',{className:'hrm-my-card-top-drop-btn',onClick:function onClick(){return _this2.setState({showDrop:true});}},React.createElement('i',{className:'hrm-my-card-top-icon-button icon-New-Flow-menu'})),React.createElement('div',{className:'hrm-my-card-top-drop-menu wea-right-menu',onMouseLeave:function onMouseLeave(){return _this2.setState({showDrop:false});},style:{display:showDrop?'block':'none'}},React.createElement('span',{className:'hrm-my-card-top-drop-btn',onClick:function onClick(){return _this2.setState({showDrop:false});}},React.createElement('i',{className:'hrm-my-card-top-icon-button icon-New-Flow-menu'})),React.createElement('div',{className:'wea-right-menu-icon-background'}),menu));}}]);return Main;}(React.Component);exports.default=Main;

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(173);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(68);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */]
  },

  propTypes: {
    to: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(42);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(182);

var _runTransitionHook = __webpack_require__(70);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(34);

var _PathUtils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(70);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(108);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(548), __esModule: true };

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.i18n=undefined;var _ecCom=__webpack_require__(0);var getLabel=_ecCom.WeaLocaleProvider.getLabel;var i18n=exports.i18n={module:{orgAndAuthCenter:function orgAndAuthCenter(){return getLabel(33635,'组织权限中心');},securitySetting:function securitySetting(){return getLabel(32496,'安全设置');},authorizationSetting:function authorizationSetting(){return getLabel(16526,'权限设置');},subCompanyFieldDef:function subCompanyFieldDef(){return getLabel(81876,'分部字段定义');},departmentFieldDef:function departmentFieldDef(){return getLabel(81877,'部门字段定义');},resourceFieldDef:function resourceFieldDef(){return getLabel(81878,'人员卡片字段定义');},roleSetting:function roleSetting(){return getLabel(16527,'角色设置');},batchMaintenance:function batchMaintenance(){return getLabel(33923,'批量维护');},batchAdjustSubCompany:function batchAdjustSubCompany(){return getLabel(385879,'批量调整分部信息');},batchAdjustDepartment:function batchAdjustDepartment(){return getLabel(385881,'批量调整部门信息');},batchAdjustResource:function batchAdjustResource(){return getLabel(385883,'批量调整人员信息');},batchEditSubCompany:function batchEditSubCompany(){return getLabel(385885,'批量编辑分部信息');},batchEditDepartment:function batchEditDepartment(){return getLabel(385887,'批量编辑部门信息');},batchEditResource:function batchEditResource(){return getLabel(385889,'批量编辑人员信息');},batchUploadPhoto:function batchUploadPhoto(){return getLabel(385891,'批量上传人员照片');},batchAdjustSubCompanyTips:function batchAdjustSubCompanyTips(){return getLabel(385880,'将多个分部的指定信息调整成统一值');},batchAdjustDepartmentTips:function batchAdjustDepartmentTips(){return getLabel(385882,'将多个部门的指定信息调整成统一值');},batchAdjustResourceTips:function batchAdjustResourceTips(){return getLabel(385884,'将多个人员的指定信息调整成统一值');},batchEditSubCompanyTips:function batchEditSubCompanyTips(){return getLabel(385886,'在一个列表中编辑分部信息，例如批量排序，批量编号');},batchEditDepartmentTips:function batchEditDepartmentTips(){return getLabel(385888,'在一个列表中编辑部门信息，例如批量排序，批量编号');},batchEditResourceTips:function batchEditResourceTips(){return getLabel(385890,'在一个列表中编辑人员信息，例如批量排序，批量编号');},batchUploadPhotoTips:function batchUploadPhotoTips(){return getLabel(385892,'批量上传维护人员照片');},authAdjust:function authAdjust(){return getLabel(34238,'权限调整');},matrixAdjust:function matrixAdjust(){return getLabel(383940,'批量调整');},authSearch:function authSearch(){return getLabel(81553,'权限查询');},appDetach:function appDetach(){return getLabel(33653,'组织机构应用分权');},matrixSetting:function matrixSetting(){return getLabel(33926,'矩阵设置');},stateChangeWfSetting:function stateChangeWfSetting(){return getLabel(84790,'状态变更流程');},timeManagerWfSetting:function timeManagerWfSetting(){return getLabel(82797,'考勤流程设置');},enterLog:function enterLog(){return getLabel(18168,'人员登入日志');},basicInfoImport:function basicInfoImport(){return getLabel(125428,'基础数据导入');},salaryIndexSetting:function salaryIndexSetting(){return getLabel(19427,'薪酬指标设置');},paidLevelSetting:function paidLevelSetting(){return getLabel(82799,'调休设置');},paidLevelTimeSetting:function paidLevelTimeSetting(){return getLabel(82800,'调休时间查询');},onlineAnalysis:function onlineAnalysis(){return getLabel(31277,'在线人数分析');},//only chinese
importExternalDataAttendance:function importExternalDataAttendance(){return getLabel(33539,'考勤外部数据导入');},dataSyncSetting:function dataSyncSetting(){return getLabel(33740,'数据同步设置');},salaryBank:function salaryBank(){return getLabel(15812,'工资银行');},personalSalaryAdjustment:function personalSalaryAdjustment(){return getLabel(33399,'个人工资项调整');},workTime:function workTime(){return getLabel(125799,'工作时段');},shiftsSetting:function shiftsSetting(){return getLabel(125800,'班次设置');},limitedLoginAnalysis:function limitedLoginAnalysis(){return getLabel(31310,'并发登录被限统计');},//only chinese
salaryIndexMaintenance:function salaryIndexMaintenance(){return getLabel(19430,'薪酬指标数据维护');},wageSetting:function wageSetting(){return getLabel(33397,'工资项设置');},trainTypes:function trainTypes(){return getLabel(6130,'培训种类');},trainPlan:function trainPlan(){return getLabel(6128,'培训规划');},trainResource:function trainResource(){return getLabel(15879,'培训资源');},schedulingSetting:function schedulingSetting(){return getLabel(16695,'排班设置');},generalWorkingHours:function generalWorkingHours(){return getLabel(16687,'一般工作时间');},//only chinese
workingDayAdjust:function workingDayAdjust(){return getLabel(16750,'工作日期调整');},payrollManagement:function payrollManagement(){return getLabel(33398,'工资单管理');},leaveType:function leaveType(){return getLabel(21609,'请假类型设置');},annualPeriod:function annualPeriod(){return getLabel(21598,'年假有效期设置');},annualRule:function annualRule(){return getLabel(32758,'年假批量处理规则');},annualSetting:function annualSetting(){return getLabel(21600,'年假设置');},onlineAttendance:function onlineAttendance(){return getLabel(33545,'在线签到考勤');},trainArrange:function trainArrange(){return getLabel(6156,'培训安排');},paidLeavePeriod:function paidLeavePeriod(){return getLabel(131559,'带薪假有效期设置');},paidLeaveRule:function paidLeaveRule(){return getLabel(131560,'带薪假批量处理规则');},paidLeaveSetting:function paidLeaveSetting(){return getLabel(131557,'带薪假设置');},trainActivity:function trainActivity(){return getLabel(6136,'培训活动');},attendanceSetting:function attendanceSetting(){return getLabel(128558,'考勤应用设置');},orgChart:function orgChart(){return getLabel(16459,'图形编辑');},privacySetting:function privacySetting(){return getLabel(127406,'隐私设置');},rpType:function rpType(){return getLabel(6099,'奖惩种类');},rpManage:function rpManage(){return getLabel(6100,'奖惩管理');},contractType:function contractType(){return getLabel(6158,'合同种类');},assType:function assType(){return getLabel(6118,'考核种类');},assItem:function assItem(){return getLabel(6117,'考核项目');},assImple:function assImple(){return getLabel(6124,'考核实施');},contractExpireWarning:function contractExpireWarning(){return getLabel(19149,'合同到期提醒');},titleSetting:function titleSetting(){return getLabel(16462,'职称设置');},signatureManagement:function signatureManagement(){return getLabel(16627,"签章管理");},moduleManagementDecent:function moduleManagementDecent(){return getLabel(33654,'模块管理分权');},dismiss:function dismiss(){return getLabel(16472,'人员解聘');},formal:function formal(){return getLabel(16466,'人员转正');},rehire:function rehire(){return getLabel(16471,'人员返聘');},quit:function quit(){return getLabel(16469,'人员离职');},renew:function renew(){return getLabel(16467,'人员续签');},retire:function retire(){return getLabel(16470,'人员退休');},personTransfer:function personTransfer(){return getLabel(16468,'人员调动');},trial:function trial(){return getLabel(17513,'人员试用');},entryMaintenanceSettings:function entryMaintenanceSettings(){return getLabel(386202,'入职维护设置');},groupSet:function groupSet(){return getLabel(24001,'群组设置');},educationSet:function educationSet(){return getLabel(16464,'学历设置');},decentAdminSetting:function decentAdminSetting(){return getLabel(386203,'分权管理员设置');},staffCardDisplay:function staffCardDisplay(){return getLabel(33647,'人员卡片显示栏目');},birthdayRemind:function birthdayRemind(){return getLabel('391181',"生日提醒");},areaSet:function areaSet(){return getLabel(126169,'行政区域设置');},managementDecent:function managementDecent(){return getLabel(24326,'管理分权');},contractMaintain:function contractMaintain(){return getLabel(33741,'合同维护');},contractTemplate:function contractTemplate(){return getLabel(15786,'合同模板');},funcManageDecent:function funcManageDecent(){return getLabel('33651',"功能管理赋权");},letStaffFeelWarm:function letStaffFeelWarm(){return getLabel('391180',"员工关怀提醒");},employDemand:function employDemand(){return getLabel('6131',"用工需求");},recruitPlan:function recruitPlan(){return getLabel('6132',"招聘计划");},recruitInfo:function recruitInfo(){return getLabel('366',"招聘信息");},workNature:function workNature(){return getLabel('804',"用工性质");},unitSetting:function unitSetting(){return getLabel(16511,'单位设置');},recruitLibrary:function recruitLibrary(){return getLabel(16251,'应聘库');},loginFailLog:function loginFailLog(){return getLabel('391172',"人员登入失败日志");}},label:{authorizationGroup:function authorizationGroup(){return getLabel(492,'权限组');},allAuthorization:function allAuthorization(){return getLabel(33363,'全部权限');},authorizationGroupInfo:function authorizationGroupInfo(){return getLabel(383045,'权限组信息');},authorizationDetail:function authorizationDetail(){return getLabel(383040,'权限明细');},selectAuthorization:function selectAuthorization(){return getLabel(383046,'选择权限项');},createAuthorizationGroup:function createAuthorizationGroup(){return getLabel(383047,'新建权限组');},modifyAuthorizationGroup:function modifyAuthorizationGroup(){return getLabel(383048,'编辑权限组');},byList:function byList(){return getLabel(130619,'按列表');},byAuthGroup:function byAuthGroup(){return getLabel(382866,'按权限组');},basicSetting:function basicSetting(){return getLabel(130187,'基本设置');},networkStrategy:function networkStrategy(){return getLabel(21384,'网络策略');},advanceSetting:function advanceSetting(){return getLabel(19332,'高级设置');},fieldLabel:function fieldLabel(){return getLabel(15456,'字段显示名');},fieldName:function fieldName(){return getLabel(23241,'数据库字段名');},fieldType:function fieldType(){return getLabel(84113,'字段类型');},enable:function enable(){return getLabel(31676,'启用');},required:function required(){return getLabel(18019,'必填');},uploadFile:function uploadFile(){return getLabel(20798,'上传文件');},selectComponent:function selectComponent(){return getLabel(383051,'下拉框');},groupName:function groupName(){return getLabel(129927,'分组名称');},show:function show(){return getLabel(127791,'显示');},organization:function organization(){return getLabel(25332,'组织结构');},createRole:function createRole(){return getLabel(383069,'新建角色');},modifyRole:function modifyRole(){return getLabel(383070,'编辑角色');},roleName:function roleName(){return getLabel(15068,'角色名称');},explain:function explain(){return getLabel(85,'说明');},//only chinese
roleInfo:function roleInfo(){return getLabel(33401,'角色信息');},authInfo:function authInfo(){return getLabel(17864,'功能权限');},detachInfo:function detachInfo(){return getLabel(17865,'机构权限');},memberInfo:function memberInfo(){return getLabel(126254,'成员设置');},authRole:function authRole(){return getLabel(23265,'赋权角色：用于向同级管理员分配数据维护权限。');},detachRole:function detachRole(){return getLabel(23266,'分权角色：用于向下级管理员分配“分配权限”的权限。');},addRoleAuth:function addRoleAuth(){return getLabel(383101,'添加功能权限');},editRoleAuth:function editRoleAuth(){return getLabel(383941,'编辑权限级别');},addDetachAuth:function addDetachAuth(){return getLabel(383942,'添加机构权限');},editDetachAuth:function editDetachAuth(){return getLabel(383943,'编辑操作级别');},addMemberAuth:function addMemberAuth(){return getLabel(125217,'添加成员');},editMemberAuth:function editMemberAuth(){return getLabel(383944,'编辑成员级别');},authList:function authList(){return getLabel(440,'权限项');},roleLevel:function roleLevel(){return getLabel(383032,'权限级别');},company:function company(){return getLabel(140,'总部');},subcompany:function subcompany(){return getLabel(33553,'分部');},department:function department(){return getLabel(126029,'部门');},//only chinese
all:function all(){return getLabel(82857,'全部');},select:function select(){return getLabel(126832,'选择');},saveAs:function saveAs(){return getLabel(131623,'另存为');},selectObject:function selectObject(){return getLabel(383945,'选择对象');},transferObject:function transferObject(){return getLabel(383946,'转移内容');},copyObject:function copyObject(){return getLabel(125318,'复制内容');},removeObject:function removeObject(){return getLabel(15444,'删除内容');},adjustObject:function adjustObject(){return getLabel(383947,'调整内容');},type:function type(){return getLabel(132033,'类型');},selectedCount:function selectedCount(){return getLabel(383948,'已选择数量');},selectedCount0:function selectedCount0(){return getLabel(31503,'已选择');},totalCount:function totalCount(){return getLabel(383949,'总计数量');},authTransferBeginIn:function authTransferBeginIn(){return getLabel(383950,'从{beginTime}开始');},authTransferFinished:function authTransferFinished(){return getLabel(383951,'从{beginTime}开始至{endTime}结束，共用时：{processTime}');},transferTarget:function transferTarget(){return getLabel(383952,'由{param}{op}');},copyTo:function copyTo(){return getLabel(383953,'复制到');},transferTo:function transferTo(){return getLabel(129168,'移动到');},deleteTarget:function deleteTarget(){return getLabel(131966,'删除');},authTransferTotalCount:function authTransferTotalCount(){return getLabel(383954,'共计{param}项权限');},authTransferDeleteFinished:function authTransferDeleteFinished(){return getLabel(34240,'共计{param}项权限删除成功');},authTransferCopyFinished:function authTransferCopyFinished(){return getLabel(34033,'共计{param}项权限复制成功');},authTransferTransFinished:function authTransferTransFinished(){return getLabel(33379,'共计{param}项权限转移成功');},userDatas:function userDatas(){return getLabel(383955,'的数据');},itemCount:function itemCount(){return getLabel(1331,'数量');},detail:function detail(){return getLabel(17463,'明细');},globalSetting:function globalSetting(){return getLabel(33174,'全局设置');},appDetachList:function appDetachList(){return getLabel(128623,'应用分权列表');},createAppDetach:function createAppDetach(){return getLabel(383956,'新建应用分权');},editAppDetach:function editAppDetach(){return getLabel(383957,'编辑应用分权');},basicInfo:function basicInfo(){return getLabel(1361,'基本信息');},target:function target(){return getLabel(106,'对象');},viewRange:function viewRange(){return getLabel(34102,'查看范围');},addObject:function addObject(){return getLabel(383958,'添加对象');},addRange:function addRange(){return getLabel(383959,'添加范围');},editObject:function editObject(){return getLabel(383960,'编辑对象');},editRange:function editRange(){return getLabel(383961,'编辑范围');},matrixName:function matrixName(){return getLabel(195,'名称');},matrixDesc:function matrixDesc(){return getLabel(433,'描述');},createMatrix:function createMatrix(){return getLabel(383962,'新建矩阵');},modifyMatrix:function modifyMatrix(){return getLabel(383963,'编辑矩阵');},matrixMaintenance:function matrixMaintenance(){return getLabel(383964,'矩阵维护者');},orderId:function orderId(){return getLabel(15486,'序号');},total:function total(){return getLabel(18609,'共');},dataSourceCount:function dataSourceCount(){return getLabel(30690,'条数据');},screen:function screen(){return getLabel(126129,'筛选');},screenInfo:function screenInfo(){return getLabel(385323,'筛选此列数据');},subCompanyInfo:function subCompanyInfo(){return getLabel(32816,'分部信息');},departmentInfo:function departmentInfo(){return getLabel(16289,'部门信息');},companyInfo:function companyInfo(){return getLabel(16455,'组织结构');},showCanceledOrg:function showCanceledOrg(){return getLabel(384037,'显示封存机构');},hideCanceledOrg:function hideCanceledOrg(){return getLabel(384038,'不显示封存机构');},group:function group(){return getLabel(81554,'常用组');},resource:function resource(){return getLabel(1867,'人员');},batchOperateTitle:function batchOperateTitle(){return getLabel(384039,'点击切换批量操作');},canceled:function canceled(){return getLabel(22205,'已封存');},noFileSelected:function noFileSelected(){return getLabel(384040,'未选择任何文件');},downLoadTemplete:function downLoadTemplete(){return getLabel(125333,'选择文件');},success:function success(){return getLabel(15242,'成功');},fail:function fail(){return getLabel(498,'失败');},addVirtualOrg:function addVirtualOrg(){return getLabel(384043,'新建组织维度');},editVirtualOrg:function editVirtualOrg(){return getLabel(384044,'编辑组织维度');},editCompany:function editCompany(){return getLabel(384045,'编辑总部');},addSubCompany:function addSubCompany(){return getLabel(384046,'新建分部');},editSubCompany:function editSubCompany(){return getLabel(384047,'编辑分部');},addDepartment:function addDepartment(){return getLabel(125303,'新建部门');},editDepartment:function editDepartment(){return getLabel(384048,'编辑部门');},confirmInfo:function confirmInfo(){return getLabel(24960,'提示信息');},row:function row(){return getLabel(27592,'行');},col:function col(){return getLabel(384968,'列');},status:function status(){return getLabel(602,'状态');},importResourceResultInfo:function importResourceResultInfo(){return getLabel(384060,'共{rownum}条数据，{succnum}条导入成功！');},importResourceResultInfo1:function importResourceResultInfo1(){return getLabel(384061,'共{rownum}条数据，全部导入成功！');},childInfoName:function childInfoName(){return getLabel(384279,'子信息名称');},displayOrder:function displayOrder(){return getLabel(129806,'显示顺序');},today:function today(){return getLabel(130019,'今天');},tswk:function tswk(){return getLabel(15539,'本周');},tsmth:function tsmth(){return getLabel(383428,'本月');},tssn:function tssn(){return getLabel(383465,'本季');},tsyr:function tsyr(){return getLabel(130017,'本年');},preMonth:function preMonth(){return getLabel(27347,'上个月');},preYear:function preYear(){return getLabel(81716,'上一年');},dateRange:function dateRange(){return getLabel(32530,'指定日期范围');},importTemplate:function importTemplate(){return getLabel(129833,'导入模板');},org:function org(){return getLabel(376,'组织');},//only chinese
orgMaintenance:function orgMaintenance(){return getLabel(33596,'组织维护');},divisionAndDepartmentImport:function divisionAndDepartmentImport(){return getLabel(125432,'分部、部门导入');},post:function post(){return getLabel(6086,'岗位');},postSetting:function postSetting(){return getLabel(382806,'职务岗位设置');},personalization:function personalization(){return getLabel(18166,'个性化设置');},personalData:function personalData(){return getLabel(125429,'个人数据');},administrativeDivision:function administrativeDivision(){return getLabel(126167,'行政区域');},adminDivisionSetting:function adminDivisionSetting(){return getLabel(126169,'行政区域设置');},workingPlace:function workingPlace(){return getLabel('15712',"办公地点");},workingPlaceSetting:function workingPlaceSetting(){return getLabel(125448,'办公地点设置');},major:function major(){return getLabel(803,'专业');},majorSetting:function majorSetting(){return getLabel(16463,'专业设置');},number:function number(){return getLabel('714',"编号");},loginName:function loginName(){return getLabel(16126,'登录名');},downloadTemplateFirst:function downloadTemplateFirst(){return getLabel(383083,'请先下载模板');},importResult:function importResult(){return getLabel(82341,'导入结果');},newSalaryIndex:function newSalaryIndex(){return getLabel(384289,'新建薪酬指标');},editSalaryIndex:function editSalaryIndex(){return getLabel(384290,'编辑薪酬指标');},overdue:function overdue(){return getLabel(127265,'天后过期');},searchCondition:function searchCondition(){return getLabel(20331,'查询条件');},paidLevelTime:function paidLevelTime(){return getLabel(82845,'调休时间（小时）');},promptInformation:function promptInformation(){return getLabel(24960,'提示信息');},checkEnable:function checkEnable(){return getLabel(18624,'是否启用');},syncDateRange:function syncDateRange(){return getLabel(33542,'同步时间范围');},customTimeSegment:function customTimeSegment(){return getLabel(31298,'自定义时间段');},salaryAdjustment:function salaryAdjustment(){return getLabel(33404,'工资项调整');},adjustmentHistory:function adjustmentHistory(){return getLabel(15817,'调整历史');},createStateChangeWf:function createStateChangeWf(){return getLabel(384621,'新建状态变更流程');},dateRangeCondition:function dateRangeCondition(){return getLabel(124799,'日期范围');},createWorktime:function createWorktime(){return getLabel(384622,'新建工作时段');},modifyWorktime:function modifyWorktime(){return getLabel(384623,'编辑工作时段');},beforeWork:function beforeWork(){return getLabel(125813,'上班前');},afterWork:function afterWork(){return getLabel(125814,'下班后');},minute:function minute(){return getLabel(15049,'分钟');},shiftsDetail:function shiftsDetail(){return getLabel(125817,'班次明细');},newSalaryBank:function newSalaryBank(){return getLabel(384565,'新建工资银行');},editSalaryBank:function editSalaryBank(){return getLabel(384566,'编辑工资银行');},newSalaryIndexDatas:function newSalaryIndexDatas(){return getLabel(384571,'新建薪酬指标数据');},editSalaryIndexDatas:function editSalaryIndexDatas(){return getLabel(384572,'编辑薪酬指标数据');},downloadExcelTemplate:function downloadExcelTemplate(){return getLabel('391178',"下载Excel模板");},templateFile:function templateFile(){return getLabel(19971,'模板文件');},downloadExcelFileBeforeImport:function downloadExcelFileBeforeImport(){return getLabel(385329,'请下载模板文件，填入数据后导入');},salaryIndex:function salaryIndex(){return getLabel(19454,'薪酬指标');},excelFileImport:function excelFileImport(){return getLabel(18577,'Excel文件导入');},formulaSetting:function formulaSetting(){return getLabel(384714,'公式设置');},newTrainTypes:function newTrainTypes(){return getLabel(384743,'新建培训种类');},editTrainTypes:function editTrainTypes(){return getLabel(384745,'编辑培训种类');},personScheduling:function personScheduling(){return getLabel(125801,'人员排班');},dateScheduling:function dateScheduling(){return getLabel(125802,'时间排班');},withScheduling:function withScheduling(){return getLabel(385030,'以具体排班为准');},schedulingDetail:function schedulingDetail(){return getLabel(125817,'班次明细');},schedulingDetailTips:function schedulingDetailTips(){return getLabel(125822,'点击班次，可查看班次时间段明细。');},plsSelectScheduling:function plsSelectScheduling(){return getLabel(384624,'请选择工作时段：（所选时段不能有重叠）');},plsSelectDate:function plsSelectDate(){return getLabel(27938,'请选择日期');},schedulingDetail0:function schedulingDetail0(){return getLabel(125833,'排班明细');},schedulingDetailTips0:function schedulingDetailTips0(){return getLabel(125834,'点击列表行，可查看人员排班时间段明细。');},day:function day(){return getLabel(1925,'天');},year:function year(){return getLabel(383372,'年');},month:function month(){return getLabel(383373,'月');},newTrainPlan:function newTrainPlan(){return getLabel(384870,'新建培训规划');},editTrainPlan:function editTrainPlan(){return getLabel(384871,'编辑培训规划');},test:function test(){return getLabel(6102,'考评');},formName:function formName(){return getLabel(15451,'表单名称');},plsSetFormName:function plsSetFormName(){return getLabel(82091,'请填写表单名称');},uploadFileFirst:function uploadFileFirst(){return getLabel(384951,'请先上传文件');},newTrainResource:function newTrainResource(){return getLabel(384956,'新建培训资源');},editTrainResource:function editTrainResource(){return getLabel(384957,'编辑培训资源');},editStateChangeWf:function editStateChangeWf(){return getLabel(385031,'编辑状态变更流程');},createStatesSchedule:function createStatesSchedule(){return getLabel(385037,'新建考勤流程');},editStatesSchedule:function editStatesSchedule(){return getLabel(385038,'编辑考勤流程');},setSchduleDetail:function setSchduleDetail(){return getLabel(125835,'设置排班');},multiResouce:function multiResouce(){return getLabel(83496,'多人力资源');},pathSetting:function pathSetting(){return getLabel(16483,'路径设置');},payroll:function payroll(){return getLabel(503,'工资单');},plsSelectNeedCancelSchedule:function plsSelectNeedCancelSchedule(){return getLabel(125950,'请选择需要取消的班次');},calendar:function calendar(){return getLabel(490,'日历');},detailList:function detailList(){return getLabel(491,'清单');},createWorkingDay:function createWorkingDay(){return getLabel(385333,'新建工作日期调整');},editWorkingDay:function editWorkingDay(){return getLabel(385334,'编辑工作日期调整');},publicScope:function publicScope(){return getLabel(6104,'公开范围');},pleaseSelectDatas:function pleaseSelectDatas(){return getLabel(385148,'请勾选需要删除的数据！');},newPublicScope:function newPublicScope(){return getLabel(385149,'新建公开范围');},createPaidLeavePeriod:function createPaidLeavePeriod(){return getLabel(385335,'新建带薪假有效期设置');},editPaidLeavePeriod:function editPaidLeavePeriod(){return getLabel(385336,'编辑带薪假有效期设置');},editPublicScope:function editPublicScope(){return getLabel(385171,'编辑公开范围');},newTrainArrangement:function newTrainArrangement(){return getLabel(385173,'新建培训安排');},editTrainArrangement:function editTrainArrangement(){return getLabel(385174,'编辑培训安排');},trainSchedule:function trainSchedule(){return getLabel(16150,'培训日程');},createPaidLeaveRule:function createPaidLeaveRule(){return getLabel(385337,'新建带薪假批量处理规则');},editPaidLeaveRule:function editPaidLeaveRule(){return getLabel(385338,'编辑带薪假批量处理规则');},paidLeaveYear:function paidLeaveYear(){return getLabel(385339,'带薪假年');},annualYear:function annualYear(){return getLabel(385340,'年假年份');},sent:function sent(){return getLabel('19558',"已发送");},unsend:function unsend(){return getLabel(19557,'未发送');},createAnnualPeriod:function createAnnualPeriod(){return getLabel(385341,'新建年假有效期设置');},editAnnualPeriod:function editAnnualPeriod(){return getLabel(385342,'编辑年假有效期设置');},createAnnualRule:function createAnnualRule(){return getLabel(385343,'新建年假批量处理规则');},editAnnualRule:function editAnnualRule(){return getLabel(385344,'编辑年假批量处理规则');},noOver:function noOver(){return getLabel(24324,'未结束');},over:function over(){return getLabel(383417,'已结束');},unaccomplish:function unaccomplish(){return getLabel(385345,'暂未实现！');},showAllType:function showAllType(){return getLabel(385346,'显示全部类型');},newWorkHour:function newWorkHour(){return getLabel(385347,'新建一般工作时间');},editWorkHour:function editWorkHour(){return getLabel(385348,'编辑一般工作时间');},pleaseSelectTime:function pleaseSelectTime(){return getLabel(385349,'请选择引用的工作日');},selectQuotingSet:function selectQuotingSet(){return getLabel(32760,'引用设置');},monday:function monday(){return getLabel(392,'星期一');},tuesday:function tuesday(){return getLabel(393,'星期二');},wednesday:function wednesday(){return getLabel(394,'星期三');},thursday:function thursday(){return getLabel(395,'星期四');},friday:function friday(){return getLabel(396,'星期五');},saturday:function saturday(){return getLabel(397,'星期六');},sunday:function sunday(){return getLabel(398,'星期日');},onlineAttendanceSet:function onlineAttendanceSet(){return getLabel(34169,'在线签到考勤设置');},workTimeSet:function workTimeSet(){return getLabel(385350,'工作时间设置');},nolimited:function nolimited(){return getLabel(32499,'不限制');},halfday:function halfday(){return getLabel(128559,'半天');},allday:function allday(){return getLabel(27641,'全天');},minUnit:function minUnit(){return getLabel(385351,'最小单位');},defaultTime:function defaultTime(){return getLabel(385352,'默认时间');},illustration:function illustration(){return getLabel(25734,'说明');},daytime:function daytime(){return getLabel(390,'日');},am:function am(){return getLabel(16689,'上午');},pm:function pm(){return getLabel(16690,'下午');},attendanceRulesSetting:function attendanceRulesSetting(){return getLabel(385353,'考勤规则设置');},trainTest:function trainTest(){return getLabel(16143,'培训考核');},trainReview:function trainReview(){return getLabel(16144,'培训考评');},attendCircumstances:function attendCircumstances(){return getLabel(33430,'参加情况');},addTrainActivity:function addTrainActivity(){return getLabel(385927,'新增培训活动');},editTrainActivity:function editTrainActivity(){return getLabel(385928,'编辑培训活动');},addTrainee:function addTrainee(){return getLabel(16148,'增加培训人');},addTrainSchedule:function addTrainSchedule(){return getLabel(16151,'增加培训日程');},editTrainSchedule:function editTrainSchedule(){return getLabel(385929,'编辑培训日程');},stopActivity:function stopActivity(){return getLabel(385172,'结束活动');},addTestInfo:function addTestInfo(){return getLabel(385930,'新增培训考核');},editTestInfo:function editTestInfo(){return getLabel(385931,'编辑培训考核');},addReviewInfo:function addReviewInfo(){return getLabel(385932,'新增培训考评');},editReviewInfo:function editReviewInfo(){return getLabel(385933,'编辑培训考评');},finishInfo:function finishInfo(){return getLabel(6135,'结束信息');},none:function none(){return getLabel(83519,'无');},setYear:function setYear(){return getLabel(385642,'指定年份');},newSalaryItemsSet:function newSalaryItemsSet(){return getLabel(385934,'新建工资项设置');},editSalaryItemsSet:function editSalaryItemsSet(){return getLabel(385935,'编辑工资项设置');},levelSet:function levelSet(){return getLabel(385936,'等级设置');},benchmarkSet:function benchmarkSet(){return getLabel(33603,'个人基准设置');},customerSetting:function customerSetting(){return getLabel(32470,'自定义设置');},condition:function condition(){return getLabel(15364,'条件');},formula:function formula(){return getLabel(18125,'公式');},remindingCycle:function remindingCycle(){return getLabel(18711,'提醒周期');},useSamePassword:function useSamePassword(){return getLabel(32500,'同一密码使用');},forcedRevision:function forcedRevision(){return getLabel(385663,'天后强制修改，');},preCompulsoryRevision:function preCompulsoryRevision(){return getLabel(32502,'强制修改前');},remindingUser:function remindingUser(){return getLabel(385664,'天提醒用户');},errAccumulative:function errAccumulative(){return getLabel(32504,'输入密码错误累计');},lockAccount:function lockAccount(){return getLabel(385665,'次锁定账号，');},locking:function locking(){return getLabel(16213,'锁定');},unlockingInMinutes:function unlockingInMinutes(){return getLabel(385666,'分钟后自动解锁');},preview:function preview(){return getLabel(221,'预览');},beforeActive:function beforeActive(){return getLabel(385667,'启用此功能必须先');},setNetworkStrategy:function setNetworkStrategy(){return getLabel(385668,'设置网段策略');},leaveStaffHelper:function leaveStaffHelper(){return getLabel(385669,'启用后，只有有"离职人员查看"权限的用户可以检索非在职人员');},syncDynamicPasswordHelper:function syncDynamicPasswordHelper(){return getLabel(83874,'同步默认方式到所有使用动态密码的人');},syncDynamicTokenHelper:function syncDynamicTokenHelper(){return getLabel(385672,'同步默认方式到所有使用动态令牌的人');},syncHTKeyHelper:function syncHTKeyHelper(){return getLabel(385673,'同步默认方式到所有使用海泰key的人');},syncCAHelper:function syncCAHelper(){return getLabel(388512,'同步默认方式到所有使用CA验证的人');},startIPAddress:function startIPAddress(){return getLabel(21387,'起始IP地址');},endIPAddress:function endIPAddress(){return getLabel(385675,'结束IP地址');},createNetworkStrategy:function createNetworkStrategy(){return getLabel(385676,'新建网段策略');},editNetworkStrategy:function editNetworkStrategy(){return getLabel(385679,'编辑网段策略');},unfilled:function unfilled(){return getLabel(21423,'未填写');},addConditionField:function addConditionField(){return getLabel(385683,'此区域用于添加条件字段');},addValField:function addValField(){return getLabel(385684,'此区域用于添加取值字段');},taxRateSet:function taxRateSet(){return getLabel(17226,'税率设置');},newRpType:function newRpType(){return getLabel(385937,'新建奖惩种类');},editRpType:function editRpType(){return getLabel(385938,'编辑奖惩种类');},newRpManage:function newRpManage(){return getLabel(385939,'新建奖惩管理');},editRpManage:function editRpManage(){return getLabel(385940,'编辑奖惩管理');},personalPercent:function personalPercent(){return getLabel(385941,'个人百分比');},companyPercent:function companyPercent(){return getLabel(385942,'公司百分比');},newContractType:function newContractType(){return getLabel(385943,'新建合同种类');},editContractType:function editContractType(){return getLabel(385944,'编辑合同种类');},newAssType:function newAssType(){return getLabel(385945,'新建考核种类');},editAssType:function editAssType(){return getLabel(385946,'编辑考核种类');},assDoc:function assDoc(){return getLabel(15759,'考核资料');},assItem:function assItem(){return getLabel(6117,'考核项目');},assedPost:function assedPost(){return getLabel(17425,'被考核岗位');},//only chinese
weight:function weight(){return getLabel(6071,'权重');},assPerson:function assPerson(){return getLabel(15662,'考核人');},oneself:function oneself(){return getLabel(15763,'本人');},directSuperior:function directSuperior(){return getLabel(15709,'直接上级');},allSuperiors:function allSuperiors(){return getLabel(15762,'所有上级');},directSubordinates:function directSubordinates(){return getLabel(15764,'直接下级');},allLowerLevels:function allLowerLevels(){return getLabel(15765,'所有下级');},anotherDeptPerson:function anotherDeptPerson(){return getLabel(15766,'本部门其他人');},humanResource:function humanResource(){return getLabel(179,'人力资源');},createWorkflow:function createWorkflow(){return getLabel(127037,'创建流程路径');},createForm:function createForm(){return getLabel(127027,'创建表单');},newAssItem:function newAssItem(){return getLabel(385947,'新建考核项目');},editAssItem:function editAssItem(){return getLabel(385948,'编辑考核项目');},addWarningObject:function addWarningObject(){return getLabel(385949,'添加提醒对象');},batchAdjust:function batchAdjust(){return getLabel(383940,'批量调整');},batchEdit:function batchEdit(){return getLabel(383518,'批量编辑');},batchUpload:function batchUpload(){return getLabel(21400,'批量上传');},scheduleMember:function scheduleMember(){return getLabel(125839,'排班人员');},curAss:function curAss(){return getLabel(15652,'当前考核');},completedAss:function completedAss(){return getLabel(15656,'已完成考核');},assSituation:function assSituation(){return getLabel(15920,'考核情况');},assDetail:function assDetail(){return getLabel(386205,'考核明细');},authedSub:function authedSub(){return getLabel(83500,'分权多分部');},authedDepart:function authedDepart(){return getLabel(21482,'分权多部门');},authedHrm:function authedHrm(){return getLabel(21480,'分权多人力资源');},personalSet:function personalSet(){return getLabel(17627,'个人设置');},companySet:function companySet(){return getLabel(83482,'公司设置');},scope:function scope(){return getLabel(19467,'范围');},timeScope:function timeScope(){return getLabel(19482,'时间范围');},_year:function _year(){return getLabel(17138,'年度');},halfYear:function halfYear(){return getLabel(19483,'半年度');},quarter:function quarter(){return getLabel(17495,'季度');},monthly:function monthly(){return getLabel(19398,'月度');},job:function job(){return getLabel(1915,'职务');},levelFrom:function levelFrom(){return getLabel(386206,'职级(从)');},levelTo:function levelTo(){return getLabel(386207,'职级(到)');},money:function money(){return getLabel(26877,'金额');},city:function city(){return getLabel(493,'城市');},taxBase:function taxBase(){return getLabel(15835,'税收基数');},series:function series(){return getLabel(386208,'级数');},taxLevelFrom:function taxLevelFrom(){return getLabel(15837,'含税级距(从)');},taxLevelTo:function taxLevelTo(){return getLabel(15838,'含税级距(到)');},taxRate:function taxRate(){return getLabel('391179',"税率(%)");},quickCalDeduction:function quickCalDeduction(){return getLabel(19756,'速算扣除数');},newTitle:function newTitle(){return getLabel(386209,'新建职称');},editTitle:function editTitle(){return getLabel(386210,'编辑职称');},supportFormatPic:function supportFormatPic(){return getLabel(386211,'支持 jpg、png、gif 格式的图片文件');},batchAdjustSupSubCompany:function batchAdjustSupSubCompany(){return getLabel(386069,'批量调整上级分部');},batchAdjustSubCompany:function batchAdjustSubCompany(){return getLabel(386070,'批量调整分部');},batchAdjustSupDepartment:function batchAdjustSupDepartment(){return getLabel(386071,'批量调整上级部门');},batchAdjustSup:function batchAdjustSup(){return getLabel(386072,'批量调整上级');},batchAdjustStation:function batchAdjustStation(){return getLabel(386073,'批量调整岗位');},batchAdjustDepartment:function batchAdjustDepartment(){return getLabel(386074,'批量调整部门');},batchAdjustAccount:function batchAdjustAccount(){return getLabel(386075,'批量调整主次账号');},joinGroup:function joinGroup(){return getLabel(130759,'加入到组');},batchAdjustPassword:function batchAdjustPassword(){return getLabel(386120,'批量修改密码');},newJobType:function newJobType(){return getLabel(386212,'新建职务类别');},newJob:function newJob(){return getLabel(386213,'新建职务');},newPost:function newPost(){return getLabel(125302,'新建岗位');},editJobType:function editJobType(){return getLabel(386214,'编辑职务类别');},editJob:function editJob(){return getLabel(386215,'编辑职务');},editPost:function editPost(){return getLabel(386216,'编辑岗位');},typeInfo:function typeInfo(){return getLabel(32655,'类别信息');},subordinatePosition:function subordinatePosition(){return getLabel(386217,'下级职务');},jobInfo:function jobInfo(){return getLabel(383211,'职务信息');},lowerPost:function lowerPost(){return getLabel(386218,'下级岗位');},postSys:function postSys(){return getLabel(82664,'岗位体系');},manageableModule:function manageableModule(){return getLabel(386219,'可管理模块');},onlySelectedAdmin:function onlySelectedAdmin(){return getLabel(386220,'仅分配勾选模块的分权权限。');},decentralizationLink:function decentralizationLink(){return getLabel(386221,'管理分权设置链接如下：');},decentralizationSet:function decentralizationSet(){return getLabel(386222,'管理分权设置');},newMajor:function newMajor(){return getLabel(386223,'新建专业');},editMajor:function editMajor(){return getLabel(386224,'编辑专业');},untreatedMatters:function untreatedMatters(){return getLabel(386225,'未处理事宜');},format:function format(){return getLabel(386226,'格式：');},defalutSignTime:function defalutSignTime(){return getLabel(32541,'不填写默认为所有时间都可签到');},workingTime:function workingTime(){return getLabel(386227,'工作时间总计：');},groupMember:function groupMember(){return getLabel(386228,'群组人员');},newEducation:function newEducation(){return getLabel(386229,'新建学历');},editEducation:function editEducation(){return getLabel(386230,'编辑学历');},sysShowItems:function sysShowItems(){return getLabel(32980,'系统显示栏目');},defineShowItems:function defineShowItems(){return getLabel(32744,'自定义显示栏目');},childItems:function childItems(){return getLabel(32749,'子栏目');},sysadminRemind:function sysadminRemind(){return getLabel(386231,'管理员提醒');},staffRemind:function staffRemind(){return getLabel(386232,'员工提醒');},css:function css(){return getLabel(1014,'样式');},pictureSet:function pictureSet(){return getLabel(22923,'图片设置');},maxSize:function maxSize(){return getLabel(386233,'最大 10M/个（建议尺寸：475*500）');},adviceSize:function adviceSize(){return getLabel('386989',"最大 10M/个（建议尺寸：700*330）");},sysAdmin:function sysAdmin(){return getLabel(16139,'系统管理员');},date:function date(){return getLabel(22823,'日期');},newCountry:function newCountry(){return getLabel(386234,'新建国家');},newProvince:function newProvince(){return getLabel(386235,'编辑省份');},newCity:function newCity(){return getLabel(386236,'编辑城市');},newCityTwo:function newCityTwo(){return getLabel(386237,'编辑区县');},editCountry:function editCountry(){return getLabel(386238,'编辑国家');},editProvince:function editProvince(){return getLabel(386235,'编辑省份');},editCity:function editCity(){return getLabel(386236,'编辑城市');},editCityTwo:function editCityTwo(){return getLabel(386237,'编辑区县');},countryInfo:function countryInfo(){return getLabel(386239,'国家信息');},lowerProvince:function lowerProvince(){return getLabel(386240,'下级省份');},provinceInfo:function provinceInfo(){return getLabel(386241,'省份信息');},lowerCity:function lowerCity(){return getLabel(386242,'下级城市');},cityInfo:function cityInfo(){return getLabel(386243,'城市信息');},lowerCityTwo:function lowerCityTwo(){return getLabel(386244,'下级区县');},areaImportTemplet:function areaImportTemplet(){return getLabel(386245,'行政区域导入模板');},newWorkPlace:function newWorkPlace(){return getLabel(386246,'新建办公地点');},editWorkPlace:function editWorkPlace(){return getLabel(386247,'编辑办公地点');},wpImportTemplet:function wpImportTemplet(){return getLabel(386248,'办公地点导入模板');},newContractMaintain:function newContractMaintain(){return getLabel(386249,'新建合同维护');},editContractMaintain:function editContractMaintain(){return getLabel(386250,'编辑合同维护');},newContractTemplate:function newContractTemplate(){return getLabel(386251,'新建合同模板');},editContractTemplate:function editContractTemplate(){return getLabel(386252,'编辑合同模板');},nationalAbbr:function nationalAbbr(){return getLabel(382324,'国家简称');},provinceAbbr:function provinceAbbr(){return getLabel(382327,'省份简称');},ownedCountry:function ownedCountry(){return getLabel(125935,'所属国家');},province:function province(){return getLabel(800,'省份');},cityTwo:function cityTwo(){return getLabel(25223,'区县（二级城市）');},anniversaryReminding:function anniversaryReminding(){return getLabel('391182',"入职周年提醒");},newFuncManageDecent:function newFuncManageDecent(){return getLabel('386990',"新建功能管理赋权");},editFuncManageDecent:function editFuncManageDecent(){return getLabel('386991',"编辑功能管理赋权");},maintainerSet:function maintainerSet(){return getLabel('386992',"维护人设置");},decentSet:function decentSet(){return getLabel('33378',"赋权设置");},decentSubcompany:function decentSubcompany(){return getLabel('83500',"分权多分部");},decentDepartment:function decentDepartment(){return getLabel('21482',"分权多部门");},contractContent:function contractContent(){return getLabel('386993',"合同内容");},untreated:function untreated(){return getLabel('15746',"未处理");},recruiting:function recruiting(){return getLabel('15747',"正在招聘");},newEmployDemand:function newEmployDemand(){return getLabel('386994',"新建用工需求");},editEmployDemand:function editEmployDemand(){return getLabel('386995',"编辑用工需求");},newRecruitPlan:function newRecruitPlan(){return getLabel('386996',"新建招聘计划");},editRecruitPlan:function editRecruitPlan(){return getLabel('386997',"编辑招聘计划");},stopRecruitPlan:function stopRecruitPlan(){return getLabel('386998',"结束招聘计划");},recruitStep:function recruitStep(){return getLabel('15745',"招聘步骤");},recruitInfo:function recruitInfo(){return getLabel('366',"招聘信息");},applicationInfo:function applicationInfo(){return getLabel('386999',"应聘情况");},newRecruitInfo:function newRecruitInfo(){return getLabel('17153',"新建招聘信息");},editRecruitInfo:function editRecruitInfo(){return getLabel('387000',"编辑招聘信息");},recruitSchedule:function recruitSchedule(){return getLabel('15720',"招聘日程");},newSignature:function newSignature(){return getLabel('16387',"新建签章");},editSignature:function editSignature(){return getLabel('387001',"编辑签章");},signatureImage:function signatureImage(){return getLabel('18695',"签章图片");},postImportTemplet:function postImportTemplet(){return getLabel(387063,'职务岗位导入模板');},majorImportTemplet:function majorImportTemplet(){return getLabel(387064,'专业导入模板');},newWorkNature:function newWorkNature(){return getLabel(387065,'新建用工性质');},editWorkNature:function editWorkNature(){return getLabel(387276,'编辑用工性质');},addSysadmin:function addSysadmin(){return getLabel('391183',"添加管理员");},newCommonGroup:function newCommonGroup(){return getLabel(387067,'新建群组');},editCommonGroup:function editCommonGroup(){return getLabel(33534,'编辑群组');},addGroupMember:function addGroupMember(){return getLabel(387068,'添加群组人员');},newUnit:function newUnit(){return getLabel(387069,'新建单位');},editUnit:function editUnit(){return getLabel(387178,'编辑单位');},toBeTreated:function toBeTreated(){return getLabel(16349,'待处理');},stayBy:function stayBy(){return getLabel(15689,'备用');},adjustTarget:function adjustTarget(){return getLabel('387024',"调整对象");},adjustResult:function adjustResult(){return getLabel('387025',"共调整 {param1} 个{param2}的 {param3} 个信息项！");},noPhoto:function noPhoto(){return getLabel('387051',"无照片");},hasPhoto:function hasPhoto(){return getLabel('387052',"有照片");},historyUploadRecord:function historyUploadRecord(){return getLabel('387056',"历史上传记录");},viewUploadLogs:function viewUploadLogs(){return getLabel('387057',"查看上传日志");},uploadLogs:function uploadLogs(){return getLabel('387058',"上传日志");},categoryAbbreviation:function categoryAbbreviation(){return getLabel(382407,"类别简称");},jobCategory:function jobCategory(){return getLabel(805,"职务类别");},jobAbbreviation:function jobAbbreviation(){return getLabel(382410,"职务简称");},duties:function duties(){return getLabel(15855,"所属职务");},postAbbreviation:function postAbbreviation(){return getLabel(382413,"岗位简称");},viewRefs:function viewRefs(){return getLabel('33364',"查看引用");},view:function view(){return getLabel('33564',"查看");},addRoleRefs:function addRoleRefs(){return getLabel('387114',"添加角色引用");},multiDeleteRefs:function multiDeleteRefs(){return getLabel('387113',"批量删除引用");},newSysadmin:function newSysadmin(){return getLabel(387059,'新建管理员');},editSysadmin:function editSysadmin(){return getLabel(387060,'编辑管理员');},newModuleDecent:function newModuleDecent(){return getLabel(387061,'新建模块管理分权');},editModuleDecent:function editModuleDecent(){return getLabel(387062,'编辑模块管理分权');},includeChildren:function includeChildren(){return getLabel('128725',"包含下级");},notIncludeChildren:function notIncludeChildren(){return getLabel('387277',"不包含下级");},haveNotDepartment:function haveNotDepartment(){return getLabel('387278',"您选择的分部下无部门信息，请重新选择！");},haveNotPerson:function haveNotPerson(){return getLabel('387279',"您选择的部门下无人员信息，请重新选择！");},adminSet:function adminSet(){return getLabel(17869,'管理员设置');},tips:function tips(){return getLabel('558',"提示");},dbEncryption:function dbEncryption(){return getLabel('387371',"数据库加密");},createAndMoveGroup:function createAndMoveGroup(){return getLabel('31194',"新建分组并移动");}},button:{collect:function collect(){return getLabel(28111,'收藏');},helper:function helper(){return getLabel(275,'帮助');},search:function search(){return getLabel(82529,'搜索');},reset:function reset(){return getLabel(27088,'重置');},ok:function ok(){return getLabel(33703,'确定');},cancel:function cancel(){return getLabel(32694,'取消');},create:function create(){return getLabel(365,'新建');},remove:function remove(){return getLabel(20230,'移除');},delete:function _delete(){return getLabel(131966,'删除');},modify:function modify(){return getLabel(93,'编辑');},transfer:function transfer(){return getLabel(80,'转移');},multiRemove:function multiRemove(){return getLabel(383696,'批量移除');},multiDelete:function multiDelete(){return getLabel(32136,'批量删除');},save:function save(){return getLabel(30986,'保存');},saveAndSetting:function saveAndSetting(){return getLabel(32159,'保存并进入详细设置');},more:function more(){return getLabel(131654,'更多')+'>>';},createGroup:function createGroup(){return getLabel(30131,'新建分组');},editGroup:function editGroup(){return getLabel(83149,'编辑分组');},groupMaintain:function groupMaintain(){return getLabel(383049,'分组维护');},createChildInfo:function createChildInfo(){return getLabel(17550,'新建子信息');},childInfoMaintain:function childInfoMaintain(){return getLabel(384280,'子信息维护');},editChildInfo:function editChildInfo(){return getLabel(32732,'编辑子信息');},add:function add(){return getLabel(131201,'添加');},copy:function copy(){return getLabel(77,'复制');},log:function log(){return getLabel(83,'日志');},replace:function replace(){return getLabel(84563,'替换');},columnVisibleSetting:function columnVisibleSetting(){return getLabel(32535,'显示列定制');},multiModify:function multiModify(){return getLabel(383518,'批量编辑');},multiModifyAuthRoleLevel:function multiModifyAuthRoleLevel(){return getLabel(383965,'批量编辑权限级别');},multiModifyDetachRoleLevel:function multiModifyDetachRoleLevel(){return getLabel(383966,'批量编辑操作级别');},multiModifyMemberRoleLevel:function multiModifyMemberRoleLevel(){return getLabel(383967,'批量编辑成员级别');},removeRef:function removeRef(){return getLabel(33462,'删除引用');},doExcute:function doExcute(){return getLabel(83073,'开始执行');},done:function done(){return getLabel(555,'完成');},selectAll:function selectAll(){return getLabel(383968,'选择全部');},selectAll0:function selectAll0(){return getLabel(556,'全选');},stop:function stop(){return getLabel(17581,'停止');},goBack:function goBack(){return getLabel(1290,'返回');},maintenancer:function maintenancer(){return getLabel(19909,'维护者');},fieldMaintenance:function fieldMaintenance(){return getLabel(33943,'字段维护');},dataMaintenance:function dataMaintenance(){return getLabel(33933,'数据维护');},toDataMaintenance:function toDataMaintenance(){return getLabel(383969,'保存并进入数据维护');},import:function _import(){return getLabel(18596,'导入');},export:function _export(){return getLabel(28343,'导出Excel');},clearScreen:function clearScreen(){return getLabel(383970,'清空筛选');},importResource:function importResource(){return getLabel(17887,'人员导入');},importOrg:function importOrg(){return getLabel(125523,'组织结构导入');},resourceAddToVirtual:function resourceAddToVirtual(){return getLabel(34100,'加入到多维组织');},setManager:function setManager(){return getLabel(34078,'设置上级');},selectFile:function selectFile(){return getLabel(125333,'选择文件');},submit:function submit(){return getLabel(615,'提交');},importHistoryQuery:function importHistoryQuery(){return getLabel(24644,'历史导入记录');},queryImportLog:function queryImportLog(){return getLabel(384041,'查看导入日志');},getImportLog:function getImportLog(){return getLabel(24835,'导入日志');},postSystemImport:function postSystemImport(){return getLabel(125443,'岗位体系导入');},groupInfoImport:function groupInfoImport(){return getLabel(125445,'常用组信息导入');},personalAndWorkInfoImport:function personalAndWorkInfoImport(){return getLabel(125678,'个人信息、工作信息明细内容导入');},//only chinese
areaInfoImport:function areaInfoImport(){return getLabel(126168,'行政区域导入');},workingPlaceImport:function workingPlaceImport(){return getLabel(384176,'办公地点导入');},workingPlaceInfoImport:function workingPlaceInfoImport(){return getLabel(125447,'办公地点信息导入');},majorImport:function majorImport(){return getLabel(384177,'专业导入');},majorInfoImport:function majorInfoImport(){return getLabel(125449,'专业信息导入');},downloadErrorDatas:function downloadErrorDatas(){return getLabel(384190,'下载错误数据');},downloadAllDatas:function downloadAllDatas(){return getLabel(384191,'下载全部数据');},syncToSubDept:function syncToSubDept(){return getLabel(21671,'同步下级单位');},immediateSync:function immediateSync(){return getLabel(33543,'立即同步');},autoGenerate:function autoGenerate(){return getLabel(83444,'自动生成');},createScheduling:function createScheduling(){return getLabel(125836,'新建排班');},multiRemoveScheduling:function multiRemoveScheduling(){return getLabel(385032,'批量取消排班');},clearScheudling:function clearScheudling(){return getLabel(125841,'清除排班');},close:function close(){return getLabel(309,'关闭');},//only chinese
multiOp:function multiOp(){return getLabel(21611,'批量处理');},resetSetting:function resetSetting(){return getLabel(32761,'清除设置');},setAddedDays:function setAddedDays(){return getLabel(128858,'设置额外年假');},setting:function setting(){return getLabel(30747,'设置');},sync:function sync(){return getLabel(18240,'同步');},multiSetting:function multiSetting(){return getLabel(33511,'批量设置');},syncDefault:function syncDefault(){return getLabel(385686,'同步默认方式');},saveSelectedData:function saveSelectedData(){return getLabel(385789,'保存选中项');},batchOp:function batchOp(){return getLabel(31914,'批量操作');},importMatrix:function importMatrix(){return getLabel('386933',"矩阵导入");},synchroDecentModules:function synchroDecentModules(){return getLabel(33901,"同步所有分权模块");},bind:function bind(){return getLabel(-1,"绑定");},clickToSet:function clickToSet(){return getLabel(-1,"点击设置");},moveToGroup:function moveToGroup(){return getLabel('-81296',"移动到组");},testConnect:function testConnect(){return getLabel('383271',"测试连接");}},confirm:{defaultTitle:function defaultTitle(){return getLabel(131329,'信息确认');},removeGroupInfo:function removeGroupInfo(){return getLabel(383053,'删除分组，该分组下的字段将显示到“基本信息”分组中，确定要删除吗？');},groupNameExist:function groupNameExist(){return getLabel(130074,'已存在同名分组，请确认');},childInfoNameExist:function childInfoNameExist(){return getLabel(384281,'已存在同名子信息，请确认');},groupNameIsEmpty:function groupNameIsEmpty(){return getLabel(130064,'请填写分组名称');},displayOrDBFieldIsEmpty:function displayOrDBFieldIsEmpty(){return getLabel(383054,'字段显示名或数据库字段名不能为空!');},displayOrDBFieldExist:function displayOrDBFieldExist(){return getLabel(383055,'已存在同名字段显示名或数据库字段名，请确认！');},removeSelected:function removeSelected(){return getLabel(385639,'确定要移除选择的记录吗？');},deleteSelected:function deleteSelected(){return getLabel(385625,'确定要删除选择的记录吗？');},operationConfirm:function operationConfirm(){return getLabel(383971,'确定要{param}吗？');},selectedEmpty:function selectedEmpty(){return getLabel(84093,'请至少选择一条记录!');},displayNameExist:function displayNameExist(){return getLabel(383972,'显示名重复');},fieldNameExist:function fieldNameExist(){return getLabel(383973,'字段名重复');},matrixNameExist:function matrixNameExist(){return getLabel(384283,'已存在同名矩阵，请确认');},cancelSelected:function cancelSelected(){return getLabel(384051,'确定要封存选中的记录吗？');},doISCancelSelected:function doISCancelSelected(){return getLabel(384050,'确定要解封选中的记录吗？');},remove:function remove(){return getLabel(83449,'确定要移除吗？');},delete:function _delete(){return getLabel(83877,'确定要删除吗？');},cancel:function cancel(){return getLabel(384052,'确定要封存吗？');},doISCancel:function doISCancel(){return getLabel(384053,'确定要解封吗？');},subCompanyCodeExist:function subCompanyCodeExist(){return getLabel(384055,'分部编号重复');},departmentCodeExist:function departmentCodeExist(){return getLabel(384056,'部门编号重复');},workCodeExist:function workCodeExist(){return getLabel(384057,'人员编号重复');},forbidden:function forbidden(){return getLabel(385359,'确定要禁用吗?');},active:function active(){return getLabel(385033,'确认要启用吗?');},removeConfirm:function removeConfirm(){return getLabel(83449,'确定要移除吗？');},syncToSubDept:function syncToSubDept(){return getLabel(21669,'您确定此设置同步到下级单位吗？此操作将覆盖所有下级单位的设置！');},conditionFieldEmpty:function conditionFieldEmpty(){return getLabel(384625,'条件字段不能为空');},changeRotationModel:function changeRotationModel(){return getLabel(125925,'切换轮换模式将清空班次明细，是否继续？');},checkGenForm:function checkGenForm(){return getLabel(84793,'将生成{param}表单，是否继续？');},informConfirm:function informConfirm(){return getLabel(15782,'确定要通知吗？');},noModification:function noModification(){return getLabel(19583,'没有修改项！');},salaryAdjustConfirm:function salaryAdjustConfirm(){return getLabel(19581,'你确定要调整薪酬设置吗？');},payrollClosedConfirm:function payrollClosedConfirm(){return getLabel(20805,'关闭工资单后将无法再编辑和重新生成此月工资单');},checkCancelSchedule:function checkCancelSchedule(){return getLabel(125838,'确定要取消排班吗？');},syncPaidLeavePeriod:function syncPaidLeavePeriod(){return getLabel(21669,'您确定此设置同步到下级单位吗？此操作将覆盖所有下级单位的设置！');},syncAnnualPeriod:function syncAnnualPeriod(){return getLabel(21669,'您确定此设置同步到下级单位吗？此操作将覆盖所有下级单位的设置！');},payrollSendConfirm:function payrollSendConfirm(){return getLabel(19586,'你确定要发送工资单吗？');},leaveTypeNameExist:function leaveTypeNameExist(){return getLabel(385360,'已存在相同请假类型名称，请确认！');},setAddedDays:function setAddedDays(){return getLabel(385361,'设置额外年假是将上一年度的剩余额外年假更新到本年度的额外年假中，确认进行此操作？');},batchHandleWarning:function batchHandleWarning(){return getLabel(385952,'批处理将按照该项设置的规则重新设置人力资源工资表, 以前所做的所有改动都将改变,是否继续?');},refreshWarning:function refreshWarning(){return getLabel(385953,'当前页面数据将会丢失，是否继续？');},batchDeleteConfirm:function batchDeleteConfirm(){return getLabel(385625,'确定要删除选择的记录吗？');},syncPrivacySetting:function syncPrivacySetting(){return getLabel(385753,'确定将所选字段的默认设置同步到所有人吗？');},batchHandleWaring:function batchHandleWaring(){return getLabel('387002',"确定要批处理吗？");},batchHandleTip:function batchHandleTip(){return getLabel('385952',"批处理将按照该项设置的规则重新设置人力资源工资表, 以前所做的所有改动都将改变,是否继续?");},checkAdjust:function checkAdjust(){return getLabel('387023',"确定要做以下调整吗？");},deletePhoto:function deletePhoto(){return getLabel('387049',"确定要删除照片吗？");},multiDeletePhoto:function multiDeletePhoto(){return getLabel('387050',"确定删除所选人员照片吗？");},moveFieldConfirm:function moveFieldConfirm(){return getLabel('388100',"确定要移动所选择的记录到分组{params}吗？");}},message:{authFailed:function authFailed(){return getLabel(2012,'对不起，您暂时没有权限！');},actionError:function actionError(){return getLabel(132200,'操作失败！');},opSuccess:function opSuccess(){return getLabel(30700,'操作成功');},saveSuccess:function saveSuccess(){return getLabel(83551,'保存成功！');},saveFailed:function saveFailed(){return getLabel(84544,'保存失败！');},removeSuccess:function removeSuccess(){return getLabel(385950,'移除成功！');},deleteSuccess:function deleteSuccess(){return getLabel(83472,'删除成功！');},dataEmpty:function dataEmpty(){return getLabel(82241,'不能为空');},serverProcessing:function serverProcessing(){return getLabel(84041,'服务器正在处理，请稍候...');},dataNone:function dataNone(){return getLabel(83553,'暂无数据');},recordNotFound:function recordNotFound(){return getLabel(83781,'没有数据');},noMatchingData:function noMatchingData(){return getLabel(384284,'暂无匹配数据');},cancelSuccess:function cancelSuccess(){return getLabel(22155,'封存成功！');},doISCancelSuccess:function doISCancelSuccess(){return getLabel(22156,'解封成功！');},serverImportProcessing:function serverImportProcessing(){return getLabel(384042,'服务器正在处理数据导入，请稍后……');},supSubComError:function supSubComError(){return getLabel(22214,'所选上级分部不能为当前分部本身！');},supDeptComError:function supDeptComError(){return getLabel(15773,'上级部门不能为本部门!');},selectImportTemplete:function selectImportTemplete(){return getLabel(385362,'请选择导入模板!');},selectImportTempleteError:function selectImportTempleteError(){return getLabel(384059,'导入文件存在以下错误，请解决后重新上传！');},hardLoading:function hardLoading(){return getLabel(384193,'拼命加载中');},pleaseUploadFile:function pleaseUploadFile(){return getLabel(384197,'请上传文件');},pleaseConfirmDelRows:function pleaseConfirmDelRows(){return getLabel(30951,'请选择需要删除的数据!');},autoGenerateStateChangeForom:function autoGenerateStateChangeForom(){return getLabel(124924,'根据所选变更流程类型自动生成对应的表单');},syncSuccess:function syncSuccess(){return getLabel(384626,'同步成功');},plsSelectScheduling:function plsSelectScheduling(){return getLabel(385034,'请选择工作时段');},plsSelectDate:function plsSelectDate(){return getLabel(27938,'请选择日期');},dateRangeError:function dateRangeError(){return getLabel(385035,'下班时间必须晚于上班时间');},plsSelect:function plsSelect(){return getLabel(125389,'请先选择');},autoGenFormFaild:function autoGenFormFaild(){return getLabel(83398,'类型表单不支持自动生成，请选择已有表单！');},sechduleInfoNone:function sechduleInfoNone(){return getLabel(125942,'该人员在选择日期范围内没有排班信息！');},syncDataNone:function syncDataNone(){return getLabel(21677,'没有选择要同步的项！');},paidLeaveDays:function paidLeaveDays(){return getLabel(131712,'带薪假天数必须不小于0！');},annualdays:function annualdays(){return getLabel(129356,'年假天数必须不小于0！');},mustIntVal:function mustIntVal(){return getLabel(129033,'值只能为正整数！');},addeddays:function addeddays(){return getLabel(385363,'额外年假天数必须不小于0！');},leavedays:function leavedays(){return getLabel(385364,'已休年假天数必须不小于0！');},basedays:function basedays(){return getLabel(385365,'年假基数必须不小于0！');},expiryLessThanEffective:function expiryLessThanEffective(){return getLabel(129817,'失效日期不能小于生效日期');},workingage:function workingage(){return getLabel(385685,'工龄必须不小于0！');},dateConstructError:function dateConstructError(){return getLabel(385643,'数据格式异常');},hrmResourceRequired:function hrmResourceRequired(){return getLabel(385951,'人力资源浏览框必填');},logicWrong:function logicWrong(){return getLabel(18098,'条件设置不合逻辑');},scopeRequired:function scopeRequired(){return getLabel(386267,'范围必填！');},formulaRequired:function formulaRequired(){return getLabel(386268,'公式必填！');},implementation:function implementation(){return getLabel(385345,'暂未实现！');},plsSelect1:function plsSelect1(){return getLabel(387022,'请至少选择一个设置项！');},plsSelectSubCompany:function plsSelectSubCompany(){return getLabel(82181,'请选择分部');},plsSelectDepartment:function plsSelectDepartment(){return getLabel(386118,'请选择分部、部门');},plsSelectResource:function plsSelectResource(){return getLabel(386119,'请选择分部、部门或人员');},plsSelectTarget:function plsSelectTarget(){return getLabel('387021',"请选择调整对象！");},accountTypeDiff:function accountTypeDiff(){return getLabel(125528,'选择的记录中同时包含主次两种类型账号，请选择同类型账号！');},pwdLen:function pwdLen(){return getLabel('20172',"密码长度不能小于");},pwdType:function pwdType(){return getLabel('31863',"新密码不符合要求，必须为字母大写、字母小写、数字组合！请重新输入！");},pwdType1:function pwdType1(){return getLabel('83716',"新密码不符合要求，必须为字母、数字、特殊字符组合！请重新输入！");},dataConstructError:function dataConstructError(){return getLabel(385643,'数据格式异常');},pleaseAtLeastSelectOne:function pleaseAtLeastSelectOne(){return getLabel(387070,'请至少勾选一项可管理模块！');},requiredInfoIsNotFull:function requiredInfoIsNotFull(){return getLabel(387071,'第{param}行必填信息不完整！');},startTimeIsAlone:function startTimeIsAlone(){return getLabel(16696,'开始时间和结束时间没有成对出现！');},startTimeMustGreater:function startTimeMustGreater(){return getLabel(387072,'结束时间需要大于开始时间！');},afternoonStartTimeShouldBeLater:function afternoonStartTimeShouldBeLater(){return getLabel(387073,'下午开始时间需要晚于上午结束时间！');},secondSignTip:function secondSignTip(){return getLabel(82927,'第2次签到开始时间只能在上午结束时间与下午开始时间之内！');},effectiveDateRequired:function effectiveDateRequired(){return getLabel(387074,'生效日必填');},openThenShowSignInSignOut:function openThenShowSignInSignOut(){return getLabel(387416,'开启后前端界面会出现【签到】、【签退】按钮');},codeTip:function codeTip(){return getLabel(387165,'注意：代码只能为英文字母和阿拉伯数字，英文字母大小写敏感！');},noVerifyMethod:function noVerifyMethod(){return getLabel(-1,'没有可用的校验方式？');},doubleCheckPwdFaild:function doubleCheckPwdFaild(){return getLabel(81608,'密码验证不通过，请重新输入！');},moveSuccess:function moveSuccess(){return getLabel('129196',"移动成功");},'390218':function _(){return getLabel('390218',"请输入正确的手机号码");},'24570':function _(){return getLabel('24570',"邮箱地址的格式不正确");}},smallType:{HRM_ENGINE_SECURITYSETTING:1001,//安全设置
HRM_ENGINE_ORGANIZATION:1002,//组织机构
HRM_ENGINE_ORGANIZATION_COMPANY:1003,//总部
HRM_ENGINE_ORGANIZATION_VIRTUAL:1006,//虚拟维度
HRM_ENGINE_ORGANIZATION_SUBCOMPANY:1004,//分部
HRM_ENGINE_ORGANIZATION_DPEARTMENT:1005,//部门
HRM_ENGINE_ORGANIZATION_RESOURCE:2,//人力资源
HRM_ENGINE_ORGANIZATION_VIRTUAL_RESOURCE:1010//虚拟人力资源
}};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(37) && !__webpack_require__(43)(function () {
  return Object.defineProperty(__webpack_require__(85)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(44);
var toIObject = __webpack_require__(45);
var arrayIndexOf = __webpack_require__(140)(false);
var IE_PROTO = __webpack_require__(89)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(39).f;
var has = __webpack_require__(44);
var TAG = __webpack_require__(30)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(282);
var global = __webpack_require__(25);
var hide = __webpack_require__(47);
var Iterators = __webpack_require__(81);
var TO_STRING_TAG = __webpack_require__(30)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 117 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(207),
    isLength = __webpack_require__(152);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(40),
    stubFalse = __webpack_require__(314);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(317),
    listCacheDelete = __webpack_require__(318),
    listCacheGet = __webpack_require__(319),
    listCacheHas = __webpack_require__(320),
    listCacheSet = __webpack_require__(321);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(157);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(335);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(212),
    baseAssignValue = __webpack_require__(213);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(82),
    isObjectLike = __webpack_require__(55);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isFun = function isFun(arg) {
  return !!arg && typeof arg === 'function';
};

exports.default = isFun;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(6);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _ecCom=__webpack_require__(0);var _isArray=__webpack_require__(29);var _isArray2=_interopRequireDefault(_isArray);__webpack_require__(453);var _i18n=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.state={value:props.value||''};return _this;}(0,_createClass3.default)(Main,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if('value'in this.props&&this.state.value!==nextProps.value){this.setState({value:nextProps.value});}}},{key:'close',value:function close(){this.setState({value:''});this.props.onChange&&this.props.onChange('');}},{key:'onChange',value:function onChange(datas){var value='';if((0,_isArray2.default)(datas)&&!(0,_isEmpty2.default)(datas)){value=''+datas.pop();}else{value=datas;}this.setState({value:value});this.props.onChange&&this.props.onChange(value);}},{key:'render',value:function render(){var tip=this.props.tip;var value=this.state.value;return React.createElement('div',{className:'hrm-upload-avatar'},(0,_isEmpty2.default)(value)&&React.createElement('div',{className:'hrm-upload-wrapper'},React.createElement(_ecCom.WeaUpload,{autoUpload:true,uploadUrl:'/api/doc/upload/uploadFile',category:'all',limitType:'jpg,gif,png',onChange:this.onChange.bind(this)},React.createElement('i',{className:'icon-coms-AddTo upload-icon'})),React.createElement('span',{className:'tip'},'(',tip()+'400*600',')')),!(0,_isEmpty2.default)(value)&&React.createElement('div',{className:'hrm-avatar'},React.createElement('img',{src:'/weaver/weaver.file.FileDownload?fileid='+value}),React.createElement(_antd.Icon,{type:'cross-circle-o',title:'\u5220\u9664\u56FE\u7247',onClick:this.close.bind(this)})));}}]);return Main;}(React.Component),_class.defaultProps={tip:_i18n.i18n.label.pictureSizeSuggestedInfo},_temp);exports.default=Main;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetch=exports.tabs=exports.format=exports.downloadCvs2Img=undefined;var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _ecCom=__webpack_require__(0);var getLabel=_ecCom.WeaLocaleProvider.getLabel;var downloadCvs2Img=function downloadCvs2Img(params){var cvs=params.cvs,title=params.title;var $a=document.createElement('a');$a.download=title+'.jpg';$a.target='_blank';var url=void 0;if(cvs){url=cvs.toDataURL("image/jpg");}if(url)$a.href=url;if(typeof MouseEvent==='function'){var evt=new MouseEvent('click',{view:window,bubbles:true,cancelable:false});$a.dispatchEvent(evt);}else{if(window.navigator.msSaveOrOpenBlob){var bstr=atob(url.split(',')[1]);var n=bstr.length;var u8arr=new Uint8Array(n);while(n--){u8arr[n]=bstr.charCodeAt(n);}var blob=new Blob([u8arr]);window.navigator.msSaveOrOpenBlob(blob,title+'.jpg');}else{var html=''+'<body style="margin:0;">'+'<img src="'+url+'" style="max-width:100%;" title="" />'+'</body>';var tab=window.open();tab.document.write(html);}}};var format=function format(fmt){var date=new Date();var o={"M+":date.getMonth()+1,//月份   
"d+":date.getDate(),//日   
"h+":date.getHours(),//小时   
"m+":date.getMinutes(),//分   
"s+":date.getSeconds(),//秒   
"q+":Math.floor((date.getMonth()+3)/3),//季度   
"S":date.getMilliseconds()//毫秒   
};if(/(y+)/.test(fmt))fmt=fmt.replace(RegExp.$1,(date.getFullYear()+"").substr(4-RegExp.$1.length));for(var k in o){if(new RegExp("("+k+")").test(fmt))fmt=fmt.replace(RegExp.$1,RegExp.$1.length==1?o[k]:("00"+o[k]).substr((""+o[k]).length));}return fmt;};var getSearchsAd=function getSearchsAd(params){var isFormInit=params.isFormInit,conditions=params.conditions,form=params.form;var arr=[];isFormInit&&conditions.map(function(c){c.items.map(function(field,index){arr.push(React.createElement(_antd.Col,{span:10,offset:1},React.createElement('div',{style:{marginTop:20}},React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:6},wrapperCol:{span:18}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:form.getFormParams()})))));});});return React.createElement(_antd.Row,null,arr);};var getButtonsAd=function getButtonsAd(params){var form=params.form,search=params.search,cancel=params.cancel;var buttonsAd=[];[0,1,2].map(function(v){var name=v==0?getLabel(82529,'搜索'):v==1?getLabel(27088,'重置'):getLabel(32694,'取消');buttonsAd.push(React.createElement(_antd.Button,{type:v==0?"primary":'',onClick:function onClick(){v==1?form.reset():v==0?search():cancel();}},name));});return buttonsAd;};var tabs={getSearchsAd:getSearchsAd,getButtonsAd:getButtonsAd};var fetch=function fetch(params){var name=params.name,_params$fetchParams=params.fetchParams,fetchParams=_params$fetchParams===undefined?{}:_params$fetchParams,logic=params.logic,Api=params.Api;Api[name](fetchParams).then(function(cb){var api_status=cb.api_status;if(api_status){logic(cb);}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};exports.downloadCvs2Img=downloadCvs2Img;exports.format=format;exports.tabs=tabs;exports.fetch=fetch;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _keys=__webpack_require__(111);var _keys2=_interopRequireDefault(_keys);var _toConsumableArray2=__webpack_require__(74);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _defineProperty4=__webpack_require__(38);var _defineProperty5=_interopRequireDefault(_defineProperty4);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7;var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _ecCom=__webpack_require__(0);var _classnames2=__webpack_require__(583);var _classnames3=_interopRequireDefault(_classnames2);var _common=__webpack_require__(584);var _i18n=__webpack_require__(11);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty3.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var confirm=_antd.Modal.confirm;var info=_antd.Modal.info;var LogStore=_comsMobx.WeaLogView.LogStore;var HrmBaseStore=(_class=function(){function HrmBaseStore(){var _this=this;(0,_classCallCheck3.default)(this,HrmBaseStore);this.toJS=mobx.toJS;this.moment=_moment2.default;this.tabConfig={//模块主tab组件参数，通过继承来重写
keyParam:'viewCondition',activeTabKey:''};this.basicDialogParams={icon:"icon-coms-hrm",iconBgcolor:"#217346",style:{width:520,height:300},visible:false,title:''};this.menuIconCollection={save:'icon-coms-Preservation',create:'icon-coms-New-Flow',modify:'icon-coms-edit',remove:'icon-coms-Batch-delete',copy:'icon-coms-form-copy',entry:'icon-coms-edit',setting:'icon-coms-Flow-setting',log:'icon-coms-Print-log',multiModify:'icon-coms-BatchEditing',import:' icon-coms-leading-in',export:'icon-coms-export',search:'icon-coms-search',sync:'icon-coms-Update-synchronization',nextStep:'icon-coms-Next-step',lastStp:'icon-coms-Last-step'};this.getBasicMenus=function(){return[{key:'97',content:_i18n.i18n.button.collect(),icon:React.createElement('i',{className:'icon-coms-Collection'}),disabled:true}];};this.menus=[//右键菜单定义
{key:'97',content:_i18n.i18n.button.collect(),icon:React.createElement('i',{className:'icon-coms-Collection'}),disabled:true}];this.dialogPropsDef={moduleName:'hrm',visible:false,title:'',moreBtn:{datas:[]}// hasScroll: true
};this.refsDialogPropsDef={moduleName:'hrm',visible:false,title:''};this.dateSwitchTypeList=['year','month','week','day'];this.formTarget={};this.opId=null;this.authorizationInfo={};this.checkAuthorized=function(moduleName,params,callback,apiMethod){var needCheckDetachable=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;if(needCheckDetachable){(0,_common.checkAuthAndDetach)(moduleName,params,apiMethod).then(function(rs){rs.map(function(result,index){if(result.status==='1'){switch(index){case 0:var init=!result.hasRight;_this.authorizationInfo=result;_this.containerInitFinished=(0,_extends3.default)({},_this.containerInitFinished,{init:init,authorized:result.hasRight,userId:result.userId});_this.containerInitFinished.authorized&&callback&&callback();break;case 1:_this.containerInitFinished.detachable=result.detachable==='0'?false:true;break;}}});});}else{(0,_common.authorized)(moduleName,params,apiMethod).then(function(data){if(data.status==='1'){var init=!data.hasRight;_this.authorizationInfo=data;_this.containerInitFinished={init:init,authorized:data.hasRight};_this.containerInitFinished.authorized&&callback&&callback();}},function(error){_this.containerInitFinished={init:true,authorized:false};});}};this.btnsAndMenus=function(tabConfig){var topBtnDef=[],//WeaTop按钮
menuDef=[],//右键菜单
tabBtnDef=[];//WeaTab按钮
var activeTabIndex=_this.getTabIndex(tabConfig.tabs,tabConfig.activeTabKey);if(tabConfig.activeTabKey===''||activeTabIndex<0){return{btns:topBtnDef,menus:menuDef,tabBtnDef:tabBtnDef};}var tab=tabConfig.tabs[activeTabIndex];var topButtonDef=tab.topButtonDef,tabButtonDef=tab.tabButtonDef;topButtonDef&&topButtonDef.map(function(def,idx){//组织WeaTop按钮
var lbl=typeof def.label=='function'?def.label():def.label;switch(def.comType){case'button':var disabled=false;if(def.checkAction)disabled=_this[def.checkAction];topBtnDef.push(React.createElement(_antd.Button,{type:def.type,onClick:def.onClickHandle,disabled:disabled||def.disabled},lbl));menuDef.push({//组织右键菜单
key:'$top-btn-'+idx,content:lbl,icon:React.createElement('i',{className:def.rightMenuIcon||def.icon}),onClick:def.onClickHandle,disabled:disabled||def.disabled||false});break;default:break;}});tabButtonDef&&tabButtonDef.map(function(def,idx){var _classnames;//组织WeaTab按钮
var lab=typeof def.label=='function'?def.label():def.label;switch(def.comType){case'button':var disabled=false;if(def.checkAction)disabled=_this[def.checkAction];var classes=(0,_classnames3.default)((_classnames={},(0,_defineProperty5.default)(_classnames,def.icon,true),(0,_defineProperty5.default)(_classnames,'tabBtn',true),(0,_defineProperty5.default)(_classnames,'tabBtn-active',!disabled),(0,_defineProperty5.default)(_classnames,'tabBtn-disable',disabled),_classnames));if(def.brower==null){tabBtnDef.push(React.createElement('i',{className:classes,title:lab,onClick:!disabled?def.onClickHandle:null}));}else{switch(def.brower){case'authorization':tabBtnDef.push(React.createElement(_ecCom.WeaBrowser,{customized:true,tabs:[{name:_i18n.i18n.label.byList(),key:'1',dataParams:{list:1}},{name:_i18n.i18n.label.byAuthGroup(),key:'2'}],title:_i18n.i18n.label.selectAuthorization(),icon:'icon-coms-hrm',iconBgcolor:'#217346',type:'hrmRoleRight',inputStyle:{width:200},onChange:function onChange(ids,names,datas){return def.onClickHandle(ids,names,datas);},isSingle:false},React.createElement('i',{className:classes,title:lab})));// def.lableComs = <WeaBrowser
// 		customized
// 		tabs={[{name: i18n.label.byList, key: '1', dataParams: {list: 1}},{name: i18n.label.byAuthGroup, key: '2'}]}
// 		title={i18n.label.selectAuthorization}
// 		icon={'icon-coms-hrm'}
// 		iconBgcolor={'#217346'}
// 		type={'hrmRoleRight'}
// 		inputStyle={{width: 200}}
// 		onChange={(ids, names, datas) => def.onClickHandle(ids, names, datas)}
// 		isSingle={false}
// 	>
// 		<div>{def.label}</div>
// 	</WeaBrowser>
break;}}// menuDef.push({ //组织右键菜单
// 	key: `$tab-btn-${idx}`,
// 	content: def.lableComs || def.label,
// 	icon: <i className={def.rightMenuIcon || def.icon}/>,
// 	onClick: def.brower == null ? def.onClickHandle : null,
// 	disabled: disabled || def.disabled || false
// })
break;default:break;}});menuDef.push.apply(menuDef,(0,_toConsumableArray3.default)(_this.getBasicMenus()));//组织右键菜单
return{btns:topBtnDef,menus:menuDef,tabBtnDef:tabBtnDef};};this.setDialogVisible=function(com,val){var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var callback=arguments[3];_this.dialogParams[com]=(0,_extends3.default)({},_this.dialogParams[com],{visible:val,title:title});callback&&callback();};this.confirmInfo=function(props){confirm((0,_extends3.default)({},props,{title:_i18n.i18n.confirm.defaultTitle(),okText:_i18n.i18n.button.ok(),cancelText:_i18n.i18n.button.cancel()}));};this.hint=function(props){info((0,_extends3.default)({},props,{title:_i18n.i18n.confirm.defaultTitle(),okText:_i18n.i18n.button.ok()// style: {
// 	zIndex: 10000,
// 	parent: {
// 		style: {
// 			zIndex: 10000
// 		}
// 	}
// },
}));};this.setFormData=function(formName,fields){_this.formTarget[formName+'Fields']=fields;_this.formTarget[formName]=new _comsMobx.WeaForm();_this.formTarget[formName].initFormFields(fields);};this.requestFormData=function(form,api){var params=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var callback=arguments[3];api(params).then(function(data){if(data.status==='1'){_this.setFormData(form,data.formField);callback&&callback();}},function(error){});};this.requestTableData=function(tableStore,api){var params=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var callback=arguments[3];api(params).then(function(data){if(data.status==='1'){tableStore.getDatas(data.sessionkey,1);callback&&callback();}else _antd.message.error(data.message);},function(error){_antd.message.error(_i18n.i18n.message.actionError());});};this.showLog=function(logTypeParams){window.setLogViewProps((0,_extends3.default)({visible:true,logStore:new LogStore()},logTypeParams));};_initDefineProp(this,'containerInitFinished',_descriptor,this);_initDefineProp(this,'topTabCount',_descriptor2,this);_initDefineProp(this,'rDate',_descriptor3,this);_initDefineProp(this,'showError',_descriptor4,this);_initDefineProp(this,'dialogParams',_descriptor5,this);_initDefineProp(this,'definedColumn',_descriptor6,this);this.editTable={};this.editTableConfig={//WeaTableEdit参数定义，通过继承来重写
showTitle:false,draggable:true,showAdd:false,showDelete:false,showCopy:false,deleteConfirm:true/**
	 * 设置WeaTableEdit的refs对象
	 * @param  {Object} refs [WeaTableEdit]
	 */};this.setEditTable=function(refs,name){_this.editTable[name]=refs;};_initDefineProp(this,'recordOP',_descriptor7,this);this.generateTableEditRightMenuInfo=function(tableConfig){var rightMenuInfo=[];var keys=(0,_keys2.default)(tableConfig);keys.map(function(key,index){rightMenuInfo.push({key:'8'+(index+1),disabled:tableConfig[key].disabled,content:tableConfig[key].content,icon:React.createElement('i',{className:_this.menuIconCollection[key]}),onClick:tableConfig[key].callback});});return rightMenuInfo;};this.generateTableSelectedData=function(target){var selectedData={};_this.tableEditConfig[target].columns.map(function(column){column.hasOwnProperty('checkType')&&column.checkType==='checkbox'&&(0,_assign2.default)(selectedData,(0,_defineProperty5.default)({},column.dataIndex,[]));});return selectedData;};this.generateOtherParams=function(componentType){var otherParams={customProps:{'root':{viewAttr:1}},optionManageProps:{dialogProps:{icon:"icon-coms-hrm",iconBgcolor:"#217346"}}};switch(componentType){case'input':(0,_assign2.default)(otherParams.customProps,{'input':{viewAttr:1},'input.text':{viewAttr:1}});break;case'select':(0,_assign2.default)(otherParams.customProps,{'select':{viewAttr:1}});break;}return otherParams;};this.convertData=function(datas,target){var tData=[],selectedData=_this.generateTableSelectedData(target);datas.map(function(data,index){var d={};(0,_assign2.default)(d,(0,_extends3.default)({},data.record,data.props));delete d.key;var selectedDataKey=(0,_keys2.default)(selectedData);selectedDataKey.map(function(key){data.record.hasOwnProperty(key)&&data.record[key]==='1'&&selectedData[key].push(index);});if(data.hasOwnProperty('com')){var keys=(0,_keys2.default)(data.com);keys.map(function(key){if(data.com[key].length>0){var comDef=data.com[key][0];if(comDef.type==='CUSTOMFIELD'&&data.hasOwnProperty(comDef.key)&&data[comDef.key].length>0){(0,_assign2.default)(d,(0,_defineProperty5.default)({},comDef.key,data[comDef.key]));(0,_assign2.default)(comDef,{viewAttr:1,otherParams:_this.generateOtherParams(data[comDef.key][0])});}else if(comDef.type==='INPUT'&&key!='fieldname'){comDef.otherParams={inputType:window.inputType};}}});(0,_assign2.default)(d,{com:data.com});}tData.push(d);});return{datas:tData,selectedData:selectedData};};}/********************* unobservable list *********************///form collection
//数据操作对象主键ID
/**
	 * 权限验证
	 * @param  {String}   moduleName [模块名]
	 * @param  {Object}   params     [restful request url params]
	 * @param  {Function} callback   [验证通过后的callback function]
	 * @return {null}
	 */(0,_createClass3.default)(HrmBaseStore,[{key:'getTabIndex',/**
	 * 获取激活的tab页下标
	 * @param  {Array} tabs [tabData数组]
	 * @param  {String} key [tabKey]
	 * @return {Integer} [tab下标]
	 */value:function getTabIndex(tabs,key){if(tabs!=null&&tabs.length>0){return _.findIndex(tabs,{viewCondition:key});}return-1;}/**
	 * 获取WeaTop按钮、WeaTab按钮以及右键菜单列表
	 * @param  {Object} tabConfig [description]
	 * @return {Object}           [description]
	 *//**
	 * [description]
	 * @param  {String}   com      [dialog's name]
	 * @param  {Boolean}   val      [visible: true or false]
	 * @param  {String}   title    [dialog's title]
	 * @param  {Function} callback [callback function]
	 * @return {null}
	 *//**
	 * 初始化formStore
	 * @param  {String} formName [form's name]
	 * @param  {Array} fields   [form field definition]
	 * @return {null}
	 *//**
	 * 请求高级搜索表单的通用方法
	 * @param  {String}   form     [form's name]
	 * @param  {Function}   api      [restful api function]
	 * @param  {Object}   params   [restful request url params]
	 * @param  {Function} callback [callback function]
	 * @return {null}
	 *//**
	 * 获取表格数据的通用方法
	 * @param  {String} tableStore [tableStore's name]
	 * @param  {Function} api        [restful api function]
	 * @param  {Object} params     [restful request url params]
	 * @return {null}
	 *//********************* unobservable list *********************//********************* observable list *********************///WeaTab统计值
//状态刷新，组件引用该值监听变化重新render
//状态刷新，组件引用该值监听变化重新render
//模态框参数
/********************* observable list *********************//********************* action list *********************//********************* action list *********************//********************* tableEdit props & functions *********************///可编辑表格refs对象
/**
	 * 通过refs对WeaTableEdit进行添加行、删除行、复制行操作
	 * @param  {String} type [action]
	 */},{key:'getLocale',value:function getLocale(){return{firstDayOfWeek:0,lang:{format:{eras:[getLabel(383357,"公元前"),getLabel(383358,"公元")],months:[getLabel(1492,"一月"),getLabel(1493,"二月"),getLabel(383385,"三月"),getLabel(383387,"四月"),getLabel(1496,"五月"),getLabel(383392,"六月"),getLabel(383393,"七月"),getLabel(383394,"八月"),getLabel(383395,"九月"),getLabel(383396,"十月"),getLabel(383397,"十一月"),getLabel(383398,"十二月")],shortMonths:[getLabel(1492,"一月"),getLabel(1493,"二月"),getLabel(383385,"三月"),getLabel(383387,"四月"),getLabel(1496,"五月"),getLabel(383392,"六月"),getLabel(383393,"七月"),getLabel(383394,"八月"),getLabel(383395,"九月"),getLabel(383396,"十月"),getLabel(383397,"十一月"),getLabel(383398,"十二月")],weekdays:[getLabel(24626,"星期天"),getLabel(383399,"星期一"),getLabel(383400,"星期二"),getLabel(383402,"星期三"),getLabel(383403,"星期四"),getLabel(383404,"星期五"),getLabel(383405,"星期六")],shortWeekdays:[getLabel(16106,"周日"),getLabel(16100,"周一"),getLabel(16101,"周二"),getLabel(16102,"周三"),getLabel(16103,"周四"),getLabel(16104,"周五"),getLabel(16105,"周六")],veryShortWeekdays:[getLabel(16106,"周日"),getLabel(16100,"周一"),getLabel(16101,"周二"),getLabel(16102,"周三"),getLabel(16103,"周四"),getLabel(16104,"周五"),getLabel(16105,"周六")],ampms:[getLabel(383408,"上午"),getLabel(383409,"下午")],datePatterns:['yyyy\''+getLabel(383372,"年")+'\'M\''+getLabel(383373,"月")+'\'d\''+getLabel(383374,"日")+'\' EEEE','yyyy\''+getLabel(383372,"年")+'\'M\''+getLabel(383373,"月")+'\'d\''+getLabel(383374,"日")+'\'',"yyyy-M-d","yy-M-d"],timePatterns:['ahh\''+getLabel(383411,"时")+'\'mm\''+getLabel(383412,"分")+'\'ss\''+getLabel(383414,"秒")+'\' \'GMT\'Z','ahh\''+getLabel(383411,"时")+'\'mm\''+getLabel(383412,"分")+'\'ss\''+getLabel(383414,"秒")+'\'',"H:mm:ss","ah:mm"],dateTimePattern:'{date} {time}'}}};}/********************* tableEdit props & functions *********************/}]);return HrmBaseStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'containerInitFinished',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{//模块初始化状态
init:false,authorized:false,detachable:false};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'topTabCount',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'rDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Date().getTime();}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'showError',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Date().getTime();}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'dialogParams',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'definedColumn',[_mobx.action],{enumerable:true,initializer:function initializer(){return function(table){table.setColSetVisible(true);table.tableColSet(true);};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'recordOP',[_mobx.action],{enumerable:true,initializer:function initializer(){return function(target,type){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;switch(type){case'add':target.refs.edit.doAdd();break;case'remove':target.refs.edit.doDelete();break;case'copy':target.refs.edit.doCopy();break;case'valid':return target.refs.edit.doRequiredCheck();default:break;}};}})),_class);exports.default=HrmBaseStore;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveUserIcon=exports.uploadPortrailAuth=exports.delTag=exports.saveTag=exports.saveRemark=exports.editResource=exports.getResourceCard=exports.getHrmResourceTab=exports.getHrmResourceTab4Formal=exports.getResourceBaseTitle=exports.isAdmin=undefined;var _ecCom=__webpack_require__(0);var isAdmin=exports.isAdmin=function isAdmin(params){return _ecCom.WeaTools.callApi('/api/hrm/resource/isAdmin','GET',params);};var getResourceBaseTitle=exports.getResourceBaseTitle=function getResourceBaseTitle(params){return _ecCom.WeaTools.callApi('/api/hrm/resource/getResourceBaseTitle','GET',params);};var getHrmResourceTab4Formal=exports.getHrmResourceTab4Formal=function getHrmResourceTab4Formal(params){return _ecCom.WeaTools.callApi('/api/hrm/resource4formal/getHrmResourceTab','GET',params);};var getHrmResourceTab=exports.getHrmResourceTab=function getHrmResourceTab(params){return _ecCom.WeaTools.callApi('/api/hrm/resource/getHrmResourceTab','GET',params);};var getResourceCard=exports.getResourceCard=function getResourceCard(params){return _ecCom.WeaTools.callApi('/api/hrm/resource/getResourceCard','GET',params);};var editResource=exports.editResource=function editResource(params){return _ecCom.WeaTools.callApi('/api/hrm/resource/editResource','POST',params);};var saveRemark=exports.saveRemark=function saveRemark(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/resource4formal/saveRemark','POST',params);};var saveTag=exports.saveTag=function saveTag(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/resource4formal/saveTag','POST',params);};var delTag=exports.delTag=function delTag(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/resource4formal/delTag','POST',params);};var uploadPortrailAuth=exports.uploadPortrailAuth=function uploadPortrailAuth(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/usericon/getHasRight','GET',params);};var saveUserIcon=exports.saveUserIcon=function saveUserIcon(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/usericon/saveUserIcon','POST',params);};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(83);

var emptyObject = __webpack_require__(132);
var _invariant = __webpack_require__(84);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(134);
var invariant = __webpack_require__(84);
var ReactPropTypesSecret = __webpack_require__(135);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
exports.falsy = falsy;

var _propTypes = __webpack_require__(18);

function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = exports.history = (0, _propTypes.shape)({
  listen: _propTypes.func.isRequired,
  push: _propTypes.func.isRequired,
  replace: _propTypes.func.isRequired,
  go: _propTypes.func.isRequired,
  goBack: _propTypes.func.isRequired,
  goForward: _propTypes.func.isRequired
});

var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(138);
module.exports = __webpack_require__(20).Object.assign;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(31);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(139) });


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(59);
var gOPS = __webpack_require__(92);
var pIE = __webpack_require__(80);
var toObject = __webpack_require__(62);
var IObject = __webpack_require__(87);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(43)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(45);
var toLength = __webpack_require__(88);
var toAbsoluteIndex = __webpack_require__(141);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(78);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(31);
var core = __webpack_require__(20);
var fails = __webpack_require__(43);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(277);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(285);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(35);
var dPs = __webpack_require__(281);
var enumBugKeys = __webpack_require__(91);
var IE_PROTO = __webpack_require__(89)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(85)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(202).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(30);


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(25);
var core = __webpack_require__(20);
var LIBRARY = __webpack_require__(61);
var wksExt = __webpack_require__(145);
var defineProperty = __webpack_require__(39).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(80);
var createDesc = __webpack_require__(58);
var toIObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(86);
var has = __webpack_require__(44);
var IE8_DOM_DEFINE = __webpack_require__(113);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(37) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.loadjs = factory();
  }
}(this, function() {
/**
 * Global dependencies.
 * @global {Object} document - DOM
 */

var devnull = function() {},
    bundleIdCache = {},
    bundleResultCache = {},
    bundleCallbackQueue = {};


/**
 * Subscribe to bundle load event.
 * @param {string[]} bundleIds - Bundle ids
 * @param {Function} callbackFn - The callback function
 */
function subscribe(bundleIds, callbackFn) {
  // listify
  bundleIds = bundleIds.push ? bundleIds : [bundleIds];

  var depsNotFound = [],
      i = bundleIds.length,
      numWaiting = i,
      fn,
      bundleId,
      r,
      q;

  // define callback function
  fn = function (bundleId, pathsNotFound) {
    if (pathsNotFound.length) depsNotFound.push(bundleId);

    numWaiting--;
    if (!numWaiting) callbackFn(depsNotFound);
  };

  // register callback
  while (i--) {
    bundleId = bundleIds[i];

    // execute callback if in result cache
    r = bundleResultCache[bundleId];
    if (r) {
      fn(bundleId, r);
      continue;
    }

    // add to callback queue
    q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
    q.push(fn);
  }
}


/**
 * Publish bundle load event.
 * @param {string} bundleId - Bundle id
 * @param {string[]} pathsNotFound - List of files not found
 */
function publish(bundleId, pathsNotFound) {
  // exit if id isn't defined
  if (!bundleId) return;

  var q = bundleCallbackQueue[bundleId];

  // cache result
  bundleResultCache[bundleId] = pathsNotFound;

  // exit if queue is empty
  if (!q) return;

  // empty callback queue
  while (q.length) {
    q[0](bundleId, pathsNotFound);
    q.splice(0, 1);
  }
}


/**
 * Execute callbacks.
 * @param {Object or Function} args - The callback args
 * @param {string[]} depsNotFound - List of dependencies not found
 */
function executeCallbacks(args, depsNotFound) {
  // accept function as argument
  if (args.call) args = {success: args};

  // success and error callbacks
  if (depsNotFound.length) (args.error || devnull)(depsNotFound);
  else (args.success || devnull)(args);
}


/**
 * Load individual file.
 * @param {string} path - The file path
 * @param {Function} callbackFn - The callback function
 */
function loadFile(path, callbackFn, args, numTries) {
  var doc = document,
      async = args.async,
      maxTries = (args.numRetries || 0) + 1,
      beforeCallbackFn = args.before || devnull,
      pathStripped = path.replace(/^(css|img)!/, ''),
      isCss,
      e;

  numTries = numTries || 0;

  if (/(^css!|\.css$)/.test(path)) {
    isCss = true;

    // css
    e = doc.createElement('link');
    e.rel = 'stylesheet';
    e.href = pathStripped; //.replace(/^css!/, '');  // remove "css!" prefix
  } else if (/(^img!|\.(png|gif|jpg|svg)$)/.test(path)) {
    // image
    e = doc.createElement('img');
    e.src = pathStripped;    
  } else {
    // javascript
    e = doc.createElement('script');
    e.src = path;
    e.async = async === undefined ? true : async;
  }

  e.onload = e.onerror = e.onbeforeload = function (ev) {
    var result = ev.type[0];

    // Note: The following code isolates IE using `hideFocus` and treats empty
    // stylesheets as failures to get around lack of onerror support
    if (isCss && 'hideFocus' in e) {
      try {
        if (!e.sheet.cssText.length) result = 'e';
      } catch (x) {
        // sheets objects created from load errors don't allow access to
        // `cssText`
        result = 'e';
      }
    }

    // handle retries in case of load failure
    if (result == 'e') {
      // increment counter
      numTries += 1;

      // exit function and try again
      if (numTries < maxTries) {
        return loadFile(path, callbackFn, args, numTries);
      }
    }

    // execute callback
    callbackFn(path, result, ev.defaultPrevented);
  };

  // add to document (unless callback returns `false`)
  if (beforeCallbackFn(path, e) !== false) doc.head.appendChild(e);
}


/**
 * Load multiple files.
 * @param {string[]} paths - The file paths
 * @param {Function} callbackFn - The callback function
 */
function loadFiles(paths, callbackFn, args) {
  // listify paths
  paths = paths.push ? paths : [paths];

  var numWaiting = paths.length,
      x = numWaiting,
      pathsNotFound = [],
      fn,
      i;

  // define callback function
  fn = function(path, result, defaultPrevented) {
    // handle error
    if (result == 'e') pathsNotFound.push(path);

    // handle beforeload event. If defaultPrevented then that means the load
    // will be blocked (ex. Ghostery/ABP on Safari)
    if (result == 'b') {
      if (defaultPrevented) pathsNotFound.push(path);
      else return;
    }

    numWaiting--;
    if (!numWaiting) callbackFn(pathsNotFound);
  };

  // load scripts
  for (i=0; i < x; i++) loadFile(paths[i], fn, args);
}


/**
 * Initiate script load and register bundle.
 * @param {(string|string[])} paths - The file paths
 * @param {(string|Function)} [arg1] - The bundleId or success callback
 * @param {Function} [arg2] - The success or error callback
 * @param {Function} [arg3] - The error callback
 */
function loadjs(paths, arg1, arg2) {
  var bundleId,
      args;

  // bundleId (if string)
  if (arg1 && arg1.trim) bundleId = arg1;

  // args (default is {})
  args = (bundleId ? arg2 : arg1) || {};

  // throw error if bundle is already defined
  if (bundleId) {
    if (bundleId in bundleIdCache) {
      throw "LoadJS";
    } else {
      bundleIdCache[bundleId] = true;
    }
  }

  // load scripts
  loadFiles(paths, function (pathsNotFound) {
    // execute callbacks
    executeCallbacks(args, pathsNotFound);

    // publish bundle load event
    publish(bundleId, pathsNotFound);
  }, args);
}


/**
 * Execute callbacks when dependencies have been satisfied.
 * @param {(string|string[])} deps - List of bundle ids
 * @param {Object} args - success/error arguments
 */
loadjs.ready = function ready(deps, args) {
  // subscribe to bundle load event
  subscribe(deps, function (depsNotFound) {
    // execute callbacks
    executeCallbacks(args, depsNotFound);
  });

  return loadjs;
};


/**
 * Manually satisfy bundle dependencies.
 * @param {string} bundleId - The bundle id
 */
loadjs.done = function done(bundleId) {
  publish(bundleId, []);
};


/**
 * Reset loadjs dependencies statuses
 */
loadjs.reset = function reset() {
  bundleIdCache = {};
  bundleResultCache = {};
  bundleCallbackQueue = {};
};


/**
 * Determine if bundle has already been defined
 * @param String} bundleId - The bundle id
 */
loadjs.isDefined = function isDefined(bundleId) {
  return bundleId in bundleIdCache;
};


// export
return loadjs;

}));


/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(313),
    isObjectLike = __webpack_require__(55);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(315),
    baseUnary = __webpack_require__(154),
    nodeUtil = __webpack_require__(155);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(208);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(120),
    stackClear = __webpack_require__(322),
    stackDelete = __webpack_require__(323),
    stackGet = __webpack_require__(324),
    stackHas = __webpack_require__(325),
    stackSet = __webpack_require__(326);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(327),
    mapCacheDelete = __webpack_require__(334),
    mapCacheGet = __webpack_require__(336),
    mapCacheHas = __webpack_require__(337),
    mapCacheSet = __webpack_require__(338);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(348),
    stubArray = __webpack_require__(216);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(222);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _withPropsReactive = __webpack_require__(50);

var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);

var _log = __webpack_require__(41);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PolyEditor = function (_React$Component) {
  _inherits(PolyEditor, _React$Component);

  function PolyEditor(props) {
    _classCallCheck(this, PolyEditor);

    var _this = _possibleConstructorReturn(this, (PolyEditor.__proto__ || Object.getPrototypeOf(PolyEditor)).call(this, props));

    if (typeof window !== 'undefined') {
      if (!(props.__map__ && props.__poly__)) {
        _log2.default.warning('MAP_INSTANCE_REQUIRED');
      } else {
        var self = _this;
        _this.setterMap = {
          active: function active(val) {
            self.toggleActive(val);
          }
        };
        _this.map = props.__map__;
        _this.poly = props.__poly__;
        _this.editorActive = false;
        _this.createEditorInstance().then(function () {
          _this.props.onInstanceCreated && _this.props.onInstanceCreated();
        });
      }
    }
    return _this;
  }

  _createClass(PolyEditor, [{
    key: 'toggleActive',
    value: function toggleActive(active) {
      if (active) {
        if (!this.editorActive) {
          this.activeEditor();
        }
      } else {
        if (this.editorActive) {
          this.inactiveEditor();
        }
      }
    }
  }, {
    key: 'activeEditor',
    value: function activeEditor() {
      if (this.polyEditor) {
        this.editorActive = true;
        this.polyEditor.open();
      }
    }
  }, {
    key: 'inactiveEditor',
    value: function inactiveEditor() {
      this.editorActive = false;
      if (this.polyEditor) {
        this.polyEditor.close();
      }
    }
  }, {
    key: 'createEditorInstance',
    value: function createEditorInstance() {
      var _this2 = this;

      if (this.polyEditor) {
        return Promise.resolve(this.polyEditor);
      }
      return new Promise(function (resolve) {
        _this2.map.plugin(['AMap.PolyEditor'], function () {
          _this2.polyEditor = new window.AMap.PolyEditor(_this2.map, _this2.poly);
          resolve(_this2.polyEditor);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }, {
    key: 'instance',
    get: function get() {
      return this.polyEditor;
    }
  }]);

  return PolyEditor;
}(_react2.default.Component);

exports.default = (0, _withPropsReactive2.default)(PolyEditor);

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.InfoGroup4Formal3=exports.InfoGroup4Formal2=exports.InfoGroup4Formal1=exports.InfoGroup4Formal=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InfoGroup4Formal=function(_React$Component){(0,_inherits3.default)(InfoGroup4Formal,_React$Component);function InfoGroup4Formal(props){(0,_classCallCheck3.default)(this,InfoGroup4Formal);var _this=(0,_possibleConstructorReturn3.default)(this,(InfoGroup4Formal.__proto__||(0,_getPrototypeOf2.default)(InfoGroup4Formal)).call(this,props));_this.state={showGroup:true};return _this;}(0,_createClass3.default)(InfoGroup4Formal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,items=_props.items,_props$colLeft=_props.colLeft,colLeft=_props$colLeft===undefined?6:_props$colLeft,_props$colRight=_props.colRight,colRight=_props$colRight===undefined?15:_props$colRight,hide=_props.hide;var showGroup=this.state.showGroup;var colArr=[];items&&items.forEach(function(obj,index){var showValue=void 0;if(obj.isOpenHrm){showValue=obj.showName!=''?React.createElement('a',{href:'javaScript:openhrm('+obj.value+')',onClick:function onClick(event){return window.pointerXY(event);}},obj.showName):React.createElement('div',null,'\xA0');}else{showValue=obj.value?React.createElement('div',{dangerouslySetInnerHTML:{__html:obj.value}}):React.createElement('div',null,'\xA0');}colArr.push(React.createElement(_antd.Col,{span:24/2},React.createElement(_antd.Row,null,React.createElement(_antd.Col,{className:'wea-info-group-content-cell-label',span:colLeft},obj.label?obj.label:React.createElement('div',null,'\xA0'),':'),React.createElement(_antd.Col,{className:'wea-info-group-content-cell-value',span:colRight},showValue))));});return React.createElement('div',{className:'wea-info-group',style:hide?{display:'none'}:null},React.createElement(_antd.Row,{className:'wea-info-group-title'},React.createElement(_antd.Col,{span:20},React.createElement('div',{className:'wea-info-group-title-info'},title)),React.createElement(_antd.Col,{span:4,style:{textAlign:"right",paddingRight:10,fontSize:12,lineHeight:'32px'}},React.createElement('i',{style:{cursor:'pointer'},className:showGroup?'icon-coms-up':'icon-coms-down',onClick:function onClick(){return _this2.setState({showGroup:!showGroup});}}))),React.createElement(_antd.Row,{className:'wea-info-group-content',style:showGroup?null:{display:'none'}},colArr));}}]);return InfoGroup4Formal;}(React.Component);var InfoGroup4Formal1=function(_React$Component2){(0,_inherits3.default)(InfoGroup4Formal1,_React$Component2);function InfoGroup4Formal1(props){(0,_classCallCheck3.default)(this,InfoGroup4Formal1);var _this3=(0,_possibleConstructorReturn3.default)(this,(InfoGroup4Formal1.__proto__||(0,_getPrototypeOf2.default)(InfoGroup4Formal1)).call(this,props));_this3.state={showGroup:true};return _this3;}(0,_createClass3.default)(InfoGroup4Formal1,[{key:'render',value:function render(){var _this4=this;var _props2=this.props,title=_props2.title,items=_props2.items,_props2$colLeft=_props2.colLeft,colLeft=_props2$colLeft===undefined?6:_props2$colLeft,_props2$colRight=_props2.colRight,colRight=_props2$colRight===undefined?18:_props2$colRight;var showGroup=this.state.showGroup;var colArr=[];items&&items.forEach(function(obj,index){var showValue=void 0;if(obj.isOpenHrm){showValue=obj.showName!=''?React.createElement('a',{href:'javaScript:openhrm('+obj.value+')',onClick:function onClick(event){return window.pointerXY(event);}},obj.showName):React.createElement('div',null,'\xA0');}else{showValue=obj.value?React.createElement('div',{dangerouslySetInnerHTML:{__html:obj.value}}):React.createElement('div',null,'\xA0');}colArr.push(React.createElement(_antd.Row,null,obj.label&&React.createElement(_antd.Col,{className:'wea-info-group-content-cell-label',span:colLeft},obj.label?obj.label:React.createElement('div',null,'\xA0'),':'),React.createElement(_antd.Col,{className:'wea-info-group-content-cell-value',span:obj.label?colRight:24},showValue)));});if((0,_isEmpty2.default)(colArr)||colArr.length==0){colArr.push(React.createElement('li',{style:{textAlign:'center',listStyleType:'none'}},React.createElement('div',{style:{width:'100%',fontSize:'30px'}},React.createElement('i',{className:'icon-coms-NoData'})),React.createElement('div',{style:{color:'#B2B2B2'}},_i18n.i18n.message.dataNone())));}return React.createElement('div',{className:'wea-info-group'},React.createElement(_antd.Row,{className:'wea-info-group-title'},React.createElement(_antd.Col,{span:20},React.createElement('div',{className:'wea-info-group-title-info'},title)),React.createElement(_antd.Col,{span:4,style:{textAlign:"right",paddingRight:10,fontSize:12,lineHeight:'32px'}},React.createElement('i',{style:{cursor:'pointer'},className:showGroup?'icon-coms-up':'icon-coms-down',onClick:function onClick(){return _this4.setState({showGroup:!showGroup});}}))),React.createElement(_antd.Row,{className:'wea-info-group-content',style:showGroup?null:{display:'none'}},colArr));}}]);return InfoGroup4Formal1;}(React.Component);var InfoGroup4Formal2=function(_React$Component3){(0,_inherits3.default)(InfoGroup4Formal2,_React$Component3);function InfoGroup4Formal2(props){(0,_classCallCheck3.default)(this,InfoGroup4Formal2);var _this5=(0,_possibleConstructorReturn3.default)(this,(InfoGroup4Formal2.__proto__||(0,_getPrototypeOf2.default)(InfoGroup4Formal2)).call(this,props));_this5.state={showGroup:true};return _this5;}(0,_createClass3.default)(InfoGroup4Formal2,[{key:'render',value:function render(){var _this6=this;var _props3=this.props,title=_props3.title,items=_props3.items;var showGroup=this.state.showGroup;var colArr=[];items&&items.forEach(function(obj,index){colArr.push(React.createElement(_antd.Row,{className:'wea-info-group-row'},React.createElement(_antd.Col,{className:'wea-info-group-content-cell-label',span:6},obj.label),React.createElement(_antd.Col,{className:'wea-info-group-content-cell-value',span:18},React.createElement(_antd.Col,{span:14},obj.value),React.createElement(_antd.Col,{span:10,dangerouslySetInnerHTML:{__html:obj.link}}))));});return React.createElement('div',{className:'wea-info-group'},React.createElement(_antd.Row,{className:'wea-info-group-title'},React.createElement(_antd.Col,{span:20},React.createElement('div',{className:'wea-info-group-title-info'},title)),React.createElement(_antd.Col,{span:4,style:{textAlign:"right",paddingRight:10,fontSize:12,lineHeight:'32px'}},React.createElement('i',{style:{cursor:'pointer'},className:showGroup?'icon-coms-up':'icon-coms-down',onClick:function onClick(){return _this6.setState({showGroup:!showGroup});}}))),React.createElement(_antd.Row,{className:'wea-info-group-content',style:showGroup?null:{display:'none'}},colArr));}}]);return InfoGroup4Formal2;}(React.Component);var InfoGroup4Formal3=function(_React$Component4){(0,_inherits3.default)(InfoGroup4Formal3,_React$Component4);function InfoGroup4Formal3(props){(0,_classCallCheck3.default)(this,InfoGroup4Formal3);return(0,_possibleConstructorReturn3.default)(this,(InfoGroup4Formal3.__proto__||(0,_getPrototypeOf2.default)(InfoGroup4Formal3)).call(this,props));}(0,_createClass3.default)(InfoGroup4Formal3,[{key:'render',value:function render(){var _props4=this.props,title=_props4.title,items=_props4.items,_props4$colLeft=_props4.colLeft,colLeft=_props4$colLeft===undefined?6:_props4$colLeft,_props4$colRight=_props4.colRight,colRight=_props4$colRight===undefined?18:_props4$colRight;var colArr=[];items&&items.forEach(function(item,index){var children=[];colArr.push(React.createElement(_antd.Col,{span:12},children));item.map(function(obj,index){var showValue=void 0;if(obj.isOpenHrm){showValue=obj.showName!=''?React.createElement('a',{href:'javaScript:openhrm('+obj.value+')',onClick:function onClick(event){return window.pointerXY(event);}},obj.showName):React.createElement('div',null,'\xA0');}else{showValue=obj.value?React.createElement('div',{dangerouslySetInnerHTML:{__html:obj.value}}):React.createElement('div',null,'\xA0');}children.push(React.createElement(_antd.Row,null,React.createElement(_antd.Col,{className:'wea-info-group-new-content-cell-label',span:colLeft},obj.label?obj.label:React.createElement('div',null,'\xA0'),':'),React.createElement(_antd.Col,{className:'wea-info-group-new-content-cell-value',span:colRight},showValue)));});});return React.createElement('div',{className:'wea-info-group-new'},React.createElement(_antd.Row,{className:'wea-info-group-new-title'},React.createElement(_antd.Col,{span:24},React.createElement('div',{className:'wea-info-group-new-title-info'},title))),React.createElement(_antd.Row,{className:'wea-info-group-new-content',gutter:64},colArr));}}]);return InfoGroup4Formal3;}(React.Component);exports.InfoGroup4Formal=InfoGroup4Formal;exports.InfoGroup4Formal1=InfoGroup4Formal1;exports.InfoGroup4Formal2=InfoGroup4Formal2;exports.InfoGroup4Formal3=InfoGroup4Formal3;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(165),
    toKey = __webpack_require__(98);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(29),
    isKey = __webpack_require__(166),
    stringToPath = __webpack_require__(405),
    toString = __webpack_require__(56);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(29),
    isSymbol = __webpack_require__(125);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));}(0,_createClass3.default)(Main,[{key:'onBtnClick',value:function onBtnClick(){this.props.onBtnClick&&this.props.onBtnClick(this.props.value);}},{key:'render',value:function render(){var props=this.props;var viewAttr=props.viewAttr;return React.createElement('div',{className:'hrm-input-btn'},React.createElement(_ecCom.WeaInput,props),viewAttr!='1'&&React.createElement(_antd.Button,{type:'primary',onClick:this.onBtnClick.bind(this)},props.btnText));}}]);return Main;}(React.Component);exports.default=Main;

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(32);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]

  /**
   * A <Router> is a high-level API for automatically setting up
   * a router that renders a <RouterContext> with all the props
   * it needs each time the URL changes.
   */
};var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(33);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(66);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(33);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(101);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(27);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(33);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(42);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(42);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(42);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(183);
var objectAssign = __webpack_require__(83);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(34);

var _PathUtils = __webpack_require__(28);

var _createHistory = __webpack_require__(71);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(32);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(72);

var _BrowserProtocol = __webpack_require__(73);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(189);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(52);

var _createHistory = __webpack_require__(71);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(73);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(34);

var _PathUtils = __webpack_require__(28);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(72);

var _DOMUtils = __webpack_require__(52);

var _HashProtocol = __webpack_require__(192);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(71);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(73);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(34);

var _DOMUtils = __webpack_require__(52);

var _DOMStateStorage = __webpack_require__(109);

var _PathUtils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(194);
var ITERATOR = __webpack_require__(30)('iterator');
var Iterators = __webpack_require__(81);
module.exports = __webpack_require__(20).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(60);
var TAG = __webpack_require__(30)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var downloadCvs2Img=function downloadCvs2Img(params){var cvs=params.cvs,title=params.title;var $a=document.createElement('a');$a.download=title+'.jpg';$a.target='_blank';var url=void 0;if(cvs){url=cvs.toDataURL("image/jpg");}if(url)$a.href=url;if(typeof MouseEvent==='function'){var evt=new MouseEvent('click',{view:window,bubbles:true,cancelable:false});$a.dispatchEvent(evt);}else{if(window.navigator.msSaveOrOpenBlob){var bstr=atob(url.split(',')[1]);var n=bstr.length;var u8arr=new Uint8Array(n);while(n--){u8arr[n]=bstr.charCodeAt(n);}var blob=new Blob([u8arr]);window.navigator.msSaveOrOpenBlob(blob,title+'.jpg');}else{var html=''+'<body style="margin:0;">'+'<img src="'+url+'" style="max-width:100%;" title="" />'+'</body>';var tab=window.open();tab.document.write(html);}}};var format=function format(fmt){var date=new Date();var o={"M+":date.getMonth()+1,//月份   
"d+":date.getDate(),//日   
"h+":date.getHours(),//小时   
"m+":date.getMinutes(),//分   
"s+":date.getSeconds(),//秒   
"q+":Math.floor((date.getMonth()+3)/3),//季度   
"S":date.getMilliseconds()//毫秒   
};if(/(y+)/.test(fmt))fmt=fmt.replace(RegExp.$1,(date.getFullYear()+"").substr(4-RegExp.$1.length));for(var k in o){if(new RegExp("("+k+")").test(fmt))fmt=fmt.replace(RegExp.$1,RegExp.$1.length==1?o[k]:("00"+o[k]).substr((""+o[k]).length));}return fmt;};exports.downloadCvs2Img=downloadCvs2Img;exports.format=format;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sectionToChinese=exports.IEVersion=exports.onNewRequest=exports.jumpToHrmContract=exports.jumpToHrmPost=exports.jumpToHrmSubCompany=exports.jumpToHrmDept=exports.jumpToHrmCard=exports.chkMail=exports.getUserName=exports.jsRewardsRecord2Detial=exports.jsHrmTrainApply=exports.jsTrainRecordShowDetail=exports.openTrainArrange=exports.openFnaExpenseResourceDetail=exports.openFnaBudgetResourceDetail=exports.openHrmResourceView=exports.cptSearch=exports.openCRM=exports.doProjcSearch=exports.docSearch=exports.jsRequestView=exports.openFullWindowForXtable=exports.jsHrmResourceSystemView=exports.doAddWorkPlanByHrm=exports.addCoWork=exports.sendSmsMessage=exports.sendMail=exports.sendEmessage=undefined;var _antd=__webpack_require__(6);var confirm=_antd.Modal.confirm;//发消息、发起群聊
function sendEmessage(emessageId){var isGroup=false;if(!!emessageId){if(emessageId.indexOf(",")>-1){isGroup=true;}}if(!emessageId){_antd.message.warning(SystemEnv.getHtmlNoteName(4780,readCookie("languageidweaver")));return;}if(emessageId.match(/,$/)){emessageId=emessageId.substring(0,emessageId.length-1);}var openType=isGroup?"2":"0";if(isGroup){confirm({content:SystemEnv.getHtmlNoteName(4781,readCookie("languageidweaver")),onOk:function onOk(){sendMsgToPCorWeb(emessageId,openType,'','');},onCancel:function onCancel(){}});}else{sendMsgToPCorWeb(emessageId,openType,'','');}}//发送邮件
function sendMail(id){openFullWindowForXtable("/email/new/MailInBox.jsp?opNewEmail=1&amp;isInternal=1&amp;internalto&id="+id);}//发送短信
function sendSmsMessage(id){openFullWindowForXtable("/sms/SmsMessageEdit.jsp?hrmid="+id);}//新建协作
function addCoWork(id){openFullWindowForXtable("/cowork/AddCoWork.jsp?hrmid="+id);}//新建日程
function doAddWorkPlanByHrm(id){openFullWindowForXtable("/workplan/data/WorkPlan.jsp?resourceid="+id+"&add=1");}//系统信息
function jsHrmResourceSystemView(id){//window.open(`/spa/hrm/index.html#/main/hrm/systeminfo${window.WeaHrm4Formal?'4Formal':''}/${id}`);
window.open("/spa/hrm/index_mobx.html#/main/hrm/systeminfo/"+id);}//我的下属--流程
function jsRequestView(id){openFullWindowForXtable("/workflow/request/RequestView.jsp?resourceid="+id);}//我的下属--文档
function docSearch(id){openFullWindowForXtable('/docs/search/DocSearchTemp.jsp?docstatus=6&hrmresid='+id);}//我的下属--项目
function doProjcSearch(id){openFullWindowForXtable("/proj/search/SearchOperation.jsp?member="+id);}//我的下属--客户
function openCRM(id){openFullWindowForXtable('/CRM/search/SearchOperation.jsp?destination=myAccount&resourceid='+id);}//我的下属--资产
function cptSearch(id){openFullWindowForXtable('/cpt/search/SearchOperation.jsp?resourceid='+id+'&isdata=2');}//我的下属--下属
function openHrmResourceView(id){//openFullWindowForXtable("/hrm/HrmTab.jsp?_fromURL=HrmResourceView&id="+id+"&srcid="+id);
window.open("/spa/hrm/index_mobx.html#/main/hrm/underling/"+id);}//我的下属--预算
function openFnaBudgetResourceDetail(id){openFullWindowForXtable("/fna/report/budget/FnaBudgetResourceDetail.jsp?resourceid="+id);}//我的下属--收支
function openFnaExpenseResourceDetail(id){openFullWindowForXtable("/fna/report/expense/FnaExpenseResourceDetail.jsp?resourceid="+id);}function openTrainArrange(workflowid,trainplanid){// openFullWindowForXtable(`/workflow/request/AddRequest.jsp?workflowid=${workflowid}&TrainPlanId=${trainplanid}`);
openFullWindowForXtable("/spa/workflow/index_form.jsp#/main/workflow/req?iscreate=1&beagenter=0&f_weaver_belongto_usertype=0&f_weaver_belongto_userid=&workflowid="+workflowid+"&TrainPlanId="+trainplanid);}//培训记录--详细信息
function jsTrainRecordShowDetail(id){var dialog=new window.top.Dialog();dialog.currentWindow=window;var url="/hrm/HrmDialogTab.jsp?_fromURL=HrmResourceTrainRecordBasic&isdialog=1&id="+id;dialog.Title="培训记录详细信息";dialog.Width=800;dialog.Height=503;dialog.Drag=true;dialog.URL=url;dialog.show();}//培训记录--培训安排--申请
function jsHrmTrainApply(trainplanid,applyworkflowid){openFullWindowForXtable("/workflow/request/AddRequest.jsp?workflowid="+applyworkflowid+"&TrainPlanId="+trainplanid);}//考核奖惩--奖惩情况--详细信息
function jsRewardsRecord2Detial(id){//openFullWindowForXtable("/hrm/HrmDialogTab.jsp?_fromURL=HrmAwardEdit&id="+id+"&cmd=showdetail");
var dialog=new window.top.Dialog();dialog.currentWindow=window;dialog.Title="奖惩信息";var url="/hrm/HrmDialogTab.jsp?_fromURL=HrmAwardEdit&id="+id+"&cmd=showdetail";dialog.Width=800;dialog.Height=500;dialog.Drag=true;dialog.URL=url;dialog.show();}function openFullWindowForXtable(url){var redirectUrl=url;var width=screen.availWidth-10;var height=screen.availHeight-60;//if (height == 768 ) height -= 75 ;
//if (height == 600 ) height -= 60 ;
var szFeatures="top=0,";szFeatures+="left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";//channelmode
window.open(redirectUrl,"",szFeatures);}var openFullWindowHaveBar=function openFullWindowHaveBar(url){var redirectUrl=url;var width=screen.availWidth-10;var height=screen.availHeight-50;var szFeatures="top=0,";szFeatures+="left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,toolbar=no,location=no,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";//channelmode
window.open(redirectUrl,"",szFeatures);};function getUserName(){try{var _vbsserial="";var _hCard=htactx.OpenDevice(1);//打开设备
if(_hCard==0){_antd.message.warning("请确认您已经正确地安装了驱动程序并插入了usb令牌");return _vbsserial;}try{_vbsserial=htactx.GetUserName(_hCard);//获取用户名
htactx.CloseDevice(_hCard);return _vbsserial;}catch(e){_antd.message.warning("请确认您已经正确地安装了驱动程序并插入了usb令牌2");htactx.CloseDevice(_hCard);return _vbsserial;}}catch(e){_antd.message.warning("请确认您已经正确地安装了驱动程序并插入了usb令牌");htactx.CloseDevice(hCard);return vbsserial;}}function chkMail(email){if(email==''){return true;}var pattern=/^(?:[a-z\d]+[&\_\-\+\.]?)*[a-z\d]+@(?:([a-z\d]+\-?)*[a-z\d]+\.)+([a-z]{2,})+$/i;var chkFlag=pattern.test(email);if(chkFlag){return true;}else{_antd.message.warning("邮箱地址的格式不正确");return false;}}function jumpToHrmCard(id){window.open("/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/"+id,'_blank');}function jumpToHrmDept(id){// window.open('/hrm/HrmTab.jsp?_fromURL=HrmDepartmentDsp&id=' + id);
window.open("/spa/hrm/engine.html#/hrmengine/organization?showTree=false&isView=1&type=department&id="+id,'_blank');}function jumpToHrmSubCompany(id){// window.open('/hrm/HrmTab.jsp?_fromURL=HrmSubCompanyDsp&id=' + id);
window.open("/spa/hrm/engine.html#/hrmengine/organization?showTree=false&isView=1&type=subcompany&id="+id,'_blank');}function jumpToHrmPost(id){// window.open('/hrm/HrmDialogTab.jsp?_fromURL=HrmJobTitlesEdit&id=' + id);
window.open("/spa/hrm/engine.html#/hrmengine/posts?id="+id,'_blank');}function jumpToHrmContract(id){window.open('/hrm/contract/contract/HrmContractView.jsp?id='+id,'_blank');}//新建流程
function onNewRequest(params){var wfid=params.wfid||'';var f_weaver_belongto_userid=params.f_weaver_belongto_userid||'';var beagenter=params.beagenter||'';var isagent=params.isagent||'';//计数
jQuery.post('/workflow/request/AddWorkflowUseCount.jsp',{wfid:wfid});var paramstr="workflowid="+wfid+"&isagent="+isagent+"&beagenter="+beagenter+"&f_weaver_belongto_userid="+f_weaver_belongto_userid+"&f_weaver_belongto_usertype=0";openFullWindowHaveBar('/workflow/request/CreateRequestForward.jsp?'+paramstr);}var openFullWindowHaveBarForWFList=function openFullWindowHaveBarForWFList(url,requestid){try{document.getElementById("wflist_"+requestid+"span").innerHTML="";}catch(e){}var redirectUrl=url;var width=screen.availWidth-10;var height=screen.availHeight-50;var szFeatures="top=0,left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,status=yes,toolbar=no,location=no,";szFeatures+="menubar=no,scrollbars=yes,resizable=yes";window.open(redirectUrl,"",szFeatures);};var viewDepartment=function viewDepartment(departmentid){openFullWindowForXtable("/hrm/HrmTab.jsp?_fromURL=HrmDepartmentDsp&id="+departmentid);};var viewSubCompany=function viewSubCompany(subcompanyid){openFullWindowForXtable("/hrm/HrmTab.jsp?_fromURL=HrmSubCompanyDsp&id="+subcompanyid);};var IEVersion=function IEVersion(){var userAgent=navigator.userAgent;//取得浏览器的userAgent字符串  
var isIE=userAgent.indexOf("compatible")>-1&&userAgent.indexOf("MSIE")>-1;//判断是否IE<11浏览器  
var isEdge=userAgent.indexOf("Edge")>-1&&!isIE;//判断是否IE的Edge浏览器  
var isIE11=userAgent.indexOf('Trident')>-1&&userAgent.indexOf("rv:11.0")>-1;if(isIE){var reIE=new RegExp("MSIE (\\d+\\.\\d+);");reIE.test(userAgent);var fIEVersion=parseFloat(RegExp["$1"]);if(fIEVersion==7){return 7;}else if(fIEVersion==8){return 8;}else if(fIEVersion==9){return 9;}else if(fIEVersion==10){return 10;}else{return 6;//IE版本<=7
}}else if(isEdge){return'edge';//edge
}else if(isIE11){return 11;//IE11  
}else{return-1;//不是ie浏览器
}};var sectionToChinese=function sectionToChinese(section){var chnNumChar=["零","一","二","三","四","五","六","七","八","九"];var chnUnitSection=["","万","亿","万亿","亿亿"];var chnUnitChar=["","十","百","千"];var strIns='',chnStr='';var unitPos=0;var zero=true;while(section>0){var v=section%10;if(v===0){if(!zero){zero=true;chnStr=chnNumChar[v]+chnStr;}}else{zero=false;strIns=chnNumChar[v];strIns+=chnUnitChar[unitPos];chnStr=strIns+chnStr;}unitPos++;section=Math.floor(section/10);}return chnStr;};window.viewDepartment=viewDepartment;window.viewSubCompany=viewSubCompany;window.openFullWindowHaveBarForWFList=openFullWindowHaveBarForWFList;window.openFullWindowForXtable=openFullWindowForXtable;exports.sendEmessage=sendEmessage;exports.sendMail=sendMail;exports.sendSmsMessage=sendSmsMessage;exports.addCoWork=addCoWork;exports.doAddWorkPlanByHrm=doAddWorkPlanByHrm;exports.jsHrmResourceSystemView=jsHrmResourceSystemView;exports.openFullWindowForXtable=openFullWindowForXtable;exports.jsRequestView=jsRequestView;exports.docSearch=docSearch;exports.doProjcSearch=doProjcSearch;exports.openCRM=openCRM;exports.cptSearch=cptSearch;exports.openHrmResourceView=openHrmResourceView;exports.openFnaBudgetResourceDetail=openFnaBudgetResourceDetail;exports.openFnaExpenseResourceDetail=openFnaExpenseResourceDetail;exports.openTrainArrange=openTrainArrange;exports.jsTrainRecordShowDetail=jsTrainRecordShowDetail;exports.jsHrmTrainApply=jsHrmTrainApply;exports.jsRewardsRecord2Detial=jsRewardsRecord2Detial;exports.getUserName=getUserName;exports.chkMail=chkMail;exports.jumpToHrmCard=jumpToHrmCard;exports.jumpToHrmDept=jumpToHrmDept;exports.jumpToHrmSubCompany=jumpToHrmSubCompany;exports.jumpToHrmPost=jumpToHrmPost;exports.jumpToHrmContract=jumpToHrmContract;exports.onNewRequest=onNewRequest;exports.IEVersion=IEVersion;exports.sectionToChinese=sectionToChinese;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(76);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isReactChildren = isReactChildren;
exports.createRouteFromReactElement = createRouteFromReactElement;
exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
exports.createRoutes = createRoutes;

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidChild(object) {
  return object == null || _react2.default.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  _react2.default.Children.forEach(children, function (element) {
    if (_react2.default.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(44);
var toObject = __webpack_require__(62);
var IE_PROTO = __webpack_require__(89)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(61);
var $export = __webpack_require__(31);
var redefine = __webpack_require__(201);
var hide = __webpack_require__(47);
var Iterators = __webpack_require__(81);
var $iterCreate = __webpack_require__(280);
var setToStringTag = __webpack_require__(115);
var getPrototypeOf = __webpack_require__(199);
var ITERATOR = __webpack_require__(30)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(47);


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(25).document;
module.exports = document && document.documentElement;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(114);
var hiddenKeys = __webpack_require__(91).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 204 */
/***/ (function(module, exports) {



/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(117),
    nativeKeys = __webpack_require__(302);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(82),
    isObject = __webpack_require__(54);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(209)))

/***/ }),
/* 209 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(213),
    eq = __webpack_require__(157);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(339);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(341),
    isArguments = __webpack_require__(151),
    isArray = __webpack_require__(29),
    isBuffer = __webpack_require__(119),
    isIndex = __webpack_require__(159),
    isTypedArray = __webpack_require__(153);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(214),
    baseKeysIn = __webpack_require__(343),
    isArrayLike = __webpack_require__(118);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(218),
    getPrototype = __webpack_require__(219),
    getSymbols = __webpack_require__(160),
    stubArray = __webpack_require__(216);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(206);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(221),
    getSymbols = __webpack_require__(160),
    keys = __webpack_require__(97);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(218),
    isArray = __webpack_require__(29);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(40);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(95),
    arrayMap = __webpack_require__(363),
    isArray = __webpack_require__(29),
    isSymbol = __webpack_require__(125);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54),
    isSymbol = __webpack_require__(125);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(365)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderMarkerComponent = exports.getPropValue = exports.MarkerAllProps = exports.MarkerConfigurableProps = undefined;

var _common = __webpack_require__(64);

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(48);

var _isFun = __webpack_require__(126);

var _isFun2 = _interopRequireDefault(_isFun);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MarkerConfigurableProps = exports.MarkerConfigurableProps = ['position', 'offset', 'icon', 'content', 'draggable', 'visible', 'zIndex', 'angle', 'animation', 'shadow', 'title', 'clickable', 'extData', 'label'];

var MarkerAllProps = exports.MarkerAllProps = MarkerConfigurableProps.concat(['topWhenClick', 'bubble', 'raiseOnDrag', 'cursor', 'autoRotation', 'shape']);

var getPropValue = exports.getPropValue = function getPropValue(key, value) {
  if (MarkerAllProps.indexOf(key) === -1) {
    return null;
  }
  if (key === 'position') {
    return (0, _common.toLnglat)(value);
  } else if (key === 'offset') {
    return (0, _common.toPixel)(value);
  }
  return value;
};

var renderMarkerComponent = exports.renderMarkerComponent = function renderMarkerComponent(component, marker) {
  var child = component;
  if ((0, _isFun2.default)(component)) {
    var extData = marker.getExtData();
    child = component(extData);
  }
  if (child) {
    (0, _reactDom.render)(_react2.default.createElement(
      'div',
      null,
      child
    ), marker.getContent());
  }
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(38);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_class2,_temp,_initialiseProps;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(0);var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _AdvanceSearchFormInfo=__webpack_require__(389);var _AdvanceSearchFormInfo2=_interopRequireDefault(_AdvanceSearchFormInfo);var _lodash=__webpack_require__(65);var _lodash2=_interopRequireDefault(_lodash);var _index=__webpack_require__(17);var _i18n=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Tabs=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_Component){(0,_inherits3.default)(Tabs,_Component);function Tabs(props){(0,_classCallCheck3.default)(this,Tabs);var _this=(0,_possibleConstructorReturn3.default)(this,(Tabs.__proto__||(0,_getPrototypeOf2.default)(Tabs)).call(this,props));_initialiseProps.call(_this);_this.state={showSearchAd:false};return _this;}(0,_createClass3.default)(Tabs,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({showSearchAd:false});}},{key:'getTabButtonsAd',value:function getTabButtonsAd(){return[_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.doSearch},_i18n.i18n.button.search()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.doReset},_i18n.i18n.button.reset()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:this.doCancel},_i18n.i18n.button.cancel())];}},{key:'render',value:function render(){var tabConfig=this.props.tabConfig;return _react2.default.createElement('div',{style:{width:'100%',height:'100%'}},tabConfig.tabs.length>0&&this.renderTabNav(),tabConfig.tabs.length>0&&this.renderTabContent());}}]);return Tabs;}(_react.Component),_initialiseProps=function _initialiseProps(){var _this2=this;this.doSearch=function(){var _props=_this2.props,conditionForm=_props.conditionForm,tabConfig=_props.tabConfig,activeTabInfo=_props.activeTabInfo;var tabInfo=tabConfig.tabs[activeTabInfo.activeTabIndex];tabInfo.doSearch(conditionForm.getFormParams());_this2.setState({showSearchAd:false});};this.doReset=function(){var conditionForm=_this2.props.conditionForm;conditionForm.resetConditionValue();};this.doCancel=function(){var conditionForm=_this2.props.conditionForm;_this2.setState({showSearchAd:false});};this.renderForm=function(){var _props2=_this2.props,conditionForm=_props2.conditionForm,conditionFormFields=_props2.conditionFormFields,itemRender=_props2.itemRender;var isFormInit=conditionForm.isFormInit;if(isFormInit)return _react2.default.createElement(_AdvanceSearchFormInfo2.default,{form:conditionForm,formFields:conditionFormFields,itemRender:itemRender});else return'';};this.initTab=function(props){return _react2.default.cloneElement(_react2.default.createElement(_ecCom.WeaTab,null),(0,_extends3.default)({},props));};this.renderTabNav=function(){//data
var _props3=_this2.props,activeTabInfo=_props3.activeTabInfo,tabConfig=_props3.tabConfig,tabChangeHandle=_props3.tabChangeHandle,tabBtnDef=_props3.tabBtnDef,conditionForm=_props3.conditionForm,conditionFormFields=_props3.conditionFormFields,advanceHeight=_props3.advanceHeight,store=_props3.store;var tabInfo=tabConfig.tabs[activeTabInfo.activeTabIndex];var tabProps={type:'editable-inline',datas:tabConfig.tabs||[],keyParam:tabConfig.keyParam,selectedKey:tabConfig.activeTabKey,onChange:tabChangeHandle};tabBtnDef&&(0,_assign2.default)(tabProps,{buttons:tabBtnDef});var searchType=tabInfo.searchType||[];if(searchType.length>0){(0,_assign2.default)(tabProps,{searchType:searchType,onSearch:function onSearch(value){if(searchType.indexOf('advanced')>=0){tabInfo.doSearch(conditionForm.getFormParams());}else{tabInfo.doSearch((0,_defineProperty3.default)({},tabInfo.searchKey,value));}}});if(searchType.indexOf('advanced')>=0&&conditionForm!=null&&conditionForm.isFormInit){var formParams=conditionForm.getFormParams();(0,_assign2.default)(tabProps,{searchsBaseValue:formParams[tabInfo.searchKey]||'',showSearchAd:_this2.state.showSearchAd,setShowSearchAd:function setShowSearchAd(bool){_this2.setState({showSearchAd:bool});},onSearchChange:function onSearchChange(value){return conditionForm.updateFields((0,_defineProperty3.default)({},tabInfo.searchKey,{value:value}),false);},buttonsAd:_this2.getTabButtonsAd(),searchsAd:_this2.renderForm()});(0,_assign2.default)(tabProps,{//advanceHeight: calFormHeight(conditionFormFields.length, _.keys(formParams).length)
advanceHeight:advanceHeight?advanceHeight:(0,_index.calFormHeight)(conditionFormFields.length,conditionForm.fieldArr)});}}tabConfig.onTabEdit&&(0,_assign2.default)(tabProps,{onEdit:tabConfig.onTabEdit});return _this2.initTab(tabProps);};this.renderTabContent=function(){var _props4=_this2.props,children=_props4.children,activeTabInfo=_props4.activeTabInfo,rightMenu=_props4.rightMenu,store=_props4.store;if(Array.isArray(children)){return _react2.default.cloneElement(children[activeTabInfo.activeTabIndex],{rightMenu:rightMenu,activeTabIndex:activeTabInfo.activeTabIndex,store:store});}else{return _react2.default.cloneElement(children,{rightMenu:rightMenu,activeTabIndex:activeTabInfo.activeTabIndex,store:store});}};},_temp))||_class;exports.default=Tabs;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(229),
    baseIteratee = __webpack_require__(230),
    toInteger = __webpack_require__(414);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(390),
    baseMatchesProperty = __webpack_require__(403),
    identity = __webpack_require__(235),
    isArray = __webpack_require__(29),
    property = __webpack_require__(411);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(392),
    isObjectLike = __webpack_require__(55);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(393),
    arraySome = __webpack_require__(396),
    cacheHas = __webpack_require__(397);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));}(0,_createClass3.default)(Main,[{key:'onBtnClick',value:function onBtnClick(){this.props.onBtnClick&&this.props.onBtnClick(this.props.value);}},{key:'render',value:function render(){var props=this.props;return React.createElement('div',{className:'hrm-input-btn'},React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:2},React.createElement(_ecCom.WeaCheckbox,props)),React.createElement(_antd.Col,{span:8},_i18n.i18n.label.enableDate(),'\uFF1A',React.createElement(_ecCom.WeaInput,props),getLabel('386546',"天后")),React.createElement(_antd.Col,{span:4},React.createElement(_ecCom.WeaDatePicker,props)),React.createElement(_antd.Col,{span:8},_i18n.i18n.label.enableMode(),'\uFF1A',React.createElement(_ecCom.WeaSelect,props))));}}]);return Main;}(React.Component);exports.default=Main;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(223),
    castSlice = __webpack_require__(437),
    charsEndIndex = __webpack_require__(438),
    charsStartIndex = __webpack_require__(441),
    stringToArray = __webpack_require__(442),
    toString = __webpack_require__(56);

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(229),
    baseIsNaN = __webpack_require__(439),
    strictIndexOf = __webpack_require__(440);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _FieldSetting=__webpack_require__(446);var _FieldSetting2=_interopRequireDefault(_FieldSetting);var _FormSetting=__webpack_require__(447);var _FormSetting2=_interopRequireDefault(_FormSetting);var _TemplateEdit=__webpack_require__(448);var _TemplateEdit2=_interopRequireDefault(_TemplateEdit);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var AddressBookExportSetting=(0,_mobxReact.observer)(_class=function(_Component){(0,_inherits3.default)(AddressBookExportSetting,_Component);function AddressBookExportSetting(props){(0,_classCallCheck3.default)(this,AddressBookExportSetting);return(0,_possibleConstructorReturn3.default)(this,(AddressBookExportSetting.__proto__||(0,_getPrototypeOf2.default)(AddressBookExportSetting)).call(this,props));}(0,_createClass3.default)(AddressBookExportSetting,[{key:'render',value:function render(){return _react2.default.createElement('div',null,_react2.default.createElement(_FieldSetting2.default,{store:this.props.store}),_react2.default.createElement(_TemplateEdit2.default,{store:this.props.store}),_react2.default.createElement(_FormSetting2.default,{store:this.props.store}));}}]);return AddressBookExportSetting;}(_react.Component))||_class;exports.default=AddressBookExportSetting;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FormInfo=(0,_mobxReact.observer)(_class=function(_Component){(0,_inherits3.default)(FormInfo,_Component);function FormInfo(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,FormInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=FormInfo.__proto__||(0,_getPrototypeOf2.default)(FormInfo)).call.apply(_ref,[this].concat(args))),_this),_this.renderForm=function(){var _this$props=_this.props,formFields=_this$props.formFields,form=_this$props.form,colCount=_this$props.colCount,itemRender=_this$props.itemRender,onSelectedChangeHandle=_this$props.onSelectedChangeHandle,showLabel=_this$props.showLabel;var groupArr=[];var formParams=form.getFormParams();var labelVisible=showLabel==null||showLabel==true;var col=colCount?colCount:1;var itemProps={ratio1to2:labelVisible,style:{marginLeft:0//labelVisible ? -30 : 0
},labelCol:{span:labelVisible?''+window.HrmEngineLabelCol:0},// error: form.getError(field),
tipPosition:'bottom',wrapperCol:{span:labelVisible?''+window.HrmEngineWrapperCol:24}};var textAreaProps={minRows:4,maxRows:4};formFields.map(function(fields){var formItems=[];fields.items.map(function(field){var customerRender=itemRender!=null?itemRender[field.domkey[0]]:null;var showCheckbox=field.checkbox||false;var label=field.label;if(showCheckbox)label=_react2.default.createElement(_ecCom.WeaCheckbox,{id:index,content:label,value:field.checkboxValue,onChange:function onChange(v){field.checkboxValue=v==='1';onSelectedChangeHandle&&onSelectedChangeHandle();}});var coms=void 0;if(customerRender==null){coms=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:(0,_extends3.default)({},field,textAreaProps,{hasBorder:field.viewAttr===1}),form:form,formParams:formParams});}else{coms=customerRender(field,textAreaProps,form,formParams);}(0,_assign2.default)(itemProps,{label:label,error:form.getError(field)});coms!=null&&formItems.push({com:_react2.default.createElement(_ecCom.WeaFormItem,itemProps,coms),col:1});});groupArr.push(_react2.default.createElement(_ecCom.WeaSearchGroup,{center:_this.props.center!=null?_this.props.center:true,needTigger:true,title:formFields.length<2?null:fields.title,showGroup:true,items:formItems,col:col,fontSize:14}));});return groupArr;},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(FormInfo,[{key:'render',value:function render(){var _props=this.props,formFields=_props.formFields,className=_props.className,showError=_props.showError;if(formFields==null)return _react2.default.createElement('div',null);return _react2.default.createElement('div',{className:className},this.renderForm());}}]);return FormInfo;}(_react.Component))||_class;exports.default=FormInfo;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _comsMobx=__webpack_require__(10);var _i18n=__webpack_require__(11);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);__webpack_require__(457);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var confirm=_antd.Modal.confirm;var SystemCard=(_dec=(0,_mobxReact.inject)('hrmSystemCard'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(SystemCard,_React$Component);function SystemCard(props){(0,_classCallCheck3.default)(this,SystemCard);var _this=(0,_possibleConstructorReturn3.default)(this,(SystemCard.__proto__||(0,_getPrototypeOf2.default)(SystemCard)).call(this,props));_this.showConfirm=function(){var hrmSystemCard=_this.props.hrmSystemCard,saveSecondaryPasswordSetting=hrmSystemCard.saveSecondaryPasswordSetting;confirm({title:getLabel(131329,'信息确认'),content:_react2.default.createElement('div',null,_react2.default.createElement('span',null,getLabel('388860',"确定要停用该管理员的二次验证密码吗？")),_react2.default.createElement('br',null),_react2.default.createElement('span',null,getLabel('388861',"为确保账户安全，请及时重设密码！"))),okText:getLabel(33703,'确定'),cancelText:getLabel(32694,'取消'),onOk:function onOk(){saveSecondaryPasswordSetting(false);},onCancel:function onCancel(){return false;}});};return _this;}(0,_createClass3.default)(SystemCard,[{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'init',value:function init(){var hrmSystemCard=this.props.hrmSystemCard;var getHasRight=hrmSystemCard.getHasRight;getHasRight();}},{key:'getViewCards',value:function getViewCards(){var hrmSystemCard=this.props.hrmSystemCard;var headerColumns=hrmSystemCard.headerColumns;var arr=[];for(var i=0;i<headerColumns.length;i++){arr.push(_react2.default.createElement('div',{style:{float:'left',width:'150px',height:'70px',marginLeft:'30px'}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:10},_react2.default.createElement('img',{src:headerColumns[i].icon,alt:''})),_react2.default.createElement(_antd.Col,{span:14},_react2.default.createElement('div',null,headerColumns[i].label),_react2.default.createElement('div',{style:{color:headerColumns[i]['font-color']}},headerColumns[i].num)))));}arr.push(_react2.default.createElement('div',{style:{clear:'both'}}));return _react2.default.createElement('div',{style:{marginTop:'25px'}},arr);}},{key:'getPanelComponent',value:function getPanelComponent(){var hrmSystemCard=this.props.hrmSystemCard;var condition1=hrmSystemCard.condition1,form1=hrmSystemCard.form1;var isFormInit=form1.isFormInit;var condition=condition1;var form=form1;var formParams=form1.getFormParams();var arr=[];isFormInit&&condition.map(function(c){c.items.slice(0,2).map(function(field){arr.push(_react2.default.createElement(_antd.Col,{span:10,offset:1},_react2.default.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:formParams}))));});});return _react2.default.createElement('div',{style:{paddingTop:'30px',paddingBottom:'30px'}},_react2.default.createElement(_antd.Row,null,arr));}},{key:'handleSearch',value:function handleSearch(){var hrmSystemCard=this.props.hrmSystemCard;hrmSystemCard.getTableInfo();hrmSystemCard.hideSearchAd();}},{key:'getSecSettingForm',value:function getSecSettingForm(){var _this2=this;var hrmSystemCard=this.props.hrmSystemCard;var condition2=hrmSystemCard.condition2,form2=hrmSystemCard.form2,isSecSetting=hrmSystemCard.isSecSetting;var isFormInit=form2.isFormInit;var condition=condition2;var form=form2;var formParams=form2.getFormParams();var arr=[];var userUsbType=void 0;var usbstate=void 0;var needauto=void 0;if(formParams.userUsbType)userUsbType=formParams.userUsbType;if(formParams.usbstate)usbstate=formParams.usbstate;if(formParams.needauto)needauto=formParams.needauto;isFormInit&&condition.map(function(c){var items=c.items;for(var i=0;i<items.length;i++){var field=items[i];var domkey=field.domkey[0];if((!userUsbType||userUsbType=='-1')&&domkey!=='userUsbType')continue;if(userUsbType=='4'&&(!usbstate||usbstate=='0'||usbstate=='2')&&(domkey=='tokenKey'||domkey=='serial'||domkey=='needauto'||domkey=='enableDate'||domkey=='enableUsbType'))continue;if(userUsbType=='4'&&usbstate=='1'&&(!needauto||needauto=='0')&&(domkey=='tokenKey'||domkey=='serial'||domkey=='enableDate'||domkey=='enableUsbType'))continue;if(userUsbType=='4'&&usbstate=='1'&&needauto=='1'&&(domkey=='tokenKey'||domkey=='serial'))continue;if(userUsbType=='2'&&(!usbstate||usbstate=='0'||usbstate=='2')&&(domkey=='tokenKey'||domkey=='mobile'||domkey=='needauto'||domkey=='enableDate'||domkey=='enableUsbType'))continue;if(userUsbType=='2'&&usbstate=='1'&&(!needauto||needauto=='0')&&(domkey=='tokenKey'||domkey=='mobile'||domkey=='enableDate'||domkey=='enableUsbType'))continue;if(userUsbType=='2'&&usbstate=='1'&&needauto=='1'&&(domkey=='tokenKey'||domkey=='mobile'))continue;if(userUsbType=='3'&&(!usbstate||usbstate=='0'||usbstate=='2')&&(domkey=='serial'||domkey=='mobile'||domkey=='needauto'||domkey=='enableDate'||domkey=='enableUsbType'))continue;if(userUsbType=='3'&&usbstate=='1'&&(!needauto||needauto=='0')&&(domkey=='serial'||domkey=='mobile'||domkey=='enableDate'||domkey=='enableUsbType'))continue;if(userUsbType=='3'&&usbstate=='1'&&needauto=='1'&&(domkey=='serial'||domkey=='mobile'))continue;if((domkey=='tokenKey'||domkey=='serial'||domkey=='mobile')&&field.viewAttr!==3)field.viewAttr=3;var dom=void 0;if(domkey=='serial'){dom=_this2.getInputAndBtn(field,form,formParams);}else if(domkey=='tokenKey'){dom=_this2.getInputAndBtn(field,form,formParams);}else{dom=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:formParams});}arr.push(_react2.default.createElement('div',{style:{marginTop:'10px'}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:22,offset:1},_react2.default.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:8},wrapperCol:{span:10}},dom,isSecSetting?'':_react2.default.createElement('p',{style:{marginTop:5}},_i18n.i18n.message.noAvailableCheckoutMethod(),'\uFF0C',_react2.default.createElement('a',{href:'/spa/hrm/engine.html#/hrmengine/securitySetting',target:'_blank'},_i18n.i18n.button.clickSetting()),'\u3002'))))));}});//将二次验证密码push到队列中
var isSecondaryVerifyUsed=hrmSystemCard.isSecondaryVerifyUsed,isSecondaryVerifySetted=hrmSystemCard.isSecondaryVerifySetted,saveSecondaryPasswordSetting=hrmSystemCard.saveSecondaryPasswordSetting;arr.push(_react2.default.createElement('div',{style:{marginTop:'10px'}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:22,offset:1},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel('388412',"二次验证密码"),labelCol:{span:8},wrapperCol:{span:16}},_react2.default.createElement('div',{style:{marginTop:!isSecondaryVerifySetted?7:0}},_react2.default.createElement('span',null,isSecondaryVerifySetted?getLabel('15809',"已设置"):getLabel('15808',"未设置")),isSecondaryVerifySetted&&_react2.default.createElement(_antd.Button,{type:'primary',style:{marginLeft:111},onClick:function onClick(){return _this2.showConfirm();}},getLabel('26471',"停用"))))))));return _react2.default.createElement('div',{style:{marginTop:'30px',paddingLeft:'60px'}},arr);}},{key:'getInputAndBtn',value:function getInputAndBtn(field,form,formParams){var _this3=this;return _react2.default.createElement('div',null,_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:formParams}),_react2.default.createElement('div',{style:{position:'absolute',top:0,left:220}},_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this3.updateKey();}},_i18n.i18n.label.binding())));}},{key:'secSettingFormVerify',value:function secSettingFormVerify(){var hrmSystemCard=this.props.hrmSystemCard;var form2=hrmSystemCard.form2,isSecSetting=hrmSystemCard.isSecSetting;var userAgent=navigator.userAgent;//取得浏览器的userAgent字符串
var isOpera=userAgent.indexOf("Opera")>-1;//判断是否Opera浏览器
var isIE=userAgent.indexOf("compatible")>-1&&userAgent.indexOf("MSIE")>-1&&!isOpera;//判断是否IE浏览器
var params=form2.getFormParams();var userUsbType=params.userUsbType;var usbstate=params.usbstate;var mobile=params.mobile;var tokenKey=params.tokenKey;var serial=params.serial;if(!isSecSetting){_antd.message.warning(_i18n.i18n.message.noAvailableCheckMode());return false;}if(!userUsbType||userUsbType=='-1'){// message.warning('请选择辅助校验方式！');
// return false;
hrmSystemCard.save();}if(userUsbType=='4'&&!mobile){_antd.message.warning(_i18n.i18n.message.fillTelphoneNum());return false;}if(userUsbType=='4'&&mobile&&mobile.length!==11){_antd.message.warning(_i18n.i18n.message.fillAvailableTelphoneNum());return false;}if(userUsbType=='2'&&!isIE){_antd.message.warning(_i18n.i18n.message.htKey());return false;}if(userUsbType=='2'&&isIE&&!serial){_antd.message.warning(_i18n.i18n.message.fillUserKey());return false;}if(userUsbType=='3'&&!tokenKey){_antd.message.warning(_i18n.i18n.message.bindToken());return false;}if(userUsbType=='3'&&tokenKey&&(!this.isdigit(tokenKey)||tokenKey.length!==10)){_antd.message.warning(_i18n.i18n.message.tokenNumLen());return false;}this.isTokenKeyUsed({tokenKey:tokenKey});}},{key:'isdigit',value:function isdigit(s){var r,re;re=/\d*/i;//\d表示数字,*表示匹配多个数字
r=s.match(re);return r==s?true:false;}//序列号是否被占用
},{key:'isTokenKeyUsed',value:function isTokenKeyUsed(params){var hrmSystemCard=this.props.hrmSystemCard;_ecCom.WeaTools.callApi('/api/hrm/sysadmin/checkIsUsed','POST',params).then(function(data){if(data.isUsed){var msg=_i18n.i18n.message.tokenBinded().replace('{params}',data.lastname);_antd.message.warning(msg);// message.warning('令牌序列号已经绑定给' + data.lastname + '，不能重复绑定！');
}else{hrmSystemCard.save();}});}//"用户密钥"和"令牌序列号"绑定
},{key:'updateKey',value:function updateKey(){var hrmSystemCard=this.props.hrmSystemCard;var form2=hrmSystemCard.form2;var needusb=form2.getFormParams().userUsbType;if(needusb=="2"){var returnstr=PublicFunc.getUserName()||'';if(returnstr!==""){hrmSystemCard.setLoginId(returnstr);}}else if(needusb=="3"){this.bindTokenKey();}}},{key:'bindTokenKey',value:function bindTokenKey(){var title="";var url="/spa/hrm/index_mobx.html#/main/hrm/BindTokenKey?requestFrom=system&userid="+this.props.params.hrmId;var dialog=ecCom.WeaTools.createDialog({title:title,url:url,style:{width:600,height:365},zIndex:9999});dialog.show();}},{key:'setSecurity',value:function setSecurity(){var hrmSystemCard=this.props.hrmSystemCard;var hrmId=this.props.params.hrmId||'';hrmSystemCard.hrmId=hrmId;var params={id:hrmId};hrmSystemCard.setDialogShow();hrmSystemCard.getSecSettingCondition(params);}},{key:'render',value:function render(){var _this4=this;var hrmSystemCard=this.props.hrmSystemCard;var tabKey=hrmSystemCard.tabKey,headerColumns=hrmSystemCard.headerColumns,tableStore=hrmSystemCard.tableStore,isPanelShow=hrmSystemCard.isPanelShow,isSecSettingShow=hrmSystemCard.isSecSettingShow,hrmId=hrmSystemCard.hrmId,hasRight=hrmSystemCard.hasRight,loading=hrmSystemCard.loading;var form1=hrmSystemCard.form1;var btn1=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this4.setSecurity();}},_i18n.i18n.label.securitySetting())];var btn2=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this4.handleSearch();}},_i18n.i18n.button.search()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){form1.reset();hrmSystemCard.tabKey='0';}},_i18n.i18n.button.reset()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmSystemCard.hideSearchAd();}},_i18n.i18n.button.cancel())];var btn3=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this4.secSettingFormVerify();}},_i18n.i18n.button.save())];var dropMenuDatas=[{key:'0',content:_i18n.i18n.label.securitySetting(),icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'})},{key:'1',content:_i18n.i18n.button.save(),icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'})}];var dropMenuDatas1=dropMenuDatas.slice(0,1);var dropMenuDatas2=dropMenuDatas.slice(1,2);dropMenuDatas1.push({icon:_react2.default.createElement('i',{className:'icon-coms-Print-log'}),content:_i18n.i18n.button.log(),key:'showLog',onClick:function onClick(key){window.setLogViewProps({logSmallType:_i18n.i18n.smallType.HRM_RSOURCEMANAGER_SECURITYSETTING,targetId:hrmId});}});var tabName1=[{key:'0',title:_i18n.i18n.label.all()},{key:'1',title:_i18n.i18n.label.today()},{key:'2',title:_i18n.i18n.label.tswk()},{key:'3',title:_i18n.i18n.label.tsmth()},{key:'4',title:_i18n.i18n.label.tssn()},{key:'5',title:_i18n.i18n.label.tsyr()}];var items=[{com:_react2.default.createElement(_antd.Spin,{spinning:tableStore.loading},_react2.default.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true}))}];if(loading){return _react2.default.createElement('div',null);}if(!hasRight){return _react2.default.createElement('div',{style:{height:'100%'}},_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},getLabel(2012,'对不起，您暂时没有权限！'))));}return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas1,onClick:function onClick(){return _this4.setSecurity();},collectParams:{favname:_i18n.i18n.label.sysManager(),favouritetype:5}},_react2.default.createElement(_ecCom.WeaTop,{title:_i18n.i18n.label.sysManager(),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',loading:true,buttons:btn1,showDropIcon:true,dropMenuDatas:dropMenuDatas1,onDropMenuClick:function onDropMenuClick(){return _this4.setSecurity();}}),_react2.default.createElement(_ecCom.WeaTab,{selectedKey:tabKey,datas:tabName1,keyParam:'key',searchType:['base','advanced'],showSearchAd:isPanelShow,searchsBaseValue:form1.getFormParams().relatedname,setShowSearchAd:function setShowSearchAd(bool){return hrmSystemCard.setShowSearchAd(bool);},hideSearchAd:function hideSearchAd(){return hrmSystemCard.hideSearchAd();},searchsAd:this.getPanelComponent(),advanceHeight:94,hasMask:false,buttonsAd:btn2,onSearch:function onSearch(){return hrmSystemCard.getTableInfo();},onChange:function onChange(key){return hrmSystemCard.tabClick(key);},onSearchChange:function onSearchChange(v){return hrmSystemCard.updateFormFields(v,'1');}}),this.getViewCards(),_react2.default.createElement('div',{className:'system-card-info-group'},_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:_i18n.i18n.label.sysOpLog(),showGroup:true,items:items,col:1}))),_react2.default.createElement(_ecCom.WeaDialog,{title:_i18n.i18n.label.securitySetting(),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isSecSettingShow,closable:true,onCancel:function onCancel(){hrmSystemCard.hideDialog();hrmSystemCard.reset();},buttons:btn3,style:{width:'600px',height:'300px'}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas2,onClick:function onClick(){return _this4.secSettingFormVerify();}},this.getSecSettingForm())));}}]);return SystemCard;}(_react2.default.Component))||_class)||_class);exports.default=SystemCard;

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DateFormat=exports.createQRCode=exports.getIconColor=exports.getIcon=exports.dateFormat=exports.convertCalendarDate=exports.calColumnIndex=exports.getColumIndex=exports.validNumber=exports.validDBKeys=exports.calFormHeight=exports.findTabCount=exports.transParams=exports.getFormParamValue=exports.validate=undefined;var _from=__webpack_require__(247);var _from2=_interopRequireDefault(_from);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _antd=__webpack_require__(6);var _lodash=__webpack_require__(65);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var dbKeys=["PERCENT","PLAN","PRECISION","PRIMARY","PRINT","PROC","PROCEDURE","PUBLIC","RAISERROR","READ","READTEXT","RECONFIGURE","REFERENCES","REPLICATION","RESTORE","RESTRICT","RETURN","REVOKE","RIGHT","ROLLBACK","ROWCOUNT","ROWGUIDCOL","RULE","SAVE","SCHEMA","SELECT","SESSION_USER","SET","SETUSER","SHUTDOWN","SOME","STATISTICS","SYSTEM_USER","TABLE","TEXTSIZE","THEN","TO","TOP","TRAN","TRANSACTION","TRIGGER","TRUNCATE","TSEQUAL","UNION","UNIQUE","UPDATE","UPDATETEXT","USE","USER","VALUES","VARYING","VIEW","WAITFOR","WHEN","WHERE","WHILE","WITH","WRITETEXT","EXCEPT","EXEC","EXECUTE","EXISTS","EXIT","FETCH","FILE","FILLFACTOR","FOR","FOREIGN","FREETEXT","FREETEXTTABLE","FROM","FULL","FUNCTION","GOTO","GRANT","GROUP","HAVING","HOLDLOCK","IDENTITY","IDENTITY_INSERT","IDENTITYCOL","IF","IN","INDEX","INNER","INSERT","INTERSECT","INTO","IS","JOIN","KEY","KILL","LEFT","LIKE","LINENO","LOAD","NATIONAL","NOCHECK","NONCLUSTERED","NOT","NULL","NULLIF","OF","OFF","OFFSETS","ON","OPEN","OPENDATASOURCE","OPENQUERY","OPENROWSET","OPENXML","OPTION","OR","ORDER","OUTER","OVER","ADD","ALL","ALTER","AND","ANY","AS","ASC","AUTHORIZATION","BACKUP","BEGIN","BETWEEN","BREAK","BROWSE","BULK","BY","CASCADE","CASE","CHECK","CHECKPOINT","CLOSE","CLUSTERED","COALESCE","COLLATE","COLUMN","COMMIT","COMPUTE","CONSTRAINT","CONTAINS","CONTAINSTABLE","CONTINUE","CONVERT","CREATE","CROSS","CURRENT","CURRENT_DATE","CURRENT_TIME","CURRENT_TIMESTAMP","CURRENT_USER","CURSOR","DATABASE","DBCC","DEALLOCATE","DECLARE","DEFAULT","DELETE","DENY","DESC","DISK","DISTINCT","DISTRIBUTED","DOUBLE","DROP","DUMMY","DUMP","ELSE","END","ERRLVL","ESCAPE","ACCESS","ADD","ALL","ALTER","AND","ANY","AS","ASC","AUDIT","BETWEEN","BY","CHAR","CHECK","CLUSTER","COLUMN","COMMENT","COMPRESS","CONNECT","CREATE","CURRENT","DATE","DECIMAL","DEFAULT","DELETE","DESC","DISTINCT","DROP","ELSE","EXCLUSIVE","EXISTS","FILE","FLOAT","FOR","FROM","GRANT","GROUP","HAVING","IDENTIFIED","IMMEDIATE","IN","INCREMENT","INDEX","INITIAL","INSERT","INTEGER","INTERSECT","INTO","IS","LEVEL","LIKE","LOCK","LONG","MAXEXTENTS","MINUS","MLSLABEL","MODE","MODIFY","NOAUDIT","NOCOMPRESS","NOT","NOWAIT","NULL","NUMBER","OF","OFFLINE","ON","ONLINE","OPTION","OR","ORDER","PCTFREE","PRIOR","PRIVILEGES","PUBLIC","RAW","RENAME","RESOURCE","REVOKE","ROW","ROWID","ROWNUM","ROWS","SELECT","SESSION","SET","SHARE","SIZE","SMALLINT","START","SUCCESSFUL","SYNONYM","SYSDATE","TABLE","THEN","TO","TRIGGER","UID","UNION","UNIQUE","UPDATE","USER","VALIDATE","VALUES","VARCHAR","VARCHAR2","VIEW","WHENEVER","WHERE","WITH"];var validate=exports.validate=function validate(conditions){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!(0,_isEmpty2.default)(conditions)){for(var i=0,leg=conditions.length;i<leg;i++){var cd=conditions[i];for(var j=0,length=cd.items.length;j<length;j++){var c=cd.items[j];if(c){var domkey=c.domkey[0];var viewAttr=c.viewAttr;if(c.conditionType=="BROWSER")viewAttr=c.browserConditionParam.viewAttr;if(viewAttr=="3"&&!params[domkey]){if(domkey=="managerid"||domkey=="belongto"){//直接上级 主账号不用校验
}else{//message.warning(domkey+'必要信息不完整！');
_antd.message.warning("必要信息不完整！");return false;}}}}}}return true;};var getFormParamValue=exports.getFormParamValue=function getFormParamValue(){var conditions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fieldname=arguments[1];var fieldvalue="";if(!(0,_isEmpty2.default)(conditions)){for(var i=0,leg=conditions.length;i<leg;i++){var cd=conditions[i];for(var j=0,length=cd.items.length;j<length;j++){var c=cd.items[j];if(c){var domkey=c.domkey[0];if(domkey==fieldname){fieldvalue=c.value;}}}}}return fieldvalue;};var transParams=exports.transParams=function transParams(formParams){var params={};for(var key in formParams){if(formParams[key]===!!formParams[key])params[key]=!!formParams[key]?"1":"0";else params[key]=formParams[key];}return params;};var findTabCount=exports.findTabCount=function findTabCount(str){var bIndex=str.lastIndexOf("(");var eIndex=str.lastIndexOf(")");var title="",count="";try{title=str.substring(0,bIndex);count=str.substring(bIndex+1,eIndex);}catch(err){}return{title:title,count:count};};var calFormHeight=exports.calFormHeight=function calFormHeight(groupLength,children){var childrenLength=0;children.map(function(c){if(c.colSpan!=null){childrenLength+=c.colSpan==2?1:2;}else childrenLength+=1;});var height=(childrenLength/2+childrenLength%2)*52+10;if(groupLength>1)height+=groupLength*45;if(height>300)return 300;return height;};var validDBKeys=exports.validDBKeys=function validDBKeys(value){if((0,_lodash.indexOf)(dbKeys,value.toUpperCase())>=0){_antd.message.error("不能使用数据库保留字作为字段名!");return{isValid:false,value:""};}return{isValid:true,value:value};};var validNumber=exports.validNumber=function validNumber(value){if(isNaN(parseInt(value)))return 0;return parseInt(value);};var getColumIndex=exports.getColumIndex=function getColumIndex(num){var n=64;var loopIndex=num/26;if(loopIndex<=1)return String.fromCharCode(n+(num%26===0?26:num));else return""+String.fromCharCode(n+parseInt(loopIndex))+String.fromCharCode(n+num%26);};var calColumnIndex=exports.calColumnIndex=function calColumnIndex(val){var arr=(0,_from2.default)(val);var num=0;if(arr.length===1)num=arr[0].charCodeAt()-64;else{arr.map(function(c,i){if(i===0)num+=(c.charCodeAt()-64)*26;else num+=c.charCodeAt()-64;});}return num;};var convertCalendarDate=exports.convertCalendarDate=function convertCalendarDate(date){var y=date.getYear();var d=date.getDayOfMonth();if(d<10)d="0"+d;var m=date.getMonth()+1;if(m<10)m="0"+m;return y+"-"+m+"-"+d;};var dateFormat=exports.dateFormat=function dateFormat(date,format){var o={"M+":date.getMonth()+1,//month
"d+":date.getDate(),//day
"h+":date.getHours(),//hour
"m+":date.getMinutes(),//minute
"s+":date.getSeconds(),//second
"q+":Math.floor((date.getMonth()+3)/3),//quarter
S:date.getMilliseconds()//millisecond
};if(/((y|Y)+)/.test(format))format=format.replace(RegExp.$1,(date.getFullYear()+"").substr(4-RegExp.$1.length));for(var k in o){if(new RegExp("("+k+")").test(format))format=format.replace(RegExp.$1,RegExp.$1.length==1?o[k]:("00"+o[k]).substr((""+o[k]).length));}return format;};var getLabel=_ecCom.WeaLocaleProvider.getLabel;/**
  正常
  迟到
  早退
  旷工
  漏签
  请假
  出差
  公出
  加班
  异常数据抵扣
 */// NORMAL,BELATE,LEAVEEARLY,ABSENT,NOSIGN,LEAVE,EVECTION,OUTDAYS,OVERTIME,OTHER;
var getIcon=exports.getIcon=function getIcon(type){var res={};if(type=='LEAVE'){res.color='#2DB7F5';res.icon='icon-Human-resources-leave';}if(type=='EVECTION'){res.color='#48C651';res.icon='icon-Human-resources-business-travel';}if(type=='OUTDAYS'){res.color='#4F8CFF';res.icon='icon-Human-resources-work';}if(type=='OVERTIME'){res.color='#8D6BF3';res.icon='icon-Human-resources-overtime';}if(type=='OTHER'){res.color='#ABB4C1';res.icon='icon-Human-resources-abnormal-small2';}return res;};var getIconColor=exports.getIconColor=function getIconColor(type){var res={};if(type=='ALL'){res.color='#2DB7F5';res.name=getLabel(82857,'全部');res.icon='icon-Human-resources-all';}if(type=='NORMAL'){res.color='#2DB7F5';res.name=getLabel('225',"正常");res.icon='icon-Human-resources-normal';}if(type=='BELATE'){res.color='#FF8F00';res.name=getLabel('20081',"迟到");res.bcolor='#FFF6EB';res.icon='icon-Human-resources-late';}if(type=='LEAVEEARLY'){res.color='#7326FF';res.name=getLabel('20082',"早退");res.bcolor='#F1E9FF';res.icon='icon-Human-resources-Leave-early';}if(type=='ABSENT'){res.color='#FC4B6C';res.name=getLabel('20085',"旷工");res.bcolor='#FFE6EB';res.icon='icon-Human-resources-Absenteeism';}if(type=='NOSIGN'){res.color='#BD10E0';res.name=getLabel('20086',"漏签");res.bcolor='#FAECFD';res.icon='icon-Human-resources-check';}if(type=='LEAVE'){res.color='#2DB7F5';res.name=getLabel('670',"请假");res.bcolor='#EFFAFF';res.icon='icon-Human-resources-leave';}if(type=='EVECTION'){res.color='#30BE3A';res.name=getLabel('20084',"出差");res.bcolor='#EFFAF0';res.icon='icon-Human-resources-business-travel';}if(type=='OUTDAYS'){res.color='#4F8CFF';res.name=getLabel('24058',"公出");res.bcolor='#DFEBFF';res.icon='icon-Human-resources-work';}if(type=='OVERTIME'){res.color='#8D6BF3';res.name=getLabel('6151',"加班");res.bcolor='#FAECFD';res.icon='icon-Human-resources-overtime-small';}if(type=='OTHER'){res.color='#ABB4C1';res.name=getLabel('32104',"异常");res.title=getLabel('132031',"异常数据抵扣");res.bcolor='#F0F6FF';res.icon='icon-Human-resources-abnormal-small2';}return res;};var createQRCode=exports.createQRCode=function createQRCode(data){//生成二维码
var txt="BEGIN:VCARD \n"+"VERSION:3.0 \n"+"N:"+data.lastname+" \n"+"TEL;CELL;VOICE:"+data.mobile+"\n"+"TEL;WORK;VOICE:"+data.telephone+"\n"+"EMAIL:"+data.email+" \n"+"TITLE:"+data.jobtitle+" \n"+"ROLE:"+data.department+"\n"+"ADR;WORK:"+data.locationname+" \n"+"END:VCARD";return utf16to8(txt);function utf16to8(str){var out,i,len,c;out="";len=str.length;for(i=0;i<len;i++){c=str.charCodeAt(i);if(c>=0x0001&&c<=0x007F){out+=str.charAt(i);}else if(c>0x07FF){out+=String.fromCharCode(0xE0|c>>12&0x0F);out+=String.fromCharCode(0x80|c>>6&0x3F);out+=String.fromCharCode(0x80|c>>0&0x3F);}else{out+=String.fromCharCode(0xC0|c>>6&0x1F);out+=String.fromCharCode(0x80|c>>0&0x3F);}}return out;}};// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
var DateFormat=exports.DateFormat=function DateFormat(date,fmt){if(date&&fmt){var _this=date;var type=Object.prototype.toString.call(date);if(type=="[object String]"){var dateArray=date.split(" "),d1=dateArray[0].split("-"),d2=dateArray[1]?dateArray[1].split(":"):[];_this=new Date((d1[0]||0)*1,(d1[1]||0)*1-1,(d1[2]||0)*1,(d2[0]||0)*1,(d2[1]||0)*1,(d2[2]||0)*1);}else if(type=="[object Date]"){}else{return"";}var o={"M+":_this.getMonth()+1,//月份
"d+":_this.getDate(),//日
"h+":_this.getHours()%12==0?12:_this.getHours()%12,//小时
"H+":_this.getHours(),//小时
"m+":_this.getMinutes(),//分
"s+":_this.getSeconds(),//秒
"q+":Math.floor((_this.getMonth()+3)/3),//季度
"S":_this.getMilliseconds()//毫秒
};var week={"0":"\\u65e5","1":"\\u4e00","2":"\\u4e8c","3":"\\u4e09","4":"\\u56db","5":"\\u4e94","6":"\\u516d"};if(/(y+)/.test(fmt)){fmt=fmt.replace(RegExp.$1,(_this.getFullYear()+"").substr(4-RegExp.$1.length));}if(/(E+)/.test(fmt)){var weekStr=(RegExp.$1.length>1?RegExp.$1.length>2?"\\u661f\\u671f":"\\u5468":"")+week[_this.getDay()+""];fmt=fmt.replace(RegExp.$1,Utils.GB2312UnicodeConverter.ToGB2312(weekStr));}for(var k in o){if(new RegExp("("+k+")").test(fmt)){fmt=fmt.replace(RegExp.$1,RegExp.$1.length==1?o[k]:("00"+o[k]).substr((""+o[k]).length));}}return fmt;}else{return"";}};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(466), __esModule: true };

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(35);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(81);
var ITERATOR = __webpack_require__(30)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(30)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.i18n=undefined;var _ecCom=__webpack_require__(0);var getLabel=_ecCom.WeaLocaleProvider.getLabel;var i18n=exports.i18n={label:{organization:function organization(){return getLabel(25332,'组织结构');},collect:function collect(){return getLabel(28111,'收藏');},helper:function helper(){return getLabel(275,'帮助');},search:function search(){return getLabel(82529,'搜索');},reset:function reset(){return getLabel(27088,'重置');},ok:function ok(){return getLabel(33703,'确定');},cancel:function cancel(){return getLabel(32694,'取消');},create:function create(){return getLabel(365,'新建');},remove:function remove(){return getLabel(20230,'移除');},delete:function _delete(){return getLabel(131966,'删除');},modify:function modify(){return getLabel(93,'编辑');},transfer:function transfer(){return getLabel(80,'转移');},multiRemove:function multiRemove(){return getLabel(383696,'批量移除');},multiDelete:function multiDelete(){return getLabel(32136,'批量删除');},save:function save(){return getLabel(30986,'保存');},saveAndSetting:function saveAndSetting(){return getLabel(32159,'保存并进入详细设置');},add:function add(){return getLabel(131201,'添加');},copy:function copy(){return getLabel(77,'复制');},log:function log(){return getLabel(83,'日志');},replace:function replace(){return getLabel(84563,'替换');},columnVisibleSetting:function columnVisibleSetting(){return getLabel(32535,'显示列定制');},multiModify:function multiModify(){return getLabel(383518,'批量编辑');},import:function _import(){return getLabel(18596,'导入');},export:function _export(){return getLabel(28343,'导出Excel');},'389091':function _(){return getLabel('389091',"选择班次");},'18609':function _(){return getLabel(18609,'共');},'30690':function _(){return getLabel(30690,'条数据');},year:function year(){return getLabel('26577',"年");},month:function month(){return getLabel(6076,'月');},day:function day(){return getLabel(1925,'天');},hour:function hour(){return getLabel('391',"小时");}},confirm:{defaultTitle:function defaultTitle(){return getLabel(131329,'信息确认');},removeSelected:function removeSelected(){return getLabel(385639,'确定要移除选择的记录吗？');},deleteSelected:function deleteSelected(){return getLabel(385625,'确定要删除选择的记录吗？');},selectedEmpty:function selectedEmpty(){return getLabel(84093,'请至少选择一条记录!');},cancelSelected:function cancelSelected(){return getLabel(384051,'确定要封存选中的记录吗？');},doISCancelSelected:function doISCancelSelected(){return getLabel(384050,'确定要解封选中的记录吗？');},remove:function remove(){return getLabel(83449,'确定要移除吗？');},delete:function _delete(){return getLabel(83877,'确定要删除吗？');},cancel:function cancel(){return getLabel(384052,'确定要封存吗？');},doISCancel:function doISCancel(){return getLabel(384053,'确定要解封吗？');},forbidden:function forbidden(){return getLabel(385359,'确定要禁用吗?');},active:function active(){return getLabel(385033,'确认要启用吗?');}},message:{authFailed:function authFailed(){return getLabel(2012,'对不起，您暂时没有权限！');},actionError:function actionError(){return getLabel(132200,'操作失败！');},opSuccess:function opSuccess(){return getLabel(30700,'操作成功');},saveSuccess:function saveSuccess(){return getLabel(83551,'保存成功！');},saveFailed:function saveFailed(){return getLabel(84544,'保存失败！');},removeSuccess:function removeSuccess(){return getLabel(385950,'移除成功！');},deleteSuccess:function deleteSuccess(){return getLabel(83472,'删除成功！');},uploadSuccess:function uploadSuccess(){return getLabel('25388',"上传成功");}}};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _pulicFunc=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var More=function(_React$Component){(0,_inherits3.default)(More,_React$Component);function More(props){(0,_classCallCheck3.default)(this,More);var _this=(0,_possibleConstructorReturn3.default)(this,(More.__proto__||(0,_getPrototypeOf2.default)(More)).call(this,props));_this.state={value:'',height:510};return _this;}(0,_createClass3.default)(More,[{key:'reRenderColumns',value:function reRenderColumns(columns,strokeColor){columns.forEach(function(c,index){if(c.dataIndex=='percent'){c.render=function(text,record){var result=parseInt(record.result),max=parseInt(record.total);return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaProgress,{percent:result/max*100,format:function format(){return result;},strokeColor:strokeColor}));};}if(c.dataIndex=='departmentid'){c.render=function(text,record){return _react2.default.createElement('a',{onClick:function onClick(){return(0,_pulicFunc.jumpToHrmDept)(record.departmentid);}},record.departmentname);};}if(c.dataIndex=='title'){c.render=function(text,record){// return <a onClick={() => jumpToHrmPost()}>{record.name}</a>
return _react2.default.createElement('span',null,record.name);};}if(c.dataIndex=='mark'){c.render=function(text,record){// return <a onClick={() => jumpToHrmJob()}>{record.mark}</a>
return _react2.default.createElement('span',null,record.mark);};}});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,visible=_props.visible,_onCancel=_props.onCancel,buttons=_props.buttons,search=_props.search,tableStore=_props.tableStore,strokeColor=_props.strokeColor;var _state=this.state,value=_state.value,height=_state.height;return _react2.default.createElement(_ecCom.WeaDialog,{title:title,icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:visible,closable:true,onCancel:function onCancel(){_onCancel();_this2.setState({value:''});},buttons:buttons,style:{width:870,height:510},onChangeHeight:function onChangeHeight(h){return _this2.setState({height:h});}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:10,offset:14},_react2.default.createElement('div',{style:{textAlign:'right',paddingTop:10,paddingRight:20}},_react2.default.createElement(_ecCom.WeaInputSearch,{value:value,onSearch:function onSearch(v){return search(v);},onSearchChange:function onSearchChange(v){return _this2.setState({value:v});}})))),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:24},_react2.default.createElement('div',{style:{padding:'10px 0'}},_react2.default.createElement('div',{style:{borderTop:'1px solid #E9E9E9'}},_react2.default.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,scroll:{y:height-135},getColumns:function getColumns(c){_this2.reRenderColumns(c,strokeColor);return c;}}))))));}}]);return More;}(_react2.default.Component);exports.default=More;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Form=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Form,_React$Component);function Form(props){(0,_classCallCheck3.default)(this,Form);var _this=(0,_possibleConstructorReturn3.default)(this,(Form.__proto__||(0,_getPrototypeOf2.default)(Form)).call(this,props));_this.customRender=function(c,form){return c.items.map(function(item){var label=item.label;return React.createElement(_ecCom.WeaFormItem,{label:label,labelCol:{span:6},wrapperCol:{span:18},tipPosition:'bottom',error:form.getError(item),style:{padding:'5px 0'}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:item,form:form,formParams:form.getFormParams()}));});};return _this;}(0,_createClass3.default)(Form,[{key:'render',value:function render(){var _this2=this;var datas=this.props.datas,form=datas.form;return React.createElement('div',{className:'content'},form.render({},{},true,function(c){return _this2.customRender(c,form);}));}}]);return Form;}(React.Component))||_class;exports.default=Form;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DistanceToPeak=exports.Tip=exports.LeftTree=exports.Icon=exports.Loading=exports.NoData=exports.AlertPage=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _jquery=__webpack_require__(545);var _jquery2=_interopRequireDefault(_jquery);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var AlertPage=function(_React$Component){(0,_inherits3.default)(AlertPage,_React$Component);function AlertPage(){(0,_classCallCheck3.default)(this,AlertPage);return(0,_possibleConstructorReturn3.default)(this,(AlertPage.__proto__||(0,_getPrototypeOf2.default)(AlertPage)).apply(this,arguments));}(0,_createClass3.default)(AlertPage,[{key:'render',value:function render(){return _react2.default.createElement('div',{style:{height:'100%'}},_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},getLabel(2012,'对不起，您暂时没有权限！'))));}}]);return AlertPage;}(_react2.default.Component);var NoData=function(_React$Component2){(0,_inherits3.default)(NoData,_React$Component2);function NoData(){(0,_classCallCheck3.default)(this,NoData);return(0,_possibleConstructorReturn3.default)(this,(NoData.__proto__||(0,_getPrototypeOf2.default)(NoData)).apply(this,arguments));}(0,_createClass3.default)(NoData,[{key:'render',value:function render(){var _props=this.props,_props$className=_props.className,className=_props$className===undefined?'icon-coms-NoData':_props$className,_props$tip=_props.tip,tip=_props$tip===undefined?getLabel('390474',"暂无数据！"):_props$tip;return _react2.default.createElement('div',{style:{position:'absolute',top:'50%',left:'50%',marginTop:-45,marginLeft:-45,width:90}},_react2.default.createElement('i',{className:className,style:{fontSize:90}}),_react2.default.createElement('p',{style:{textAlign:'center',fontSize:14,padding:5}},tip));}}]);return NoData;}(_react2.default.Component);var Loading=function(_React$Component3){(0,_inherits3.default)(Loading,_React$Component3);function Loading(props){(0,_classCallCheck3.default)(this,Loading);return(0,_possibleConstructorReturn3.default)(this,(Loading.__proto__||(0,_getPrototypeOf2.default)(Loading)).call(this,props));}(0,_createClass3.default)(Loading,[{key:'render',value:function render(){var size=this.props.size;var style={position:'absolute',top:'50%',left:'50%',marginLeft:size==='lg'?-16:-8,marginTop:size==='lg'?-16:-8};return _react2.default.createElement('div',{style:style},_react2.default.createElement(_antd.Spin,{spinning:true,size:size==='lg'?'large':''}));}}]);return Loading;}(_react2.default.Component);//Icon组件参数：bgColor(背景色)必填，shape(形状)、pixel(像素)选填，默认为正方形和10px,
//onIconClick为图标点击的回调函数，回调的值为图标的状态值：0和1。0 -> 关闭，1 -> 开启。
//当不传onIconClick参数时，点击图标没有变化。
var Icon=function(_React$Component4){(0,_inherits3.default)(Icon,_React$Component4);function Icon(props){(0,_classCallCheck3.default)(this,Icon);var _this4=(0,_possibleConstructorReturn3.default)(this,(Icon.__proto__||(0,_getPrototypeOf2.default)(Icon)).call(this,props));_this4.handleClick=function(){var iconState=_this4.props.iconState;//当父组件没有传onIconClick参数时，不处理这个点击事件。
if(!_this4.props.onIconClick){return;}//将图标的状态通过回调函数传回到父组件
_this4.props.onIconClick(iconState===0?1:0);};return _this4;}(0,_createClass3.default)(Icon,[{key:'render',value:function render(){var _props2=this.props,iconState=_props2.iconState,bgColor=_props2.bgColor,className=_props2.className,_props2$shape=_props2.shape,shape=_props2$shape===undefined?'square':_props2$shape,_props2$pixel=_props2.pixel,pixel=_props2$pixel===undefined?10:_props2$pixel;var style={backgroundColor:iconState===1?bgColor:'#C0C0C0',//图标开启时，使用bgColor作为背景色；当为关闭的状态，则将背景色置为灰色。
width:pixel,height:pixel,cursor:'pointer'};if(shape==='circle'){//图标为圆形的情况
(0,_assign2.default)(style,{borderRadius:'50%'});}return _react2.default.createElement('div',{style:style,className:iconState===1&&className,onClick:this.handleClick});}}]);return Icon;}(_react2.default.Component);var LeftTree=function(_React$Component5){(0,_inherits3.default)(LeftTree,_React$Component5);function LeftTree(props){(0,_classCallCheck3.default)(this,LeftTree);var _this5=(0,_possibleConstructorReturn3.default)(this,(LeftTree.__proto__||(0,_getPrototypeOf2.default)(LeftTree)).call(this,props));_this5.init=function(){if(_this5.tree)_this5.tree.reset(function(){return _this5.tree.fetchData();});};_this5.handleOrgTreeNodeClick=function(event,ids,nodeids,nodes){var handleOrgTreeNodeClick=_this5.props.handleOrgTreeNodeClick;var _nodes$=nodes[0],type=_nodes$.type,name=_nodes$.name;handleOrgTreeNodeClick({id:ids[0],type:type,name:name});};_this5.tree=null;_this5.setRef=function(element){_this5.tree=element;};return _this5;}(0,_createClass3.default)(LeftTree,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.triggerRefresh!==nextProps.triggerRefresh){this.init();}}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'render',value:function render(){var _this6=this;var _props3=this.props,title=_props3.title,rightStr=_props3.rightStr;return _react2.default.createElement('div',{style:{height:'100%'}},_react2.default.createElement(_ecCom.WeaOrgTree,(0,_extends3.default)({},this.props,{ref:this.setRef,needSearch:true,noCache:true,isLoadAllSub:true,inputLeftDom:'<b>'+title+'</b>',params:{rightStr:rightStr},treeNodeClick:function treeNodeClick(event,ids,nodeids,nodes){return _this6.handleOrgTreeNodeClick(event,ids,nodeids,nodes);}})));}}]);return LeftTree;}(_react2.default.Component);var Tip=function(_React$Component6){(0,_inherits3.default)(Tip,_React$Component6);function Tip(props){(0,_classCallCheck3.default)(this,Tip);return(0,_possibleConstructorReturn3.default)(this,(Tip.__proto__||(0,_getPrototypeOf2.default)(Tip)).call(this,props));}(0,_createClass3.default)(Tip,[{key:'render',value:function render(){var _props4=this.props,tip=_props4.tip,icon=_props4.icon;return _react2.default.createElement('div',{style:{position:'absolute',width:600,top:'42%',left:'50%',marginLeft:-300,textAlign:'center'}},_react2.default.createElement('i',{className:icon,style:{fontSize:80,color:'#D9D9D9'}}),_react2.default.createElement('p',{style:{padding:10}},tip));}}]);return Tip;}(_react2.default.Component);var DistanceToPeak=function(_React$Component7){(0,_inherits3.default)(DistanceToPeak,_React$Component7);function DistanceToPeak(props){(0,_classCallCheck3.default)(this,DistanceToPeak);return(0,_possibleConstructorReturn3.default)(this,(DistanceToPeak.__proto__||(0,_getPrototypeOf2.default)(DistanceToPeak)).call(this,props));}(0,_createClass3.default)(DistanceToPeak,[{key:'componentDidMount',value:function componentDidMount(){var requestDistanceToPeak=this.props.requestDistanceToPeak;var headerHeight=(0,_jquery2.default)('.e9theme-bs-header').height();var navbarHeight=(0,_jquery2.default)('.e9theme-bs-navbar').height();var gap=10;var distance=0;if(headerHeight!==null){distance=headerHeight+navbarHeight+10;}requestDistanceToPeak(distance);}},{key:'render',value:function render(){return _react2.default.createElement('div',null);}}]);return DistanceToPeak;}(_react2.default.Component);exports.AlertPage=AlertPage;exports.NoData=NoData;exports.Loading=Loading;exports.Icon=Icon;exports.LeftTree=LeftTree;exports.Tip=Tip;exports.DistanceToPeak=DistanceToPeak;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _mobx=__webpack_require__(8);var _i18nbk=__webpack_require__(112);var _ImportLog=__webpack_require__(258);var _ImportLog2=_interopRequireDefault(_ImportLog);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var ImportResult=(_dec=(0,_mobxReact.inject)('hrmImportCommon'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(ImportResult,_React$Component);function ImportResult(props){(0,_classCallCheck3.default)(this,ImportResult);var _this=(0,_possibleConstructorReturn3.default)(this,(ImportResult.__proto__||(0,_getPrototypeOf2.default)(ImportResult)).call(this,props));_this.getButtons=function(){var hrmImportCommon=_this.props.hrmImportCommon,resultDialog=hrmImportCommon.resultDialog,setLogDialogVisible=hrmImportCommon.setLogDialogVisible,failnum=resultDialog.failnum,succnum=resultDialog.succnum,importStatus=resultDialog.importStatus;var buttons=[];if(importStatus=='over'||importStatus=='error'){// if (failnum > 0 && succnum > 0) {
//     buttons.push(<Button type="primary" disabled onClick={() => {}}>{i18n.button.downloadErrorDatas()}</Button>);
// }
// buttons.push(<Button type="primary" disabled onClick={() => {}}>{i18n.button.downloadAllDatas()}</Button>);
buttons.push(React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return setLogDialogVisible(true);}},_i18nbk.i18n.button.getImportLog()));}buttons.push(React.createElement(_ecCom.WeaMoreButton,null));return buttons;};_this.reRenderColumns=function(c){c.forEach(function(item){if(item.dataIndex=='operatedetail'){item.render=function(text,record){return React.createElement('span',{style:{color:'#FF0000'}},text);};}});};_this.getErrorInfo=function(){var hrmImportCommon=_this.props.hrmImportCommon,resultDialog=hrmImportCommon.resultDialog,errorTip=resultDialog.errorTip,errorInfo=resultDialog.errorInfo;var columns=[{"title":_i18nbk.i18n.label.confirmInfo(),"width":"100%","dataIndex":"message",render:function render(text,record,index){return React.createElement('span',{style:{color:'#FF0000'}},text);}}];var elements=React.createElement('div',{style:{color:'#FF0000'},className:'hrm-import-table-th'},React.createElement('div',{style:{margin:'20px 0'}},React.createElement('div',{className:'hrm-import-error-tip'},React.createElement(_antd.Icon,{type:'cross',style:{color:'#fff',fontSize:18}})),errorTip),React.createElement('div',{style:{padding:'0 30px'}},React.createElement(_antd.Table,{dataSource:errorInfo,columns:columns,pagination:false,bordered:true})));return elements;};_this.getResultInfo=function(){var hrmImportCommon=_this.props.hrmImportCommon,resultDialog=hrmImportCommon.resultDialog,succnum=resultDialog.succnum,failnum=resultDialog.failnum,tableStore=resultDialog.tableStore,height=_this.state.height;var icon=React.createElement('div',{style:{backgroundColor:succnum>0?'#54D3A2':'#FF0000',marginLeft:270},className:'hrm-import-error-tip'},React.createElement(_antd.Icon,{type:succnum>0?'check':'cross',style:{color:'#fff',fontSize:18}}));var tip=React.createElement('span',{style:{color:succnum>0?'#54D3A2':'#FF0000'}},succnum>0&&failnum==0?_i18nbk.i18n.label.importResourceResultInfo1().replace('{rownum}',''+(succnum+failnum)):_i18nbk.i18n.label.importResourceResultInfo().replace('{rownum}',''+(succnum+failnum)).replace('{succnum}',''+succnum));var resultTable=succnum+failnum>0&&failnum>0&&React.createElement(WeaTable,{comsWeaTableStore:tableStore,bordered:true,pagination:true,rowKey:function rowKey(record,index){return index;},getColumns:function getColumns(c){return _this.reRenderColumns(c);}});return React.createElement('div',null,React.createElement('div',{style:succnum+failnum>0&&failnum>0?{marginTop:20}:{marginTop:height/2-30}},icon,tip),React.createElement('div',{style:{padding:'10px 20px'}},resultTable));};_this.getImportProcessInfo=function(){var hrmImportCommon=_this.props.hrmImportCommon,resultDialog=hrmImportCommon.resultDialog,datas=resultDialog.datas,importStatus=resultDialog.importStatus;var columns=[{"title":_i18nbk.i18n.label.row(),"width":"15%","dataIndex":"rownum"},{"title":_i18nbk.i18n.label.status(),"width":"15%","dataIndex":"status",render:function render(text,record,index){return React.createElement('span',{style:{color:text=='1'?'#54D3A2':'#FF0000'}},text=='1'?_i18nbk.i18n.label.success():_i18nbk.i18n.label.fail());}},{"title":_i18nbk.i18n.label.confirmInfo(),"width":"70%","dataIndex":"message",render:function render(text,record,index){return React.createElement('span',{style:{color:'#FF0000'}},text);}}];var loadingTip=(importStatus!=='over'||importStatus!=='error')&&React.createElement(_antd.Spin,{tip:_i18nbk.i18n.message.serverImportProcessing()});var processTable=React.createElement(_antd.Table,{dataSource:(0,_mobx.toJS)(datas),columns:columns,pagination:false,bordered:true});return React.createElement('div',{className:'hrm-import-ant-table'},React.createElement('div',{style:{margin:'20px 0',paddingLeft:260},className:'hrm-import-loading'},loadingTip),React.createElement('div',{style:{padding:'0 20px 10px'}},processTable));};_this.state={width:740,height:450};return _this;}(0,_createClass3.default)(ImportResult,[{key:'render',value:function render(){var _this2=this;var hrmImportCommon=this.props.hrmImportCommon,resultDialog=hrmImportCommon.resultDialog,logDialog=hrmImportCommon.logDialog,setResultInfoDialogVisible=hrmImportCommon.setResultInfoDialogVisible,hasErrorInfo=hrmImportCommon.hasErrorInfo,setScoll=hrmImportCommon.setScoll,title=resultDialog.title,visible=resultDialog.visible,importStatus=resultDialog.importStatus,errorInfo=resultDialog.errorInfo,loading=resultDialog.loading,_state=this.state,width=_state.width,height=_state.height;return React.createElement('div',null,React.createElement(_ecCom.WeaDialog,{title:title,icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:visible,closable:true,onCancel:function onCancel(){return setResultInfoDialogVisible(false);},buttons:this.getButtons(),style:{width:width,height:height},onChangeHeight:function onChangeHeight(h){return _this2.setState({height:h});}},React.createElement(_antd.Spin,{spinning:loading},React.createElement(_ecCom.WeaNewScroll,{height:height,ref:function ref(com){return setScoll(com);}},!loading&&(hasErrorInfo(errorInfo)?this.getErrorInfo(errorInfo):importStatus=='over'||importStatus=='error'?this.getResultInfo():this.getImportProcessInfo())))),logDialog.visible&&React.createElement(_ImportLog2.default,null));}}]);return ImportResult;}(React.Component))||_class)||_class);exports.default=ImportResult;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _pulicFunc=__webpack_require__(196);var _i18nbk=__webpack_require__(112);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var ImportLog=(_dec=(0,_mobxReact.inject)('hrmImportCommon'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(ImportLog,_React$Component);function ImportLog(props){(0,_classCallCheck3.default)(this,ImportLog);var _this=(0,_possibleConstructorReturn3.default)(this,(ImportLog.__proto__||(0,_getPrototypeOf2.default)(ImportLog)).call(this,props));_this.getDialogButtons=function(){var buttons=[React.createElement(_ecCom.WeaMoreButton,null)];return buttons;};_this.getSearchPanelButtons=function(){var hrmImportCommon=_this.props.hrmImportCommon,searchLogInfo=hrmImportCommon.searchLogInfo,setLogPanelStatus=hrmImportCommon.setLogPanelStatus,logDialog=hrmImportCommon.logDialog,form=logDialog.form;return[React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){searchLogInfo();setLogPanelStatus(false);}},_i18nbk.i18n.button.search()),React.createElement(_antd.Button,{onClick:function onClick(){return form.reset();}},_i18nbk.i18n.button.reset()),React.createElement(_antd.Button,{onClick:function onClick(){return setLogPanelStatus(false);}},_i18nbk.i18n.button.cancel())];};_this.state={width:870,height:510,isPanelShow:false,num:5};return _this;}(0,_createClass3.default)(ImportLog,[{key:'getPanelComponents',value:function getPanelComponents(){var hrmImportCommon=this.props.hrmImportCommon,logDialog=hrmImportCommon.logDialog,form=logDialog.form,condition=logDialog.condition,loading=logDialog.loading,isFormInit=form.isFormInit;var arr=[];isFormInit&&condition.map(function(c){c.items.map(function(field,index){arr.push(React.createElement(_antd.Col,{span:(index+1)/2==1?13:9,offset:1},React.createElement('div',{style:{marginTop:10},className:'hrm-date-group'},React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:index==1?5:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:form.getFormParams()})))));});});return React.createElement(_antd.Spin,{spinning:loading},React.createElement(_antd.Row,null,arr));}},{key:'reRenderColumns',value:function reRenderColumns(c){c.forEach(function(item){if(item.dataIndex=='operator'){item.render=function(text,record){return React.createElement('span',null,React.createElement('a',{style:{cursor:'pointer',color:'#4D7AD8'},onClick:function onClick(){return(0,_pulicFunc.jumpToHrmCard)(record.operator);}},record.operatorspan));};}if(item.dataIndex=='status'){item.render=function(text,record){return React.createElement('span',null,record.status=='1'?React.createElement('span',{style:{color:'rgb(84, 211, 162)'}},_i18nbk.i18n.label.success()):React.createElement('span',{style:{color:'rgb(255, 0, 0)'}},_i18nbk.i18n.label.fail()));};}});}},{key:'render',value:function render(){var _this2=this;var hrmImportCommon=this.props.hrmImportCommon,logDialog=hrmImportCommon.logDialog,setLogDialogVisible=hrmImportCommon.setLogDialogVisible,setLogPanelStatus=hrmImportCommon.setLogPanelStatus,title=logDialog.title,visible=logDialog.visible,isPanelShow=logDialog.isPanelShow,tableStore=logDialog.tableStore,_state=this.state,width=_state.width,height=_state.height,num=_state.num;return React.createElement(_ecCom.WeaDialog,{title:title,icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:visible,closable:true,onCancel:function onCancel(){return setLogDialogVisible(false);},buttons:this.getDialogButtons(),style:{width:width,height:height},onChangeHeight:function onChangeHeight(h){return _this2.setState({height:h});}},React.createElement(_ecCom.WeaTab,{searchType:['advanced'],showSearchAd:isPanelShow,setShowSearchAd:function setShowSearchAd(bool){return setLogPanelStatus(bool);},hideSearchAd:function hideSearchAd(){return setLogPanelStatus(false);},searchsAd:this.getPanelComponents(),advanceHeight:Math.ceil(num/2)*42+10,hasMask:false,buttonsAd:this.getSearchPanelButtons()}),React.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,needScroll:true,scroll:{y:height-125},rowKey:function rowKey(record,index){return index;},getColumns:function getColumns(c){return _this2.reRenderColumns(c);}}));}}]);return ImportLog;}(React.Component))||_class)||_class);exports.default=ImportLog;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getImportHistoryFile=exports.deleteTableRow=exports.saveForm=exports.getFormCondition=exports.getSearchCondition=exports.getSearchResult=undefined;var _ecCom=__webpack_require__(0);//获取表格信息
var getSearchResult=exports.getSearchResult=function getSearchResult(params){return _ecCom.WeaTools.callApi('/api/hrm/group/getSearchResult','POST',params);};//获取下拉面板中的组件
var getSearchCondition=exports.getSearchCondition=function getSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/group/getSearchCondition','GET',params);};//获取Dialog中的表单组件 
var getFormCondition=exports.getFormCondition=function getFormCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/group/getHrmGroupForm','GET',params);};//保存"新建"表单
var saveForm=exports.saveForm=function saveForm(params){return _ecCom.WeaTools.callApi('/api/hrm/group/save','POST',params);};//常用组基本信息删除
var deleteTableRow=exports.deleteTableRow=function deleteTableRow(params){return _ecCom.WeaTools.callApi('/api/hrm/group/delete','POST',params);};//常用组导入历史记录下载
var getImportHistoryFile=exports.getImportHistoryFile=function getImportHistoryFile(params){return _ecCom.WeaTools.callApi('/api/hrm/group/getImportHistoryFile','GET',params);};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(35);
var aFunction = __webpack_require__(76);
var SPECIES = __webpack_require__(30)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(53);
var invoke = __webpack_require__(576);
var html = __webpack_require__(202);
var cel = __webpack_require__(85);
var global = __webpack_require__(25);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(60)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(35);
var isObject = __webpack_require__(36);
var newPromiseCapability = __webpack_require__(197);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.exportExcel=exports.getSfChangeSearchResult=exports.getSfChangeSearchCondition=exports.getSearchResult=exports.getSearchCondition=exports.getRight=undefined;var _ecCom=__webpack_require__(0);var getRight=exports.getRight=function getRight(params){return _ecCom.WeaTools.callApi('/api/hrm/ChangeRp/getHasRight','GET',params);};var getSearchCondition=exports.getSearchCondition=function getSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/resourceState/getSearchCondition','GET',params);};var getSearchResult=exports.getSearchResult=function getSearchResult(params){return _ecCom.WeaTools.callApi('/api/hrm/resourceState/getSearchResult','POST',params);};var getSfChangeSearchCondition=exports.getSfChangeSearchCondition=function getSfChangeSearchCondition(params,idy){if(idy=='staff'){return _ecCom.WeaTools.callApi('/api/hrm/ChangeRp/getSearchCondition','GET',params);}if(idy=='contract'){return _ecCom.WeaTools.callApi('/api/hrm/Contract/getSearchCondition','GET',params);}};var getSfChangeSearchResult=exports.getSfChangeSearchResult=function getSfChangeSearchResult(params,idy){if(idy=='staff'){return _ecCom.WeaTools.callApi('/api/hrm/ChangeRp/getRpResult','POST',params);}if(idy=='contract'){return _ecCom.WeaTools.callApi('/api/hrm/Contract/getRpResult','POST',params);}};var exportExcel=exports.exportExcel=function exportExcel(dataKey){return _ecCom.WeaTools.callApi('/api/ec/dev/table/export','POST',{dataKey:dataKey});};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getTabTableData=exports.getHrmKQReportDetialTabInfo=exports.getTableData=exports.getReportData=exports.getSearchCondition=undefined;var _promise=__webpack_require__(75);var _promise2=_interopRequireDefault(_promise);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getSearchCondition=exports.getSearchCondition=function getSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/schedulediffreport/getSearchCondition','POST',params);};var getReportData=exports.getReportData=function getReportData(params){return _ecCom.WeaTools.callApi('/api/hrm/schedulediffreport/getReportData','POST',params);};var getTableData=exports.getTableData=function getTableData(params){return _ecCom.WeaTools.callApi('/api/hrm/kq/report/getHrmKQReportDetialInfo','POST',params);};var getHrmKQReportDetialTabInfo=exports.getHrmKQReportDetialTabInfo=function getHrmKQReportDetialTabInfo(params){return _ecCom.WeaTools.callApi('/api/hrm/kq/report/getHrmKQReportDetialTabInfo','POST',params);};var getTabTableData=exports.getTabTableData=function getTabTableData(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _promise2.default.all([getHrmKQReportDetialTabInfo(),getTableData()]);};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _ecCom=__webpack_require__(0);var _Route=__webpack_require__(267);var _Route2=_interopRequireDefault(_Route);var _IndexRedirect=__webpack_require__(268);var _IndexRedirect2=_interopRequireDefault(_IndexRedirect);var _Home=__webpack_require__(272);var _Home2=_interopRequireDefault(_Home);var _Checking=__webpack_require__(301);var _Checking2=_interopRequireDefault(_Checking);var _BirthdayInfo=__webpack_require__(366);var _BirthdayInfo2=_interopRequireDefault(_BirthdayInfo);var _Group=__webpack_require__(367);var _Group2=_interopRequireDefault(_Group);var _Shift=__webpack_require__(369);var _Shift2=_interopRequireDefault(_Shift);var _Outside=__webpack_require__(370);var _Outside2=_interopRequireDefault(_Outside);var _Total=__webpack_require__(387);var _Total2=_interopRequireDefault(_Total);var _Online=__webpack_require__(416);var _Online2=_interopRequireDefault(_Online);var _Underling=__webpack_require__(417);var _Underling2=_interopRequireDefault(_Underling);var _TrainRecord=__webpack_require__(418);var _TrainRecord2=_interopRequireDefault(_TrainRecord);var _RewardsRecord=__webpack_require__(419);var _RewardsRecord2=_interopRequireDefault(_RewardsRecord);var _Finance=__webpack_require__(420);var _Finance2=_interopRequireDefault(_Finance);var _RoleSet=__webpack_require__(421);var _RoleSet2=_interopRequireDefault(_RoleSet);var _SystemInfo=__webpack_require__(429);var _SystemInfo2=_interopRequireDefault(_SystemInfo);var _SystemInfo4Formal=__webpack_require__(430);var _SystemInfo4Formal2=_interopRequireDefault(_SystemInfo4Formal);var _Password=__webpack_require__(431);var _Password2=_interopRequireDefault(_Password);var _AddressBook=__webpack_require__(436);var _AddressBook2=_interopRequireDefault(_AddressBook);var _AddressBookForOrgChart=__webpack_require__(449);var _AddressBookForOrgChart2=_interopRequireDefault(_AddressBookForOrgChart);var _index=__webpack_require__(450);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(456);var _index4=_interopRequireDefault(_index3);var _Info=__webpack_require__(460);var _Info2=_interopRequireDefault(_Info);var _Info4Formal_new=__webpack_require__(461);var _Info4Formal_new2=_interopRequireDefault(_Info4Formal_new);var _Personal=__webpack_require__(462);var _Personal2=_interopRequireDefault(_Personal);var _Work=__webpack_require__(463);var _Work2=_interopRequireDefault(_Work);var _Checking3=__webpack_require__(464);var _Checking4=_interopRequireDefault(_Checking3);var _SystemCard=__webpack_require__(244);var _SystemCard2=_interopRequireDefault(_SystemCard);var _Group3=__webpack_require__(475);var _Group4=_interopRequireDefault(_Group3);var _BasicConditionAnalysis=__webpack_require__(477);var _BasicConditionAnalysis2=_interopRequireDefault(_BasicConditionAnalysis);var _ChangeRelatedReport=__webpack_require__(481);var _ChangeRelatedReport2=_interopRequireDefault(_ChangeRelatedReport);var _ConstRpSubSearch=__webpack_require__(487);var _ConstRpSubSearch2=_interopRequireDefault(_ConstRpSubSearch);var _RpSubSearch=__webpack_require__(489);var _RpSubSearch2=_interopRequireDefault(_RpSubSearch);var _ScheduleDiffReport=__webpack_require__(490);var _ScheduleDiffReport2=_interopRequireDefault(_ScheduleDiffReport);var _ScheduleDiffReport4Formal=__webpack_require__(491);var _ScheduleDiffReport4Formal2=_interopRequireDefault(_ScheduleDiffReport4Formal);var _ScheduleDiffMonthAttDetail=__webpack_require__(492);var _ScheduleDiffMonthAttDetail2=_interopRequireDefault(_ScheduleDiffMonthAttDetail);var _index5=__webpack_require__(494);var _index6=_interopRequireDefault(_index5);var _BindTokenKey=__webpack_require__(497);var _BindTokenKey2=_interopRequireDefault(_BindTokenKey);var _index7=__webpack_require__(498);var _index8=_interopRequireDefault(_index7);var _index9=__webpack_require__(499);var _index10=_interopRequireDefault(_index9);var _index11=__webpack_require__(516);var _index12=_interopRequireDefault(_index11);var _index13=__webpack_require__(528);var _index14=_interopRequireDefault(_index13);var _index15=__webpack_require__(532);var _index16=_interopRequireDefault(_index15);var _index17=__webpack_require__(539);var _index18=_interopRequireDefault(_index17);var _index19=__webpack_require__(554);var _index20=_interopRequireDefault(_index19);__webpack_require__(556);__webpack_require__(17);var _index21=__webpack_require__(559);var _index22=_interopRequireDefault(_index21);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}window.WeaHrm4Formal=false;window.HrmGroupCol=2;//人力布局(1、一行2列，2、一行4列)
window.HrmLabelCol=6;window.HrmWrapperCol=15;window.inputType={inputType:'MULTILANG',isBase64:true//, isBase64: true}; //'MULTILANG'; //'NORMAL';
};// 考勤
// 排班
// 外勤
//工作历程
// 在线人员
//我的下属
//培训记录
//奖惩考核
//我的工资
//角色设置
//系统信息
//系统信息
//密码修改、设置
//通讯录
//通讯录FOR ORG CHART
// 新建人员
// 卡片
// 卡片
// 基本信息
// 基本信息
// 个人信息
// 工作信息
//系统信息
//系统信息
//我的工资
// 旧考勤
// 新考勤
//培训记录
//奖惩考核
//角色设置
//工作历程
//系统管理员卡片
//常用组
//报表
//基本状况分析
//人员变动情况
//统计子表
//统计子表--自定义
//考勤报表
//正式系统考勤报表
//考勤月报表
//组织图表
//
//忘记密码
//应聘人员
//用工需求
//时间工资汇总
//人员工资汇总
//新建、编辑常用组单页
//常用组建议
var getLocaleLabel=_ecCom.WeaLocaleProvider.getLocaleLabel.bind(undefined,'hrm');var HrmRoute=React.createElement(_Route2.default,{name:'hrm',breadcrumbName:'\u4EBA\u4E8B',path:'hrm',onEnter:getLocaleLabel,component:_Home2.default},React.createElement(_Route2.default,{name:'addressBook',breadcrumbName:'\u901A\u8BAF\u5F55',path:'addressBook',component:_AddressBook2.default}),React.createElement(_Route2.default,{name:'orgStaff',breadcrumbName:'\u901A\u8BAF\u5F55FOR ORG CHART',path:'orgStaff',component:_AddressBookForOrgChart2.default}),React.createElement(_Route2.default,{name:'add',breadcrumbName:'\u65B0\u5EFA\u4EBA\u5458',path:'add',component:_index2.default}),React.createElement(_Route2.default,{name:'card',path:'card',component:_index4.default},React.createElement(_IndexRedirect2.default,{to:'cardInfo'}),React.createElement(_Route2.default,{name:'cardInfo',path:'cardInfo',component:window.WeaHrm4Formal?_Info4Formal_new2.default:_Info2.default}),React.createElement(_Route2.default,{name:'cardInfoId',path:'cardInfo/:hrmId',component:window.WeaHrm4Formal?_Info4Formal_new2.default:_Info2.default}),React.createElement(_Route2.default,{name:'cardPersonal',path:'cardPersonal',component:_Personal2.default}),React.createElement(_Route2.default,{name:'cardPersonalId',path:'cardPersonal/:hrmId',component:_Personal2.default}),React.createElement(_Route2.default,{name:'cardWork',path:'cardWork',component:_Work2.default}),React.createElement(_Route2.default,{name:'cardWorkId',path:'cardWork/:hrmId',component:_Work2.default}),React.createElement(_Route2.default,{name:'cardSystemInfo',path:'cardSystemInfo',component:window.WeaHrm4Formal?_SystemInfo4Formal2.default:_SystemInfo2.default}),React.createElement(_Route2.default,{name:'cardSystemInfoId',path:'cardSystemInfo/:hrmId',component:window.WeaHrm4Formal?_SystemInfo4Formal2.default:_SystemInfo2.default}),React.createElement(_Route2.default,{name:'cardFinance',path:'cardFinance',component:_Finance2.default}),React.createElement(_Route2.default,{name:'cardFinanceId',path:'cardFinance/:hrmId',component:_Finance2.default}),React.createElement(_Route2.default,{name:'cardChecking',path:'cardChecking',component:_Checking2.default}),React.createElement(_Route2.default,{name:'cardCheckingId',path:'cardChecking/:hrmId',component:_Checking2.default}),React.createElement(_Route2.default,{name:'cardCheckingN',path:'cardCheckingN',component:_Checking4.default}),React.createElement(_Route2.default,{name:'cardCheckingNId',path:'cardCheckingN/:hrmId',component:_Checking4.default}),React.createElement(_Route2.default,{name:'cardTrainRecord',path:'cardTrainRecord',component:_TrainRecord2.default}),React.createElement(_Route2.default,{name:'cardTrainRecordId',path:'cardTrainRecord/:hrmId',component:_TrainRecord2.default}),React.createElement(_Route2.default,{name:'cardRewardsRecord',path:'cardRewardsRecord',component:_RewardsRecord2.default}),React.createElement(_Route2.default,{name:'cardRewardsRecordId',path:'cardRewardsRecord/:hrmId',component:_RewardsRecord2.default}),React.createElement(_Route2.default,{name:'cardRoleSet',path:'cardRoleSet',component:_RoleSet2.default}),React.createElement(_Route2.default,{name:'cardRoleSetId',path:'cardRoleSet/:hrmId',component:_RoleSet2.default}),React.createElement(_Route2.default,{name:'cardTotal',path:'cardTotal',component:_Total2.default}),React.createElement(_Route2.default,{name:'cardTotalId',path:'cardTotal/:hrmId',component:_Total2.default}),React.createElement(_Route2.default,{name:'systemCard',path:'systemCard',component:_SystemCard2.default}),React.createElement(_Route2.default,{name:'systemCardId',path:'systemCard/:hrmId',component:_SystemCard2.default}),React.createElement(_Route2.default,{name:'addGroup',path:'addGroup',component:_Group4.default}),React.createElement(_Route2.default,{name:'addGroupId',path:'addGroup/:hrmId',component:_Group4.default})),React.createElement(_Route2.default,{name:'report',path:'report'},React.createElement(_Route2.default,{name:'basicConditionAnalysis',path:'basicConditionAnalysis',component:_BasicConditionAnalysis2.default}),React.createElement(_Route2.default,{name:'departmentStatistics',path:'departmentStatistics',component:_BasicConditionAnalysis2.default}),React.createElement(_Route2.default,{name:'postStatistics',path:'postStatistics',component:_BasicConditionAnalysis2.default}),React.createElement(_Route2.default,{name:'jobStatusStatistics',path:'jobStatusStatistics',component:_BasicConditionAnalysis2.default}),React.createElement(_Route2.default,{name:'add',path:'add',component:_ChangeRelatedReport2.default}),React.createElement(_Route2.default,{name:'confirmation',path:'confirmation',component:_ChangeRelatedReport2.default}),React.createElement(_Route2.default,{name:'transfer',path:'transfer',component:_ChangeRelatedReport2.default}),React.createElement(_Route2.default,{name:'renew',path:'renew',component:_ChangeRelatedReport2.default}),React.createElement(_Route2.default,{name:'rehire',path:'rehire',component:_ChangeRelatedReport2.default}),React.createElement(_Route2.default,{name:'loss',path:'loss',component:_ChangeRelatedReport2.default}),React.createElement(_Route2.default,{name:'contract',path:'contract',component:_ChangeRelatedReport2.default})),React.createElement(_Route2.default,{name:'checking',breadcrumbName:'\u6211\u7684\u8003\u52E4',path:'checking',component:_Checking2.default}),React.createElement(_Route2.default,{name:'birthdayinfo',breadcrumbName:'\u4EBA\u5458\u751F\u65E5',path:'birthdayinfo',component:_BirthdayInfo2.default}),React.createElement(_Route2.default,{name:'group',breadcrumbName:'\u4EBA\u529B\u8D44\u6E90',path:'group',component:_Group2.default}),React.createElement(_Route2.default,{name:'shift',breadcrumbName:'\u6211\u7684\u6392\u73ED',path:'shift',component:_Shift2.default}),React.createElement(_Route2.default,{name:'outside',breadcrumbName:'\u5916\u52E4\u7B7E\u5230',path:'outside',component:_Outside2.default}),React.createElement(_Route2.default,{name:'total',breadcrumbName:'\u5DE5\u4F5C\u5386\u7A0B',path:'total',component:_Total2.default}),React.createElement(_Route2.default,{name:'online',breadcrumbName:'\u5728\u7EBF\u4EBA\u5458',path:'online',component:_Online2.default}),React.createElement(_Route2.default,{name:'password',breadcrumbName:'\u5BC6\u7801\u4FEE\u6539\u548C\u8BBE\u7F6E',path:'password',component:_Password2.default}),React.createElement(_Route2.default,{name:'underling',breadcrumbName:'\u6211\u7684\u4E0B\u5C5E',path:'underling',component:_Underling2.default}),React.createElement(_Route2.default,{name:'underlingId',breadcrumbName:'\u6211\u7684\u4E0B\u5C5E',path:'underling/:hrmId',component:_Underling2.default}),React.createElement(_Route2.default,{name:'trainrecord',breadcrumbName:'\u57F9\u8BAD\u8BB0\u5F55',path:'trainrecord',component:_TrainRecord2.default}),React.createElement(_Route2.default,{name:'rewardsrecord',breadcrumbName:'\u5956\u60E9\u8003\u6838',path:'rewardsrecord',component:_RewardsRecord2.default}),React.createElement(_Route2.default,{name:'rewardsrecordId',breadcrumbName:'\u5956\u60E9\u8003\u6838',path:'rewardsrecord/:hrmId',component:_RewardsRecord2.default}),React.createElement(_Route2.default,{name:'finance',breadcrumbName:'\u6211\u7684\u5DE5\u8D44',path:'finance',component:_Finance2.default}),React.createElement(_Route2.default,{name:'roleset',breadcrumbName:'\u89D2\u8272\u8BBE\u7F6E',path:'roleset',component:_RoleSet2.default}),React.createElement(_Route2.default,{name:'systeminfo',breadcrumbName:'\u7CFB\u7EDF\u4FE1\u606F',path:'systeminfo',component:window.WeaHrm4Formal?_SystemInfo4Formal2.default:_SystemInfo2.default}),React.createElement(_Route2.default,{name:'systeminfoId',breadcrumbName:'\u7CFB\u7EDF\u4FE1\u606F',path:'systeminfo/:hrmId',component:window.WeaHrm4Formal?_SystemInfo4Formal2.default:_SystemInfo2.default}),React.createElement(_Route2.default,{name:'constrpsubsearch',breadcrumbName:'\u7EDF\u8BA1\u5B50\u8868',path:'constrpsubsearch/:scopeId',component:_ConstRpSubSearch2.default}),React.createElement(_Route2.default,{name:'rpsubsearch',breadcrumbName:'\u7EDF\u8BA1\u5B50\u8868--\u81EA\u5B9A\u4E49',path:'rpsubsearch',component:_RpSubSearch2.default}),React.createElement(_Route2.default,{name:'schedulediffreport',breadcrumbName:'\u8003\u52E4\u62A5\u8868',path:'schedulediffreport',component:window.WeaHrm4Formal?_ScheduleDiffReport4Formal2.default:_ScheduleDiffReport2.default}),React.createElement(_Route2.default,{name:'schedulediffmonthattdetail',breadcrumbName:'\u8003\u52E4\u62A5\u8868',path:'schedulediffmonthattdetail',component:_ScheduleDiffMonthAttDetail2.default}),React.createElement(_Route2.default,{name:'orgChart',breadcrumbName:'\u7EC4\u7EC7\u56FE\u8868',path:'orgChart',component:_index6.default}),React.createElement(_Route2.default,{name:'BindTokenKey',breadcrumbName:'\u4EE4\u724C\u7ED1\u5B9A',path:'BindTokenKey',component:_BindTokenKey2.default}),React.createElement(_Route2.default,{name:'forgetPassword',breadcrumbName:'\u5FD8\u8BB0\u5BC6\u7801',path:'forgetPassword',component:_index8.default}),React.createElement(_Route2.default,{name:'applicant',breadcrumbName:'\u5E94\u8058\u4EBA\u5458',path:'applicant',component:_index10.default}),React.createElement(_Route2.default,{name:'usedemand',breadcrumbName:'\u7528\u5DE5\u9700\u6C42',path:'usedemand',component:_index12.default}),React.createElement(_Route2.default,{name:'timeWageSummary',breadcrumbName:'\u65F6\u95F4\u5DE5\u8D44\u6C47\u603B',path:'timeWageSummary',component:_index14.default}),React.createElement(_Route2.default,{name:'staffPayrollSummary',breadcrumbName:'\u4EBA\u5458\u5DE5\u8D44\u6C47\u603B',path:'staffPayrollSummary',component:_index16.default}),React.createElement(_Route2.default,{name:'operateGroup',breadcrumbName:'\u65B0\u5EFA\u3001\u7F16\u8F91\u5E38\u7528\u7EC4\u5355\u9875',path:'operateGroup',component:_index18.default}),React.createElement(_Route2.default,{name:'groupAdvice',breadcrumbName:'\u5E38\u7528\u7EC4\u5EFA\u8BAE',path:'groupAdvice',component:_index20.default}));module.exports={Route:HrmRoute,store:_index22.default};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createReactClass = __webpack_require__(21);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(18);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(198);

var _InternalPropTypes = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = (0, _createReactClass2.default)({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
  },

  propTypes: {
    path: _propTypes.string,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: _propTypes.func,
    getComponents: _propTypes.func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Route;
module.exports = exports['default'];

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createReactClass = __webpack_require__(21);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(18);

var _routerWarning = __webpack_require__(269);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _Redirect = __webpack_require__(270);

var _Redirect2 = _interopRequireDefault(_Redirect);

var _InternalPropTypes = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = (0, _createReactClass2.default)({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
      } else {
         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: _propTypes.string.isRequired,
    query: _propTypes.object,
    state: _propTypes.object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = IndexRedirect;
module.exports = exports['default'];

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = routerWarning;
exports._resetWarned = _resetWarned;

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createReactClass = __webpack_require__(21);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(18);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(198);

var _PatternUtils = __webpack_require__(271);

var _InternalPropTypes = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = (0, _createReactClass2.default)({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = (0, _RouteUtils.createRouteFromReactElement)(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: _propTypes.string,
    from: _propTypes.string, // Alias for path
    to: _propTypes.string.isRequired,
    query: _propTypes.object,
    state: _propTypes.object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Redirect;
module.exports = exports['default'];

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.compilePattern = compilePattern;
exports.matchPattern = matchPattern;
exports.getParamNames = getParamNames;
exports.getParams = getParams;
exports.formatPattern = formatPattern;

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _loadjs=__webpack_require__(148);var _loadjs2=_interopRequireDefault(_loadjs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaLogViewComp=_comsMobx.WeaLogView.Component;var LogStore=_comsMobx.WeaLogView.LogStore;var Home=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Home,_React$Component);function Home(props){(0,_classCallCheck3.default)(this,Home);var _this=(0,_possibleConstructorReturn3.default)(this,(Home.__proto__||(0,_getPrototypeOf2.default)(Home)).call(this,props));_initialiseProps.call(_this);_this.state={visible:false,logStore:new LogStore(),logType:'3',logSmallType:''};window.setLogViewProps=_this.setLogViewProps;return _this;}(0,_createClass3.default)(Home,[{key:'componentDidMount',value:function componentDidMount(){(0,_loadjs2.default)(["/social/js/drageasy/drageasy.js","/social/js/bootstrap/js/bootstrap.js?v=20171218","/social/im/js/IMUtil_wev8.js","/social/js/imcarousel/imcarousel.js"]);}},{key:'render',value:function render(){return React.createElement('div',{style:{height:"100%"}},React.createElement('iframe',{id:'hiddenPreLoaderSingle',name:'hiddenPreLoaderSingle',style:{display:"none"},width:'0',height:'0',border:'0',frameborder:'0'}),React.createElement(_ecCom.WeaLocaleProvider,null,this.props.children),React.createElement(_ecCom.WeaPopoverHrm,null),React.createElement(WeaLogViewComp,(0,_extends3.default)({},this.state,{onCancel:this.onCancel})));}}]);return Home;}(React.Component),_initialiseProps=function _initialiseProps(){var _this2=this;this.setLogViewProps=function(props){_this2.setState((0,_extends3.default)({targetId:'',visible:true,logStore:new LogStore(),logType:'3'},props));};this.onCancel=function(props){_this2.setState({visible:false});};},_temp);exports.default=Home;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(274);
module.exports = __webpack_require__(20).Object.getPrototypeOf;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(62);
var $getPrototypeOf = __webpack_require__(199);

__webpack_require__(142)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(276);
var $Object = __webpack_require__(20).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(31);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(37), 'Object', { defineProperty: __webpack_require__(39).f });


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(278), __esModule: true };

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(93);
__webpack_require__(116);
module.exports = __webpack_require__(145).f('iterator');


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(78);
var defined = __webpack_require__(77);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(144);
var descriptor = __webpack_require__(58);
var setToStringTag = __webpack_require__(115);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(47)(IteratorPrototype, __webpack_require__(30)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(39);
var anObject = __webpack_require__(35);
var getKeys = __webpack_require__(59);

module.exports = __webpack_require__(37) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(283);
var step = __webpack_require__(284);
var Iterators = __webpack_require__(81);
var toIObject = __webpack_require__(45);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(200)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(286), __esModule: true };

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(287);
__webpack_require__(204);
__webpack_require__(292);
__webpack_require__(293);
module.exports = __webpack_require__(20).Symbol;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(25);
var has = __webpack_require__(44);
var DESCRIPTORS = __webpack_require__(37);
var $export = __webpack_require__(31);
var redefine = __webpack_require__(201);
var META = __webpack_require__(288).KEY;
var $fails = __webpack_require__(43);
var shared = __webpack_require__(90);
var setToStringTag = __webpack_require__(115);
var uid = __webpack_require__(79);
var wks = __webpack_require__(30);
var wksExt = __webpack_require__(145);
var wksDefine = __webpack_require__(146);
var enumKeys = __webpack_require__(289);
var isArray = __webpack_require__(290);
var anObject = __webpack_require__(35);
var isObject = __webpack_require__(36);
var toIObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(86);
var createDesc = __webpack_require__(58);
var _create = __webpack_require__(144);
var gOPNExt = __webpack_require__(291);
var $GOPD = __webpack_require__(147);
var $DP = __webpack_require__(39);
var $keys = __webpack_require__(59);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(203).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(80).f = $propertyIsEnumerable;
  __webpack_require__(92).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(61)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(47)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(79)('meta');
var isObject = __webpack_require__(36);
var has = __webpack_require__(44);
var setDesc = __webpack_require__(39).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(43)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(59);
var gOPS = __webpack_require__(92);
var pIE = __webpack_require__(80);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(60);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(45);
var gOPN = __webpack_require__(203).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146)('asyncIterator');


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146)('observable');


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(295), __esModule: true };

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(296);
module.exports = __webpack_require__(20).Object.setPrototypeOf;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(31);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(297).set });


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(36);
var anObject = __webpack_require__(35);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(53)(Function.call, __webpack_require__(147).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(299), __esModule: true };

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(300);
var $Object = __webpack_require__(20).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(31);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(144) });


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);__webpack_require__(149);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _toString=__webpack_require__(56);var _toString2=_interopRequireDefault(_toString);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _debounce=__webpack_require__(49);var _debounce2=_interopRequireDefault(_debounce);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _path=__webpack_require__(225);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var toJS=mobx.toJS;var __this=void 0;var main=(_dec=(0,_mobxReact.inject)('hrmOldChecking'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.onOperatesClick=function(record,index,operate,flag,argumentString){if(toJS(operate)&&toJS(operate).href.indexOf('addChecking')>-1){__this.addChecking();}};_this.state={iWidth:window.innerWidth,oHeight:300};if(window.innerHeight>850){_this.state.oHeight=450;}else if(window.innerHeight>600){_this.state.oHeight=window.innerHeight/2-100;}else{_this.state.oHeight=200;}_this.onStsClick.bind(_this);__this=_this;var hrmOldChecking=_this.props.hrmOldChecking;hrmOldChecking.init();return _this;}(0,_createClass3.default)(main,[{key:'componentDidMount',value:function componentDidMount(){var hrmOldChecking=this.props.hrmOldChecking;hrmOldChecking.hrmId=this.props.params.hrmId||'';this.getData();hrmOldChecking.getHrmNewWorkflwList();//document.title = hrmOldChecking.title;
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmOldChecking=this.props.hrmOldChecking;if(this.props.location.key!==nextProps.location.key){hrmOldChecking.init();this.getData();}}},{key:'getData',value:function getData(){var _this2=this;var hrmOldChecking=this.props.hrmOldChecking;var tabkey=hrmOldChecking.tabkey;hrmOldChecking.getData(function(){tabkey==1&&_this2.refs.chart&&_this2.refs.chart.paint();});}},{key:'getRightMenu',value:function getRightMenu(){var _this3=this;var hrmOldChecking=this.props.hrmOldChecking;var btns=[];btns.push({key:"add",icon:_react2.default.createElement('i',{className:'icon-coms-workflow'}),content:getLabel('385037',"新建考勤流程"),onClick:function onClick(key){_this3.addChecking();}});return btns;}},{key:'addChecking',value:function addChecking(){var hrmOldChecking=this.props.hrmOldChecking;hrmOldChecking.updateNewVisible(true);}},{key:'getTopButtons',value:function getTopButtons(){var _this4=this;var hrmOldChecking=this.props.hrmOldChecking;var btns=[];btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this4.addChecking();}},getLabel('385037',"新建考勤流程")));return btns;}},{key:'chooseUser',value:function chooseUser(e){var hrmOldChecking=this.props.hrmOldChecking;var hrmId='',hrmName=undefined;if(e.selected){hrmId=e.node.props.id;hrmName=e.node.props.name;}if(hrmId){hrmOldChecking.updateHrmId(hrmId);if(hrmName)hrmOldChecking.updateHrmName(hrmName);this.getData();}}},{key:'changeUserRoot',value:function changeUserRoot(ids,names,datas){var hrmOldChecking=this.props.hrmOldChecking;hrmOldChecking.updateUserRoot(datas);}},{key:'resetUserRoot',value:function resetUserRoot(){var hrmOldChecking=this.props.hrmOldChecking;hrmOldChecking.updateUserRoot();hrmOldChecking.updateHrmId();hrmOldChecking.updateHrmName();this.getData();}},{key:'changeTab',value:function changeTab(key){var hrmOldChecking=this.props.hrmOldChecking;hrmOldChecking.changeTabHandler(key);this.getData();}},{key:'changeDateTab',value:function changeDateTab(key){var hrmOldChecking=this.props.hrmOldChecking;hrmOldChecking.changeDateTabHandler(key);this.getData();}},{key:'reFresh',value:function reFresh(){var hrmOldChecking=this.props.hrmOldChecking;this.getData();}},{key:'changeDate',value:function changeDate(v){var hrmOldChecking=this.props.hrmOldChecking;var dateTabkey=hrmOldChecking.dateTabkey;if(dateTabkey=='2'){v=new _moment2.default(v).format('YYYY-MM');}else{v=new _moment2.default(v).format('YYYY');}hrmOldChecking.changeDateHandler(v);this.getData();}},{key:'handlerStatusClick',value:function handlerStatusClick(item){var hrmOldChecking=this.props.hrmOldChecking;hrmOldChecking.handlerStatusClick(item.type);}},{key:'renderLeft',value:function renderLeft(){var hrmOldChecking=this.props.hrmOldChecking;var oHeight=this.state.oHeight;var tabkey=hrmOldChecking.tabkey,leftTitle=hrmOldChecking.leftTitle,userRoot=hrmOldChecking.userRoot;userRoot=toJS(userRoot);var hrmId=this.props.params.hrmId||'';var org=_react2.default.createElement(_ecCom.WeaOrgTree,{dataUrl:'/api/hrm/base/getHrmResourceTree',rootKey:'rootManager',treeNodeClick:this.chooseUser.bind(this),params:Array.isArray(userRoot)&&userRoot[0]?{rootid:userRoot[0].id}:{rootid:hrmId}});return _react2.default.createElement('div',{className:'wea-hrm-checking-left',style:{height:window.innerHeight-125}},_react2.default.createElement('div',{className:'left-header'},_react2.default.createElement('div',{className:'header-title bb align-center'},getLabel('32997',"人员组织"))),_react2.default.createElement('div',{className:'left-body'},_react2.default.createElement(_ecCom.WeaBrowser,{isSingle:true,linkUrl:'/hrm/resource/HrmResource.jsp?id=',title:getLabel('179',"人力资源"),type:'1',viewAttr:'2',replaceDatas:userRoot,customIcon:'icon-coms-Reset',addOnClick:this.resetUserRoot.bind(this),onChange:this.changeUserRoot.bind(this)}),tabkey==='1'?_react2.default.createElement('div',{style:{height:window.innerHeight-235}},org):_react2.default.createElement(_ecCom.WeaNewScroll,{height:oHeight,className:'left-checking'},org),tabkey==='2'&&this.renderDetail()));}// 截取很magic的a标签数据
},{key:'sliceA',value:function sliceA(str){if(str.indexOf('a>')>-1&&str.indexOf('<a')>-1){str=str.match(/\>(.+)</)[1];}return str;}},{key:'renderDetail',value:function renderDetail(){var _this5=this;var hrmOldChecking=this.props.hrmOldChecking;var oHeight=this.state.oHeight;var calendarCheckedDay=hrmOldChecking.calendarCheckedDay,calendarData=hrmOldChecking.calendarData;calendarData=toJS(calendarData);if(calendarCheckedDay){var data=calendarData[calendarCheckedDay];return _react2.default.createElement(_ecCom.WeaNewScroll,{height:window.innerHeight-200-oHeight,className:'bt'},_react2.default.createElement('div',{className:'detail-wrapper'},_react2.default.createElement('strong',{className:'detail-header'},_react2.default.createElement('i',{className:'icon-coms-New-schedule'}),data.date,'\xA0 ',getLabel('20080',"考勤情况")),(0,_isEmpty2.default)(data.signInfo)&&_react2.default.createElement('div',{className:'empty align-center'},getLabel('386472',"当天没有考勤数据")),!(0,_isEmpty2.default)(data.signInfo)&&_react2.default.createElement(_antd.Timeline,null,data.signInfo.map(function(i){return _react2.default.createElement(_antd.Timeline.Item,null,i.item&&i.item.map(function(d){return _react2.default.createElement('div',{className:'item'},_react2.default.createElement('span',{className:'title'},d.title),'\xA0:\xA0',_react2.default.createElement('span',{className:'value'},_this5.sliceA(d.value)));}));}))));}return _react2.default.createElement('div',{className:'detail-wrapper align-center bt'},_react2.default.createElement('span',null,getLabel('386473',"点击日历查看每天考勤情况")));}},{key:'getLocale',value:function getLocale(){return{firstDayOfWeek:0,lang:{format:{eras:[getLabel(383357,"公元前"),getLabel(383358,"公元")],months:[getLabel(1492,"一月"),getLabel(1493,"二月"),getLabel(383385,"三月"),getLabel(383387,"四月"),getLabel(1496,"五月"),getLabel(383392,"六月"),getLabel(383393,"七月"),getLabel(383394,"八月"),getLabel(383395,"九月"),getLabel(383396,"十月"),getLabel(383397,"十一月"),getLabel(383398,"十二月")],shortMonths:[getLabel(1492,"一月"),getLabel(1493,"二月"),getLabel(383385,"三月"),getLabel(383387,"四月"),getLabel(1496,"五月"),getLabel(383392,"六月"),getLabel(383393,"七月"),getLabel(383394,"八月"),getLabel(383395,"九月"),getLabel(383396,"十月"),getLabel(383397,"十一月"),getLabel(383398,"十二月")],weekdays:[getLabel(24626,"星期天"),getLabel(383399,"星期一"),getLabel(383400,"星期二"),getLabel(383402,"星期三"),getLabel(383403,"星期四"),getLabel(383404,"星期五"),getLabel(383405,"星期六")],shortWeekdays:[getLabel(16106,"周日"),getLabel(16100,"周一"),getLabel(16101,"周二"),getLabel(16102,"周三"),getLabel(16103,"周四"),getLabel(16104,"周五"),getLabel(16105,"周六")],veryShortWeekdays:[getLabel(16106,"周日"),getLabel(16100,"周一"),getLabel(16101,"周二"),getLabel(16102,"周三"),getLabel(16103,"周四"),getLabel(16104,"周五"),getLabel(16105,"周六")],ampms:[getLabel(383408,"上午"),getLabel(383409,"下午")],datePatterns:['yyyy\''+getLabel(383372,"年")+'\'M\''+getLabel(383373,"月")+'\'d\''+getLabel(383374,"日")+'\' EEEE','yyyy\''+getLabel(383372,"年")+'\'M\''+getLabel(383373,"月")+'\'d\''+getLabel(383374,"日")+'\'',"yyyy-M-d","yy-M-d"],timePatterns:['ahh\''+getLabel(383411,"时")+'\'mm\''+getLabel(383412,"分")+'\'ss\''+getLabel(383414,"秒")+'\' \'GMT\'Z','ahh\''+getLabel(383411,"时")+'\'mm\''+getLabel(383412,"分")+'\'ss\''+getLabel(383414,"秒")+'\'',"H:mm:ss","ah:mm"],dateTimePattern:'{date} {time}'}}};}},{key:'getTipText',value:function getTipText(data){return _react2.default.createElement('div',null,_react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:data.title}}),_react2.default.createElement('div',null,getLabel('24979',"开始时间"),'\uFF1A ',data.start),_react2.default.createElement('div',null,getLabel('743',"结束时间"),'\uFF1A ',data.end),data.type&&_react2.default.createElement('div',null,getLabel('500401',"类型"),'\uFF1A ',data.type),_react2.default.createElement('div',null,data.workflowtype=='OVERTIME'?getLabel('132055',"时长（小时）"):getLabel('132014',"时长（天）"),'\uFF1A ',data.count));}},{key:'onMonthSelect',value:function onMonthSelect(date){var hrmOldChecking=this.props.hrmOldChecking;var dateTabkey=hrmOldChecking.dateTabkey,pDate=hrmOldChecking.pDate;var select=new _moment2.default(date.time).format('YYYY-MM');if(pDate.slice(0,7)==select){hrmOldChecking.updateCalendarCheckedDay(date.getDayOfMonth());}}},{key:'onyearMonthSelect',value:function onyearMonthSelect(date){var hrmOldChecking=this.props.hrmOldChecking;var select=new _moment2.default(date.time).format('YYYY-MM');hrmOldChecking.changeDateHandler(select);hrmOldChecking.updateDateTabkey('2');this.getData();}},{key:'monthDateCellRender',value:function monthDateCellRender(date){var _this6=this;var hrmOldChecking=this.props.hrmOldChecking;var dateTabkey=hrmOldChecking.dateTabkey,pDate=hrmOldChecking.pDate,calendarData=hrmOldChecking.calendarData,statusActiveType=hrmOldChecking.statusActiveType;calendarData=toJS(calendarData);var select=new _moment2.default(date.time).format('YYYY-MM');if(pDate.slice(0,7)==select){var day=date.getDayOfMonth();var data=calendarData[day];if(data&&(data.types.indexOf(statusActiveType)>-1||statusActiveType=='ALL'||data.types.indexOf('NORMAL')>-1)){return _react2.default.createElement('div',{className:'calendar-item'},_react2.default.createElement('span',{className:'icon-wrapper'},data.types&&data.types.map(function(type,idx){if(idx>4)return;var ic=Util.getIconColor(type);if(type==statusActiveType||statusActiveType=='ALL'){return _react2.default.createElement('i',{className:''+ic.icon,style:{color:ic.color,marginRight:2},title:ic.name},_react2.default.createElement('span',{className:'path1'}),_react2.default.createElement('span',{className:'path2'}),_react2.default.createElement('span',{className:'path3'}),_react2.default.createElement('span',{className:'path4'}));}})),_react2.default.createElement('span',{className:'tip',style:{color:data.isWorkDay?'#FF1B10':'#1B9B12'}},data.tip),_react2.default.createElement(_ecCom.WeaNewScroll,{height:85},data.workflow&&data.workflow.map(function(item){if(item.workflowtype==statusActiveType||statusActiveType=='ALL'){var ic=Util.getIconColor(item.workflowtype);return _react2.default.createElement(_antd.Tooltip,{placement:'right',title:_this6.getTipText(item)},_react2.default.createElement('div',{className:'workflow-item',style:{backgroundColor:ic.bcolor}},_react2.default.createElement('div',{className:'text-overflow',dangerouslySetInnerHTML:{__html:item.title},style:{color:ic.color}})));}})));}}}},{key:'yearDateCellRender',value:function yearDateCellRender(date){var hrmOldChecking=this.props.hrmOldChecking;var dateTabkey=hrmOldChecking.dateTabkey,pDate=hrmOldChecking.pDate,yearData=hrmOldChecking.yearData,statusActiveType=hrmOldChecking.statusActiveType;yearData=toJS(yearData);var d=date.getDayOfMonth();var m=date.getMonth()+1;var data={},ic=undefined;if(yearData!==undefined&&!(0,_isEmpty2.default)(yearData)){data=yearData[m][d];try{if(data.type!=='NORMAL')ic=Util.getIconColor(data.type);}catch(e){return _react2.default.createElement('div',{className:'date-item'},d);}}var content=void 0;if(ic&&(statusActiveType==data.type||statusActiveType=='ALL')){content=_react2.default.createElement('span',null,_react2.default.createElement('i',{className:''+ic.icon,style:{color:ic.color}},_react2.default.createElement('span',{className:'path1'}),_react2.default.createElement('span',{className:'path2'}),_react2.default.createElement('span',{className:'path3'}),_react2.default.createElement('span',{className:'path4'})),data.tip&&_react2.default.createElement('span',{className:'tip',style:{color:data.isWorkDay?'#FF1B10':'#1B9B12'}},data.tip));}else{content=_react2.default.createElement('span',null,data.tip&&_react2.default.createElement('span',{className:'tip',style:{color:data.isWorkDay?'#FF1B10':'#1B9B12'}},data.tip),d);}return _react2.default.createElement('div',{className:'date-item'},content);}},{key:'renderCalendar',value:function renderCalendar(){var hrmOldChecking=this.props.hrmOldChecking;var dateTabkey=hrmOldChecking.dateTabkey,pDate=hrmOldChecking.pDate,pDate1=hrmOldChecking.pDate1;return _react2.default.createElement('div',{className:'calendar-wrapper'},dateTabkey=='2'&&_react2.default.createElement(_antd.Calendar,{mode:'month',dateCellRender:this.monthDateCellRender.bind(this),locale:this.getLocale(),onSelect:this.onMonthSelect.bind(this),value:new Date(pDate)}),dateTabkey=='1'&&_react2.default.createElement(_ecCom.WeaYear,{value:pDate1,dateCellRender:this.yearDateCellRender.bind(this),onMonthSelect:this.onyearMonthSelect.bind(this)}));}},{key:'onStsClick',value:function onStsClick(item){var hrmOldChecking=this.props.hrmOldChecking;if(parseFloat(item.value)>0){hrmOldChecking.updateStsType(item.type);hrmOldChecking.getTableData();hrmOldChecking.updateVisible(true);}else{var content=getLabel('386474',"本月没有{params}数据！").replace('{params}',item.title);_antd.Modal.warning({title:_i18n.i18n.confirm.defaultTitle(),content:content});}}},{key:'renderStatistics',value:function renderStatistics(){var _this7=this;var hrmOldChecking=this.props.hrmOldChecking;var iWidth=this.state.iWidth;var chartOptions=hrmOldChecking.chartOptions,groupitem2=hrmOldChecking.groupitem2,groupitem3=hrmOldChecking.groupitem3,groupitem4=hrmOldChecking.groupitem4,count=hrmOldChecking.count;chartOptions=toJS(chartOptions);groupitem4=toJS(groupitem4);groupitem3=toJS(groupitem3);groupitem2=toJS(groupitem2);return _react2.default.createElement('div',{style:{minWidth:860}},_react2.default.createElement(_antd.Row,{className:'statistics-wrapper'},_react2.default.createElement(_antd.Col,{span:8,className:'chart-wrapper'},_react2.default.createElement('div',{className:'chart-content'},_react2.default.createElement('div',{className:'statistics-title bb'},getLabel('16732',"出勤统计")),_react2.default.createElement('div',{className:'echart-item'},_react2.default.createElement(_ecCom.WeaEchart,{style:{height:160,width:160,display:'inline-block'},ref:'chart',option:chartOptions,useDefault:false})),_react2.default.createElement('div',{className:'echart-count'},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12,className:'number align-center cursor-pointer',style:{color:chartOptions.series[0].color[1]},onClick:function onClick(){return _this7.onStsClick(chartOptions.series[0].data[1]);}},!(0,_isEmpty2.default)(chartOptions.series[0].data)&&chartOptions.series[0].data[1].value,' '),_react2.default.createElement(_antd.Col,{span:12,className:'number align-center cursor-pointer',style:{color:chartOptions.series[0].color[0]},onClick:function onClick(){return _this7.onStsClick(chartOptions.series[0].data[0]);}},!(0,_isEmpty2.default)(chartOptions.series[0].data)&&chartOptions.series[0].data[0].value,' ')),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12,className:'align-center'},_react2.default.createElement('span',{className:'dot mr15',style:{backgroundColor:chartOptions.series[0].color[1]}}),_react2.default.createElement('span',{className:''},!(0,_isEmpty2.default)(chartOptions.series[0].data)&&chartOptions.series[0].data[1].name,'\uFF08',_i18n.i18n.label.day(),'\uFF09')),_react2.default.createElement(_antd.Col,{span:12,className:'align-center'},_react2.default.createElement('span',{className:'dot mr15',style:{backgroundColor:chartOptions.series[0].color[0]}}),_react2.default.createElement('span',{className:''},!(0,_isEmpty2.default)(chartOptions.series[0].data)&&chartOptions.series[0].data[0].name,'\uFF08',_i18n.i18n.label.day(),'\uFF09')))))),_react2.default.createElement(_antd.Col,{span:16,className:'abnormal-wrapper'},_react2.default.createElement('div',{className:'statistics-title bb'},getLabel('132057',"异常考勤汇总")),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:18,className:'left br',style:{paddingTop:iWidth>=1684?40:10}},groupitem2&&groupitem2.map(function(d){return _react2.default.createElement('div',{className:'item cursor-pointer',onClick:function onClick(){return _this7.onStsClick(d);}},_react2.default.createElement(_antd.Col,{span:8},_react2.default.createElement('div',{className:'icon-wrapper',style:{backgroundColor:d.color}},_react2.default.createElement('i',{className:d.icon}))),_react2.default.createElement(_antd.Col,{span:16,className:'message'},_react2.default.createElement('div',{className:'information'},d.value),_react2.default.createElement('div',null,d.title,d.type=="OVERTIME"?'('+_i18n.i18n.label.hour()+')':'('+_i18n.i18n.label.day()+')')));})),_react2.default.createElement(_antd.Col,{span:6,className:'right'},groupitem3&&groupitem3.map(function(d){return _react2.default.createElement(_antd.Row,{className:'cursor-pointer',onClick:function onClick(){return _this7.onStsClick(d);}},_react2.default.createElement(_antd.Col,{span:8,className:'information',style:{textAlign:'left',paddingLeft:'30px'}},d.value),_react2.default.createElement(_antd.Col,{span:16,style:{textAlign:'left',paddingLeft:'15px'}},d.title));}))))),_react2.default.createElement(_antd.Row,{gutter:36,className:'detail'},groupitem4&&groupitem4.map(function(d){return _react2.default.createElement(_antd.Col,{span:8,style:{marginBottom:20}},_react2.default.createElement(_antd.Row,{className:'detail-title',title:d.title},d.title),_react2.default.createElement('div',{className:'detail-body'},d.item.map(function(i){return _react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:20,title:i.title},i.title),_react2.default.createElement(_antd.Col,{span:4,title:i.value},i.value));})));})));}},{key:'getBtns',value:function getBtns(){var btns=[_react2.default.createElement(_antd.Button,{onClick:function onClick(){return console.log("more");}},_i18n.i18n.button.more())];return btns;}},{key:'render',value:function render(){var _this8=this;var hrmOldChecking=this.props.hrmOldChecking;var getStatusList=hrmOldChecking.getStatusList,statusActiveType=hrmOldChecking.statusActiveType,tabDatas=hrmOldChecking.tabDatas,tabkey=hrmOldChecking.tabkey,dateTabDatas=hrmOldChecking.dateTabDatas,dateTabkey=hrmOldChecking.dateTabkey,pDate=hrmOldChecking.pDate,hasRight=hrmOldChecking.hasRight,leftTitle=hrmOldChecking.leftTitle,hrmName=hrmOldChecking.hrmName,loading=hrmOldChecking.loading,newVisible=hrmOldChecking.newVisible,visible=hrmOldChecking.visible,table=hrmOldChecking.table;var newWorklist=hrmOldChecking.newWorklist;newWorklist=toJS(newWorklist);var statusList=getStatusList();var query=this.props.location.query;var getMsg=function getMsg(name){var content=getLabel('386475',"您无权查看 {params} 的考勤数据！").replace('{params}',name);return content;};return _react2.default.createElement('div',{className:'wea-hrm-checking'},_react2.default.createElement(_ecCom.WeaPopoverHrm,null),_react2.default.createElement(_ecCom.WeaDialog,{visible:visible,onCancel:function onCancel(){return hrmOldChecking.updateVisible(false);},closable:true,style:{width:900,height:window.innerHeight-250>500?500:window.innerHeight-250},title:getLabel('386477',"考勤明细"),icon:'icon-coms-hrm',iconBgcolor:'#217346',moreBtn:{datas:[]}},_react2.default.createElement(_ecCom.WeaNewScroll,{height:window.innerHeight-250>500?500:window.innerHeight-250,ref:'scrollBar'},_react2.default.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true,onOperatesClick:this.onOperatesClick.bind(this)}))),_react2.default.createElement(_ecCom.WeaDialog,{visible:newVisible,className:'new-hrm-workflow',onCancel:function onCancel(){return hrmOldChecking.updateNewVisible(false);},closable:true,style:{width:600,height:400},title:getLabel('385037',"新建考勤流程"),icon:'icon-portal-workflow',iconBgcolor:'#0079de'},_react2.default.createElement('div',{className:'new-hrm-workflow-body'},_react2.default.createElement('div',{className:'new-hrm-workflow-wrapper'},_react2.default.createElement('div',{className:'hearder'},_react2.default.createElement('i',{className:'icon-coms-hrm'}),getLabel('15882',"人事管理"),_react2.default.createElement('span',null,'('),newWorklist.length,_react2.default.createElement('span',null,')')),_react2.default.createElement(_ecCom.WeaNewScroll,{height:270},!(0,_isEmpty2.default)(newWorklist)&&newWorklist.map(function(item){return _react2.default.createElement('div',{className:'cursor-pointer item',onClick:function onClick(){hrmOldChecking.handlerNewWorkflow(item);}},item.title);}))))),_react2.default.createElement(_antd.Spin,{spining:loading},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu()},_react2.default.createElement('div',{style:query.fromcard?{display:'none'}:{display:''}},_react2.default.createElement(_ecCom.WeaTop,{title:''+(hrmName||'\''+getLabel('130758',"我")+'\'')+getLabel('125404',"的考勤"),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu()})),this.renderLeft(),_react2.default.createElement('div',{style:{width:'100%',paddingLeft:221}},_react2.default.createElement(_ecCom.WeaTab,{selectedKey:tabkey,keyParam:'key',datas:[{title:getLabel('16558',"考勤统计"),key:"1"},{title:getLabel('386476',"考勤日历"),key:"2"}],onChange:this.changeTab.bind(this)}),_react2.default.createElement('div',{className:'picker-wrapper checking icon-cls'},_react2.default.createElement('div',{style:{width:140,paddingLeft:10,display:'none'},className:'text-overflow',title:hrmName},leftTitle,'\xA0:\xA0\xA0',hrmName),[{title:_i18n.i18n.label.year(),key:"1"},{title:_i18n.i18n.label.month(),key:"2"}].map(function(item){return _react2.default.createElement('div',{span:1,onClick:_this8.changeDateTab.bind(_this8,item.key),className:'cursor-pointer date-item '+(item.key===dateTabkey?'active':'')},item.title);}),_react2.default.createElement(_ecCom.WeaDatePicker,{arrow:true,type:dateTabkey=='1'?'year':'month',date:pDate,onChange:this.changeDate.bind(this)}),_react2.default.createElement('span',{className:'icon-coms-Refresh cursor-pointer',style:{left:dateTabkey=='1'?96:120},onClick:this.reFresh.bind(this)}),tabkey=='2'&&_react2.default.createElement('div',{className:'status-info clearfix',style:{maxWidth:tabkey==2?window.innerWidth-700:window.innerWidth-900,float:'right'}},statusList&&statusList.map(function(item){return _react2.default.createElement('span',{className:'item cursor-pointer '+(item.type==statusActiveType?'active':''),style:{width:window.e9_locale.userLanguage===8&&60},onClick:function onClick(){return _this8.handlerStatusClick(item);},title:item.title},_react2.default.createElement('i',{className:''+item.icon,style:{color:item.color}},_react2.default.createElement('span',{className:'path1'}),_react2.default.createElement('span',{className:'path2'}),_react2.default.createElement('span',{className:'path3'}),_react2.default.createElement('span',{className:'path4'})),_react2.default.createElement('span',{className:'name',title:item.name,style:{width:window.e9_locale.userLanguage===8&&45}},item.name));}))),_react2.default.createElement(_ecCom.WeaNewScroll,{height:window.innerHeight-153-65,className:'bt'},!hasRight&&_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',null,getMsg(hrmName))),hasRight&&_react2.default.createElement('div',{className:'hrm-checking-content icon-cls'},tabkey=='1'&&this.renderStatistics(),tabkey=='2'&&this.renderCalendar()))))));}}]);return main;}(_react2.default.Component))||_class)||_class);//窗口大小变化
jQuery(window).resize(function(){if(__this){__this.setState({iWidth:window.innerWidth});}});exports.default=main;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(206);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(207),
    isMasked = __webpack_require__(307),
    isObject = __webpack_require__(54),
    toSource = __webpack_require__(210);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(95);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(308);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(40);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(82),
    isObjectLike = __webpack_require__(55);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(82),
    isLength = __webpack_require__(152),
    isObjectLike = __webpack_require__(55);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(156),
    arrayEach = __webpack_require__(211),
    assignValue = __webpack_require__(212),
    baseAssign = __webpack_require__(340),
    baseAssignIn = __webpack_require__(342),
    cloneBuffer = __webpack_require__(345),
    copyArray = __webpack_require__(346),
    copySymbols = __webpack_require__(347),
    copySymbolsIn = __webpack_require__(349),
    getAllKeys = __webpack_require__(220),
    getAllKeysIn = __webpack_require__(350),
    getTag = __webpack_require__(94),
    initCloneArray = __webpack_require__(351),
    initCloneByTag = __webpack_require__(352),
    initCloneObject = __webpack_require__(357),
    isArray = __webpack_require__(29),
    isBuffer = __webpack_require__(119),
    isMap = __webpack_require__(359),
    isObject = __webpack_require__(54),
    isSet = __webpack_require__(361),
    keys = __webpack_require__(97);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(121);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(121);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(121);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(121);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(120);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(120),
    Map = __webpack_require__(150),
    MapCache = __webpack_require__(158);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(328),
    ListCache = __webpack_require__(120),
    Map = __webpack_require__(150);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(329),
    hashDelete = __webpack_require__(330),
    hashGet = __webpack_require__(331),
    hashHas = __webpack_require__(332),
    hashSet = __webpack_require__(333);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(122);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(122);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(122);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(122);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(123);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(123);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(123);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(123);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(63);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(124),
    keys = __webpack_require__(97);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(124),
    keysIn = __webpack_require__(215);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54),
    isPrototype = __webpack_require__(117),
    nativeKeysIn = __webpack_require__(344);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(40);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 346 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(124),
    getSymbols = __webpack_require__(160);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(124),
    getSymbolsIn = __webpack_require__(217);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(221),
    getSymbolsIn = __webpack_require__(217),
    keysIn = __webpack_require__(215);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(161),
    cloneDataView = __webpack_require__(353),
    cloneRegExp = __webpack_require__(354),
    cloneSymbol = __webpack_require__(355),
    cloneTypedArray = __webpack_require__(356);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(161);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(95);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(161);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(358),
    getPrototype = __webpack_require__(219),
    isPrototype = __webpack_require__(117);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(360),
    baseUnary = __webpack_require__(154),
    nodeUtil = __webpack_require__(155);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(94),
    isObjectLike = __webpack_require__(55);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(362),
    baseUnary = __webpack_require__(154),
    nodeUtil = __webpack_require__(155);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(94),
    isObjectLike = __webpack_require__(55);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(40);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 365 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _comsMobx=__webpack_require__(10);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;window.openFullWindowForXtable=PublicFunc.openFullWindowForXtable;var WeaTable=_comsMobx.WeaTableNew.WeaTable;var _this=void 0;var BirthdayInfo=(_dec=(0,_mobxReact.inject)('hrmBirthdayInfo'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(BirthdayInfo,_React$Component);function BirthdayInfo(props){(0,_classCallCheck3.default)(this,BirthdayInfo);var _this2=(0,_possibleConstructorReturn3.default)(this,(BirthdayInfo.__proto__||(0,_getPrototypeOf2.default)(BirthdayInfo)).call(this,props));_this=_this2;var funcs=['jumpToHrmCard'];funcs.forEach(function(f){return _this2[f]=_this2[f].bind(_this2);});return _this2;}(0,_createClass3.default)(BirthdayInfo,[{key:'componentDidMount',value:function componentDidMount(){var hrmBirthdayInfo=this.props.hrmBirthdayInfo;hrmBirthdayInfo.getHasRight();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location.key!==nextProps.location.key){var hrmBirthdayInfo=this.props.hrmBirthdayInfo;hrmBirthdayInfo.getHasRight();}}},{key:'render',value:function render(){var _this3=this;var hrmBirthdayInfo=this.props.hrmBirthdayInfo;var title=hrmBirthdayInfo.title,form=hrmBirthdayInfo.form,table=hrmBirthdayInfo.table,showSearchAd=hrmBirthdayInfo.showSearchAd,searchParamsAd=hrmBirthdayInfo.searchParamsAd,verified=hrmBirthdayInfo.verified,hasRight=hrmBirthdayInfo.hasRight;if(verified&&hasRight){var formParams=form.getFormParams();return _react2.default.createElement('div',{className:'wea-myhrm-Online'},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},_react2.default.createElement(_ecCom.WeaTop,{title:title(),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:[],buttonSpace:10,showDropIcon:false},_react2.default.createElement(_ecCom.WeaTab,{buttonsAd:this.getTabButtonsAd(),searchType:['base','advanced'],searchsBaseValue:formParams.lastname,setShowSearchAd:function setShowSearchAd(bool){hrmBirthdayInfo.setShowSearchAd(bool);},hideSearchAd:function hideSearchAd(){return hrmBirthdayInfo.setShowSearchAd(false);},searchsAd:_react2.default.createElement(_antd.Form,{horizontal:true},this.getSearchs()),showSearchAd:showSearchAd,onSearch:function onSearch(v){hrmBirthdayInfo.doSearch();},onSearchChange:function onSearchChange(v){form.updateFields({lastname:{name:'lastname',value:v}});}}),_react2.default.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true,getColumns:function getColumns(c){return _this3.reRenderColumns(c);}}))));}if(verified&&!hasRight){return _react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},_i18n.i18n.message.authFailed()));}return _react2.default.createElement('div',null);}},{key:'getSearchs',value:function getSearchs(){var hrmBirthdayInfo=this.props.hrmBirthdayInfo;var form=hrmBirthdayInfo.form,condition=hrmBirthdayInfo.condition;var isFormInit=form.isFormInit;var group=[];var monthOptions=hrmBirthdayInfo.getMonth();var dayOptions=hrmBirthdayInfo.getDay();var formParams=form.getFormParams();var month=new _moment2.default().format('MM');isFormInit&&toJS(condition).map(function(c){var items=[];c.items.map(function(fields){var hide=false;var dom=void 0;if(fields.domkey[0]=='bDate'){hide=true;}if(fields.domkey[0]=='bMonth'){dom=_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:10,style:{'margin-right':'5px'}},_react2.default.createElement(_ecCom.WeaSelect,{options:monthOptions,value:formParams.bMonth||month,onChange:function onChange(v){form.updateFields({bMonth:{name:'bMonth',value:v}});}})),_react2.default.createElement(_antd.Col,{span:10},_react2.default.createElement(_ecCom.WeaSelect,{options:dayOptions,value:formParams.bDate||'',onChange:function onChange(v){form.updateFields({bDate:{name:'bDate',value:v}});}})));}else{dom=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:fields,form:form,formParams:formParams});}items.push({com:_react2.default.createElement(_ecCom.WeaFormItem,{label:''+fields.label,labelCol:{span:''+fields.labelcol},wrapperCol:{span:''+fields.fieldcol}},dom),colSpan:1,hide:hide});});group.push(_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:c.title,showGroup:c.defaultshow,items:items}));});return group;}},{key:'reRenderColumns',value:function reRenderColumns(columns){columns.forEach(function(c){if(c.dataIndex=='lastname'){c.render=function(text,record){return _react2.default.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:_this.jumpToHrmCard.bind(null,record.id)},record.lastname);};}else{c.render=function(text,record){var valueSpan=record[c.dataIndex+"span"]!==undefined?record[c.dataIndex+"span"]:record[c.dataIndex];return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:valueSpan}});};}});return columns;}},{key:'jumpToHrmCard',value:function jumpToHrmCard(hrmId){PublicFunc.jumpToHrmCard(hrmId);}},{key:'getRightMenu',value:function getRightMenu(){var keys=this.getSelectedRowKeys();var arr=[{icon:_react2.default.createElement('i',{className:'icon-coms-ws'}),content:_i18n.i18n.button.search()},{icon:_react2.default.createElement('i',{className:'icon-coms-task-list'}),content:_i18n.i18n.button.columnVisibleSetting()}];return arr;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmBirthdayInfo=this.props.hrmBirthdayInfo;switch(key){case'0':hrmBirthdayInfo.doSearch();break;case'1':this.definedColumn();break;}}},{key:'getSelectedRowKeys',value:function getSelectedRowKeys(){var hrmBirthdayInfo=this.props.hrmBirthdayInfo;var table=hrmBirthdayInfo.table;var selectedRowKeys=table.selectedRowKeys;return selectedRowKeys;}},{key:'definedColumn',value:function definedColumn(){var hrmBirthdayInfo=this.props.hrmBirthdayInfo;var table=hrmBirthdayInfo.table;table.setColSetVisible(true);table.tableColSet(true);}},{key:'getTabButtonsAd',value:function getTabButtonsAd(){var hrmBirthdayInfo=this.props.hrmBirthdayInfo;var form=hrmBirthdayInfo.form,searchParamsAd=hrmBirthdayInfo.searchParamsAd;return[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmBirthdayInfo.doSearch();hrmBirthdayInfo.setShowSearchAd(false);}},_i18n.i18n.button.search()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){form.reset();form.updateFields({bMonth:{value:new _moment2.default().format('MM')}});}},_i18n.i18n.button.reset()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){hrmBirthdayInfo.setShowSearchAd(false);}},_i18n.i18n.button.cancel())];}}]);return BirthdayInfo;}(_react2.default.Component))||_class)||_class);exports.default=BirthdayInfo;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _comsMobx=__webpack_require__(10);var _i18n=__webpack_require__(11);__webpack_require__(368);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var toJS=mobx.toJS;var WeaTable=_comsMobx.WeaTableNew.WeaTable;var confirm=_antd.Modal.confirm;var FormItem=_antd.Form.Item;;var Group=(_dec=(0,_mobxReact.inject)('hrmGroup'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Group,_React$Component);function Group(props){(0,_classCallCheck3.default)(this,Group);return(0,_possibleConstructorReturn3.default)(this,(Group.__proto__||(0,_getPrototypeOf2.default)(Group)).call(this,props));}(0,_createClass3.default)(Group,[{key:'componentWillMount',value:function componentWillMount(){var hrmGroup=this.props.hrmGroup;var form1=hrmGroup.form1;var bool=window.location.href.indexOf("/spa/hrm/index_mobx.html")>-1;if(bool){document.title=getLabel(81554,'常用组');hrmGroup.setWeaTopStatus(true);}form1.reset();}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmGroup=this.props.hrmGroup;var form1=hrmGroup.form1;if(this.props.location.key!==nextProps.location.key){form1.reset();this.init();}}},{key:'init',value:function init(){var hrmGroup=this.props.hrmGroup;hrmGroup.getPanelForm('1');hrmGroup.getTableInfo('1');hrmGroup.hasSuggestHint();}},{key:'getPanelComponents',value:function getPanelComponents(condition,form,arg){var arr=[];var formParams=form.getFormParams();var isFormInit=form.isFormInit;isFormInit&&condition.map(function(c){c.items.map(function(field,index){arr.push(_react2.default.createElement(_antd.Col,{span:10,offset:1},_react2.default.createElement('div',{style:{marginTop:20}},_react2.default.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:formParams})))));});});return _react2.default.createElement('div',{className:'hrm-group-datepicker'},_react2.default.createElement(_antd.Row,null,arr));}},{key:'getNewAndShareComponents',value:function getNewAndShareComponents(condition,form,isLinkage){var _this3=this;var arr=[];var formParams=form.getFormParams();var isFormInit=form.isFormInit;isFormInit&&condition.map(function(c){var items=c.items;for(var i=0;i<items.length;i++){var field=items[i];var dom=void 0;if(isLinkage&&_this3.fieldFilter(field))continue;if(isLinkage){dom=_this3.getShareDom(field,form,formParams);}else{dom=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:formParams});}arr.push(_react2.default.createElement('div',{style:{marginTop:15},className:'hrm-group-browser'},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:18,offset:3},_react2.default.createElement(_ecCom.WeaFormItem,{label:field.domkey[0]!=='alllevel'&&field.domkey[0]!=='rolelevel'?''+field.label:'',labelCol:{span:7},wrapperCol:{span:14},error:form.getError(field),tipPosition:'bottom',colon:field.domkey[0]!=='alllevel'&&field.domkey[0]!=='rolelevel'?true:false},dom)))));}});return _react2.default.createElement('div',{style:{padding:'25px 0 40px 0',position:'relative'}},arr);}},{key:'fieldFilter',value:function fieldFilter(field){var hrmGroup=this.props.hrmGroup;var form6=hrmGroup.form6;var sharetype=void 0;var jobtitlelevel=void 0;var formParams=form6.getFormParams();if(formParams.sharetype)sharetype=formParams.sharetype;if(formParams.jobtitlelevel)jobtitlelevel=formParams.jobtitlelevel;var domkey=field.domkey[0];if(sharetype=='1'&&(domkey=='sbid'||domkey=='did'||domkey=='rid'||domkey=='rolelevel'||domkey=='jobtitle'||domkey=='jobtitlelevel'||domkey=='seclevel'||domkey=='jobtitledepartment'||domkey=='jobtitlesubcompany'||domkey=='customid'||domkey=='alllevel'))return true;if(sharetype=='2'&&(domkey=='rsid'||domkey=='did'||domkey=='rid'||domkey=='rolelevel'||domkey=='jobtitle'||domkey=='jobtitlelevel'||domkey=='jobtitledepartment'||domkey=='jobtitlesubcompany'||domkey=='customid'))return true;if(sharetype=='3'&&(domkey=='rsid'||domkey=='sbid'||domkey=='rid'||domkey=='rolelevel'||domkey=='jobtitle'||domkey=='jobtitlelevel'||domkey=='jobtitledepartment'||domkey=='jobtitlesubcompany'||domkey=='customid'))return true;if(sharetype=='4'&&(domkey=='rsid'||domkey=='sbid'||domkey=='did'||domkey=='jobtitle'||domkey=='jobtitlelevel'||domkey=='jobtitledepartment'||domkey=='jobtitlesubcompany'||domkey=='customid'||domkey=='alllevel'))return true;if(sharetype=='7'&&(jobtitlelevel=='0'||!jobtitlelevel)&&(domkey=='rsid'||domkey=='sbid'||domkey=='did'||domkey=='rid'||domkey=='rolelevel'||domkey=='seclevel'||domkey=='jobtitledepartment'||domkey=='jobtitlesubcompany'||domkey=='customid'||domkey=='alllevel'))return true;if(sharetype=='7'&&jobtitlelevel=='1'&&(domkey=='rsid'||domkey=='sbid'||domkey=='did'||domkey=='rid'||domkey=='rolelevel'||domkey=='seclevel'||domkey=='jobtitlesubcompany'||domkey=='customid'||domkey=='alllevel'))return true;if(sharetype=='7'&&jobtitlelevel=='2'&&(domkey=='rsid'||domkey=='sbid'||domkey=='did'||domkey=='rid'||domkey=='rolelevel'||domkey=='seclevel'||domkey=='jobtitledepartment'||domkey=='customid'||domkey=='alllevel'))return true;if(sharetype=='8'&&(domkey=='sbid'||domkey=='rsid'||domkey=='did'||domkey=='rid'||domkey=='rolelevel'||domkey=='jobtitle'||domkey=='jobtitlelevel'||domkey=='jobtitledepartment'||domkey=='jobtitlesubcompany'||domkey=='alllevel'))return true;if(sharetype=='5'&&(domkey=='sbid'||domkey=='rsid'||domkey=='did'||domkey=='rid'||domkey=='rolelevel'||domkey=='jobtitle'||domkey=='jobtitlelevel'||domkey=='jobtitledepartment'||domkey=='jobtitlesubcompany'||domkey=='customid'||domkey=='alllevel'))return true;}},{key:'getShareDom',value:function getShareDom(field,form,formParams){var hrmGroup=this.props.hrmGroup;var checkBoxVal=hrmGroup.checkBoxVal,selectvalue=hrmGroup.selectvalue,scopeValue=hrmGroup.scopeValue;var dom=void 0;var options=[{key:'1',selected:true,showname:getLabel('27511',"部门")},{key:'2',showname:getLabel('33553',"分部")},{key:'3',showname:getLabel('140',"总部")}];if(field.domkey[0]=='alllevel'){dom=_react2.default.createElement('div',{style:{position:'absolute',top:-88,right:-90},className:'hrm-group-wcb'},_react2.default.createElement(_ecCom.WeaCheckbox,{value:checkBoxVal,onChange:function onChange(val){return hrmGroup.setCheckBoxVal(val);}}),_react2.default.createElement('span',{style:{marginLeft:10}},getLabel('125963',"含下级")));}else if(field.domkey[0]=='rolelevel'){dom=_react2.default.createElement('div',{style:{position:'absolute',top:-95,right:-125}},_react2.default.createElement('span',{style:{float:'left',marginTop:6}},_i18n.i18n.label.level()),_react2.default.createElement('div',{style:{float:'left'}},_react2.default.createElement(_ecCom.WeaSelect,{value:selectvalue,options:options,onChange:function onChange(val){return hrmGroup.setSelectValue(val);}})));}else if(field.domkey[0]=='seclevel'){dom=_react2.default.createElement(_ecCom.WeaScope,{isMobx:true,viewAttr:3,value:scopeValue,onChange:function onChange(val){return hrmGroup.setScopeValue(val);}});}else{dom=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:formParams});}return dom;}},{key:'getImportComponents',value:function getImportComponents(condition,form,arg){var _this4=this;var _arr=[];var isFormInit=form.isFormInit;isFormInit&&condition.map(function(c){var arr=[];c.items.map(function(field,index){if(field.domkey){var dom=_this4.getDOM(field,arg);arr.push({com:_react2.default.createElement('div',{className:'hrm-group-import  hrm-group-import-item'},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:2,offset:4},_react2.default.createElement('div',{className:'hrm-group-box'},_react2.default.createElement('div',{className:'hrm-group-circle hrm-group-radius',style:{marginTop:20}},index+1))),_react2.default.createElement(_antd.Col,{span:14},_react2.default.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:arg=='2'&&index==2?{span:24-(''+field.labelcol)}:{span:''+field.fieldcol},style:{margin:'5px 0'}},dom,field.domkey[0]=='importlx'&&_this4.getImportTypeValue()?_react2.default.createElement('div',{style:{position:'absolute',top:0,right:-145,color:'#4D7AD8'}},getLabel('131396',"覆盖时将替换原人员列表")):'')))),colSpan:1});}if(!field.domkey){var _dom=_this4.getParagraph(field,arg);arr.push({com:_react2.default.createElement('div',{style:{marginTop:15}},_dom),colSpan:1});}});_arr.push(_react2.default.createElement('div',{style:{color:'#666666',position:'relative'}},_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:c.title,showGroup:c.defaultshow,items:arr,col:1,fontSize:13})));});return _arr;}},{key:'getDOM',value:function getDOM(field,arg){var _this5=this;var hrmGroup=this.props.hrmGroup;var excelfile=hrmGroup.excelfile,list=hrmGroup.list,upStatus=hrmGroup.upStatus,form4=hrmGroup.form4,form5=hrmGroup.form5;var dom=void 0;var form=void 0;if(arg=='1')form=form4;if(arg=='2')form=form5;var formParams=form.getFormParams();if(field.domkey[0]=='templet'){var link=void 0;var arr=field.value.split(';');if(formParams.keyField=='workcode')link=arr[0];if(formParams.keyField=='loginid')link=arr[1];if(formParams.keyField=='lastname')link=arr[2];dom=_react2.default.createElement('a',{href:link,className:'hrm-group-linkStyle'},getLabel('386488',"常用组信息导入模板"));}else if(field.domkey[0]=='excelfile'){dom=_react2.default.createElement('div',null,_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaUpload,{uploadUrl:'/api/doc/upload/uploadFile',category:'string',limitType:'xls',datas:upStatus==='uploaded'?list:[],onChange:function onChange(id,l){hrmGroup.setExcelfile(id[0]);hrmGroup.setList(l);hrmGroup.updateFormFields((parseInt(arg)+2).toString(),id[0]);},onUploading:function onUploading(s){return _this5.onUploading(s);}},_react2.default.createElement(_antd.Button,null,getLabel('125333',"选择文件")))),_react2.default.createElement('div',{style:{marginTop:-30,marginLeft:90}},list.length==0?_react2.default.createElement('p',null,getLabel('384040',"未选择任何文件")):list.map(function(file){return _react2.default.createElement('p',null,file.filename);})));}else{dom=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:formParams});}return dom;}},{key:'getImportTypeValue',value:function getImportTypeValue(){var hrmGroup=this.props.hrmGroup;var form5=hrmGroup.form5;var formParams=form5.getFormParams();if(formParams.importlx=='update'){return true;}else{return false;}}},{key:'getParagraph',value:function getParagraph(field,arg){var hrmGroup=this.props.hrmGroup;var form4=hrmGroup.form4,form5=hrmGroup.form5;var dom=void 0;var form=void 0;if(arg=='1')form=form4;if(arg=='2')form=form5;var formParams=form.getFormParams();if(field.index=='1'){var link=void 0;var arr=void 0;if(field.link){arr=field.link.split(';');if(formParams.keyField=='workcode')link=arr[0];if(formParams.keyField=='loginid')link=arr[1];}dom=_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:2,offset:4},_react2.default.createElement('div',{className:'hrm-group-box'},_react2.default.createElement('div',{className:'hrm-group-circle hrm-group-radius'},field.index))),_react2.default.createElement(_antd.Col,{span:14},arg=='1'?_react2.default.createElement('p',null,_react2.default.createElement('span',null,field.value+': '),_react2.default.createElement('a',{href:link,className:'hrm-group-linkStyle'},getLabel('386488',"常用组信息导入模板"))):_react2.default.createElement('p',null,field.value)));}else{dom=_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:2,offset:4},_react2.default.createElement('div',{className:'hrm-group-box'},_react2.default.createElement('div',{className:'hrm-group-circle hrm-group-radius'},field.index))),_react2.default.createElement(_antd.Col,{span:14},_react2.default.createElement('p',null,field.value)));}return dom;}},{key:'onUploading',value:function onUploading(s){var hrmGroup=this.props.hrmGroup;var list=hrmGroup.list;hrmGroup.setUpStatus(s);if(s=='uploading'){hrmGroup.setList([]);}else{hrmGroup.setList(list);}}},{key:'getSuggestIcon',value:function getSuggestIcon(arg){var hrmGroup=this.props.hrmGroup;var hasTrumpet=hrmGroup.hasTrumpet,hasHint=hrmGroup.hasHint;if(arg!=='1'){return false;}return _react2.default.createElement('i',{style:{position:'absolute',right:'95%',top:5}},hasTrumpet?_react2.default.createElement('img',{src:'/hrm/hrm_e9/image/u30775.png',alt:'',onClick:function onClick(){return hrmGroup.setSuggestDialogStatus(true);},style:{cursor:'pointer'}}):'',hasHint?_react2.default.createElement('img',{src:'/hrm/hrm_e9/image/u30777.png',alt:'',style:{cursor:'pointer',position:'absolute',left:15,top:8}}):'');}},{key:'getImportIcon',value:function getImportIcon(arg){var _this6=this;if(arg=='3'||arg=='4'){return false;}return _react2.default.createElement('i',{className:'icon-coms-download2 hrm-group-clickicon',title:_i18n.i18n.button.import(),onClick:function onClick(){return _this6.handleImportClick(arg);}});}},{key:'getAddIcon',value:function getAddIcon(arg){var hrmGroup=this.props.hrmGroup;if(arg=='1'||arg=='3'){return _react2.default.createElement('i',{className:'icon-coms-plus hrm-group-clickicon',title:_i18n.i18n.button.create(),onClick:function onClick(){arg=='3'?hrmGroup.getForm((parseInt(arg)+2).toString()):hrmGroup.getForm(arg);}});}if(arg=='2'){return _react2.default.createElement('div',{style:{display:'inline'}},_react2.default.createElement(_ecCom.WeaBrowser,{ref:'weabrowser',type:17,title:getLabel('30042',"人员"),customized:true,hasAdvanceSerach:true,isSingle:false,onChange:function onChange(){hrmGroup.setMemberId(arguments.length<=0?undefined:arguments[0]);hrmGroup.save('3');}},_react2.default.createElement('i',{style:{backgroundColor:'#34A2FF',padding:4,color:'#FFFFFF'},className:'icon-coms-plus',title:_i18n.i18n.button.add()})));}}},{key:'getBatchDeleteIcon',value:function getBatchDeleteIcon(arg){var _this7=this;var hrmGroup=this.props.hrmGroup;if(arg=='4'){return false;}var len=void 0;if(arg=='1')len=hrmGroup.tableStore1.selectedRowKeys.length;if(arg=='2')len=hrmGroup.tableStore2.selectedRowKeys.length;if(arg=='3')len=hrmGroup.tableStore3.selectedRowKeys.length;return _react2.default.createElement('i',{style:len>0?{marginRight:16,backgroundColor:'#34A2FF'}:{marginRight:16,backgroundColor:'#D9D9D9'},className:'icon-coms-Loss hrm-group-clickicon',title:_i18n.i18n.button.multiDelete(),onClick:function onClick(){return len>0&&_this7.handleBatchDelete(arg);}});}},{key:'getAuthorityIcon',value:function getAuthorityIcon(){return _react2.default.createElement('div',{style:{paddingTop:200,textAlign:'center',color:'#666'}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:10,offset:7},_react2.default.createElement('img',{src:'/hrm/hrm_e9/image/noauthority.png',alt:''}))),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:10,offset:7},_react2.default.createElement('p',null,_i18n.i18n.message.authFailed()))));}},{key:'handleImportClick',value:function handleImportClick(arg){var hrmGroup=this.props.hrmGroup;if(arg=='1'){hrmGroup.getForm('3');}if(arg=='2'){hrmGroup.getForm('4');}}},{key:'handleBatchDelete',value:function handleBatchDelete(arg){var hrmGroup=this.props.hrmGroup;var tableStore1=hrmGroup.tableStore1,tableStore2=hrmGroup.tableStore2,tableStore3=hrmGroup.tableStore3;var store=void 0;if(arg=='1')store=tableStore1;if(arg=='2')store=tableStore2;if(arg=='3')store=tableStore3;var srk=this.getSelectedRow(toJS(store));this.doDel(srk,arg);}},{key:'getSelectedRow',value:function getSelectedRow(store){return store.selectedRowKeys;}},{key:'handleSearch',value:function handleSearch(arg){var hrmGroup=this.props.hrmGroup;if(arg=='1'){hrmGroup.getTableInfo('1');hrmGroup.setPanelOneStatus(false);}if(arg=='2'){hrmGroup.getTableInfo('2');hrmGroup.setPanelTwoStatus(false);}if(arg=='3'){hrmGroup.getTableInfo('7');hrmGroup.setPanelThreeStatus(false);}}},{key:'handleSubmit',value:function handleSubmit(arg){var hrmGroup=this.props.hrmGroup;var excelfile=hrmGroup.excelfile;if(excelfile==''){_antd.message.warning(_i18n.i18n.message.pleaseUploadFile());return false;}if(arg=='1'){hrmGroup.setImportInfoDialogStatus(true);hrmGroup.save('5');}if(arg=='2'){hrmGroup.setImportMemInfoDialogStatus(true);hrmGroup.save('6');}}},{key:'handleImportHistory',value:function handleImportHistory(){var hrmGroup=this.props.hrmGroup;hrmGroup.setImportHistoryDialogStatus(true);hrmGroup.getTableInfo('5');}},{key:'handleOneDropMenuClick',value:function handleOneDropMenuClick(key){var hrmGroup=this.props.hrmGroup;if(key=='0')this.handleImportClick('1');if(key=='1')hrmGroup.getForm('1');if(key=='2')this.handleBatchDelete('1');}},{key:'handleTwoDropMenuClick',value:function handleTwoDropMenuClick(key){var hrmGroup=this.props.hrmGroup;if(key=='3')hrmGroup.save('1');if(key=='4')hrmGroup.save('2');}},{key:'handleThreeDropMenuClick',value:function handleThreeDropMenuClick(key){var hrmGroup=this.props.hrmGroup;if(key=='5')this.handleSubmit('1');if(key=='6')this.handleImportHistory();}},{key:'handleFourDropMenuClick',value:function handleFourDropMenuClick(key){var hrmGroup=this.props.hrmGroup;if(key=='5')this.handleSubmit('2');if(key=='7'){};}},{key:'handleFiveDropMenuClick',value:function handleFiveDropMenuClick(key){var hrmGroup=this.props.hrmGroup;if(key=='3')hrmGroup.save('4');if(key=='7'){};}},{key:'handleSixDropMenuClick',value:function handleSixDropMenuClick(key){var hrmGroup=this.props.hrmGroup;hrmGroup.setSuggestDialogStatus(false);}},{key:'handleSevenDropMenuClick',value:function handleSevenDropMenuClick(key){var hrmGroup=this.props.hrmGroup;if(key=='0')this.handleImportClick('2');if(key=='1')this.refs.weabrowser.openModal();if(key=='2')this.handleBatchDelete('2');}},{key:'handleEightDropMenuClick',value:function handleEightDropMenuClick(key){var hrmGroup=this.props.hrmGroup;if(key=='1')hrmGroup.getForm('5');if(key=='2')this.handleBatchDelete('3');}},{key:'handleNineDropMenuClick',value:function handleNineDropMenuClick(key){var hrmGroup=this.props.hrmGroup;if(key=='3')hrmGroup.save('9');if(key=='7'){};}},{key:'handleDropMenuClick',value:function handleDropMenuClick(key){var hrmGroup=this.props.hrmGroup;var editTabKey=hrmGroup.editTabKey;if(editTabKey=='0')this.handleNineDropMenuClick(key);if(editTabKey=='1')this.handleSevenDropMenuClick(key);if(editTabKey=='2')this.handleEightDropMenuClick(key);}},{key:'getTable',value:function getTable(params){var _this8=this;var tableStore=params.tableStore;var loading=params.loading;var title=params.title;var customComponent=params.customComponent;var isNeedScroll=params.isNeedScroll;var isNeedRerender=params.isNeedRerender;var tag=params.tag;var height=params.height;var isNeedSearchGroup=params.isNeedSearchGroup;if(isNeedSearchGroup){if(isNeedScroll){return _react2.default.createElement('div',{className:'hrm-group-table hrm-group-form'},_react2.default.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,needScroll:isNeedScroll,getColumns:function getColumns(c){return _this8.reRenderColumns(c,isNeedRerender);},onOperatesClick:function onOperatesClick(record,index,operate){return _this8.onOperatesClick(record,index,operate,tag);}}));}else{return _react2.default.createElement('div',{className:'hrm-group-table hrm-group-form'},_react2.default.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,scroll:{y:height-130},getColumns:function getColumns(c){return _this8.reRenderColumns(c,isNeedRerender);},onOperatesClick:function onOperatesClick(record,index,operate){return _this8.onOperatesClick(record,index,operate,tag);}}));}}else{return _react2.default.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,scroll:{y:height-130},getColumns:function getColumns(c){return _this8.reRenderColumns(c,isNeedRerender);},onOperatesClick:function onOperatesClick(record,index,operate){return _this8.onOperatesClick(record,index,operate,tag);}});}}},{key:'getAntTable',value:function getAntTable(params,isWrapBySearchgroup){var _this9=this;var col=params.col;var ds=params.ds;var loading=params.loading;var isPagination=params.isPagination;var action=params.action;var num=params.num;var height=void 0;if(isWrapBySearchgroup){height=params.height-85;}else{height=params.height-48;}if(col.length>0&&!this.isEmptyObject(action)){col[num].render=function(text,record){return _react2.default.createElement('span',null,_react2.default.createElement('a',{href:'/api/hrm/group/getImportHistoryFile?filename='+_this9.getNumFromString(record.fileName)},action.download),_react2.default.createElement('span',{className:'ant-divider'}),_react2.default.createElement('a',{onClick:function onClick(){return _this9.delImportHistory(record);}},action.delete));};return _react2.default.createElement('div',{className:'hrm-group-antTable'},_react2.default.createElement(_antd.Table,{columns:col,dataSource:ds,loading:loading,pagination:isPagination,scroll:{y:height}}));}return _react2.default.createElement('div',{className:'hrm-group-antable'},_react2.default.createElement(_antd.Table,{columns:col,dataSource:ds,loading:loading,pagination:isPagination,scroll:{y:height}}));}},{key:'delImportHistory',value:function delImportHistory(record){var hrmGroup=this.props.hrmGroup;var dataSource=hrmGroup.dataSource;var num=this.getNumFromString(record.fileName);hrmGroup.setDelFileNum(num);var index=this.getRowIndex(record.key,toJS(dataSource));this.showConfirm('4',[],index);}},{key:'getNumFromString',value:function getNumFromString(str){return str.replace(/[^0-9]+/g,'');}},{key:'getRowIndex',value:function getRowIndex(key,dataSource){var arr=[];if(dataSource instanceof Array){for(var i=0;i<dataSource.length;i++){arr.push(dataSource[i].key);}}return arr.indexOf(key);}},{key:'reRenderColumns',value:function reRenderColumns(columns,isNeedRerender){var hrmGroup=this.props.hrmGroup;var _this=this;if(isNeedRerender){columns.forEach(function(c,index){var obj={};if(c.dataIndex=='name'){c.render=function(text,record){var rowData=toJS(record);var id=void 0;if(rowData.id)id=rowData.id;if(rowData.groupid)id=rowData.groupid;return _react2.default.createElement('a',{onClick:function onClick(){return _this.rowDataClick(id);}},rowData.name);};}else if(c.dataIndex=='result'){c.render=function(text,record){var rowData=toJS(record);return _react2.default.createElement('a',{onClick:function onClick(){hrmGroup.setGroupId(rowData.id);hrmGroup.getForm('2');hrmGroup.tabClick('1');},dangerouslySetInnerHTML:{__html:record.resultspan}});};}else if(c.dataIndex=='dsporder'){c.render=function(text,record){var rowData=toJS(record);if(rowData.dsporder<0){rowData.dsporder=1;}return _react2.default.createElement(_ecCom.WeaInput,{value:rowData.dsporder,onBlur:function onBlur(val){return hrmGroup.setDsporderArr(val,rowData);}});};}else{c.render=function(text,record){var valueSpan=record[c.dataIndex+"span"]!==undefined?record[c.dataIndex+"span"]:record[c.dataIndex];return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:valueSpan}});};}});}return columns;}},{key:'rowDataClick',value:function rowDataClick(id){var hrmGroup=this.props.hrmGroup;hrmGroup.setGroupId(id);hrmGroup.getForm('2');hrmGroup.tabClick('0');}},{key:'onOperatesClick',value:function onOperatesClick(record,index,operate,tag){var hrmGroup=this.props.hrmGroup;var funcIndex=operate.index;if(tag=='base'){hrmGroup.setGroupId(record.id);if(funcIndex=='0')hrmGroup.tabClick('0');if(funcIndex=='1')hrmGroup.tabClick('1');if(funcIndex=='2')hrmGroup.tabClick('2');if(funcIndex=='0'||funcIndex=='1'||funcIndex=='2'){hrmGroup.getForm('2');}if(funcIndex=='3')this.doDel([],'1');}if(tag=='member'){hrmGroup.setMemberId(record.id);if(funcIndex=='0')this.doDel([],'2');}if(tag=='share'){hrmGroup.setTypeId(record.id);hrmGroup.getTableInfo('3');if(funcIndex=='0')this.doDel([],'3');}if(tag=='suggest'){hrmGroup.setSuggestId(record.randomFieldId);if(funcIndex=='0'){hrmGroup.save('7');}if(funcIndex=='1'){hrmGroup.delete('5');}if(funcIndex=='2'){hrmGroup.save('8');}}}},{key:'doDel',value:function doDel(arr,arg){var hrmGroup=this.props.hrmGroup;if(arg=='1'){this.showConfirm('1',arr);}if(arg=='2'){this.showConfirm('2',arr);}if(arg=='3'){this.showConfirm('3',arr);}}},{key:'getCustomComponent',value:function getCustomComponent(arg){var hrmGroup=this.props.hrmGroup;return[this.getSuggestIcon(arg),this.getImportIcon(arg),this.getAddIcon(arg),this.getBatchDeleteIcon(arg)];}},{key:'showConfirm',value:function showConfirm(arg,arr,index){var _this=this;confirm({title:_i18n.i18n.confirm.defaultTitle(),content:arr.length==0?_i18n.i18n.confirm.delete():_i18n.i18n.confirm.batchDeleteConfirm(),okText:_i18n.i18n.button.ok(),cancelText:_i18n.i18n.button.cancel(),onOk:function onOk(){_this.ok(arg,arr,index);},onCancel:function onCancel(){return false;}});}},{key:'ok',value:function ok(arg,arr,index){var hrmGroup=this.props.hrmGroup;var dataSource=hrmGroup.dataSource;if(arr.length!==0){for(var i=0;i<arr.length;i++){if(arg=='1')hrmGroup.setGroupId(arr[i]);if(arg=='2')hrmGroup.setMemberId(arr[i]);if(arg=='3')hrmGroup.setTypeId(arr[i]);hrmGroup.delete(arg,'batch');if(i==arr.length-1)hrmGroup.delete(arg,'batch','last');}}else{if(arg=='4')dataSource.splice(index,1);hrmGroup.delete(arg);}}},{key:'isEmptyObject',value:function isEmptyObject(obj){for(var key in obj){return false;}return true;}},{key:'getGroupSettingBtns',value:function getGroupSettingBtns(key){var btns=void 0;if(key=='0'){btns=[];}else if(key=='1'){btns=this.getCustomComponent('2');}else if(key=='2'){btns=this.getCustomComponent('3');}return btns;}},{key:'render',value:function render(){var _this10=this;var hrmGroup=this.props.hrmGroup;var isSuggestDialogShow=hrmGroup.isSuggestDialogShow,isPanelOneShow=hrmGroup.isPanelOneShow,isPanelTwoShow=hrmGroup.isPanelTwoShow,isPanelThreeShow=hrmGroup.isPanelThreeShow,isNewDialogShow=hrmGroup.isNewDialogShow,isEditDialogShow=hrmGroup.isEditDialogShow,isImportBaseDialogShow=hrmGroup.isImportBaseDialogShow,isImportMemberDialogShow=hrmGroup.isImportMemberDialogShow,isShareDialogShow=hrmGroup.isShareDialogShow,isImportInfoDialogShow=hrmGroup.isImportInfoDialogShow,isImportHistoryDialogShow=hrmGroup.isImportHistoryDialogShow,isImportMemInfoDialogShow=hrmGroup.isImportMemInfoDialogShow;var form1=hrmGroup.form1,form2=hrmGroup.form2,form3=hrmGroup.form3,form4=hrmGroup.form4,form5=hrmGroup.form5,form6=hrmGroup.form6,form7=hrmGroup.form7;var tableStore1=hrmGroup.tableStore1,tableStore2=hrmGroup.tableStore2,tableStore3=hrmGroup.tableStore3,tableStore4=hrmGroup.tableStore4;var editTabKey=hrmGroup.editTabKey,suggestTabKey=hrmGroup.suggestTabKey;var columns=hrmGroup.columns,dataSource=hrmGroup.dataSource,loading=hrmGroup.loading,action=hrmGroup.action,logFilePath=hrmGroup.logFilePath,height=hrmGroup.height;var condition1=hrmGroup.condition1,condition2=hrmGroup.condition2,condition3=hrmGroup.condition3,condition4=hrmGroup.condition4,condition5=hrmGroup.condition5,condition6=hrmGroup.condition6,condition7=hrmGroup.condition7;var orderArr=hrmGroup.orderArr,hasWeaTop=hrmGroup.hasWeaTop,hasAuthority=hrmGroup.hasAuthority;var searchsBaseValue1=form1.getFormParams().name;var searchsBaseValue2=form2.getFormParams().resourcename;var searchsBaseValue3=form7.getFormParams().suggesttitle;var type=form3.getFormParams().type;var tbParams1={tableStore:tableStore1,loading:tableStore1.loading,title:getLabel('386490',"常用组列表"),customComponent:this.getCustomComponent('1'),isNeedScroll:true,isNeedRerender:true,isNeedSearchGroup:true,tag:'base'};var tbParams2={tableStore:tableStore2,loading:tableStore2.loading,title:getLabel('386491',"成员列表"),customComponent:this.getCustomComponent('2'),height:height,isNeedRerender:true,isNeedSearchGroup:true,tag:'member'};var tbParams3={tableStore:tableStore3,loading:tableStore3.loading,title:getLabel('386492',"共享范围列表"),customComponent:this.getCustomComponent('3'),height:height,isNeedRerender:false,isNeedSearchGroup:true,tag:'share'};var tbParams4={tableStore:tableStore4,loading:tableStore4.loading,height:height,isNeedRerender:true,isNeedSearchGroup:false,tag:'suggest'};var paramsForAntTable={col:columns,ds:dataSource,loading:loading,isPagination:false,action:action,height:height,num:2};var tabName=[{key:'0',title:getLabel('81711',"基本信息")},{key:'1',title:getLabel('431',"成员")},{key:'2',title:getLabel('82752',"共享范围")},{key:'3',title:getLabel('16349',"待处理")},{key:'4',title:getLabel('1454',"已处理")}];var dropMenuDatas=[{key:'0',content:_i18n.i18n.button.import(),icon:_react2.default.createElement('i',{className:'icon-coms-download2'})},{key:'1',content:_i18n.i18n.button.add(),icon:_react2.default.createElement('i',{className:'icon-coms-New-Flow'})},{key:'2',content:_i18n.i18n.button.multiDelete(),icon:_react2.default.createElement('i',{className:'icon-coms-delete'})},{key:'3',content:_i18n.i18n.button.save(),icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'})},{key:'4',content:_i18n.i18n.button.saveAndSetting(),icon:_react2.default.createElement('i',{className:'icon-coms-Flow-setting'})},{key:'5',content:_i18n.i18n.button.submit(),icon:_react2.default.createElement('i',{className:'icon-coms-export'})},{key:'6',content:_i18n.i18n.button.importHistoryQuery(),icon:_react2.default.createElement('i',{className:'icon-coms-Print-log'})}];var dropMenuDatas1=dropMenuDatas.slice(0,3);var dropMenuDatas2=dropMenuDatas.slice(3,5).concat(dropMenuDatas.slice(7,8));var dropMenuDatas3=dropMenuDatas.slice(5,7).concat(dropMenuDatas.slice(7,8));var dropMenuDatas4=dropMenuDatas.slice(5,6).concat(dropMenuDatas.slice(7,8));var dropMenuDatas5=dropMenuDatas.slice(3,4).concat(dropMenuDatas.slice(7,8));var dropMenuDatas6=dropMenuDatas.slice(7,8);var dropMenuDatas7=dropMenuDatas.slice(1,3);var btn1=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this10.handleSearch('1');}},_i18n.i18n.button.search()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return form1.reset();}},_i18n.i18n.button.reset()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmGroup.setPanelOneStatus(false);}},_i18n.i18n.button.cancel())];var btn2=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmGroup.save('1');}},_i18n.i18n.button.save()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmGroup.save('2');}},_i18n.i18n.button.saveAndSetting())];var btn=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmGroup.save('9');}},_i18n.i18n.button.save()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmGroup.save('10');}},_i18n.i18n.button.save())];var btn3=void 0;var datas=void 0;if(editTabKey=='0'){btn3=btn.slice(0,1).concat(btn.slice(2,3));datas=dropMenuDatas5;}if(editTabKey=='1'){btn3=btn.slice(1,2).concat(btn.slice(2,3));datas=dropMenuDatas1;}if(editTabKey=='2'){btn3=btn.slice(2,3);datas=dropMenuDatas7;}var btn4=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this10.handleSearch('2');}},_i18n.i18n.button.search()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return form2.reset();}},_i18n.i18n.button.reset()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmGroup.setPanelTwoStatus(false);}},_i18n.i18n.button.cancel())];var btn5=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this10.handleSubmit('1');}},_i18n.i18n.button.submit()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this10.handleImportHistory();}},_i18n.i18n.button.importHistoryQuery()),_react2.default.createElement(_ecCom.WeaMoreButton,null)];var btn6=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this10.handleSubmit('2');}},_i18n.i18n.button.submit()),_react2.default.createElement(_ecCom.WeaMoreButton,null)];var btn7=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmGroup.save('4');}},_i18n.i18n.button.save()),_react2.default.createElement(_ecCom.WeaMoreButton,null)];var btn8=[_react2.default.createElement(_antd.Button,{type:'primary',disabled:!logFilePath?true:false},_react2.default.createElement('a',{href:'/api/hrm/group/getImportHistoryFile?filename='+logFilePath},getLabel('386493',"导入日志下载"))),_react2.default.createElement(_antd.Button,{disabled:true},'\u66F4\u591A >>')];var btn9=[_react2.default.createElement(_antd.Button,{disabled:true},'\u66F4\u591A >>')];var btn10=[_react2.default.createElement(_antd.Button,{disabled:true},'\u66F4\u591A >>')];var btn11=[_react2.default.createElement(_antd.Button,{disabled:true},'\u66F4\u591A >>')];var btn12=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this10.handleSearch('3');}},_i18n.i18n.button.search()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return form7.reset();}},_i18n.i18n.button.reset()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmGroup.setPanelThreeStatus(false);}},_i18n.i18n.button.cancel())];return _react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas1,onClick:function onClick(key){return _this10.handleOneDropMenuClick(key);}},true?_react2.default.createElement(_ecCom.WeaTop,{title:getLabel('18166',"个性化设置"),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',loading:true}):'',_react2.default.createElement(_ecCom.WeaTab,{searchType:['base','advanced'],showSearchAd:isPanelOneShow,searchsBaseValue:searchsBaseValue1,setShowSearchAd:function setShowSearchAd(bool){return hrmGroup.setPanelOneStatus(bool);},hideSearchAd:function hideSearchAd(){return hrmGroup.setPanelOneStatus(false);},searchsAd:this.getPanelComponents(condition1,form1,'1'),advanceHeight:74,buttonsAd:btn1,buttons:this.getCustomComponent('1'),onSearch:function onSearch(){return hrmGroup.getTableInfo('1');},onSearchChange:function onSearchChange(val){return hrmGroup.updateFormFields('1',val);}}),this.getTable(tbParams1)),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel('126253',"公共组调整建议"),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isSuggestDialogShow,closable:true,onCancel:function onCancel(){hrmGroup.setSuggestDialogStatus(false);hrmGroup.setPanelThreeStatus(false);},buttons:btn11,style:{width:890,height:510},onChangeHeight:function onChangeHeight(height){return hrmGroup.changeHeight(height);}},_react2.default.createElement(_ecCom.WeaTab,{selectedKey:suggestTabKey,datas:tabName.slice(3,5),keyParam:'key',searchsBaseValue:searchsBaseValue3,onChange:function onChange(key){return hrmGroup.suggestTabClick(key);},searchType:['base','advanced'],setShowSearchAd:function setShowSearchAd(bool){return hrmGroup.setPanelThreeStatus(bool);},hideSearchAd:function hideSearchAd(){return hrmGroup.setPanelThreeStatus(false);},showSearchAd:isPanelThreeShow,searchsAd:this.getPanelComponents(condition7,form7,'3'),advanceHeight:120,buttonsAd:btn12,onSearch:function onSearch(){return hrmGroup.getTableInfo('7');},onSearchChange:function onSearchChange(val){return hrmGroup.updateFormFields('5',val);}}),_react2.default.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas6,onClick:function onClick(key){return _this10.handleSixDropMenuClick(key);}},this.getTable(tbParams4))),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel('125445',"常用组信息导入"),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isImportBaseDialogShow,closable:true,onCancel:function onCancel(){return hrmGroup.setImportBaseDialogStatus(false);},buttons:btn5,style:{width:870,height:510}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas3,onClick:function onClick(key){return _this10.handleThreeDropMenuClick(key);}},_react2.default.createElement('div',{className:'hrm-group-form'},this.getImportComponents(condition4,form4,'1')))),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel('125445',"常用组信息导入"),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isImportInfoDialogShow,closable:true,onCancel:function onCancel(){return hrmGroup.setImportInfoDialogStatus(false);},buttons:btn8,style:{width:700,height:510},onChangeHeight:function onChangeHeight(height){return hrmGroup.changeHeight(height);}},_react2.default.createElement('div',{className:'hrm-group-table hrm-group-form'},_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:false,title:getLabel('386987',"导入情况"),showGroup:true,fontSize:13},this.getAntTable(paramsForAntTable,true)))),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel('24644',"历史导入记录"),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isImportHistoryDialogShow,closable:true,onCancel:function onCancel(){return hrmGroup.setImportHistoryDialogStatus(false);},buttons:btn9,style:{width:750,height:510},onChangeHeight:function onChangeHeight(height){return hrmGroup.changeHeight(height);}},hasAuthority?this.getAntTable(paramsForAntTable,false):this.getAuthorityIcon()),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel('386494',"导入成员"),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isImportMemberDialogShow,closable:true,onCancel:function onCancel(){return hrmGroup.setImportMemberDialogStatus(false);},buttons:btn6,style:{width:650,height:430}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas4,onClick:function onClick(key){return _this10.handleFourDropMenuClick(key);}},_react2.default.createElement('div',{className:'hrm-group-form'},this.getImportComponents(condition5,form5,'2')))),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel('386495',"常用组人员导入"),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isImportMemInfoDialogShow,closable:true,onCancel:function onCancel(){return hrmGroup.setImportMemInfoDialogStatus(false);},buttons:btn10,style:{width:700,height:510},onChangeHeight:function onChangeHeight(height){return hrmGroup.changeHeight(height);}},_react2.default.createElement('div',{className:'hrm-group-table hrm-group-form'},_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:false,title:getLabel('386987',"导入情况"),showGroup:true,fontSize:13},this.getAntTable(paramsForAntTable,true)))),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel('386496',"新建常用组"),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isNewDialogShow,closable:true,onCancel:function onCancel(){return hrmGroup.setNewDialogStatus(false);},buttons:btn2,style:{width:650}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas2,onClick:function onClick(key){return _this10.handleTwoDropMenuClick(key);}},this.getNewAndShareComponents(condition3,form3,false))),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel('126252',"常用组设置"),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isEditDialogShow,closable:true,onCancel:function onCancel(){hrmGroup.setEditDialogStatus(false);hrmGroup.setPanelTwoStatus(false);hrmGroup.tabReset();},buttons:btn3,style:{width:780,height:510},onChangeHeight:function onChangeHeight(height){return hrmGroup.changeHeight(height);}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:datas,onClick:function onClick(key){return _this10.handleDropMenuClick(key);}},_react2.default.createElement('div',{className:'hrm-group-tab'},_react2.default.createElement(_ecCom.WeaTab,{selectedKey:editTabKey,datas:type=='0'?tabName.slice(0,2):tabName.slice(0,3),keyParam:'key',searchsBaseValue:searchsBaseValue2,onChange:function onChange(key){return hrmGroup.tabClick(key);},searchType:editTabKey=='1'?['base','advanced']:'',setShowSearchAd:function setShowSearchAd(bool){return hrmGroup.setPanelTwoStatus(bool);},hideSearchAd:function hideSearchAd(){return hrmGroup.setPanelTwoStatus(false);},showSearchAd:isPanelTwoShow,searchsAd:editTabKey=='1'?this.getPanelComponents(condition2,form2,'2'):[],advanceHeight:120,buttonsAd:btn4,buttons:this.getGroupSettingBtns(editTabKey),onSearch:function onSearch(){return hrmGroup.getTableInfo('2');},onSearchChange:function onSearchChange(val){return hrmGroup.updateFormFields('2',val);}})),_react2.default.createElement('div',{className:'hrm-resource-edit-content',style:editTabKey=='0'?{display:'block'}:{display:'none'}},this.getNewAndShareComponents(condition3,form3,false)),_react2.default.createElement('div',{style:editTabKey=='1'?{display:'block'}:{display:'none'},className:'hrm-group-weatable'},this.getTable(tbParams2)),_react2.default.createElement('div',{style:editTabKey=='2'?{display:'block'}:{display:'none'}},this.getTable(tbParams3)))),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel('18645',"添加共享"),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isShareDialogShow,closable:true,onCancel:function onCancel(){return hrmGroup.setShareDialogStatus(false);},buttons:btn7,style:{width:700,height:250}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas5,onClick:function onClick(key){return _this10.handleFiveDropMenuClick(key);}},this.getNewAndShareComponents(condition6,form6,true))));}}]);return Group;}(_react2.default.Component))||_class)||_class);Group=_antd.Form.create({})(Group);exports.default=Group;

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);__webpack_require__(149);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _toString=__webpack_require__(56);var _toString2=_interopRequireDefault(_toString);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var toJS=mobx.toJS;var main=(_dec=(0,_mobxReact.inject)('hrmShift'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));var hrmShift=_this.props.hrmShift;hrmShift.init();return _this;}(0,_createClass3.default)(main,[{key:'componentDidMount',value:function componentDidMount(){this.getData();var hrmShift=this.props.hrmShift;//document.title = hrmShift.title;
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location.key!==nextProps.location.key){var hrmShift=this.props.hrmShift;hrmShift.init();this.getData();}}},{key:'getData',value:function getData(){var hrmShift=this.props.hrmShift;hrmShift.getData();}},{key:'getRightMenu',value:function getRightMenu(){var _this2=this;var hrmShift=this.props.hrmShift;var newChecking=hrmShift.newChecking;var btns=[];btns.push({key:"search",icon:_react2.default.createElement('i',{className:'icon-workflow-Right-menu--search'}),content:newChecking(),onClick:function onClick(key){_this2.addChecking();}});return btns;}},{key:'addChecking',value:function addChecking(){var hrmShift=this.props.hrmShift;hrmShift.updateNewVisible(true);}},{key:'chooseUser',value:function chooseUser(e){var hrmShift=this.props.hrmShift;var hrmId='',hrmName=undefined;if(e.selected){hrmId=e.node.props.id;hrmName=e.node.props.name;}if(hrmId){hrmShift.updateHrmId(hrmId);if(hrmName)hrmShift.updateHrmName(hrmName);this.getData();}}},{key:'changeUserRoot',value:function changeUserRoot(ids,names,datas){var hrmShift=this.props.hrmShift;hrmShift.updateUserRoot(datas);}},{key:'resetUserRoot',value:function resetUserRoot(){var hrmShift=this.props.hrmShift;hrmShift.updateUserRoot();hrmShift.updateHrmId();hrmShift.updateHrmName();this.getData();}},{key:'changeDateTab',value:function changeDateTab(key){var hrmShift=this.props.hrmShift;hrmShift.changeDateTabHandler(key);this.getData();}},{key:'reFresh',value:function reFresh(){var hrmShift=this.props.hrmShift;this.getData();}},{key:'changeDate',value:function changeDate(v){var hrmShift=this.props.hrmShift;var dateTabkey=hrmShift.dateTabkey;if(dateTabkey=='2'){v=new _moment2.default(v).format('YYYY-MM');}else{v=new _moment2.default(v).format('YYYY');}hrmShift.changeDateHandler(v);this.getData();}},{key:'renderLeft',value:function renderLeft(){var hrmShift=this.props.hrmShift;var leftTitle=hrmShift.leftTitle,userRoot=hrmShift.userRoot;userRoot=toJS(userRoot);return _react2.default.createElement('div',{className:'wea-hrm-checking-left',style:{height:window.innerHeight-125}},_react2.default.createElement('div',{className:'left-header'},_react2.default.createElement('div',{className:'header-title bb align-center header-title-shift'},leftTitle)),_react2.default.createElement('div',{className:'left-body'},_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaBrowser,{isSingle:true,linkUrl:'/hrm/resource/HrmResource.jsp?id=',title:getLabel('179',"人力资源"),type:'1',viewAttr:'2',replaceDatas:userRoot,customIcon:'icon-coms-Reset',addOnClick:this.resetUserRoot.bind(this),onChange:this.changeUserRoot.bind(this)}),_react2.default.createElement('div',{style:{height:window.innerHeight-225}},_react2.default.createElement(_ecCom.WeaOrgTree,{dataUrl:'/api/hrm/base/getHrmResourceTree',rootKey:'rootManager',treeNodeClick:this.chooseUser.bind(this),params:Array.isArray(userRoot)&&userRoot[0]?{rootid:userRoot[0].id}:{}})))));}},{key:'getLocale',value:function getLocale(){return{firstDayOfWeek:0,lang:{format:{eras:[getLabel(383357,"公元前"),getLabel(383358,"公元")],months:[getLabel(1492,"一月"),getLabel(1493,"二月"),getLabel(383385,"三月"),getLabel(383387,"四月"),getLabel(1496,"五月"),getLabel(383392,"六月"),getLabel(383393,"七月"),getLabel(383394,"八月"),getLabel(383395,"九月"),getLabel(383396,"十月"),getLabel(383397,"十一月"),getLabel(383398,"十二月")],shortMonths:[getLabel(1492,"一月"),getLabel(1493,"二月"),getLabel(383385,"三月"),getLabel(383387,"四月"),getLabel(1496,"五月"),getLabel(383392,"六月"),getLabel(383393,"七月"),getLabel(383394,"八月"),getLabel(383395,"九月"),getLabel(383396,"十月"),getLabel(383397,"十一月"),getLabel(383398,"十二月")],weekdays:[getLabel(24626,"星期天"),getLabel(383399,"星期一"),getLabel(383400,"星期二"),getLabel(383402,"星期三"),getLabel(383403,"星期四"),getLabel(383404,"星期五"),getLabel(383405,"星期六")],shortWeekdays:[getLabel(16106,"周日"),getLabel(16100,"周一"),getLabel(16101,"周二"),getLabel(16102,"周三"),getLabel(16103,"周四"),getLabel(16104,"周五"),getLabel(16105,"周六")],veryShortWeekdays:[getLabel(16106,"周日"),getLabel(16100,"周一"),getLabel(16101,"周二"),getLabel(16102,"周三"),getLabel(16103,"周四"),getLabel(16104,"周五"),getLabel(16105,"周六")],ampms:[getLabel(383408,"上午"),getLabel(383409,"下午")],datePatterns:['yyyy\''+getLabel(383372,"年")+'\'M\''+getLabel(383373,"月")+'\'d\''+getLabel(383374,"日")+'\' EEEE','yyyy\''+getLabel(383372,"年")+'\'M\''+getLabel(383373,"月")+'\'d\''+getLabel(383374,"日")+'\'',"yyyy-M-d","yy-M-d"],timePatterns:['ahh\''+getLabel(383411,"时")+'\'mm\''+getLabel(383412,"分")+'\'ss\''+getLabel(383414,"秒")+'\' \'GMT\'Z','ahh\''+getLabel(383411,"时")+'\'mm\''+getLabel(383412,"分")+'\'ss\''+getLabel(383414,"秒")+'\'',"H:mm:ss","ah:mm"],dateTimePattern:'{date} {time}'}}};}},{key:'onyearMonthSelect',value:function onyearMonthSelect(date){var hrmShift=this.props.hrmShift;var select=new _moment2.default(date.time).format('YYYY-MM');hrmShift.changeDateHandler(select);hrmShift.updateDateTabkey('2');this.getData();}},{key:'monthDateCellRender',value:function monthDateCellRender(date){var hrmShift=this.props.hrmShift;var dateTabkey=hrmShift.dateTabkey,pDate=hrmShift.pDate,calendarData=hrmShift.calendarData,statusActiveType=hrmShift.statusActiveType;calendarData=toJS(calendarData);var select=new _moment2.default(date.time).format('YYYY-MM');if(pDate.slice(0,7)==select){var day=date.getDayOfMonth();var data=calendarData[day];if(data){return _react2.default.createElement('div',{className:'calendar-item'},_react2.default.createElement('span',{className:'tip',style:{color:data.isWorkDay?'#FF1B10':'#1B9B12'}},data.tip),data.items&&data.items.map(function(item){return _react2.default.createElement(_antd.Tooltip,{placement:'right',title:item.title},_react2.default.createElement('div',{className:'workflow-item text-overflow shift-item',style:{backgroundColor:item.color}},item.title));}));}}}},{key:'renderYearCellBottom',value:function renderYearCellBottom(items){if(!(0,_isEmpty2.default)(items)){return _react2.default.createElement(_antd.Row,{className:'year-cell-bottom'},items.map(function(item){return _react2.default.createElement(_antd.Col,{span:24/items.length,style:{backgroundColor:item.color,height:'100%'}});}));}}},{key:'yearDateCellRender',value:function yearDateCellRender(date){var hrmShift=this.props.hrmShift;var pDate=hrmShift.pDate,yearData=hrmShift.yearData;yearData=toJS(yearData);var d=date.getDayOfMonth();var m=date.getMonth()+1;var data={};if(yearData!==undefined&&!(0,_isEmpty2.default)(yearData)){data=yearData[m][d];}var content=_react2.default.createElement('span',null,data.tip&&_react2.default.createElement('span',{className:'tip',style:{color:data.isWorkDay?'#FF1B10':'#1B9B12'}},data.tip),d,data.items&&this.renderYearCellBottom(data.items));return _react2.default.createElement('div',{className:'date-item'},content);}},{key:'renderCalendar',value:function renderCalendar(){var hrmShift=this.props.hrmShift;var dateTabkey=hrmShift.dateTabkey,pDate=hrmShift.pDate;return _react2.default.createElement('div',{className:'calendar-wrapper'},dateTabkey=='2'&&_react2.default.createElement(_antd.Calendar,{mode:'month',dateCellRender:this.monthDateCellRender.bind(this),locale:this.getLocale(),value:new Date(pDate)}),dateTabkey=='1'&&_react2.default.createElement(_ecCom.WeaYear,{value:pDate,dateCellRender:this.yearDateCellRender.bind(this),onMonthSelect:this.onyearMonthSelect.bind(this)}));}},{key:'render',value:function render(){var _this3=this;var hrmShift=this.props.hrmShift;var title=hrmShift.title,dateTabDatas=hrmShift.dateTabDatas,dateTabkey=hrmShift.dateTabkey,pDate=hrmShift.pDate,hasRight=hrmShift.hasRight,canSearch=hrmShift.canSearch,leftTitle=hrmShift.leftTitle,hrmName=hrmShift.hrmName,loading=hrmShift.loading;var errorMsg=getLabel('386500',"您无权查看 {params} 的排班数据！").replace('{params}',hrmName);return _react2.default.createElement('div',{className:'wea-hrm-checking'},_react2.default.createElement(_ecCom.WeaPopoverHrm,null),_react2.default.createElement(_antd.Spin,{spining:loading},_react2.default.createElement(_ecCom.WeaTop,{title:title(),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:[],buttonSpace:10,showDropIcon:false// dropMenuDatas={this.getRightMenu()}
},canSearch&&this.renderLeft(),_react2.default.createElement('div',{style:{width:'100%',paddingLeft:canSearch?221:0}},_react2.default.createElement(_antd.Row,{className:'picker-wrapper'},_react2.default.createElement(_antd.Col,{span:2,className:'leftTitle'},leftTitle(),'\xA0:\xA0\xA0',hrmName),[{title:_i18n.i18n.label.year(),key:"1"},{title:_i18n.i18n.label.month(),key:"2"}].map(function(item){return _react2.default.createElement(_antd.Col,{span:1,onClick:_this3.changeDateTab.bind(_this3,item.key),className:'cursor-pointer date-item '+(item.key===dateTabkey?'active':'')},item.title);}),_react2.default.createElement(_antd.Col,{span:10,className:'picker'},_react2.default.createElement(_ecCom.WeaDatePicker,{arrow:true,type:dateTabkey=='1'?'year':'month',date:pDate,onChange:this.changeDate.bind(this)}),_react2.default.createElement('i',{className:'icon-coms-Refresh cursor-pointer',onClick:this.reFresh.bind(this)}))),_react2.default.createElement(_ecCom.WeaNewScroll,{height:window.innerHeight-153-15,className:'bt'},!hasRight&&_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',null,errorMsg)),hasRight&&_react2.default.createElement('div',{className:'hrm-checking-content'},this.renderCalendar()))))));}}]);return main;}(_react2.default.Component))||_class)||_class);exports.default=main;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);__webpack_require__(149);__webpack_require__(371);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _toString=__webpack_require__(56);var _toString2=_interopRequireDefault(_toString);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _Map=__webpack_require__(372);var _Map2=_interopRequireDefault(_Map);var _loadjs=__webpack_require__(148);var _loadjs2=_interopRequireDefault(_loadjs);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var toJS=mobx.toJS;var main=(_dec=(0,_mobxReact.inject)('hrmOutside'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.reRenderColumns=function(columns,store){var handleViewClick=store.handleViewClick;columns.map(function(c){if(c.dataIndex==='canViewSignImg'){c.render=function(text,record){var randomFieldId=record.randomFieldId,canViewSignImgspan=record.canViewSignImgspan;if(canViewSignImgspan==='1'){return _react2.default.createElement('a',{onClick:function onClick(){return handleViewClick(randomFieldId);}},getLabel(33564,'查看'));}else{return _react2.default.createElement('span',null);}};}});};return _this;}(0,_createClass3.default)(main,[{key:'componentDidMount',value:function componentDidMount(){var hrmOutside=this.props.hrmOutside;hrmOutside.init();this.getData();//document.title = hrmOutside.title;
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location.key!==nextProps.location.key){var hrmOutside=this.props.hrmOutside;hrmOutside.init();this.getData();}}},{key:'getData',value:function getData(){var hrmOutside=this.props.hrmOutside;hrmOutside.getData();}},{key:'getRightMenu',value:function getRightMenu(){var hrmOutside=this.props.hrmOutside;var dataKey=hrmOutside.dataKey,tabkey=hrmOutside.tabkey,hasRight=hrmOutside.hasRight;var btns=[];if(tabkey=='3'&&hasRight){//分页控件导出有bug，先屏蔽
btns.push({key:"exportExcel",icon:_react2.default.createElement('i',{className:'icon-coms-export'}),content:_i18n.i18n.button.export(),onClick:function onClick(key){hrmOutside.exportExcel(dataKey);}});}return btns;}},{key:'chooseUser',value:function chooseUser(e){var hrmOutside=this.props.hrmOutside;var hrmId='',hrmName=undefined;if(e.selected){hrmId=e.node.props.id;hrmName=e.node.props.name;}if(hrmId){hrmOutside.updateHrmId(hrmId);if(hrmName)hrmOutside.updateHrmName(hrmName);this.getData();}}},{key:'changeUserRoot',value:function changeUserRoot(ids,names,datas){var hrmOutside=this.props.hrmOutside;hrmOutside.updateUserRoot(datas);}},{key:'resetUserRoot',value:function resetUserRoot(){var hrmOutside=this.props.hrmOutside;hrmOutside.updateUserRoot();hrmOutside.updateHrmId();hrmOutside.updateHrmName();this.getData();}},{key:'reFresh',value:function reFresh(){this.getData();}},{key:'changeTab',value:function changeTab(key){var hrmOutside=this.props.hrmOutside;hrmOutside.changeTab(key);//this.resetUserRoot();
this.getData();}},{key:'changeDateTab',value:function changeDateTab(key){var hrmOutside=this.props.hrmOutside;hrmOutside.changeDateTab(key);this.getData();}},{key:'changeDate',value:function changeDate(v1,v2){var hrmOutside=this.props.hrmOutside;hrmOutside.changeDate(v1,v2);this.getData();}},{key:'handlerCheckbox',value:function handlerCheckbox(v){var hrmOutside=this.props.hrmOutside;hrmOutside.handlerCheckbox(v);}},{key:'handlerPosition',value:function handlerPosition(item){var hrmOutside=this.props.hrmOutside;hrmOutside.updatePosition(item);hrmOutside.updateVisible(true);}},{key:'onTreeCheck',value:function onTreeCheck(ids,datas){var hrmOutside=this.props.hrmOutside;var idds=[];datas.forEach(function(d){idds.push(d.id);});hrmOutside.updateHrmId(idds.join(','));hrmOutside.updateOrgTreeCheckedDatas(datas);this.getData();}},{key:'renderLeft',value:function renderLeft(){var _this2=this;var hrmOutside=this.props.hrmOutside;var leftTitle=hrmOutside.leftTitle,userRoot=hrmOutside.userRoot,orgTreeIsMult=hrmOutside.orgTreeIsMult,orgTreeCheckedDatas=hrmOutside.orgTreeCheckedDatas;userRoot=toJS(userRoot);return _react2.default.createElement('div',{className:'wea-hrm-checking-left',style:{height:window.innerHeight-125}},_react2.default.createElement('div',{className:'left-header'},_react2.default.createElement('div',{className:'header-title bb'},_react2.default.createElement('div',{style:{padding:'0 15px'}},_react2.default.createElement('span',{style:{float:'left'}},leftTitle()),_react2.default.createElement('span',{style:{float:'right',fontSize:'12px'}},_react2.default.createElement(_ecCom.WeaCheckbox,{onChange:function onChange(v){hrmOutside.updateOrgTreeIsMult(v);hrmOutside.updateOrgTreeCheckedDatas();_this2.refs.orgTree&&_this2.refs.orgTree.resetCheck();},value:orgTreeIsMult}),'\xA0\xA0',getLabel('386504',"开启选择"))))),_react2.default.createElement('div',{className:'left-body'},_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaBrowser,{isSingle:true,linkUrl:'/hrm/resource/HrmResource.jsp?id=',title:getLabel('179',"人力资源"),type:'1',viewAttr:'2',replaceDatas:userRoot,customIcon:'icon-coms-Reset',addOnClick:this.resetUserRoot.bind(this),onChange:this.changeUserRoot.bind(this)}),_react2.default.createElement('div',{style:{display:orgTreeIsMult=='0'?'block':'none',height:window.innerHeight-225}},_react2.default.createElement(_ecCom.WeaOrgTree,{renderNodeId:function renderNodeId(item){return item.id;},dataUrl:'/api/hrm/base/getHrmResourceTree',rootKey:'rootManager',treeNodeClick:this.chooseUser.bind(this),params:Array.isArray(userRoot)&&userRoot[0]?{rootid:userRoot[0].id}:{}})),_react2.default.createElement('div',{style:{display:orgTreeIsMult=='1'?'block':'none',height:window.innerHeight-225}},_react2.default.createElement(_ecCom.WeaOrgTree,{ref:'orgTree',dataUrl:'/api/hrm/base/getHrmResourceTree',rootKey:'rootManager',onCheck:this.onTreeCheck.bind(this),isMult:true,checkStrictly:false,checkedDatas:orgTreeCheckedDatas,params:Array.isArray(userRoot)&&userRoot[0]?{rootid:userRoot[0].id}:{}})))));}},{key:'renderList',value:function renderList(){var _this3=this;var hrmOutside=this.props.hrmOutside;var timeData=hrmOutside.timeData;timeData=toJS(timeData);return _react2.default.createElement(_antd.Timeline,{className:'list-wrapper grayBG'},timeData&&timeData.map(function(item,index){return _react2.default.createElement(_antd.Timeline.Item,{className:'list-item'},_react2.default.createElement('div',{className:'list-item-wrapper'},_react2.default.createElement('div',{className:'list-item-title'},item.date),_react2.default.createElement('div',{className:'list-item-content'},(0,_isEmpty2.default)(item.items)&&_react2.default.createElement('div',{className:'no-signinfo gray align-center'},_react2.default.createElement(_antd.Icon,{type:'frown gray',style:{marginRight:10}}),getLabel('386505',"当天无外勤签到记录")),!(0,_isEmpty2.default)(item.items)&&item.items.map(function(i){return _react2.default.createElement('div',{className:'list-item-single'},_react2.default.createElement('div',{className:'mb5'},i.name,_react2.default.createElement('span',{className:'gray',style:{marginLeft:15}},i.time),_react2.default.createElement('span',{style:{float:'right',marginRight:10,color:'#67AFF7'}},i.signTitle)),i.information&&_react2.default.createElement('div',{className:'mb5',dangerouslySetInnerHTML:{__html:i.information}}),i.pics&&_react2.default.createElement('div',{className:'mb5'},i.pics.map(function(pic){return _react2.default.createElement('div',null,_react2.default.createElement('img',{src:pic,border:'0',width:'100',height:'110',onClick:function onClick(event){return(0,_index.carousel)(pic,index,'ant-timeline-item');}}));})),_react2.default.createElement('span',{className:'cursor-pointer gray',onClick:_this3.handlerPosition.bind(_this3,i)},_react2.default.createElement('i',{className:'icon-coms-position',style:{marginRight:6}}),' ',i.title));}))));}));}},{key:'renderDetail',value:function renderDetail(){var _this4=this;var hrmOutside=this.props.hrmOutside;var config=hrmOutside.config,dataKey=hrmOutside.dataKey,table=hrmOutside.table;// config = toJS(config);
return _react2.default.createElement('div',{className:'radio-search-group'},_react2.default.createElement(_ecCom.WeaRadioGroup,{config:config(),onChange:function onChange(params){hrmOutside.radioGroupParams=params;hrmOutside.getData(params);}}),_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:getLabel('19325',"明细表"),showGroup:true},_react2.default.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true,getColumns:function getColumns(columns){return _this4.reRenderColumns(columns,hrmOutside);}})));}},{key:'renderMap',value:function renderMap(){var hrmOutside=this.props.hrmOutside;var mapData=hrmOutside.mapData;mapData=toJS(mapData);if(!(0,_isEmpty2.default)(mapData)){return _react2.default.createElement(_Map2.default,{config:mapData,mult:true});}else{return _react2.default.createElement('div',{className:'grayBG'},_react2.default.createElement(_ecCom.WeaAlertPage,{icon:_react2.default.createElement('img',{style:{width:77,height:97},src:'/cloudstore/resource/pc/com/images/no_sign.png'})},_react2.default.createElement('div',null,getLabel('386505',"当天无外勤签到记录"))));}}},{key:'renderContent',value:function renderContent(){var hrmOutside=this.props.hrmOutside;var tabkey=hrmOutside.tabkey;if(tabkey==1)return this.renderList();if(tabkey==2)return this.renderMap();if(tabkey==3)return this.renderDetail();}},{key:'getTabButtonsAd',value:function getTabButtonsAd(){var hrmOutside=this.props.hrmOutside;var dataKey=hrmOutside.dataKey;return[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmOutside.exportExcel(dataKey);}},_i18n.i18n.button.export())];}},{key:'render',value:function render(){var _this5=this;var hrmOutside=this.props.hrmOutside;var title=hrmOutside.title,tabkey=hrmOutside.tabkey,tabDatas=hrmOutside.tabDatas,loading=hrmOutside.loading,hasRight=hrmOutside.hasRight,hrmName=hrmOutside.hrmName,dateTabkey=hrmOutside.dateTabkey,dateTabDatas=hrmOutside.dateTabDatas,dateTabDatas1=hrmOutside.dateTabDatas1,pDate=hrmOutside.pDate,showSignInfo=hrmOutside.showSignInfo,signTitle=hrmOutside.signTitle,visible=hrmOutside.visible,positionObj=hrmOutside.positionObj;tabDatas=tabDatas();dateTabDatas1=dateTabDatas1();dateTabDatas=dateTabDatas();positionObj=toJS(positionObj);var errorMsg=getLabel('386507',"你无权查看{params}的外勤数据！").replace('{params}',hrmName);return _react2.default.createElement('div',{className:'wea-hrm-checking wea-hrm-outside'},_react2.default.createElement(_ecCom.WeaPopoverHrm,null),_react2.default.createElement(_ecCom.WeaDialog,{visible:visible,onCancel:function onCancel(){hrmOutside.updateVisible(false);},closable:true,style:{width:700,height:500},title:getLabel('386506',"位置详情"),icon:'icon-coms-hrm',iconBgcolor:'#008572'},visible&&_react2.default.createElement(_Map2.default,{config:positionObj,ref:'map1'})),_react2.default.createElement(_antd.Spin,{spining:loading},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu()},_react2.default.createElement(_ecCom.WeaTop,{title:title(),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:[],buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu()},this.renderLeft(),_react2.default.createElement('div',{style:{width:'100%',paddingLeft:221}},_react2.default.createElement(_ecCom.WeaTab,{buttons:tabkey==3&&this.getTabButtonsAd(),selectedKey:tabkey,keyParam:'key',datas:tabDatas,onChange:this.changeTab.bind(this)}),tabkey!=3&&_react2.default.createElement(_antd.Row,{className:'picker-wrapper'},tabkey==1&&dateTabDatas.map(function(item){return _react2.default.createElement(_antd.Col,{span:1,onClick:_this5.changeDateTab.bind(_this5,item.key),className:'cursor-pointer date-item '+(item.key===dateTabkey?'active':'')},item.title);}),tabkey==2&&dateTabDatas1.map(function(item){return _react2.default.createElement(_antd.Col,{span:1,onClick:_this5.changeDateTab.bind(_this5,item.key),className:'cursor-pointer date-item '+(item.key===dateTabkey?'active':'')},item.title);}),_react2.default.createElement(_antd.Col,{span:13,className:'picker'},_react2.default.createElement(_ecCom.WeaDatePicker,{arrow:true,type:dateTabkey=='3'?'month':'day',date:pDate,onChange:this.changeDate.bind(this)}),_react2.default.createElement('i',{className:'icon-coms-Refresh cursor-pointer outside-refresh',onClick:this.reFresh.bind(this)})),_react2.default.createElement(_antd.Col,{span:6,className:'checkbox-wrapper',title:signTitle()},_react2.default.createElement(_ecCom.WeaCheckbox,{value:showSignInfo,onChange:this.handlerCheckbox.bind(this)}),signTitle())),_react2.default.createElement(_ecCom.WeaNewScroll,{height:tabkey==3?window.innerHeight-150-35:window.innerHeight-150-65},_react2.default.createElement('div',{className:''+(tabkey==2?'wea-outside-content':'')},!hasRight&&_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',null,errorMsg)),hasRight&&this.renderContent())))))));}}]);return main;}(_react2.default.Component))||_class)||_class);exports.default=main;

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(48);var _reactDom2=_interopRequireDefault(_reactDom);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _reactAmap=__webpack_require__(373);__webpack_require__(386);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var mapInstance=void 0;var iconCls={'0':'markerRBg','1':'markerYBg'};var colors=["#0072E3","#BE77FF","#FFD306","#02DF82","#D94600","#AE0000","#5CADAD","#AE57A4","#613030 ","#D9006C"];var cLength=colors.length;var content=function content(i){return'<div class=\'markerContent '+iconCls[0]+'\'>'+(i+1)+'</div>';};var createDetailTemplete=function createDetailTemplete(c){return'<div class="hrm-map-detail">\n      <i class="cursor-pointer icon-coms-Clear" onclick=\'return closeHrmMapInfoWindow();\'></i>\n      <div class="mb5">\n        <span class="mr10">'+c.name+'</span>\n        <span class="gray mb5">'+c.time+'</span>\n        <span class="signTitle">'+c.signTitle+'</span>\n      </div>\n      '+(c.information?'<div class="mb5">'+c.information+'</div>':'')+'\n      '+(c.pics?'<div className="mb5">\n        '+c.pics.map(function(pic){return'<div><img src='+pic+' border="0" width="100" height="110"/></div>';})+'\n      </div>':'')+'\n      <span class="gray">\n        <i class="icon-coms-position mr5"></i> '+c.title+'\n      </span>\n    </div>';};var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.closeInfoWindow=function(){_this.setState({infoWindow:(0,_extends3.default)({},_this.state.infoWindow,{visible:false})});};_this.initMap=function(){_this.setState({showMap:false});var _this$props=_this.props,config=_this$props.config,mult=_this$props.mult;if((0,_isEmpty2.default)(config)||mult&&config.length==0)return;_this.setState({infoWindow:(0,_extends3.default)({},_this.state.infoWindow,{visible:false})});_this.addMarker();};_this.addMarker=function(){var _this$props2=_this.props,config=_this$props2.config,mult=_this$props2.mult;var markers=[];var polylines=[];if(mult){config.map(function(c,i){var path=[];c.items.map(function(item,j){var markerProps={title:item.title,content:content(j),position:{longitude:item.x,latitude:item.y},events:{click:function click(e){_this.setState({infoWindow:(0,_extends3.default)({},_this.state.infoWindow,{content:createDetailTemplete(item),position:{longitude:item.x,latitude:item.y},visible:true})});}}};path.push(markerProps.position);markers.push(_react2.default.createElement(_reactAmap.Marker,markerProps));});var polylineProps={path:path,style:{strokeColor:colors[i%cLength],strokeOpacity:1,strokeWeight:2,strokeStyle:"solid"}};polylines.push(_react2.default.createElement(_reactAmap.Polyline,polylineProps));});}else{var markerProps={title:config.title,content:content(0),position:{longitude:config.x,latitude:config.y},events:{click:function click(e){_this.setState({infoWindow:(0,_extends3.default)({},_this.state.infoWindow,{content:createDetailTemplete(config),position:{longitude:config.x,latitude:config.y},visible:true})});}}};markers.push(_react2.default.createElement(_reactAmap.Marker,markerProps));}_this.setState({markers:markers,polylines:polylines,showMap:true});};_this.setFitView=function(){setTimeout(function(){mapInstance&&mapInstance.setFitView();},0);};_this.setMapInstance=function(instanace){if(instanace.CLASS_NAME==='AMap.Map'){mapInstance=instanace;}};_this.state={markers:[],polylines:[],infoWindow:{visible:false,isCustom:true},showMap:false};return _this;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){window.closeHrmMapInfoWindow=this.closeInfoWindow;this.initMap();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.initMap();}},{key:'render',value:function render(){var _this2=this;var mapEvt={created:function created(instanace){return _this2.setMapInstance(instanace);},complete:function complete(){return _this2.setFitView();}};var mapProps={zoom:14,resizeEnable:true,plugins:['Scale',{name:'ToolBar',options:{locate:false}}],events:mapEvt};return _react2.default.createElement('div',{className:'wea-hrm-map',style:{width:'100%',height:'100%'}},this.state.showMap&&_react2.default.createElement(_ecCom.WeaMap,mapProps,this.state.markers,this.state.polylines,this.state.infoWindow.visible&&_react2.default.createElement(_reactAmap.InfoWindow,this.state.infoWindow)));}}]);return Main;}(_react2.default.Component);Main.propTypes={position:_react2.default.PropTypes.any,// 位置，可以是经纬度数组或LngLat实例
title:_react2.default.PropTypes.string,// 提示文字
zoom:_react2.default.PropTypes.number// 缩放比例
};Main.defaultProps={zoom:14};exports.default=Main;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MouseTool = exports.Marker = exports.GroundImage = exports.InfoWindow = exports.PolyEditor = exports.Polyline = exports.Polygon = exports.CircleEditor = exports.Circle = exports.Markers = exports.Map = undefined;

var _map = __webpack_require__(374);

var _map2 = _interopRequireDefault(_map);

var _marker = __webpack_require__(377);

var _marker2 = _interopRequireDefault(_marker);

var _markers = __webpack_require__(378);

var _markers2 = _interopRequireDefault(_markers);

var _circle = __webpack_require__(379);

var _circle2 = _interopRequireDefault(_circle);

var _polygon = __webpack_require__(380);

var _polygon2 = _interopRequireDefault(_polygon);

var _polyline = __webpack_require__(381);

var _polyline2 = _interopRequireDefault(_polyline);

var _infowindow = __webpack_require__(382);

var _infowindow2 = _interopRequireDefault(_infowindow);

var _groundimage = __webpack_require__(383);

var _groundimage2 = _interopRequireDefault(_groundimage);

var _circleeditor = __webpack_require__(384);

var _circleeditor2 = _interopRequireDefault(_circleeditor);

var _polyeditor = __webpack_require__(162);

var _polyeditor2 = _interopRequireDefault(_polyeditor);

var _mousetool = __webpack_require__(385);

var _mousetool2 = _interopRequireDefault(_mousetool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Map = _map2.default;
exports.Markers = _markers2.default;
exports.Circle = _circle2.default;
exports.CircleEditor = _circleeditor2.default;
exports.Polygon = _polygon2.default;
exports.Polyline = _polyline2.default;
exports.PolyEditor = _polyeditor2.default;
exports.InfoWindow = _infowindow2.default;
exports.GroundImage = _groundimage2.default;
exports.Marker = _marker2.default;
exports.MouseTool = _mousetool2.default;
exports.default = {
  Map: _map2.default,
  Markers: _markers2.default,
  Circle: _circle2.default,
  CircleEditor: _circleeditor2.default,
  Polygon: _polygon2.default,
  Polyline: _polyline2.default,
  PolyEditor: _polyeditor2.default,
  InfoWindow: _infowindow2.default,
  GroundImage: _groundimage2.default,
  Marker: _marker2.default,
  MouseTool: _mousetool2.default
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _APILoader = __webpack_require__(375);

var _APILoader2 = _interopRequireDefault(_APILoader);

var _isFun = __webpack_require__(126);

var _isFun2 = _interopRequireDefault(_isFun);

var _log = __webpack_require__(41);

var _log2 = _interopRequireDefault(_log);

var _common = __webpack_require__(64);

var _withPropsReactive = __webpack_require__(50);

var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = _react2.default.Component;
var Children = _react2.default.Children;
var containerStyle = {
  width: '100%',
  height: '100%'
};
var wrapperStyle = {
  width: '100%',
  height: '100%',
  position: 'relative'

  // Native supported dynamic props by Amap
};var NativeDynamicProps = ['layers', 'zoom', 'center', 'labelzIndex',

// 'lang', native error in JSSDK when 3D viewMode
'mapStyle', 'features', 'cursor', 'pitch'];

/*
 * Props below can set by 'setStatus' altogether
 */
var StatusDynamicProps = ['animateEnable', 'doubleClickZoom', 'dragEnable', 'isHotspot', 'jogEnable', 'keyboardEnable', 'resizeEnable', 'rotateEnable', 'scrollWheel', 'touchZoom', 'zoomEnable'];

var StaticProps = ['view', 'zooms', 'showIndoorMap', 'indoorMap', 'expandZoomRange', 'showBuildingBlock', 'viewMode', 'pitchEnable', 'buildingAnimation', 'skyColor'];

var CreateProps = NativeDynamicProps.concat(StatusDynamicProps, StaticProps);

// const reservedPropName = [
//   'amapkey',
//   'version',
//   'useAMapUI',
//   'onInstanceCreated',
//   'events',
//   'loading',
//   'plugins'
// ]

var defaultOpts = {
  MapType: {
    showRoad: false,
    showTraffic: false,
    defaultType: 0
  },
  ToolBar: {
    position: 'RB',
    noIpLocate: true,
    locate: true,
    liteStyle: true,
    autoPosition: false
  },
  OverView: {},
  ControlBar: {}
};

var BaseMap = function (_Component) {
  _inherits(BaseMap, _Component);

  function BaseMap(props) {
    _classCallCheck(this, BaseMap);

    var _this = _possibleConstructorReturn(this, (BaseMap.__proto__ || Object.getPrototypeOf(BaseMap)).call(this, props));

    _this.state = {
      mapLoaded: false
    };
    var self = _this;
    _this.setterMap = {
      zoom: function zoom(val) {
        self.map.setZoom(val);
      },
      cursor: function cursor(val) {
        self.map.setDefaultCursor(val);
      },
      labelzIndex: function labelzIndex(val) {
        self.map.setlabelzIndex(val);
      }
    };
    _this.converterMap = {
      center: _common.toLnglat
    };
    if (typeof window !== 'undefined') {
      _this.pluginMap = {};
      new _APILoader2.default({
        key: props.amapkey,
        useAMapUI: props.useAMapUI,
        version: props.version,
        protocol: props.protocol
      }).load().then(function () {
        _this.createInstance();
        if (!_this.state.mapLoaded) {
          _this.setState({
            mapLoaded: true
          });
        }
      });
    }
    return _this;
  }

  _createClass(BaseMap, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.mapLoaded) {
        this.updateMapProps(this.props, nextProps);
      }
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _this2 = this;

      return Children.map(this.props.children, function (child) {
        if (child) {
          var cType = child.type;
          /* 针对下面两种组件不注入地图相关属性
           * 1. 明确声明不需要注入的
           * 2. DOM 元素
           */
          if (cType.preventAmap || typeof cType === 'string') {
            return child;
          }
          return _react2.default.cloneElement(child, {
            __map__: _this2.map
          });
        }
        return child;
      });
    }
  }, {
    key: 'createInstance',
    value: function createInstance() {
      if (!this.map) {
        var options = this.buildCreateOptions();
        this.map = new window.AMap.Map(this.mapWrapper, options);
        // install map plugins
        this.setPlugins(this.props);
        this.props.onInstanceCreated && this.props.onInstanceCreated();
      }
    }
  }, {
    key: 'buildCreateOptions',
    value: function buildCreateOptions() {
      var _this3 = this;

      var props = this.props;
      var options = {};
      CreateProps.forEach(function (key) {
        if (key in props) {
          options[key] = _this3.getSetterValue(key, props);
        }
      });
      return options;
    }
  }, {
    key: 'updateMapProps',
    value: function updateMapProps(prevProps, nextProps) {
      var _this4 = this;

      var nextMapStatus = {};
      var statusChangeFlag = false;
      var statusPropExist = false;
      StatusDynamicProps.forEach(function (key) {
        if (key in nextProps) {
          statusPropExist = true;
          if (_this4.detectPropChanged(key, prevProps, nextProps)) {
            statusChangeFlag = true;
            nextMapStatus[key] = nextProps[key];
          }
        }
      });
      statusChangeFlag && this.map.setStatus(nextMapStatus);
      if (statusPropExist && 'status' in nextProps) {
        _log2.default.warning('\u4EE5\u4E0B\u8FD9\u4E9B\u5C5E\u6027\u53EF\u4EE5\u5355\u72EC\u63D0\u4F9B\u8FDB\u884C\u914D\u7F6E\uFF0C\u4E5F\u53EF\u4EE5\u7EDF\u4E00\u4F5C\u4E3A\u2018status\u2019\u5C5E\u6027\u914D\u7F6E\uFF1B\u4F46\u662F\u8BF7\u4E0D\u8981\u540C\u65F6\u4F7F\u7528\u8FD9\u4E24\u79CD\u65B9\u5F0F\u3002\n\uFF08' + StatusDynamicProps.join(', ') + '\uFF09');
      }
      StaticProps.forEach(function (key) {
        if (key in nextProps) {
          if (_this4.detectPropChanged(key, prevProps, nextProps)) {
            _log2.default.warning('\'' + key + '\' \u662F\u4E00\u4E2A\u9759\u6001\u5C5E\u6027\uFF0C\u5730\u56FE\u5B9E\u4F8B\u521B\u5EFA\u6210\u529F\u540E\u65E0\u6CD5\u4FEE\u6539');
          }
        }
      });
      this.setPlugins(nextProps);
    }
  }, {
    key: 'getSetterValue',
    value: function getSetterValue(key, props) {
      if (key in this.converterMap) {
        return this.converterMap[key](props[key]);
      }
      return props[key];
    }
  }, {
    key: 'detectPropChanged',
    value: function detectPropChanged(key, prevProps, nextProps) {
      return prevProps[key] !== nextProps[key];
    }
  }, {
    key: 'setPlugins',
    value: function setPlugins(props) {
      var _this5 = this;

      var pluginList = ['Scale', 'ToolBar', 'MapType', 'OverView', 'ControlBar'];
      if ('plugins' in props) {
        var plugins = props.plugins;
        if (plugins && plugins.length) {
          plugins.forEach(function (p) {
            var name = void 0,
                config = void 0,
                visible = void 0;
            if (typeof p === 'string') {
              name = p;
              config = null;
              visible = true;
            } else {
              name = p.name;
              config = p.options || {};
              visible = 'visible' in config && typeof config.visible === 'boolean' ? config.visible : true;
              delete config.visible;
            }
            var idx = pluginList.indexOf(name);
            if (idx === -1) {
              _log2.default.warning('\u6CA1\u6709 \u2018' + name + '\u2019 \u8FD9\u4E2A\u63D2\u4EF6\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u62FC\u5199\u9519\u8BEF');
            } else {
              if (visible) {
                pluginList.splice(idx, 1);
                _this5.installPlugin(name, config);
              }
            }
          });
        }
      }
      this.removeOrDisablePlugins(pluginList);
    }
  }, {
    key: 'removeOrDisablePlugins',
    value: function removeOrDisablePlugins(plugins) {
      var _this6 = this;

      if (plugins && plugins.length) {
        plugins.forEach(function (p) {
          if (p in _this6.pluginMap) {
            // ControlBar has no 'hide' method
            if (p === 'ControlBar') {
              _this6.map.removeControl(_this6.pluginMap[p]);
              delete _this6.pluginMap[p];
            } else {
              _this6.pluginMap[p].hide();
            }
          }
        });
      }
    }
  }, {
    key: 'installPlugin',
    value: function installPlugin(name, opts) {
      opts = opts || {};
      switch (name) {
        case 'Scale':
        case 'ToolBar':
        case 'OverView':
        case 'MapType':
          this.setMapPlugin(name, opts);
          break;
        case 'ControlBar':
          this.setControlBar(opts);
          break;
        default:
        // do nothing
      }
    }
  }, {
    key: 'setMapPlugin',
    value: function setMapPlugin(name, opts) {
      var _this7 = this;

      if (this.pluginMap[name]) {
        this.pluginMap[name].show();
      } else {
        var onCreated = opts.onCreated,
            restOpts = _objectWithoutProperties(opts, ['onCreated']);

        var initOpts = _extends({}, defaultOpts[name], restOpts);
        this.map.plugin(['AMap.' + name], function () {
          _this7.pluginMap[name] = new window.AMap[name](initOpts);
          _this7.map.addControl(_this7.pluginMap[name]);
          if ((0, _isFun2.default)(onCreated)) {
            onCreated(_this7.pluginMap[name]);
          }
        });
      }
    }
  }, {
    key: 'setControlBar',
    value: function setControlBar(opts) {
      var _this8 = this;

      if (this.pluginMap.ControlBar) {
        // do nothing
      } else {
        var onCreated = opts.onCreated,
            restOpts = _objectWithoutProperties(opts, ['onCreated']);

        var initOpts = _extends({}, defaultOpts.ControlBar, restOpts);
        this.map.plugin(['AMap.ControlBar'], function () {
          _this8.pluginMap.ControlBar = new window.AMap.ControlBar(initOpts);
          _this8.map.addControl(_this8.pluginMap.ControlBar);
          if ((0, _isFun2.default)(onCreated)) {
            onCreated(_this8.pluginMap.ControlBar);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      return _react2.default.createElement(
        'div',
        { style: wrapperStyle },
        _react2.default.createElement(
          'div',
          { ref: function ref(div) {
              _this9.mapWrapper = div;
            }, style: containerStyle },
          this.state.mapLoaded ? null : this.props.loading || null
        ),
        _react2.default.createElement(
          'div',
          null,
          this.state.mapLoaded ? this.renderChildren() : null
        )
      );
    }
  }, {
    key: 'instance',
    get: function get() {
      return this.map;
    }
  }]);

  return BaseMap;
}(Component);

exports.default = (0, _withPropsReactive2.default)(BaseMap);

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_CONFIG = {
  v: '1.4.0',
  hostAndPath: 'webapi.amap.com/maps',
  key: 'f97efc35164149d0c0f299e7a8adb3d2',
  callback: '__amap_init_callback',
  useAMapUI: false
};

var mainPromise = null;
var amapuiPromise = null;
var amapuiInited = false;

var APILoader = function () {
  function APILoader(_ref) {
    var key = _ref.key,
        useAMapUI = _ref.useAMapUI,
        version = _ref.version,
        protocol = _ref.protocol;

    _classCallCheck(this, APILoader);

    this.config = _extends({}, DEFAULT_CONFIG, { useAMapUI: useAMapUI, protocol: protocol });
    if (typeof window !== 'undefined') {
      if (key) {
        this.config.key = key;
      } else if ('amapkey' in window) {
        this.config.key = window.amapkey;
      }
    }
    if (version) {
      this.config.v = version;
    }
    this.protocol = protocol || window.location.protocol;
    if (this.protocol.indexOf(':') === -1) {
      this.protocol += ':';
    }
  }

  _createClass(APILoader, [{
    key: 'getScriptSrc',
    value: function getScriptSrc(cfg) {
      return this.protocol + '//' + cfg.hostAndPath + '?v=' + cfg.v + '&key=' + cfg.key + '&callback=' + cfg.callback;
    }
  }, {
    key: 'buildScriptTag',
    value: function buildScriptTag(src) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      script.src = src;
      return script;
    }
  }, {
    key: 'getAmapuiPromise',
    value: function getAmapuiPromise() {
      var script = this.buildScriptTag(this.protocol + '//webapi.amap.com/ui/1.0/main-async.js');
      var p = new Promise(function (resolve) {
        script.onload = function () {
          resolve();
        };
      });
      document.body.appendChild(script);
      return p;
    }
  }, {
    key: 'getMainPromise',
    value: function getMainPromise() {
      var _this = this;

      var script = this.buildScriptTag(this.getScriptSrc(this.config));
      var p = new Promise(function (resolve) {
        window[_this.config.callback] = function () {
          resolve();
          delete window[_this.config.callback];
        };
      });
      document.body.appendChild(script);
      return p;
    }
  }, {
    key: 'load',
    value: function load() {
      if (typeof window === 'undefined') {
        return null;
      }
      var useAMapUI = this.config.useAMapUI;

      mainPromise = mainPromise || this.getMainPromise();
      if (useAMapUI) {
        amapuiPromise = amapuiPromise || this.getAmapuiPromise();
      }
      return new Promise(function (resolve) {
        mainPromise.then(function () {
          if (useAMapUI && amapuiPromise) {
            amapuiPromise.then(function () {
              if (window.initAMapUI && !amapuiInited) {
                window.initAMapUI();
                if (typeof useAMapUI === 'function') {
                  useAMapUI();
                }
                amapuiInited = true;
              }
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    }
  }]);

  return APILoader;
}();

exports.default = APILoader;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var toCapitalString = function toCapitalString(str) {
  return str[0].toUpperCase() + str.slice(1, str.length);
};
exports.default = toCapitalString;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(48);

var _log = __webpack_require__(41);

var _log2 = _interopRequireDefault(_log);

var _withPropsReactive = __webpack_require__(50);

var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);

var _markerUtils = __webpack_require__(226);

var _common = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Marker = function (_React$Component) {
  _inherits(Marker, _React$Component);

  function Marker(props) {
    _classCallCheck(this, Marker);

    var _this = _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).call(this, props));

    if (typeof window !== 'undefined') {
      if (!props.__map__) {
        _log2.default.warning('MAP_INSTANCE_REQUIRED');
      } else {
        _this.setterMap = {
          visible: function visible(val) {
            if (val) {
              this.marker && this.marker.show();
            } else {
              this.marker && this.marker.hide();
            }
          },
          zIndex: function zIndex(val) {
            this.marker && this.marker.setzIndex(val);
          }
        };
        _this.converterMap = {
          position: _common.toLnglat,
          offset: _common.toPixel
        };
        _this.map = props.__map__;
        _this.element = _this.map.getContainer();
        setTimeout(function () {
          _this.createMarker(props);
        }, 13);
      }
    }
    return _this;
  }

  _createClass(Marker, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.map) {
        this.refreshMarkerLayout(nextProps);
      }
    }
  }, {
    key: 'createMarker',
    value: function createMarker(props) {
      var options = this.buildCreateOptions(props);
      this.marker = new window.AMap.Marker(options);

      this.marker.render = function (marker) {
        return function (component) {
          (0, _markerUtils.renderMarkerComponent)(component, marker);
        };
      }(this.marker);
      this.props.onInstanceCreated && this.props.onInstanceCreated();
      this.setMarkerLayout(props);
      this.setChildComponent(props);
    }

    // 在创建实例时根据传入配置，设置初始化选项

  }, {
    key: 'buildCreateOptions',
    value: function buildCreateOptions(props) {
      var _this2 = this;

      var opts = {};
      _markerUtils.MarkerAllProps.forEach(function (key) {
        if (key in props) {
          opts[key] = _this2.getSetterParam(key, props[key]);
        }
      });
      opts.map = this.map;
      return opts;
    }

    // 初始化标记的外观

  }, {
    key: 'setMarkerLayout',
    value: function setMarkerLayout(props) {
      if ('render' in props || 'children' in props && props.children) {
        this.createContentWrapper();
        if ('className' in props && props.className) {
          // https://github.com/ElemeFE/react-amap/issues/40
          this.contentWrapper.className = props.className;
        }
      }
    }
  }, {
    key: 'createContentWrapper',
    value: function createContentWrapper() {
      this.contentWrapper = document.createElement('div');
      this.marker.setContent(this.contentWrapper);
    }
  }, {
    key: 'setChildComponent',
    value: function setChildComponent(props) {
      if (this.contentWrapper) {
        if ('className' in props && props.className) {
          // https://github.com/ElemeFE/react-amap/issues/40
          this.contentWrapper.className = props.className;
        }
        if ('render' in props) {
          (0, _markerUtils.renderMarkerComponent)(props.render, this.marker);
        } else if ('children' in props) {
          var child = props.children;
          var childType = typeof child === 'undefined' ? 'undefined' : _typeof(child);
          if (childType !== 'undefined' && this.contentWrapper) {
            (0, _reactDom.render)(_react2.default.createElement(
              'div',
              null,
              child
            ), this.contentWrapper);
          }
        }
      }
    }
  }, {
    key: 'refreshMarkerLayout',
    value: function refreshMarkerLayout(nextProps) {
      this.setChildComponent(nextProps);
    }
  }, {
    key: 'getSetterParam',
    value: function getSetterParam(key, val) {
      if (key in this.converterMap) {
        return this.converterMap[key](val);
      }
      return val;
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }, {
    key: 'instance',
    get: function get() {
      return this.marker;
    }
  }]);

  return Marker;
}(_react2.default.Component);

exports.default = (0, _withPropsReactive2.default)(Marker);

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(48);

var _isFun = __webpack_require__(126);

var _isFun2 = _interopRequireDefault(_isFun);

var _log = __webpack_require__(41);

var _log2 = _interopRequireDefault(_log);

var _markerUtils = __webpack_require__(226);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (typeof window !== 'undefined') {
  var styleText = '.amap_markers_pop_window{\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background: #fff;\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n}\n.amap_markers_pop_window::before{\n    content: \' \';\n    display: block;\n    position: absolute;\n    bottom: -12px;\n    left: 50%;\n    margin-left: -7px;\n    width: 0;\n    height: 0;\n    border-top: 12px solid #ddd;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n}\n.amap_markers_pop_window::after{\n    content: \' \';\n    display: block;\n    position: absolute;\n    bottom: -11px;\n    left: 50%;\n    margin-left: -6px;\n    width: 0;\n    height: 0;\n    border-top: 11px solid #fff;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n}\n.amap_markers_pop_window_item{\n    cursor:pointer;\n    width: 40px;\n    height: 50px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n}\n.amap_markers_pop_window_item span{\n    pointer-events: none;\n}\n.amap_markers_window_overflow_warning{\n    text-align: center;\n    width: 100%;\n    margin: 5px 0;\n    color: #666;\n}';
  var headEl = document.head || document.getElementsByTagName('head')[0];
  var styleEl = document.createElement('style');
  styleEl.type = 'text/css';
  styleEl.textContent = styleText;
  headEl.appendChild(styleEl);
}

var Component = _react2.default.Component;

var SCALE = 0.8;
var SIZE_WIDTH = 32 * SCALE;
var SIZE_HEIGHT = 46 * SCALE - 2;
var SIZE_HOVER_WIDTH = 46 * SCALE;
var SIZE_HOVER_HEIGHT = 66 * SCALE - 2;
var MAX_INFO_MARKERS = 42;

var defaultOpts = {
  useCluster: false,
  markersCache: [],
  markerIDCache: []
};

var ClusterProps = ['gridSize', 'minClusterSize', 'maxZoom', 'averageCenter', 'styles', 'zoomOnClick', 'renderCluserMarker'];

var IdKey = '__react_amap__';

/*
 * props
 * {
 *  useCluster(boolean)是否使用聚合点
 *  markers(array<>)坐标列表
 *  __map__ 父级组件传过来的地图实例
 *  __ele__ 父级组件传过来的地图容器
 * }
 */

var Markers = function (_Component) {
  _inherits(Markers, _Component);

  function Markers(props) {
    _classCallCheck(this, Markers);

    var _this = _possibleConstructorReturn(this, (Markers.__proto__ || Object.getPrototypeOf(Markers)).call(this, props));

    if (typeof window !== 'undefined') {
      if (!props.__map__) {
        _log2.default.warning('MAP_INSTANCE_REQUIRED');
      } else {
        _this.map = props.__map__;
        _this.element = _this.map.getContainer();
        _this.markersCache = defaultOpts.markersCache;
        _this.useCluster = null;
        _this.markerIDCache = defaultOpts.markerIDCache;
        _this.resetOffset = new window.AMap.Pixel(-SIZE_WIDTH / 2, -SIZE_HEIGHT);
        _this.hoverOffset = new window.AMap.Pixel(-SIZE_HOVER_WIDTH / 2, -SIZE_HOVER_HEIGHT);
        _this.createMarkers(props);
      }
    }
    return _this;
  }

  _createClass(Markers, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'createMarkers',
    value: function createMarkers(props) {
      var _this2 = this;

      var markers = props.markers || [];

      var mapMarkers = [];
      var markerReactChildDOM = {};
      markers.length && markers.forEach(function (raw, idx) {
        var options = _this2.buildCreateOptions(props, raw, idx);
        options.map = _this2.map;

        var markerContent = null;
        if ((0, _isFun2.default)(props.render)) {
          // $FlowFixMe
          var markerChild = props.render(raw);
          if (markerChild !== false) {
            var div = document.createElement('div');
            div.setAttribute(IdKey, '1');
            markerContent = div;
            markerReactChildDOM[idx] = markerChild;
          }
        }

        if (!markerContent) {
          markerContent = document.createElement('div');
          var img = document.createElement('img');
          img.src = '//webapi.amap.com/theme/v1.3/markers/n/mark_bs.png';
          markerContent.appendChild(img);
        }
        options.content = markerContent;

        var marker = new window.AMap.Marker(options);
        marker.on('click', function (e) {
          _this2.onMarkerClick(e);
        });
        marker.on('mouseover', function (e) {
          _this2.onMarkerHover(e);
        });
        marker.on('mouseout', function (e) {
          _this2.onMarkerHoverOut(e);
        });

        marker.render = function (marker) {
          return function (component) {
            return (0, _markerUtils.renderMarkerComponent)(component, marker);
          };
        }(marker);

        _this2.bindMarkerEvents(marker);
        mapMarkers.push(marker);
      });
      this.markersCache = mapMarkers;
      this.markerReactChildDOM = markerReactChildDOM;
      this.exposeMarkerInstance();

      this.checkClusterSettings(props);
    }
  }, {
    key: 'checkClusterSettings',
    value: function checkClusterSettings(props) {
      var _this3 = this;

      if (props.useCluster) {
        this.loadClusterPlugin(props.useCluster).then(function (cluster) {
          cluster.setMarkers(_this3.markersCache);
        });
      } else {
        if (this.mapCluster) {
          var markers = this.mapCluster.getMarkers();
          this.mapCluster.clearMarkers();
          markers.forEach(function (marker) {
            marker.setMap(_this3.map);
          });
        }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.map) {
        this.setMarkerChild();
      }
    }
  }, {
    key: 'setMarkerChild',
    value: function setMarkerChild() {
      var _this4 = this;

      Object.keys(this.markerReactChildDOM).forEach(function (idx) {
        var dom = _this4.markersCache[idx].getContent();
        var child = _this4.markerReactChildDOM[idx];
        _this4.renderMarkerChild(dom, child);
      });
    }
  }, {
    key: 'renderMarkerChild',
    value: function renderMarkerChild(dom, child) {
      (0, _reactDom.render)(_react2.default.createElement(
        'div',
        null,
        child
      ), dom);
    }
  }, {
    key: 'buildCreateOptions',
    value: function buildCreateOptions(props, raw, idx) {
      var result = {};
      // 强制用户通过 render 函数来定义外观
      // const disabledKeys = ['label', 'icon', 'content'];
      // 还是不强制好，通过覆盖的方式来(如果有 render，覆盖 content/icon);
      var disabledKeys = ['extData'];
      _markerUtils.MarkerAllProps.forEach(function (key) {
        if (key in raw && disabledKeys.indexOf(key) === -1) {
          result[key] = (0, _markerUtils.getPropValue)(key, raw[key]);
        } else if (key in props) {
          if ((0, _isFun2.default)(props[key])) {
            var tmpValue = props[key].call(null, raw, idx);
            result[key] = (0, _markerUtils.getPropValue)(key, tmpValue);
          } else {
            result[key] = (0, _markerUtils.getPropValue)(key, props[key]);
          }
        }
      });
      result.extData = raw;
      return result;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.map) {
        this.refreshMarkersLayout(nextProps);
      }
    }
  }, {
    key: 'refreshMarkersLayout',
    value: function refreshMarkersLayout(nextProps) {
      var markerChanged = nextProps.markers !== this.props.markers;
      var clusterChanged = !!this.props.useCluster !== !!nextProps.useCluster;
      if (markerChanged) {
        this.markersCache.length && this.markersCache.forEach(function (marker) {
          if (marker) {
            marker.setMap(null);
            marker = null;
          }
        });
        this.markersCache = defaultOpts.markersCache;
        this.createMarkers(nextProps);
        this.setMarkerChild();
      }
      if (markerChanged || clusterChanged) {
        if (this.markersWindow) {
          this.markersWindow.close();
        }
      }
      if (clusterChanged) {
        this.checkClusterSettings(nextProps);
      }
    }
  }, {
    key: 'loadClusterPlugin',
    value: function loadClusterPlugin(clusterConfig) {
      var _this5 = this;

      if (this.mapCluster) {
        return Promise.resolve(this.mapCluster);
      }
      var config = typeof clusterConfig === 'boolean' ? {} : clusterConfig;
      return new Promise(function (resolve) {
        _this5.map.plugin(['AMap.MarkerClusterer'], function () {
          resolve(_this5.createClusterPlugin(config));
        });
      });
    }
  }, {
    key: 'createClusterPlugin',
    value: function createClusterPlugin(config) {
      var options = {};
      // const style = {
      //   url: clusterIcon,
      //   size: new window.AMap.Size(56, 56),
      //   offset: new window.AMap.Pixel(-28, -28)
      // };
      var defalutOptions = {
        minClusterSize: 2,
        zoomOnClick: false,
        maxZoom: 18,
        gridSize: 60,
        // styles: [style, style, style],
        averageCenter: true
      };

      ClusterProps.forEach(function (key) {
        if (key in config) {
          options[key] = config[key];
        } else {
          options[key] = defalutOptions[key];
        }
      });

      this.mapCluster = new window.AMap.MarkerClusterer(this.map, [], options);
      var events = {};
      if ('events' in config) {
        events = config.events;
        if ('created' in events) {
          events.created(this.mapCluster);
        }
      }
      this.initClusterMarkerWindow();
      this.bindClusterEvent(events);
      return this.mapCluster;
    }
  }, {
    key: 'onMarkerClick',
    value: function onMarkerClick(e) {
      var marker = e.target;
      this.triggerMarkerClick(e, marker);
    }
  }, {
    key: 'onMarkerHover',
    value: function onMarkerHover(e) {
      e.target.setTop(true);
      this.setMarkerHovered(e, e.target);
    }
  }, {
    key: 'onMarkerHoverOut',
    value: function onMarkerHoverOut(e) {
      e.target.setTop(false);
      this.setMarkerHoverOut(e, e.target);
    }
  }, {
    key: 'onWindowMarkerClick',
    value: function onWindowMarkerClick(element) {
      var marker = element.markerRef;
      this.triggerMarkerClick(null, marker);
    }
  }, {
    key: 'onWindowMarkerHover',
    value: function onWindowMarkerHover(element) {
      var marker = element.markerRef;
      this.setMarkerHovered(null, marker);
    }
  }, {
    key: 'onWindowMarkerHoverOut',
    value: function onWindowMarkerHoverOut(element) {
      var marker = element.markerRef;
      this.setMarkerHoverOut(null, marker);
    }
  }, {
    key: 'setMarkerHovered',
    value: function setMarkerHovered(e, marker) {
      this.triggerMarkerHover(e, marker);
    }
  }, {
    key: 'setMarkerHoverOut',
    value: function setMarkerHoverOut(e, marker) {
      this.triggerMarkerHoverOut(e, marker);
    }
  }, {
    key: 'triggerMarkerClick',
    value: function triggerMarkerClick(e, marker) {
      // const raw = marker.getExtData();
      var events = this.props.events || {};
      if ((0, _isFun2.default)(events.click)) {
        events.click(e, marker);
      }
    }
  }, {
    key: 'triggerMarkerHover',
    value: function triggerMarkerHover(e, marker) {
      // const raw = marker.getExtData();
      var events = this.props.events || {};
      if ((0, _isFun2.default)(events.mouseover)) {
        events.mouseover(e, marker);
      }
    }
  }, {
    key: 'triggerMarkerHoverOut',
    value: function triggerMarkerHoverOut(e, marker) {
      // const raw = marker.getExtData();
      var events = this.props.events || {};
      if ((0, _isFun2.default)(events.mouseout)) {
        events.mouseout(e, marker);
      }
    }
  }, {
    key: 'initClusterMarkerWindow',
    value: function initClusterMarkerWindow() {
      this.markersWindow = new window.AMap.InfoWindow({
        isCustom: true,
        autoMove: true,
        closeWhenClickMap: true,
        content: '<span>loading...</span>',
        showShadow: false,
        offset: new window.AMap.Pixel(0, -20)
      });
      this.markersDOM = document.createElement('div');
      this.markersDOM.className = 'amap_markers_pop_window';
      this.markersWindow.setContent(this.markersDOM);
    }
  }, {
    key: 'bindClusterEvent',
    value: function bindClusterEvent(events) {
      var _this6 = this;

      this.mapCluster.on('click', function (e) {
        if (_this6.props.useCluster && _this6.props.useCluster.zoomOnClick) {
          //
        } else {
          var returnValue = true;
          if ((0, _isFun2.default)(events.click)) {
            returnValue = events.click(e);
          }
          if (returnValue !== false) {
            _this6.showMarkersInfoWindow(e);
          }
        }
      });
    }
  }, {
    key: 'showMarkersInfoWindow',
    value: function showMarkersInfoWindow(e) {
      var _this7 = this;

      var pos = e.lnglat;
      var markers = e.markers;
      this.markersDOM.innerHTML = '';
      if (markers && markers.length) {
        var length = markers.length;
        if (length > MAX_INFO_MARKERS) {
          markers = markers.slice(0, MAX_INFO_MARKERS);
        }
        markers.forEach(function (m) {
          var contentDOM = m.getContent();
          var itemDOM = document.createElement('div');
          itemDOM.className = 'window_marker_item';
          itemDOM.appendChild(contentDOM);
          itemDOM.markerRef = m;
          itemDOM.addEventListener('click', _this7.onWindowMarkerClick.bind(_this7, itemDOM), true);
          itemDOM.addEventListener('mouseover', _this7.onWindowMarkerHover.bind(_this7, itemDOM), true);
          itemDOM.addEventListener('mouseout', _this7.onWindowMarkerHoverOut.bind(_this7, itemDOM), true);

          _this7.markersDOM.appendChild(itemDOM);
        });
        if (length > MAX_INFO_MARKERS) {
          var warning = document.createElement('div');
          warning.className = 'amap_markers_window_overflow_warning';
          warning.innerText = '更多坐标请放大地图查看';
          this.markersDOM.appendChild(warning);
        }
      }
      this.markersWindow.open(this.map, pos);
    }
  }, {
    key: 'exposeMarkerInstance',
    value: function exposeMarkerInstance() {
      if ('events' in this.props) {
        var events = this.props.events || {};
        if ((0, _isFun2.default)(events.created)) {
          events.created(this.markersCache);
        }
      }
    }
  }, {
    key: 'bindMarkerEvents',
    value: function bindMarkerEvents(marker) {
      var events = this.props.events || {};
      var list = Object.keys(events);
      var preserveEv = ['click', 'mouseover', 'mouseout', 'created'];
      list.length && list.forEach(function (evName) {
        if (preserveEv.indexOf(evName) === -1) {
          marker.on(evName, events[evName]);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Markers;
}(Component);

exports.default = Markers;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _withPropsReactive = __webpack_require__(50);

var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);

var _log = __webpack_require__(41);

var _log2 = _interopRequireDefault(_log);

var _common = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * props
 * {
 *  __map__ 父级组件传过来的地图实例
 * }
 */

var configurableProps = ['center', 'radius', 'draggable', 'extData',

/* 原生的接口中并没有这些对象，这是本组件的扩展 */
'visible', 'style'];

var allProps = configurableProps.concat(['zIndex', 'bubble']);

var Circle = function (_React$Component) {
  _inherits(Circle, _React$Component);

  function Circle(props) {
    _classCallCheck(this, Circle);

    var _this = _possibleConstructorReturn(this, (Circle.__proto__ || Object.getPrototypeOf(Circle)).call(this, props));

    if (typeof window !== 'undefined') {
      if (!props.__map__) {
        _log2.default.warning('MAP_INSTANCE_REQUIRED');
      } else {
        var self = _this;
        _this.setterMap = {
          visible: function visible(val) {
            if (self.mapCircle) {
              if (val) {
                self.mapCircle.show();
              } else {
                self.mapCircle.hide();
              }
            }
          },
          style: function style(val) {
            self.mapCircle && self.mapCircle.setOptions(val);
          }
        };
        _this.converterMap = {
          center: _common.toLnglat
        };
        _this.state = {
          loaded: false
        };
        _this.map = props.__map__;
        _this.element = _this.map.getContainer();
        _this.createInstance(props).then(function () {
          _this.setState({
            loaded: true
          });
          _this.props.onInstanceCreated && _this.props.onInstanceCreated();
        });
      }
    }
    return _this;
  }

  _createClass(Circle, [{
    key: 'createInstance',
    value: function createInstance(props) {
      var options = this.buildCreateOptions(props);
      options.map = this.map;
      this.mapCircle = new window.AMap.Circle(options);
      return Promise.resolve(this.mapCircle);
    }
  }, {
    key: 'buildCreateOptions',
    value: function buildCreateOptions(props) {
      var _this2 = this;

      var options = {};
      allProps.forEach(function (key) {
        if (key in props) {
          if (key === 'style' && props.style !== undefined) {
            var styleItem = Object.keys(props.style);
            styleItem.forEach(function (item) {
              // $FlowFixMe
              options[item] = props.style[item];
            });
          } else {
            options[key] = _this2.getSetterValue(key, props);
          }
        }
      });
      return options;
    }
  }, {
    key: 'getSetterValue',
    value: function getSetterValue(key, props) {
      if (key in this.converterMap) {
        return this.converterMap[key](props[key]);
      }
      return props[key];
    }
  }, {
    key: 'renderEditor',
    value: function renderEditor(children) {
      if (!children) {
        return null;
      }
      if (_react2.default.Children.count(children) !== 1) {
        return null;
      }
      return _react2.default.cloneElement(_react2.default.Children.only(children), {
        __circle__: this.mapCircle,
        __map__: this.map,
        __ele__: this.element
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.loaded ? this.renderEditor(this.props.children) : null;
    }
  }, {
    key: 'instance',
    get: function get() {
      return this.mapCircle;
    }
  }]);

  return Circle;
}(_react2.default.Component);

exports.default = (0, _withPropsReactive2.default)(Circle);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _withPropsReactive = __webpack_require__(50);

var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);

var _log = __webpack_require__(41);

var _log2 = _interopRequireDefault(_log);

var _polyeditor = __webpack_require__(162);

var _polyeditor2 = _interopRequireDefault(_polyeditor);

var _common = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * props
 * {
 *  __map__ 父级组件传过来的地图实例
 *
 * }
 */

var configurableProps = ['path', 'draggable', 'extData',

/* 本插件扩展的属性*/
'style', 'visible'];

var allProps = configurableProps.concat(['zIndex', 'bubble']);

var Polygon = function (_Component) {
  _inherits(Polygon, _Component);

  function Polygon(props) {
    _classCallCheck(this, Polygon);

    var _this = _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).call(this, props));

    if (typeof window !== 'undefined') {
      if (!props.__map__) {
        _log2.default.warning('MAP_INSTANCE_REQUIRED');
      } else {
        var self = _this;
        _this.setterMap = {
          visible: function visible(val) {
            if (val) {
              self.polygon && self.polygon.show();
            } else {
              self.polygon && self.polygon.hide();
            }
          },
          style: function style(val) {
            self.polygon.setOptions(val);
          }
        };
        _this.converterMap = {
          path: function path(val) {
            return self.buildPathValue(val);
          }
        };
        _this.state = {
          loaded: false
        };
        _this.map = props.__map__;
        _this.element = _this.map.getContainer();
        setTimeout(function () {
          _this.initMapPolygon(props);
        }, 13);
      }
    }
    return _this;
  }

  _createClass(Polygon, [{
    key: 'initMapPolygon',
    value: function initMapPolygon(props) {
      var options = this.buildCreateOptions(props);
      options.map = this.map;
      this.polygon = new window.AMap.Polygon(options);
      this.setState({
        loaded: true
      });
      this.props.onInstanceCreated && this.props.onInstanceCreated();
    }
  }, {
    key: 'buildCreateOptions',
    value: function buildCreateOptions(props) {
      var _this2 = this;

      var options = {};
      allProps.forEach(function (key) {
        if (key in props) {
          if (key === 'style' && props.style) {
            var styleItem = Object.keys(props.style);
            styleItem.forEach(function (item) {
              // $FlowFixMe
              options[item] = props.style[item];
            });
            // visible 做特殊处理
          } else if (key !== 'visible') {
            options[key] = _this2.getSetterValue(key, props[key]);
          }
        }
      });
      return options;
    }
  }, {
    key: 'detectPropChanged',
    value: function detectPropChanged(key, nextProps) {
      return this.props[key] !== nextProps[key];
    }
  }, {
    key: 'getSetterValue',
    value: function getSetterValue(key, value) {
      if (key in this.converterMap) {
        return this.converterMap[key](value);
      }
      return value;
    }
  }, {
    key: 'buildPathValue',
    value: function buildPathValue(path) {
      var _this3 = this;

      if (path.length) {
        var firstNode = path[0];
        if (typeof firstNode[0] === 'number') {
          return path.map(function (p) {
            return (0, _common.toLnglat)(p);
          });
        }
        if ('getLng' in firstNode) {
          return path;
        }
        if ('longitude' in firstNode || 'lng' in firstNode) {
          return path.map(function (p) {
            return (0, _common.toLnglat)(p);
          });
        }
        if ('length' in firstNode && firstNode.length) {
          // $FlowFixMe
          return path.map(function (ring) {
            return _this3.buildPathValue(ring);
          });
        }
      }
      return [];
    }
  }, {
    key: 'renderEditor',
    value: function renderEditor(children) {
      if (!children) {
        return null;
      }
      if (_react2.default.Children.count(children) !== 1) {
        return null;
      }
      var child = _react2.default.Children.only(children);
      if (child.type === _polyeditor2.default) {
        return _react2.default.cloneElement(child, {
          __poly__: this.polygon,
          __map__: this.map
        });
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.loaded ? this.renderEditor(this.props.children) : null;
    }
  }, {
    key: 'instance',
    get: function get() {
      return this.polygon;
    }
  }]);

  return Polygon;
}(_react.Component);

exports.default = (0, _withPropsReactive2.default)(Polygon);

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _withPropsReactive = __webpack_require__(50);

var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);

var _log = __webpack_require__(41);

var _log2 = _interopRequireDefault(_log);

var _polyeditor = __webpack_require__(162);

var _polyeditor2 = _interopRequireDefault(_polyeditor);

var _common = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = _react2.default.Component;

var configurableProps = ['path', 'extData', 'draggable',

/* 扩展属性*/
'visible', 'style'];

var allProps = configurableProps.concat(['zIndex', 'bubble', 'showDir']);

var Polyline = function (_Component) {
  _inherits(Polyline, _Component);

  function Polyline(props) {
    _classCallCheck(this, Polyline);

    var _this = _possibleConstructorReturn(this, (Polyline.__proto__ || Object.getPrototypeOf(Polyline)).call(this, props));

    if (typeof window !== 'undefined') {
      if (!props.__map__) {
        _log2.default.warning('MAP_INSTANCE_REQUIRED');
      } else {
        var self = _this;
        _this.setterMap = {
          visible: function visible(val) {
            if (val) {
              self.polyline && self.polyline.show();
            } else {
              self.polyline && self.polyline.hide();
            }
          },
          style: function style(val) {
            self.polyline.setOptions(val);
          }
        };
        _this.converterMap = {
          path: function path(val) {
            return self.buildPathValue(val);
          }
        };
        _this.state = {
          loaded: false
        };
        _this.map = props.__map__;
        _this.element = _this.map.getContainer();
        setTimeout(function () {
          _this.createMapPolyline(props);
        }, 13);
      }
    }
    return _this;
  }

  _createClass(Polyline, [{
    key: 'createMapPolyline',
    value: function createMapPolyline(props) {
      var options = this.buildCreateOptions(props);
      options.map = this.map;
      this.polyline = new window.AMap.Polyline(options);
      this.setState({
        loaded: true
      });
      this.props.onInstanceCreated && this.props.onInstanceCreated();
    }
  }, {
    key: 'buildCreateOptions',
    value: function buildCreateOptions(props) {
      var _this2 = this;

      var options = {};
      allProps.forEach(function (key) {
        if (key in props) {
          if (key === 'style' && props.style) {
            var styleItem = Object.keys(props.style);
            styleItem.forEach(function (item) {
              // $FlowFixMe
              options[item] = props.style[item];
            });
            // visible 做特殊处理
          } else if (key !== 'visible') {
            options[key] = _this2.getSetterValue(key, props[key]);
          }
        }
      });
      return options;
    }
  }, {
    key: 'detectPropChanged',
    value: function detectPropChanged(key, nextProps) {
      return this.props[key] !== nextProps[key];
    }
  }, {
    key: 'getSetterValue',
    value: function getSetterValue(key, value) {
      if (key in this.converterMap) {
        return this.converterMap[key](value);
      }
      return value;
    }
  }, {
    key: 'buildPathValue',
    value: function buildPathValue(path) {
      if (path.length) {
        if ('getLng' in path[0]) {
          return path;
        }
        return path.map(function (p) {
          return (0, _common.toLnglat)(p);
        });
      }
      return path;
    }
  }, {
    key: 'renderEditor',
    value: function renderEditor(children) {
      if (!children) {
        return null;
      }
      if (_react2.default.Children.count(children) !== 1) {
        return null;
      }
      var child = _react2.default.Children.only(children);
      if (child.type === _polyeditor2.default) {
        return _react2.default.cloneElement(child, {
          __poly__: this.polyline,
          __map__: this.map
        });
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.loaded ? this.renderEditor(this.props.children) : null;
    }
  }, {
    key: 'instance',
    get: function get() {
      return this.polyline;
    }
  }]);

  return Polyline;
}(Component);

exports.default = (0, _withPropsReactive2.default)(Polyline);

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(48);

var _withPropsReactive = __webpack_require__(50);

var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);

var _log = __webpack_require__(41);

var _log2 = _interopRequireDefault(_log);

var _common = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * props
 * {
 *  __map__ 父级组件传过来的地图实例
 * }
 */

var Component = _react2.default.Component;

var configurableProps = ['content', 'position', 'size',
/* 以下属性是本插件的扩展 */
'visible',

/* 这个 setOffset  方法高德并没有明确在文档中列出来，不确定会不会撤销 */
'offset'];

var allProps = configurableProps.concat(['isCustom', 'autoMove', 'closeWhenClickMap', 'showShadow']);

var InfoWindow = function (_Component) {
  _inherits(InfoWindow, _Component);

  function InfoWindow(props) {
    _classCallCheck(this, InfoWindow);

    var _this = _possibleConstructorReturn(this, (InfoWindow.__proto__ || Object.getPrototypeOf(InfoWindow)).call(this, props));

    if (typeof window !== 'undefined') {
      if (!props.__map__) {
        _log2.default.warning('MAP_INSTANCE_REQUIRED');
      } else {
        var self = _this;
        _this.setterMap = {
          visible: function visible(val) {
            if (val) {
              self.showWindow();
              self.setClassName(self.props);
              self.setChild(self.props);
            } else {
              self.closeWindow();
            }
          }
        };
        _this.converterMap = {
          size: _common.toSize,
          offset: _common.toPixel,
          position: _common.toLnglat
        };
        _this.map = props.__map__;
        _this.isCustom = true;
        setTimeout(function () {
          _this.createInfoWindow(props);
        }, 13);
      }
    }
    return _this;
  }

  _createClass(InfoWindow, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.map) {
        this.refreshWindowLayout(nextProps);
      }
    }
  }, {
    key: 'createInfoWindow',
    value: function createInfoWindow(props) {
      var options = this.buildCreateOptions(props);
      this.infoWindow = new window.AMap.InfoWindow(options);
      this.props.onInstanceCreated && this.props.onInstanceCreated();
    }
  }, {
    key: 'refreshWindowLayout',
    value: function refreshWindowLayout(nextProps) {
      this.setChild(nextProps);
      this.setClassName(nextProps);
    }
  }, {
    key: 'checkPropChanged',
    value: function checkPropChanged(key, nextProps) {
      return this.props[key] !== nextProps[key];
    }
  }, {
    key: 'showWindow',
    value: function showWindow() {
      this.infoWindow.open(this.map, this.infoWindow.getPosition());
    }
  }, {
    key: 'closeWindow',
    value: function closeWindow() {
      this.infoWindow.close();
    }
  }, {
    key: 'buildCreateOptions',
    value: function buildCreateOptions(props) {
      var _this2 = this;

      var options = {};

      // 如果开发者没有设置 isCustom 属性，默认设置为 false
      if ('isCustom' in props) {
        options.isCustom = !!props.isCustom;
      } else {
        options.isCustom = false;
      }

      if ('content' in props) {
        options.content = props.content;
      } else {
        this.infoDOM = document.createElement('div');
        options.content = this.infoDOM;
      }

      allProps.forEach(function (key) {
        if (key in props) {
          if (['visible', 'isCustom', 'content'].indexOf(key) === -1) {
            options[key] = _this2.getSetterValue(key, props[key]);
          }
        }
      });
      return options;
    }
  }, {
    key: 'getSetterValue',
    value: function getSetterValue(key, value) {
      if (key in this.converterMap) {
        return this.converterMap[key](value);
      }
      return value;
    }
  }, {
    key: 'setChild',
    value: function setChild(props) {
      var child = props.children;
      if (this.infoDOM && child) {
        (0, _reactDom.render)(_react2.default.createElement(
          'div',
          null,
          child
        ), this.infoDOM);
      } else {
        if (props.children) {
          console.warn('因为你设置 isCustom 为 true，InfoWindow 的 Children 被忽略');
        }
      }
    }
  }, {
    key: 'setClassName',
    value: function setClassName(props) {
      if (this.infoDOM) {
        var baseClsValue = '';
        // 刷新 className
        if ('className' in props && props.className) {
          baseClsValue += props.className;
        } else if (props.isCustom === true) {
          baseClsValue += 'amap_markers_pop_window';
        }
        this.infoDOM.className = baseClsValue;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }, {
    key: 'instance',
    get: function get() {
      return this.infoWindow;
    }
  }]);

  return InfoWindow;
}(Component);

exports.default = (0, _withPropsReactive2.default)(InfoWindow);

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _withPropsReactive = __webpack_require__(50);

var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);

var _log = __webpack_require__(41);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * props
 * {
 *  __map__ 父级组件传过来的地图实例
 * }
 */
var defaultOpts = {
  clickable: false,
  opacity: 1,
  visible: true
};

var GroundImage = function (_React$Component) {
  _inherits(GroundImage, _React$Component);

  function GroundImage(props) {
    _classCallCheck(this, GroundImage);

    var _this = _possibleConstructorReturn(this, (GroundImage.__proto__ || Object.getPrototypeOf(GroundImage)).call(this, props));

    if (typeof window !== 'undefined') {
      if (!props.__map__) {
        _log2.default.warning('MAP_INSTANCE_REQUIRED');
      } else {
        var self = _this;
        _this.setterMap = {
          visible: function visible(val) {
            if (val) {
              self.image && self.image.show();
            } else {
              self.image && self.image.hide();
            }
          },
          src: function src(val) {
            self.image.setImageUrl(val);
          }
        };
        _this.converterMap = {
          bounds: function bounds(val) {
            return self.buildBounds(val);
          }
        };
        _this.map = props.__map__;
        _this.element = _this.map.getContainer();
        setTimeout(function () {
          _this.createGroundImage(props);
        }, 13);
      }
    }
    return _this;
  }

  _createClass(GroundImage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'checkPropsChanged',
    value: function checkPropsChanged(nextProps, key) {
      return this.props[key] !== nextProps[key];
    }
  }, {
    key: 'createGroundImage',
    value: function createGroundImage(props) {
      var src = void 0,
          bounds = void 0,
          opacity = void 0,
          clickable = void 0;
      if ('src' in props) {
        src = props.src;
      } else {
        _log2.default.warning('SRC_REQUIRED', true);
      }
      if ('bounds' in props) {
        bounds = this.buildBounds(props.bounds);
      } else {
        _log2.default.warning('BOUNDS_REQUIRED', true);
      }

      if ('clickable' in props) {
        clickable = props.clickable;
      } else {
        clickable = defaultOpts.clickable;
      }
      if ('opacity' in props) {
        opacity = props.opacity;
      } else {
        opacity = defaultOpts.opacity;
      }
      this.image = new window.AMap.GroundImage(src, bounds, {
        map: this.map,
        clickable: clickable,
        opacity: opacity
      });
      this.props.onInstanceCreated && this.props.onInstanceCreated();
    }
  }, {
    key: 'buildBounds',
    value: function buildBounds(rawBounds) {
      if (!rawBounds) {
        return rawBounds;
      }
      if ('getSouthWest' in rawBounds) {
        return rawBounds;
      }
      var bounds = new window.AMap.Bounds(new window.AMap.LngLat(rawBounds.sw.longitude, rawBounds.sw.latitude), new window.AMap.LngLat(rawBounds.ne.longitude, rawBounds.ne.latitude));
      return bounds;
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }, {
    key: 'instance',
    get: function get() {
      return this.image;
    }
  }]);

  return GroundImage;
}(_react2.default.Component);

exports.default = (0, _withPropsReactive2.default)(GroundImage);

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _log = __webpack_require__(41);

var _log2 = _interopRequireDefault(_log);

var _isFun = __webpack_require__(126);

var _isFun2 = _interopRequireDefault(_isFun);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CircleEditor = function (_React$Component) {
  _inherits(CircleEditor, _React$Component);

  function CircleEditor(props) {
    _classCallCheck(this, CircleEditor);

    var _this = _possibleConstructorReturn(this, (CircleEditor.__proto__ || Object.getPrototypeOf(CircleEditor)).call(this, props));

    if (typeof window !== 'undefined') {
      if (!(props.__map__ && props.__circle__)) {
        _log2.default.warning('CIRCLE_INSTANCE_REQUIRED');
      } else {
        _this.map = props.__map__;
        _this.element = _this.map.getContainer();
        _this.circle = props.__circle__;
        _this.editorActive = false;
        _this.onPropsUpdate(props);
      }
    }
    return _this;
  }

  _createClass(CircleEditor, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.map) {
        this.onPropsUpdate(nextProps);
      }
    }
  }, {
    key: 'onPropsUpdate',
    value: function onPropsUpdate(props) {
      if ('active' in props && props.active === false) {
        this.toggleActive(false, props);
      } else {
        this.toggleActive(true, props);
      }
    }
  }, {
    key: 'toggleActive',
    value: function toggleActive(active, props) {
      if (active) {
        if (!this.editorActive) {
          this.activeEditor(props);
        }
      } else {
        if (this.editorActive) {
          this.inactiveEditor();
        }
      }
    }
  }, {
    key: 'activeEditor',
    value: function activeEditor(props) {
      var _this2 = this;

      this.loadCircleEditor(props).then(function (editor) {
        _this2.editorActive = true;
        editor.open();
      });
    }
  }, {
    key: 'inactiveEditor',
    value: function inactiveEditor() {
      this.editorActive = false;
      if (this.circleEditor) {
        this.circleEditor.close();
      }
    }
  }, {
    key: 'loadCircleEditor',
    value: function loadCircleEditor(props) {
      var _this3 = this;

      if (this.circleEditor) {
        return Promise.resolve(this.circleEditor);
      }
      return new Promise(function (resolve) {
        _this3.map.plugin(['AMap.CircleEditor'], function () {
          resolve(_this3.createEditorInstance(props));
        });
      });
    }
  }, {
    key: 'createEditorInstance',
    value: function createEditorInstance(props) {
      this.circleEditor = new window.AMap.CircleEditor(this.map, this.circle);
      var events = this.exposeEditorInstance(props);
      events && this.bindEditorEvents(events);
      return this.circleEditor;
    }
  }, {
    key: 'exposeEditorInstance',
    value: function exposeEditorInstance(props) {
      if ('events' in props) {
        var _events = props.events || {};
        if ((0, _isFun2.default)(_events.created)) {
          _events.created(this.circleEditor);
        }
        delete _events.created;
        return _events;
      }
      return false;
    }
  }, {
    key: 'bindEditorEvents',
    value: function bindEditorEvents(events) {
      var _this4 = this;

      var list = Object.keys(events);
      list.length && list.forEach(function (evName) {
        _this4.circleEditor.on(evName, events[evName]);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return CircleEditor;
}(_react2.default.Component);

exports.default = CircleEditor;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _withPropsReactive = __webpack_require__(50);

var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);

var _log = __webpack_require__(41);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MouseTool = function (_React$Component) {
  _inherits(MouseTool, _React$Component);

  function MouseTool(props) {
    _classCallCheck(this, MouseTool);

    var _this = _possibleConstructorReturn(this, (MouseTool.__proto__ || Object.getPrototypeOf(MouseTool)).call(this, props));

    if (typeof window !== 'undefined') {
      if (!props.__map__) {
        _log2.default.warning('MAP_INSTANCE_REQUIRED');
      } else {
        _this.map = props.__map__;
        _this.loadToolInstance().then(function () {
          _this.props.onInstanceCreated && _this.props.onInstanceCreated();
        });
      }
    }
    return _this;
  }

  _createClass(MouseTool, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'loadToolInstance',
    value: function loadToolInstance() {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.map.plugin(['AMap.MouseTool'], function () {
          _this2.tool = new window.AMap.MouseTool(_this2.map);
          resolve();
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }, {
    key: 'instance',
    get: function get() {
      return this.tool;
    }
  }]);

  return MouseTool;
}(_react2.default.Component);

exports.default = (0, _withPropsReactive2.default)(MouseTool);

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);__webpack_require__(388);var _infoGroup4Formal=__webpack_require__(163);var _i18n=__webpack_require__(11);var _Tabs=__webpack_require__(227);var _Tabs2=_interopRequireDefault(_Tabs);var _findIndex=__webpack_require__(228);var _findIndex2=_interopRequireDefault(_findIndex);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var _this=void 0;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var WeaTable=_comsMobx.WeaTableNew.WeaTable;var HrmResourceTotal=(_dec=(0,_mobxReact.inject)('hrmResourceTotal'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(HrmResourceTotal,_React$Component);function HrmResourceTotal(props){(0,_classCallCheck3.default)(this,HrmResourceTotal);var _this2=(0,_possibleConstructorReturn3.default)(this,(HrmResourceTotal.__proto__||(0,_getPrototypeOf2.default)(HrmResourceTotal)).call(this,props));_this2.renderCol=function(cols){var idx=(0,_findIndex2.default)(cols,function(item){return item.dataIndex==='finish';});idx!=-1&&(cols[idx].render=function(text,record){return _react2.default.createElement(_ecCom.WeaProgress,{percent:record.finish===''?0:record.finish,strokeColor:record.finishspan});});};_this=_this2;return _this2;}(0,_createClass3.default)(HrmResourceTotal,[{key:'componentDidMount',value:function componentDidMount(){var hrmResourceTotal=this.props.hrmResourceTotal;var hrmId=this.props.params.hrmId||'';hrmResourceTotal.hrmId=hrmId;hrmResourceTotal.getHasRight();}},{key:'render',value:function render(){var _this3=this;var hrmResourceTotal=this.props.hrmResourceTotal;var title=hrmResourceTotal.title,loading=hrmResourceTotal.loading,verified=hrmResourceTotal.verified,hasRight=hrmResourceTotal.hasRight,dialogParams=hrmResourceTotal.dialogParams,tabConfig=hrmResourceTotal.tabConfig,getTabIndex=hrmResourceTotal.getTabIndex,formTarget=hrmResourceTotal.formTarget;var condition=hrmResourceTotal.condition;condition=toJS(condition);var query=this.props.location.query;var form=formTarget.conditionForm,fields=formTarget.conditionFormFields;var tabProps={tabConfig:tabConfig,tabChangeHandle:tabConfig.tabChangeHandle,activeTabInfo:{activeTabKey:tabConfig.activeTabKey,activeTabIndex:getTabIndex(tabConfig.tabs,tabConfig.activeTabKey)},store:hrmResourceTotal,conditionForm:form,conditionFormFields:fields,tabBtnDef:tabConfig.buttons};var scrollProps={scroll:{y:480}};console.log("dialogParams",dialogParams);console.log("tabProps",tabProps);if(verified&&hasRight){return _react2.default.createElement('div',{className:'wea-hrm-resource-total'},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},_react2.default.createElement('div',{style:query.fromcard?{display:'none'}:{display:''}},_react2.default.createElement(_ecCom.WeaTop,{title:title(),loading:loading,icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:[],buttonSpace:10,showDropIcon:false})),_react2.default.createElement(_antd.Row,{gutter:24},_react2.default.createElement(_antd.Col,{span:'12'},_react2.default.createElement(_antd.Row,{className:'wea-hrm-resource-total-info'},condition&&condition.map(function(c,index){if(index==0){var colArr=[];c.items&&c.items.forEach(function(obj,index){colArr.push(_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{className:'wea-info-group-content-cell-label',span:6},obj.label?obj.label:_react2.default.createElement('div',null,'\xA0'),':'),_react2.default.createElement(_antd.Col,{className:'wea-info-group-content-cell-value',span:12},obj.value),obj.codeName?_react2.default.createElement(_antd.Col,{className:'wea-info-group-content-cell-value',span:6},_react2.default.createElement('a',{onClick:function onClick(){return _this3.onSelectHandle(obj,index);}},getLabel(17463,'明细'))):_react2.default.createElement(_antd.Col,{className:'wea-info-group-content-cell-value',span:6})));});return _react2.default.createElement(_antd.Col,{span:'24'},_react2.default.createElement('div',{className:'wea-info-group'},_react2.default.createElement(_antd.Row,{className:'wea-info-group-title'},_react2.default.createElement(_antd.Col,{span:24},_react2.default.createElement('div',{className:'wea-info-group-title-info'},c.title))),_react2.default.createElement(_antd.Row,{className:'wea-info-group-content'},colArr)));}}))),_react2.default.createElement(_antd.Col,{span:'12'},_react2.default.createElement(_antd.Row,{className:'wea-hrm-resource-total-info'},condition&&condition.map(function(c,index){if(index>0){return _react2.default.createElement(_antd.Col,{span:'24'},_react2.default.createElement(_infoGroup4Formal.InfoGroup4Formal1,{className:'hrm-base-group-title',items:c.items,title:c.title,showGroup:c.defaultshow}));}}))))),_react2.default.createElement(_ecCom.WeaDialog,(0,_extends3.default)({},dialogParams,{hasScroll:false}),form!=null&&form.isFormInit&&_react2.default.createElement(_Tabs2.default,tabProps,dialogParams.cType==='table'?_react2.default.createElement(WeaTable,(0,_extends3.default)({comsWeaTableStore:dialogParams.table,hasOrder:true,needScroll:true,getColumns:function getColumns(cols){return _this3.renderCol(cols);}},scrollProps)):_react2.default.createElement(_ecCom.WeaTree,{datas:hrmResourceTotal.toJS(dialogParams.treeData),rowKey:'categoryid'}))));}if(verified&&!hasRight){return _react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},_i18n.i18n.message.authFailed()));}return _react2.default.createElement('div',null);}},{key:'onSelectHandle',value:function onSelectHandle(obj,index){this.props.hrmResourceTotal.onSelectHandle(obj,index);}},{key:'getRightMenu',value:function getRightMenu(){var arr=[{icon:_react2.default.createElement('i',{className:'icon-coms-ws'}),content:_i18n.i18n.button.search()},{icon:_react2.default.createElement('i',{className:'icon-coms-task-list'}),content:_i18n.i18n.button.columnVisibleSetting()}];return arr;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmResourceTotal=this.props.hrmResourceTotal;switch(key){case'0'://hrmResourceTotal.doSearch();
break;case'1'://this.definedColumn();
break;}}}]);return HrmResourceTotal;}(_react2.default.Component))||_class)||_class);exports.default=HrmResourceTotal;

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _lodash=__webpack_require__(65);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var AdvanceSearchFormInfo=function(_Component){(0,_inherits3.default)(AdvanceSearchFormInfo,_Component);function AdvanceSearchFormInfo(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,AdvanceSearchFormInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=AdvanceSearchFormInfo.__proto__||(0,_getPrototypeOf2.default)(AdvanceSearchFormInfo)).call.apply(_ref,[this].concat(args))),_this),_this.renderForm=function(){var _this$props=_this.props,form=_this$props.form,formFields=_this$props.formFields,itemRender=_this$props.itemRender;var arr=[];var formParams=form.getFormParams();formFields.map(function(c){var _arr=[];c.items.map(function(field,index){var customerRender=itemRender!=null?itemRender[field.domkey[0]]:null;var itemProps={ratio1to2:true,label:field.label,labelCol:{span:''+window.HrmEngineLabelCol},error:form.getError(field),tipPosition:'bottom',wrapperCol:{span:''+window.HrmEngineWrapperCol}};var coms=void 0;if(customerRender==null){coms=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form});}else{coms=customerRender(field,form,formParams);}coms!=null&&_arr.push(_react2.default.createElement(_antd.Col,{span:11,offset:index%2===0?1:0},_react2.default.createElement(_ecCom.WeaFormItem,{ratio1to2:true,label:''+field.label,labelCol:{span:''+window.HrmEngineLabelCol},error:form.getError(field),tipPosition:'bottom',wrapperCol:{span:''+window.HrmEngineWrapperCol}},coms)));if(_arr.length===2||index===c.items.length-1){var clone=[].concat(_arr);_arr.length=0;arr.push(_react2.default.createElement(_antd.Row,{gutter:8,style:{marginTop:'10px'}},clone));}});});return _react2.default.createElement(_antd.Form,null,arr);},_this.renderGroupForm=function(){var _this$props2=_this.props,form=_this$props2.form,formFields=_this$props2.formFields,itemRender=_this$props2.itemRender;var formParams=form.getFormParams();var arr=[];formFields.map(function(c){var _arr=[];c.items.map(function(field,index){var customerRender=itemRender!=null?itemRender[field.domkey[0]]:null;var itemProps={ratio1to2:true,label:field.label,labelCol:{span:''+window.HrmEngineLabelCol},error:form.getError(field),tipPosition:'bottom',wrapperCol:{span:''+window.HrmEngineWrapperCol}};var coms=void 0;if(customerRender==null){coms=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form});}else{coms=customerRender(field,form,formParams);}coms!=null&&_arr.push({com:_react2.default.createElement(_ecCom.WeaFormItem,{ratio1to2:true,label:''+field.label,labelCol:{span:''+window.HrmEngineLabelCol},error:form.getError(field),wrapperCol:{span:''+window.HrmEngineWrapperCol}},coms),col:field.colSpan||2});});arr.push(_react2.default.createElement(_ecCom.WeaSearchGroup,{showGroup:c.defaultshow,items:_arr,fontSize:13}));});return arr;},_this.renderFormComponent=function(){var formFields=_this.props.formFields;var com=formFields.length>1?_this.renderGroupForm():_this.renderForm();return com;},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(AdvanceSearchFormInfo,[{key:'render',value:function render(){return _react2.default.createElement(_ecCom.WeaNewScroll,{height:'100%'},this.renderGroupForm());}}]);return AdvanceSearchFormInfo;}(_react.Component);exports.default=AdvanceSearchFormInfo;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(391),
    getMatchData = __webpack_require__(402),
    matchesStrictComparable = __webpack_require__(234);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(156),
    baseIsEqual = __webpack_require__(231);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(156),
    equalArrays = __webpack_require__(232),
    equalByTag = __webpack_require__(398),
    equalObjects = __webpack_require__(401),
    getTag = __webpack_require__(94),
    isArray = __webpack_require__(29),
    isBuffer = __webpack_require__(119),
    isTypedArray = __webpack_require__(153);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(158),
    setCacheAdd = __webpack_require__(394),
    setCacheHas = __webpack_require__(395);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 395 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(95),
    Uint8Array = __webpack_require__(222),
    eq = __webpack_require__(157),
    equalArrays = __webpack_require__(232),
    mapToArray = __webpack_require__(399),
    setToArray = __webpack_require__(400);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 399 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(220);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(233),
    keys = __webpack_require__(97);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(231),
    get = __webpack_require__(404),
    hasIn = __webpack_require__(408),
    isKey = __webpack_require__(166),
    isStrictComparable = __webpack_require__(233),
    matchesStrictComparable = __webpack_require__(234),
    toKey = __webpack_require__(98);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(164);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(406);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(407);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(158);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(409),
    hasPath = __webpack_require__(410);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 409 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(165),
    isArguments = __webpack_require__(151),
    isArray = __webpack_require__(29),
    isIndex = __webpack_require__(159),
    isLength = __webpack_require__(152),
    toKey = __webpack_require__(98);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(412),
    basePropertyDeep = __webpack_require__(413),
    isKey = __webpack_require__(166),
    toKey = __webpack_require__(98);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 412 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(164);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(415);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(224);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _comsMobx=__webpack_require__(10);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;window.openFullWindowForXtable=PublicFunc.openFullWindowForXtable;var WeaTable=_comsMobx.WeaTableNew.WeaTable;var _this=void 0;var HrmOnline=(_dec=(0,_mobxReact.inject)('hrmOnline'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(HrmOnline,_React$Component);function HrmOnline(props){(0,_classCallCheck3.default)(this,HrmOnline);var _this2=(0,_possibleConstructorReturn3.default)(this,(HrmOnline.__proto__||(0,_getPrototypeOf2.default)(HrmOnline)).call(this,props));_this2.onOperatesClick=function(record,index,operate,flag,argumentString){var hrmOnline=_this2.props.hrmOnline;var fn=operate.href?operate.href.split(':')[1].split('(')[0]:'';var id=record.id?record.id:'';if(fn=='forcedOffline'){hrmOnline.forcedOffline(id);}else{PublicFunc[fn](id);}};_this=_this2;var funcs=['onOperatesClick','jumpToHrmCard'];funcs.forEach(function(f){return _this2[f]=_this2[f].bind(_this2);});return _this2;}(0,_createClass3.default)(HrmOnline,[{key:'componentDidMount',value:function componentDidMount(){var hrmOnline=this.props.hrmOnline;hrmOnline.getData();}},{key:'render',value:function render(){var _this3=this;var hrmOnline=this.props.hrmOnline;var title=hrmOnline.title,form=hrmOnline.form,table=hrmOnline.table,showSearchAd=hrmOnline.showSearchAd,searchParamsAd=hrmOnline.searchParamsAd;var formParams=form.getFormParams();return _react2.default.createElement('div',{className:'wea-myhrm-Online'},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},_react2.default.createElement(_ecCom.WeaTop,{title:title(),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:[],buttonSpace:10,showDropIcon:false},_react2.default.createElement(_ecCom.WeaTab,{buttonsAd:this.getTabButtonsAd(),searchType:['base','advanced'],searchsBaseValue:formParams.lastname,setShowSearchAd:function setShowSearchAd(bool){hrmOnline.setShowSearchAd(bool);},hideSearchAd:function hideSearchAd(){return hrmOnline.setShowSearchAd(false);},searchsAd:_react2.default.createElement(_antd.Form,{horizontal:true},this.getSearchs()),showSearchAd:showSearchAd,onSearch:function onSearch(v){hrmOnline.doSearch();},onSearchChange:function onSearchChange(v){form.updateFields({lastname:{name:'lastname',value:v}});}}),_react2.default.createElement(WeaTable,{comsWeaTableStore:table//hasOrder={true}
,needScroll:true,getColumns:function getColumns(c){return _this3.reRenderColumns(c);},onOperatesClick:this.onOperatesClick}))));}},{key:'getSearchs',value:function getSearchs(){var hrmOnline=this.props.hrmOnline;var form=hrmOnline.form,condition=hrmOnline.condition;var isFormInit=form.isFormInit;var group=[];var formParams=form.getFormParams();isFormInit&&!(0,_isEmpty2.default)(condition)&&toJS(condition).map(function(c){var items=[];c.items.map(function(fields){var hide=false;var dom=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:fields,form:form,formParams:formParams});items.push({com:_react2.default.createElement(_ecCom.WeaFormItem,{label:''+fields.label,labelCol:{span:''+fields.labelcol},wrapperCol:{span:''+fields.fieldcol}},dom),colSpan:1,hide:hide});});group.push(_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:c.title,showGroup:c.defaultshow,items:items}));});return group;}},{key:'reRenderColumns',value:function reRenderColumns(columns){columns.forEach(function(c){if(c.dataIndex=='lastname'){c.render=function(text,record){return _react2.default.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:_this.jumpToHrmCard.bind(null,record.id)},record.lastname);};}else{c.render=function(text,record){var valueSpan=record[c.dataIndex+"span"]!==undefined?record[c.dataIndex+"span"]:record[c.dataIndex];return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:valueSpan}});};}});return columns;}},{key:'jumpToHrmCard',value:function jumpToHrmCard(hrmId){PublicFunc.jumpToHrmCard(hrmId);}},{key:'getRightMenu',value:function getRightMenu(){var keys=this.getSelectedRowKeys();var arr=[{icon:_react2.default.createElement('i',{className:'icon-coms-ws'}),content:_i18n.i18n.button.search()},{icon:_react2.default.createElement('i',{className:'icon-coms-task-list'}),content:_i18n.i18n.button.columnVisibleSetting()}];return arr;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmOnline=this.props.hrmOnline;switch(key){case'0':hrmOnline.doSearch();break;case'1':this.definedColumn();break;}}},{key:'getSelectedRowKeys',value:function getSelectedRowKeys(){var hrmOnline=this.props.hrmOnline;var table=hrmOnline.table;var selectedRowKeys=table.selectedRowKeys;return selectedRowKeys;}},{key:'definedColumn',value:function definedColumn(){var hrmOnline=this.props.hrmOnline;var table=hrmOnline.table;table.setColSetVisible(true);table.tableColSet(true);}},{key:'getTabButtonsAd',value:function getTabButtonsAd(){var hrmOnline=this.props.hrmOnline;var form=hrmOnline.form,searchParamsAd=hrmOnline.searchParamsAd;return[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmOnline.doSearch();hrmOnline.setShowSearchAd(false);}},_i18n.i18n.button.search()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){form.reset();}},_i18n.i18n.button.reset()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){hrmOnline.setShowSearchAd(false);}},_i18n.i18n.button.cancel())];}}]);return HrmOnline;}(_react2.default.Component))||_class)||_class);exports.default=HrmOnline;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _comsMobx=__webpack_require__(10);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var WeaTable=_comsMobx.WeaTableNew.WeaTable;var _this=void 0;var HrmUnderling=(_dec=(0,_mobxReact.inject)('hrmUnderling'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(HrmUnderling,_React$Component);function HrmUnderling(props){(0,_classCallCheck3.default)(this,HrmUnderling);var _this2=(0,_possibleConstructorReturn3.default)(this,(HrmUnderling.__proto__||(0,_getPrototypeOf2.default)(HrmUnderling)).call(this,props));_this2.onOperatesClick=function(record,index,operate,flag,argumentString){var fn=operate.href?operate.href.split(':')[1].split('(')[0]:'';var id=record.id?record.id:'';PublicFunc[fn](id);};_this=_this2;var funcs=['onOperatesClick','jumpToHrmCard'];funcs.forEach(function(f){return _this2[f]=_this2[f].bind(_this2);});return _this2;}(0,_createClass3.default)(HrmUnderling,[{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location.key!==nextProps.location.key){this.init();}}},{key:'init',value:function init(){var hrmUnderling=this.props.hrmUnderling;var hrmId=this.props.params.hrmId||'';hrmUnderling.id=hrmId;hrmUnderling.lastname='';hrmUnderling.showAllLevel=false;hrmUnderling.getSearchList();}},{key:'getTopButtons',value:function getTopButtons(){var _this3=this;var hrmUnderling=this.props.hrmUnderling;var showAllLevel=hrmUnderling.showAllLevel;var btns=[];var btnShowAllLevel=_react2.default.createElement(_antd.Button,{size:'small',style:{height:'28px'},onClick:function onClick(){return _this3.changeShowAllLevel();},title:showAllLevel?_i18n.i18n.button.directSubordinates():_i18n.i18n.button.DisplaySubordinateSubordinates()},_react2.default.createElement('span',null,showAllLevel?_react2.default.createElement('i',{className:'icon-coms-DisplaySubordinates',style:{color:'#2db7f5'}}):_react2.default.createElement('i',{className:'icon-coms-NoDisplayOfSubordinates'})));btns.push(btnShowAllLevel);btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmUnderling.getSearchList();}},_i18n.i18n.button.search()));return btns;}},{key:'changeShowAllLevel',value:function changeShowAllLevel(){var hrmUnderling=this.props.hrmUnderling;hrmUnderling.changeShowAllLevel();}},{key:'render',value:function render(){var _this4=this;var hrmUnderling=this.props.hrmUnderling;var title=hrmUnderling.title,lastname=hrmUnderling.lastname,table=hrmUnderling.table;if(window.location.href.indexOf("/spa/hrm/index_mobx.html")>-1){if(title){document.title=title;}}return _react2.default.createElement('div',{className:'wea-myhrm-Underling'},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu()},_react2.default.createElement(_ecCom.WeaTop,{title:title,icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu()},_react2.default.createElement(_ecCom.WeaTab,{searchType:['base'],searchsBaseValue:lastname,onSearch:function onSearch(v){hrmUnderling.getSearchList();},onSearchChange:function onSearchChange(v){hrmUnderling.lastname=v;}}),_react2.default.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true,getColumns:function getColumns(c){return _this4.reRenderColumns(c);},onOperatesClick:this.onOperatesClick}))));}},{key:'reRenderColumns',value:function reRenderColumns(columns){columns.forEach(function(c){if(c.dataIndex=='lastname'){c.render=function(text,record){return _react2.default.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:_this.jumpToHrmCard.bind(null,record.id)},record.lastname);};}else{c.render=function(text,record){var valueSpan=record[c.dataIndex+"span"]!==undefined?record[c.dataIndex+"span"]:record[c.dataIndex];return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:valueSpan}});};}});return columns;}},{key:'jumpToHrmCard',value:function jumpToHrmCard(hrmId){PublicFunc.jumpToHrmCard(hrmId);}},{key:'getRightMenu',value:function getRightMenu(){var _this5=this;var keys=this.getSelectedRowKeys();var hrmUnderling=this.props.hrmUnderling;var arr=[{icon:_react2.default.createElement('i',{className:'icon-coms-ws'}),content:_i18n.i18n.button.search(),key:'getSearchList',onClick:function onClick(key){hrmUnderling.getSearchList();}},{icon:_react2.default.createElement('i',{className:'icon-coms-task-list'}),content:_i18n.i18n.button.columnVisibleSetting(),key:'definedColumn',onClick:function onClick(key){_this5.definedColumn();}}];return arr;}},{key:'getSelectedRowKeys',value:function getSelectedRowKeys(){var hrmUnderling=this.props.hrmUnderling;var table=hrmUnderling.table;var selectedRowKeys=table.selectedRowKeys;return selectedRowKeys;}},{key:'definedColumn',value:function definedColumn(){var hrmUnderling=this.props.hrmUnderling;var table=hrmUnderling.table;table.setColSetVisible(true);table.tableColSet(true);}}]);return HrmUnderling;}(_react2.default.Component))||_class)||_class);exports.default=HrmUnderling;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(38);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _comsMobx=__webpack_require__(10);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;window.openFullWindowForXtable=PublicFunc.openFullWindowForXtable;var WeaTable=_comsMobx.WeaTableNew.WeaTable;var _this=void 0;var HrmTrainRecord=(_dec=(0,_mobxReact.inject)('hrmTrainRecord'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(HrmTrainRecord,_React$Component);function HrmTrainRecord(props){(0,_classCallCheck3.default)(this,HrmTrainRecord);var _this2=(0,_possibleConstructorReturn3.default)(this,(HrmTrainRecord.__proto__||(0,_getPrototypeOf2.default)(HrmTrainRecord)).call(this,props));_this2.onOperatesClick=function(record,index,operate,flag,argumentString){var hrmTrainRecord=_this2.props.hrmTrainRecord;var condition=hrmTrainRecord.condition;var fn=operate.href?operate.href.split(':')[1].split('(')[0]:'';var id=record.id?record.id:'';var applyworkflowid=!(0,_isEmpty2.default)(toJS(condition))&&toJS(condition)[0].applyworkflowid;if(fn&&fn=='jsHrmTrainApply'){PublicFunc[fn](id,applyworkflowid);}else{PublicFunc[fn](id);}};_this=_this2;var funcs=['onOperatesClick'];funcs.forEach(function(f){return _this2[f]=_this2[f].bind(_this2);});return _this2;}(0,_createClass3.default)(HrmTrainRecord,[{key:'componentDidMount',value:function componentDidMount(){this.changeTab('1');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location.key!==nextProps.location.key){this.changeTab('1');}}},{key:'render',value:function render(){var _React$createElement;var hrmTrainRecord=this.props.hrmTrainRecord;var title=hrmTrainRecord.title,form=hrmTrainRecord.form,table=hrmTrainRecord.table,showSearchAd=hrmTrainRecord.showSearchAd,searchParamsAd=hrmTrainRecord.searchParamsAd,tabkey=hrmTrainRecord.tabkey,tabDatas=hrmTrainRecord.tabDatas;tabDatas=toJS(tabDatas);var query=this.props.location.query;var formParams=form.getFormParams();return _react2.default.createElement('div',{className:'wea-myhrm-Trainrecord'},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},_react2.default.createElement('div',{style:query.fromcard?{display:'none'}:{display:''}},_react2.default.createElement(_ecCom.WeaTop,{title:title(),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:[],buttonSpace:10,showDropIcon:false})),_react2.default.createElement(_ecCom.WeaTab,(_React$createElement={selectedKey:tabkey,datas:[{title:_i18n.i18n.module.trainRecord(),key:"1"},{title:_i18n.i18n.label.trainingArrangements(),key:"2"}],keyParam:'key'},(0,_defineProperty3.default)(_React$createElement,'selectedKey',tabkey),(0,_defineProperty3.default)(_React$createElement,'onChange',this.changeTab.bind(this)),(0,_defineProperty3.default)(_React$createElement,'buttonsAd',this.getTabButtonsAd()),(0,_defineProperty3.default)(_React$createElement,'searchType',['base','advanced']),(0,_defineProperty3.default)(_React$createElement,'searchsBaseValue',formParams.planname),(0,_defineProperty3.default)(_React$createElement,'setShowSearchAd',function setShowSearchAd(bool){hrmTrainRecord.setShowSearchAd(bool);}),(0,_defineProperty3.default)(_React$createElement,'hideSearchAd',function hideSearchAd(){return hrmTrainRecord.setShowSearchAd(false);}),(0,_defineProperty3.default)(_React$createElement,'searchsAd',this.getSearchs()),(0,_defineProperty3.default)(_React$createElement,'showSearchAd',showSearchAd),(0,_defineProperty3.default)(_React$createElement,'onSearch',function onSearch(v){hrmTrainRecord.doSearch();}),(0,_defineProperty3.default)(_React$createElement,'onSearchChange',function onSearchChange(v){form.updateFields({planname:{name:'planname',value:v}});}),_React$createElement)),_react2.default.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true//onOperatesClick={this.onOperatesClick}
})));}},{key:'changeTab',value:function changeTab(key){var hrmTrainRecord=this.props.hrmTrainRecord;hrmTrainRecord.changeTab(key);}},{key:'getSearchs',value:function getSearchs(){var hrmTrainRecord=this.props.hrmTrainRecord;var form=hrmTrainRecord.form,condition=hrmTrainRecord.condition;var isFormInit=form.isFormInit;var group=[];var formParams=form.getFormParams();isFormInit&&toJS(condition).map(function(c){var items=[];c.items.map(function(fields){var hide=false;var dom=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:fields,form:form,formParams:formParams});items.push({com:_react2.default.createElement(_ecCom.WeaFormItem,{label:''+fields.label,labelCol:{span:''+fields.labelcol},wrapperCol:{span:''+fields.fieldcol}},dom),colSpan:1,hide:hide});});group.push(_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:c.title,showGroup:c.defaultshow,items:items}));});return group;}},{key:'getRightMenu',value:function getRightMenu(){var keys=this.getSelectedRowKeys();var arr=[{icon:_react2.default.createElement('i',{className:'icon-coms-ws'}),content:_i18n.i18n.button.search()},{icon:_react2.default.createElement('i',{className:'icon-coms-task-list'}),content:_i18n.i18n.button.columnVisibleSetting()}];return arr;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmTrainRecord=this.props.hrmTrainRecord;switch(key){case'0':hrmTrainRecord.doSearch();break;case'1':this.definedColumn();break;}}},{key:'getSelectedRowKeys',value:function getSelectedRowKeys(){var hrmTrainRecord=this.props.hrmTrainRecord;var table=hrmTrainRecord.table;var selectedRowKeys=table.selectedRowKeys;return selectedRowKeys;}},{key:'definedColumn',value:function definedColumn(){var hrmTrainRecord=this.props.hrmTrainRecord;var table=hrmTrainRecord.table;table.setColSetVisible(true);table.tableColSet(true);}},{key:'getTabButtonsAd',value:function getTabButtonsAd(){var hrmTrainRecord=this.props.hrmTrainRecord;var form=hrmTrainRecord.form,searchParamsAd=hrmTrainRecord.searchParamsAd;return[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmTrainRecord.doSearch();hrmTrainRecord.setShowSearchAd(false);}},_i18n.i18n.button.search()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){form.reset();}},_i18n.i18n.button.reset()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){hrmTrainRecord.setShowSearchAd(false);}},_i18n.i18n.button.cancel())];}}]);return HrmTrainRecord;}(_react2.default.Component))||_class)||_class);exports.default=HrmTrainRecord;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _comsMobx=__webpack_require__(10);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;window.openFullWindowForXtable=PublicFunc.openFullWindowForXtable;var WeaTable=_comsMobx.WeaTableNew.WeaTable;var _this=void 0;var HrmRewardsRecord=(_dec=(0,_mobxReact.inject)('hrmRewardsRecord'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(HrmRewardsRecord,_React$Component);function HrmRewardsRecord(props){(0,_classCallCheck3.default)(this,HrmRewardsRecord);var _this2=(0,_possibleConstructorReturn3.default)(this,(HrmRewardsRecord.__proto__||(0,_getPrototypeOf2.default)(HrmRewardsRecord)).call(this,props));_this2.onOperatesClick=function(record,index,operate,flag,argumentString){var fn=operate.href?operate.href.split(':')[1].split('(')[0]:'';var id=record.id?record.id:'';PublicFunc[fn](id);};_this=_this2;var funcs=['onOperatesClick'];funcs.forEach(function(f){return _this2[f]=_this2[f].bind(_this2);});return _this2;}(0,_createClass3.default)(HrmRewardsRecord,[{key:'componentDidMount',value:function componentDidMount(){var hrmRewardsRecord=this.props.hrmRewardsRecord;this.changeTab('1');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location.key!==nextProps.location.key){this.changeTab('1');}}},{key:'render',value:function render(){var hrmRewardsRecord=this.props.hrmRewardsRecord;var title=hrmRewardsRecord.title,form=hrmRewardsRecord.form,table=hrmRewardsRecord.table,tabkey=hrmRewardsRecord.tabkey,tabDatas=hrmRewardsRecord.tabDatas,isshowrecord=hrmRewardsRecord.isshowrecord;var qname='';var query=this.props.location.query;var formParams=form.getFormParams();return _react2.default.createElement('div',{className:'wea-myhrm-rewardsrecord'},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},_react2.default.createElement('div',{style:query.fromcard?{display:'none'}:{display:''}},_react2.default.createElement(_ecCom.WeaTop,{title:title(),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:[],buttonSpace:10,showDropIcon:false})),_react2.default.createElement(_ecCom.WeaTab,{selectedKey:tabkey,datas:tabDatas(),searchType:['base'],keyParam:'key',onChange:this.changeTab.bind(this),searchsBaseValue:formParams.qname,onSearch:function onSearch(v){hrmRewardsRecord.doSearch({qname:qname});},onSearchChange:function onSearchChange(v){qname=v;}}),_react2.default.createElement('div',{className:'wea-new-table',style:tabkey=='2'?{display:'none'}:{}},this.getTables()),_react2.default.createElement('div',{style:tabkey=='1'&&!isshowrecord?{display:'none'}:{height:'100%'}},_react2.default.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true//onOperatesClick={this.onOperatesClick}
}))));}},{key:'getTables',value:function getTables(){var hrmRewardsRecord=this.props.hrmRewardsRecord;var tableinfo=hrmRewardsRecord.tableinfo;var tableinfoData=!(0,_isEmpty2.default)(tableinfo)&&toJS(tableinfo);var tabs=[];if(!(0,_isEmpty2.default)(tableinfoData)){tableinfoData.forEach(function(table){var columns=table.tabinfo.columns;// columns[0].render=(text,record)=>{
//   return <a href={"/hrm/HrmTab.jsp?_fromURL=HrmResourceRewardsRecordDetail&checkid="+record.key} target='blank'>{text}</a>
// }
table&&tabs.push(_react2.default.createElement('div',null,_react2.default.createElement('span',{style:{lineHeight:'40px'}},table.tabinfo.tabname),_react2.default.createElement(_antd.Table,{dataSource:table.tabinfo.datas,columns:columns,pagination:false})));});}return tabs;}},{key:'changeTab',value:function changeTab(key){var hrmRewardsRecord=this.props.hrmRewardsRecord;hrmRewardsRecord.changeTab(key);}},{key:'getRightMenu',value:function getRightMenu(){var keys=this.getSelectedRowKeys();var arr=[{icon:_react2.default.createElement('i',{className:'icon-coms-ws'}),content:_i18n.i18n.button.search()},{icon:_react2.default.createElement('i',{className:'icon-coms-task-list'}),content:_i18n.i18n.button.columnVisibleSetting()}];return arr;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmRewardsRecord=this.props.hrmRewardsRecord;switch(key){case'0':hrmRewardsRecord.doSearch();break;case'1':this.definedColumn();break;}}},{key:'getSelectedRowKeys',value:function getSelectedRowKeys(){var hrmRewardsRecord=this.props.hrmRewardsRecord;var table=hrmRewardsRecord.table;var selectedRowKeys=table.selectedRowKeys;return selectedRowKeys;}},{key:'definedColumn',value:function definedColumn(){var hrmRewardsRecord=this.props.hrmRewardsRecord;var table=hrmRewardsRecord.table;table.setColSetVisible(true);table.tableColSet(true);}}]);return HrmRewardsRecord;}(_react2.default.Component))||_class)||_class);exports.default=HrmRewardsRecord;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(143);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;window.openFullWindowForXtable=PublicFunc.openFullWindowForXtable;var WeaTable=_comsMobx.WeaTableNew.WeaTable;var _this=void 0;var HrmFinance=(_dec=(0,_mobxReact.inject)('hrmFinance'),_dec2=(0,_mobxReact.inject)('hrmCard'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(HrmFinance,_React$Component);function HrmFinance(props){(0,_classCallCheck3.default)(this,HrmFinance);var _this2=(0,_possibleConstructorReturn3.default)(this,(HrmFinance.__proto__||(0,_getPrototypeOf2.default)(HrmFinance)).call(this,props));_this2.reRenderColumns=function(columns){columns.forEach(function(c){if(c.dataIndex.indexOf('column_')!=-1){c.render=function(text,record){return _react2.default.createElement('span',{title:record[c.dataIndex].titles||''},(0,_typeof3.default)(record[c.dataIndex])=='object'?record[c.dataIndex].value:record[c.dataIndex]);};}});return columns;};_this=_this2;var funcs=['editCard','backCard','saveEditCard','onTabChange'];funcs.forEach(function(f){return _this2[f]=_this2[f].bind(_this2);});return _this2;}(0,_createClass3.default)(HrmFinance,[{key:'componentDidMount',value:function componentDidMount(){var hrmCard=this.props.hrmCard;hrmCard.setTopButtons(this.getTopButtons.bind(this));hrmCard.setTopRightMenus(this.getRightMenu.bind(this));hrmCard.setTopShowDropIcon(true);this.init();}},{key:'init',value:function init(){var hrmFinance=this.props.hrmFinance;var hrmId=this.props.params.hrmId||'';hrmFinance.hrmId=hrmId;hrmFinance.init();hrmFinance.getTabInfo();}},{key:'render',value:function render(){var hrmFinance=this.props.hrmFinance;var title=hrmFinance.title,form=hrmFinance.form,tabDatas=hrmFinance.tabDatas,table=hrmFinance.table,formFields=hrmFinance.formFields,tabkey=hrmFinance.tabkey,isEditor=hrmFinance.isEditor;var qname='';var query=this.props.location.query;var formParams=form.getFormParams();return _react2.default.createElement('div',{className:'wea-myhrm-finance wea-myhrm',style:{background:'#ffffff',height:'100%',position:'relative'}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},_react2.default.createElement('div',{style:{minHeight:window.innerHeight-146}},_react2.default.createElement('div',{style:query.fromcard?{display:'none'}:{display:''}},_react2.default.createElement(_ecCom.WeaTop,{title:title(),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu()})),_react2.default.createElement(_antd.Spin,{spinning:(0,_isEmpty2.default)(toJS(table))&&(0,_isEmpty2.default)(toJS(formFields))},_react2.default.createElement('div',{className:'hrm-my-card-basicInfo hrm-my-cardInfo'},this.getFormField()),_react2.default.createElement('div',{style:isEditor||(0,_isEmpty2.default)(tabDatas)?{display:'none'}:{height:'100%'}},_react2.default.createElement(_ecCom.WeaTab,{selectedKey:tabkey,datas:tabDatas,keyParam:'key',onChange:this.onTabChange}),this.getTable())))));}},{key:'editCard',value:function editCard(){var hrmFinance=this.props.hrmFinance;hrmFinance.edit();}},{key:'saveEditCard',value:function saveEditCard(){var hrmFinance=this.props.hrmFinance;hrmFinance.save();}},{key:'backCard',value:function backCard(){this.init();}},{key:'getTable',value:function getTable(){var hrmFinance=this.props.hrmFinance;var table=hrmFinance.table;table=toJS(table);if(!(0,_isEmpty2.default)(table)){return _react2.default.createElement('div',{className:'wea-new-table'},_react2.default.createElement(_antd.Table,{dataSource:table.datas,columns:this.reRenderColumns(table.columns),pagination:false}));}}},{key:'getFormField',value:function getFormField(){var hrmFinance=this.props.hrmFinance;var form=hrmFinance.form,formFields=hrmFinance.formFields,isEditor=hrmFinance.isEditor;var isFormInit=form.isFormInit;var group=[];formFields=toJS(formFields);isFormInit&&formFields.forEach(function(c){var items=[];c.items.forEach(function(field){items.push({com:_react2.default.createElement(_ecCom.WeaFormItem,{underline:!isEditor,label:''+field.label,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form})),colSpan:1});});group.push(_react2.default.createElement(_ecCom.WeaSearchGroup,{className:(isEditor?'hrm-center':'')+' '+(c.isHide?'wea-hide':''),needTigger:true,title:c.title,showGroup:c.defaultshow,items:items,col:window.HrmGroupCol}));});return group;}},{key:'onTabChange',value:function onTabChange(key){var hrmFinance=this.props.hrmFinance;hrmFinance.changeTab(key);}},{key:'getRightMenu',value:function getRightMenu(){var _this3=this;var _props=this.props,hrmFinance=_props.hrmFinance,hrmCard=_props.hrmCard;var isEditor=hrmFinance.isEditor,buttons=hrmFinance.buttons;var arr=[];if(buttons&&buttons.hasEdit){if(isEditor){arr=[{icon:_react2.default.createElement('i',{className:'icon-coms-common'}),content:_i18n.i18n.button.save(),key:'save',onClick:function onClick(key){_this3.saveEditCard();}},{icon:_react2.default.createElement('i',{className:'icon-coms-go-back'}),content:_i18n.i18n.button.back(),key:'back',onClick:function onClick(key){_this3.backCard();}}];}else{arr=[{icon:_react2.default.createElement('i',{className:'icon-coms-edit'}),content:_i18n.i18n.button.modify(),key:'editCard',onClick:function onClick(key){_this3.editCard();}}];arr.push({icon:_react2.default.createElement('i',{className:'icon-coms-Print-log'}),content:_i18n.i18n.button.log(),key:'showLog',onClick:function onClick(key){window.setLogViewProps({logSmallType:_i18n.i18n.smallType.HRM_RSOURCE_CARD_FINANCE,targetId:hrmId});}});}}return arr;}},{key:'getTopButtons',value:function getTopButtons(){var hrmFinance=this.props.hrmFinance;var isEditor=hrmFinance.isEditor,buttons=hrmFinance.buttons;var save=_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.saveEditCard},_i18n.i18n.button.save());var back=_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.backCard},_i18n.i18n.button.back());var edit=_react2.default.createElement(_antd.Button,{type:'primary',onClick:this.editCard},_i18n.i18n.button.modify());var btns=[];if(isEditor){if(buttons&&buttons.hasSave){btns.push(save);btns.push(back);}}else{if(buttons&&buttons.hasEdit){btns.push(edit);}}return btns;}}]);return HrmFinance;}(_react2.default.Component))||_class)||_class)||_class);exports.default=HrmFinance;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _antd=__webpack_require__(6);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _forEach=__webpack_require__(46);var _forEach2=_interopRequireDefault(_forEach);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);__webpack_require__(428);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var toJS=mobx.toJS;var HrmRoleSet=(_dec=(0,_mobxReact.inject)('hrmRoleSet'),_dec2=(0,_mobxReact.inject)('hrmCard'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(HrmRoleSet,_React$Component);function HrmRoleSet(props){(0,_classCallCheck3.default)(this,HrmRoleSet);var _this2=(0,_possibleConstructorReturn3.default)(this,(HrmRoleSet.__proto__||(0,_getPrototypeOf2.default)(HrmRoleSet)).call(this,props));_this2.onOperatesClick=function(record,index,operate,flag,argumentString){var func=operate.href?operate.href.split(':')[1].split('(')[0]:'';var id=record.id?record.id:'';if(func=='showLog'){id=record.roleid?record.roleid:'';}_this2[func]&&_this2[func](id);};return _this2;}(0,_createClass3.default)(HrmRoleSet,[{key:'componentDidMount',value:function componentDidMount(){var hrmCard=this.props.hrmCard;hrmCard.setTopButtons(this.getTopButtons.bind(this));hrmCard.setTopRightMenus(this.getRightMenu.bind(this));hrmCard.setTopShowDropIcon(true);this.init();}},{key:'init',value:function init(){var hrmRoleSet=this.props.hrmRoleSet;var hrmId=this.props.params.hrmId||'';hrmRoleSet.init();hrmRoleSet.getData({id:hrmId});}},{key:'getHrmRoleSetForm',value:function getHrmRoleSetForm(){var hrmRoleSet=this.props.hrmRoleSet;var form=hrmRoleSet.form,formFields=hrmRoleSet.formFields;var isFormInit=form.isFormInit;var group=[];var formParams=form.getFormParams();isFormInit&&!(0,_isEmpty2.default)(formFields)&&toJS(formFields).map(function(c){c.items.map(function(fields){var dom=React.createElement(_comsMobx.WeaSwitch,{fieldConfig:fields,form:form,formParams:formParams});group.push(React.createElement(_ecCom.WeaFormItem,{label:''+fields.label,labelCol:{span:''+fields.labelcol},wrapperCol:{span:''+fields.fieldcol}},dom));});});return group;}},{key:'reRenderColumns',value:function reRenderColumns(columns){var _this=this;columns.forEach(function(c){if(c.dataIndex=='roleid'){c.render=function(text,record){return React.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:function onClick(){return _this.edit(record.id);},dangerouslySetInnerHTML:{__html:record.roleidspan}});};}else{c.render=function(text,record){var valueSpan=record[c.dataIndex+"span"]!==undefined?record[c.dataIndex+"span"]:record[c.dataIndex];return React.createElement('span',{dangerouslySetInnerHTML:{__html:valueSpan}});};}});return columns;}},{key:'doSave',value:function doSave(){var hrmId=this.props.params.hrmId||'';var hrmRoleSet=this.props.hrmRoleSet;hrmRoleSet.save(hrmId);}},{key:'onCancel',value:function onCancel(){var hrmRoleSet=this.props.hrmRoleSet;hrmRoleSet.onCancel();}},{key:'update',value:function update(){var hrmRoleSet=this.props.hrmRoleSet;hrmRoleSet.update();}},{key:'edit',value:function edit(id){var hrmRoleSet=this.props.hrmRoleSet;hrmRoleSet.edit(id);}},{key:'add',value:function add(){var hrmRoleSet=this.props.hrmRoleSet;hrmRoleSet.add();}},{key:'delBatch',value:function delBatch(){var hrmRoleSet=this.props.hrmRoleSet;var keys=this.getSelectedRowKeys();var ids=keys?keys.join(','):'';hrmRoleSet.delBatch(ids);}},{key:'del',value:function del(id){var hrmRoleSet=this.props.hrmRoleSet;hrmRoleSet.delBatch(id);}},{key:'showLog',value:function showLog(id){var params={targetId:id};params.logType='4';params.logSmallType='1012';window.setLogViewProps(params);}},{key:'getSelectedRowKeys',value:function getSelectedRowKeys(){var hrmRoleSet=this.props.hrmRoleSet;var table=hrmRoleSet.table;var selectedRowKeys=table.selectedRowKeys;return selectedRowKeys;}},{key:'definedColumn',value:function definedColumn(){var hrmRoleSet=this.props.hrmRoleSet;var table=hrmRoleSet.table;table.setColSetVisible(true);table.tableColSet(true);}},{key:'getRightMenu',value:function getRightMenu(){var _this3=this;var keys=this.getSelectedRowKeys();var arr=[{icon:React.createElement('i',{className:'icon-coms-Batch-delete'}),content:_i18n.i18n.button.multiDelete(),key:'delBatch',onClick:function onClick(key){_this3.delBatch();}},{icon:React.createElement('i',{className:'icon-coms-task-list'}),content:_i18n.i18n.button.columnVisibleSetting(),key:'definedColumn',onClick:function onClick(key){_this3.definedColumn();}}];arr.push({icon:React.createElement('i',{className:'icon-coms-Print-log'}),content:_i18n.i18n.button.log(),key:'showLog',onClick:function onClick(key){_this3.showLog();}});return arr;}},{key:'getTopButtons',value:function getTopButtons(){var _this4=this;var hrmRoleSet=this.props.hrmRoleSet;var hasRight=hrmRoleSet.hasRight,buttons=hrmRoleSet.buttons;var btnAdd=React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){_this4.add();}},_i18n.i18n.button.add());var btns=[];if(hasRight){btns.push(btnAdd);}return btns;}},{key:'render',value:function render(){var _this5=this;var hrmRoleSet=this.props.hrmRoleSet;var dialogShow=hrmRoleSet.dialogShow,isEditor=hrmRoleSet.isEditor,hasRight=hrmRoleSet.hasRight,verified=hrmRoleSet.verified,formFields=hrmRoleSet.formFields,table=hrmRoleSet.table;var customComponent=React.createElement('div',{className:'customComponent'},React.createElement('i',{style:{margin:'0 10px'},className:'icon-coms-Add-to-hot detailBtn',title:_i18n.i18n.button.add(),onClick:function onClick(){return _this5.add();}}),React.createElement('i',{className:'icon-coms-form-delete-hot detailBtn',title:_i18n.i18n.button.delete(),onClick:function onClick(){return _this5.delBatch();}}));if(verified&&!hasRight){return React.createElement(WeaAlertPage,null,React.createElement('div',{style:{color:'#000'}},_i18n.i18n.message.authFailed()));}if(verified&&hasRight){return React.createElement('div',{className:'wea-myhrm-roleset',style:{background:'#ffffff',height:'100%',position:'relative'}},React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu()},React.createElement('div',{style:{height:'100%'}},React.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:_i18n.i18n.label.role(),showGroup:true,customComponent:customComponent},React.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true,getColumns:function getColumns(c){return _this5.reRenderColumns(c);},onOperatesClick:this.onOperatesClick})),React.createElement(_ecCom.WeaDialog,{title:isEditor?_i18n.i18n.label.editRole():_i18n.i18n.label.addRole(),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:dialogShow,onCancel:function onCancel(){return _this5.onCancel();},buttons:React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this5.doSave();}},_i18n.i18n.button.save()),style:{width:500,height:160}},React.createElement(_ecCom.WeaNewScroll,{height:180,ref:'scrollBar'},React.createElement('div',{style:{paddingLeft:50,paddingTop:30}},this.getHrmRoleSetForm()))))));}return React.createElement('div',null);}}]);return HrmRoleSet;}(React.Component))||_class)||_class)||_class);exports.default=HrmRoleSet;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(423),
    createBaseEach = __webpack_require__(426);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(424),
    keys = __webpack_require__(97);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(425);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(118);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(235);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _forEach=__webpack_require__(46);var _forEach2=_interopRequireDefault(_forEach);var _comsMobx=__webpack_require__(10);var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);__webpack_require__(236);var _inputBtn=__webpack_require__(167);var _inputBtn2=_interopRequireDefault(_inputBtn);var _topButton=__webpack_require__(99);var _topButton2=_interopRequireDefault(_topButton);var _needAutoBtn=__webpack_require__(237);var _needAutoBtn2=_interopRequireDefault(_needAutoBtn);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getKey=_ecCom.WeaTools.getKey;var toJS=mobx.toJS;var confirm=_antd.Modal.confirm;var HrmSystemInfo=(_dec=(0,_mobxReact.inject)('hrmSystemInfo'),_dec2=(0,_mobxReact.inject)('hrmCard'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(HrmSystemInfo,_React$Component);function HrmSystemInfo(props){(0,_classCallCheck3.default)(this,HrmSystemInfo);var _this=(0,_possibleConstructorReturn3.default)(this,(HrmSystemInfo.__proto__||(0,_getPrototypeOf2.default)(HrmSystemInfo)).call(this,props));var funcs=['doSave','edit','backCard','onPickerChange','onCheckChange','onSelectChange'];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});return _this;}// componentWillReceiveProps(nextProps) {
// 	const keyOld = this.props.location.key;
// 	const keyNew = nextProps.location.key;
// 	if(keyOld !== keyNew) {
// 		const {hrmSystemInfo} = this.props;
// 		hrmSystemInfo.init();
// 		hrmSystemInfo.getFormField();
// 	}
// }
(0,_createClass3.default)(HrmSystemInfo,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,hrmSystemInfo=_props.hrmSystemInfo,hrmCard=_props.hrmCard;hrmSystemInfo.init();hrmSystemInfo.hrmId=this.props.params.hrmId||'';hrmSystemInfo.getFormField();hrmSystemInfo.getWeekInfo(new _moment2.default().format('YYYY-MM-DD'));var dom=$('<Object id="htactx" name="htactx" classid="clsid:FB4EE423-43A4-4AA9-BDE9-4335A6D3C74E" codebase="HTActX.cab#version=1,0,0,1" style="HEIGHT: 0px; WIDTH: 0px"></Object>');$(document.body).append(dom);hrmCard.setTopButtons(this.getTopButtons.bind(this));hrmCard.setTopRightMenus(this.getRightMenu.bind(this));hrmCard.setTopShowDropIcon(true);}},{key:'getSearchs',value:function getSearchs(){var _this2=this;var hrmSystemInfo=this.props.hrmSystemInfo;var isEditor=hrmSystemInfo.isEditor,checkValue=hrmSystemInfo.checkValue,inputVlaue=hrmSystemInfo.inputVlaue,pickerValue=hrmSystemInfo.pickerValue,selectValue=hrmSystemInfo.selectValue,options=hrmSystemInfo.options,formFields=hrmSystemInfo.formFields,form=hrmSystemInfo.form;var formParams=hrmSystemInfo.getFormParams();var userUsbType=formParams.userUsbType||'';var usbState=formParams.usbstate||'';var date=hrmSystemInfo.date;var cancelSecondPwd=function cancelSecondPwd(){confirm({title:_i18n.i18n.confirm.defaultTitle(),content:React.createElement('div',null,React.createElement('div',null,_i18n.i18n.label['388923']()),React.createElement('div',null,_i18n.i18n.label['388924']())),okText:_i18n.i18n.button.ok(),cancelText:_i18n.i18n.button.cancel(),width:420,onOk:function onOk(){form.updateFields({useSecondaryPwd:{value:'0'}});}});};var isFormInit=form.isFormInit;var group=[];var group1=[];var colIndex=1;isFormInit&&formFields.forEach(function(c){c.items.forEach(function(field){var domkey=field.domkey[0]||'';var hide=false;var hideLabel=false;if(userUsbType==''&&(domkey=='tokenKey'||domkey=='serial'||domkey=='usbstate'))hide=true;if(userUsbType=='4'&&(domkey=='tokenKey'||domkey=='serial'))hide=true;if(userUsbType=='2'&&domkey=='tokenKey')hide=true;if(userUsbType=='3'&&domkey=='serial')hide=true;if(!isEditor&&(domkey=='password'||domkey=='password1'))hide=true;if(domkey==='validatecode'){hide=isEditor?false:true;}if(domkey=='startUsing'){hide=true;if(isEditor&&(userUsbType=='3'||userUsbType=='4')&&usbState=='1'){hide=false;}}if(!hide){var dom=void 0;if(isEditor&&domkey=='tokenKey'){hideLabel=true;var key=getKey(field);var bindObj=form.$(key);dom=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:7},React.createElement('span',null,_i18n.i18n.label.tokenNum(),': ')),React.createElement(_antd.Col,{span:17},React.createElement(_inputBtn2.default,(0,_extends3.default)({btnText:_i18n.i18n.label.binding()},bindObj.bind(),{viewAttr:3,onBtnClick:function onBtnClick(v){return _this2.updateKey();}})))));}else if(isEditor&&domkey=='serial'){hideLabel=true;var _key=getKey(field);var _bindObj=form.$(_key);dom=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:7},React.createElement('span',null,_i18n.i18n.label.userKey(),': ')),React.createElement(_antd.Col,{span:17},React.createElement(_inputBtn2.default,(0,_extends3.default)({btnText:_i18n.i18n.label.binding()},_bindObj.bind(),{viewAttr:3,onBtnClick:function onBtnClick(v){return _this2.updateKey(v);}})))));}else if(isEditor&&domkey=='startUsing'){hideLabel=true;dom=React.createElement('div',null,React.createElement(_antd.Row,{style:{lineHeight:'40px'}},React.createElement(_antd.Col,{span:6},React.createElement('span',null,_i18n.i18n.label.autoEnable(),'\uFF1A')),React.createElement(_antd.Col,{span:18},React.createElement(_ecCom.WeaCheckbox,{display:'switch',value:checkValue,onChange:_this2.onCheckChange}))),checkValue&&checkValue=='1'&&React.createElement('div',null,React.createElement(_antd.Row,{style:{lineHeight:'40px'}},React.createElement(_antd.Col,{span:6},React.createElement('span',null,_i18n.i18n.label.enableDate(),'\uFF1A')),React.createElement(_antd.Col,{span:18},React.createElement(_ecCom.WeaDatePicker,{noInput:true,startValue:new Date(),viewAttr:3,value:pickerValue,onChange:_this2.onPickerChange}))),React.createElement(_antd.Row,{style:{lineHeight:'40px'}},React.createElement(_antd.Col,{span:6},React.createElement('span',null,_i18n.i18n.label.enableMode(),'\uFF1A')),React.createElement(_antd.Col,{span:18},React.createElement(_ecCom.WeaSelect,{options:options,viewAttr:3,value:selectValue,onChange:_this2.onSelectChange})))));}else if(domkey=='useSecondaryPwd'){dom=React.createElement('div',{className:'wea-field-readonly'},formParams.useSecondaryPwd==='1'?_i18n.i18n.label['15809']():_i18n.i18n.label['15808']());}else{dom=React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form});}if(!isEditor){if(colIndex%2==0){group1.push(React.createElement(_ecCom.WeaFormItem,{underline:true,label:''+field.label,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},dom));}else{group.push(React.createElement(_ecCom.WeaFormItem,{underline:true,hideLabel:hideLabel,label:''+field.label,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},dom));}colIndex++;}else{if(domkey=='password'||domkey=='password1'||domkey=='seclevel'){group1.push(React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},dom));}else if(domkey=='useSecondaryPwd'){group1.push(React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},React.createElement('div',null,React.createElement('div',{style:{float:'left',lineHeight:'30px',marginRight:'30px'}},formParams.useSecondaryPwd==='1'?_i18n.i18n.label['15809']():_i18n.i18n.label['15808']()),formParams.useSecondaryPwd==='1'&&React.createElement(_antd.Button,{style:{float:'left'},type:'primary',onClick:function onClick(){return cancelSecondPwd();}},_i18n.i18n.label['26471']()))));}else if(domkey==='validatecode'){group1.push(React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},dom,React.createElement('img',{src:'/weaver/weaver.file.MakeValidateCode?isView=1&validatetype=0&validatenum=4&seriesnum_='+date,style:{cursor:'pointer',position:'absolute',top:-5,left:'105%'},onClick:function onClick(){return hrmSystemInfo.date=new Date();}})));}else{group.push(React.createElement(_ecCom.WeaFormItem,{hideLabel:hideLabel,label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},dom));}}}});});return React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:12},group),React.createElement(_antd.Col,{span:12},group1));}},{key:'render',value:function render(){var hrmSystemInfo=this.props.hrmSystemInfo;var viewDate=hrmSystemInfo.viewDate,isEditor=hrmSystemInfo.isEditor,weekInfo=hrmSystemInfo.weekInfo,title=hrmSystemInfo.title;var formParams=hrmSystemInfo.getFormParams();var query=this.props.location.query;if(!query.fromcard&&window.location.href.indexOf("/spa/hrm/index_mobx.html")>-1){document.title=_i18n.i18n.label.sysInfo();}return React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu()},React.createElement('div',{className:'wea-myhrm-systeminfo wea-myhrm',style:{background:'#ffffff',minHeight:window.innerHeight-146}},!query.fromcard&&React.createElement(_ecCom.WeaTop,{title:title(),icon:React.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu()}),React.createElement('div',{className:'hrm-my-card-basicInfo hrm-my-cardInfo wea-myhrm-systeminfo'},React.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:_i18n.i18n.label.sysInfo(),showGroup:true},this.getSearchs()))));}},{key:'getTopButtons',value:function getTopButtons(){var hrmSystemInfo=this.props.hrmSystemInfo;var isEditor=hrmSystemInfo.isEditor,buttons=hrmSystemInfo.buttons;var save=React.createElement(_antd.Button,{type:'primary',onClick:this.doSave},_i18n.i18n.button.save());var back=React.createElement(_antd.Button,{type:'primary',onClick:this.backCard},_i18n.i18n.button.back());var edit=React.createElement(_antd.Button,{type:'primary',onClick:this.edit},_i18n.i18n.button.modify());var btns=[];if(isEditor){if(buttons&&buttons.hasEdit){btns.push(save);btns.push(back);}}else{if(buttons&&buttons.hasEdit){btns.push(edit);}}return btns;}},{key:'doSave',value:function doSave(){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.doSave();}},{key:'edit',value:function edit(){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.edit();}},{key:'backCard',value:function backCard(){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.backCard();}},{key:'updateKey',value:function updateKey(){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.updateKey();}},{key:'onPickerChange',value:function onPickerChange(v){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.onPickerChange(v);}},{key:'onCheckChange',value:function onCheckChange(v){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.onCheckChange(v);}},{key:'onSelectChange',value:function onSelectChange(v){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.onSelectChange(v);}},{key:'getRightMenu',value:function getRightMenu(){var _this3=this;var hrmSystemInfo=this.props.hrmSystemInfo;var isEditor=hrmSystemInfo.isEditor,buttons=hrmSystemInfo.buttons,hrmId=hrmSystemInfo.hrmId;var arr=[];if(buttons&&toJS(buttons).hasEdit){if(isEditor){arr=[{icon:React.createElement('i',{className:'icon-coms-common'}),content:_i18n.i18n.button.save(),key:'save',onClick:function onClick(key){_this3.doSave();}},{icon:React.createElement('i',{className:'icon-coms-go-back'}),content:_i18n.i18n.button.back(),key:'back',onClick:function onClick(key){_this3.backCard();}}];}else{arr=[{icon:React.createElement('i',{className:'icon-coms-edit'}),content:_i18n.i18n.button.modify(),key:'edit',onClick:function onClick(key){_this3.edit();}}];arr.push({icon:React.createElement('i',{className:'icon-coms-Print-log'}),content:_i18n.i18n.button.log(),key:'showLog',onClick:function onClick(key){window.setLogViewProps({logSmallType:_i18n.i18n.smallType.HRM_RSOURCE_CARD_SYSTEM,targetId:hrmId});}});}}return arr;}}]);return HrmSystemInfo;}(React.Component))||_class)||_class)||_class);exports.default=HrmSystemInfo;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _forEach=__webpack_require__(46);var _forEach2=_interopRequireDefault(_forEach);var _comsMobx=__webpack_require__(10);var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);__webpack_require__(236);var _inputBtn=__webpack_require__(167);var _inputBtn2=_interopRequireDefault(_inputBtn);var _needAutoBtn=__webpack_require__(237);var _needAutoBtn2=_interopRequireDefault(_needAutoBtn);var _topButton=__webpack_require__(99);var _topButton2=_interopRequireDefault(_topButton);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getKey=_ecCom.WeaTools.getKey;var toJS=mobx.toJS;var confirm=_antd.Modal.confirm;var HrmSystemInfo=(_dec=(0,_mobxReact.inject)('hrmSystemInfo'),_dec2=(0,_mobxReact.inject)('hrmCard'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(HrmSystemInfo,_React$Component);function HrmSystemInfo(props){(0,_classCallCheck3.default)(this,HrmSystemInfo);var _this=(0,_possibleConstructorReturn3.default)(this,(HrmSystemInfo.__proto__||(0,_getPrototypeOf2.default)(HrmSystemInfo)).call(this,props));var funcs=['doSave','edit','backCard','onPickerChange','onCheckChange','onSelectChange'];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});return _this;}(0,_createClass3.default)(HrmSystemInfo,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,hrmSystemInfo=_props.hrmSystemInfo,hrmCard=_props.hrmCard;hrmSystemInfo.init();hrmSystemInfo.hrmId=this.props.params.hrmId||'';hrmSystemInfo.getFormField();hrmSystemInfo.getWeekInfo(new _moment2.default().format('YYYY-MM-DD'));var dom=$('<Object id="htactx" name="htactx" classid="clsid:FB4EE423-43A4-4AA9-BDE9-4335A6D3C74E" codebase="HTActX.cab#version=1,0,0,1" style="HEIGHT: 0px; WIDTH: 0px"></Object>');$(document.body).append(dom);hrmCard.setTopButtons(this.getTopButtons.bind(this));hrmCard.setTopRightMenus(this.getRightMenu.bind(this));hrmCard.setTopShowDropIcon(true);}},{key:'getSearchs',value:function getSearchs(){var _this2=this;var hrmSystemInfo=this.props.hrmSystemInfo;var isEditor=hrmSystemInfo.isEditor,checkValue=hrmSystemInfo.checkValue,inputVlaue=hrmSystemInfo.inputVlaue,pickerValue=hrmSystemInfo.pickerValue,selectValue=hrmSystemInfo.selectValue,options=hrmSystemInfo.options,formFields=hrmSystemInfo.formFields,form=hrmSystemInfo.form;var formParams=hrmSystemInfo.getFormParams();var userUsbType=formParams.userUsbType||'';var usbState=formParams.usbstate||'';var date=hrmSystemInfo.date;var cancelSecondPwd=function cancelSecondPwd(){confirm({title:_i18n.i18n.confirm.defaultTitle(),content:React.createElement('div',null,React.createElement('div',null,_i18n.i18n.label['388923']()),React.createElement('div',null,_i18n.i18n.label['388924']())),okText:_i18n.i18n.button.ok(),cancelText:_i18n.i18n.button.cancel(),width:420,onOk:function onOk(){form.updateFields({useSecondaryPwd:{value:'0'}});}});};var isFormInit=form.isFormInit;var group=[];var group1=[];var colIndex=1;isFormInit&&formFields.forEach(function(c){c.items.forEach(function(field){var domkey=field.domkey[0]||'';var hide=false;var hideLabel=false;if(userUsbType==''&&(domkey=='tokenKey'||domkey=='serial'||domkey=='usbstate'))hide=true;if(userUsbType=='4'&&(domkey=='tokenKey'||domkey=='serial'))hide=true;if(userUsbType=='2'&&domkey=='tokenKey')hide=true;if(userUsbType=='3'&&domkey=='serial')hide=true;if(!isEditor&&(domkey=='password'||domkey=='password1'))hide=true;if(domkey==='validatecode'){hide=isEditor?false:true;}if(domkey=='startUsing'){hide=true;if(isEditor&&(userUsbType=='2'||userUsbType=='3')&&usbState=='1'){hide=false;}}if(!hide){var dom=void 0;if(isEditor&&domkey=='tokenKey'){hideLabel=true;var key=getKey(field);var bindObj=form.$(key);dom=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:7},React.createElement('span',null,_i18n.i18n.label.tokenNum(),': ')),React.createElement(_antd.Col,{span:17},React.createElement(_inputBtn2.default,(0,_extends3.default)({btnText:_i18n.i18n.label.binding()},bindObj.bind(),{viewAttr:3,onBtnClick:function onBtnClick(v){return _this2.updateKey();}})))));}else if(isEditor&&domkey=='serial'){hideLabel=true;var _key=getKey(field);var _bindObj=form.$(_key);dom=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:7},React.createElement('span',null,_i18n.i18n.label.userKey(),': ')),React.createElement(_antd.Col,{span:17},React.createElement(_inputBtn2.default,(0,_extends3.default)({btnText:_i18n.i18n.label.binding()},_bindObj.bind(),{viewAttr:3,onBtnClick:function onBtnClick(v){return _this2.updateKey(v);}})))));}else if(isEditor&&domkey=='startUsing'){hideLabel=true;dom=React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:6},React.createElement('span',null,_i18n.i18n.label.autoEnable(),'\uFF1A')),React.createElement(_antd.Col,{span:18},React.createElement(_ecCom.WeaCheckbox,{display:'switch',value:checkValue,onChange:_this2.onCheckChange}))),checkValue&&checkValue=='1'&&React.createElement('div',null,React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:6},React.createElement('span',null,_i18n.i18n.label.enableDate(),'\uFF1A')),React.createElement(_antd.Col,{span:18},React.createElement(_ecCom.WeaDatePicker,{noInput:true,startValue:new Date(),viewAttr:3,value:pickerValue,onChange:_this2.onPickerChange}))),React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:6},React.createElement('span',null,_i18n.i18n.label.enableMode(),'\uFF1A')),React.createElement(_antd.Col,{span:18},React.createElement(_ecCom.WeaSelect,{options:options,viewAttr:3,value:selectValue,onChange:_this2.onSelectChange})))));}else if(domkey=='useSecondaryPwd'){dom=React.createElement('div',{className:'wea-field-readonly'},formParams.useSecondaryPwd==='1'?_i18n.i18n.label['15809']():_i18n.i18n.label['15808']());}else{dom=React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form});}if(!isEditor){if(colIndex%2==0){group1.push(React.createElement(_ecCom.WeaFormItem,{underline:true,label:''+field.label,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},dom));}else{group.push(React.createElement(_ecCom.WeaFormItem,{underline:true,hideLabel:hideLabel,label:''+field.label,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},dom));}colIndex++;}else{if(domkey=='password'||domkey=='password1'||domkey=='seclevel'){group1.push(React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},dom));}else if(domkey=='useSecondaryPwd'){group1.push(React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},React.createElement('div',null,React.createElement('div',{style:{float:'left',lineHeight:'30px',marginRight:'30px'}},formParams.useSecondaryPwd==='1'?_i18n.i18n.label['15809']():_i18n.i18n.label['15808']()),formParams.useSecondaryPwd==='1'&&React.createElement(_antd.Button,{style:{float:'left'},type:'primary',onClick:function onClick(){return cancelSecondPwd();}},_i18n.i18n.label['26471']()))));}else if(domkey==='validatecode'){group1.push(React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},dom,React.createElement('img',{src:'/weaver/weaver.file.MakeValidateCode?isView=1&validatetype=0&validatenum=4&seriesnum_='+date,style:{cursor:'pointer',position:'absolute',top:-5,left:'105%'},onClick:function onClick(){return hrmSystemInfo.date=new Date();}})));}else{group.push(React.createElement(_ecCom.WeaFormItem,{hideLabel:hideLabel,label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},dom));}}}});});return React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:12},group),React.createElement(_antd.Col,{span:12},group1));}},{key:'render',value:function render(){var hrmSystemInfo=this.props.hrmSystemInfo;var viewDate=hrmSystemInfo.viewDate,isEditor=hrmSystemInfo.isEditor,weekInfo=hrmSystemInfo.weekInfo,title=hrmSystemInfo.title;var formParams=hrmSystemInfo.getFormParams();var query=this.props.location.query;if(!query.fromcard&&window.location.href.indexOf("/spa/hrm/index_mobx.html")>-1){document.title=_i18n.i18n.label.sysInfo();}return React.createElement('div',{className:'wea-myhrm-systeminfo wea-myhrm',style:{background:'#ffffff',height:'100%',position:'relative'}},React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu()},React.createElement('div',{style:query.fromcard?{display:'none'}:{display:''}},React.createElement(_ecCom.WeaTop,{title:title(),icon:React.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu()})),React.createElement('div',{className:'hrm-my-card-basicInfo hrm-my-cardInfo wea-myhrm-systeminfo'},React.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:_i18n.i18n.label.sysInfo(),showGroup:true},this.getSearchs()),!isEditor&&weekInfo&&!(0,_isEmpty2.default)(weekInfo)&&React.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:_i18n.i18n.label.sysLogiInfo(),showGroup:true,className:'wea-sys-table'},React.createElement(_antd.Row,{className:'bord-line total'},React.createElement(_antd.Col,{span:4},_i18n.i18n.label.weekSituation()),React.createElement(_antd.Col,{span:4},weekInfo.kqinfo.weekworkdayslabel,':',weekInfo.kqinfo.weekworkdays),React.createElement(_antd.Col,{span:4},weekInfo.kqinfo.weeksigninnumlabel,':',weekInfo.kqinfo.weeksigninnum),React.createElement(_antd.Col,{span:4},weekInfo.kqinfo.weeksignoutnumlabel,':',weekInfo.kqinfo.weeksignoutnum),React.createElement(_antd.Col,{span:4},weekInfo.kqinfo.weekblogwritenumlabel,':',weekInfo.kqinfo.weekblogwritenum),React.createElement(_antd.Col,{span:4},weekInfo.kqinfo.weekblognotwritenumlabel,':',weekInfo.kqinfo.weekblognotwritenum)),React.createElement(_antd.Row,{className:'header',style:{height:70}},React.createElement(_antd.Col,{span:3,style:{lineHeight:'70px'}},viewDate&&viewDate.slice(0,7)),React.createElement(_antd.Col,{span:3,className:'picker-col',style:{lineHeight:'70px'}},React.createElement(_ecCom.WeaDatePicker,{type:'week',label:hrmSystemInfo.getDateLabel(),arrow:true,date:viewDate,onChange:function onChange(v){return hrmSystemInfo.onPickerHandler(v);}})),weekInfo.weekInfo&&!(0,_isEmpty2.default)(weekInfo.weekInfo)&&weekInfo.weekInfo.map(function(item){return React.createElement(_antd.Col,{span:3,style:{paddingTop:7}},React.createElement('div',null,item.weekday),React.createElement('br',null),React.createElement('div',null,React.createElement('strong',null,item.date)));})),React.createElement('div',{className:'body'},hrmSystemInfo.bodyConf&&!(0,_isEmpty2.default)(hrmSystemInfo.bodyConf)&&hrmSystemInfo.bodyConf.map(function(conf){return React.createElement(_antd.Row,{className:'bord-line '+(conf.isRow?'line':'double')},React.createElement(_antd.Col,{span:3,className:'info-title'},React.createElement('i',{className:conf.icon}),conf.title),React.createElement(_antd.Col,{span:3,className:'picker-col'},React.createElement('div',null,React.createElement('i',{className:conf.fieldsConf[0].icon}),conf.fieldsConf[0].title,' :'),conf.fieldsConf.length>1&&conf.fieldsConf[1]&&React.createElement('div',null,React.createElement('br',null),conf.fieldsConf[1].isIp?React.createElement('span',{className:conf.fieldsConf[1].icon},React.createElement('span',{className:'path1'}),React.createElement('span',{className:'path2'}),React.createElement('span',{className:'path3'})):React.createElement('i',{className:conf.fieldsConf[1].icon}),conf.fieldsConf[1].title,' :')),weekInfo.weekInfo&&!(0,_isEmpty2.default)(weekInfo.weekInfo)&&weekInfo.weekInfo.map(function(item){return React.createElement(_antd.Col,{span:3},React.createElement('div',{className:'text-overflow',title:item[conf.fields[0]]},item[conf.fields[0]]),conf.fields.length>1&&conf.fields[1]&&React.createElement('div',{className:'text-overflow',title:item[conf.fields[1]]},React.createElement('br',null),item[conf.fields[1]]));}));}))))));}},{key:'getTopButtons',value:function getTopButtons(){var hrmSystemInfo=this.props.hrmSystemInfo;var isEditor=hrmSystemInfo.isEditor,buttons=hrmSystemInfo.buttons;var save=React.createElement(_antd.Button,{type:'primary',onClick:this.doSave},_i18n.i18n.button.save());var back=React.createElement(_antd.Button,{type:'primary',onClick:this.backCard},_i18n.i18n.button.back());var edit=React.createElement(_antd.Button,{type:'primary',onClick:this.edit},_i18n.i18n.button.modify());var btns=[];if(isEditor){if(buttons&&toJS(buttons).hasEdit){btns.push(save);btns.push(back);}}else{if(buttons&&toJS(buttons).hasEdit){btns.push(edit);}}return btns;}},{key:'doSave',value:function doSave(){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.doSave();}},{key:'edit',value:function edit(){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.edit();}},{key:'backCard',value:function backCard(){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.backCard();}},{key:'updateKey',value:function updateKey(){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.updateKey();}},{key:'onPickerChange',value:function onPickerChange(v){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.onPickerChange(v);}},{key:'onCheckChange',value:function onCheckChange(v){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.onCheckChange(v);}},{key:'onSelectChange',value:function onSelectChange(v){var hrmSystemInfo=this.props.hrmSystemInfo;hrmSystemInfo.onSelectChange(v);}},{key:'getRightMenu',value:function getRightMenu(){var _this3=this;var hrmSystemInfo=this.props.hrmSystemInfo;var isEditor=hrmSystemInfo.isEditor,buttons=hrmSystemInfo.buttons,hrmId=hrmSystemInfo.hrmId;var arr=[];if(buttons&&toJS(buttons).hasEdit){if(isEditor){arr=[{icon:React.createElement('i',{className:'icon-coms-common'}),content:_i18n.i18n.button.save(),key:'save',onClick:function onClick(key){_this3.doSave();}},{icon:React.createElement('i',{className:'icon-coms-go-back'}),content:_i18n.i18n.button.back(),key:'back',onClick:function onClick(key){_this3.backCard();}}];}else{arr=[{icon:React.createElement('i',{className:'icon-coms-edit'}),content:_i18n.i18n.button.modify(),key:'editCard',onClick:function onClick(key){_this3.edit();}}];arr.push({icon:React.createElement('i',{className:'icon-coms-Print-log'}),content:_i18n.i18n.button.log(),key:'showLog',onClick:function onClick(key){window.setLogViewProps({logSmallType:_i18n.i18n.smallType.HRM_RSOURCE_CARD_SYSTEM,targetId:hrmId});}});}}return arr;}}]);return HrmSystemInfo;}(React.Component))||_class)||_class)||_class);exports.default=HrmSystemInfo;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(38);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _i18n=__webpack_require__(11);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);__webpack_require__(432);var _SecondaryVerify=__webpack_require__(433);var _SecondaryVerify2=_interopRequireDefault(_SecondaryVerify);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Step=_antd.Steps.Step;var toJS=mobx.toJS;var FormItem=_antd.Form.Item;var Password=(_dec=(0,_mobxReact.inject)('hrmPassword'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Password,_React$Component);function Password(props){(0,_classCallCheck3.default)(this,Password);var _this=(0,_possibleConstructorReturn3.default)(this,(Password.__proto__||(0,_getPrototypeOf2.default)(Password)).call(this,props));_this.state={oldVal:'',newVal:'',confirmVal:'',verifyCode:'',minPassLen:1,passwordComplexity:'0',pwd:'',tip:'',date:new Date(),height:460};return _this;}(0,_createClass3.default)(Password,[{key:'componentDidMount',value:function componentDidMount(){var hrmPassword=this.props.hrmPassword;hrmPassword.getSecuritySettingStatus();this.init();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location.key!==nextProps.location.key){this.resetPwdField();}}},{key:'init',value:function init(){var _this2=this;var hrmPassword=this.props.hrmPassword;var hrmId=this.props.params.hrmId||'';hrmPassword.hrmId=hrmId;_ecCom.WeaTools.callApi('/api/hrm/password/getPasswordSetting','GET',{id:hrmId}).then(function(data){_this2.setState({passwordComplexity:data.passwordComplexity,minPassLen:data.minpasslen});if(data.passwordComplexity=='1'){_this2.setState({tip:getLabel('24080',"字母大写、字母小写、数字组合")});}if(data.passwordComplexity=='2'){_this2.setState({tip:getLabel('24081',"字母、数字、特殊字符组合")});}hrmPassword.hrmId=data.hrmId;});hrmPassword.tabKey='0';}},{key:'pwdSave',value:function pwdSave(){var _this3=this;var _state=this.state,oldVal=_state.oldVal,newVal=_state.newVal,confirmVal=_state.confirmVal,verifyCode=_state.verifyCode;var _state2=this.state,minPassLen=_state2.minPassLen,passwordComplexity=_state2.passwordComplexity;if(!oldVal||!newVal||!confirmVal||!verifyCode){_antd.message.warning(getLabel('386497',"必填信息不完整！"));return false;}var hrmId=this.props.params.hrmId||'';var dialogId=this.props.location.query.dialogId||'';var params={'id':hrmId,'passwordold':oldVal,'passwordnew':newVal,'validatecode':verifyCode};var result=this.newPwdVerification(newVal,confirmVal,minPassLen,passwordComplexity);if(result){_ecCom.WeaTools.callApi('/api/hrm/password/changePassword','POST',params).then(function(data){if(data.status=='1'){_antd.message.success(data.message);if(dialogId!=''){setTimeout(function(){var dialog=top.window.getParentDialog();if(!dialog){if(dialogId&&window.top.window.dialogMapper&&window.top.window.dialogMapper[dialogId]){dialog=window.top.window.dialogMapper[dialogId];}}_this3.resetPwdField();dialog.close();// 关闭。 会触发onCancel
},3000);}else{_this3.resetPwdField();}}else{_antd.message.warning(data.message);}_this3.setState({date:new Date()});});}}},{key:'resetPwdField',value:function resetPwdField(){this.setState({oldVal:'',newVal:'',confirmVal:'',verifyCode:''});}},{key:'newPwdVerification',value:function newPwdVerification(newVal,confirmVal,minPassLen,passwordComplexity){var checkpass=true;if(newVal!==confirmVal){_antd.message.warning(getLabel('386508',"密码确认不正确！"));return false;}else{if(newVal.length<minPassLen){_antd.message.warning(getLabel('20172',"密码长度不能小于")+minPassLen);return false;}else{if(passwordComplexity=="1"){var complexity11=/[a-z]+/;var complexity12=/[A-Z]+/;var complexity13=/\d+/;if(complexity11.test(newVal)&&complexity12.test(newVal)&&complexity13.test(newVal)){checkpass=true;}else{_antd.message.warning(getLabel('31863',"新密码不符合要求，必须为字母大写、字母小写、数字组合！请重新输入！"));checkpass=false;}}else if(passwordComplexity=="2"){var complexity21=/[a-zA-Z_]+/;var complexity22=/\W+/;var complexity23=/\d+/;if(complexity21.test(newVal)&&complexity22.test(newVal)&&complexity23.test(newVal)){checkpass=true;}else{_antd.message.warning(getLabel('83716',"新密码不符合要求，必须为字母、数字、特殊字符组合！请重新输入！"));checkpass=false;}}}return checkpass;}}},{key:'getPwdModificationGrid',value:function getPwdModificationGrid(){var _this4=this;var _state3=this.state,oldVal=_state3.oldVal,newVal=_state3.newVal,confirmVal=_state3.confirmVal,verifyCode=_state3.verifyCode,tip=_state3.tip,date=_state3.date;var dialogId=this.props.location.query.dialogId||'';return _react2.default.createElement('div',null,_react2.default.createElement('div',{style:{marginTop:'60px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel('32738',"旧密码"),labelCol:{span:3,offset:6},wrapperCol:{span:7}},_react2.default.createElement(_ecCom.WeaInput,{type:'password',viewAttr:'3',value:oldVal,onChange:function onChange(val){return _this4.setState({oldVal:val});}}))),_react2.default.createElement('div',{style:{marginTop:'35px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel('27303',"新密码"),labelCol:{span:3,offset:6},wrapperCol:{span:7}},_react2.default.createElement(_ecCom.WeaInput,{type:'password',viewAttr:'3',passwordStrength:true,tip:tip,value:newVal,onChange:function onChange(val){return _this4.setState({newVal:val});}}))),_react2.default.createElement('div',{style:{marginTop:'35px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel('32739',"确认新密码"),labelCol:{span:3,offset:6},wrapperCol:{span:7}},_react2.default.createElement(_ecCom.WeaInput,{type:'password',viewAttr:'3',value:confirmVal,onChange:function onChange(val){return _this4.setState({confirmVal:val});}}))),_react2.default.createElement('div',{style:{marginTop:'35px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel('130021',"验证码"),labelCol:{span:3,offset:6},wrapperCol:{span:7}},_react2.default.createElement('div',{style:{width:'170%'}},_react2.default.createElement(_ecCom.WeaInput,{viewAttr:'3',value:verifyCode,style:{width:'58.9%',float:'left'},onChange:function onChange(val){return _this4.setState({verifyCode:val});}}),_react2.default.createElement('img',{src:'/weaver/weaver.file.MakeValidateCode?isView=1&validatetype=0&validatenum=4&seriesnum_='+date,style:{cursor:'pointer',display:'block',float:'left',marginLeft:25},onClick:function onClick(){return _this4.setState({date:new Date()});}})))),dialogId!=''&&_react2.default.createElement(_ecCom.WeaDialogFooter,{buttons:_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this4.pwdSave();}},_i18n.i18n.button.save())}));}},{key:'getPwdSettingContent',value:function getPwdSettingContent(){var hrmPassword=this.props.hrmPassword;var isSetted=hrmPassword.isSetted;return _react2.default.createElement('div',{style:{position:'relative'}},_react2.default.createElement('div',{style:{position:'absolute',left:'50%',top:50,marginLeft:-337}},_react2.default.createElement('div',{style:{float:'left',width:265}},_react2.default.createElement('img',{src:'/hrm/hrm_e9/image/computer.png',alt:''})),_react2.default.createElement('div',{style:{float:'left',width:410}},isSetted?this.pwdSecurityStatus():this.pwdSettingIllustration())));}},{key:'pwdSecurityStatus',value:function pwdSecurityStatus(){var hrmPassword=this.props.hrmPassword;var secStatus=hrmPassword.secStatus;var pwd=this.state.pwd;return _react2.default.createElement('div',{style:{marginTop:'30px'}},_react2.default.createElement('p',{style:{marginBottom:'12px',fontWeight:'bold'}},_react2.default.createElement('span',{style:{fontSize:'14px'}},getLabel('386526',"密保状态"),'\uFF1A'),_react2.default.createElement('span',{style:{fontSize:'13px',color:'#2DB7F5'}},secStatus?getLabel('387099','已启用'):getLabel('387100','已停用'))),_react2.default.createElement('p',{style:{marginBottom:'12px'}},'\u2022 ',getLabel('386509',"密保问题忘了怎么办？")),_react2.default.createElement('p',{style:{marginBottom:'12px'}},getLabel('386510',"可采用发送短信或发送邮件方式找回密码,若这两种方式都未开启，则联系系统管理员解决。")),_react2.default.createElement('div',{style:{marginTop:'35px'}},_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmPassword.doOpen('1');hrmPassword.isModifyBtnClick=false;}},secStatus?getLabel('26471',"停用"):getLabel('26472',"启用")),secStatus?_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmPassword.doOpen('1');hrmPassword.isModifyBtnClick=true;},style:{marginLeft:'30px'}},getLabel('103',"修改")):''));}},{key:'pwdSettingIllustration',value:function pwdSettingIllustration(){var hrmPassword=this.props.hrmPassword;return _react2.default.createElement('div',{style:{marginTop:'30px'}},_react2.default.createElement('p',{style:{marginBottom:'12px'}},'\u2022 ',getLabel('386511',"什么是密保问题？")),_react2.default.createElement('p',{style:{marginBottom:'12px'}},getLabel('506872',"由用户设定的几个问题及对应答案组成，用于找回E-cology登录密码。")),_react2.default.createElement('p',{style:{marginBottom:'12px'}},'\u2022 ',getLabel('386512',"如何用密保问题找回密码？")),_react2.default.createElement('p',{style:{marginBottom:'12px'}},getLabel('386513',"您可以通过登录页面中的“忘记密码”选择“密保问题”验证答案，找回密码。")),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmPassword.doOpen('1');}},getLabel('386514',"立即设置")));}},{key:'pwdVerification',value:function pwdVerification(arg){var hrmPassword=this.props.hrmPassword;var isSetted=hrmPassword.isSetted,secStatus=hrmPassword.secStatus,isModifyBtnClick=hrmPassword.isModifyBtnClick;var pwd=this.state.pwd;var hrmId=this.props.params.hrmId||'';if(isSetted&&!isModifyBtnClick){if(!pwd){_antd.message.warning(getLabel('386497',"必填信息不完整！"));return false;}hrmPassword.setSecutityStatus(pwd);}if(!isSetted||isModifyBtnClick){if(!pwd){_antd.message.warning(getLabel('386497',"必填信息不完整！"));return false;}var params={'id':hrmId,'pswd':pwd};_ecCom.WeaTools.callApi('/api/hrm/password/verifyPswd','POST',params).then(function(data){if(data.result=='true'){hrmPassword.getTableEditInfo();hrmPassword.doOpen('2');hrmPassword.doClose('1');}else{if(data.message){_antd.message.warning(data.message);}else{_antd.message.warning(getLabel('386525',"密码校验不通过，请重新输入！"));}}});hrmPassword.setPwdCopy(pwd);}this.setState({pwd:''});}},{key:'getButtons',value:function getButtons(){var _this5=this;var hrmPassword=this.props.hrmPassword;var current=hrmPassword.current;var btns=[];var pre=_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this5.pre();}},_i18n.i18n.button.lastStep());var next=_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this5.next();}},_i18n.i18n.button.nextStep());var finish=_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this5.finish();}},_i18n.i18n.button.done());if(current==0){btns=[next];}else if(current==1){btns=[pre,next];}else{btns=[finish];}return btns;}},{key:'pre',value:function pre(){var hrmPassword=this.props.hrmPassword;var current=hrmPassword.current;this.props.form.resetFields();hrmPassword.minus();}},{key:'next',value:function next(){var hrmPassword=this.props.hrmPassword;var current=hrmPassword.current,datasource=hrmPassword.datasource;var pwd=this.state.pwd;if(current==0){if(datasource.length==0){_antd.message.warning(getLabel('386515',"请填写密保问题！"));return false;}else{for(var i=0;i<datasource.length;i++){if(this.isEmptyObject(datasource[i])){_antd.message.warning(getLabel('386497',"必填信息不完整！"));return false;}for(var key in datasource[i]){if(!('answer'in datasource[i])||!('question'in datasource[i])){_antd.message.warning(getLabel('386497',"必填信息不完整！"));return false;}if(datasource[i][key]==''){_antd.message.warning(getLabel('386497',"必填信息不完整！"));return false;}}}}}if(current==1){var answerArray=[];var obj=this.props.form.getFieldsValue();for(var _i in obj){answerArray.push(obj[_i]);}var b=this.securityAnswerVerification(answerArray);if(typeof b=='number'){_antd.message.warning(getLabel('24419',"问题 ")+b+getLabel('386516'," 输入的答案与问题不匹配，请重新输入！"));return false;}else{if(b){var ds=toJS(datasource);var _obj={};for(var _i2=0;_i2<ds.length;_i2++){for(var _key in ds[_i2]){_obj[_key+'_'+_i2]=ds[_i2][_key];}}hrmPassword.save(_obj);this.props.form.resetFields();}else{_antd.message.warning(getLabel('386497',"必填信息不完整！"));return false;}}}hrmPassword.plus();}},{key:'finish',value:function finish(){var hrmPassword=this.props.hrmPassword;var isSetted=hrmPassword.isSetted;hrmPassword.doClose('2');hrmPassword.reset();}},{key:'isEmptyObject',value:function isEmptyObject(obj){for(var key in obj){return false;}return true;}},{key:'securityAnswerVerification',value:function securityAnswerVerification(answerArray){var hrmPassword=this.props.hrmPassword;var datasource=hrmPassword.datasource;var arr=[];var _arr=toJS(datasource);for(var i=0;i<answerArray.length;i++){if(!answerArray[i])return false;}for(var _i3=0;_i3<_arr.length;_i3++){arr.push(_arr[_i3].answer);}for(var _i4=0;_i4<arr.length;_i4++){if(arr[_i4]!==answerArray[_i4]){return _i4+1;}}return true;}},{key:'getTableEdit',value:function getTableEdit(){var hrmPassword=this.props.hrmPassword;var columns=hrmPassword.columns,datasource=hrmPassword.datasource;return _react2.default.createElement(_ecCom.WeaTableEdit,{columns:toJS(columns),datas:toJS(datasource),onChange:function onChange(arr){return hrmPassword.datasource=arr;}});}},{key:'getQaForm',value:function getQaForm(){var hrmPassword=this.props.hrmPassword;var datasource=hrmPassword.datasource;var _props$form=this.props.form,getFieldDecorator=_props$form.getFieldDecorator,getFieldProps=_props$form.getFieldProps;var _arr=[];_arr.push(_react2.default.createElement('div',{style:{marginTop:'40px'}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:1,offset:5},_react2.default.createElement('img',{src:'/hrm/hrm_e9/image/wenhao.png',alt:'',style:{width:'15px',height:'15px'}})),_react2.default.createElement(_antd.Col,{span:13},_react2.default.createElement('p',null,getLabel('386517',"以下是您刚刚设置的密保问题，请依次做出回答，以便进行确认"))))));for(var i=0;i<datasource.length;i++){_arr.push(_react2.default.createElement('div',{style:{marginTop:'15px'}},_react2.default.createElement('div',{style:{marginTop:'20px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel('24419',"问题 "),labelCol:{span:3,offset:2},wrapperCol:{span:15}},_react2.default.createElement('p',{style:{marginTop:-2}},datasource[i].question))),_react2.default.createElement('div',{style:{marginTop:'20px'}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel('24122',"答案"),labelCol:{span:3,offset:2},wrapperCol:{span:15}},_react2.default.createElement(FormItem,null,_react2.default.createElement(_ecCom.WeaInput,(0,_extends3.default)({},getFieldProps('answer'+(i+1)),getFieldDecorator('answer'+(i+1)),{type:'text',viewAttr:'3'})))))));}return _react2.default.createElement(_antd.Form,null,_arr);}},{key:'getFinishLogo',value:function getFinishLogo(){return _react2.default.createElement('div',{style:{position:'relative'}},_react2.default.createElement('div',{style:{position:'absolute',top:50,left:'50%',marginLeft:-92.5,width:185}},_react2.default.createElement('img',{src:'/hrm/hrm_e9/image/finish.png',alt:''})),_react2.default.createElement('p',{style:{fontSize:'15px',paddingTop:190,textAlign:'center'}},getLabel('386518',"您已完成了密保问题的设置!")));}},{key:'dropMenuDatasClick',value:function dropMenuDatasClick(key){var hrmPassword=this.props.hrmPassword;hrmPassword.doOpen('1');if(key=='3')hrmPassword.setModifyBtnStatus(false);if(key=='4')hrmPassword.setModifyBtnStatus(false);if(key=='5')hrmPassword.setModifyBtnStatus(true);}},{key:'render',value:function render(){var _this6=this,_ref;var hrmPassword=this.props.hrmPassword;var tabKey=hrmPassword.tabKey,isPwdVerifyDialogShow=hrmPassword.isPwdVerifyDialogShow,isPwdSecuritySettingShow=hrmPassword.isPwdSecuritySettingShow,current=hrmPassword.current,isSetted=hrmPassword.isSetted,secStatus=hrmPassword.secStatus,hrmId=hrmPassword.hrmId;var _state4=this.state,pwd=_state4.pwd,height=_state4.height;var btn1=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this6.pwdSave();}},_i18n.i18n.button.save())];var btn2=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this6.pwdVerification();}},_i18n.i18n.button.nextStep())];var dropMenuDatas=[(_ref={key:'0',content:_i18n.i18n.button.save()},(0,_defineProperty3.default)(_ref,'key','save'),(0,_defineProperty3.default)(_ref,'icon',_react2.default.createElement('i',{className:'icon-coms-Preservation'})),(0,_defineProperty3.default)(_ref,'onClick',function onClick(key){_this6.pwdSave();}),_ref),{key:'1',content:_i18n.i18n.button.nextStep(),icon:_react2.default.createElement('i',{className:'icon-coms-Browse-box-Add-to'})},{key:'2',content:getLabel('386514',"立即设置"),icon:_react2.default.createElement('i',{className:'icon-coms-currency'})},{key:'3',content:getLabel('26472',"启用"),icon:_react2.default.createElement('i',{className:'icon-coms-operation'})},{key:'4',content:getLabel('26471',"停用"),icon:_react2.default.createElement('i',{className:'icon-coms-locking'})},{key:'5',content:getLabel('103',"修改"),icon:_react2.default.createElement('i',{className:'icon-coms-edit'})}];var dropMenuDatas1=dropMenuDatas.slice(0,1);var dropMenuDatas2=dropMenuDatas.slice(1,2);var dropMenuDatas3=void 0;if(!isSetted)dropMenuDatas3=dropMenuDatas.slice(2,3);if(isSetted&&!secStatus)dropMenuDatas3=dropMenuDatas.slice(3,4);if(isSetted&&secStatus)dropMenuDatas3=dropMenuDatas.slice(4,6);dropMenuDatas1.push({icon:_react2.default.createElement('i',{className:'icon-coms-Print-log'}),content:_i18n.i18n.button.log(),key:'showLog',onClick:function onClick(key){window.setLogViewProps({logSmallType:_i18n.i18n.smallType.HRM_PASSWPRD,targetId:hrmId});}});var tabName1=[{key:'0',title:getLabel('388431',"登录密码")},{key:'2',title:getLabel('388412',"二次验证密码")},{key:'1',title:getLabel('81604',"密保设置")}];var dialogId=this.props.location.query.dialogId||'';if(dialogId!=''){tabName1=[{key:'0',title:getLabel('81631',"密码修改")}];}return _react2.default.createElement('div',{className:'hrm-password-bgcolor'},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:tabKey=='0'?dropMenuDatas1:dropMenuDatas3,onClick:function onClick(key){tabKey=='0'?'':_this6.dropMenuDatasClick(key);},collectParams:{favname:getLabel('20170',"密码设置"),favouritetype:5}},_react2.default.createElement(_ecCom.WeaTop,{title:getLabel('20170',"密码设置"),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',loading:true,buttons:tabKey=='0'&&dialogId==''?btn1:[],showDropIcon:tabKey=='0'&&dialogId==''?true:false,dropMenuDatas:dropMenuDatas1}),_react2.default.createElement(_ecCom.WeaTab,{selectedKey:tabKey,datas:tabName1,keyParam:'key',onChange:function onChange(key){hrmPassword.tabKey=key;['oldVal','newVal','confirmVal','verifyCode'].map(function(v){return _this6.setState((0,_defineProperty3.default)({},v,''));});}}),tabKey=='0'?this.getPwdModificationGrid():tabKey=='1'?this.getPwdSettingContent():_react2.default.createElement(_SecondaryVerify2.default,null)),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel('504331',"请先输入登录密码"),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isPwdVerifyDialogShow,onCancel:function onCancel(){hrmPassword.doClose('1');_this6.setState({pwd:''});},buttons:btn2,style:{width:600,height:105}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas2,onClick:function onClick(){return _this6.pwdVerification();}},_react2.default.createElement('div',{style:{paddingTop:37}},_react2.default.createElement(_ecCom.WeaFormItem,{label:getLabel('388431',"登录密码"),labelCol:{span:3,offset:2},wrapperCol:{span:15}},_react2.default.createElement(_ecCom.WeaInput,{type:'password',viewAttr:'3',value:pwd,onChange:function onChange(val){return _this6.setState({pwd:val});}}))))),_react2.default.createElement(_ecCom.WeaDialog,{title:getLabel('386520',"密保问题设置"),icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:isPwdSecuritySettingShow,hasScroll:true,onCancel:function onCancel(){hrmPassword.doClose('2'),hrmPassword.reset();},buttons:this.getButtons(),style:{width:720,height:460},onChangeHeight:function onChangeHeight(h){return _this6.setState({height:h});}},_react2.default.createElement(_antd.Steps,{current:current,className:'hrm-pwd-step-wrapper'},_react2.default.createElement(Step,{description:getLabel('386521',"填写密保问题")}),_react2.default.createElement(Step,{description:getLabel('386522',"验证密保问题")}),_react2.default.createElement(Step,{description:getLabel('386523',"完成密保问题")})),_react2.default.createElement('div',{ref:'scrollBar'},_react2.default.createElement('div',{className:''+(current==0?'wea-show':'wea-hide')},this.getTableEdit()),_react2.default.createElement('div',{className:''+(current==1?'wea-show':'wea-hide')},current==1&&this.getQaForm()),_react2.default.createElement('div',{className:''+(current==2?'wea-show':'wea-hide')},this.getFinishLogo()))));}}]);return Password;}(_react2.default.Component))||_class)||_class);Password=_antd.Form.create({})(Password);exports.default=Password;

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _MainDialog=__webpack_require__(434);var _MainDialog2=_interopRequireDefault(_MainDialog);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var SecondaryVerify=(_dec=(0,_mobxReact.inject)('hrmSecondaryVerify'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(SecondaryVerify,_React$Component);function SecondaryVerify(props){(0,_classCallCheck3.default)(this,SecondaryVerify);var _this=(0,_possibleConstructorReturn3.default)(this,(SecondaryVerify.__proto__||(0,_getPrototypeOf2.default)(SecondaryVerify)).call(this,props));_this.getDescription=function(isSetted){var ele=void 0;if(!isSetted){var desc=[getLabel('504320',"什么是二次验证密码？"),getLabel('506871',"用于身份确认的二次验证密码")+'\uFF0C'+getLabel('504322',"为保安全性，请设置为和登录密码不同的密码。")];ele=desc.map(function(item,index){return _react2.default.createElement('p',{style:{padding:'3px 0'}},(index==0?'•':'')+' '+item);});}else{var status=_react2.default.createElement('p',{style:{fontSize:18}},_react2.default.createElement('span',null,getLabel('504323',"二次验证密码状态")),_react2.default.createElement('span',null,' : '),_react2.default.createElement('span',{style:{fontWeight:'bold',color:'#4DB1FA'}},getLabel('504324',"已设置")));var _desc=[getLabel('504325',"二次验证密码可以自行停用吗？"),getLabel('504326',"不可以，只能由管理员操作。"),getLabel('504327',"二次验证密码忘记了怎么办？"),getLabel('504328',"请联系系统管理员解决。")];ele=_desc.map(function(item,index){return _react2.default.createElement('p',{style:{padding:'3px 0'}},([0,2].includes(index)?'•':'')+' '+item);});ele.unshift(status);}return ele;};_this.getButton=function(isSetted){var hrmSecondaryVerify=_this.props.hrmSecondaryVerify,setSecondaryVerify=hrmSecondaryVerify.setSecondaryVerify,modifySecondaryPass=hrmSecondaryVerify.modifySecondaryPass;var btn=void 0;if(!isSetted){btn=_react2.default.createElement(_antd.Button,{type:'primary',style:{marginTop:30},onClick:function onClick(){return setSecondaryVerify();}},getLabel('504329',"立即设置"));}else{btn=_react2.default.createElement(_antd.Button,{type:'primary',style:{marginTop:30},onClick:function onClick(){return modifySecondaryPass();}},getLabel('504330',"修改"));}return btn;};_this.getPaddingLeft=function(){var w=window.innerWidth||document.body.clientWidth;var pl=void 0;if(w>1366){pl='28%';}else{pl='23%';}return pl;};return _this;}(0,_createClass3.default)(SecondaryVerify,[{key:'componentDidMount',value:function componentDidMount(){var hrmSecondaryVerify=this.props.hrmSecondaryVerify,isSettedSecondaryPwd=hrmSecondaryVerify.isSettedSecondaryPwd;isSettedSecondaryPwd();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmSecondaryVerify.resetSecondaryVerify();}},{key:'render',value:function render(){var hrmSecondaryVerify=this.props.hrmSecondaryVerify,secondaryVerify=hrmSecondaryVerify.secondaryVerify,isSetted=secondaryVerify.isSetted,loading=secondaryVerify.loading;if(loading){return _react2.default.createElement('div',{className:'hrm-loading-center',style:{top:400}},_react2.default.createElement(_antd.Spin,{spinning:loading,size:'large'}));}else{return _react2.default.createElement('div',null,_react2.default.createElement('div',{style:{paddingTop:80,paddingLeft:this.getPaddingLeft()}},_react2.default.createElement('img',{src:'/hrm/hrm_e9/image/SecondaryVerify.png',style:{float:'left'}}),_react2.default.createElement('div',{style:{float:'left',paddingLeft:15,paddingTop:10}},this.getDescription(isSetted),this.getButton(isSetted))),_react2.default.createElement(_MainDialog2.default,null));}}}]);return SecondaryVerify;}(_react2.default.Component))||_class)||_class);exports.default=SecondaryVerify;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _FormInfo=__webpack_require__(435);var _FormInfo2=_interopRequireDefault(_FormInfo);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MainDialog=(_dec=(0,_mobxReact.inject)('hrmSecondaryVerify'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(MainDialog,_React$Component);function MainDialog(props){(0,_classCallCheck3.default)(this,MainDialog);return(0,_possibleConstructorReturn3.default)(this,(MainDialog.__proto__||(0,_getPrototypeOf2.default)(MainDialog)).call(this,props));}(0,_createClass3.default)(MainDialog,[{key:'render',value:function render(){var hrmSecondaryVerify=this.props.hrmSecondaryVerify,mainDialog=hrmSecondaryVerify.mainDialog,closeDialog=hrmSecondaryVerify.closeDialog,buttons=hrmSecondaryVerify.buttons,style=hrmSecondaryVerify.style,dropMenuDatas=hrmSecondaryVerify.dropMenuDatas,title=mainDialog.title,visible=mainDialog.visible;return React.createElement(_ecCom.WeaDialog,{title:title,icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:visible,hasScroll:true,onCancel:function onCancel(){return closeDialog();},buttons:buttons,style:style},React.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas},visible&&React.createElement(_FormInfo2.default,null)));}}]);return MainDialog;}(React.Component))||_class)||_class);exports.default=MainDialog;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FormInfo=(_dec=(0,_mobxReact.inject)('hrmSecondaryVerify'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(FormInfo,_React$Component);function FormInfo(props){(0,_classCallCheck3.default)(this,FormInfo);var _this=(0,_possibleConstructorReturn3.default)(this,(FormInfo.__proto__||(0,_getPrototypeOf2.default)(FormInfo)).call(this,props));_this.getForm=function(){var hrmSecondaryVerify=_this.props.hrmSecondaryVerify,formInfo=hrmSecondaryVerify.formInfo,date=hrmSecondaryVerify.date,setDate=hrmSecondaryVerify.setDate,form=formInfo.form,conditions=formInfo.conditions,passwordComplexity=formInfo.passwordComplexity,isFormInit=form.isFormInit;var outterArray=[];var len=conditions.length>0&&conditions[0].items.length;isFormInit&&conditions.map(function(c){var innerArray=[];c.items.map(function(field,index){var key=field.domkey[0];innerArray.push({com:React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:_this.getLabelCol(len,passwordComplexity),wrapperCol:{span:12},error:form.getError(field),tipPosition:'bottom'},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:form.getFormParams(),onBlur:function onBlur(cb){return _this.handleBlur({key:key,cb:cb});}}),key==='validatecode'&&React.createElement('img',{src:'/weaver/weaver.file.MakeValidateCode?isView=1&validatetype=0&validatenum=4&seriesnum_='+date,style:{cursor:'pointer',position:'absolute',left:'105%'},onClick:function onClick(){return setDate();}})),colSpan:1});});outterArray.push(React.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:'',showGroup:c.defaultshow,items:innerArray,col:1}));});return outterArray;};_this.getLabelCol=function(len,passwordComplexity){var labelCol={span:5};if(passwordComplexity!='0'){if(len>1){(0,_assign2.default)(labelCol,{offset:0});}else{(0,_assign2.default)(labelCol,{offset:3});}}else{(0,_assign2.default)(labelCol,{offset:2});}return labelCol;};_this.handleBlur=function(params){var key=params.key,cb=params.cb;var hrmSecondaryVerify=_this.props.hrmSecondaryVerify,verifyPassword=hrmSecondaryVerify.verifyPassword;(key=='oldSecondaryPwd'||key=='secondaryPwd1'||key=='newSecondaryPwd1')&&verifyPassword({cb:cb,key:key});};return _this;}(0,_createClass3.default)(FormInfo,[{key:'componentDidMount',value:function componentDidMount(){var hrmSecondaryVerify=this.props.hrmSecondaryVerify,getFormConditions=hrmSecondaryVerify.getFormConditions;getFormConditions();}},{key:'componentWillUnmount',value:function componentWillUnmount(){var hrmSecondaryVerify=this.props.hrmSecondaryVerify,resetFormInfo=hrmSecondaryVerify.resetFormInfo;resetFormInfo();}},{key:'render',value:function render(){var hrmSecondaryVerify=this.props.hrmSecondaryVerify,formInfo=hrmSecondaryVerify.formInfo,loading=formInfo.loading;if(loading){return React.createElement('div',{className:'hrm-loading-center-small'},React.createElement(_antd.Spin,{spinning:loading}));}else{return this.getForm();}}}]);return FormInfo;}(React.Component))||_class)||_class);exports.default=FormInfo;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(38);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobx=__webpack_require__(8);var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _ecCom=__webpack_require__(0);var _trim=__webpack_require__(238);var _trim2=_interopRequireDefault(_trim);var _comsMobx=__webpack_require__(10);__webpack_require__(241);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _AddressBookExportSetting=__webpack_require__(242);var _AddressBookExportSetting2=_interopRequireDefault(_AddressBookExportSetting);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var AddressBook=(_dec=(0,_mobxReact.inject)('hrmAddressBook'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(AddressBook,_React$Component);function AddressBook(props){(0,_classCallCheck3.default)(this,AddressBook);var _this=(0,_possibleConstructorReturn3.default)(this,(AddressBook.__proto__||(0,_getPrototypeOf2.default)(AddressBook)).call(this,props));_this.onTabEdit=function(targetKey,action){var hrmAddressBook=_this.props.hrmAddressBook;if(action==='remove'){var params={};params.opera="delete";params.mouldid=targetKey;hrmAddressBook.deleteTabs(params);}};_this.reRenderColumns=function(columns){var __this=_this;var hrmAddressBook=_this.props.hrmAddressBook;var virtualtype=hrmAddressBook.virtualtype;columns.forEach(function(c){if(c.dataIndex=='lastname'){c.render=function(text,record){return React.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:function onClick(){return(0,_pulicFunc.jumpToHrmCard)(record.id);}},record.lastname);};}else if(c.dataIndex=='managerid'){c.render=function(text,record){return React.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:function onClick(){return(0,_pulicFunc.jumpToHrmCard)(record.managerid);},dangerouslySetInnerHTML:{__html:record.manageridspan}});};}else if(c.dataIndex=='subcompanyid1'&&!(virtualtype.indexOf("-")>-1)){c.render=function(text,record){return React.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:function onClick(){return(0,_pulicFunc.jumpToHrmSubCompany)(record.subcompanyid1);},dangerouslySetInnerHTML:{__html:record.subcompanyid1span}});};}else if(c.dataIndex=='departmentid'&&!(virtualtype.indexOf("-")>-1)){c.render=function(text,record){return React.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:function onClick(){return(0,_pulicFunc.jumpToHrmDept)(record.departmentid);},dangerouslySetInnerHTML:{__html:record.departmentidspan}});};}else if(c.dataIndex=='jobtitle'){c.render=function(text,record){return React.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:function onClick(){return(0,_pulicFunc.jumpToHrmPost)(record.jobtitle);},dangerouslySetInnerHTML:{__html:record.jobtitlespan}});};}else{c.render=function(text,record){var valueSpan=record[c.dataIndex+"span"]!==undefined?record[c.dataIndex+"span"]:record[c.dataIndex];return React.createElement('span',{dangerouslySetInnerHTML:{__html:valueSpan}});};}});return columns;};_this.onOperatesClick=function(record,index,operate,flag,argumentString){var fn=operate.href?operate.href.split(':')[1].split('(')[0]:'';var id=record.id?record.id:'';PublicFunc[fn](id);};_this.treeNodeClick=function(event){var hrmAddressBook=_this.props.hrmAddressBook;var form=hrmAddressBook.form,companysId=hrmAddressBook.companysId;var type=event.node.props.type||'0';var id=event.node.props.id||'';var params={};form.resetConditionValue();hrmAddressBook.updateShowSearchAd(false);hrmAddressBook.tabkey='default_3';if(type=='0'){params['virtualtype']=companysId;}if(type=='1'){params['subcompanyid1']=id;}if(type=='2'){params['departmentid']=id;}hrmAddressBook.doSearch(params);};_this.state={transferVisible:false};return _this;}(0,_createClass3.default)(AddressBook,[{key:'componentDidMount',value:function componentDidMount(){var _props$location$query=this.props.location.query,from=_props$location$query.from,lastname=_props$location$query.lastname;var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.searchFrom=from||'';hrmAddressBook.searchKeyWord=lastname||'';this.init();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;if(this.props.location.key!==nextProps.location.key){var _nextProps$location$q=nextProps.location.query,from=_nextProps$location$q.from,lastname=_nextProps$location$q.lastname;var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.searchFrom=from||'';hrmAddressBook.searchKeyWord=lastname||'';this.refs.WeaOrgTree.reset(function(){_this2.refs.WeaOrgTree.fetchData();});this.init();}}},{key:'init',value:function init(){var _props$location$query2=this.props.location.query,type=_props$location$query2.type,id=_props$location$query2.id;var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.showAllLevel=false;hrmAddressBook.rightMenus=[];hrmAddressBook.defaultShowLeft=false;if(hrmAddressBook.searchFrom&&hrmAddressBook.searchFrom=='quickSearch'){hrmAddressBook.tabkey='default_3';}else{hrmAddressBook.tabkey='default_3';}var params={};if(type&&type!=''&&id&&id!=''){if(type=='1'){params['subcompanyid1']=id;}if(type=='2'){params['departmentid']=id;}}hrmAddressBook.getData(params);hrmAddressBook.getRightMenuConfig();hrmAddressBook.updateShowSearchAd(false);hrmAddressBook.updateVisible1(false);hrmAddressBook.updateVisible2(false);}},{key:'getTabButtonsAd',value:function getTabButtonsAd(){var _this3=this;var hrmAddressBook=this.props.hrmAddressBook;var tabkey=hrmAddressBook.tabkey,form=hrmAddressBook.form,companysId=hrmAddressBook.companysId;var btns=[React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmAddressBook.updateShowSearchAd(false);_this3.doSearch();}},_i18n.i18n.button.search())];if(companysId&&companysId<0){}else{tabkey=='default_3'&&btns.push(React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmAddressBook.updateVisible2(true);}},_i18n.i18n.button.saveAsTemplate()));tabkey=='default_3'&&btns.push(React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmAddressBook.formatTransfer();hrmAddressBook.updateVisible1(true);}},_i18n.i18n.button.conditionDef()));btns.push(React.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){return form.resetConditionValue();}},_i18n.i18n.button.reset()));btns.push(React.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){return hrmAddressBook.updateShowSearchAd(false);}},_i18n.i18n.button.cancel()));}return btns;}},{key:'getSearchs',value:function getSearchs(){var _this4=this;var hrmAddressBook=this.props.hrmAddressBook;var conditioninfo=hrmAddressBook.conditioninfo,conditioninfoAll=hrmAddressBook.conditioninfoAll,form=hrmAddressBook.form,showAllCondition=hrmAddressBook.showAllCondition;var isFormInit=form.isFormInit;var ci=(0,_mobx.toJS)(showAllCondition?conditioninfoAll:conditioninfo);var group=[];isFormInit&&ci.forEach(function(c){var items=[];c.items.forEach(function(field){if(field.isQuickSearch){_this4.quickSearchPara=field.domkey[0];}items.push({com:React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:field.labelcol},wrapperCol:{span:field.fieldcol}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form})),colSpan:1});});group.push(React.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:c.title,showGroup:c.defaultshow,items:items}));});return React.createElement('div',null,group,!showAllCondition&&React.createElement('div',{style:{textAlign:'right',padding:'20px 25px'}},React.createElement('span',{className:'cursor-pointer',onClick:function onClick(){return hrmAddressBook.updateShowAllCondition(true);},style:{marginRight:12}},React.createElement('span',{style:{marginRight:8}},_i18n.i18n.label.allCondition()),React.createElement('i',{className:'icon-coms-right',style:{color:'#b2b2b2'}}))));}},{key:'getRightMenu',value:function getRightMenu(){var hrmAddressBook=this.props.hrmAddressBook;var rightMenus=hrmAddressBook.rightMenus;var btns=[];var keys=this.getSelectedRowKeys();!(0,_isEmpty2.default)((0,_mobx.toJS)(rightMenus))&&(0,_mobx.toJS)(rightMenus).forEach(function(c){var item={icon:React.createElement('i',{className:''+c.menuIcon}),content:c.menuName};if(c.menuFun=='sendEmessage')item.disabled=keys.length==0;btns.push(item);});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmAddressBook=this.props.hrmAddressBook;var rightMenus=hrmAddressBook.rightMenus;var menuFun=rightMenus.toJS()[key].menuFun;this[menuFun]&&this[menuFun]();}},{key:'getTree',value:function getTree(){var _this5=this;var hrmAddressBook=this.props.hrmAddressBook;var companysId=hrmAddressBook.companysId;return React.createElement(_ecCom.WeaOrgTree,{ref:'WeaOrgTree',loading:true,needSearch:true,noCache:true,needDropMenu:true,onSelect:function onSelect(v){return _this5.selectVirtual(v);},isLoadSubDepartment:true,topPrefix:'hrmSearch',companysId:companysId,inputLeftDom:'<b>'+_i18n.i18n.label.organization()+'</b',treeNodeClick:this.treeNodeClick,expandAllChildrenOnSearch:true});}},{key:'selectVirtual',value:function selectVirtual(v){var hrmAddressBook=this.props.hrmAddressBook;var params={};params['virtualtype']=v.key;hrmAddressBook.virtualtype=v.key;hrmAddressBook.selectVirtual(v.key);hrmAddressBook.getData(params);hrmAddressBook.getRightMenuConfig();hrmAddressBook.updateShowSearchAd(false);hrmAddressBook.updateVisible1(false);hrmAddressBook.updateVisible2(false);}},{key:'getDialogBtns1',value:function getDialogBtns1(){var hrmAddressBook=this.props.hrmAddressBook;var btns=[React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmAddressBook.saveHrmSearchUserDefine();}},_i18n.i18n.button.save())];return btns;}},{key:'getDialogBtns2',value:function getDialogBtns2(){var hrmAddressBook=this.props.hrmAddressBook;var btns=[React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmAddressBook.saveTemplete();}},_i18n.i18n.button.save())];return btns;}},{key:'filterLeft',value:function filterLeft(items){var leftItems=(0,_cloneDeep2.default)(items);var hrmAddressBook=this.props.hrmAddressBook;var transferleftIptVal=hrmAddressBook.transferleftIptVal,transferSelectedKey=hrmAddressBook.transferSelectedKey;if(transferSelectedKey){leftItems=leftItems.filter(function(item){return item.idx==transferSelectedKey;});}if((0,_trim2.default)(transferleftIptVal)){leftItems=leftItems.filter(function(item){return item.label.indexOf((0,_trim2.default)(transferleftIptVal))>-1;});}return leftItems;}},{key:'filterRight',value:function filterRight(items){var rightItems=(0,_cloneDeep2.default)(items);var hrmAddressBook=this.props.hrmAddressBook;var transferRightIptVal=hrmAddressBook.transferRightIptVal;if((0,_trim2.default)(transferRightIptVal)){rightItems=rightItems.filter(function(item){return item.label.indexOf((0,_trim2.default)(transferRightIptVal))>-1;});}return rightItems;}},{key:'renderItem',value:function renderItem(item){return React.createElement('div',{className:'trasfer-list-item'},React.createElement('div',{className:'top text-overflow',title:item.label},item.label),React.createElement('div',{className:'bottom text-overflow',title:item.title},item.title));}},{key:'renderTransfer',value:function renderTransfer(){var hrmAddressBook=this.props.hrmAddressBook;var transferDatas=hrmAddressBook.transferDatas,transferKeys=hrmAddressBook.transferKeys,transferOptions=hrmAddressBook.transferOptions,transferleftIptVal=hrmAddressBook.transferleftIptVal,transferRightIptVal=hrmAddressBook.transferRightIptVal,transferSelectedKey=hrmAddressBook.transferSelectedKey;transferDatas=(0,_mobx.toJS)(transferDatas);transferKeys=(0,_mobx.toJS)(transferKeys);transferOptions=(0,_mobx.toJS)(transferOptions);return React.createElement('div',{style:{padding:20}},!(0,_isEmpty2.default)(transferDatas)&&React.createElement(_ecCom.WeaTransfer,{icon:'icon-coms-hrm',iconBgcolor:'#217346',filterLeft:this.filterLeft.bind(this),filterRight:this.filterRight.bind(this),height:350,leftHeader:React.createElement('div',{className:'trasfer-header'},React.createElement('span',null,_i18n.i18n.label.toBeSelected()),React.createElement(_ecCom.WeaInputSearch,{value:transferleftIptVal,onSearchChange:function onSearchChange(v){return hrmAddressBook.updateTransferleftIptVal(v);}}),React.createElement(_ecCom.WeaSelect,{options:transferOptions,value:transferSelectedKey,onChange:function onChange(v){return hrmAddressBook.updateTransferSelectedKey(v);}})),rightHeader:React.createElement('div',{className:'trasfer-header'},React.createElement('span',null,_i18n.i18n.label.selected()),React.createElement(_ecCom.WeaInputSearch,{value:transferRightIptVal,onSearchChange:function onSearchChange(v){return hrmAddressBook.updateTransferRightptVal(v);}})),renderItem:this.renderItem,data:transferDatas,selectedKeys:transferKeys,onChange:function onChange(keys,datas){return hrmAddressBook.updateTransferKeys(keys);}}));}},{key:'getTopButtons',value:function getTopButtons(){var _this6=this;var hrmAddressBook=this.props.hrmAddressBook;var showAllLevel=hrmAddressBook.showAllLevel,tabkey=hrmAddressBook.tabkey,rightMenus=hrmAddressBook.rightMenus;var keys=this.getSelectedRowKeys();var btns=[];var btnShowAllLevel=React.createElement(_antd.Button,{size:'small',style:{height:'28px'},onClick:function onClick(){return _this6.changeShowAllLevel();},title:showAllLevel?_i18n.i18n.button.directSubordinates():_i18n.i18n.button.DisplaySubordinateSubordinates()},React.createElement('span',null,showAllLevel?React.createElement('i',{className:'icon-coms-DisplaySubordinates',style:{color:'#2db7f5'}}):React.createElement('i',{className:'icon-coms-NoDisplayOfSubordinates'})));if(tabkey=='default_2'){btns.push(btnShowAllLevel);}(0,_mobx.toJS)(rightMenus).map(function(item,index){if(item.isTop&&item.isTop=='1'){btns.push(React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this6[item.menuFun]&&_this6[item.menuFun]();},disabled:item.menuFun=='sendEmessage'&&keys.length==0},item.menuName));}});return btns;}},{key:'changeShowAllLevel',value:function changeShowAllLevel(){var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.changeShowAllLevel();}},{key:'sendEmessage',value:function sendEmessage(){var keys=this.getSelectedRowKeys();var ids=keys?keys.join(','):'';PublicFunc.sendEmessage(ids);}},{key:'exportExcel',value:function exportExcel(){var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.initExportSetting();return;hrmAddressBook.exportExcel();}},{key:'doSearch',value:function doSearch(params){var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.doSearch(params);}},{key:'reSearch',value:function reSearch(){var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.reSearch();}},{key:'definedColumn',value:function definedColumn(){var hrmAddressBook=this.props.hrmAddressBook;var table=hrmAddressBook.table;table.setColSetVisible(true);table.tableColSet(true);}},{key:'getSelectedRowKeys',value:function getSelectedRowKeys(){var hrmAddressBook=this.props.hrmAddressBook;var table=hrmAddressBook.table;var selectedRowKeys=table.selectedRowKeys;return selectedRowKeys;}},{key:'render',value:function render(){var _this7=this;var hrmAddressBook=this.props.hrmAddressBook;var title=hrmAddressBook.title,tabs=hrmAddressBook.tabs,tabkey=hrmAddressBook.tabkey,showSearchAd=hrmAddressBook.showSearchAd,loading=hrmAddressBook.loading,comsWeaTableStore=hrmAddressBook.comsWeaTableStore,form=hrmAddressBook.form,table=hrmAddressBook.table,visible1=hrmAddressBook.visible1,visible2=hrmAddressBook.visible2,templeteValue=hrmAddressBook.templeteValue,defaultShowLeft=hrmAddressBook.defaultShowLeft,spinning=hrmAddressBook.spinning;var formParams=form.getFormParams();return React.createElement('div',{className:'wea-hrm-address'},React.createElement(_ecCom.WeaDialog,{className:'wea-hrm-address-dialog',visible:visible1,onCancel:function onCancel(){return hrmAddressBook.updateVisible1(false);},closable:true,style:{width:700,height:440},title:_i18n.i18n.button.conditionDef(),icon:'icon-coms-hrm',iconBgcolor:'#217346',buttons:this.getDialogBtns1()},this.renderTransfer()),React.createElement(_ecCom.WeaDialog,{visible:visible2,onCancel:function onCancel(){return hrmAddressBook.updateVisible2(false);},closable:true,style:{width:500,height:120},title:_i18n.i18n.button.saveAsTemplate(),icon:'icon-coms-hrm',iconBgcolor:'#217346',buttons:this.getDialogBtns2()},React.createElement('div',{style:{padding:20}},React.createElement(_ecCom.WeaFormItem,{label:_i18n.i18n.label.searchTemplateName(),labelCol:{span:6},wrapperCol:{span:14}},React.createElement(_ecCom.WeaInput,(0,_extends3.default)({viewAttr:'3',value:templeteValue},window.inputType,{value:'',onChange:function onChange(v){return hrmAddressBook.updateTempleteValue(v);}}))))),React.createElement(_antd.Spin,{spinning:spinning},React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},React.createElement(_ecCom.WeaTop,{title:title(),loading:false,icon:React.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu(),onDropMenuClick:this.onRightMenuClick.bind(this)},React.createElement(_ecCom.WeaLeftRightLayout,{isNew:true,showLeft:defaultShowLeft,leftCom:this.getTree()},React.createElement(_ecCom.WeaTab,{type:'editable-inline',buttonsAd:this.getTabButtonsAd(),searchType:['base','advanced'],searchsBaseValue:form.getFormParams()[this.quickSearchPara||'lastname']||'',searchsAd:this.getSearchs(),showSearchAd:showSearchAd,setShowSearchAd:function setShowSearchAd(bool){hrmAddressBook.updateShowSearchAd(bool);},hideSearchAd:function hideSearchAd(){hrmAddressBook.updateShowSearchAd(false);},keyParam:'typeid',datas:(0,_mobx.toJS)(tabs),selectedKey:tabkey,onChange:function onChange(val){hrmAddressBook.updateTabkey(val);},onSearch:function onSearch(){hrmAddressBook.getSearchList();},onSearchChange:function onSearchChange(value){form.updateFields((0,_defineProperty3.default)({},_this7.quickSearchPara||'lastname',{value:value}));},onEdit:this.onTabEdit}),React.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true,getColumns:this.reRenderColumns,onOperatesClick:this.onOperatesClick}))))),React.createElement(_AddressBookExportSetting2.default,{store:hrmAddressBook}));}}]);return AddressBook;}(React.Component))||_class)||_class);exports.default=AddressBook;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(239);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(240);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 439 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 440 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(240);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(443),
    hasUnicode = __webpack_require__(444),
    unicodeToArray = __webpack_require__(445);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 444 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 445 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _lodash=__webpack_require__(65);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var FieldSetting=(0,_mobxReact.observer)(_class=function(_Component){(0,_inherits3.default)(FieldSetting,_Component);function FieldSetting(props){(0,_classCallCheck3.default)(this,FieldSetting);var _this=(0,_possibleConstructorReturn3.default)(this,(FieldSetting.__proto__||(0,_getPrototypeOf2.default)(FieldSetting)).call(this,props));_this.renderItem=function(item){var store=_this.props.store;var setRealPath=store.setRealPath,realPath=store.realPath,keyfield=store.keyfield,setKeyField=store.setKeyField;//departmentid 部门 subcompanyid1 分部
if(['departmentid','subcompanyid1'].indexOf(item.id)>-1){var options=(0,_lodash.cloneDeep)(_this.state.options);options[0].showname=item.id==='departmentid'?getLabel('18916',"仅本部门"):getLabel('18919',"仅本分部");options[1].showname=item.id==='departmentid'?getLabel('388381',"部门全路径"):getLabel('388382',"分部全路径");return _react2.default.createElement('div',{className:'item'},_react2.default.createElement('div',{className:'left'},_react2.default.createElement('div',{className:'info'},item.name),_react2.default.createElement('div',{className:'info info-module'},item.gName)),_react2.default.createElement('div',{className:'right'},_react2.default.createElement(_ecCom.WeaSelect,{options:options,value:item.id==='departmentid'?realPath.depRealPath:realPath.subCompRealPath,onChange:function onChange(v){setRealPath(item.id==='departmentid',v);_this.setState({t:new Date().getTime()});}})));}else if(item.id==='managerid'){var _options=(0,_lodash.cloneDeep)(_this.state.keyFieldOptions);_options[0].showname=getLabel('714',"编号");_options[1].showname=getLabel('412',"登录名");_options[2].showname=getLabel('25034',"姓名");return _react2.default.createElement('div',{className:'item'},_react2.default.createElement('div',{className:'left'},_react2.default.createElement('div',{className:'info'},item.name),_react2.default.createElement('div',{className:'info info-module'},item.gName)),_react2.default.createElement('div',{className:'right'},_react2.default.createElement(_ecCom.WeaSelect,{options:_options,value:keyfield,onChange:setKeyField})));}return _react2.default.createElement('div',{className:'item'},_react2.default.createElement('div',{className:'name'},item.name),_react2.default.createElement('div',{className:'name name-module'},item.gName));};_this.state={options:[{key:"0",selected:true,showname:""},{key:"1",selected:false,showname:""}],keyFieldOptions:[{key:"1",selected:true,showname:""},{key:"2",selected:false,showname:""},{key:"3",selected:false,showname:""}],t:new Date().getTime()};return _this;}(0,_createClass3.default)(FieldSetting,[{key:'render',value:function render(){var _this2=this;var t=this.state.t;var store=this.props.store;var refreshTransfer=store.refreshTransfer,showGroup=store.showGroup,getDialogBtn=store.getDialogBtn,getTransferData=store.getTransferData,selectOptions=store.selectOptions,setSelectedGroup=store.setSelectedGroup,getSelectedGroup=store.getSelectedGroup,_filterLeft=store.filterLeft,_filterRight=store.filterRight,searchField=store.searchField,onTransChange=store.onTransChange,formTarget=store.formTarget,fieldSettingDialogParams=store.fieldSettingDialogParams,selectedKeys=store.selectedKeys,templates=store.templates,selectedTemplate=store.selectedTemplate,loadTemplateFields=store.loadTemplateFields;var templateList=[];if(templates&&templates.length>0){templateList.push({key:'-1',selected:false,showname:''});templates.map(function(data,index){templateList.push({key:index.toString(),selected:false,showname:data.name});});}var _getDialogBtn=getDialogBtn(),buttons=_getDialogBtn.buttons,menus=_getDialogBtn.menus;var transferProps={height:425,data:getTransferData(),leftHeader:_react2.default.createElement('div',{className:'header'},_react2.default.createElement('div',{className:'title text-elli'},getLabel(83302,'待选')),_react2.default.createElement('div',{className:'options'},_react2.default.createElement(_ecCom.WeaSelect,{options:selectOptions,onChange:function onChange(v){setSelectedGroup(v);_this2.setState({t:new Date().getTime()});}})),_react2.default.createElement('div',{className:'search'},_react2.default.createElement(_ecCom.WeaInputSearch,{onSearchChange:function onSearchChange(v){return searchField(v);},onSearch:function onSearch(v){return searchField(v);}}))),rightHeader:_react2.default.createElement('div',{className:'header'},_react2.default.createElement('div',{className:'title text-elli'},getLabel(83303,'已选')),_react2.default.createElement('div',{className:'options'},showGroup&&_react2.default.createElement(_ecCom.WeaSelect,{options:templateList,value:selectedTemplate,onChange:function onChange(v){loadTemplateFields(v);_this2.setState({t:new Date().getTime()});}})),_react2.default.createElement('div',{className:'search'},_react2.default.createElement(_ecCom.WeaInputSearch,{onSearchChange:function onSearchChange(v){return searchField(v,false);},onSearch:function onSearch(v){return searchField(v,false);}}))),renderItem:this.renderItem,filterLeft:function filterLeft(items){var groupInfo=getSelectedGroup();items=items.filter(function(item){if(groupInfo.key==='0'){return _filterLeft===''?true:item.name.indexOf(_filterLeft)!=-1;}else{return item.gName===groupInfo.showname&&(_filterLeft===''?true:item.name.indexOf(_filterLeft)!=-1);}});return items;},filterRight:function filterRight(items){items=items.filter(function(item){return _filterRight===''?true:item.name.indexOf(_filterRight)!=-1;});return items;},onChange:onTransChange,selectedKeys:selectedKeys};var saveForm=formTarget.saveForm,saveFormFields=formTarget.saveFormFields;return _react2.default.createElement(_ecCom.WeaDialog,(0,_extends3.default)({},fieldSettingDialogParams,{buttons:buttons,moreBtn:{datas:menus}}),_react2.default.createElement(_antd.Spin,{spinning:this.props.store.spinning},_react2.default.createElement(_ecCom.WeaTransfer,transferProps)));}}]);return FieldSetting;}(_react.Component))||_class;exports.default=FieldSetting;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _FormInfo=__webpack_require__(243);var _FormInfo2=_interopRequireDefault(_FormInfo);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FormSetting=(0,_mobxReact.observer)(_class=function(_Component){(0,_inherits3.default)(FormSetting,_Component);function FormSetting(props){(0,_classCallCheck3.default)(this,FormSetting);return(0,_possibleConstructorReturn3.default)(this,(FormSetting.__proto__||(0,_getPrototypeOf2.default)(FormSetting)).call(this,props));}(0,_createClass3.default)(FormSetting,[{key:'render',value:function render(){var store=this.props.store;var getDialogBtn=store.getDialogBtn,formTarget=store.formTarget,saveFormDialogParams=store.saveFormDialogParams;var _getDialogBtn=getDialogBtn(),buttons=_getDialogBtn.buttons,menus=_getDialogBtn.menus;var saveForm=formTarget.saveForm,saveFormFields=formTarget.saveFormFields;var dp=(0,_extends3.default)({},saveFormDialogParams,{key:new Date().getTime()});return _react2.default.createElement(_ecCom.WeaDialog,(0,_extends3.default)({},dp,{buttons:buttons,moreBtn:{datas:menus}}),_react2.default.createElement(_FormInfo2.default,{center:false,form:saveForm,formFields:saveFormFields}));}}]);return FormSetting;}(_react.Component))||_class;exports.default=FormSetting;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _findIndex=__webpack_require__(228);var _findIndex2=_interopRequireDefault(_findIndex);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var TemplateEdit=(0,_mobxReact.observer)(_class=function(_Component){(0,_inherits3.default)(TemplateEdit,_Component);function TemplateEdit(props){(0,_classCallCheck3.default)(this,TemplateEdit);var _this=(0,_possibleConstructorReturn3.default)(this,(TemplateEdit.__proto__||(0,_getPrototypeOf2.default)(TemplateEdit)).call(this,props));_this.doEdit=function(id,record){_this.props.store.editTemplate(record);};_this.doSaveAs=function(id){_this.props.store.saveAs(id);};_this.doDelete=function(id){_this.props.store.deleteTemplate({id:id});};_this.onOperatesClick=function(record,index,operate){var func=operate.href?operate.href.split(':')[1].split('(')[0]:'';var id=record.id?record.id:'';_this[func]&&_this[func](id,record);};_this.renderCol=function(cols){var idx=(0,_findIndex2.default)(cols,function(item){return item.dataIndex==='name';});idx!=-1&&(cols[idx].render=function(text,record){return _react2.default.createElement('a',{onClick:function onClick(){return _this.doEdit(record.id,record);}},_ecCom.WeaLocaleProvider.formatMultiLang(record.name));});};return _this;}(0,_createClass3.default)(TemplateEdit,[{key:'render',value:function render(){var _this2=this;var store=this.props.store;var editDialogParams=store.editDialogParams,multiDelete=store.multiDelete,templateStore=store.templateStore,editTemplate=store.editTemplate,deleteTemplate=store.deleteTemplate;var tableProps={scroll:{y:380}};return _react2.default.createElement(_ecCom.WeaDialog,(0,_extends3.default)({},editDialogParams,{buttons:[],moreBtn:{datas:[]},layout:document.getElementsByClassName('wea-hrm-address')[0]}),_react2.default.createElement(_ecCom.WeaTab,{datas:[],keyParam:'viewcondition'//主键
,buttons:[_react2.default.createElement(_ecCom.WeaButtonIcon,{buttonType:'add',type:'primary',onClick:function onClick(){return editTemplate();}}),_react2.default.createElement(_ecCom.WeaButtonIcon,{buttonType:'del',type:'primary',onClick:function onClick(){return deleteTemplate({});},disabled:multiDelete})]}),_react2.default.createElement(WeaTable,(0,_extends3.default)({comsWeaTableStore:templateStore},tableProps,{needScroll:true,onOperatesClick:function onOperatesClick(record,index,operate){return _this2.onOperatesClick(record,index,operate);},getColumns:function getColumns(cols){return _this2.renderCol(cols);}})));}}]);return TemplateEdit;}(_react.Component))||_class;exports.default=TemplateEdit;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(38);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobx=__webpack_require__(8);var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _ecCom=__webpack_require__(0);var _trim=__webpack_require__(238);var _trim2=_interopRequireDefault(_trim);var _comsMobx=__webpack_require__(10);__webpack_require__(241);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _AddressBookExportSetting=__webpack_require__(242);var _AddressBookExportSetting2=_interopRequireDefault(_AddressBookExportSetting);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var AddressBook=(_dec=(0,_mobxReact.inject)('hrmAddressBook'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(AddressBook,_React$Component);function AddressBook(props){(0,_classCallCheck3.default)(this,AddressBook);var _this=(0,_possibleConstructorReturn3.default)(this,(AddressBook.__proto__||(0,_getPrototypeOf2.default)(AddressBook)).call(this,props));_this.onTabEdit=function(targetKey,action){var hrmAddressBook=_this.props.hrmAddressBook;if(action==='remove'){var params={};params.opera="delete";params.mouldid=targetKey;hrmAddressBook.deleteTabs(params);}};_this.reRenderColumns=function(columns){var __this=_this;columns.forEach(function(c){if(c.dataIndex=='lastname'){c.render=function(text,record){return React.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:function onClick(){return(0,_pulicFunc.jumpToHrmCard)(record.id);}},record.lastname);};}else if(c.dataIndex=='managerid'){c.render=function(text,record){return React.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:function onClick(){return(0,_pulicFunc.jumpToHrmCard)(record.managerid);},dangerouslySetInnerHTML:{__html:record.manageridspan}});};}else if(c.dataIndex=='subcompanyid1'){c.render=function(text,record){return React.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:function onClick(){return(0,_pulicFunc.jumpToHrmSubCompany)(record.subcompanyid1);},dangerouslySetInnerHTML:{__html:record.subcompanyid1span}});};}else if(c.dataIndex=='departmentid'){c.render=function(text,record){return React.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:function onClick(){return(0,_pulicFunc.jumpToHrmDept)(record.departmentid);},dangerouslySetInnerHTML:{__html:record.departmentidspan}});};}else if(c.dataIndex=='jobtitle'){c.render=function(text,record){return React.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:function onClick(){return(0,_pulicFunc.jumpToHrmPost)(record.jobtitle);},dangerouslySetInnerHTML:{__html:record.jobtitlespan}});};}else{c.render=function(text,record){var valueSpan=record[c.dataIndex+"span"]!==undefined?record[c.dataIndex+"span"]:record[c.dataIndex];return React.createElement('span',{dangerouslySetInnerHTML:{__html:valueSpan}});};}});return columns;};_this.onOperatesClick=function(record,index,operate,flag,argumentString){var fn=operate.href?operate.href.split(':')[1].split('(')[0]:'';var id=record.id?record.id:'';PublicFunc[fn](id);};_this.treeNodeClick=function(event){var hrmAddressBook=_this.props.hrmAddressBook;var form=hrmAddressBook.form;var type=event.node.props.type||'0';var id=event.node.props.id||'';var params={};form.resetConditionValue();hrmAddressBook.updateShowSearchAd(false);hrmAddressBook.tabkey='default_3';if(type=='1'){params['subcompanyid1']=id;}if(type=='2'){params['departmentid']=id;}hrmAddressBook.doSearch(params);};_this.state={transferVisible:false};return _this;}(0,_createClass3.default)(AddressBook,[{key:'componentDidMount',value:function componentDidMount(){// const {
//   from,
//   lastname
// } = this.props.location.query;
var hrmAddressBook=this.props.hrmAddressBook;// hrmAddressBook.searchFrom = from || '';
// hrmAddressBook.searchKeyWord = lastname || '';
var paramsFromURL=this.props.location.query;this.init(paramsFromURL);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location.key!==nextProps.location.key){// const {
//   from,
//   lastname
// } = nextProps.location.query;
var hrmAddressBook=this.props.hrmAddressBook;// hrmAddressBook.searchFrom = from || '';
// hrmAddressBook.searchKeyWord = lastname || '';
// this.refs.WeaOrgTree.reset(()=>{
//   this.refs.WeaOrgTree.fetchData();
// });
var paramsFromURL=nextProps.location.query;this.init(paramsFromURL);}}},{key:'init',value:function init(paramsFromURL){var _props$location$query=this.props.location.query,type=_props$location$query.type,id=_props$location$query.id;var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.showAllLevel=false;hrmAddressBook.rightMenus=[];hrmAddressBook.defaultShowLeft=false;if(hrmAddressBook.searchFrom&&hrmAddressBook.searchFrom=='quickSearch'){hrmAddressBook.tabkey='default_3';}else{hrmAddressBook.tabkey='default_3';}var params={};if(type&&type!=''&&id&&id!=''){if(type=='1'){params['subcompanyid1']=id;}if(type=='2'){params['departmentid']=id;}}(0,_assign2.default)(params,paramsFromURL);hrmAddressBook.getData(params);hrmAddressBook.getRightMenuConfig();hrmAddressBook.updateShowSearchAd(false);hrmAddressBook.updateVisible1(false);hrmAddressBook.updateVisible2(false);}},{key:'getTabButtonsAd',value:function getTabButtonsAd(){var _this2=this;var hrmAddressBook=this.props.hrmAddressBook;var tabkey=hrmAddressBook.tabkey,form=hrmAddressBook.form;var btns=[React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmAddressBook.updateShowSearchAd(false);_this2.doSearch();}},_i18n.i18n.button.search())];tabkey=='default_3'&&btns.push(React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmAddressBook.updateVisible2(true);}},_i18n.i18n.button.saveAsTemplate()));tabkey=='default_3'&&btns.push(React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmAddressBook.formatTransfer();hrmAddressBook.updateVisible1(true);}},_i18n.i18n.button.conditionDef()));btns.push(React.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){return form.resetConditionValue();}},_i18n.i18n.button.reset()));btns.push(React.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){return hrmAddressBook.updateShowSearchAd(false);}},_i18n.i18n.button.cancel()));return btns;}},{key:'getSearchs',value:function getSearchs(){var _this3=this;var hrmAddressBook=this.props.hrmAddressBook;var conditioninfo=hrmAddressBook.conditioninfo,conditioninfoAll=hrmAddressBook.conditioninfoAll,form=hrmAddressBook.form,showAllCondition=hrmAddressBook.showAllCondition;var isFormInit=form.isFormInit;var ci=(0,_mobx.toJS)(showAllCondition?conditioninfoAll:conditioninfo);var group=[];isFormInit&&ci.forEach(function(c){var items=[];c.items.forEach(function(field){if(field.isQuickSearch){_this3.quickSearchPara=field.domkey[0];}items.push({com:React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:field.labelcol},wrapperCol:{span:field.fieldcol}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form})),colSpan:1});});group.push(React.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:c.title,showGroup:c.defaultshow,items:items}));});return React.createElement('div',null,group,!showAllCondition&&React.createElement('div',{style:{textAlign:'right',padding:'20px 25px'}},React.createElement('span',{className:'cursor-pointer',onClick:function onClick(){return hrmAddressBook.updateShowAllCondition(true);},style:{marginRight:12}},React.createElement('span',{style:{marginRight:8}},_i18n.i18n.label.allCondition()),React.createElement('i',{className:'icon-coms-right',style:{color:'#b2b2b2'}}))));}},{key:'getRightMenu',value:function getRightMenu(){var hrmAddressBook=this.props.hrmAddressBook;var rightMenus=hrmAddressBook.rightMenus;var btns=[];var keys=this.getSelectedRowKeys();!(0,_isEmpty2.default)((0,_mobx.toJS)(rightMenus))&&(0,_mobx.toJS)(rightMenus).forEach(function(c){var item={icon:React.createElement('i',{className:''+c.menuIcon}),content:c.menuName};if(c.menuFun=='sendEmessage')item.disabled=keys.length==0;btns.push(item);});return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmAddressBook=this.props.hrmAddressBook;var rightMenus=hrmAddressBook.rightMenus;var menuFun=rightMenus.toJS()[key].menuFun;this[menuFun]&&this[menuFun]();}},{key:'getTree',value:function getTree(){return React.createElement(WeaOrgTree,{ref:'WeaOrgTree',loading:true,needSearch:true,isLoadSubDepartment:true,topPrefix:'hrmSearch',inputLeftDom:'<b>'+_i18n.i18n.label.organization()+'</b',treeNodeClick:this.treeNodeClick});}},{key:'getDialogBtns1',value:function getDialogBtns1(){var hrmAddressBook=this.props.hrmAddressBook;var btns=[React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmAddressBook.saveHrmSearchUserDefine();}},_i18n.i18n.button.save())];return btns;}},{key:'getDialogBtns2',value:function getDialogBtns2(){var hrmAddressBook=this.props.hrmAddressBook;var btns=[React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmAddressBook.saveTemplete();}},_i18n.i18n.button.save())];return btns;}},{key:'filterLeft',value:function filterLeft(items){var leftItems=(0,_cloneDeep2.default)(items);var hrmAddressBook=this.props.hrmAddressBook;var transferleftIptVal=hrmAddressBook.transferleftIptVal,transferSelectedKey=hrmAddressBook.transferSelectedKey;if(transferSelectedKey){leftItems=leftItems.filter(function(item){return item.idx==transferSelectedKey;});}if((0,_trim2.default)(transferleftIptVal)){leftItems=leftItems.filter(function(item){return item.label.indexOf((0,_trim2.default)(transferleftIptVal))>-1;});}return leftItems;}},{key:'filterRight',value:function filterRight(items){var rightItems=(0,_cloneDeep2.default)(items);var hrmAddressBook=this.props.hrmAddressBook;var transferRightIptVal=hrmAddressBook.transferRightIptVal;if((0,_trim2.default)(transferRightIptVal)){rightItems=rightItems.filter(function(item){return item.label.indexOf((0,_trim2.default)(transferRightIptVal))>-1;});}return rightItems;}},{key:'renderItem',value:function renderItem(item){return React.createElement('div',{className:'trasfer-list-item'},React.createElement('div',{className:'top text-overflow',title:item.label},item.label),React.createElement('div',{className:'bottom text-overflow',title:item.title},item.title));}},{key:'renderTransfer',value:function renderTransfer(){var hrmAddressBook=this.props.hrmAddressBook;var transferDatas=hrmAddressBook.transferDatas,transferKeys=hrmAddressBook.transferKeys,transferOptions=hrmAddressBook.transferOptions,transferleftIptVal=hrmAddressBook.transferleftIptVal,transferRightIptVal=hrmAddressBook.transferRightIptVal,transferSelectedKey=hrmAddressBook.transferSelectedKey;transferDatas=(0,_mobx.toJS)(transferDatas);transferKeys=(0,_mobx.toJS)(transferKeys);transferOptions=(0,_mobx.toJS)(transferOptions);return React.createElement('div',{style:{padding:20}},!(0,_isEmpty2.default)(transferDatas)&&React.createElement(_ecCom.WeaTransfer,{icon:'icon-coms-hrm',iconBgcolor:'#217346',filterLeft:this.filterLeft.bind(this),filterRight:this.filterRight.bind(this),height:350,leftHeader:React.createElement('div',{className:'trasfer-header'},React.createElement('span',null,_i18n.i18n.label.toBeSelected()),React.createElement(_ecCom.WeaInputSearch,{value:transferleftIptVal,onSearchChange:function onSearchChange(v){return hrmAddressBook.updateTransferleftIptVal(v);}}),React.createElement(_ecCom.WeaSelect,{options:transferOptions,value:transferSelectedKey,onChange:function onChange(v){return hrmAddressBook.updateTransferSelectedKey(v);}})),rightHeader:React.createElement('div',{className:'trasfer-header'},React.createElement('span',null,_i18n.i18n.label.selected()),React.createElement(_ecCom.WeaInputSearch,{value:transferRightIptVal,onSearchChange:function onSearchChange(v){return hrmAddressBook.updateTransferRightptVal(v);}})),renderItem:this.renderItem,data:transferDatas,selectedKeys:transferKeys,onChange:function onChange(keys,datas){return hrmAddressBook.updateTransferKeys(keys);}}),' ');}},{key:'getTopButtons',value:function getTopButtons(){var _this4=this;var hrmAddressBook=this.props.hrmAddressBook;var showAllLevel=hrmAddressBook.showAllLevel,tabkey=hrmAddressBook.tabkey,rightMenus=hrmAddressBook.rightMenus;var keys=this.getSelectedRowKeys();var btns=[];var btnShowAllLevel=React.createElement(_antd.Button,{size:'small',style:{height:'28px'},onClick:function onClick(){return _this4.changeShowAllLevel();},title:showAllLevel?_i18n.i18n.button.directSubordinates():_i18n.i18n.button.DisplaySubordinateSubordinates()},React.createElement('span',null,showAllLevel?React.createElement('i',{className:'icon-coms-DisplaySubordinates',style:{color:'#2db7f5'}}):React.createElement('i',{className:'icon-coms-NoDisplayOfSubordinates'})));if(tabkey=='default_2'){btns.push(btnShowAllLevel);}(0,_mobx.toJS)(rightMenus).map(function(item,index){if(item.isTop&&item.isTop=='1'){btns.push(React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this4[item.menuFun]&&_this4[item.menuFun]();},disabled:item.menuFun=='sendEmessage'&&keys.length==0},item.menuName));}});return btns;}},{key:'changeShowAllLevel',value:function changeShowAllLevel(){var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.changeShowAllLevel();}},{key:'sendEmessage',value:function sendEmessage(){var keys=this.getSelectedRowKeys();var ids=keys?keys.join(','):'';PublicFunc.sendEmessage(ids);}},{key:'exportExcel',value:function exportExcel(){var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.initExportSetting();return;hrmAddressBook.exportExcel();}},{key:'doSearch',value:function doSearch(params){var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.doSearch(params);}},{key:'reSearch',value:function reSearch(){var hrmAddressBook=this.props.hrmAddressBook;hrmAddressBook.reSearch();}},{key:'definedColumn',value:function definedColumn(){var hrmAddressBook=this.props.hrmAddressBook;var table=hrmAddressBook.table;table.setColSetVisible(true);table.tableColSet(true);}},{key:'getSelectedRowKeys',value:function getSelectedRowKeys(){var hrmAddressBook=this.props.hrmAddressBook;var table=hrmAddressBook.table;var selectedRowKeys=table.selectedRowKeys;return selectedRowKeys;}},{key:'render',value:function render(){var _this5=this;var hrmAddressBook=this.props.hrmAddressBook;var title=hrmAddressBook.title,tabs=hrmAddressBook.tabs,tabkey=hrmAddressBook.tabkey,showSearchAd=hrmAddressBook.showSearchAd,loading=hrmAddressBook.loading,comsWeaTableStore=hrmAddressBook.comsWeaTableStore,form=hrmAddressBook.form,table=hrmAddressBook.table,visible1=hrmAddressBook.visible1,visible2=hrmAddressBook.visible2,templeteValue=hrmAddressBook.templeteValue,defaultShowLeft=hrmAddressBook.defaultShowLeft,spinning=hrmAddressBook.spinning;var formParams=form.getFormParams();return React.createElement('div',{className:'wea-hrm-address'},React.createElement(_ecCom.WeaDialog,{className:'wea-hrm-address-dialog',visible:visible1,onCancel:function onCancel(){return hrmAddressBook.updateVisible1(false);},closable:true,style:{width:700,height:440},title:_i18n.i18n.button.conditionDef(),icon:'icon-coms-hrm',iconBgcolor:'#217346',buttons:this.getDialogBtns1()},this.renderTransfer()),React.createElement(_ecCom.WeaDialog,{visible:visible2,onCancel:function onCancel(){return hrmAddressBook.updateVisible2(false);},closable:true,style:{width:500,height:120},title:_i18n.i18n.button.saveAsTemplate(),icon:'icon-coms-hrm',iconBgcolor:'#217346',buttons:this.getDialogBtns2()},React.createElement('div',{style:{padding:20}},React.createElement(_ecCom.WeaFormItem,{label:_i18n.i18n.label.searchTemplateName(),labelCol:{span:6},wrapperCol:{span:14}},React.createElement(_ecCom.WeaInput,(0,_extends3.default)({viewAttr:'3',value:templeteValue},window.inputType,{value:'',onChange:function onChange(v){return hrmAddressBook.updateTempleteValue(v);}}))))),React.createElement(_antd.Spin,{spinning:spinning},React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},React.createElement(_ecCom.WeaTop,{title:title(),loading:false,icon:React.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu(),onDropMenuClick:this.onRightMenuClick.bind(this)},React.createElement(_ecCom.WeaTab,{type:'editable-inline',buttonsAd:this.getTabButtonsAd(),searchType:['base','advanced'],searchsBaseValue:form.getFormParams()[this.quickSearchPara||'lastname']||'',searchsAd:this.getSearchs(),showSearchAd:showSearchAd,setShowSearchAd:function setShowSearchAd(bool){hrmAddressBook.updateShowSearchAd(bool);},hideSearchAd:function hideSearchAd(){hrmAddressBook.updateShowSearchAd(false);},keyParam:'typeid'// datas={toJS(tabs)}
,selectedKey:tabkey,onChange:function onChange(val){hrmAddressBook.updateTabkey(val);},onSearch:function onSearch(){hrmAddressBook.getSearchList();},onSearchChange:function onSearchChange(value){form.updateFields((0,_defineProperty3.default)({},_this5.quickSearchPara||'lastname',{value:value}));},onEdit:this.onTabEdit}),React.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true,getColumns:this.reRenderColumns,onOperatesClick:this.onOperatesClick})))),React.createElement(_AddressBookExportSetting2.default,{store:hrmAddressBook}));}}]);return AddressBook;}(React.Component))||_class)||_class);exports.default=AddressBook;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _add=__webpack_require__(451);var _add2=_interopRequireDefault(_add);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _i18n=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('hrmAdd'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var hrmAdd=this.props.hrmAdd;var departmentid=this.props.location.query.departmentid||'';hrmAdd.departmentid=departmentid;hrmAdd.checkRight();}},{key:'render',value:function render(){var hrmAdd=this.props.hrmAdd;var verified=hrmAdd.verified,hasRight=hrmAdd.hasRight;if(window.location.href.indexOf("/spa/hrm/index_mobx.html")>-1){document.title=_i18n.i18n.module.createResource();}if(verified&&hasRight){return React.createElement(_add2.default,this.props);}if(verified&&!hasRight){return React.createElement(_ecCom.WeaAlertPage,null,React.createElement('div',{style:{color:'#000'}},_i18n.i18n.message.authFailed()));}return React.createElement('div',null);}}]);return Main;}(React.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;// import Immutable from 'immutable'
// const is = Immutable.is;
var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _simple=__webpack_require__(452);var _simple2=_interopRequireDefault(_simple);var _full=__webpack_require__(454);var _full2=_interopRequireDefault(_full);__webpack_require__(455);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var toJS=mobx.toJS;var _this=void 0;var Add=(_dec=(0,_mobxReact.inject)('hrmAdd'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Add,_React$Component);function Add(props){(0,_classCallCheck3.default)(this,Add);var _this2=(0,_possibleConstructorReturn3.default)(this,(Add.__proto__||(0,_getPrototypeOf2.default)(Add)).call(this,props));_this2.onOperatesClick=function(record,index,operate,flag,argumentString){var fn=operate.href?operate.href.split(':')[1].split('(')[0]:'';var id=record.id?record.id:'';PublicFunc[fn](id);};_this2.getFields=function(){var bool=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var index=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var hrmAdd=_this2.props.hrmAdd;var formSearch=hrmAdd.formSearch,condition=hrmAdd.condition;var browserConditions=toJS(condition);var fieldsData=!(0,_isEmpty2.default)(browserConditions)&&browserConditions[index].items;var items=new Array();fieldsData.forEach(function(field){field&&items.push({com:_react2.default.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:formSearch})),colSpan:field.colSpan||2});});return items;};_this2.treeNodeClick=function(nodeObj){var type=nodeObj.node.props.type||'0';var id=nodeObj.node.props.id||'';var name=nodeObj.node.props.name||'';var hrmAdd=_this2.props.hrmAdd;var formSearch=hrmAdd.formSearch;hrmAdd.setShowSearchAd(false);var params={};if(type=='1'){params.subcompanyid1=id;}if(type=='2'){params.departmentid=id;}hrmAdd.doSearch(params);};_this=_this2;var funcs=['onOperatesClick','jumpToHrmCard','openFullmode','update'];funcs.forEach(function(f){return _this2[f]=_this2[f].bind(_this2);});return _this2;}(0,_createClass3.default)(Add,[{key:'componentDidMount',value:function componentDidMount(){var hrmAdd=this.props.hrmAdd;hrmAdd.getData();hrmAdd.simpleVisible=true;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmAdd=this.props.hrmAdd;var keyOld=this.props.location.key;var keyNew=nextProps.location.key;if(keyOld!==keyNew){hrmAdd.setShowSearchAd(false);this.componentDidMount();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var hrmAdd=this.props.hrmAdd;hrmAdd.setShowSearchAd(false);hrmAdd.simpleVisible=false;}},{key:'render',value:function render(){var _this3=this;var hrmAdd=this.props.hrmAdd;var dataKey=hrmAdd.dataKey,formSearch=hrmAdd.formSearch,title=hrmAdd.title,searchParamsAd=hrmAdd.searchParamsAd,showSearchAd=hrmAdd.showSearchAd,table=hrmAdd.table,simpleVisible=hrmAdd.simpleVisible,fullVisible=hrmAdd.fullVisible;var formParams=formSearch.getFormParams();return _react2.default.createElement('div',{className:'wea-myhrm-Add'},_react2.default.createElement(_simple2.default,{visible:simpleVisible,openFullmode:this.openFullmode,update:this.update,onCancel:function onCancel(){hrmAdd.simpleVisible=false;}}),_react2.default.createElement(_full2.default,{visible:fullVisible,update:this.update,onCancel:function onCancel(){hrmAdd.fullVisible=false;}}),_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},_react2.default.createElement(_ecCom.WeaTop,{title:title(),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu(),onDropMenuClick:this.onRightMenuClick.bind(this)},_react2.default.createElement('div',{style:{height:'100%'}},_react2.default.createElement(_ecCom.WeaLeftRightLayout,{isNew:true,leftCom:this.getTree()},_react2.default.createElement(_ecCom.WeaTab,{onlyShowRight:true,buttonsAd:this.getTabButtonsAd(),searchType:['base','advanced'],searchsBaseValue:formParams.resourcename,setShowSearchAd:function setShowSearchAd(bool){hrmAdd.setShowSearchAd(bool);},hideSearchAd:function hideSearchAd(){return hrmAdd.setShowSearchAd(false);},searchsAd:this.getSearchs(true),showSearchAd:showSearchAd,onSearch:function onSearch(v){hrmAdd.doSearch();},onSearchChange:function onSearchChange(v){formSearch.updateFields({resourcename:{name:'resourcename',value:v}});}}),_react2.default.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true,getColumns:function getColumns(c){return _this3.reRenderColumns(c);},onOperatesClick:this.onOperatesClick}))))));}},{key:'reRenderColumns',value:function reRenderColumns(columns){columns.forEach(function(c){if(c.dataIndex=='lastname'){c.render=function(text,record){return _react2.default.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:_this.jumpToHrmCard.bind(null,record.id)},record.lastname);};}else{c.render=function(text,record){var valueSpan=record[c.dataIndex+"span"]!==undefined?record[c.dataIndex+"span"]:record[c.dataIndex];return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:valueSpan}});};}});return columns;}},{key:'jumpToHrmCard',value:function jumpToHrmCard(hrmId){(0,_pulicFunc.jumpToHrmCard)(hrmId);}},{key:'update',value:function update(){var hrmAdd=this.props.hrmAdd;hrmAdd.update();}},{key:'addhrm',value:function addhrm(){var hrmAdd=this.props.hrmAdd;hrmAdd.simpleVisible=true;}},{key:'openFullmode',value:function openFullmode(){var hrmAdd=this.props.hrmAdd;hrmAdd.openFullmode();}},{key:'getButtons',value:function getButtons(){var _this4=this;var hrmAdd=this.props.hrmAdd;var title=hrmAdd.title;var btns=[];btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this4.addhrm();}},title()));return btns;}},{key:'getTabButtonsAd',value:function getTabButtonsAd(){var hrmAdd=this.props.hrmAdd;var formSearch=hrmAdd.formSearch;return[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmAdd.doSearch();hrmAdd.setShowSearchAd(false);}},_i18n.i18n.button.search()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){formSearch.reset();}},_i18n.i18n.button.reset()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){hrmAdd.setShowSearchAd(false);}},_i18n.i18n.button.cancel())];}},{key:'getSearchs',value:function getSearchs(bool){var _this5=this;var hrmAdd=this.props.hrmAdd;var condition=hrmAdd.condition,formSearch=hrmAdd.formSearch;var isFormInit=formSearch.isFormInit;var searchGroupArr=[];isFormInit&&toJS(condition)&&toJS(condition).forEach(function(item,index){searchGroupArr.push(_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:_this5.getTitle(index),showGroup:_this5.isShowFields(index),items:_this5.getFields(bool,index)}));});return searchGroupArr;}},{key:'getTitle',value:function getTitle(){var index=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var hrmAdd=this.props.hrmAdd;var condition=hrmAdd.condition;return!(0,_isEmpty2.default)(toJS(condition))&&toJS(condition)[index].title;}},{key:'isShowFields',value:function isShowFields(){var index=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var hrmAdd=this.props.hrmAdd;var condition=hrmAdd.condition;return!(0,_isEmpty2.default)(toJS(condition))&&toJS(condition)[index].defaultshow;}},{key:'getTree',value:function getTree(){return _react2.default.createElement(_ecCom.WeaOrgTree,{loading:true,needDropMenu:false,needSearch:true,isLoadSubDepartment:true,inputLeftDom:'<b>'+_i18n.i18n.label.organization()+'</b>',topPrefix:'hrmAdd',treeNodeClick:this.treeNodeClick,params:{rightStr:'HrmResourceAdd:Add'}});}},{key:'getRightMenu',value:function getRightMenu(){var keys=this.getSelectedRowKeys();var arr=[{icon:_react2.default.createElement('i',{className:'icon-coms-New-Flow'}),content:_i18n.i18n.module.createResource()},{icon:_react2.default.createElement('i',{className:'icon-coms-ws'}),content:_i18n.i18n.button.search()},{icon:_react2.default.createElement('i',{className:'icon-coms-task-list'}),content:_i18n.i18n.button.columnVisibleSetting()// ,{
//         icon: <i className='icon-Right-menu-Batch-sharing'/>,
//         content:'收藏',
// },{
//         icon: <i className='icon-Right-menu-Custom'/>,
//         content:'帮助'
// }
}];return arr;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'0':this.addhrm();break;case'1':this.doSearch();break;case'2':this.definedColumn();break;}}},{key:'getSelectedRowKeys',value:function getSelectedRowKeys(){var hrmAdd=this.props.hrmAdd;var table=hrmAdd.table;var selectedRowKeys=table.selectedRowKeys;return selectedRowKeys;}},{key:'sendEmessage',value:function sendEmessage(){var keys=this.getSelectedRowKeys();var ids=keys?keys.join(','):'';PublicFunc.sendEmessage(ids);}},{key:'exportExcel',value:function exportExcel(){var hrmAdd=this.props.hrmAdd;var dataKey=hrmAdd.dataKey;dataKey&&hrmAdd.exportExcel(dataKey);}},{key:'doSearch',value:function doSearch(){var hrmAdd=this.props.hrmAdd;hrmAdd.doSearch();}},{key:'definedColumn',value:function definedColumn(){var hrmAdd=this.props.hrmAdd;var table=hrmAdd.table;table.setColSetVisible(true);table.tableColSet(true);}}]);return Add;}(_react2.default.Component))||_class)||_class);exports.default=Add;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _uploadAvatar=__webpack_require__(127);var _uploadAvatar2=_interopRequireDefault(_uploadAvatar);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getKey=_ecCom.WeaTools.getKey;var toJS=mobx.toJS;var __this=void 0;var Simple=(_dec=(0,_mobxReact.inject)('hrmAdd'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Simple,_React$Component);function Simple(props){(0,_classCallCheck3.default)(this,Simple);var _this=(0,_possibleConstructorReturn3.default)(this,(Simple.__proto__||(0,_getPrototypeOf2.default)(Simple)).call(this,props));__this=_this;var funcs=['save','doSaveAndNew','more','openFullmode'];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});return _this;}(0,_createClass3.default)(Simple,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmAdd=this.props.hrmAdd;var conditionInfo=hrmAdd.conditionInfo;if('visible'in nextProps&&this.props.visible!==nextProps.visible){if(nextProps.visible){if((0,_isEmpty2.default)(conditionInfo))this.init();hrmAdd.updateScroll=true;hrmAdd.canSave=true;}else{hrmAdd.conditionInfo=[];}}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;var hrmAdd=this.props.hrmAdd;var updateScroll=hrmAdd.updateScroll;if(updateScroll){if(this.refs.scrollBar){setTimeout(function(){_this2.refs.scrollBar.scrollerToTop();},0);}hrmAdd.updateScroll=false;}}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'init',value:function init(){var hrmAdd=this.props.hrmAdd;hrmAdd.getHrmResourceAddForm({'type':'simple'});}},{key:'save',value:function save(){var hrmAdd=this.props.hrmAdd;hrmAdd.save();}},{key:'doSaveAndNew',value:function doSaveAndNew(){var hrmAdd=this.props.hrmAdd;hrmAdd.doSaveAndNew();}},{key:'more',value:function more(){}},{key:'openFullmode',value:function openFullmode(){var hrmAdd=this.props.hrmAdd;hrmAdd.openFullmode();}},{key:'getSearchs',value:function getSearchs(){var hrmAdd=this.props.hrmAdd;var formSimple=hrmAdd.formSimple,conditionInfo=hrmAdd.conditionInfo;var isFormInit=formSimple.isFormInit;var formParams=formSimple.getFormParams();var group=[];window.e9HideFormFieldKeys=[];isFormInit&&conditionInfo&&conditionInfo.forEach(function(c){var items=[];c.items.forEach(function(field){var hide=false;if((!formParams.accounttype||formParams.accounttype=='0')&&field.domkey[0]=='belongto')hide=true;if(formParams.accounttype=='1'&&(field.domkey[0]=='loginid'||field.domkey[0]=='password'||field.domkey[0]=='password1'))hide=true;var dom=void 0;if(field.conditionType=='RESOURCEIMG'){var key=getKey(field);var bindObj=formSimple.$(key);dom=_react2.default.createElement(_uploadAvatar2.default,bindObj.bind());}else{dom=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:mobx.toJS(field),form:formSimple});}if(c.hide||!(0,_isEmpty2.default)(field.otherParams)&&field.otherParams.hide){window.e9HideFormFieldKeys.push(field.domkey[0]);}else{items.push({com:_react2.default.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},dom),colSpan:1,hide:hide});}});group.push(_react2.default.createElement(_ecCom.WeaSearchGroup,{className:'hrm-center',hide:c.hide,needTigger:true,title:c.title,showGroup:c.defaultshow,items:items,col:1}));});return group;}},{key:'render',value:function render(){var hrmAdd=this.props.hrmAdd;var title=hrmAdd.title,loading=hrmAdd.loading;var dialogHeight=window.innerHeight-250;if(dialogHeight>660)dialogHeight=660;return _react2.default.createElement(_ecCom.WeaDialog,(0,_extends3.default)({},this.props,{closable:true,className:'hrm-addsimple',style:{width:800,height:dialogHeight},title:title(),icon:'icon-coms-hrm',iconBgcolor:'#217346',buttons:this.getBtns(),moreBtn:{datas:[]}}),_react2.default.createElement(_antd.Spin,{spinning:loading},_react2.default.createElement(_ecCom.WeaNewScroll,{height:dialogHeight,ref:'scrollBar'},this.getSearchs())));}},{key:'getBtns',value:function getBtns(){var hrmAdd=this.props.hrmAdd;var canSave=hrmAdd.canSave;return[_react2.default.createElement('div',{className:'ext-link',style:{float:'left',cursor:'pointer'},onClick:this.openFullmode},_i18n.i18n.button.fullModle(),_react2.default.createElement(_antd.Icon,{type:'double-right'})),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!canSave,onClick:this.save},_i18n.i18n.button.save()),_react2.default.createElement(_antd.Button,{type:'primary',disabled:!canSave,onClick:this.doSaveAndNew},_i18n.i18n.button.saveAndCreate())];return btns;}}]);return Simple;}(_react2.default.Component))||_class)||_class);exports.default=Simple;

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _uploadAvatar=__webpack_require__(127);var _uploadAvatar2=_interopRequireDefault(_uploadAvatar);var _inputBtn=__webpack_require__(167);var _inputBtn2=_interopRequireDefault(_inputBtn);var _forEach=__webpack_require__(46);var _forEach2=_interopRequireDefault(_forEach);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var confirm=_antd.Modal.confirm;var TabPane=_antd.Tabs.TabPane;var Step=_antd.Steps.Step;var getKey=_ecCom.WeaTools.getKey;var toJS=mobx.toJS;var Full=(_dec=(0,_mobxReact.inject)('hrmAdd'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Full,_React$Component);function Full(props){(0,_classCallCheck3.default)(this,Full);var _this=(0,_possibleConstructorReturn3.default)(this,(Full.__proto__||(0,_getPrototypeOf2.default)(Full)).call(this,props));var funcs=['pre','next','save','more','onTabChange','tableEditChange'];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});return _this;}(0,_createClass3.default)(Full,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmAdd=this.props.hrmAdd;if('visible'in this.props&&this.props.visible!==nextProps.visible){if(nextProps.visible){hrmAdd.current=0;hrmAdd.canSave=true;hrmAdd.getHrmResourceAddForm();}}}},{key:'componentDidMount',value:function componentDidMount(){var dom=$('<Object id="htactx" name="htactx" classid="clsid:FB4EE423-43A4-4AA9-BDE9-4335A6D3C74E" codebase="HTActX.cab#version=1,0,0,1" style="HEIGHT: 0px; WIDTH: 0px"></Object>');$(document.body).append(dom);// const {hrmAdd} = this.props;
// const {current} = hrmAdd;
// hrmAdd.current = 1;
}},{key:'pre',value:function pre(){var hrmAdd=this.props.hrmAdd;var current=hrmAdd.current;this.refs.scrollBar.scrollerToTop();hrmAdd.current=current-1;}},{key:'next',value:function next(){var _this2=this;var hrmAdd=this.props.hrmAdd;var current=hrmAdd.current;hrmAdd.myvalidate(function(){_this2.refs.scrollBar.scrollerToTop();hrmAdd.current=current+1;});}},{key:'save',value:function save(){var hrmAdd=this.props.hrmAdd;hrmAdd.saveFull();}},{key:'onTabChange',value:function onTabChange(key){var hrmAdd=this.props.hrmAdd;hrmAdd.onTabChange(key);}},{key:'tableEditChange',value:function tableEditChange(data){var hrmAdd=this.props.hrmAdd;hrmAdd.tableEditChange(data);}},{key:'more',value:function more(){}},{key:'getBtns',value:function getBtns(){var hrmAdd=this.props.hrmAdd;var current=hrmAdd.current,canSave=hrmAdd.canSave;var btns=[];var pre=_react2.default.createElement(_antd.Button,{type:'primary',disabled:!canSave,onClick:this.pre},_i18n.i18n.button.lastStep());var next=_react2.default.createElement(_antd.Button,{type:'primary',disabled:!canSave,onClick:this.next},_i18n.i18n.button.nextStep());var ok=_react2.default.createElement(_antd.Button,{type:'primary',disabled:!canSave,onClick:this.save},_i18n.i18n.button.done());if(current==0){btns=[next];}else if(current==3){btns=[pre,ok];}else{btns=[pre,next];}return btns;}},{key:'getSearchs',value:function getSearchs(current){var hrmAdd=this.props.hrmAdd;var formFull=hrmAdd.formFull,conditionInfo0=hrmAdd.conditionInfo0,conditionInfo1=hrmAdd.conditionInfo1,conditionInfo2=hrmAdd.conditionInfo2,conditionInfo3=hrmAdd.conditionInfo3;var isFormInit=formFull.isFormInit;var formParams=formFull.getFormParams();var group=[];var target=void 0;if(current<1)target=conditionInfo0;if(current===1)target=conditionInfo1;if(current===2)target=conditionInfo2;if(current===3)target=conditionInfo3;window.e9HideFormFieldKeys=[];isFormInit&&target&&target.forEach(function(c){var items=[];c.items.forEach(function(field){var hide=false;var hideLabel=false;if(formParams.accounttype=='1'&&(field.domkey[0]=='loginid'||field.domkey[0]=='password'||field.domkey[0]=='password1'||field.domkey[0]=='userUsbType'))hide=true;if((!formParams.userUsbType||formParams.userUsbType=='')&&(field.domkey[0]=='tokenKey'||field.domkey[0]=='serial'||field.domkey[0]=='usbstate'))hide=true;if(formParams.userUsbType=='4'&&(field.domkey[0]=='tokenKey'||field.domkey[0]=='serial'))hide=true;if(formParams.userUsbType=='2'&&field.domkey[0]=='tokenKey')hide=true;if(formParams.userUsbType=='3'&&field.domkey[0]=='serial')hide=true;if((!formParams.accounttype||formParams.accounttype=='0')&&field.domkey[0]=='belongto')hide=true;if(field.domkey[0]=='usbstate'){hideLabel=true;}var dom=void 0;if(field.conditionType=='RESOURCEIMG'){var key=getKey(field);var bindObj=formFull.$(key);dom=_react2.default.createElement(_uploadAvatar2.default,bindObj.bind());}else if(field.domkey[0]=='tokenKey'){var _key=getKey(field);var _bindObj=formFull.$(_key);dom=_react2.default.createElement(_inputBtn2.default,(0,_extends3.default)({btnText:_i18n.i18n.label.binding()},_bindObj.bind(),{onBtnClick:function onBtnClick(v){return hrmAdd.updateKey();}}));}else if(field.domkey[0]=='serial'){var _key2=getKey(field);var _bindObj2=formFull.$(_key2);dom=_react2.default.createElement(_inputBtn2.default,(0,_extends3.default)({btnText:_i18n.i18n.label.binding()},_bindObj2.bind(),{onBtnClick:function onBtnClick(v){return hrmAdd.updateKey();}}));}else{dom=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:formFull,formParams:formParams,onChange:function onChange(v){if(field.domkey[0]=='companystartdate'||field.domkey[0]=='workstartdate'){var value=0.00;var obj={};var domKey='';if(field.domkey[0]=='companystartdate'){domKey='companyworkyear';}else if(field.domkey[0]=='workstartdate'){domKey='workyear';}value=hrmAdd.calYear(v[field.domkey[0]].value);obj[domKey]={value:value};formFull.updateFields(obj);}}});}if(c.hide||!(0,_isEmpty2.default)(field.otherParams)&&field.otherParams.hide){window.e9HideFormFieldKeys.push(field.domkey[0]);}else{items.push({com:_react2.default.createElement(_ecCom.WeaFormItem,{hideLabel:hideLabel,label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},dom),colSpan:1,hide:hide});}});group.push(_react2.default.createElement(_ecCom.WeaSearchGroup,{className:'hrm-center',hide:c.hide,needTigger:true,title:c.title,showGroup:c.defaultshow,items:items,col:1}));});return group;}},{key:'getTabChildren',value:function getTabChildren(){var _this3=this;var hrmAdd=this.props.hrmAdd;var current=hrmAdd.current,tableInfo1=hrmAdd.tableInfo1,tableInfo2=hrmAdd.tableInfo2,tabkey1=hrmAdd.tabkey1,tabkey2=hrmAdd.tabkey2;var tabChildren=[];var target=void 0;var tabkey=void 0;if(current===1){target=toJS(tableInfo1);tabkey=tabkey1;}if(current===2){target=toJS(tableInfo2);tabkey=tabkey2;}target&&target.map(function(t,i){if(tabkey==i){tabChildren.push(_react2.default.createElement(_ecCom.WeaTableEdit// title={'列表信息'}
,{addFirstRow:true,columns:t.tabinfo.columns,datas:t.tabinfo.datas,onChange:_this3.tableEditChange}));}});return tabChildren;}},{key:'more',value:function more(){}},{key:'render',value:function render(){var hrmAdd=this.props.hrmAdd;var visible=hrmAdd.visible,title=hrmAdd.title,current=hrmAdd.current,loading=hrmAdd.loading,conditionInfo1=hrmAdd.conditionInfo1,conditionInfo2=hrmAdd.conditionInfo2,conditionInfo3=hrmAdd.conditionInfo3,tabInfo1=hrmAdd.tabInfo1,tabInfo2=hrmAdd.tabInfo2,tabkey1=hrmAdd.tabkey1,tabkey2=hrmAdd.tabkey2;var dialogHeight=window.innerHeight-250;if(dialogHeight>660)dialogHeight=660;return _react2.default.createElement(_ecCom.WeaDialog,(0,_extends3.default)({},this.props,{closable:true,className:'hrm-addfull',style:{width:800,height:dialogHeight},title:title(),icon:'icon-coms-hrm',iconBgcolor:'#217346',buttons:this.getBtns(),moreBtn:{datas:[]}}),_react2.default.createElement(_antd.Spin,{spinning:loading},_react2.default.createElement(_antd.Steps,{current:current,className:'step-wrapper'},_react2.default.createElement(Step,{description:_i18n.i18n.label.fillBasicInfo()}),_react2.default.createElement(Step,{description:_i18n.i18n.label.fillPrivateInfo()}),_react2.default.createElement(Step,{description:_i18n.i18n.label.fillWorkInfo()}),_react2.default.createElement(Step,{description:_i18n.i18n.label.fillSysInfo()})),_react2.default.createElement(_ecCom.WeaNewScroll,{height:dialogHeight-120,ref:'scrollBar'},_react2.default.createElement('div',{className:''+(current<1?'wea-show':'wea-hide')},this.getSearchs(0)),_react2.default.createElement('div',{className:''+(current===1?'wea-show hrm-add-detial-tabs':'wea-hide hrm-add-detial-tabs')},!(0,_isEmpty2.default)(conditionInfo1)?_react2.default.createElement('div',null,this.getSearchs(1),!(0,_isEmpty2.default)(tabInfo1)&&_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaTab,{type:'card',keyParam:'key',datas:toJS(tabInfo1),selectedKey:tabkey1,onChange:function onChange(v){hrmAdd.updateTabkey(v);}}),this.getTabChildren())):_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},_i18n.i18n.message.fillPrivateInfoAlarm())))),_react2.default.createElement('div',{className:''+(current===2?'wea-show hrm-add-detial-tabs':'wea-hide hrm-add-detial-tabs')},!(0,_isEmpty2.default)(conditionInfo2)?_react2.default.createElement('div',null,this.getSearchs(2),_react2.default.createElement(_ecCom.WeaTab,{type:'card',keyParam:'key',datas:toJS(tabInfo2),selectedKey:tabkey2,onChange:function onChange(v){hrmAdd.updateTabkey(v);}}),this.getTabChildren()):_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},_i18n.i18n.message.fillWorkInfoAlarm())))),_react2.default.createElement('div',{className:''+(current===3?'wea-show':'wea-hide')},!(0,_isEmpty2.default)(conditionInfo3)?_react2.default.createElement('div',null,this.getSearchs(3)):_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},_i18n.i18n.message.fillSysInfoAlarm())))))));}}]);return Full;}(_react2.default.Component))||_class)||_class);exports.default=Full;

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class,_class2,_temp;var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _mobxReact=__webpack_require__(7);var _SystemCard=__webpack_require__(244);var _SystemCard2=_interopRequireDefault(_SystemCard);var _PortraitSetting=__webpack_require__(458);var _PortraitSetting2=_interopRequireDefault(_PortraitSetting);var _reactRouter=__webpack_require__(57);__webpack_require__(459);var _topButton=__webpack_require__(99);var _topButton2=_interopRequireDefault(_topButton);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var Main=(_dec=(0,_mobxReact.inject)('hrmCard'),_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));}(0,_createClass3.default)(Main,[{key:'getkey',value:function getkey(path){return path.match(/hrm\/card\/\w+/)[0].split('/')[2]||'';}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var key=this.getkey(nextProps.location.pathname);if(this.props.location.key!==nextProps.location.key&&key=='cardInfo'){var hrmCard=this.props.hrmCard;hrmCard.init(key);}}},{key:'componentDidMount',value:function componentDidMount(){var hrmCard=this.props.hrmCard;var pathname=this.props.location.pathname;var key=this.getkey(pathname);var hrmId=this.props.params.hrmId||'';//const hrmId = pathname.match(/cardInfo\/\w+/)[0].split('/')[1]
hrmCard.init(key);hrmCard.verifyIsAdmin({id:hrmId});hrmCard.getData({id:hrmId});}},{key:'getTabChildren',value:function getTabChildren(){var _props=this.props,hrmCard=_props.hrmCard,children=_props.children;var tabInfo=hrmCard.tabInfo,tabKey=hrmCard.tabKey;var isIframe=false;var ifame=void 0;var innerPage=false;if(window.location.href.indexOf("/spa/hrm/index_mobx.html")==-1){innerPage=true;}tabInfo=toJS(tabInfo);tabInfo&&tabInfo.forEach(function(t){if(tabKey===t.key){if(t.isIframe){isIframe=true;ifame=React.createElement('iframe',{className:'card-iframe',style:{height:window.innerHeight-175},src:t.url});}}});return React.createElement(_ecCom.WeaNewScroll,{height:innerPage?window.innerHeight-160:window.innerHeight-110},isIframe?ifame:children);}},{key:'render',value:function render(){var _this2=this;var hrmCard=this.props.hrmCard;var verified=hrmCard.verified,isAdmin=hrmCard.isAdmin,info=hrmCard.info,tabInfo=hrmCard.tabInfo,tabKey=hrmCard.tabKey,showPortraitSetting=hrmCard.showPortraitSetting,uploadPortrailAuth=hrmCard.uploadPortrailAuth;info=toJS(info);var portraitDefalut='/messager/images/icon_m_wev8.jpg';if(window.location.href.indexOf("/spa/hrm/index_mobx.html")>-1){if(info){var lastname=info.lastname||'';document.title=_i18n.i18n.label.resourceCard()+'-'+lastname;}}if(verified&&isAdmin){return React.createElement(_SystemCard2.default,this.props);}if(verified&&!isAdmin){return React.createElement(_ecCom.WeaPopoverHrm,null,React.createElement('div',{className:'hrm-my-card',style:{height:"100%",background:'#ffff'}},React.createElement('div',{className:'hrm-my-card-top-wapper'},!(0,_isEmpty2.default)(info)&&React.createElement(_antd.Row,{className:"hrm-my-card-top"},React.createElement(_antd.Col,{span:'14',className:'hrm-my-card-top-title',style:{paddingLeft:14,paddingTop:7}},info.shortname!=null&&info.shortname.trim().length>0?React.createElement('div',{className:'hrm-my-card-top-title-img hrm-my-card-top-title-shortname',onClick:showPortraitSetting},info.shortname):React.createElement('span',{style:{verticalAlign:'middle',paddingLeft:10,paddingRight:14}},React.createElement('img',{className:'hrm-my-card-top-title-img',src:info.messagerurl||portraitDefalut,alt:'',onClick:showPortraitSetting})),React.createElement('span',{style:{display:'inline-block',verticalAlign:'30%'},className:'hrm-my-card-top-title-info'},React.createElement('div',{style:{fontSize:14,paddingBottom:6}},React.createElement('span',{style:{paddingRight:5}},info.lastname,' ',info.workcode?'('+info.workcode+')':''),React.createElement('span',{className:info.sex.value=='1'?'icon-coms-women femaleColor':'icon-coms-men maleColor',title:info.sex.name})),React.createElement('div',{className:'orgInfo',dangerouslySetInnerHTML:{__html:info.orginfo}})))),React.createElement(_topButton2.default,{buttons:hrmCard.topButtons&&hrmCard.topButtons(),buttonSpace:10,showDropIcon:hrmCard.topShowDropIcon,dropMenuDatas:hrmCard.topRightMenus&&hrmCard.topRightMenus()})),React.createElement(_ecCom.WeaTab,{type:'editable-inline',keyParam:'key',datas:toJS(tabInfo),selectedKey:tabKey,onChange:function onChange(v){_this2.tabsOnChange(v);}}),this.getTabChildren()),uploadPortrailAuth&&React.createElement(_PortraitSetting2.default,{store:hrmCard}));}return React.createElement('div',null);}},{key:'tabsOnChange',value:function tabsOnChange(key){var _this3=this;var hrmCard=this.props.hrmCard;hrmCard.setTopButtons(null);hrmCard.setTopRightMenus(null);hrmCard.setTopShowDropIcon(false);var tabInfo=hrmCard.tabInfo;hrmCard.changeTab(key);tabInfo=toJS(tabInfo);tabInfo&&tabInfo.forEach(function(t){if(t.key===key&&!t.isIframe){_this3.context.router.push({pathname:t.pathname,query:{fromcard:true}});}});}}]);return Main;}(React.Component),_class2.contextTypes={router:_reactRouter.routerShape},_temp))||_class)||_class);exports.default=Main;

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PortraitSetting=(0,_mobxReact.observer)(_class=function(_Component){(0,_inherits3.default)(PortraitSetting,_Component);function PortraitSetting(props){(0,_classCallCheck3.default)(this,PortraitSetting);var _this=(0,_possibleConstructorReturn3.default)(this,(PortraitSetting.__proto__||(0,_getPrototypeOf2.default)(PortraitSetting)).call(this,props));_this.zoom=function(type){switch(type){case'in':_this.refs.cropper.cropper.zoom(-0.1);break;case'out':_this.refs.cropper.cropper.zoom(0.1);break;}};_this.rotate=function(){_this.refs.cropper.cropper.rotate(90);};_this.onOk=function(){var store=_this.props.store;if(_this.state.uploading){_antd.message.warning('图片上传中...');return;}var imgData=null;if(_this.refs.cropper){if(typeof _this.refs.cropper.getCroppedCanvas()==='undefined'){}else{var canvas=_this.refs.cropper.getCroppedCanvas();imgData=canvas.toDataURL();}}store.onOk(imgData);};_this.onCancel=function(){var store=_this.props.store;_this.setState({imgSrc:_this.props.store.info.messagerurl,fileId:'',uploading:false});};_this.remove=function(){_this.setState({imgSrc:null});};_this.generateUploadCom=function(label){return _react2.default.createElement(_ecCom.WeaUpload,{ref:'upload',uploadUrl:'/api/doc/upload/uploadFile',category:'string',maxFilesNumber:1,autoUpload:false,maxUploadSize:4,getShowListDatas:function getShowListDatas(listT,listB){// console.debug(listT, listB)
// if (!this.isIE9 && listB.length > 0) {
// 	const { fileId } = this.state;
// 	const file = listB[0];
// 	if (window.FileReader && file.id !== fileId) {
// 		const reader = new FileReader();
// 		reader.onload = () => {
// 			this.setState({ imgSrc: reader.result, fileId: file.id });
// 		};
// 		reader.readAsDataURL(file.getNative());
// 	}
// }
if(listB.length>0&&!_this.state.uploading){_this.setState({uploading:true});window.startUploadAll();}},onChange:function onChange(ids,list){var obj={uploading:false};if(list.length>0){(0,_assign2.default)(obj,{fileId:list[0].fileid,imgSrc:list[0].imgSrc});}_this.setState(obj);}},_react2.default.createElement('div',{className:'uploadImg'},label));};_this.renderOpBar=function(){var children=[];if(_this.state.imgSrc==null||_this.state.imgSrc!=null&&_this.defaultImg.indexOf(_this.state.imgSrc)>=0){children=[_this.generateUploadCom(_i18n.i18n.button.clickUpload())];}else{children=[_this.generateUploadCom(_i18n.i18n.button.reUpload()),_react2.default.createElement('div',{className:'remove',onClick:_this.remove},_i18n.i18n.button.removeHeadImg()),_react2.default.createElement('div',{className:'icon-coms-Refresh op',style:{marginRight:'0px'},title:_i18n.i18n.button.rotate(),onClick:_this.rotate}),_react2.default.createElement('div',{className:'icon-coms-Narrow op',title:_i18n.i18n.button.zoomIn(),onClick:function onClick(){return _this.zoom('in');}}),_react2.default.createElement('div',{className:'icon-coms-Enlarge op',title:_i18n.i18n.button.zoomOut(),onClick:function onClick(){return _this.zoom('out');}})];}return children;};_this.isIE9=$.browser.msie&&parseInt($.browser.version)<10;_this.defaultImg=['/messager/images/icon_m_wev8.jpg','/messager/images/icon_w_wev8.jpg'];_this.state={imgSrc:null,fileId:'',uploading:false};return _this;}(0,_createClass3.default)(PortraitSetting,[{key:'componentDidMount',value:function componentDidMount(){this.setState({imgSrc:this.props.store.info.messagerurl});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({imgSrc:nextProps.store.info.messagerurl});}},{key:'render',value:function render(){var store=this.props.store;var info=store.info,dialogParams=store.dialogParams,editorDialogRightMenu=store.editorDialogRightMenu,getDialogOpButtons=store.getDialogOpButtons,spinning=store.spinning;var dProps=(0,_extends3.default)({},dialogParams,{buttons:getDialogOpButtons({ok:this.onOk,cancel:this.onCancel})});if(dialogParams.visible){return _react2.default.createElement(_ecCom.WeaDialog,(0,_extends3.default)({},dProps,{title:dProps.title()}),_react2.default.createElement(_antd.Spin,{spinning:spinning},_react2.default.createElement('div',{className:'uploadPortrait'},_react2.default.createElement('div',{className:'left'},_react2.default.createElement('div',{className:'currImg'},this.state.imgSrc!=null&&this.defaultImg.indexOf(this.state.imgSrc)<0?_react2.default.createElement(_ecCom.WeaImageCropper,{ref:'cropper',preview:'.preview',src:this.state.imgSrc,aspectRatio:1/1,style:{height:'100%',width:'100%'}}):_react2.default.createElement('div',{className:'icon-coms-pic defaultImg'})),_react2.default.createElement('div',{className:'opBar'},this.renderOpBar())),_react2.default.createElement('div',{className:'right'},_react2.default.createElement('div',{className:'preview'},(this.state.imgSrc==null||this.state.imgSrc!=null&&this.defaultImg.indexOf(this.state.imgSrc)>=0)&&_react2.default.createElement('div',{className:'icon-coms-pic defaultImg'})),_react2.default.createElement('div',{className:'lbl'},_i18n.i18n.label.headImagePreview())))));}return _react2.default.createElement('div',null);}}]);return PortraitSetting;}(_react.Component))||_class;exports.default=PortraitSetting;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _debounce=__webpack_require__(49);var _debounce2=_interopRequireDefault(_debounce);var _isArray=__webpack_require__(29);var _isArray2=_interopRequireDefault(_isArray);__webpack_require__(245);var _infoGroup4Formal=__webpack_require__(163);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _util=__webpack_require__(17);var _uploadAvatar=__webpack_require__(127);var _uploadAvatar2=_interopRequireDefault(_uploadAvatar);var _topButton=__webpack_require__(99);var _topButton2=_interopRequireDefault(_topButton);var _comsMobx=__webpack_require__(10);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _mobxReact=__webpack_require__(7);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getKey=_ecCom.WeaTools.getKey;var toJS=mobx.toJS;var Main=(_dec=(0,_mobxReact.inject)('hrmCardInfo'),_dec2=(0,_mobxReact.inject)('hrmCard'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));var funcs=['showSQR','editCard','backCard','saveEditCard'];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});return _this;}(0,_createClass3.default)(Main,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var keyOld=this.props.location.key;var keyNew=nextProps.location.key;if(keyOld!==keyNew){var hrmCardInfo=this.props.hrmCardInfo;hrmCardInfo.updateIsEditor();}}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,hrmCardInfo=_props.hrmCardInfo,hrmCard=_props.hrmCard;var hrmId=this.props.params.hrmId||'';hrmCardInfo.updateIsEditor();hrmCardInfo.getData(hrmId);hrmCardInfo.getRightMenu(hrmId);hrmCard.setTopButtons(this.getTopButtons.bind(this));hrmCard.setTopRightMenus(this.getRightMenu.bind(this));hrmCard.setTopShowDropIcon(true);}},{key:'showSQR',value:function showSQR(bool,e){var hrmCardInfo=this.props.hrmCardInfo;e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();hrmCardInfo.updateShowSQR(bool);}},{key:'getIcon',value:function getIcon(str){switch(str){case'sendEmessage':return'icon-coms-Send-message';case'openmessage':return'icon-coms-message-o';case'openemail':return'icon-coms-Send-emails';case'doAddWorkPlan':return'icon-coms-New-schedule-o';}}},{key:'getRightMenu',value:function getRightMenu(){var _this2=this;var _props2=this.props,hrmCardInfo=_props2.hrmCardInfo,hrmCard=_props2.hrmCard;var isEditor=hrmCardInfo.isEditor,buttons=hrmCardInfo.buttons,rightMenus=hrmCardInfo.rightMenus;buttons=toJS(buttons);rightMenus=toJS(rightMenus);var arr=[];if(isEditor){arr=[{icon:React.createElement('i',{className:'icon-coms-common'}),content:_i18n.i18n.button.save(),key:'save',onClick:function onClick(key){_this2.saveEditCard();}},{icon:React.createElement('i',{className:'icon-coms-go-back'}),content:_i18n.i18n.button.back(),key:'back',onClick:function onClick(key){_this2.backCard();}}];}else{!(0,_isEmpty2.default)(rightMenus)&&rightMenus.forEach(function(c){var item={icon:React.createElement('i',{className:''+c.menuIcon}),content:c.menuName,key:c.menuFun,onClick:function onClick(key){var menuFun=c.menuFun;if(menuFun==='showPortraitSetting'){hrmCard[menuFun]&&hrmCard[menuFun]();}_this2[menuFun]&&_this2[menuFun](c.params);}};if(c.type==='BTN_SetUserIcon'&&hrmCard.uploadPortrailAuth||c.type!='BTN_SetUserIcon')arr.push(item);});}return arr;}},{key:'showLog',value:function showLog(params){window.setLogViewProps(params);}},{key:'sendSmsMessage',value:function sendSmsMessage(){var params=this.props.params;var id=params.hrmId;if(id)PublicFunc.sendSmsMessage(id);}},{key:'sendMail',value:function sendMail(){var params=this.props.params;var id=params.hrmId;if(id)PublicFunc.sendMail(id);}},{key:'doAddWorkPlanByHrm',value:function doAddWorkPlanByHrm(){var params=this.props.params;var id=params.hrmId;if(id)PublicFunc.doAddWorkPlanByHrm(id);}},{key:'addCoWork',value:function addCoWork(){var params=this.props.params;var id=params.hrmId;if(id)PublicFunc.addCoWork(id);}},{key:'getTopButtons',value:function getTopButtons(){var hrmCardInfo=this.props.hrmCardInfo;var isEditor=hrmCardInfo.isEditor,buttons=hrmCardInfo.buttons;buttons=toJS(buttons);var save=React.createElement(_antd.Button,{type:'primary',onClick:this.saveEditCard},_i18n.i18n.button.save());var back=React.createElement(_antd.Button,{type:'primary',onClick:this.backCard},_i18n.i18n.button.back());var edit=React.createElement(_antd.Button,{type:'primary',onClick:this.editCard},_i18n.i18n.button.modify());var btns=[];if(isEditor){if(!(0,_isEmpty2.default)(buttons)&&buttons.hasSave){btns.push(save);btns.push(back);}}else{if(!(0,_isEmpty2.default)(buttons)&&buttons.hasEdit){btns.push(edit);}}return btns;}},{key:'editCard',value:function editCard(){var hrmId=this.props.params.hrmId||'';var hrmCardInfo=this.props.hrmCardInfo;hrmCardInfo.edit(hrmId);}},{key:'saveEditCard',value:function saveEditCard(){var hrmId=this.props.params.hrmId||'';var _props3=this.props,hrmCardInfo=_props3.hrmCardInfo,hrmCard=_props3.hrmCard;hrmCardInfo.saveEditCard(function(){hrmCard.getTabBaseInfo({id:hrmId});});}},{key:'backCard',value:function backCard(){var hrmId=this.props.params.hrmId||'';var hrmCardInfo=this.props.hrmCardInfo;hrmCardInfo.updateIsEditor();hrmCardInfo.qrcode(hrmId);hrmCardInfo.updateShowSQR(false);}},{key:'getSearchs',value:function getSearchs(){var hrmCardInfo=this.props.hrmCardInfo;var conditioninfo=hrmCardInfo.conditioninfo,hideBelongto=hrmCardInfo.hideBelongto,isEditor=hrmCardInfo.isEditor,form=hrmCardInfo.form,validate=hrmCardInfo.validate;var group=[];var isFormInit=form.isFormInit;var idx=0;window.e9HideFormFieldKeys=[];isFormInit&&conditioninfo.forEach(function(c){var items=[];idx++;if(c.hasResourceImage){var resourceimg=void 0;var baseGroup=React.createElement('div',null,React.createElement(_ecCom.WeaSearchGroup,{className:''+(isEditor?'hrm-base-group-title':''),needTigger:true,hide:c.hide,title:c.title,showGroup:c.defaultshow},React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:12},c.items.forEach(function(field){var dom=React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,onChange:function onChange(v){if(v.accounttype){hrmCardInfo.updateHideBelongto(v.accounttype.value=='0');}}});if(field.conditionType=='RESOURCEIMG'||field.domkey&&field.domkey[0]=='belongto'&&hideBelongto){}else{if(c.hide||!(0,_isEmpty2.default)(field.otherParams)&&field.otherParams.hide){window.e9HideFormFieldKeys.push(field.domkey[0]);}else{items.push({com:React.createElement('div',{style:{paddingLeft:30}},React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},dom)),colSpan:1});}}}),React.createElement(_ecCom.WeaSearchGroup,{className:''+(isEditor?'hrm-base-group':''),needTigger:true,hide:c.hide,title:c.title,showGroup:c.defaultshow,items:items,col:1})),React.createElement(_antd.Col,{span:12},c.items.forEach(function(field){if(field.conditionType=='RESOURCEIMG'){if(!(0,_isEmpty2.default)(validate)&&validate[36]&&validate[36].isValidate){var key=getKey(field);var bindObj=form.$(key);resourceimg=React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},React.createElement(_uploadAvatar2.default,bindObj.bind()));}}}),resourceimg))));group.push(baseGroup);}else{c.items.forEach(function(field){if(c.hide||!(0,_isEmpty2.default)(field.otherParams)&&field.otherParams.hide){window.e9HideFormFieldKeys.push(field.domkey[0]);}else{var dom=React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,onChange:function onChange(v){if(v.accounttype){hrmCardInfo.updateHideBelongto(v.accounttype.value=='0');}}});if(field.conditionType=='RESOURCEIMG'||field.domkey&&field.domkey[0]=='belongto'&&hideBelongto){}else{items.push({com:React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},dom),colSpan:2});}}});group.push(React.createElement(_ecCom.WeaSearchGroup,{className:(isEditor?'hrm-center':'')+' '+(c.isHide?'wea-hide':''),needTigger:true,hide:c.hide,title:c.title,showGroup:c.defaultshow,items:items,col:window.HrmGroupCol}));}});return group;}},{key:'getPortraitButtons',value:function getPortraitButtons(){var _this3=this;var colArr=[];var hrmCardInfo=this.props.hrmCardInfo;var sendButtons=hrmCardInfo.sendButtons,validate=hrmCardInfo.validate;sendButtons=toJS(sendButtons);var emJoinStatus=window.emJoinStatus;(0,_isArray2.default)(sendButtons)&&sendButtons.forEach(function(item){var status=true;if(item.name=='sendEmessage'){status=emJoinStatus?!emJoinStatus.joinStatus||emJoinStatus.status&&emJoinStatus.joinStatus&&emJoinStatus.emSwitch!=="0":false;}if(status&&!(0,_isEmpty2.default)(validate)&&validate[item.validateId]&&validate[item.validateId].isValidate){colArr.push(React.createElement(_antd.Col,{span:6},React.createElement('div',{className:'hrm-my-card-basicInfo-icon-circle',onClick:function onClick(){PublicFunc[item.funname](item.id);},title:item.title},React.createElement('i',{className:''+_this3.getIcon(item.name)}))));}});return colArr;}},{key:'render',value:function render(){var _this4=this;var hrmCardInfo=this.props.hrmCardInfo;var isEditor=hrmCardInfo.isEditor,infoGroup=hrmCardInfo.infoGroup,imgSrc=hrmCardInfo.imgSrc,modelItems=hrmCardInfo.modelItems,showSQR=hrmCardInfo.showSQR,showBigImg=hrmCardInfo.showBigImg,sendButtons=hrmCardInfo.sendButtons,accountInfo=hrmCardInfo.accountInfo,showAccountInfo=hrmCardInfo.showAccountInfo,QRCodeOptions=hrmCardInfo.QRCodeOptions,validate=hrmCardInfo.validate;sendButtons=toJS(sendButtons);infoGroup=toJS(infoGroup);modelItems=toJS(modelItems);var sendBtns=this.getPortraitButtons();var hasQRCode=!(0,_isEmpty2.default)(validate)&&validate[37]&&validate[37].isValidate;var getPortrait=function getPortrait(){var loadingImg='/images/messageimages/temp/loading_wev8.gif';return React.createElement('div',{className:'hrm-my-card-basicInfo-left-imgwrap'},!showBigImg&&React.createElement('img',{className:'hrm-my-card-basicInfo-left-img',src:imgSrc?imgSrc:loadingImg,onError:function onError(){_this4.setState({imgSrc:'/images/messageimages/temp/man_wev8.png'});},onClick:function onClick(){return imgSrc&&hrmCardInfo.updateShowBigImg(true);}}),showBigImg&&React.createElement('img',{className:'hrm-my-card-basicInfo-left-img-big',onError:function onError(){_this4.setState({imgSrc:'/images/messageimages/temp/man_wev8.png'});},onClick:function onClick(){return imgSrc&&hrmCardInfo.updateShowBigImg(false);},src:imgSrc?imgSrc:loadingImg}),React.createElement('div',{className:'hrm-my-card-basicInfo-left-corner',style:{display:hasQRCode?'block':'none'},title:showSQR?_i18n.i18n.button.back():!(0,_isEmpty2.default)(validate)&&validate[37]&&validate[37].validateName,onClick:(0,_debounce2.default)(_this4.showSQR.bind(null,!showSQR),150)},React.createElement('i',{className:'icon-coms-'+(showSQR?'Revoke2':'Scan')})),React.createElement('div',{className:'hrm-my-card-basicInfo-sqr',style:{display:showSQR?'block':'none'},onClick:_this4.showSQR.bind(null,false)},!(0,_isEmpty2.default)(QRCodeOptions)&&React.createElement('div',{className:'hrm-my-card-basicInfo-sqr-canvas',style:{marginTop:(jQuery(".hrm-my-card-basicInfo-sqr").height()-152)/2}},React.createElement(_ecCom.WeaQrcode,{text:(0,_util.createQRCode)(QRCodeOptions),size:120,level:'L'})),React.createElement('p',{className:'hrm-my-card-basicInfo-sqr-title'},_i18n.i18n.button.scanAddContacts())));};var getAccountinfo=function getAccountinfo(){var colArr=[];var idx=0;accountInfo&&accountInfo.forEach(function(a,i){var showValue=void 0;if(a.showName&&a.showName!=''){showValue=React.createElement('a',{href:'javaScript:openhrm('+a.value+')',onClick:function onClick(event){return window.pointerXY(event);}},a.showName);}else{showValue=a.value?React.createElement('div',{dangerouslySetInnerHTML:{__html:a.value}}):React.createElement('div',null,'\xA0');}if(a.name=='weixin'){colArr.push(React.createElement(_antd.Col,{className:'hrm-my-card-basicInfo-left-accountinfo-label',span:'24'},React.createElement('a',{onClick:function onClick(){showWeaDialog();}},a.label)));}else{colArr.push(React.createElement(_antd.Col,{className:'hrm-my-card-basicInfo-left-accountinfo-label',span:'12'},a.label,':'));colArr.push(React.createElement(_antd.Col,{className:'hrm-my-card-basicInfo-left-accountinfo-value',span:'12'},showValue));}if(a.name=='lastlogindate'){idx=i;}a.name=='lastlogindate'&&colArr.push(React.createElement(_antd.Col,{className:'hrm-my-card-basicInfo-left-accountinfo-middline',span:'24'}));});if(!showAccountInfo){colArr.splice((idx+1)*2+1,colArr.length);}colArr.push(React.createElement(_antd.Col,{className:'hrm-my-card-basicInfo-left-accountinfo-endicon',span:'24',onClick:function onClick(){return hrmCardInfo.updateShowAccountInfo(!showAccountInfo);}},React.createElement('i',{className:showAccountInfo?'icon-coms-up':'icon-coms-down',title:showAccountInfo?_i18n.i18n.button.collapse():_i18n.i18n.button.expand()})));return colArr;};var viewCard=React.createElement('div',{className:'hrm-my-card-basicInfo',style:{height:'100%'}},React.createElement(_ecCom.WeaDialog,{style:{width:500,height:380},title:_i18n.i18n.button.companyWechat(),hideIcon:true},React.createElement('div',{className:'align-center'},React.createElement('img',{src:'/hrm/resource/image/qrcode.jpg',style:{height:374,width:344}}))),React.createElement('div',{className:'hrm-my-card-basicInfo-left'},getPortrait(),!(0,_isEmpty2.default)(sendBtns)&&React.createElement(_antd.Row,{className:'hrm-my-card-basicInfo-left-imgwrap-op',type:'flex',justify:'center',gutter:16},sendBtns),React.createElement(_antd.Row,null,getAccountinfo())),React.createElement('div',{className:'hrm-my-card-basicInfo-right',style:{minHeight:window.innerHeight-138}},React.createElement('div',{className:'hrm-my-card-basicInfo-right-counts'},modelItems&&modelItems.map(function(c){var fontColor=c['font-color'];return React.createElement('div',{className:'hrm-my-card-basicInfo-right-counts-cell',onClick:function onClick(){window.open(c.url);}},React.createElement('img',{src:c.icon,alt:''}),React.createElement('div',{className:'hrm-my-card-basicInfo-right-counts-cell-info'},React.createElement('div',null,c.label),React.createElement('div',{title:c.num,className:'text-overflow'},React.createElement('span',{style:{color:fontColor?fontColor:null,fontSize:18}},c.num))));})),React.createElement(_antd.Row,{gutter:24},React.createElement(_antd.Col,{span:'24'},React.createElement(_antd.Row,{className:'hrm-my-card-basicInfo-right-info'},infoGroup&&infoGroup.map(function(info){return React.createElement(_antd.Col,{span:'24'},React.createElement(_infoGroup4Formal.InfoGroup4Formal,{items:info.items,hide:info.hide,title:info.title,showGroup:info.defaultshow}));}))))));var editCard=React.createElement('div',{className:'hrm-my-card-basicInfo hrm-my-cardInfo',style:{height:'100%'}},this.getSearchs());return React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu()},!isEditor?viewCard:editCard);}}]);return Main;}(React.Component))||_class)||_class)||_class);exports.default=Main;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _debounce=__webpack_require__(49);var _debounce2=_interopRequireDefault(_debounce);var _isArray=__webpack_require__(29);var _isArray2=_interopRequireDefault(_isArray);__webpack_require__(245);var _infoGroup4Formal=__webpack_require__(163);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _util=__webpack_require__(17);var _uploadAvatar=__webpack_require__(127);var _uploadAvatar2=_interopRequireDefault(_uploadAvatar);var _topButton=__webpack_require__(99);var _topButton2=_interopRequireDefault(_topButton);var _comsMobx=__webpack_require__(10);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _mobxReact=__webpack_require__(7);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getKey=_ecCom.WeaTools.getKey;var toJS=mobx.toJS;var InputGroup=_antd.Input.Group;var Main=(_dec=(0,_mobxReact.inject)('hrmCardInfo4Formal'),_dec2=(0,_mobxReact.inject)('hrmCard'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.clickHandle=function(){var hrmCardInfo4Formal=_this.props.hrmCardInfo4Formal;var isSelf=hrmCardInfo4Formal.isSelf;if(!_this.state.editable&&isSelf){_this.setState({editable:true});_this.textareaDom.refs.textareaNormal.refs.input.refs.input.focus();}};_this.onBlurHandle=function(value){var hrmCardInfo4Formal=_this.props.hrmCardInfo4Formal;var saveRemark=hrmCardInfo4Formal.saveRemark,hrmId=hrmCardInfo4Formal.hrmId;var urlParams={remark:value};hrmId!=''&&(0,_assign2.default)(urlParams,{id:hrmId});saveRemark(urlParams);_this.setState({editable:false,textVal:value});};var funcs=['showSQR','editCard','backCard','saveEditCard'];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});_this.state={editable:false,textVal:''};return _this;}(0,_createClass3.default)(Main,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.divDom&&this.divDom.removeEventListener('click',this.clickHandle);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var keyOld=this.props.location.key;var keyNew=nextProps.location.key;if(keyOld!==keyNew){var hrmCardInfo4Formal=this.props.hrmCardInfo4Formal;hrmCardInfo4Formal.updateIsEditor();}}},{key:'componentDidMount',value:function componentDidMount(){this.divDom&&this.divDom.addEventListener('click',this.clickHandle);var _props=this.props,hrmCardInfo4Formal=_props.hrmCardInfo4Formal,hrmCard=_props.hrmCard;var hrmId=this.props.params.hrmId||'';hrmCardInfo4Formal.updateIsEditor();hrmCardInfo4Formal.getData(hrmId);hrmCardInfo4Formal.getRightMenu(hrmId);var isEditor=this.props.location.query.isEditor||'';if(isEditor=='true'){this.editCard();}hrmCard.setTopButtons(this.getTopButtons.bind(this));hrmCard.setTopRightMenus(this.getRightMenu.bind(this));hrmCard.setTopShowDropIcon(true);}},{key:'showSQR',value:function showSQR(bool,e){var hrmCardInfo4Formal=this.props.hrmCardInfo4Formal;e.stopPropagation&&e.stopPropagation();e.preventDefault&&e.preventDefault();e.nativeEvent&&e.nativeEvent.preventDefault();hrmCardInfo4Formal.updateShowSQR(bool);}},{key:'getIcon',value:function getIcon(str){switch(str){case'sendEmessage':return'icon-coms-Send-message';case'openmessage':return'icon-coms-message-o';case'openemail':return'icon-coms-Send-emails';case'doAddWorkPlan':return'icon-coms-New-schedule-o';}}},{key:'getRightMenu',value:function getRightMenu(){var _this2=this;var _props2=this.props,hrmCardInfo4Formal=_props2.hrmCardInfo4Formal,hrmCard=_props2.hrmCard;var isEditor=hrmCardInfo4Formal.isEditor,buttons=hrmCardInfo4Formal.buttons,rightMenus=hrmCardInfo4Formal.rightMenus;buttons=toJS(buttons);rightMenus=toJS(rightMenus);var arr=[];if(isEditor){arr=[{icon:React.createElement('i',{className:'icon-coms-common'}),content:_i18n.i18n.button.save(),key:'save',onClick:function onClick(key){_this2.saveEditCard();}},{icon:React.createElement('i',{className:'icon-coms-go-back'}),content:_i18n.i18n.button.back(),key:'back',onClick:function onClick(key){_this2.backCard();}}];}else{!(0,_isEmpty2.default)(rightMenus)&&rightMenus.forEach(function(c){var item={icon:React.createElement('i',{className:''+c.menuIcon}),content:c.menuName,key:c.menuFun,onClick:function onClick(key){var menuFun=c.menuFun;if(menuFun==='showPortraitSetting')hrmCard[menuFun]&&hrmCard[menuFun]();_this2[menuFun]&&_this2[menuFun](c.params);}};if(c.type==='BTN_SetUserIcon'&&hrmCard.uploadPortrailAuth||c.type!='BTN_SetUserIcon')arr.push(item);});}return arr;}},{key:'showLog',value:function showLog(params){window.setLogViewProps(params);}},{key:'sendSmsMessage',value:function sendSmsMessage(){var params=this.props.params;var id=params.hrmId;if(id)PublicFunc.sendSmsMessage(id);}},{key:'sendMail',value:function sendMail(){var params=this.props.params;var id=params.hrmId;if(id)PublicFunc.sendMail(id);}},{key:'doAddWorkPlanByHrm',value:function doAddWorkPlanByHrm(){var params=this.props.params;var id=params.hrmId;if(id)PublicFunc.doAddWorkPlanByHrm(id);}},{key:'addCoWork',value:function addCoWork(){var params=this.props.params;var id=params.hrmId;if(id)PublicFunc.addCoWork(id);}},{key:'getTopButtons',value:function getTopButtons(){var hrmCardInfo4Formal=this.props.hrmCardInfo4Formal;var isEditor=hrmCardInfo4Formal.isEditor,buttons=hrmCardInfo4Formal.buttons;buttons=toJS(buttons);var save=React.createElement(_antd.Button,{type:'primary',onClick:this.saveEditCard},_i18n.i18n.button.save());var back=React.createElement(_antd.Button,{type:'primary',onClick:this.backCard},_i18n.i18n.button.back());var edit=React.createElement(_antd.Button,{type:'primary',onClick:this.editCard},_i18n.i18n.button.modify());var btns=[];if(buttons==null)return btns;if(isEditor){if(!(0,_isEmpty2.default)(buttons)&&buttons.hasSave){btns.push(save);btns.push(back);}}else{if(!(0,_isEmpty2.default)(buttons)&&buttons.hasEdit){btns.push(edit);}}return btns;}},{key:'editCard',value:function editCard(){var hrmId=this.props.params.hrmId||'';var hrmCardInfo4Formal=this.props.hrmCardInfo4Formal;hrmCardInfo4Formal.edit(hrmId);}},{key:'saveEditCard',value:function saveEditCard(){var hrmId=this.props.params.hrmId||'';var _props3=this.props,hrmCardInfo4Formal=_props3.hrmCardInfo4Formal,hrmCard=_props3.hrmCard;hrmCardInfo4Formal.saveEditCard(function(){hrmCard.getTabBaseInfo({id:hrmId});});}},{key:'backCard',value:function backCard(){var hrmId=this.props.params.hrmId||'';var hrmCardInfo4Formal=this.props.hrmCardInfo4Formal;hrmCardInfo4Formal.updateIsEditor();hrmCardInfo4Formal.qrcode(hrmId);hrmCardInfo4Formal.updateShowSQR(false);}},{key:'getSearchs',value:function getSearchs(){var hrmCardInfo4Formal=this.props.hrmCardInfo4Formal;var conditioninfo=hrmCardInfo4Formal.conditioninfo,hideBelongto=hrmCardInfo4Formal.hideBelongto,isEditor=hrmCardInfo4Formal.isEditor,form=hrmCardInfo4Formal.form,validate=hrmCardInfo4Formal.validate;var group=[];var isFormInit=form.isFormInit;var idx=0;window.e9HideFormFieldKeys=[];isFormInit&&conditioninfo.forEach(function(c){var items=[];idx++;if(c.hasResourceImage){var resourceimg=void 0;var baseGroup=React.createElement('div',null,React.createElement(_ecCom.WeaSearchGroup,{className:''+(isEditor?'hrm-base-group-title':''),needTigger:true,hide:c.hide,title:c.title,showGroup:c.defaultshow},React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:12},c.items.forEach(function(field){var dom=React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,onChange:function onChange(v){if(v.accounttype){hrmCardInfo4Formal.updateHideBelongto(v.accounttype.value=='0');}}});if(field.conditionType=='RESOURCEIMG'||field.domkey&&field.domkey[0]=='belongto'&&hideBelongto){}else{if(c.hide||!(0,_isEmpty2.default)(field.otherParams)&&field.otherParams.hide){window.e9HideFormFieldKeys.push(field.domkey[0]);}else{items.push({com:React.createElement('div',{style:{paddingLeft:30}},React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},dom)),colSpan:1});}}}),React.createElement(_ecCom.WeaSearchGroup,{className:''+(isEditor?'hrm-base-group':''),needTigger:true,hide:c.hide,title:c.title,showGroup:c.defaultshow,items:items,col:1})),React.createElement(_antd.Col,{span:12},c.items.forEach(function(field){if(!(0,_isEmpty2.default)(validate)&&validate[36]&&validate[36].isValidate){if(field.conditionType=='RESOURCEIMG'){var key=getKey(field);var bindObj=form.$(key);resourceimg=React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},React.createElement(_uploadAvatar2.default,bindObj.bind()));}}}),resourceimg))));group.push(baseGroup);}else{c.items.forEach(function(field){if(c.hide||!(0,_isEmpty2.default)(field.otherParams)&&field.otherParams.hide){window.e9HideFormFieldKeys.push(field.domkey[0]);}else{var dom=React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,onChange:function onChange(v){if(v.accounttype){hrmCardInfo4Formal.updateHideBelongto(v.accounttype.value=='0');}}});if(field.conditionType=='RESOURCEIMG'||field.domkey&&field.domkey[0]=='belongto'&&hideBelongto){}else{items.push({com:React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},dom),colSpan:1});}}});group.push(React.createElement(_ecCom.WeaSearchGroup,{className:(isEditor?'hrm-center':'')+' '+(c.isHide?'wea-hide':''),needTigger:true,hide:c.hide,title:c.title,showGroup:c.defaultshow,items:items,col:window.HrmGroupCol}));}});return group;}},{key:'getPortraitButtons',value:function getPortraitButtons(){var _this3=this;var colArr=[];var hrmCardInfo4Formal=this.props.hrmCardInfo4Formal;var sendButtons=hrmCardInfo4Formal.sendButtons,validate=hrmCardInfo4Formal.validate;sendButtons=toJS(sendButtons);var emJoinStatus=window.emJoinStatus;(0,_isArray2.default)(sendButtons)&&sendButtons.forEach(function(item){var status=true;if(item.name=='sendEmessage'){status=emJoinStatus?!emJoinStatus.joinStatus||emJoinStatus.status&&emJoinStatus.joinStatus&&emJoinStatus.emSwitch!=="0":false;}if(status&&!(0,_isEmpty2.default)(validate)&&validate[item.validateId]&&validate[item.validateId].isValidate){colArr.push(React.createElement(_antd.Col,{span:6},React.createElement('div',{className:'hrm-my-card-basicInfo-icon-circle',onClick:function onClick(){PublicFunc[item.funname](item.id);},title:item.title},React.createElement('i',{className:''+_this3.getIcon(item.name)}))));}});return colArr;}},{key:'render',value:function render(){var _this4=this;var _state=this.state,editable=_state.editable,textVal=_state.textVal;var hrmCardInfo4Formal=this.props.hrmCardInfo4Formal;var isEditor=hrmCardInfo4Formal.isEditor,infoGroup=hrmCardInfo4Formal.infoGroup,infoGroup2=hrmCardInfo4Formal.infoGroup2,imgSrc=hrmCardInfo4Formal.imgSrc,modelItems=hrmCardInfo4Formal.modelItems,showSQR=hrmCardInfo4Formal.showSQR,showBigImg=hrmCardInfo4Formal.showBigImg,sendButtons=hrmCardInfo4Formal.sendButtons,accountInfo=hrmCardInfo4Formal.accountInfo,showAccountInfo=hrmCardInfo4Formal.showAccountInfo,QRCodeOptions=hrmCardInfo4Formal.QRCodeOptions,remarkInfo=hrmCardInfo4Formal.remarkInfo,tagInfo=hrmCardInfo4Formal.tagInfo,saveTag=hrmCardInfo4Formal.saveTag,delTag=hrmCardInfo4Formal.delTag,isSelf=hrmCardInfo4Formal.isSelf,visibleWeiXin=hrmCardInfo4Formal.visibleWeiXin,validate=hrmCardInfo4Formal.validate;var remarkEditable=isSelf;var textValHtml='';if(remarkInfo.value!=null&&remarkInfo.value.length>0){var arr=remarkInfo.value.split(/[\s\n]/);arr.map(function(text){textValHtml+='<div class="remarkRow"><li></li><div>'+text+'</div></div>';});}else{textValHtml=remarkEditable?'<p style="color: #868686">'+_i18n.i18n.label.fillSpecialtyIntroduction()+'</p>':'';}sendButtons=toJS(sendButtons);infoGroup=toJS(infoGroup);infoGroup2=toJS(infoGroup2);modelItems=toJS(modelItems);var sendBtns=this.getPortraitButtons();var hasQRCode=!(0,_isEmpty2.default)(validate)&&validate[37]&&validate[37].isValidate;var calculateHeight=function calculateHeight(){var height=window.innerHeight;if(document.getElementsByClassName('hrm-my-card').length>0){height-=document.getElementsByClassName('hrm-my-card-top-wapper')[0].offsetHeight;height-=document.getElementsByClassName('wea-tab')[0].offsetHeight;if(document.getElementsByClassName('e9theme-layout-header').length>0)height-=document.getElementsByClassName('e9theme-layout-header')[0].offsetHeight+10;//头部菜单高度
height-=10;return height;}return null;};var getPortrait=function getPortrait(){var loadingImg='/images/messageimages/temp/loading_wev8.gif';return React.createElement('div',{className:'hrm-my-card-basicInfo-left-imgwrap'},!showBigImg&&React.createElement('img',{className:'hrm-my-card-basicInfo-left-img',src:imgSrc?imgSrc:loadingImg,onError:function onError(){_this4.setState({imgSrc:'/images/messageimages/temp/man_wev8.png'});},onClick:function onClick(){return imgSrc&&hrmCardInfo4Formal.updateShowBigImg(true);}}),showBigImg&&React.createElement('img',{className:'hrm-my-card-basicInfo-left-img-big',onError:function onError(){_this4.setState({imgSrc:'/images/messageimages/temp/man_wev8.png'});},onClick:function onClick(){return imgSrc&&hrmCardInfo4Formal.updateShowBigImg(false);},src:imgSrc?imgSrc:loadingImg}),React.createElement('div',{className:'hrm-my-card-basicInfo-left-corner',style:{display:hasQRCode?'block':'none'},title:showSQR?_i18n.i18n.button.back():!(0,_isEmpty2.default)(validate)&&validate[37]&&validate[37].validateName,onClick:(0,_debounce2.default)(_this4.showSQR.bind(null,!showSQR),150)},React.createElement('i',{className:'icon-coms-'+(showSQR?'Revoke2':'Scan')})),React.createElement('div',{className:'hrm-my-card-basicInfo-sqr',style:{display:showSQR?'block':'none'},onClick:_this4.showSQR.bind(null,false)},!(0,_isEmpty2.default)(QRCodeOptions)&&React.createElement('div',{className:'hrm-my-card-basicInfo-sqr-canvas',style:{marginTop:(jQuery(".hrm-my-card-basicInfo-sqr").height()-152)/2}},React.createElement(_ecCom.WeaQrcode,{text:(0,_util.createQRCode)(QRCodeOptions),size:120,level:'L'})),React.createElement('p',{className:'hrm-my-card-basicInfo-sqr-title'},_i18n.i18n.button.scanAddContacts())));};var getAccountinfo=function getAccountinfo(){var colArr=[];var idx=0;accountInfo&&accountInfo.forEach(function(a,i){var showValue=void 0;if(a.isOpenHrm){showValue=a.showName!=''?React.createElement('a',{href:'javaScript:openhrm('+a.value+')',onClick:function onClick(event){return window.pointerXY(event);}},a.showName):React.createElement('div',null,'\xA0');}else{showValue=a.value?React.createElement('div',{dangerouslySetInnerHTML:{__html:a.value}}):React.createElement('div',null,'\xA0');}if(a.name=='weixin'){colArr.push(React.createElement(_antd.Col,{className:'hrm-my-card-basicInfo-left-accountinfo-label',span:'24'},React.createElement('a',{onClick:function onClick(){hrmCardInfo4Formal.updateVisibleWeiXin(true);}},a.label)));}else{colArr.push(React.createElement(_antd.Col,{className:'hrm-my-card-basicInfo-left-accountinfo-label',span:'12'},a.label,':'));colArr.push(React.createElement(_antd.Col,{className:'hrm-my-card-basicInfo-left-accountinfo-value',span:'12'},showValue));}if(a.name=='lastlogindate'){idx=i;}a.name=='lastlogindate'&&colArr.push(React.createElement(_antd.Col,{className:'hrm-my-card-basicInfo-left-accountinfo-middline',span:'24'}));});if(!showAccountInfo){colArr.splice((idx+1)*2,colArr.length);}colArr.push(React.createElement(_antd.Col,{className:'hrm-my-card-basicInfo-left-accountinfo-endicon',span:'24',onClick:function onClick(){return hrmCardInfo4Formal.updateShowAccountInfo(!showAccountInfo);}},React.createElement('i',{className:showAccountInfo?'icon-coms-up':'icon-coms-down',title:showAccountInfo?_i18n.i18n.button.collapse():_i18n.i18n.button.expand()})));return colArr;};var viewCard=React.createElement('div',{className:'hrm-my-card-basicInfo',style:{height:'100%'}},React.createElement(_ecCom.WeaDialog,{style:{width:500,height:380},title:_i18n.i18n.button.companyWechat(),visible:visibleWeiXin,onCancel:function onCancel(){return hrmCardInfo4Formal.updateVisibleWeiXin(false);},hideIcon:true},React.createElement('div',{className:'align-center'},React.createElement('img',{src:'/hrm/resource/image/qrcode.jpg',style:{height:374,width:344}}))),React.createElement('div',{className:'hrm-my-card-basicInfo-left'},getPortrait(),!(0,_isEmpty2.default)(sendBtns)&&React.createElement(_antd.Row,{className:'hrm-my-card-basicInfo-left-imgwrap-op',type:'flex',justify:'center',gutter:16},sendBtns),React.createElement(_antd.Row,null,getAccountinfo())),React.createElement('div',{className:'hrm-my-card-basicInfo-right',style:{minHeight:calculateHeight()}},React.createElement('div',{className:'hrm-my-card-basicInfo-right-counts'},modelItems&&modelItems.map(function(c){var fontColor=c['font-color'];return React.createElement('div',{className:'hrm-my-card-basicInfo-right-counts-cell',onClick:function onClick(){window.open(c.url);}},React.createElement('img',{src:c.icon,alt:''}),React.createElement('div',{className:'hrm-my-card-basicInfo-right-counts-cell-info'},React.createElement('div',null,c.label),React.createElement('div',{title:c.num,className:'text-overflow'},React.createElement('span',{style:{color:fontColor?fontColor:null,fontSize:18}},c.num))));})),React.createElement(_antd.Row,{gutter:24},React.createElement(_antd.Col,{span:'24'},React.createElement(_antd.Row,{className:'hrm-my-card-basicInfo-right-info'},infoGroup&&infoGroup.map(function(info){return React.createElement(_antd.Col,{span:'24'},React.createElement(_infoGroup4Formal.InfoGroup4Formal3,{items:info.items,title:info.title,showGroup:info.defaultshow}));})),React.createElement(_antd.Row,{className:'hrm-my-card-basicInfo-right-info'},React.createElement('div',{className:'wea-info-group-new'},React.createElement(_antd.Row,{className:'wea-info-group-new-title'},React.createElement(_antd.Col,{span:24},React.createElement('div',{className:'wea-info-group-new-title-info'},_i18n.i18n.label.specialtyIntroduction()))),React.createElement(_antd.Row,{className:'wea-info-group-new-content'},React.createElement(_antd.Col,{span:12},React.createElement('div',{className:'remarkContainer',ref:function ref(dom){_this4.divDom=dom;}},editable&&React.createElement(_ecCom.WeaTextarea,{style:{minHeight:'150px'},minRows:8,ref:function ref(dom){_this4.textareaDom=dom;},value:remarkInfo.value,onBlur:this.onBlurHandle}),!editable&&React.createElement('div',{dangerouslySetInnerHTML:{__html:textValHtml},style:{padding:'0px 10px 0px 10px'}}))),React.createElement(_antd.Col,{span:12},React.createElement('div',{className:'tagContainer'},React.createElement(_antd.Row,{className:'tagList'},tagInfo.value&&tagInfo.value.length>0&&tagInfo.value.map(function(tag){return React.createElement('div',{className:'tagInfo'},tag,remarkEditable&&React.createElement('i',{className:'ant-modal-close-x',onClick:function onClick(){return delTag({tag:tag});}}));})),remarkEditable&&React.createElement(_antd.Row,{className:'addTagContainer'},React.createElement(InputGroup,{compact:true},React.createElement(_antd.Input,{style:{width:'80%'},onPressEnter:function onPressEnter(){return saveTag(_this4.tagInput.refs.input);},ref:function ref(dom){return _this4.tagInput=dom;},placeholder:'\u8F93\u5165\u7279\u957F\u6807\u7B7E'}),React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return saveTag(_this4.tagInput.refs.input);}},_i18n.i18n.button.putOn()))))))))))));var editCard=React.createElement('div',{className:'hrm-my-card-basicInfo hrm-my-cardInfo',style:{height:'100%'}},this.getSearchs());return React.createElement('div',{style:{position:'relative'}},React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu()},!isEditor?viewCard:editCard));}}]);return Main;}(React.Component))||_class)||_class)||_class);exports.default=Main;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _antd=__webpack_require__(6);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _debounce=__webpack_require__(49);var _debounce2=_interopRequireDefault(_debounce);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _toString=__webpack_require__(56);var _toString2=_interopRequireDefault(_toString);var _forEach=__webpack_require__(46);var _forEach2=_interopRequireDefault(_forEach);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var Personal=(_dec=(0,_mobxReact.inject)('hrmPersonal'),_dec2=(0,_mobxReact.inject)('hrmCard'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Personal,_React$Component);function Personal(props){(0,_classCallCheck3.default)(this,Personal);var _this=(0,_possibleConstructorReturn3.default)(this,(Personal.__proto__||(0,_getPrototypeOf2.default)(Personal)).call(this,props));var funcs=['tableEditChange','editCard','backCard','saveEditCard','onTabChange'];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});return _this;}(0,_createClass3.default)(Personal,[{key:'componentDidMount',value:function componentDidMount(){var hrmCard=this.props.hrmCard;hrmCard.setTopButtons(this.getTopButtons.bind(this));hrmCard.setTopRightMenus(this.getRightMenu.bind(this));hrmCard.setTopShowDropIcon(true);this.init();}},{key:'init',value:function init(){var hrmPersonal=this.props.hrmPersonal;var hrmId=this.props.params.hrmId||'';hrmPersonal.init();hrmPersonal.hrmId=hrmId;hrmPersonal.getData();}},{key:'getTabChildren',value:function getTabChildren(){var _this2=this;var hrmPersonal=this.props.hrmPersonal;var tableInfo=hrmPersonal.tableInfo,isEditor=hrmPersonal.isEditor,tabkey=hrmPersonal.tabkey;var tabChildren=[];tableInfo=toJS(tableInfo);tableInfo&&tableInfo.map(function(t,i){if(tabkey==i){if(t.hide){}else{tabChildren.push(React.createElement(_ecCom.WeaTableEdit,{ref:function ref(_ref){return hrmPersonal.setPersonalEditTables(_ref);},showTitle:isEditor// title={'列表信息'}
,addFirstRow:isEditor,columns:t.tabinfo.columns,datas:t.tabinfo.datas,onChange:_this2.tableEditChange,viewAttr:isEditor?2:1,getRowSelection:isEditor?null:function(){return null;}}));}}});return tabChildren;}},{key:'getSearchs',value:function getSearchs(){var hrmPersonal=this.props.hrmPersonal;var form=hrmPersonal.form,conditions=hrmPersonal.conditions,isEditor=hrmPersonal.isEditor;var isFormInit=form.isFormInit;var group=[];var tipPosition='bottom';conditions=toJS(conditions);window.e9HideFormFieldKeys=[];isFormInit&&conditions.forEach(function(c){var items=[];c.items.forEach(function(field){if(c.hide||!(0,_isEmpty2.default)(field.otherParams)&&field.otherParams.hide){window.e9HideFormFieldKeys.push(field.domkey[0]);}else{items.push({com:React.createElement(_ecCom.WeaFormItem,{underline:!isEditor,label:''+field.label,error:form.getError(field),tipPosition:tipPosition,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form})),colSpan:1});}});group.push(React.createElement(_ecCom.WeaSearchGroup,{className:''+(isEditor?'hrm-center':''),needTigger:true,hide:c.hide,title:c.title,showGroup:c.defaultshow,items:items,col:window.HrmGroupCol}));});return group;}},{key:'tableEditChange',value:function tableEditChange(data){var hrmPersonal=this.props.hrmPersonal;var _hrmPersonal$tabkey=hrmPersonal.tabkey,tabkey=_hrmPersonal$tabkey===undefined?'0':_hrmPersonal$tabkey,tableInfo=hrmPersonal.tableInfo;tableInfo=toJS(tableInfo);var d=(0,_cloneDeep2.default)(tableInfo);d[Number(tabkey)].tabinfo.datas=data;hrmPersonal.updateTableInfo(d);}},{key:'onTabChange',value:function onTabChange(key){var hrmPersonal=this.props.hrmPersonal;hrmPersonal.changeTab(key);}},{key:'getRightMenu',value:function getRightMenu(){var _this3=this;var _props=this.props,hrmPersonal=_props.hrmPersonal,hrmCard=_props.hrmCard;var isEditor=hrmPersonal.isEditor,buttons=hrmPersonal.buttons,hrmId=hrmPersonal.hrmId;var arr=[];if(buttons.hasEdit){if(isEditor){arr=[{icon:React.createElement('i',{className:'icon-coms-common'}),content:_i18n.i18n.button.save(),key:'save',onClick:function onClick(key){_this3.saveEditCard();}},{icon:React.createElement('i',{className:'icon-coms-go-back'}),content:_i18n.i18n.button.back(),key:'back',onClick:function onClick(key){_this3.backCard();}}];}else{arr=[{icon:React.createElement('i',{className:'icon-coms-edit'}),content:_i18n.i18n.button.modify(),key:'editCard',onClick:function onClick(key){_this3.editCard();}}];arr.push({icon:React.createElement('i',{className:'icon-coms-Print-log'}),content:_i18n.i18n.button.log(),key:'showLog',onClick:function onClick(key){window.setLogViewProps({logSmallType:_i18n.i18n.smallType.HRM_RSOURCE_CARD_PERSONAL,targetId:hrmId});}});}}return arr;}},{key:'getTopButtons',value:function getTopButtons(){var hrmPersonal=this.props.hrmPersonal;var isEditor=hrmPersonal.isEditor,buttons=hrmPersonal.buttons;var save=React.createElement(_antd.Button,{type:'primary',onClick:this.saveEditCard},_i18n.i18n.button.save());var back=React.createElement(_antd.Button,{type:'primary',onClick:this.backCard},_i18n.i18n.button.back());var edit=React.createElement(_antd.Button,{type:'primary',onClick:this.editCard},_i18n.i18n.button.modify());var btns=[];if(isEditor){if(buttons.hasSave){btns.push(save);btns.push(back);}}else{if(buttons.hasEdit){btns.push(edit);}}return btns;}},{key:'editCard',value:function editCard(){var hrmPersonal=this.props.hrmPersonal;hrmPersonal.edit();}},{key:'saveEditCard',value:function saveEditCard(){var hrmPersonal=this.props.hrmPersonal;hrmPersonal.save();}},{key:'backCard',value:function backCard(){this.init();}},{key:'render',value:function render(){var hrmPersonal=this.props.hrmPersonal;var loading=hrmPersonal.loading,tabkey=hrmPersonal.tabkey,tabInfo=hrmPersonal.tabInfo,date=hrmPersonal.date,tableInfo=hrmPersonal.tableInfo;//let showDetialTable = !isEmpty(tableInfo.filter(t => !t.hide));
return React.createElement('div',{className:'hrm-my-cardInfo',style:{height:'100%',position:'relative'}},React.createElement(_antd.Spin,{spinning:loading},React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick},this.getSearchs(),!(0,_isEmpty2.default)(tabInfo)&&React.createElement('div',{className:'hrm-my-cardInfo_detial_tabs'},React.createElement(_ecCom.WeaTab,{type:'card',keyParam:'key',datas:toJS(tabInfo),selectedKey:tabkey,onChange:function onChange(v){hrmPersonal.updateTabkey(v);}}),this.getTabChildren()))));}}]);return Personal;}(React.Component))||_class)||_class)||_class);exports.default=Personal;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _antd=__webpack_require__(6);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _debounce=__webpack_require__(49);var _debounce2=_interopRequireDefault(_debounce);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _toString=__webpack_require__(56);var _toString2=_interopRequireDefault(_toString);var _forEach=__webpack_require__(46);var _forEach2=_interopRequireDefault(_forEach);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var Work=(_dec=(0,_mobxReact.inject)('hrmWork'),_dec2=(0,_mobxReact.inject)('hrmCard'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Work,_React$Component);function Work(props){(0,_classCallCheck3.default)(this,Work);var _this=(0,_possibleConstructorReturn3.default)(this,(Work.__proto__||(0,_getPrototypeOf2.default)(Work)).call(this,props));var funcs=['tableEditChange','editCard','backCard','saveEditCard','onTabChange'];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});return _this;}(0,_createClass3.default)(Work,[{key:'componentDidMount',value:function componentDidMount(){var hrmCard=this.props.hrmCard;hrmCard.setTopButtons(this.getTopButtons.bind(this));hrmCard.setTopRightMenus(this.getRightMenu.bind(this));hrmCard.setTopShowDropIcon(true);this.init();}},{key:'init',value:function init(){var hrmWork=this.props.hrmWork;var hrmId=this.props.params.hrmId||'';hrmWork.init();hrmWork.hrmId=hrmId;hrmWork.getData();}},{key:'getTabChildren',value:function getTabChildren(){var _this2=this;var hrmWork=this.props.hrmWork;var tableInfo=hrmWork.tableInfo,isEditor=hrmWork.isEditor,tabkey=hrmWork.tabkey;var tabChildren=[];tableInfo=toJS(tableInfo);tableInfo&&tableInfo.map(function(t,i){if(tabkey==i){tabChildren.push(React.createElement(_ecCom.WeaTableEdit,{ref:function ref(_ref){return hrmWork.setWorkEditTables(_ref);},showTitle:isEditor// title={'列表信息'}
,addFirstRow:isEditor,columns:t.tabinfo.columns,datas:t.tabinfo.datas,onChange:_this2.tableEditChange,viewAttr:isEditor?2:1,getRowSelection:isEditor?null:function(){return null;}}));}});return tabChildren;}},{key:'getSearchs',value:function getSearchs(){var hrmWork=this.props.hrmWork;var form=hrmWork.form,conditions=hrmWork.conditions,isEditor=hrmWork.isEditor;var isFormInit=form.isFormInit;var group=[];var tipPosition='bottom';conditions=toJS(conditions);window.e9HideFormFieldKeys=[];isFormInit&&conditions.forEach(function(c){var items=[];c.items.forEach(function(field){if(c.hide||!(0,_isEmpty2.default)(field.otherParams)&&field.otherParams.hide){window.e9HideFormFieldKeys.push(field.domkey[0]);}else{items.push({com:React.createElement(_ecCom.WeaFormItem,{underline:!isEditor,label:''+field.label,error:form.getError(field),tipPosition:tipPosition,labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,onChange:function onChange(v){if(field.domkey[0]=='companystartdate'||field.domkey[0]=='workstartdate'){var value=0.00;var obj={};var domKey='';if(field.domkey[0]=='companystartdate'){domKey='companyworkyear';}else if(field.domkey[0]=='workstartdate'){domKey='workyear';}value=hrmWork.calYear(v[field.domkey[0]].value);obj[domKey]={value:value};form.updateFields(obj);}}})),colSpan:1});}});group.push(React.createElement(_ecCom.WeaSearchGroup,{className:''+(isEditor?'hrm-center':''),hide:c.hide,needTigger:true,title:c.title,showGroup:c.defaultshow,items:items,col:window.HrmGroupCol}));});return group;}},{key:'tableEditChange',value:function tableEditChange(data){var hrmWork=this.props.hrmWork;var _hrmWork$tabkey=hrmWork.tabkey,tabkey=_hrmWork$tabkey===undefined?'0':_hrmWork$tabkey,tableInfo=hrmWork.tableInfo;tableInfo=toJS(tableInfo);var d=(0,_cloneDeep2.default)(tableInfo);d[Number(tabkey)].tabinfo.datas=data;hrmWork.updateTableInfo(d);}},{key:'onTabChange',value:function onTabChange(key){var hrmWork=this.props.hrmWork;hrmWork.changeTab(key);}},{key:'getRightMenu',value:function getRightMenu(){var _this3=this;var _props=this.props,hrmWork=_props.hrmWork,hrmCard=_props.hrmCard;var isEditor=hrmWork.isEditor,buttons=hrmWork.buttons,hrmId=hrmWork.hrmId;var arr=[];if(buttons.hasEdit){if(isEditor){arr=[{icon:React.createElement('i',{className:'icon-coms-common'}),content:_i18n.i18n.button.save(),key:'save',onClick:function onClick(key){_this3.saveEditCard();}},{icon:React.createElement('i',{className:'icon-coms-go-back'}),content:_i18n.i18n.button.back(),key:'back',onClick:function onClick(key){_this3.backCard();}}];}else{arr=[{icon:React.createElement('i',{className:'icon-coms-edit'}),content:_i18n.i18n.button.modify(),key:'editCard',onClick:function onClick(key){_this3.editCard();}}];arr.push({icon:React.createElement('i',{className:'icon-coms-Print-log'}),content:_i18n.i18n.button.log(),key:'showLog',onClick:function onClick(key){window.setLogViewProps({logSmallType:_i18n.i18n.smallType.HRM_RSOURCE_CARD_WORK,targetId:hrmId});}});}}return arr;}},{key:'getTopButtons',value:function getTopButtons(){var hrmWork=this.props.hrmWork;var isEditor=hrmWork.isEditor,buttons=hrmWork.buttons;var save=React.createElement(_antd.Button,{type:'primary',onClick:this.saveEditCard},_i18n.i18n.button.save());var back=React.createElement(_antd.Button,{type:'primary',onClick:this.backCard},_i18n.i18n.button.back());var edit=React.createElement(_antd.Button,{type:'primary',onClick:this.editCard},_i18n.i18n.button.modify());var btns=[];if(isEditor){if(buttons.hasSave){btns.push(save);btns.push(back);}}else{if(buttons.hasEdit){btns.push(edit);}}return btns;}},{key:'editCard',value:function editCard(){var hrmWork=this.props.hrmWork;hrmWork.edit();}},{key:'saveEditCard',value:function saveEditCard(){var hrmWork=this.props.hrmWork;hrmWork.save();}},{key:'backCard',value:function backCard(){this.init();}},{key:'render',value:function render(){var hrmWork=this.props.hrmWork;var loading=hrmWork.loading,tabkey=hrmWork.tabkey,tabInfo=hrmWork.tabInfo,date=hrmWork.date;return React.createElement('div',{className:'hrm-my-cardInfo',style:{height:'100%',position:'relative'}},React.createElement(_antd.Spin,{spinning:loading},React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu()},this.getSearchs(),!(0,_isEmpty2.default)(tabInfo)&&React.createElement('div',{className:'hrm-my-cardInfo_detial_tabs'},React.createElement(_ecCom.WeaTab,{type:'card',keyParam:'key',datas:toJS(tabInfo),selectedKey:tabkey,onChange:function onChange(v){hrmWork.updateTabkey(v);}}),this.getTabChildren()))));}}]);return Work;}(React.Component))||_class)||_class)||_class);exports.default=Work;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);__webpack_require__(465);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _toString=__webpack_require__(56);var _toString2=_interopRequireDefault(_toString);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _debounce=__webpack_require__(49);var _debounce2=_interopRequireDefault(_debounce);var _index=__webpack_require__(246);var Util=_interopRequireWildcard(_index);var _path=__webpack_require__(225);var _i18n=__webpack_require__(251);var _Dialog=__webpack_require__(469);var _Dialog2=_interopRequireDefault(_Dialog);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var toJS=mobx.toJS;var __this=void 0;var ButtonGroup=_antd.Button.Group;var WorkInfo=function WorkInfo(props){var groupitem=props.groupitem,onStsClick=props.onStsClick;var len=groupitem.length;var iconColProps={lg:9,sm:11,xs:13};var titleColProps={lg:15,sm:13,xs:11};var paddingLeft=$(window).width()>1100?'8%':'5%';return _react2.default.createElement(_antd.Row,{className:'work',style:{paddingLeft:paddingLeft}},groupitem&&groupitem.map(function(d,index){var color=d.color,icon=d.icon,value=d.value,title=d.title;return _react2.default.createElement(_antd.Col,{span:24/len,className:'work-info'},_react2.default.createElement(_antd.Row,{className:'cursor-pointer',onClick:function onClick(){return onStsClick(d);}},_react2.default.createElement(_antd.Col,(0,_extends3.default)({},iconColProps,{style:{position:'relative'}}),_react2.default.createElement('div',{className:'work-info-icon',style:{backgroundColor:color}},_react2.default.createElement('i',{className:icon}))),_react2.default.createElement(_antd.Col,titleColProps,_react2.default.createElement('div',{className:'abnormal-font'},value),_react2.default.createElement('div',{className:'work-info-title hrm-over-flow',title:title},title))));}));};var LeaveInfo=function LeaveInfo(props){var groupitem=props.groupitem,onStsClick=props.onStsClick,hasBorder=props.hasBorder;var len=groupitem.length;var getColSpan=function getColSpan(len){var colSpan=void 0;if(len<4){colSpan=24/len;}else{colSpan=8;}return colSpan;};var getPaddingTop=function getPaddingTop(len){var rowLen=Math.ceil(len/3);var paddingTop=void 0;switch(rowLen){case 1:paddingTop=30;break;case 2:paddingTop=15;break;default:paddingTop=5;}return paddingTop;};var colSpan=getColSpan(len);var paddingTop=getPaddingTop(len);var valColProps={lg:9,md:10,sm:11,xs:12};var titleColProps={lg:15,md:14,sm:13,xs:12};var paddingLeft=$(window).width()>1100&&len>2?'8%':'5%';return _react2.default.createElement(_antd.Row,{className:'leave',style:{paddingTop:paddingTop,paddingLeft:paddingLeft}},groupitem&&groupitem.map(function(d,i){var value=d.value,title=d.title;return _react2.default.createElement(_antd.Col,{span:colSpan,className:'leave-situation'},_react2.default.createElement(_antd.Row,{className:'cursor-pointer',onClick:function onClick(){return onStsClick(d);}},_react2.default.createElement(_antd.Col,(0,_extends3.default)({},len>2?valColProps:{span:12},{className:'leave-situation-value abnormal-font hrm-over-flow',title:value}),value),_react2.default.createElement(_antd.Col,(0,_extends3.default)({},len>2?titleColProps:{span:12},{className:'leave-situation-title hrm-over-flow',title:title}),title)));}));};var SignInfo=function SignInfo(props){var groupitem=props.groupitem,onStsClick=props.onStsClick;return _react2.default.createElement('div',{className:'sign'},groupitem&&groupitem.map(function(d){var value=d.value,title=d.title;return _react2.default.createElement('div',{className:'cursor-pointer',onClick:function onClick(){return onStsClick(d);}},_react2.default.createElement('span',{className:'sign-value abnormal-font'},value),_react2.default.createElement('span',{className:'sign-title hrm-over-flow',title:title},title));}));};var NoData=function NoData(props){var tip=props.tip,loading=props.loading;if(loading){return null;}return _react2.default.createElement('div',{className:'no-data'},_react2.default.createElement(_antd.Row,{type:'flex',justify:'space-around',align:'middle',className:'outterow'},_react2.default.createElement(_antd.Col,{span:24},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{sm:11,xs:8,className:'no-data-col-1'},_react2.default.createElement('i',{className:'icon-coms-NoData f28'})),_react2.default.createElement(_antd.Col,{sm:13,xs:16,className:'no-data-tip wea-f14 hrm-over-flow',title:tip},tip)))));};var main=(_dec=(0,_mobxReact.inject)('hrmChecking'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.onOperatesClick=function(record,index,operate,flag,argumentString){if(toJS(operate)&&toJS(operate).href.indexOf('addChecking')>-1){__this.addChecking();}};_this.handleInputChange=function(value){_this.props.hrmChecking.setInputValue(value);};_this.handleButtonGroupClick=function(bool){_this.props.hrmChecking.setIsDay(bool);};_this.state={iWidth:window.innerWidth,oHeight:300};if(window.innerHeight>850){_this.state.oHeight=450;}else if(window.innerHeight>600){_this.state.oHeight=window.innerHeight/2-100;}else{_this.state.oHeight=200;}_this.onStsClick.bind(_this);__this=_this;var hrmChecking=_this.props.hrmChecking;hrmChecking.init();return _this;}(0,_createClass3.default)(main,[{key:'componentDidMount',value:function componentDidMount(){var hrmChecking=this.props.hrmChecking;hrmChecking.hrmId=this.props.params.hrmId||'';this.getData();hrmChecking.getHrmNewWorkflwList();//document.title = hrmChecking.title;
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmChecking=this.props.hrmChecking;if(this.props.location.key!==nextProps.location.key){hrmChecking.init();this.getData();}}},{key:'getData',value:function getData(){var _this2=this;var hrmChecking=this.props.hrmChecking;var tabkey=hrmChecking.tabkey;hrmChecking.getData(function(){tabkey==1&&_this2.refs.chart&&_this2.refs.chart.paint();});}},{key:'getRightMenu',value:function getRightMenu(){var _this3=this;var hrmChecking=this.props.hrmChecking;var btns=[];btns.push({key:"add",icon:_react2.default.createElement('i',{className:'icon-coms-workflow'}),content:getLabel('385037',"新建考勤流程"),onClick:function onClick(key){_this3.addChecking();}});return btns;}},{key:'addChecking',value:function addChecking(){var hrmChecking=this.props.hrmChecking;hrmChecking.updateNewVisible(true);}},{key:'getTopButtons',value:function getTopButtons(){var _this4=this;var hrmChecking=this.props.hrmChecking;var btns=[];btns.push(_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this4.addChecking();}},getLabel('385037',"新建考勤流程")));return btns;}},{key:'chooseUser',value:function chooseUser(e){var hrmChecking=this.props.hrmChecking;var hrmId='',hrmName=undefined;if(e.selected){hrmId=e.node.props.id;hrmName=e.node.props.name;}if(hrmId){hrmChecking.updateHrmId(hrmId);if(hrmName)hrmChecking.updateHrmName(hrmName);this.getData();}}},{key:'changeUserRoot',value:function changeUserRoot(ids,names,datas){var hrmChecking=this.props.hrmChecking;hrmChecking.updateUserRoot(datas);}},{key:'resetUserRoot',value:function resetUserRoot(){var hrmChecking=this.props.hrmChecking;hrmChecking.updateUserRoot();hrmChecking.updateHrmId();hrmChecking.updateHrmName();this.getData();}},{key:'changeTab',value:function changeTab(key){var hrmChecking=this.props.hrmChecking;hrmChecking.changeTabHandler(key);this.getData();}},{key:'changeDateTab',value:function changeDateTab(key){var hrmChecking=this.props.hrmChecking;hrmChecking.changeDateTabHandler(key);this.getData();}},{key:'reFresh',value:function reFresh(){var hrmChecking=this.props.hrmChecking;this.getData();}},{key:'changeDate',value:function changeDate(v){var hrmChecking=this.props.hrmChecking;var dateTabkey=hrmChecking.dateTabkey;if(dateTabkey=='2'){v=new _moment2.default(v).format('YYYY-MM');}else{v=new _moment2.default(v).format('YYYY');}hrmChecking.changeDateHandler(v);this.getData();}},{key:'handlerStatusClick',value:function handlerStatusClick(item){var hrmChecking=this.props.hrmChecking;hrmChecking.handlerStatusClick(item.type);}},{key:'renderLeft',value:function renderLeft(){var hrmChecking=this.props.hrmChecking;var oHeight=this.state.oHeight;var tabkey=hrmChecking.tabkey,leftTitle=hrmChecking.leftTitle,userRoot=hrmChecking.userRoot;userRoot=toJS(userRoot);var hrmId=this.props.params.hrmId||'';var org=_react2.default.createElement(_ecCom.WeaOrgTree,{dataUrl:'/api/hrm/base/getHrmResourceTree',rootKey:'rootManager',treeNodeClick:this.chooseUser.bind(this),params:Array.isArray(userRoot)&&userRoot[0]?{rootid:userRoot[0].id}:{rootid:hrmId}});return _react2.default.createElement('div',{className:'attendence-checking-left',style:{height:window.innerHeight-125}},_react2.default.createElement('div',{className:'left-header'},_react2.default.createElement('div',{className:'header-title bb align-center'},getLabel('32997',"人员组织"))),_react2.default.createElement('div',{className:'left-body'},_react2.default.createElement(_ecCom.WeaBrowser,{isSingle:true,linkUrl:'/hrm/resource/HrmResource.jsp?id=',title:getLabel('179',"人力资源"),type:'1',viewAttr:'2',replaceDatas:userRoot,customIcon:'icon-coms-Reset',addOnClick:this.resetUserRoot.bind(this),onChange:this.changeUserRoot.bind(this)}),tabkey==='1'?_react2.default.createElement('div',{style:{height:window.innerHeight-235}},org):_react2.default.createElement(_ecCom.WeaNewScroll,{height:oHeight,className:'left-checking'},org),tabkey==='2'&&this.renderDetail()));}// 截取很magic的a标签数据
},{key:'sliceA',value:function sliceA(str){if(str.indexOf('a>')>-1&&str.indexOf('<a')>-1){str=str.match(/\>(.+)</)[1];}return str;}},{key:'renderDetail',value:function renderDetail(){var _this5=this;var hrmChecking=this.props.hrmChecking;var oHeight=this.state.oHeight;var calendarCheckedDay=hrmChecking.calendarCheckedDay,sData=hrmChecking.sData;if(calendarCheckedDay){return _react2.default.createElement(_ecCom.WeaNewScroll,{height:window.innerHeight-200-oHeight,className:'bt'},_react2.default.createElement('div',{className:'detail-wrapper'},_react2.default.createElement('strong',{className:'detail-header'},_react2.default.createElement('i',{className:'icon-coms-New-schedule'}),sData.date,'\xA0 ',getLabel('20080',"考勤情况")),(0,_isEmpty2.default)(sData.signInfo)&&_react2.default.createElement('div',{className:'empty align-center'},getLabel('386472',"当天没有考勤数据")),!(0,_isEmpty2.default)(sData.signInfo)&&_react2.default.createElement(_antd.Timeline,null,sData.signInfo.map(function(i){return _react2.default.createElement(_antd.Timeline.Item,null,i.item&&i.item.map(function(d){return _react2.default.createElement('div',{className:'item'},_react2.default.createElement('span',{className:'title'},d.title),'\xA0:\xA0',_react2.default.createElement('span',{className:'value'},_this5.sliceA(d.value)));}));}))));}return _react2.default.createElement('div',{className:'detail-wrapper align-center bt'},_react2.default.createElement('span',null,getLabel('386473',"点击日历查看每天考勤情况")));}},{key:'getLocale',value:function getLocale(){return{firstDayOfWeek:0,lang:{format:{eras:[getLabel(383357,"公元前"),getLabel(383358,"公元")],months:[getLabel(1492,"一月"),getLabel(1493,"二月"),getLabel(383385,"三月"),getLabel(383387,"四月"),getLabel(1496,"五月"),getLabel(383392,"六月"),getLabel(383393,"七月"),getLabel(383394,"八月"),getLabel(383395,"九月"),getLabel(383396,"十月"),getLabel(383397,"十一月"),getLabel(383398,"十二月")],shortMonths:[getLabel(1492,"一月"),getLabel(1493,"二月"),getLabel(383385,"三月"),getLabel(383387,"四月"),getLabel(1496,"五月"),getLabel(383392,"六月"),getLabel(383393,"七月"),getLabel(383394,"八月"),getLabel(383395,"九月"),getLabel(383396,"十月"),getLabel(383397,"十一月"),getLabel(383398,"十二月")],weekdays:[getLabel(24626,"星期天"),getLabel(383399,"星期一"),getLabel(383400,"星期二"),getLabel(383402,"星期三"),getLabel(383403,"星期四"),getLabel(383404,"星期五"),getLabel(383405,"星期六")],shortWeekdays:[getLabel(16106,"周日"),getLabel(16100,"周一"),getLabel(16101,"周二"),getLabel(16102,"周三"),getLabel(16103,"周四"),getLabel(16104,"周五"),getLabel(16105,"周六")],veryShortWeekdays:[getLabel(16106,"周日"),getLabel(16100,"周一"),getLabel(16101,"周二"),getLabel(16102,"周三"),getLabel(16103,"周四"),getLabel(16104,"周五"),getLabel(16105,"周六")],ampms:[getLabel(383408,"上午"),getLabel(383409,"下午")],datePatterns:['yyyy\''+getLabel(383372,"年")+'\'M\''+getLabel(383373,"月")+'\'d\''+getLabel(383374,"日")+'\' EEEE','yyyy\''+getLabel(383372,"年")+'\'M\''+getLabel(383373,"月")+'\'d\''+getLabel(383374,"日")+'\'',"yyyy-M-d","yy-M-d"],timePatterns:['ahh\''+getLabel(383411,"时")+'\'mm\''+getLabel(383412,"分")+'\'ss\''+getLabel(383414,"秒")+'\' \'GMT\'Z','ahh\''+getLabel(383411,"时")+'\'mm\''+getLabel(383412,"分")+'\'ss\''+getLabel(383414,"秒")+'\'',"H:mm:ss","ah:mm"],dateTimePattern:'{date} {time}'}}};}},{key:'getTipText',value:function getTipText(data){return _react2.default.createElement('div',null,_react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:data.title}}),_react2.default.createElement('div',null,getLabel('24979',"开始时间"),'\uFF1A ',data.start),_react2.default.createElement('div',null,getLabel('743',"结束时间"),'\uFF1A ',data.end),data.type&&_react2.default.createElement('div',null,getLabel('500401',"类型"),'\uFF1A ',data.type),_react2.default.createElement('div',null,getLabel('506048',"时长"),'\uFF1A ',data.count));}},{key:'onMonthSelect',value:function onMonthSelect(date){var hrmChecking=this.props.hrmChecking;var dateTabkey=hrmChecking.dateTabkey,pDate=hrmChecking.pDate;var select=new _moment2.default(date.time).format('YYYY-MM');if(pDate.slice(0,7)==select){hrmChecking.updateCalendarCheckedDay(date.getDayOfMonth());}}},{key:'onyearMonthSelect',value:function onyearMonthSelect(date){var hrmChecking=this.props.hrmChecking;var select=new _moment2.default(date.time).format('YYYY-MM');hrmChecking.changeDateHandler(select);hrmChecking.updateDateTabkey('2');this.getData();}},{key:'monthDateCellRender',value:function monthDateCellRender(date){var _this6=this;var hrmChecking=this.props.hrmChecking;var dateTabkey=hrmChecking.dateTabkey,pDate=hrmChecking.pDate,calendarData=hrmChecking.calendarData,statusActiveType=hrmChecking.statusActiveType;calendarData=toJS(calendarData);var select=new _moment2.default(date.time).format('YYYY-MM');if(pDate.slice(0,7)==select){var day=date.getDayOfMonth();var data=calendarData[day];var components=[];if(data&&(data.types.indexOf(statusActiveType)>-1||statusActiveType=='ALL'||data.types.indexOf('NORMAL')>-1)){components.push(_react2.default.createElement('div',{className:'calendar-item'},_react2.default.createElement('span',{className:'icon-wrapper'},data.types&&data.types.map(function(type,idx){if(idx>4)return;var ic=Util.getIconColor(type);if(type==statusActiveType||statusActiveType=='ALL'){return _react2.default.createElement('i',{className:''+ic.icon,style:{color:ic.color,marginRight:2},title:ic.name},_react2.default.createElement('span',{className:'path1'}),_react2.default.createElement('span',{className:'path2'}),_react2.default.createElement('span',{className:'path3'}),_react2.default.createElement('span',{className:'path4'}));}})),_react2.default.createElement('span',{className:'tip',style:{color:data.isWorkDay?'#FF1B10':'#1B9B12'}},data.tip),_react2.default.createElement(_ecCom.WeaNewScroll,{height:data.workflow&&data.workflow.length>0?45:15},data.workflow&&data.workflow.map(function(item){if(item.workflowtype==statusActiveType||statusActiveType=='ALL'){var ic=Util.getIconColor(item.workflowtype);return _react2.default.createElement(_antd.Tooltip,{placement:'right',title:_this6.getTipText(item)},_react2.default.createElement('div',{className:'workflow-item',style:{backgroundColor:ic.bcolor}},_react2.default.createElement('div',{className:'text-overflow',dangerouslySetInnerHTML:{__html:item.title},style:{color:ic.color}})));}}))));}if(data&&data.signInfo){components.push(data.signInfo.map(function(info){var title=info.title,signTime=info.signTime;return _react2.default.createElement(_antd.Row,{className:'calendar-sign-info'},_react2.default.createElement(_antd.Col,{span:7,className:'text-overflow'},title+': '),_react2.default.createElement(_antd.Col,{span:17,className:'text-overflow'},signTime));}));}return components;}}},{key:'yearDateCellRender',value:function yearDateCellRender(date){var hrmChecking=this.props.hrmChecking;var dateTabkey=hrmChecking.dateTabkey,pDate=hrmChecking.pDate,yearData=hrmChecking.yearData,statusActiveType=hrmChecking.statusActiveType;yearData=toJS(yearData);var d=date.getDayOfMonth();var m=date.getMonth()+1;var data={},ic=undefined;if(yearData!==undefined&&!(0,_isEmpty2.default)(yearData)){data=yearData[m][d];try{if(data.type!=='NORMAL')ic=Util.getIconColor(data.type);}catch(e){return _react2.default.createElement('div',{className:'date-item'},d);}}var content=void 0;if(ic&&(statusActiveType==data.type||statusActiveType=='ALL')){content=_react2.default.createElement('span',null,_react2.default.createElement('i',{className:''+ic.icon,style:{color:ic.color}},_react2.default.createElement('span',{className:'path1'}),_react2.default.createElement('span',{className:'path2'}),_react2.default.createElement('span',{className:'path3'}),_react2.default.createElement('span',{className:'path4'})),data.tip&&_react2.default.createElement('span',{className:'tip',style:{color:data.isWorkDay?'#FF1B10':'#1B9B12'}},data.tip));}else{content=_react2.default.createElement('span',null,data.tip&&_react2.default.createElement('span',{className:'tip',style:{color:data.isWorkDay?'#FF1B10':'#1B9B12'}},data.tip),d);}return _react2.default.createElement('div',{className:'date-item'},content);}},{key:'renderCalendar',value:function renderCalendar(){var hrmChecking=this.props.hrmChecking;var dateTabkey=hrmChecking.dateTabkey,pDate=hrmChecking.pDate,pDate1=hrmChecking.pDate1;return _react2.default.createElement('div',{className:'calendar-wrapper'},dateTabkey=='2'&&_react2.default.createElement(_antd.Calendar,{mode:'month',dateCellRender:this.monthDateCellRender.bind(this),locale:this.getLocale(),onSelect:this.onMonthSelect.bind(this),value:new Date(pDate)}),dateTabkey=='1'&&_react2.default.createElement(_ecCom.WeaYear,{value:pDate1,dateCellRender:this.yearDateCellRender.bind(this),onMonthSelect:this.onyearMonthSelect.bind(this)}));}},{key:'onStsClick',value:function onStsClick(item){var hrmChecking=this.props.hrmChecking;var id=item.id;if(parseFloat(item.value)>0){hrmChecking.updateStsType(item.type);if(id==="leaveDays"){hrmChecking.openAbsenceDialog();}else{hrmChecking.getTableData();hrmChecking.updateVisible(true);}}else{var content=getLabel('386474',"本月没有{params}数据！").replace('{params}',item.title);_antd.Modal.warning({title:_i18n.i18n.confirm.defaultTitle(),content:content});}}},{key:'renderStatistics',value:function renderStatistics(){var _this7=this;var hrmChecking=this.props.hrmChecking;var iWidth=this.state.iWidth;var chartOptions=hrmChecking.chartOptions,groupitem2=hrmChecking.groupitem2,groupitem3=hrmChecking.groupitem3,groupitem4=hrmChecking.groupitem4,groupitem5=hrmChecking.groupitem5,count=hrmChecking.count;chartOptions=toJS(chartOptions);groupitem4=toJS(groupitem4);groupitem3=toJS(groupitem3);groupitem2=toJS(groupitem2);groupitem5=toJS(groupitem5);var hasLeaveInfo=hrmChecking.hasLeaveInfo,loading=hrmChecking.loading;return _react2.default.createElement('div',null,_react2.default.createElement(_antd.Row,{className:'statistics-wrapper'},_react2.default.createElement(_antd.Col,{span:8,className:'chart-wrapper'},_react2.default.createElement('div',{className:'chart-content'},_react2.default.createElement('div',{className:'statistics-title bb'},getLabel('16732',"出勤统计")),_react2.default.createElement('div',{className:'echart-item'},_react2.default.createElement(_ecCom.WeaEchart,{style:{height:160,width:160,display:'inline-block'},ref:'chart',option:chartOptions,useDefault:false})),_react2.default.createElement('div',{className:'echart-count'},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12,className:'number align-center cursor-pointer',style:{color:chartOptions.series[0].color[1]},onClick:function onClick(){return _this7.onStsClick(chartOptions.series[0].data[1]);}},!(0,_isEmpty2.default)(chartOptions.series[0].data)&&chartOptions.series[0].data[1].value,' '),_react2.default.createElement(_antd.Col,{span:12,className:'number align-center cursor-pointer',style:{color:chartOptions.series[0].color[0]},onClick:function onClick(){_this7.onStsClick(chartOptions.series[0].data[0]);}},!(0,_isEmpty2.default)(chartOptions.series[0].data)&&chartOptions.series[0].data[0].value,' ')),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12,className:'align-center hrm-over-flow'},_react2.default.createElement('span',{className:'dot mr15',style:{backgroundColor:chartOptions.series[0].color[1]}}),_react2.default.createElement('span',{className:'',title:''+(!(0,_isEmpty2.default)(chartOptions.series[0].data)&&chartOptions.series[0].data[1].name)},!(0,_isEmpty2.default)(chartOptions.series[0].data)&&chartOptions.series[0].data[1].name,'\uFF08',_i18n.i18n.label.day(),'\uFF09')),_react2.default.createElement(_antd.Col,{span:12,className:'align-center hrm-over-flow'},_react2.default.createElement('span',{className:'dot mr15',style:{backgroundColor:chartOptions.series[0].color[0]}}),_react2.default.createElement('span',{className:'',title:''+(!(0,_isEmpty2.default)(chartOptions.series[0].data)&&chartOptions.series[0].data[0].name)},!(0,_isEmpty2.default)(chartOptions.series[0].data)&&chartOptions.series[0].data[0].name,'\uFF08',_i18n.i18n.label.day(),'\uFF09')))))),_react2.default.createElement(_antd.Col,{span:16,className:'abnormal-wrapper'},_react2.default.createElement('div',{className:'statistics-title bb'},getLabel('132057',"异常考勤汇总")),_react2.default.createElement('div',{className:'abnormal-wrapper-left',style:{width:jQuery('.attendence-checking').innerWidth()<1300&&'74%'}},_react2.default.createElement(WorkInfo,{groupitem:groupitem2,onStsClick:function onStsClick(d){return _this7.onStsClick(d);}}),_react2.default.createElement('div',{style:{height:'50%'}},_react2.default.createElement('div',{className:'leave-info-header'},_react2.default.createElement('span',{className:'icon'},_react2.default.createElement('i',{className:'icon-coms-content-o'})),_react2.default.createElement('span',{className:'title'},getLabel('503887','请假信息'))),hasLeaveInfo?_react2.default.createElement(_ecCom.WeaNewScroll,{height:93},_react2.default.createElement(LeaveInfo,{groupitem:groupitem5,onStsClick:function onStsClick(d){return _this7.onStsClick(d);}})):_react2.default.createElement(NoData,{tip:getLabel('503888','暂无请假信息'),loading:loading}))),_react2.default.createElement('div',{className:'abnormal-wrapper-right',style:{width:jQuery('.attendence-checking').innerWidth()<1300&&'26%'}},_react2.default.createElement(SignInfo,{groupitem:groupitem3,onStsClick:function onStsClick(d){return _this7.onStsClick(d);},hasBorder:true})))),_react2.default.createElement(_antd.Row,{gutter:36,className:'detail'},groupitem4&&groupitem4.map(function(d){return _react2.default.createElement(_antd.Col,{span:8,style:{marginBottom:20}},_react2.default.createElement(_antd.Row,{className:'detail-title',title:d.title},d.title),_react2.default.createElement('div',{className:'detail-body'},d.item.map(function(i){return _react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:20,className:'hrm-over-flow',title:i.title},i.title),_react2.default.createElement(_antd.Col,{span:4,title:i.value},i.value));})));})));}},{key:'getBtns',value:function getBtns(){var btns=[_react2.default.createElement(_antd.Button,{onClick:function onClick(){return console.log("more");}},_i18n.i18n.button.more())];return btns;}},{key:'render',value:function render(){var _this8=this;var hrmChecking=this.props.hrmChecking;var getStatusList=hrmChecking.getStatusList,statusActiveType=hrmChecking.statusActiveType,tabDatas=hrmChecking.tabDatas,tabkey=hrmChecking.tabkey,dateTabDatas=hrmChecking.dateTabDatas,dateTabkey=hrmChecking.dateTabkey,pDate=hrmChecking.pDate,hasRight=hrmChecking.hasRight,leftTitle=hrmChecking.leftTitle,hrmName=hrmChecking.hrmName,loading=hrmChecking.loading,newVisible=hrmChecking.newVisible,visible=hrmChecking.visible,table=hrmChecking.table,setDialogHeight=hrmChecking.setDialogHeight,kqDetailDialogHeight=hrmChecking.kqDetailDialogHeight;var newWorklist=hrmChecking.newWorklist;newWorklist=toJS(newWorklist);var statusList=getStatusList();var query=this.props.location.query;var getMsg=function getMsg(name){var content=getLabel('386475',"您无权查看 {params} 的考勤数据！").replace('{params}',name);return content;};return _react2.default.createElement('div',{className:'attendence-checking'},_react2.default.createElement(_ecCom.WeaPopoverHrm,null),_react2.default.createElement(_ecCom.WeaDialog,{visible:visible,onCancel:function onCancel(){return hrmChecking.updateVisible(false);},closable:true,style:{width:900,height:500},title:getLabel('386477',"考勤明细"),icon:'icon-coms-hrm',iconBgcolor:'#217346',moreBtn:{datas:[]},onChangeHeight:function onChangeHeight(h){return setDialogHeight(h);}},_react2.default.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true,scroll:{y:kqDetailDialogHeight-80},onOperatesClick:this.onOperatesClick.bind(this)})),_react2.default.createElement(_ecCom.WeaDialog,{visible:newVisible,className:'new-hrm-workflow',onCancel:function onCancel(){return hrmChecking.updateNewVisible(false);},closable:true,style:{width:600,height:400},title:getLabel('385037',"新建考勤流程"),icon:'icon-portal-workflow',iconBgcolor:'#0079de'},_react2.default.createElement('div',{className:'new-hrm-workflow-body'},_react2.default.createElement('div',{className:'new-hrm-workflow-wrapper'},_react2.default.createElement('div',{className:'hearder'},_react2.default.createElement('i',{className:'icon-coms-hrm'}),getLabel('15882',"人事管理"),_react2.default.createElement('span',null,'('),newWorklist.length,_react2.default.createElement('span',null,')')),_react2.default.createElement(_ecCom.WeaNewScroll,{height:270},!(0,_isEmpty2.default)(newWorklist)&&newWorklist.map(function(item){return _react2.default.createElement('div',{className:'cursor-pointer item',onClick:function onClick(){hrmChecking.handlerNewWorkflow(item);}},item.title);}))))),_react2.default.createElement(_antd.Spin,{spining:loading},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu()},_react2.default.createElement('div',{style:query.fromcard?{display:'none'}:{display:''}},_react2.default.createElement(_ecCom.WeaTop,{title:''+(hrmName||'\''+getLabel('130758',"我")+'\'')+getLabel('125404',"的考勤"),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu()})),this.renderLeft(),_react2.default.createElement('div',{style:{width:'100%',paddingLeft:221}},_react2.default.createElement(_ecCom.WeaTab,{selectedKey:tabkey,keyParam:'key',datas:[{title:getLabel('16558',"考勤统计"),key:"1"},{title:getLabel('386476',"考勤日历"),key:"2"}],onChange:this.changeTab.bind(this)}),_react2.default.createElement('div',{className:'picker-wrapper checking icon-cls'},_react2.default.createElement('div',{style:{width:140,paddingLeft:10,display:'none'},className:'text-overflow',title:hrmName},leftTitle,'\xA0:\xA0\xA0',hrmName),[{title:_i18n.i18n.label.year(),key:"1"},{title:_i18n.i18n.label.month(),key:"2"}].map(function(item){return _react2.default.createElement('div',{span:1,onClick:_this8.changeDateTab.bind(_this8,item.key),className:'cursor-pointer date-item '+(item.key===dateTabkey?'active':'')},item.title);}),_react2.default.createElement('div',{style:{marginLeft:window.e9_locale.userLanguage===8&&5}},_react2.default.createElement(_ecCom.WeaDatePicker,{arrow:true,type:dateTabkey=='1'?'year':'month',date:pDate,onChange:this.changeDate.bind(this)})),_react2.default.createElement('span',{className:'icon-coms-Refresh cursor-pointer',style:{marginLeft:5},onClick:this.reFresh.bind(this)}),tabkey=='2'&&_react2.default.createElement('div',{className:'status-info clearfix',style:{maxWidth:tabkey==2?window.innerWidth-700:window.innerWidth-900,float:'right'}},statusList&&statusList.map(function(item){return _react2.default.createElement('span',{className:'item cursor-pointer '+(item.type==statusActiveType?'active':''),onClick:function onClick(){return _this8.handlerStatusClick(item);},title:item.title},_react2.default.createElement('i',{className:''+item.icon,style:{color:item.color}},_react2.default.createElement('span',{className:'path1'}),_react2.default.createElement('span',{className:'path2'}),_react2.default.createElement('span',{className:'path3'}),_react2.default.createElement('span',{className:'path4'})),_react2.default.createElement('span',{className:'name',title:item.name},item.name));}))),_react2.default.createElement(_ecCom.WeaNewScroll,{height:window.innerHeight-153-65,className:'bt'},!hasRight&&_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',null,getMsg(hrmName))),hasRight&&_react2.default.createElement('div',{className:'hrm-checking-content icon-cls'},tabkey=='1'&&this.renderStatistics(),tabkey=='2'&&this.renderCalendar()))))),_react2.default.createElement(_Dialog2.default,{store:hrmChecking}));}}]);return main;}(_react2.default.Component))||_class)||_class);//窗口大小变化
jQuery(window).resize(function(){if(__this){__this.setState({iWidth:window.innerWidth});}});exports.default=main;

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(93);
__webpack_require__(467);
module.exports = __webpack_require__(20).Array.from;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(53);
var $export = __webpack_require__(31);
var toObject = __webpack_require__(62);
var call = __webpack_require__(248);
var isArrayIter = __webpack_require__(249);
var toLength = __webpack_require__(88);
var createProperty = __webpack_require__(468);
var getIterFn = __webpack_require__(193);

$export($export.S + $export.F * !__webpack_require__(250)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(39);
var createDesc = __webpack_require__(58);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _ecCom=__webpack_require__(0);var _mobxReact=__webpack_require__(7);var _AbsenceBrief=__webpack_require__(470);var _AbsenceBrief2=_interopRequireDefault(_AbsenceBrief);var _Type=__webpack_require__(471);var _Type2=_interopRequireDefault(_Type);var _Timeline=__webpack_require__(472);var _Timeline2=_interopRequireDefault(_Timeline);var _learn=__webpack_require__(474);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Dialog=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Dialog,_React$Component);function Dialog(props){(0,_classCallCheck3.default)(this,Dialog);return(0,_possibleConstructorReturn3.default)(this,(Dialog.__proto__||(0,_getPrototypeOf2.default)(Dialog)).call(this,props));}(0,_createClass3.default)(Dialog,[{key:'render',value:function render(){var store=this.props.store,ABSENCEDIALOG=store.ABSENCEDIALOG,absenceDialog=store.absenceDialog,absenceDetail=store.absenceDetail,dialogHeight=store.dialogHeight,absenceDay=absenceDetail.absenceDay,types=absenceDetail.types,details=absenceDetail.details,loading=absenceDialog.loading;var c=void 0;if(loading){c=React.createElement(_learn.Loading,null);}else{c=React.createElement('div',{className:'absence'},React.createElement(_AbsenceBrief2.default,{absenceDay:absenceDay}),React.createElement(_Type2.default,{types:types}),React.createElement(_Timeline2.default,{details:details,scrollY:dialogHeight}));}return React.createElement(_ecCom.WeaDialog,(0,_extends3.default)({},ABSENCEDIALOG,absenceDialog),c);}}]);return Dialog;}(React.Component))||_class;exports.default=Dialog;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var AbsenceBrief=function(_React$Component){(0,_inherits3.default)(AbsenceBrief,_React$Component);function AbsenceBrief(props){(0,_classCallCheck3.default)(this,AbsenceBrief);return(0,_possibleConstructorReturn3.default)(this,(AbsenceBrief.__proto__||(0,_getPrototypeOf2.default)(AbsenceBrief)).call(this,props));}(0,_createClass3.default)(AbsenceBrief,[{key:'render',value:function render(){var absenceDay=this.props.absenceDay;return React.createElement('div',{className:'brief'},React.createElement('div',{className:'value'},getLabel('506345','未出勤')+' '+absenceDay+' '+getLabel('503882','天')));}}]);return AbsenceBrief;}(React.Component);exports.default=AbsenceBrief;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Type=function(_React$Component){(0,_inherits3.default)(Type,_React$Component);function Type(props){(0,_classCallCheck3.default)(this,Type);return(0,_possibleConstructorReturn3.default)(this,(Type.__proto__||(0,_getPrototypeOf2.default)(Type)).call(this,props));}(0,_createClass3.default)(Type,[{key:'render',value:function render(){var types=this.props.types;return React.createElement('div',{className:'types'},types.map(function(type){var bgcolor=type.bgcolor,value=type.value;return React.createElement('div',{className:'type'},React.createElement('div',{style:{backgroundColor:bgcolor},className:'label'}),React.createElement('div',{className:'value'},value));}));}}]);return Type;}(React.Component);exports.default=Type;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _Detail=__webpack_require__(473);var _Detail2=_interopRequireDefault(_Detail);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Line=function(_React$Component){(0,_inherits3.default)(Line,_React$Component);function Line(props){(0,_classCallCheck3.default)(this,Line);return(0,_possibleConstructorReturn3.default)(this,(Line.__proto__||(0,_getPrototypeOf2.default)(Line)).call(this,props));}(0,_createClass3.default)(Line,[{key:'render',value:function render(){var _props=this.props,details=_props.details,scrollY=_props.scrollY;return React.createElement('div',{className:'chart'},React.createElement(_ecCom.WeaNewScroll,{height:scrollY-110},React.createElement('div',{className:'timeline'},React.createElement(_antd.Timeline,null,details.map(function(detail){return React.createElement(_antd.Timeline.Item,null,React.createElement(_Detail2.default,{detail:detail}));})))));}}]);return Line;}(React.Component);exports.default=Line;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Detail=function(_React$Component){(0,_inherits3.default)(Detail,_React$Component);function Detail(props){(0,_classCallCheck3.default)(this,Detail);var _this=(0,_possibleConstructorReturn3.default)(this,(Detail.__proto__||(0,_getPrototypeOf2.default)(Detail)).call(this,props));_this.calKd=function(times){var kds=[];times.forEach(function(time){var a=time.split('-');//['09:00','12:00']
var p=_this.calZb(a[0],a[1]);//0.125
var kd=_this.baseKd*p;kds.push(kd);});return kds;};_this.calZb=function(start,end){var s=start.split(':');//['09','00']
var e=end.split(':');//['12','00']
var a=parseInt(e[0])-parseInt(s[0]);//3
var b=parseInt(e[1])-parseInt(s[1]);//0
var p=(a*60+b)/(24*60);//0.125
return p;};_this.calPyl=function(times){var pyls=[];times.forEach(function(time){var a=time.split('-');//['09:00','12:00']
var s=a[0].split(':');//['09','00']
var t=parseInt(s[0])*60+parseInt(s[1]);//540
var pyl=t/(24*60)*_this.baseKd;//283.5
pyls.push(pyl);});return pyls;};_this.calSjd=function(kds,pyls,times){//开始时刻
var start={dot:'00:00',pyl:0};//结束时刻
var end={dot:'23:59',pyl:_this.baseKd-32};return[start,end];//时间点容器
var moments=[];//收集时间点
times.map(function(time){//['09:00','12:00']
time.split('-').map(function(moment){moments.push(moment);});});//时间点、相应偏移量容器
var dots=[];//收集时间点和时间点的偏移量
//moments：['09:00','12:00','13:00','18:00']
moments.map(function(moment,index){var o={dot:moment};if(index%2===0){//奇数位：['09:00','13:00']
(0,_assign2.default)(o,{pyl:pyls[index/2]-16});}else{//偶数位：['12:00','18:00']
(0,_assign2.default)(o,{pyl:pyls[(index-1)/2]+kds[(index-1)/2]-16});}dots.push(o);});dots.unshift(start);dots.push(end);return dots;};_this.calAllAbs=function(absences){var all='';//整合后的时间段
var p=[];absences.forEach(function(abs){if(!all){//all = ''
all=abs;}else{//all = '09:00-10:00'
if(_this.isClose(all,abs)){//'09:00-10:00','10:00-15:00'
var c=_this.combine(all,abs);all=c;//'09:00-15:00'
}else{//'09:00-10:00','13:00-15:00'
p.push(all);all=abs;}}});//all:'16:00-18:00'
//p:['09:00-10:00','13:00-15:00']
p.push(all);var kds=_this.calKd(p);var pyls=_this.calPyl(p);return{kds:kds,pyls:pyls,p:p};};_this.isClose=function(period,nextPeriod){var m=period.split('-');//['13:00','15:30']
var nm=nextPeriod.split('-');//['14:30','18:00']
var e=m[1];//'15:30'
var s=nm[0];//'14:30'
var eh=e.split(':');//['15':'30']
var sh=s.split(':');//['14':'30']
var ehs=parseInt(eh[0]);//15
var ehe=parseInt(eh[1]);//30
var shs=parseInt(sh[0]);//14
var she=parseInt(sh[1]);//30
if(shs<ehs){return true;}if(shs===ehs&&she<ehe){return true;}return false;};_this.combine=function(period,nextPeriod){var m=period.split('-');//['13:00','15:30']
var nm=nextPeriod.split('-');//['14:30','18:00']
var p=m[0]+'-'+nm[1];//'13:00-18:00'
return p;};_this.calRestPeriods=function(sclTime){var raw=[];var restPeriods=[];var str='';sclTime.forEach(function(time){time.split('-').forEach(function(dot){raw.push(dot);});});var arr=raw.slice(1,raw.length-1);arr.forEach(function(dot,index){if(index%2===0){str=dot;}else{str=str+'-'+dot;restPeriods.push(str);}});return restPeriods;};_this.baseKd=756;//基础宽度
return _this;}//计算宽度
//参数的数据格式为:['09:00-12:00','13:00-18:00']
//计算占比
//参数的数据格式为：'09:00','12:00'
//计算偏移量
//参数的数据格式为:['09:00-12:00','13:00-18:00']
//计算时刻
//整合缺勤时间段,返回缺勤时间段的宽度和偏移量
//absences：缺勤时间段。数据格式:['09:00-10:00','13:00-15:00','16:00-18:00']
//判断两个时间段是否重合
//合并时间段
//计算休息时间段
(0,_createClass3.default)(Detail,[{key:'render',value:function render(){var detail=this.props.detail,day=detail.day,date=detail.date,sclTime=detail.sclTime,absTime=detail.absTime;//排班时段宽度
var sclKds=this.calKd(sclTime);//排班时段偏移量
var sclPyls=this.calPyl(sclTime);//休息时段宽度
var restKds=sclKds.map(function(kd,index){return sclPyls[index+1]-(sclPyls[index]+sclKds[index]);});//休息时段偏移量
var restPyls=sclKds.map(function(kd,index){return sclPyls[index]+sclKds[index];});//从缺勤数据中提炼出时间数据
var pureTime=absTime.map(function(t){return t.time;});//缺勤时间段宽度
var absKds=this.calKd(pureTime);//缺勤时间段偏移量
var absPyls=this.calPyl(pureTime);//时间点
var timeDots=this.calSjd(sclKds,sclPyls,sclTime);//整合后的缺勤时间段的宽度和偏移量
var absAll=this.calAllAbs(pureTime);//计算休息时间段
var restPeriods=this.calRestPeriods(sclTime);return React.createElement('div',{className:'detail'},React.createElement('div',{className:'day'},''+day+getLabel('503882','天')),React.createElement('div',{className:'date'},date),React.createElement('div',null,React.createElement('div',{className:'scale'},absTime.map(function(time,index){var bgColor=time.bgColor;var tips=absTime[index].tips;return React.createElement(_antd.Tooltip,{title:tips&&React.createElement('ul',null,tips.map(function(tip){return React.createElement('li',{dangerouslySetInnerHTML:{__html:tip}});}))},React.createElement('div',{className:'abs',style:{backgroundColor:bgColor,width:absKds[index],marginLeft:absPyls[index]}}));}),restKds.map(function(restKd,index){return React.createElement(_antd.Tooltip,{placement:'bottom',title:getLabel(505603,'休息时间')+': '+restPeriods[index]},React.createElement('div',{className:'rest',style:{width:restKd,marginLeft:restPyls[index]}}));}),sclKds.map(function(kd,index){return React.createElement(_antd.Tooltip,{placement:'bottom',title:getLabel(505592,'上班时间')+': '+sclTime[index]},React.createElement('div',{className:'scl',style:{width:kd,marginLeft:sclPyls[index]}}));}),React.createElement('div',{className:'base'})),React.createElement('div',{className:'moments'},timeDots.map(function(item){var dot=item.dot,pyl=item.pyl;return React.createElement('span',{style:{left:pyl},className:'moment'},dot);}))));}}]);return Detail;}(React.Component);exports.default=Detail;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Tip=exports.LeftTree=exports.Icon=exports.Loading=exports.NoData=exports.AlertPage=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var AlertPage=function(_React$Component){(0,_inherits3.default)(AlertPage,_React$Component);function AlertPage(){(0,_classCallCheck3.default)(this,AlertPage);return(0,_possibleConstructorReturn3.default)(this,(AlertPage.__proto__||(0,_getPrototypeOf2.default)(AlertPage)).apply(this,arguments));}(0,_createClass3.default)(AlertPage,[{key:'render',value:function render(){return _react2.default.createElement('div',{style:{height:'100%'}},_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},getLabel(2012,'对不起，您暂时没有权限！'))));}}]);return AlertPage;}(_react2.default.Component);var NoData=function(_React$Component2){(0,_inherits3.default)(NoData,_React$Component2);function NoData(){(0,_classCallCheck3.default)(this,NoData);return(0,_possibleConstructorReturn3.default)(this,(NoData.__proto__||(0,_getPrototypeOf2.default)(NoData)).apply(this,arguments));}(0,_createClass3.default)(NoData,[{key:'render',value:function render(){var _props=this.props,_props$className=_props.className,className=_props$className===undefined?'icon-coms-NoData':_props$className,_props$tip=_props.tip,tip=_props$tip===undefined?getLabel('83553',"暂无数据！"):_props$tip;return _react2.default.createElement('div',{style:{position:'absolute',top:'50%',left:'50%',marginTop:-45,marginLeft:-45,width:90}},_react2.default.createElement('i',{className:className,style:{fontSize:90}}),_react2.default.createElement('p',{style:{textAlign:'center',fontSize:14,padding:5}},tip));}}]);return NoData;}(_react2.default.Component);var Loading=function(_React$Component3){(0,_inherits3.default)(Loading,_React$Component3);function Loading(props){(0,_classCallCheck3.default)(this,Loading);return(0,_possibleConstructorReturn3.default)(this,(Loading.__proto__||(0,_getPrototypeOf2.default)(Loading)).call(this,props));}(0,_createClass3.default)(Loading,[{key:'render',value:function render(){var size=this.props.size;var style={position:'absolute',top:'50%',left:'50%',marginLeft:size==='lg'?-16:-8,marginTop:size==='lg'?-16:-8};return _react2.default.createElement('div',{style:style},_react2.default.createElement(_antd.Spin,{spinning:true,size:size==='lg'?'large':''}));}}]);return Loading;}(_react2.default.Component);//Icon组件参数：bgColor(背景色)必填，shape(形状)、pixel(像素)选填，默认为正方形和10px,
//onIconClick为图标点击的回调函数，回调的值为图标的状态值：0和1。0 -> 关闭，1 -> 开启。
//当不传onIconClick参数时，点击图标没有变化。
var Icon=function(_React$Component4){(0,_inherits3.default)(Icon,_React$Component4);function Icon(props){(0,_classCallCheck3.default)(this,Icon);var _this4=(0,_possibleConstructorReturn3.default)(this,(Icon.__proto__||(0,_getPrototypeOf2.default)(Icon)).call(this,props));_this4.handleClick=function(){var iconState=_this4.props.iconState;//当父组件没有传onIconClick参数时，不处理这个点击事件。
if(!_this4.props.onIconClick){return;}//将图标的状态通过回调函数传回到父组件
_this4.props.onIconClick(iconState===0?1:0);};return _this4;}(0,_createClass3.default)(Icon,[{key:'render',value:function render(){var _props2=this.props,iconState=_props2.iconState,bgColor=_props2.bgColor,className=_props2.className,_props2$shape=_props2.shape,shape=_props2$shape===undefined?'square':_props2$shape,_props2$pixel=_props2.pixel,pixel=_props2$pixel===undefined?10:_props2$pixel;var style={backgroundColor:iconState===1?bgColor:'#C0C0C0',//图标开启时，使用bgColor作为背景色；当为关闭的状态，则将背景色置为灰色。
width:pixel,height:pixel,cursor:'pointer'};if(shape==='circle'){//图标为圆形的情况
(0,_assign2.default)(style,{borderRadius:'50%'});}return _react2.default.createElement('div',{style:style,className:iconState===1&&className,onClick:this.handleClick});}}]);return Icon;}(_react2.default.Component);var LeftTree=function(_React$Component5){(0,_inherits3.default)(LeftTree,_React$Component5);function LeftTree(props){(0,_classCallCheck3.default)(this,LeftTree);var _this5=(0,_possibleConstructorReturn3.default)(this,(LeftTree.__proto__||(0,_getPrototypeOf2.default)(LeftTree)).call(this,props));_this5.init=function(){if(_this5.tree)_this5.tree.reset(function(){return _this5.tree.fetchData();});};_this5.handleOrgTreeNodeClick=function(event,ids,nodeids,nodes){var handleOrgTreeNodeClick=_this5.props.handleOrgTreeNodeClick;var _nodes$=nodes[0],type=_nodes$.type,name=_nodes$.name;handleOrgTreeNodeClick({id:ids[0],type:type,name:name});};_this5.tree=null;_this5.setRef=function(element){_this5.tree=element;};return _this5;}(0,_createClass3.default)(LeftTree,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.triggerRefresh!==nextProps.triggerRefresh){this.init();}}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'render',value:function render(){var _this6=this;var title=this.props.title;return _react2.default.createElement('div',{style:{height:'100%'}},_react2.default.createElement(_ecCom.WeaOrgTree,(0,_extends3.default)({},this.props,{ref:this.setRef,needSearch:true,noCache:true,isLoadAllSub:true,inputLeftDom:'<b>'+title+'</b>',treeNodeClick:function treeNodeClick(event,ids,nodeids,nodes){return _this6.handleOrgTreeNodeClick(event,ids,nodeids,nodes);}})));}}]);return LeftTree;}(_react2.default.Component);var Tip=function(_React$Component6){(0,_inherits3.default)(Tip,_React$Component6);function Tip(props){(0,_classCallCheck3.default)(this,Tip);return(0,_possibleConstructorReturn3.default)(this,(Tip.__proto__||(0,_getPrototypeOf2.default)(Tip)).call(this,props));}(0,_createClass3.default)(Tip,[{key:'render',value:function render(){var _props3=this.props,tip=_props3.tip,icon=_props3.icon;return _react2.default.createElement('div',{style:{position:'absolute',width:600,top:'42%',left:'50%',marginLeft:-300,textAlign:'center'}},_react2.default.createElement('i',{className:icon,style:{fontSize:80,color:'#D9D9D9'}}),_react2.default.createElement('p',{style:{padding:10}},tip));}}]);return Tip;}(_react2.default.Component);exports.AlertPage=AlertPage;exports.NoData=NoData;exports.Loading=Loading;exports.Icon=Icon;exports.LeftTree=LeftTree;exports.Tip=Tip;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _comsMobx=__webpack_require__(10);__webpack_require__(476);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var confirm=_antd.Modal.confirm;var AddGroup=(_dec=(0,_mobxReact.inject)('hrmAddGroup'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(AddGroup,_React$Component);function AddGroup(props){(0,_classCallCheck3.default)(this,AddGroup);return(0,_possibleConstructorReturn3.default)(this,(AddGroup.__proto__||(0,_getPrototypeOf2.default)(AddGroup)).call(this,props));}(0,_createClass3.default)(AddGroup,[{key:'componentDidMount',value:function componentDidMount(){var hrmAddGroup=this.props.hrmAddGroup;var hrmId=this.props.params.hrmId||'';hrmAddGroup.setHrmId(hrmId);hrmAddGroup.getForm();hrmAddGroup.getTableInfo();}},{key:'getComponents',value:function getComponents(condition,form,isLinkage){var arr=[];var formParams=form.getFormParams();var isFormInit=form.isFormInit;isFormInit&&condition.map(function(c){var items=c.items;for(var i=0;i<items.length;i++){var field=items[i];arr.push(_react2.default.createElement(_ecCom.WeaFormItem,{labelCol:{span:0}},_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:formParams})));}});return arr;}},{key:'getGroup',value:function getGroup(columns,dataSource,arg){var _this3=this;var hrmAddGroup=this.props.hrmAddGroup;var key=hrmAddGroup.key,authority=hrmAddGroup.authority;var arr=[];if(columns&&columns.length>0){arr.push(_react2.default.createElement('li',{style:arg=='2'?{backgroundColor:'#68A0F5',color:'#fff'}:{backgroundColor:'#75D6E7',color:'#fff'},className:'hrm-group-li'},columns[0].title));}if(dataSource&&dataSource.length>0){var _loop=function _loop(i){arr.push(_react2.default.createElement('li',{style:{position:'relative'},className:'hrm-group-li',onMouseEnter:function onMouseEnter(){return _this3.handleMouseOver(dataSource[i].key);},onMouseLeave:function onMouseLeave(){return _this3.handleMouseLeave();}},dataSource[i].groupname,arg=='1'&&key==dataSource[i].key||arg=='2'&&authority&&key==dataSource[i].key?_react2.default.createElement('span',{style:{position:'absolute',left:190,top:7}},_react2.default.createElement('a',{onClick:function onClick(){return _this3.del(dataSource[i].key,dataSource,arg);},className:'icon-coms-delete'})):''));};for(var i=0;i<dataSource.length;i++){_loop(i);}}if(!dataSource||dataSource.length==0){arr.push(_react2.default.createElement('li',{style:{height:158,paddingTop:50},className:'hrm-group-li'},_react2.default.createElement('div',{style:{width:'100%',fontSize:30}},_react2.default.createElement('i',{className:'icon-coms-NoData'})),_react2.default.createElement('div',null,_i18n.i18n.label.dataNone())));}return _react2.default.createElement('ul',{className:'hrm-group-ul'},arr);}},{key:'handleMouseOver',value:function handleMouseOver(key){var hrmAddGroup=this.props.hrmAddGroup;hrmAddGroup.setKey(key);}},{key:'handleMouseLeave',value:function handleMouseLeave(){var hrmAddGroup=this.props.hrmAddGroup;hrmAddGroup.setKey('');}},{key:'del',value:function del(groupid,dataSource,arg){var hrmAddGroup=this.props.hrmAddGroup;hrmAddGroup.setGroupId(groupid);this.showConfirm(groupid,dataSource,arg,hrmAddGroup);}},{key:'getIndex',value:function getIndex(key,dataSource){var arr=[];if(dataSource instanceof Array){for(var i=0;i<dataSource.length;i++){arr.push(dataSource[i].key);}}return arr.indexOf(key);}},{key:'showConfirm',value:function showConfirm(groupid,dataSource,arg,hrmAddGroup){var _this=this;confirm({title:_i18n.i18n.confirm.defaultTitle(),content:_i18n.i18n.confirm.deleteSelected(),okText:_i18n.i18n.button.ok(),cancelText:_i18n.i18n.button.cancel(),onOk:function onOk(){dataSource.splice(_this.getIndex(groupid,dataSource),1);if(arg=='1')hrmAddGroup.setDataSource('1',dataSource);if(arg=='2')hrmAddGroup.setDataSource('2',dataSource);hrmAddGroup.delete();},onCancel:function onCancel(){return false;}});}},{key:'render',value:function render(){var hrmAddGroup=this.props.hrmAddGroup;var condition=hrmAddGroup.condition,form=hrmAddGroup.form,btnName1=hrmAddGroup.btnName1,btnName2=hrmAddGroup.btnName2,title=hrmAddGroup.title;var columns1=hrmAddGroup.columns1,dataSource1=hrmAddGroup.dataSource1,columns2=hrmAddGroup.columns2,dataSource2=hrmAddGroup.dataSource2;return _react2.default.createElement('div',{className:'hrm-group-title'},_react2.default.createElement('div',{style:{paddingLeft:25,paddingBottom:45,paddingTop:20}},_react2.default.createElement('div',{style:{width:582,float:'left'}},this.getComponents(condition,form,false)),_react2.default.createElement('div',{style:{float:'left',marginLeft:16}},_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmAddGroup.add();}},btnName1)),_react2.default.createElement('div',{style:{float:'left',marginLeft:16}},_react2.default.createElement('a',{href:'/spa/hrm/index_mobx.html#/main/hrm/group',target:'_blank'},_react2.default.createElement(_antd.Button,null,btnName2)))),_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:title,showGroup:true},_react2.default.createElement('div',null,_react2.default.createElement('div',{style:{float:'left'}},this.getGroup(toJS(columns2),toJS(dataSource2),'2')),_react2.default.createElement('div',{style:{float:'left',marginLeft:16}},this.getGroup(toJS(columns1),toJS(dataSource1),'1')))));}}]);return AddGroup;}(_react2.default.Component))||_class)||_class);exports.default=AddGroup;

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _RadioGroupWrapper=__webpack_require__(478);var _RadioGroupWrapper2=_interopRequireDefault(_RadioGroupWrapper);var _ReportChart=__webpack_require__(479);var _ReportChart2=_interopRequireDefault(_ReportChart);var _DataStatistics=__webpack_require__(480);var _DataStatistics2=_interopRequireDefault(_DataStatistics);var _More=__webpack_require__(252);var _More2=_interopRequireDefault(_More);__webpack_require__(253);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var TabPane=_antd.Tabs.TabPane;var BasicConditionAnalysis=(_dec=(0,_mobxReact.inject)('hrmPerStatusReport'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(BasicConditionAnalysis,_React$Component);function BasicConditionAnalysis(props){(0,_classCallCheck3.default)(this,BasicConditionAnalysis);return(0,_possibleConstructorReturn3.default)(this,(BasicConditionAnalysis.__proto__||(0,_getPrototypeOf2.default)(BasicConditionAnalysis)).call(this,props));}(0,_createClass3.default)(BasicConditionAnalysis,[{key:'componentWillMount',value:function componentWillMount(){this.pre();}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmPerStatusReport=this.props.hrmPerStatusReport;if(this.props.location.key!==nextProps.location.key){this.pre(nextProps);hrmPerStatusReport.optionReset();hrmPerStatusReport.conditionReset();hrmPerStatusReport.paramReset();hrmPerStatusReport.apiFinishedStatusReset();hrmPerStatusReport.getSearchCondition();hrmPerStatusReport.tabKeyReset();this.refs.page.click();this.init();}}},{key:'pre',value:function pre(nextProps){var hrmPerStatusReport=this.props.hrmPerStatusReport;var pathname=void 0;if(!nextProps){pathname=this.props.location.pathname.split('/').pop();}else{pathname=nextProps.location.pathname.split('/').pop();}hrmPerStatusReport.optionReset();hrmPerStatusReport.setPathName(pathname);hrmPerStatusReport.pathToTitle();hrmPerStatusReport.getCurWindowWidth();}},{key:'init',value:function init(){var hrmPerStatusReport=this.props.hrmPerStatusReport;var pathname=hrmPerStatusReport.pathname;hrmPerStatusReport.setKey('1');if(pathname!=='basicConditionAnalysis')hrmPerStatusReport.setIntervalShow(false);}},{key:'getTabPanes',value:function getTabPanes(){var hrmPerStatusReport=this.props.hrmPerStatusReport;var tabKey=hrmPerStatusReport.tabKey;return _react2.default.createElement('div',{style:{margin:'8px 16px'}},_react2.default.createElement(_antd.Tabs,{activeKey:tabKey,onTabClick:function onTabClick(key){hrmPerStatusReport.setKey(key);hrmPerStatusReport.getData();},type:'card'},_react2.default.createElement(TabPane,{tab:_i18n.i18n.label.ageStatus(),key:'1'}),_react2.default.createElement(TabPane,{tab:_i18n.i18n.label.genderStatus(),key:'2'}),_react2.default.createElement(TabPane,{tab:_i18n.i18n.label.workingAgeStatus(),key:'3'}),_react2.default.createElement(TabPane,{tab:_i18n.i18n.label.eduStatus(),key:'4'}),_react2.default.createElement(TabPane,{tab:_i18n.i18n.label.maritalStatus(),key:'5'}),_react2.default.createElement(TabPane,{tab:_i18n.i18n.label.proTitleStatus(),key:'6'}),_react2.default.createElement(TabPane,{tab:_i18n.i18n.label.rankStatus(),key:'7'}),_react2.default.createElement(TabPane,{tab:_i18n.i18n.label.workNature(),key:'10'}),_react2.default.createElement(TabPane,{tab:_i18n.i18n.label.stateStatistics(),key:'11'}),_react2.default.createElement(TabPane,{tab:_i18n.i18n.label.securtitylevel(),key:'12'})),this.getChart(hrmPerStatusReport.getTabName()));}},{key:'getChart',value:function getChart(tagName){var hrmPerStatusReport=this.props.hrmPerStatusReport;var option1=hrmPerStatusReport.option1,option2=hrmPerStatusReport.option2,isIntervalShow=hrmPerStatusReport.isIntervalShow,interval=hrmPerStatusReport.interval,tabKey=hrmPerStatusReport.tabKey,pathname=hrmPerStatusReport.pathname,chartTitle1=hrmPerStatusReport.chartTitle1,chartTitle2=hrmPerStatusReport.chartTitle2,isEchartsShow=hrmPerStatusReport.isEchartsShow,isLeftEchartsShow=hrmPerStatusReport.isLeftEchartsShow,isRightEchartsShow=hrmPerStatusReport.isRightEchartsShow,ids=hrmPerStatusReport.ids,yAxisData=hrmPerStatusReport.yAxisData,linkList=hrmPerStatusReport.linkList,winWidth=hrmPerStatusReport.winWidth;return _react2.default.createElement(_ReportChart2.default,{option:[toJS(option1),toJS(option2)],isIntervalShow:isIntervalShow,interval:interval,tabKey:tabKey,pathname:pathname,chartTitle:[typeof chartTitle1=='function'?chartTitle1()+'(Top5)':chartTitle1,typeof chartTitle2=='function'?chartTitle2()+'(Top5)':chartTitle2],isChartsShow:[isEchartsShow,isLeftEchartsShow,isRightEchartsShow],ids:toJS(ids),yAxisData:toJS(yAxisData),linkList:linkList,tagName:tagName,winWidth:winWidth,setGap:function setGap(val){return hrmPerStatusReport.setGap(val);},getData:function getData(tag){return hrmPerStatusReport.getData(tag);}});}},{key:'getDeadline',value:function getDeadline(){var hrmPerStatusReport=this.props.hrmPerStatusReport;var deadline=hrmPerStatusReport.deadline;return _react2.default.createElement('div',{style:{color:'#989898',marginTop:4,marginRight:16}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,_react2.default.createElement('p',{style:{textAlign:'right'}},deadline))));}},{key:'search',value:function search(v){var hrmPerStatusReport=this.props.hrmPerStatusReport;hrmPerStatusReport.setSearchCondition(v);hrmPerStatusReport.getData('search');}},{key:'handleMenuClick',value:function handleMenuClick(key){if(key=='0')this.refs.a.click();}},{key:'render',value:function render(){var _this2=this;var hrmPerStatusReport=this.props.hrmPerStatusReport;var title=hrmPerStatusReport.title,pathname=hrmPerStatusReport.pathname,countDatas=hrmPerStatusReport.countDatas,visible=hrmPerStatusReport.visible,tableStore=hrmPerStatusReport.tableStore,strokeColor=hrmPerStatusReport.strokeColor,href=hrmPerStatusReport.href,paramsStr=hrmPerStatusReport.paramsStr,isApiOneFinished=hrmPerStatusReport.isApiOneFinished,isApiTwoFinished=hrmPerStatusReport.isApiTwoFinished;var btn=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this2.refs.a.click();}},_react2.default.createElement('a',{ref:'a',href:pathname=='departmentStatistics'?'/api/hrm/resourceState/downloadExcel?cmd=DepartmentRp'+paramsStr:'/api/hrm/resourceState/downloadExcel?cmd=JobRp'+paramsStr},_i18n.i18n.button.export1())),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this2.refs.a1.click();}},_react2.default.createElement('a',{href:href,ref:'a1'},_i18n.i18n.button.export())),_react2.default.createElement(_ecCom.WeaMoreButton,null)];var btn1=btn.slice(0,1);var btn2=btn.slice(1,3);var dropMenuDatas=[{key:'0',content:_i18n.i18n.button.export1(),icon:_react2.default.createElement('i',{className:'icon-coms-leading-in'})},{key:'1',content:_i18n.i18n.button.more(),disabled:true,icon:_react2.default.createElement('i',{className:'icon-coms-task-list'})}];var dropMenuDatas1=dropMenuDatas.slice(0,1);var dropMenuDatas2=dropMenuDatas.slice(1,2);return _react2.default.createElement(_antd.Spin,{spinning:!(isApiOneFinished&&isApiTwoFinished)},_react2.default.createElement('div',{style:{backgroundColor:'#fff'},ref:'page'},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:pathname=='departmentStatistics'||pathname=='postStatistics'?dropMenuDatas1:dropMenuDatas2,onClick:function onClick(e){return _this2.handleMenuClick(e);},collectParams:{favname:title,favouritetype:5}},_react2.default.createElement(_ecCom.WeaTop,{title:title,icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',loading:true,buttons:pathname=='departmentStatistics'||pathname=='postStatistics'?btn1:[],showDropIcon:true,dropMenuDatas:pathname=='departmentStatistics'||pathname=='postStatistics'?dropMenuDatas1:dropMenuDatas2,onDropMenuClick:function onDropMenuClick(e){return _this2.handleMenuClick(e);}},_react2.default.createElement(_RadioGroupWrapper2.default,null),pathname=='basicConditionAnalysis'?this.getTabPanes():'',pathname!=='basicConditionAnalysis'?_react2.default.createElement(_DataStatistics2.default,{countDatas:toJS(countDatas),pathname:pathname}):'',pathname!=='basicConditionAnalysis'?this.getChart():'',this.getDeadline()),_react2.default.createElement(_More2.default,{title:hrmPerStatusReport.getChartTitle(),visible:visible,buttons:btn2,onCancel:function onCancel(){return hrmPerStatusReport.setVisible(false);},search:function search(v){return _this2.search(v);},tableStore:tableStore,loading:tableStore.loading,strokeColor:'#6FBCEA'}))));}}]);return BasicConditionAnalysis;}(_react2.default.Component))||_class)||_class);exports.default=BasicConditionAnalysis;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var RadioGroupWrapper=(_dec=(0,_mobxReact.inject)('hrmPerStatusReport'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(RadioGroupWrapper,_React$Component);function RadioGroupWrapper(props){(0,_classCallCheck3.default)(this,RadioGroupWrapper);return(0,_possibleConstructorReturn3.default)(this,(RadioGroupWrapper.__proto__||(0,_getPrototypeOf2.default)(RadioGroupWrapper)).call(this,props));}(0,_createClass3.default)(RadioGroupWrapper,[{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'init',value:function init(){var hrmPerStatusReport=this.props.hrmPerStatusReport;hrmPerStatusReport.getSearchCondition();}},{key:'render',value:function render(){var hrmPerStatusReport=this.props.hrmPerStatusReport;var condition1=hrmPerStatusReport.condition1;var arr=toJS(condition1);return _react2.default.createElement('div',{style:{padding:'16px 16px 8px 16px'}},_react2.default.createElement(_ecCom.WeaRadioGroup,{config:arr,onChange:function onChange(params){hrmPerStatusReport.setParams(params);}}));}}]);return RadioGroupWrapper;}(_react2.default.Component))||_class)||_class);exports.default=RadioGroupWrapper;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _pulicFunc=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ReportChart=function(_React$Component){(0,_inherits3.default)(ReportChart,_React$Component);function ReportChart(props){(0,_classCallCheck3.default)(this,ReportChart);return(0,_possibleConstructorReturn3.default)(this,(ReportChart.__proto__||(0,_getPrototypeOf2.default)(ReportChart)).call(this,props));}(0,_createClass3.default)(ReportChart,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.refs.echart)this.refs.echart.paint();if(this.refs.echart1)this.refs.echart1.paint();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.winWidth!==nextProps.winWidth){if(this.refs.echart)this.refs.echart.chart.resize();if(this.refs.echart1)this.refs.echart1.chart.resize();}}},{key:'getDOM',value:function getDOM(interval,key,setGap,getData,isIntervalShow,pathname,tag,isChartsShow,chartTitle){var _this2=this;return _react2.default.createElement('div',{style:{position:'absolute',right:0}},_react2.default.createElement('div',{style:isIntervalShow?{display:'block',float:'left'}:{display:'none'}},_react2.default.createElement('div',{className:'hrm-report-interval'},this.getName(key)+':'),_react2.default.createElement('div',{style:{width:70,paddingTop:8,paddingLeft:0},className:'hrm-report-interval hrm-report-input'},_react2.default.createElement(_ecCom.WeaInput,{type:'text',viewAttr:'2',value:interval,onChange:function onChange(val){return setGap(val);}})),_react2.default.createElement('div',{className:'hrm-report-interval',style:{paddingLeft:0}},this.getSuffix(key)),_react2.default.createElement('div',{className:'hrm-report-interval',style:{fontSize:16}},_react2.default.createElement('a',{onClick:function onClick(){return getData();},className:'hrm-report-linkStyle',title:_i18n.i18n.button.refresh()},_react2.default.createElement('i',{className:'icon-coms-Refresh'})))),_react2.default.createElement('div',{style:pathname!=='basicConditionAnalysis'?{display:'block',float:'left',padding:'10px 0'}:{display:'none'}},_react2.default.createElement('a',{onClick:function onClick(){return getData(tag);},className:'hrm-report-linkStyle'},_i18n.i18n.button.more())),_react2.default.createElement('div',{className:'hrm-report-interval',style:{padding:'8px 20px 10px 10px',fontSize:16}},isChartsShow?_react2.default.createElement('a',{onClick:function onClick(){return _this2.getImgSrc(tag,chartTitle);},className:'hrm-report-linkStyle',title:_i18n.i18n.button.saveAsImage()},_react2.default.createElement('i',{className:'icon-coms-download2'})):_react2.default.createElement('a',{onClick:function onClick(){_antd.message.info(_i18n.i18n.message.dataNone());},className:'hrm-report-linkStyle',title:_i18n.i18n.button.saveAsImage()},_react2.default.createElement('i',{className:'icon-coms-download2'}))));}},{key:'getName',value:function getName(key){switch(key){case'1':return _i18n.i18n.label.ageRange();case'3':return _i18n.i18n.label.workingAgeRange();case'7':return _i18n.i18n.label.rankingInterval();}}},{key:'getSuffix',value:function getSuffix(key){switch(key){case'7':return _i18n.i18n.label.level();default:return _i18n.i18n.label.year();}}},{key:'getImgSrc',value:function getImgSrc(tag,chartTitle){var cvs=document.getElementsByTagName('canvas');if(tag!=='right'){this.downloadCvs2Img(cvs[0],chartTitle);}else{this.downloadCvs2Img(cvs[1],chartTitle);}}},{key:'downloadCvs2Img',value:function downloadCvs2Img(cvs,chartTitle){var $a=document.createElement('a');$a.download=chartTitle+'.jpg';$a.target='_blank';var url=void 0;if(cvs){url=cvs.toDataURL("image/jpg");}else{_antd.message.info(_i18n.i18n.message.dataNone());}if(url)$a.href=url;if(typeof MouseEvent==='function'){var evt=new MouseEvent('click',{view:window,bubbles:true,cancelable:false});$a.dispatchEvent(evt);}else{if(window.navigator.msSaveOrOpenBlob){var bstr=atob(url.split(',')[1]);var n=bstr.length;var u8arr=new Uint8Array(n);while(n--){u8arr[n]=bstr.charCodeAt(n);}var blob=new Blob([u8arr]);window.navigator.msSaveOrOpenBlob(blob,chartTitle+'.jpg');}else{var html=''+'<body style="margin:0;">'+'<img src="'+url+'" style="max-width:100%;" title="" />'+'</body>';var tab=window.open();tab.document.write(html);}}}},{key:'chartAction',value:function chartAction(chart,ids,yAxisData,linkList){var _this3=this;chart.off('click');chart.on('click',function(params){return _this3.handleClick(params,ids,yAxisData,linkList);});}},{key:'handleClick',value:function handleClick(params,ids,yAxisData,linkList){var pathname=this.props.pathname;if(pathname!=='departmentStatistics')return false;var anid=params.event.target.anid;if(!anid){return;}var index=anid.split('_')[1];(0,_pulicFunc.jumpToHrmDept)(ids[index]);}},{key:'render',value:function render(){var _this4=this;var _props=this.props,option=_props.option,isIntervalShow=_props.isIntervalShow,interval=_props.interval,tabKey=_props.tabKey,pathname=_props.pathname,setGap=_props.setGap,getData=_props.getData,chartTitle=_props.chartTitle,isChartsShow=_props.isChartsShow,ids=_props.ids,yAxisData=_props.yAxisData,linkList=_props.linkList,tagName=_props.tagName;return _react2.default.createElement('div',{style:{padding:'8px 16px'}},pathname=='basicConditionAnalysis'?_react2.default.createElement('div',{style:{height:500,position:'relative'}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:24},_react2.default.createElement('div',{style:{height:50}},this.getDOM(interval,tabKey,setGap,getData,isIntervalShow,pathname,pathname,isChartsShow[0],tagName)))),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:24},isChartsShow[0]?_react2.default.createElement('div',{style:{height:400}},_react2.default.createElement(_ecCom.WeaEchart,{ref:'echart',option:option[0],useDefault:false})):_react2.default.createElement('div',{style:{position:'absolute',top:100,left:'50%',marginLeft:-40,textAlign:'center'}},_react2.default.createElement('div',{style:{fontSize:80}},_react2.default.createElement('i',{className:'icon-coms-blank'})),_react2.default.createElement('div',{style:{fontSize:20,color:'#B2B2B2'}},_i18n.i18n.message.dataNone()))))):'',pathname=='departmentStatistics'||pathname=='postStatistics'?_react2.default.createElement('div',{style:{height:350,border:'1px solid #DDD',borderRadius:3}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:24},_react2.default.createElement('div',{style:{height:40,backgroundColor:'#F9F9F9',position:'relative'}},_react2.default.createElement('div',{style:{display:'block',width:'30%',height:'100%',float:'left',padding:'11px 0 12px 16px'}},chartTitle[0]),_react2.default.createElement('div',{style:{height:50}},this.getDOM(interval,tabKey,setGap,getData,isIntervalShow,pathname,pathname,isChartsShow[0],chartTitle[0]))))),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:20,offset:2},isChartsShow[0]?_react2.default.createElement('div',{style:{height:300}},_react2.default.createElement(_ecCom.WeaEchart,{ref:'echart',option:option[0],useDefault:false,chartAction:function chartAction(chart){return _this4.chartAction(chart,ids,yAxisData,linkList);}})):_react2.default.createElement('div',{style:{position:'absolute',top:100,left:'50%',marginLeft:-40,textAlign:'center'}},_react2.default.createElement('div',{style:{fontSize:80}},_react2.default.createElement('i',{className:'icon-coms-blank'})),_react2.default.createElement('div',{style:{fontSize:20,color:'#B2B2B2'}},_i18n.i18n.message.dataNone()))))):'',pathname=='jobStatusStatistics'?_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement('div',{style:{height:350,marginRight:8,border:'1px solid #DDD',borderRadius:3}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,_react2.default.createElement('div',{style:{height:40,backgroundColor:'#F9F9F9',position:'relative'}},_react2.default.createElement('div',{style:{height:'100%',padding:'11px 0 12px 16px',float:'left'}},chartTitle[0]),_react2.default.createElement('div',{style:{height:50}},this.getDOM(interval,tabKey,setGap,getData,isIntervalShow,pathname,'left',isChartsShow[1],chartTitle[0]))))),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,isChartsShow[1]?_react2.default.createElement('div',{style:{height:300}},_react2.default.createElement(_ecCom.WeaEchart,{ref:'echart',option:option[0],useDefault:false})):_react2.default.createElement('div',{style:{position:'absolute',top:100,left:'50%',marginLeft:-20,textAlign:'center'}},_react2.default.createElement('div',{style:{fontSize:50}},_react2.default.createElement('i',{className:'icon-coms-blank'})),_react2.default.createElement('div',{style:{fontSize:15,color:'#B2B2B2'}},_i18n.i18n.message.dataNone())))))),_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement('div',{style:{height:350,marginLeft:8,border:'1px solid #DDD',borderRadius:3}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,_react2.default.createElement('div',{style:{height:40,backgroundColor:'#F9F9F9',position:'relative'}},_react2.default.createElement('div',{style:{height:'100%',padding:'11px 0 12px 16px',float:'left'}},chartTitle[1]),_react2.default.createElement('div',{style:{height:50}},this.getDOM(interval,tabKey,setGap,getData,isIntervalShow,pathname,'right',isChartsShow[2],chartTitle[1]))))),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,isChartsShow[2]?_react2.default.createElement('div',{style:{height:300}},_react2.default.createElement(_ecCom.WeaEchart,{ref:'echart1',option:option[1],useDefault:false})):_react2.default.createElement('div',{style:{position:'absolute',top:100,left:'50%',marginLeft:-20,textAlign:'center'}},_react2.default.createElement('div',{style:{fontSize:50}},_react2.default.createElement('i',{className:'icon-coms-blank'})),_react2.default.createElement('div',{style:{fontSize:15,color:'#B2B2B2'}},_i18n.i18n.message.dataNone()))))))):'');}}]);return ReportChart;}(_react2.default.Component);exports.default=ReportChart;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(6);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DataStatistics=function(_React$Component){(0,_inherits3.default)(DataStatistics,_React$Component);function DataStatistics(props){(0,_classCallCheck3.default)(this,DataStatistics);return(0,_possibleConstructorReturn3.default)(this,(DataStatistics.__proto__||(0,_getPrototypeOf2.default)(DataStatistics)).call(this,props));}(0,_createClass3.default)(DataStatistics,[{key:'getIcon',value:function getIcon(i,pathname){switch(i){case 0:return _react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#00A9FF'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-synergism'})));case 1:return _react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#F67C4C'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-hrm'})));case 2:return _react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:pathname=='departmentStatistics'?{backgroundColor:'#7DC756'}:{backgroundColor:'#AC7CFF'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-meeting'})));case 3:return _react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:pathname=='departmentStatistics'?{backgroundColor:'#F9A825'}:{backgroundColor:'#50D0A3'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-crm'})));default:return _react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#00A9FF'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-synergism'})));}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,countDatas=_props.countDatas,pathname=_props.pathname;return _react2.default.createElement('div',{style:{margin:'8px 16px',height:120,border:'1px solid #DDD',borderRadius:3}},countDatas.map(function(data,index){var showname=data.showname,num=data.num;return _react2.default.createElement('div',{style:{width:1/countDatas.length*100+'%'},className:'hrm-report-count-item'},_react2.default.createElement('div',{className:'hrm-report-count-item-icon'},_this2.getIcon(index,pathname)),_react2.default.createElement('div',{className:'hrm-report-count-item-label'},_react2.default.createElement('div',{className:'hrm-report-count-item-showname'},showname),_react2.default.createElement('div',{className:'hrm-report-count-item-num'},num)));}));}}]);return DataStatistics;}(_react2.default.Component);exports.default=DataStatistics;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _RgWrapper=__webpack_require__(482);var _RgWrapper2=_interopRequireDefault(_RgWrapper);var _Statistics=__webpack_require__(483);var _Statistics2=_interopRequireDefault(_Statistics);var _BarChart=__webpack_require__(484);var _BarChart2=_interopRequireDefault(_BarChart);var _PieChart=__webpack_require__(485);var _PieChart2=_interopRequireDefault(_PieChart);var _MoreWithAdSearch=__webpack_require__(486);var _MoreWithAdSearch2=_interopRequireDefault(_MoreWithAdSearch);var _More=__webpack_require__(252);var _More2=_interopRequireDefault(_More);var _pulicFunc=__webpack_require__(23);__webpack_require__(253);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var ChangeRelatedReport=(_dec=(0,_mobxReact.inject)('hrmChangeReport'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(ChangeRelatedReport,_React$Component);function ChangeRelatedReport(props){(0,_classCallCheck3.default)(this,ChangeRelatedReport);return(0,_possibleConstructorReturn3.default)(this,(ChangeRelatedReport.__proto__||(0,_getPrototypeOf2.default)(ChangeRelatedReport)).call(this,props));}(0,_createClass3.default)(ChangeRelatedReport,[{key:'componentWillMount',value:function componentWillMount(){this.pre();}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmChangeReport=this.props.hrmChangeReport;if(this.props.location.key!==nextProps.location.key){this.pre(nextProps);hrmChangeReport.optionReset();hrmChangeReport.conditionReset();hrmChangeReport.paramReset();hrmChangeReport.tabkeyReset();hrmChangeReport.apiFinishedStatusReset();hrmChangeReport.getSearchCondition('radioGroup');// this.refs.page.click();
this.init();}}},{key:'pre',value:function pre(nextProps){var hrmChangeReport=this.props.hrmChangeReport;var pathname=void 0;if(!nextProps){pathname=this.props.location.pathname.split('/').pop();}else{pathname=nextProps.location.pathname.split('/').pop();}hrmChangeReport.setPathName(pathname);hrmChangeReport.pathToTitle();hrmChangeReport.getCurWindowWidth();hrmChangeReport.setColIdUnusualStatus();}},{key:'init',value:function init(){var hrmChangeReport=this.props.hrmChangeReport,getRight=hrmChangeReport.getRight;getRight();hrmChangeReport.tabkeyReset();}},{key:'handleMenuClick',value:function handleMenuClick(key){if(key=='0'){this.handleExportExcel();}}},{key:'getDeadline',value:function getDeadline(){var hrmChangeReport=this.props.hrmChangeReport;var deadline=hrmChangeReport.deadline;return _react2.default.createElement('div',{style:{color:'#989898',marginTop:4,marginRight:16}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,_react2.default.createElement('p',{style:{textAlign:'right'}},deadline))));}},{key:'search',value:function search(val){var hrmChangeReport=this.props.hrmChangeReport;if(val!==undefined){hrmChangeReport.setSingleSearchCondition(val);hrmChangeReport.getTableInfo('more',true);}else{hrmChangeReport.getTableInfo('bar',true);}}},{key:'handleExportExcel',value:function handleExportExcel(){var hrmChangeReport=this.props.hrmChangeReport;hrmChangeReport.getTableInfo('more',false);}},{key:'iconSet',value:function iconSet(){var icons=[_react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#2DB7F5'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-plus'}))),_react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#EB6D3A'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-Loss'}))),_react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#7DC756'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-Net-growth'}))),_react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#2DB7F5'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-hrm'}))),_react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#7DC756'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-Department-number'}))),_react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#D65DF4'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-Delayed'}))),_react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#50D0A3'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-Department-number'}))),_react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#FF986F'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-Proportion'}))),_react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#F57C4C'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-plus'}))),_react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#7DC756'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-synergism'}))),_react2.default.createElement('div',{className:'hrm-report-box'},_react2.default.createElement('div',{style:{backgroundColor:'#D55DF3'},className:'hrm-report-icon hrm-report-radius'},_react2.default.createElement('i',{className:'icon-coms-Department-number'})))];return icons;}},{key:'getIcons',value:function getIcons(i){var hrmChangeReport=this.props.hrmChangeReport;var pathname=hrmChangeReport.pathname;var icons=this.iconSet();switch(pathname){case'add':return icons.slice(i,i+1);case'confirmation':return icons.slice(i+3,i+4);case'transfer':if(i<2){return icons.slice(i+3,i+4);}else{return icons.slice(6,7);}case'contract':return icons.slice(i+8,i+9);default:if(i<2){return icons.slice(i+3,i+4);}else{return icons.slice(7,8);}}}},{key:'render',value:function render(){var _this2=this;var hrmChangeReport=this.props.hrmChangeReport;var title=hrmChangeReport.title,countDatas=hrmChangeReport.countDatas,pathname=hrmChangeReport.pathname,option1=hrmChangeReport.option1,option2=hrmChangeReport.option2,option3=hrmChangeReport.option3,chartTitle1=hrmChangeReport.chartTitle1,chartTitle2=hrmChangeReport.chartTitle2,chartTitle3=hrmChangeReport.chartTitle3,isLeftEchartsShow=hrmChangeReport.isLeftEchartsShow,isRightEchartsShow=hrmChangeReport.isRightEchartsShow,isPieChartsShow=hrmChangeReport.isPieChartsShow,ids=hrmChangeReport.ids,idsForPie=hrmChangeReport.idsForPie,yAxisData=hrmChangeReport.yAxisData,linkList=hrmChangeReport.linkList,visible1=hrmChangeReport.visible1,visible2=hrmChangeReport.visible2,tableStore=hrmChangeReport.tableStore,conditionOfAdSearch=hrmChangeReport.conditionOfAdSearch,form=hrmChangeReport.form,strokeColor=hrmChangeReport.strokeColor,isNeedWeaTab=hrmChangeReport.isNeedWeaTab,isNeedPieChart=hrmChangeReport.isNeedPieChart,tabKey=hrmChangeReport.tabKey,tabDatas=hrmChangeReport.tabDatas,isApiOneFinished=hrmChangeReport.isApiOneFinished,isApiTwoFinished=hrmChangeReport.isApiTwoFinished,winWidth=hrmChangeReport.winWidth,gridData=hrmChangeReport.gridData,isColIdUnusual=hrmChangeReport.isColIdUnusual,loading=hrmChangeReport.loading,authorized=hrmChangeReport.authorized;var btn=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this2.handleExportExcel();}},_i18n.i18n.button.export1()),_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmChangeReport.exportExcel();}},_i18n.i18n.button.export()),_react2.default.createElement(_ecCom.WeaMoreButton,null)];var btn1=btn.slice(0,1);var btn2=btn.slice(1,3);var dropMenuDatas=[{key:'0',content:_i18n.i18n.button.export1(),icon:_react2.default.createElement('i',{className:'icon-coms-leading-in'})}];if(!authorized){return _react2.default.createElement('div',{style:{height:'100%'}},loading?_react2.default.createElement('div',{className:'hrm-loading-center'},_react2.default.createElement(_antd.Spin,{spinning:loading,size:'large'})):_react2.default.createElement('div',{className:'hrm-wea-alert-page'},_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},_i18n.i18n.message.authFailed()))));}else{return _react2.default.createElement('div',{style:{backgroundColor:'#fff'},ref:'page',className:'hrm-report'},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas,onClick:function onClick(e){return _this2.handleMenuClick(e);},collectParams:{favname:title,favouritetype:5}},_react2.default.createElement(_ecCom.WeaTop,{title:title,icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',loading:true,buttons:btn1,showDropIcon:true,dropMenuDatas:dropMenuDatas,onDropMenuClick:function onDropMenuClick(e){return _this2.handleMenuClick(e);}},isNeedWeaTab?_react2.default.createElement(_ecCom.WeaTab,{selectedKey:tabKey,datas:tabDatas,keyParam:'key',onChange:function onChange(key){return hrmChangeReport.tabClick(key);}}):'',_react2.default.createElement(_RgWrapper2.default,null),_react2.default.createElement(_Statistics2.default,{countDatas:toJS(countDatas),getIcons:function getIcons(i){return _this2.getIcons(i);},isNeedLink:pathname=='contract'?true:false,linkIndex:0,setVisible:function setVisible(arg,bool){return hrmChangeReport.setVisible(arg,bool);}}),_react2.default.createElement(_BarChart2.default,{option:[toJS(option1),toJS(option2)],pathname:pathname,chartTitle:[typeof chartTitle1=='function'?chartTitle1()+'(top 5)':chartTitle1,typeof chartTitle2=='function'?chartTitle2()+'(top 5)':chartTitle2],isChartsShow:[isLeftEchartsShow,isRightEchartsShow],ids:toJS(ids),yAxisData:toJS(yAxisData),linkList:linkList,linkStyle:'hrm-report-linkStyle',winWidth:winWidth,gridData:toJS(gridData),yAxisScaleMaxLen:10,setVisible:function setVisible(arg,bool,dpId){return hrmChangeReport.setVisible(arg,bool,dpId);}}),isNeedPieChart?_react2.default.createElement(_PieChart2.default,{option:toJS(option3),chartTitle:typeof chartTitle3=='function'?chartTitle3():chartTitle3,isChartsShow:isPieChartsShow,linkStyle:'hrm-report-linkStyle',ids:toJS(idsForPie),canvasPosition:2,winWidth:winWidth,setVisible:function setVisible(arg,bool,dpId){return hrmChangeReport.setVisible(arg,bool,dpId);}}):'',this.getDeadline()),_react2.default.createElement(_More2.default,{title:hrmChangeReport.getDialogTitle(),visible:visible1,buttons:btn2,onCancel:function onCancel(){return hrmChangeReport.setVisible('1',false);},search:function search(v){return _this2.search(v);},tableStore:tableStore,loading:tableStore.loading,strokeColor:'#6FBCEA'}),_react2.default.createElement(_MoreWithAdSearch2.default,{title:hrmChangeReport.getDialogTitle(),visible:visible2,buttons:btn2,onCancel:function onCancel(){return hrmChangeReport.setVisible('2',false);},search:function search(){return _this2.search();},tableStore:tableStore,loading:tableStore.loading,searchsBaseValue:form.getFormParams().lastname,condition:toJS(conditionOfAdSearch),form:form,style:'hrm-report-scope',linkStyle:'hrm-report-linkStyle-table',isNeedReRender:true,dataIndex:['resourcename','olddepartnemtname','oldsubcompanyname','oldjobtitlename','newdepartmentname','newjobtitlename','hrmname','typename','deptname','jobname'],colId:['uid','departmentid','subcompanyid','jobid','newdepartnemtid','newjobid','olddepartnemtid','oldjobid','userid','typeid','deptid'],jumpToHrmCard:_pulicFunc.jumpToHrmCard,jumpToHrmDept:_pulicFunc.jumpToHrmDept,jumpToHrmSubCompany:_pulicFunc.jumpToHrmSubCompany,jumpToHrmPost:_pulicFunc.jumpToHrmPost,jumpToHrmContract:_pulicFunc.jumpToHrmContract,isColIdUnusual:isColIdUnusual,onSearchChange:function onSearchChange(val){return form.updateFields({lastname:{value:val}});}})));}}}]);return ChangeRelatedReport;}(_react2.default.Component))||_class)||_class);exports.default=ChangeRelatedReport;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var RadioGroupWrapper=(_dec=(0,_mobxReact.inject)('hrmChangeReport'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(RadioGroupWrapper,_React$Component);function RadioGroupWrapper(props){(0,_classCallCheck3.default)(this,RadioGroupWrapper);return(0,_possibleConstructorReturn3.default)(this,(RadioGroupWrapper.__proto__||(0,_getPrototypeOf2.default)(RadioGroupWrapper)).call(this,props));}(0,_createClass3.default)(RadioGroupWrapper,[{key:'componentDidMount',value:function componentDidMount(){var hrmChangeReport=this.props.hrmChangeReport;hrmChangeReport.getSearchCondition('radioGroup');}},{key:'render',value:function render(){var hrmChangeReport=this.props.hrmChangeReport;var condition=hrmChangeReport.condition;var arr=toJS(condition);return _react2.default.createElement('div',{style:{padding:'16px 16px 8px 16px'}},arr.length>0?_react2.default.createElement(_ecCom.WeaRadioGroup,{config:arr,onChange:function onChange(params){hrmChangeReport.setParamsThenGetData(params);}}):'');}}]);return RadioGroupWrapper;}(_react2.default.Component))||_class)||_class);exports.default=RadioGroupWrapper;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(6);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Statistics=function(_React$Component){(0,_inherits3.default)(Statistics,_React$Component);function Statistics(props){(0,_classCallCheck3.default)(this,Statistics);return(0,_possibleConstructorReturn3.default)(this,(Statistics.__proto__||(0,_getPrototypeOf2.default)(Statistics)).call(this,props));}(0,_createClass3.default)(Statistics,[{key:'getTriangleIcon',value:function getTriangleIcon(tag){if(tag>0){return _react2.default.createElement('span',null,_react2.default.createElement('i',{style:{display:'inline-block',width:0,height:0,borderRight:'4px solid transparent',borderBottom:'8px solid #7DC756',borderLeft:'4px solid transparent'}}));}else if(tag<0){return _react2.default.createElement('span',null,_react2.default.createElement('i',{style:{display:'inline-block',width:0,height:0,borderTop:'8px solid #E9612B',borderRight:'4px solid transparent',borderLeft:'4px solid transparent'}}));}}},{key:'getPercent',value:function getPercent(tag,percent){if(tag>0){return _react2.default.createElement('span',{style:{color:'#7DC756',marginLeft:5}},percent);}else if(tag<0){return _react2.default.createElement('span',{style:{color:'#E9612B',marginLeft:5}},percent);}else{return _react2.default.createElement('span',{style:{color:'#D2D2D2'}},percent);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,countDatas=_props.countDatas,getIcons=_props.getIcons,isNeedLink=_props.isNeedLink,linkIndex=_props.linkIndex,setVisible=_props.setVisible;return _react2.default.createElement('div',{style:{margin:'8px 16px',height:140,border:'1px solid #DDD',borderRadius:3}},countDatas.map(function(data,index){var showname=data.showname,num=data.num,isChange=data.isChange,percent=data.percent,changetype=data.changetype;return _react2.default.createElement('div',{style:{width:1/countDatas.length*100+'%'},className:'hrm-report-count-item-cy'},_react2.default.createElement('div',{className:'hrm-report-count-item-icon-cy'},getIcons(index)),_react2.default.createElement('div',{className:'hrm-report-count-item-label-cy'},_react2.default.createElement('div',{className:'hrm-report-count-item-showname'},showname),_react2.default.createElement('div',{className:'hrm-report-count-item-num'},isNeedLink&&linkIndex===index?_react2.default.createElement('a',{onClick:function onClick(){return setVisible('5',true);}},num):num),_react2.default.createElement('div',null,_react2.default.createElement('span',null,_this2.getTriangleIcon(isChange)),_react2.default.createElement('span',null,_this2.getPercent(isChange,percent)),_react2.default.createElement('span',{className:'hrm-report-count-item-changetype'},changetype))));}));}}]);return Statistics;}(_react2.default.Component);exports.default=Statistics;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _i18n=__webpack_require__(11);var _pulicFunc=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var BarChart=function(_React$Component){(0,_inherits3.default)(BarChart,_React$Component);function BarChart(props){(0,_classCallCheck3.default)(this,BarChart);var _this=(0,_possibleConstructorReturn3.default)(this,(BarChart.__proto__||(0,_getPrototypeOf2.default)(BarChart)).call(this,props));_this.state={text:_i18n.i18n.button.saveAsImage(),optionL:{},optionR:{}};return _this;}(0,_createClass3.default)(BarChart,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.refs.echart1)this.refs.echart1.paint();if(this.refs.echart2)this.refs.echart2.paint();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.winWidth!==nextProps.winWidth){if(this.refs.echart1)this.refs.echart1.chart.resize();if(this.refs.echart2)this.refs.echart2.chart.resize();}if(this.props.option!==nextProps.option){if(!this.isEmptyObject(nextProps.gridData)&&!this.isEmptyObject(nextProps.option[0])&&!this.isEmptyObject(nextProps.option[1])){this.setBarWidth(nextProps);}}}},{key:'isEmptyObject',value:function isEmptyObject(obj){for(var key in obj){return false;}return true;}},{key:'setBarWidth',value:function setBarWidth(nextProps){var yAxisScaleMaxLen=this.props.yAxisScaleMaxLen;if(!this.refs.echart1){return;}var h=340;var data=nextProps.gridData;var opt=nextProps.option[0];var l=yAxisScaleMaxLen||10;var b=void 0;var t=void 0;if(data.bottom){b=parseInt(data.bottom)/100*h;}else{b=60;}if(data.top){t=parseInt(data.top)/100*h;}else{t=60;}var s=(h-(b+t))/l;nextProps.option[0].series[0].barWidth=s*0.9;nextProps.option[1].series[0].barWidth=s*0.9;this.setState({optionL:nextProps.option[0],optionR:nextProps.option[1]});}},{key:'getDOM',value:function getDOM(tag,isChartsShow,chartTitle){var _this2=this;var _props=this.props,setVisible=_props.setVisible,linkStyle=_props.linkStyle;var text=this.state.text;return _react2.default.createElement('div',{style:{position:'absolute',right:0}},_react2.default.createElement('div',{style:{float:'left',padding:'10px 0'}},tag=='left'?_react2.default.createElement('a',{onClick:function onClick(){return setVisible('1',true);},className:linkStyle},_i18n.i18n.button.more()):''),_react2.default.createElement('div',{style:{float:'left',padding:'8px 20px 10px 10px',fontSize:16}},isChartsShow?_react2.default.createElement('a',{onClick:function onClick(){return _this2.download(tag,chartTitle);},className:linkStyle,title:_i18n.i18n.button.saveAsImage()},_react2.default.createElement('i',{className:'icon-coms-download2'})):_react2.default.createElement('a',{onClick:function onClick(){_antd.message.info(_i18n.i18n.message.dataNone());},className:linkStyle,title:_i18n.i18n.button.saveAsImage()},_react2.default.createElement('i',{className:'icon-coms-download2'}))));}},{key:'download',value:function download(tag,chartTitle){var cvs=document.getElementsByTagName('canvas');if(tag=='left'){this.downloadCvs2Img(cvs[0],chartTitle);}else{this.downloadCvs2Img(cvs[1],chartTitle);}}},{key:'downloadCvs2Img',value:function downloadCvs2Img(cvs,chartTitle){var $a=document.createElement('a');$a.download=chartTitle+'.jpg';$a.target='_blank';var url=void 0;if(cvs){url=cvs.toDataURL("image/jpg");}else{_antd.message.info(_i18n.i18n.message.dataNone());}if(url)$a.href=url;if(typeof MouseEvent==='function'){var evt=new MouseEvent('click',{view:window,bubbles:true,cancelable:false});$a.dispatchEvent(evt);}else{if(window.navigator.msSaveOrOpenBlob){var bstr=atob(url.split(',')[1]);var n=bstr.length;var u8arr=new Uint8Array(n);while(n--){u8arr[n]=bstr.charCodeAt(n);}var blob=new Blob([u8arr]);window.navigator.msSaveOrOpenBlob(blob,chartTitle+'.jpg');}else{var html=''+'<body style="margin:0;">'+'<img src="'+url+'" style="max-width:100%;" title="" />'+'</body>';var tab=window.open();tab.document.write(html);}}}},{key:'chartAction',value:function chartAction(chart,idy){var _this3=this;chart.off('click');chart.on('click',function(params){return _this3.handleClick(params,idy);});}},{key:'handleClick',value:function handleClick(params,idy){var _props2=this.props,ids=_props2.ids,yAxisData=_props2.yAxisData,linkList=_props2.linkList,setVisible=_props2.setVisible;if(params.componentType=='yAxis'){var anid=params.event.target.anid;if(!anid){return;}var index=anid.split('_')[1];(0,_pulicFunc.jumpToHrmDept)(ids[index]);}if(idy=='left'&&params.componentType=='series'){setVisible('2',true,ids[params.dataIndex]);}if(idy=='right'&&params.componentType=='series'){setVisible('3',true,params.name);}}},{key:'render',value:function render(){var _this4=this;var _props3=this.props,chartTitle=_props3.chartTitle,isChartsShow=_props3.isChartsShow,winWidth=_props3.winWidth;var _state=this.state,optionL=_state.optionL,optionR=_state.optionR;return _react2.default.createElement('div',null,_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement('div',{style:{height:400,margin:'8px 8px 8px 16px',border:'1px solid #DDD',borderRadius:3}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,_react2.default.createElement('div',{style:{height:40,backgroundColor:'#F9F9F9',position:'relative'}},_react2.default.createElement('div',{style:{height:'100%',padding:'11px 0 12px 16px',float:'left'}},chartTitle[0]),_react2.default.createElement('div',{style:{height:50}},this.getDOM('left',isChartsShow[0],chartTitle[0]))))),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,isChartsShow[0]?_react2.default.createElement('div',{style:{height:340}},_react2.default.createElement(_ecCom.WeaEchart,{ref:'echart1',option:optionL,useDefault:false,chartAction:function chartAction(chart){return _this4.chartAction(chart,'left');}})):_react2.default.createElement('div',{style:{position:'absolute',top:100,left:'50%',marginLeft:-24,textAlign:'center'}},_react2.default.createElement('div',{style:{fontSize:50}},_react2.default.createElement('i',{className:'icon-coms-blank'})),_react2.default.createElement('div',{style:{fontSize:15,color:'#B2B2B2'}},_i18n.i18n.message.dataNone())))))),_react2.default.createElement(_antd.Col,{span:12},_react2.default.createElement('div',{style:{height:400,margin:'8px 16px 8px 8px',border:'1px solid #DDD',borderRadius:3}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,_react2.default.createElement('div',{style:{height:40,backgroundColor:'#F9F9F9',position:'relative'}},_react2.default.createElement('div',{style:{height:'100%',padding:'11px 0 12px 16px',float:'left'}},chartTitle[1]),_react2.default.createElement('div',{style:{height:50}},this.getDOM('right',isChartsShow[1],chartTitle[1]))))),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,isChartsShow[1]?_react2.default.createElement('div',{style:{height:340}},_react2.default.createElement(_ecCom.WeaEchart,{ref:'echart2',option:optionR,useDefault:false,chartAction:function chartAction(chart){return _this4.chartAction(chart,'right');}})):_react2.default.createElement('div',{style:{position:'absolute',top:100,left:'50%',marginLeft:-24,textAlign:'center'}},_react2.default.createElement('div',{style:{fontSize:50}},_react2.default.createElement('i',{className:'icon-coms-blank'})),_react2.default.createElement('div',{style:{fontSize:15,color:'#B2B2B2'}},_i18n.i18n.message.dataNone()))))))));}}]);return BarChart;}(_react2.default.Component);exports.default=BarChart;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PieChart=function(_React$Component){(0,_inherits3.default)(PieChart,_React$Component);function PieChart(props){(0,_classCallCheck3.default)(this,PieChart);return(0,_possibleConstructorReturn3.default)(this,(PieChart.__proto__||(0,_getPrototypeOf2.default)(PieChart)).call(this,props));}(0,_createClass3.default)(PieChart,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.refs.echart)this.refs.echart.paint();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.winWidth!==nextProps.winWidth){if(this.refs.echart)this.refs.echart.chart.resize();}}},{key:'getDOM',value:function getDOM(){var _this2=this;var _props=this.props,isChartsShow=_props.isChartsShow,chartTitle=_props.chartTitle,linkStyle=_props.linkStyle;return _react2.default.createElement('div',{style:{position:'absolute',right:0}},_react2.default.createElement('div',{style:{float:'left',padding:'8px 20px 10px 10px',fontSize:16}},isChartsShow?_react2.default.createElement('a',{onClick:function onClick(){return _this2.download();},className:linkStyle},_react2.default.createElement('i',{className:'icon-coms-download2'})):_react2.default.createElement('a',{onClick:function onClick(){_antd.message.info(_i18n.i18n.message.dataNone());},className:linkStyle},_react2.default.createElement('i',{className:'icon-coms-download2'}))));}},{key:'download',value:function download(){var canvasPosition=this.props.canvasPosition;var cvs=document.getElementsByTagName('canvas');this.downloadCvs2Img(cvs[canvasPosition]);}},{key:'downloadCvs2Img',value:function downloadCvs2Img(cvs){var chartTitle=this.props.chartTitle;var $a=document.createElement('a');$a.download=chartTitle+'.jpg';$a.target='_blank';var url=void 0;if(cvs){url=cvs.toDataURL("image/jpg");}else{_antd.message.info(_i18n.i18n.message.dataNone());}if(url)$a.href=url;if(typeof MouseEvent==='function'){var evt=new MouseEvent('click',{view:window,bubbles:true,cancelable:false});$a.dispatchEvent(evt);}else{if(window.navigator.msSaveOrOpenBlob){var bstr=atob(url.split(',')[1]);var n=bstr.length;var u8arr=new Uint8Array(n);while(n--){u8arr[n]=bstr.charCodeAt(n);}var blob=new Blob([u8arr]);window.navigator.msSaveOrOpenBlob(blob,chartTitle+'.jpg');}else{var lang=model.get('lang');var html=''+'<body style="margin:0;">'+'<img src="'+url+'" style="max-width:100%;" title="'+(lang&&lang[0]||'')+'" />'+'</body>';var tab=window.open();tab.document.write(html);}}}},{key:'chartAction',value:function chartAction(chart){var _this3=this;chart.off('click');chart.on('click',function(params){return _this3.handleClick(params);});}},{key:'handleClick',value:function handleClick(params){var _props2=this.props,ids=_props2.ids,setVisible=_props2.setVisible;setVisible('4',true,ids[params.dataIndex]);}},{key:'render',value:function render(){var _this4=this;var _props3=this.props,option=_props3.option,chartTitle=_props3.chartTitle,isChartsShow=_props3.isChartsShow;return _react2.default.createElement('div',{style:{height:400,margin:'8px 16px',border:'1px solid #DDD',borderRadius:3}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,_react2.default.createElement('div',{style:{height:40,backgroundColor:'#F9F9F9',position:'relative'}},_react2.default.createElement('div',{style:{height:'100%',padding:'11px 0 12px 16px',color:'#333',float:'left'}},chartTitle),_react2.default.createElement('div',{style:{height:50}},this.getDOM())))),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,null,isChartsShow?_react2.default.createElement('div',{style:{height:340}},_react2.default.createElement(_ecCom.WeaEchart,{ref:'echart',option:option,useDefault:false,chartAction:function chartAction(chart){return _this4.chartAction(chart);}})):_react2.default.createElement('div',{style:{position:'absolute',top:100,left:'50%',marginLeft:-24,textAlign:'center'}},_react2.default.createElement('div',{style:{fontSize:50}},_react2.default.createElement('i',{className:'icon-coms-blank'})),_react2.default.createElement('div',{style:{fontSize:15,color:'#B2B2B2'}},_i18n.i18n.message.dataNone())))));}}]);return PieChart;}(_react2.default.Component);exports.default=PieChart;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _i18n=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var MoreWithAdSearch=function(_React$Component){(0,_inherits3.default)(MoreWithAdSearch,_React$Component);function MoreWithAdSearch(props){(0,_classCallCheck3.default)(this,MoreWithAdSearch);var _this=(0,_possibleConstructorReturn3.default)(this,(MoreWithAdSearch.__proto__||(0,_getPrototypeOf2.default)(MoreWithAdSearch)).call(this,props));_this.state={width:1100,height:510,isPanelShow:false,conditionNumber:4};return _this;}(0,_createClass3.default)(MoreWithAdSearch,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.condition&&nextProps.condition&&this.props.condition!==nextProps.condition&&nextProps.condition[0]&&nextProps.condition[0].items){this.setConditionNumber(nextProps.condition[0].items.length);this.setDialogWidth(nextProps.condition);}}},{key:'getPanelComponents',value:function getPanelComponents(){var _props=this.props,condition=_props.condition,form=_props.form,style=_props.style;var arr=[];var formParams=form.getFormParams();var isFormInit=form.isFormInit;isFormInit&&condition.map(function(c){c.items.map(function(field,index){arr.push(_react2.default.createElement(_antd.Col,{span:11,offset:index%2==0?1:0},_react2.default.createElement('div',{style:{marginTop:20}},_react2.default.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:6},wrapperCol:{span:index%2==0?17:18}},_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:formParams})))));});});if(style){return _react2.default.createElement('div',{className:style},_react2.default.createElement(_antd.Row,null,arr));}else{return _react2.default.createElement('div',null,_react2.default.createElement(_antd.Row,null,arr));}}},{key:'setPanelStatus',value:function setPanelStatus(bool){this.setState({isPanelShow:bool});}},{key:'setConditionNumber',value:function setConditionNumber(num){this.setState({conditionNumber:num});}},{key:'setDialogWidth',value:function setDialogWidth(condition){if(this.isConditionHasDate(condition)){this.setState({width:990});}}},{key:'isConditionHasDate',value:function isConditionHasDate(condition){if(this.isArray(condition)&&condition[0].items){var items=condition[0].items;for(var i=0;i<items.length;i++){if(items[i].conditionType&&items[i].conditionType=='DATE'&&items[i].domkey&&this.isArray(items[i].domkey)&&items[i].domkey.length==3){return true;}}}return false;}},{key:'isArray',value:function isArray(obj){return Object.prototype.toString.call(obj)=='[object Array]';}},{key:'reRenderColumns',value:function reRenderColumns(columns,isNeedReRender){if(!isNeedReRender){return;}var _props2=this.props,dataIndex=_props2.dataIndex,colId=_props2.colId,jumpToHrmCard=_props2.jumpToHrmCard,jumpToHrmDept=_props2.jumpToHrmDept,jumpToHrmSubCompany=_props2.jumpToHrmSubCompany,jumpToHrmPost=_props2.jumpToHrmPost,jumpToHrmContract=_props2.jumpToHrmContract,isColIdUnusual=_props2.isColIdUnusual;var that=this;columns.forEach(function(c,index){if(c.dataIndex==dataIndex[0]){c.render=function(text,record){return _react2.default.createElement('span',null,_react2.default.createElement(_ecCom.WeaPopoverHrm,null),_react2.default.createElement('a',{href:'javaScript:openhrm('+record[colId[0]]+');',onClick:function onClick(e){return window.pointerXY(e);}},record[dataIndex[0]]));};}if(c.dataIndex==dataIndex[1]&&!isColIdUnusual){c.render=function(text,record){return _react2.default.createElement('a',{onClick:function onClick(){return jumpToHrmDept(record[colId[1]]);}},record[dataIndex[1]]);};}if(c.dataIndex==dataIndex[1]&&isColIdUnusual){//transfer
c.render=function(text,record){return _react2.default.createElement('a',{onClick:function onClick(){return jumpToHrmDept(record[colId[6]]);}},record[dataIndex[1]]);};}if(c.dataIndex==dataIndex[2]){c.render=function(text,record){return _react2.default.createElement('a',{onClick:function onClick(){return jumpToHrmSubCompany(record[colId[2]]);}},record[dataIndex[2]]);};}if(c.dataIndex==dataIndex[3]&&!isColIdUnusual){c.render=function(text,record){return _react2.default.createElement('a',{onClick:function onClick(){return jumpToHrmPost(record[colId[3]]);}},record[dataIndex[3]]);};}if(c.dataIndex==dataIndex[3]&&isColIdUnusual){//transfer
c.render=function(text,record){return _react2.default.createElement('a',{onClick:function onClick(){return jumpToHrmPost(record[colId[7]]);}},record[dataIndex[3]]);};}if(c.dataIndex==dataIndex[4]){c.render=function(text,record){return _react2.default.createElement('a',{onClick:function onClick(){return jumpToHrmDept(record[colId[4]]);}},record[dataIndex[4]]);};}if(c.dataIndex==dataIndex[5]){c.render=function(text,record){return _react2.default.createElement('a',{onClick:function onClick(){return jumpToHrmPost(record[colId[5]]);}},record[dataIndex[5]]);};}//Contract
if(c.dataIndex==dataIndex[6]){c.render=function(text,record){return _react2.default.createElement('span',null,_react2.default.createElement(_ecCom.WeaPopoverHrm,null),_react2.default.createElement('a',{href:'javaScript:openhrm('+record[colId[8]]+');',onClick:function onClick(e){return window.pointerXY(e);}},record[dataIndex[6]]));};}if(c.dataIndex==dataIndex[7]){c.render=function(text,record){return _react2.default.createElement('a',{onClick:function onClick(){return jumpToHrmContract(record[colId[9]]);}},record[dataIndex[7]]);};}if(c.dataIndex==dataIndex[8]){c.render=function(text,record){return _react2.default.createElement('a',{conClick:function conClick(){return jumpToHrmDept(record[colId[10]]);}},record[dataIndex[8]]);};}if(c.dataIndex==dataIndex[9]){c.render=function(text,record){return _react2.default.createElement('a',{onClick:function onClick(){return jumpToHrmPost(record[colId[3]]);}},record[dataIndex[9]]);};}});}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,title=_props3.title,visible=_props3.visible,_onCancel=_props3.onCancel,buttons=_props3.buttons,search=_props3.search,tableStore=_props3.tableStore,form=_props3.form,searchsBaseValue=_props3.searchsBaseValue,_onSearchChange=_props3.onSearchChange,isNeedReRender=_props3.isNeedReRender;var _state=this.state,width=_state.width,height=_state.height,isPanelShow=_state.isPanelShow,conditionNumber=_state.conditionNumber;var btn=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){search();_this2.setPanelStatus(false);}},_i18n.i18n.button.search()),_react2.default.createElement(_antd.Button,{onClick:function onClick(){return form.reset();}},_i18n.i18n.button.reset()),_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.setPanelStatus(false);}},_i18n.i18n.button.cancel())];return _react2.default.createElement(_ecCom.WeaDialog,{title:title,icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:visible,closable:true,onCancel:function onCancel(){_onCancel();_this2.setPanelStatus(false);},buttons:buttons,style:{width:width,height:510},onChangeHeight:function onChangeHeight(h){return _this2.setState({height:h});}},_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:24},_react2.default.createElement(_ecCom.WeaTab,{searchType:['base','advanced'],showSearchAd:isPanelShow,searchsBaseValue:searchsBaseValue,setShowSearchAd:function setShowSearchAd(bool){return _this2.setPanelStatus(bool);},hideSearchAd:function hideSearchAd(){return _this2.setPanelStatus(false);},searchsAd:this.getPanelComponents(),advanceHeight:Math.ceil(conditionNumber/2)*58.5,hasMask:false,buttonsAd:btn,onSearch:function onSearch(){return search();},onSearchChange:function onSearchChange(val){return _onSearchChange(val);}}))),_react2.default.createElement(_antd.Row,null,_react2.default.createElement(_antd.Col,{span:24},_react2.default.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,scroll:{y:height-125},rowKey:function rowKey(record,index){return index;},getColumns:function getColumns(c){return _this2.reRenderColumns(c,isNeedReRender);}}))));}}]);return MoreWithAdSearch;}(_react2.default.Component);exports.default=MoreWithAdSearch;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class,_class2,_temp;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _comsMobx=__webpack_require__(10);__webpack_require__(488);var _reactRouter=__webpack_require__(57);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var Main=(_dec=(0,_mobxReact.inject)('hrmConstRpSubSearch'),_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var isCustom=this.props.location.query.isCustom;hrmConstRpSubSearch.scopeId=this.props.params.scopeId||'';hrmConstRpSubSearch.isCustom=isCustom||'';this.init();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var isCustom=nextProps.location.query.isCustom;hrmConstRpSubSearch.scopeId=nextProps.params.scopeId||'';hrmConstRpSubSearch.isCustom=isCustom||'';if(this.props.location.key!==nextProps.location.key||this.props.params.scopeId!==nextProps.params.scopeId){this.init();}}},{key:'init',value:function init(){var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;hrmConstRpSubSearch.visible=false;hrmConstRpSubSearch.templeteValue='';hrmConstRpSubSearch.templateid='0';hrmConstRpSubSearch.getTabInfo({},function(){hrmConstRpSubSearch.getCondition();});}},{key:'reset',value:function reset(){var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;this.refs.report.reset();hrmConstRpSubSearch.reset();}},{key:'formatData',value:function formatData(){var fieldParams=this.refs.report.get();var params={};var fieldnames=[];var checkshows=[];for(var key in fieldParams){var fieldparam=fieldParams[key];if(!fieldparam.disabled){if(fieldparam.checkRow){checkshows.push(key);params["con"+key+"_colname"]=key;params["con"+key+"_fieldlabel"]=fieldparam.label;params["show"+key+"_sn"]=fieldparam.index;}if(fieldparam.checked){fieldnames.push(key);params["con"+key+"_colname"]=key;var arrConditionType=fieldparam.conditionType.split("_");params["con"+key+"_htmltype"]=arrConditionType[0];params["con"+key+"_type"]=arrConditionType[1];if(fieldparam.value){params["con"+key+"_opt"]=fieldparam.value.opt||'';params["con"+key+"_value"]=fieldparam.value.optvalue||'';params["con"+key+"_opt1"]=fieldparam.value.opt1||'';params["con"+key+"_value1"]=fieldparam.value.optvalue1||'';}}}}params.check_show=checkshows;params.check_con=fieldnames;return params;}},{key:'doSearch',value:function doSearch(){var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var params=this.formatData();hrmConstRpSubSearch.doSearch(params);}},{key:'saveTemplete',value:function saveTemplete(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var tmpTabKey=hrmConstRpSubSearch.tabkey;var formParams=this.formatData();params.scopeId=hrmConstRpSubSearch.scopeId;if(hrmConstRpSubSearch.isCustom=='1'){params.scopeCmd='0';}else{if(tmpTabKey&&tmpTabKey.split("_").length==3){var tmpValue=tmpTabKey.split("_");params.scopeCmd=tmpValue[1];}else{params.scopeCmd=tmpTabKey;}}hrmConstRpSubSearch.saveTemplete((0,_extends3.default)({},params,formParams));}},{key:'doSave',value:function doSave(){var params={};params.doSave=true;this.saveTemplete(params);}},{key:'reSave',value:function reSave(){var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;hrmConstRpSubSearch.isReSave=true;hrmConstRpSubSearch.updateVisible(true);}},{key:'doDel',value:function doDel(){var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var templateid=hrmConstRpSubSearch.templateid;if(templateid!='0'){hrmConstRpSubSearch.deleteTabs();}}},{key:'getRightMenu',value:function getRightMenu(){var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var showResult=hrmConstRpSubSearch.showResult,templateid=hrmConstRpSubSearch.templateid;var btns=[];var btnDoSearch={icon:_react2.default.createElement('i',{className:'icon-coms-search'}),content:_i18n.i18n.button.search()};var btnSave={icon:_react2.default.createElement('i',{className:'icon-coms-common'}),content:_i18n.i18n.button.save()};var btnDel={icon:_react2.default.createElement('i',{className:'icon-coms-common'}),content:_i18n.i18n.button.delete()};var btnReSearch={icon:_react2.default.createElement('i',{className:'icon-coms-go-back'}),content:_i18n.i18n.button.research()};var btnReSet={icon:_react2.default.createElement('i',{className:'icon-coms-Return'}),content:_i18n.i18n.button.reset()};var btnSaveTemplete={icon:_react2.default.createElement('i',{className:'icon-coms-content-o'}),content:_i18n.i18n.button.saveAsTemplate()};var btnReSaveTemplete={icon:_react2.default.createElement('i',{className:'icon-coms-content-o'}),content:_i18n.i18n.button.saveAs()};var btnImportExcel={icon:_react2.default.createElement('i',{className:'icon-coms-export'}),content:_i18n.i18n.button.export()};if(showResult){btns.push(btnReSearch);//btns.push(btnImportExcel);
}else{if(templateid=='0'){btns.push(btnDoSearch);btns.push(btnReSet);btns.push(btnSaveTemplete);}else{btns.push(btnDoSearch);btns.push(btnSave);btns.push(btnDel);btns.push(btnReSaveTemplete);}}return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var showResult=hrmConstRpSubSearch.showResult,templateid=hrmConstRpSubSearch.templateid;if(showResult){switch(key){case'0':hrmConstRpSubSearch.reSearch();break;case'1':hrmConstRpSubSearch.importExcel();break;}}else{if(templateid=='0'){switch(key){case'0':this.doSearch();break;case'1':this.reset();break;case'2':hrmConstRpSubSearch.updateVisible(true);break;}}else{switch(key){case'0':this.doSearch();break;case'1':this.doSave();break;case'2':this.doDel();break;case'3':this.reSave();break;}}}}},{key:'getTopButtons',value:function getTopButtons(){var _this2=this;var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var showResult=hrmConstRpSubSearch.showResult,templateid=hrmConstRpSubSearch.templateid;var btns=[];var btnDoSearch=_react2.default.createElement(_antd.Button,{type:'primary',className:'wea-hrm-top-buttons',onClick:function onClick(){return _this2.doSearch();}},_i18n.i18n.button.search());var btnDoSave=_react2.default.createElement(_antd.Button,{type:'primary',className:'wea-hrm-top-buttons',onClick:function onClick(){return _this2.doSave();}},_i18n.i18n.button.save());var btnDoDel=_react2.default.createElement(_antd.Button,{type:'primary',className:'wea-hrm-top-buttons',onClick:function onClick(){return _this2.doDel();}},_i18n.i18n.button.delete());var btnReSearch=_react2.default.createElement(_antd.Button,{type:'primary',className:'wea-hrm-top-buttons',onClick:function onClick(){return hrmConstRpSubSearch.reSearch();}},_i18n.i18n.button.research());var btnReSet=_react2.default.createElement(_antd.Button,{type:'primary',className:'wea-hrm-top-buttons',onClick:function onClick(){return _this2.reset();}},_i18n.i18n.button.reset());var btnSaveTemplete=_react2.default.createElement(_antd.Button,{type:'primary',className:'wea-hrm-top-buttons',onClick:function onClick(){return hrmConstRpSubSearch.updateVisible(true);}},_i18n.i18n.button.saveAsTemplate());var btnReSaveTemplete=_react2.default.createElement(_antd.Button,{type:'primary',className:'wea-hrm-top-buttons',onClick:function onClick(){return _this2.reSave();}},_i18n.i18n.button.saveAs());var btnImportExcel=_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmConstRpSubSearch.importExcel();}},_i18n.i18n.button.export());if(showResult){btns.push(btnReSearch);//btns.push(btnImportExcel);
}else{if(templateid=='0'){btns.push(btnDoSearch);btns.push(btnReSet);btns.push(btnSaveTemplete);}else{btns.push(btnDoSearch);btns.push(btnDoSave);btns.push(btnDoDel);btns.push(btnReSaveTemplete);}}return btns;}},{key:'getDialogBtns',value:function getDialogBtns(){var _this3=this;var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var btns=[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){_this3.saveTemplete();}},_i18n.i18n.button.save())];return btns;}},{key:'getTabChildren',value:function getTabChildren(){var _this4=this;var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var topTabkey=hrmConstRpSubSearch.topTabkey,tabkey=hrmConstRpSubSearch.tabkey,tabDatas=hrmConstRpSubSearch.tabDatas;var tabChildren=void 0;tabDatas=(0,_mobx.toJS)(tabDatas);tabDatas&&tabDatas.map(function(t,i){if(topTabkey===t.key){tabChildren=_react2.default.createElement(_ecCom.WeaTab,{type:'card',selectedKey:tabkey,datas:(0,_mobx.toJS)(t.tabinfo),keyParam:'key',onChange:function onChange(key){_this4.refs.report&&_this4.refs.report.reset();hrmConstRpSubSearch.changeTab(key);}});}});return tabChildren;}},{key:'getCustomTabChildren',value:function getCustomTabChildren(){var _this5=this;var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var tabkey=hrmConstRpSubSearch.tabkey,tabDatas=hrmConstRpSubSearch.tabDatas;var tabChildren=void 0;tabDatas=(0,_mobx.toJS)(tabDatas);tabDatas&&tabDatas.map(function(t,i){tabChildren=_react2.default.createElement(_ecCom.WeaTab,{type:'card',selectedKey:tabkey,datas:(0,_mobx.toJS)(t.tabinfo),keyParam:'key',onChange:function onChange(key){_this5.refs.report&&_this5.refs.report.reset();hrmConstRpSubSearch.changeTab(key);}});});return tabChildren;}},{key:'getTableWidth',value:function getTableWidth(columns){var columnLength=columns.filter(function(col){return col.display==='true';}).length;if(columnLength>10){return columnLength*160;}else{return'100%';}}},{key:'getBreadcrumb',value:function getBreadcrumb(){var router=this.context.router;var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var title=hrmConstRpSubSearch.title,isCustom=hrmConstRpSubSearch.isCustom;var arr=[];if(isCustom=='1'){arr.push({name:_i18n.i18n.label.customerInfo(),onClick:function onClick(){if(router){router.push({pathname:'/main/hrm/rpsubsearch'});}}});arr.push({name:title,onClick:function onClick(){}});}else{arr.push({name:title,onClick:function onClick(){}});}return arr;}},{key:'tabsOnChange',value:function tabsOnChange(key){var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;this.refs.report&&this.refs.report.reset();hrmConstRpSubSearch.changeTopTab(key);}},{key:'render',value:function render(){var _this6=this;var hrmConstRpSubSearch=this.props.hrmConstRpSubSearch;var verified=hrmConstRpSubSearch.verified,hasRight=hrmConstRpSubSearch.hasRight,title=hrmConstRpSubSearch.title,form=hrmConstRpSubSearch.form,table=hrmConstRpSubSearch.table,config=hrmConstRpSubSearch.config,showResult=hrmConstRpSubSearch.showResult,tabDatas=hrmConstRpSubSearch.tabDatas,topTabkey=hrmConstRpSubSearch.topTabkey,visible=hrmConstRpSubSearch.visible,templeteValue=hrmConstRpSubSearch.templeteValue,isCustom=hrmConstRpSubSearch.isCustom;config=(0,_mobx.toJS)(config);if(verified&&hasRight){return _react2.default.createElement('div',{className:'wea-hrm-const_rpsubsearch'},_react2.default.createElement(_ecCom.WeaDialog,{visible:visible,onCancel:function onCancel(){return hrmConstRpSubSearch.updateVisible(false);},closable:true,style:{width:500,height:120},title:_i18n.i18n.button.saveAsTemplate(),icon:'icon-coms-hrm',iconBgcolor:'#217346',buttons:this.getDialogBtns()},_react2.default.createElement('div',{style:{padding:20}},_react2.default.createElement(_ecCom.WeaFormItem,{label:_i18n.i18n.label.templateName(),labelCol:{span:6},wrapperCol:{span:14}},_react2.default.createElement(_ecCom.WeaInput,{viewAttr:'3',value:templeteValue,onChange:function onChange(v){return hrmConstRpSubSearch.updateTempleteValue(v);}})))),_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},_react2.default.createElement(_ecCom.WeaTop//title={title}
,{breadcrumb:this.getBreadcrumb(),loading:false,icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu(),onDropMenuClick:this.onRightMenuClick.bind(this)},_react2.default.createElement('div',{className:'wea-hrm-detialtabinfo'},isCustom=='1'&&_react2.default.createElement('div',{className:'wea-hrm-cus_detialtabinfo'},this.getCustomTabChildren()),isCustom!='1'&&_react2.default.createElement('div',null,_react2.default.createElement(_ecCom.WeaTab,{type:'editable-inline',keyParam:'key',datas:(0,_mobx.toJS)(tabDatas),selectedKey:topTabkey,onChange:function onChange(v){_this6.tabsOnChange(v);}}),this.getTabChildren())),!showResult&&!(0,_isEmpty2.default)(config)&&_react2.default.createElement(_ecCom.WeaReportGroup,{ref:'report',config:config,hasIndex:true}),showResult&&_react2.default.createElement('div',null,_react2.default.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true,tableWidth:function tableWidth(columns){return _this6.getTableWidth(columns);}//getColumns={c=>this.reRenderColumns(c)}
,rowKey:function rowKey(record,index){return index;}})))));}if(verified&&!hasRight){return _react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},_i18n.i18n.message.authFailed()));}return _react2.default.createElement('div',null);}}]);return Main;}(_react2.default.Component),_class2.contextTypes={router:_reactRouter.routerShape},_temp))||_class)||_class);exports.default=Main;

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class,_class2,_temp;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _reactRouter=__webpack_require__(57);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _comsMobx=__webpack_require__(10);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var WeaTable=_comsMobx.WeaTableNew.WeaTable;var _this=void 0;var RpSubSearch=(_dec=(0,_mobxReact.inject)('hrmRpSubSearch'),_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_React$Component){(0,_inherits3.default)(RpSubSearch,_React$Component);function RpSubSearch(props){(0,_classCallCheck3.default)(this,RpSubSearch);var _this2=(0,_possibleConstructorReturn3.default)(this,(RpSubSearch.__proto__||(0,_getPrototypeOf2.default)(RpSubSearch)).call(this,props));_this=_this2;var funcs=['jumpToReport'];funcs.forEach(function(f){return _this2[f]=_this2[f].bind(_this2);});return _this2;}(0,_createClass3.default)(RpSubSearch,[{key:'componentDidMount',value:function componentDidMount(){var hrmRpSubSearch=this.props.hrmRpSubSearch;hrmRpSubSearch.getHasRight();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmRpSubSearch=this.props.hrmRpSubSearch;if(this.props.location.key!==nextProps.location.key){hrmRpSubSearch.getHasRight();}}},{key:'render',value:function render(){var _this3=this;var hrmRpSubSearch=this.props.hrmRpSubSearch;var title=hrmRpSubSearch.title,form=hrmRpSubSearch.form,table=hrmRpSubSearch.table,showSearchAd=hrmRpSubSearch.showSearchAd,searchParamsAd=hrmRpSubSearch.searchParamsAd,verified=hrmRpSubSearch.verified,hasRight=hrmRpSubSearch.hasRight;if(verified&&hasRight){var formParams=form.getFormParams();var loadingTable=table.loading;return _react2.default.createElement('div',{className:'wea-myhrm-RpSubSearch'},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},_react2.default.createElement(_ecCom.WeaTop,{title:title(),loading:loadingTable,icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:[],buttonSpace:10,showDropIcon:false},_react2.default.createElement(_ecCom.WeaTab,{buttonsAd:this.getTabButtonsAd(),searchType:['base','advanced'],searchsBaseValue:formParams.formlabel,setShowSearchAd:function setShowSearchAd(bool){hrmRpSubSearch.setShowSearchAd(bool);},hideSearchAd:function hideSearchAd(){return hrmRpSubSearch.setShowSearchAd(false);},searchsAd:this.getSearchs(),showSearchAd:showSearchAd,onSearch:function onSearch(v){hrmRpSubSearch.doSearch();},advanceHeight:150,onSearchChange:function onSearchChange(v){form.updateFields({formlabel:{name:'formlabel',value:v}});}}),_react2.default.createElement(_antd.Spin,{spinning:loadingTable},_react2.default.createElement(WeaTable,{comsWeaTableStore:table,hasOrder:true,needScroll:true,getColumns:function getColumns(c){return _this3.reRenderColumns(c);}})))));}if(verified&&!hasRight){return _react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},_i18n.i18n.message.authFailed()));}return _react2.default.createElement('div',null);}},{key:'getSearchs',value:function getSearchs(){var hrmRpSubSearch=this.props.hrmRpSubSearch;var form=hrmRpSubSearch.form,condition=hrmRpSubSearch.condition;var isFormInit=form.isFormInit;var group=[];var formParams=form.getFormParams();isFormInit&&toJS(condition).map(function(c){var items=[];c.items.map(function(fields){var dom=_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:fields,form:form,formParams:formParams});items.push({com:_react2.default.createElement(_ecCom.WeaFormItem,{label:''+fields.label,labelCol:{span:''+fields.labelcol},wrapperCol:{span:''+fields.fieldcol}},dom),colSpan:1});});group.push(_react2.default.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:c.title,showGroup:c.defaultshow,items:items}));});return group;}},{key:'reRenderColumns',value:function reRenderColumns(columns){columns.forEach(function(c){if(c.dataIndex=='formlabel'){c.render=function(text,record){return _react2.default.createElement('span',{style:{cursor:'pointer'},className:'wea-hrm-linkstyle',onClick:_this.jumpToReport.bind(null,record.randomFieldId)},record.formlabel);};}else{c.render=function(text,record){var valueSpan=record[c.dataIndex+"span"]!==undefined?record[c.dataIndex+"span"]:record[c.dataIndex];return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:valueSpan}});};}});return columns;}},{key:'jumpToReport',value:function jumpToReport(scopeId){var router=this.context.router;if(router){router.push({pathname:'/main/hrm/constrpsubsearch/'+scopeId,query:{isCustom:"1"}});}}},{key:'getRightMenu',value:function getRightMenu(){var keys=this.getSelectedRowKeys();var arr=[{icon:_react2.default.createElement('i',{className:'icon-coms-ws'}),content:_i18n.i18n.button.search()},{icon:_react2.default.createElement('i',{className:'icon-coms-task-list'}),content:_i18n.i18n.button.columnVisibleSetting()}];return arr;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmRpSubSearch=this.props.hrmRpSubSearch;switch(key){case'0':hrmRpSubSearch.doSearch();break;case'1':this.definedColumn();break;}}},{key:'getSelectedRowKeys',value:function getSelectedRowKeys(){var hrmRpSubSearch=this.props.hrmRpSubSearch;var table=hrmRpSubSearch.table;var selectedRowKeys=table.selectedRowKeys;return selectedRowKeys;}},{key:'definedColumn',value:function definedColumn(){var hrmRpSubSearch=this.props.hrmRpSubSearch;var table=hrmRpSubSearch.table;table.setColSetVisible(true);table.tableColSet(true);}},{key:'getTabButtonsAd',value:function getTabButtonsAd(){var hrmRpSubSearch=this.props.hrmRpSubSearch;var form=hrmRpSubSearch.form,searchParamsAd=hrmRpSubSearch.searchParamsAd;return[_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){hrmRpSubSearch.doSearch();hrmRpSubSearch.setShowSearchAd(false);}},_i18n.i18n.button.search()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){form.reset();}},_i18n.i18n.button.reset()),_react2.default.createElement(_antd.Button,{type:'ghost',onClick:function onClick(){hrmRpSubSearch.setShowSearchAd(false);}},_i18n.i18n.button.cancel())];}}]);return RpSubSearch;}(_react2.default.Component),_class2.contextTypes={router:_reactRouter.routerShape},_temp))||_class)||_class);exports.default=RpSubSearch;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class,_class2,_temp;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _comsMobx=__webpack_require__(10);__webpack_require__(254);var _reactRouter=__webpack_require__(57);var _debounce=__webpack_require__(49);var _debounce2=_interopRequireDefault(_debounce);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _i18n=__webpack_require__(11);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var TabPane=_antd.Tabs.TabPane;var Main=(_dec=(0,_mobxReact.inject)('hrmScheduleDiffReport'),_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.getDetailRightMenu=function(){var hrmScheduleDiffReport=_this.props.hrmScheduleDiffReport;var rightMenu=[];rightMenu.push({key:'1',content:_i18n.i18n.button.export(),icon:_react2.default.createElement('i',{className:'icon-coms-export'}),onClick:function onClick(){return hrmScheduleDiffReport.exportDetialExcel();}});return rightMenu;};var funcs=['getReportData'];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});return _this;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;this.init();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;if(this.props.location.key!==nextProps.location.key){this.init();}}},{key:'init',value:function init(){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;hrmScheduleDiffReport.getSearchCondition();}},{key:'doSearch',value:function doSearch(){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;hrmScheduleDiffReport.getData();}},{key:'getRightMenu',value:function getRightMenu(){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;var btns=[];var btnImportExcel={icon:_react2.default.createElement('i',{className:'icon-coms-export'}),content:_i18n.i18n.button.export()};btns.push(btnImportExcel);return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;switch(key){case'0':hrmScheduleDiffReport.exportExcel();break;case'1':break;}}},{key:'getTopButtons',value:function getTopButtons(){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;var btns=[];var btnExportExcel=_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmScheduleDiffReport.exportExcel();}},_i18n.i18n.button.export());btns.push(btnExportExcel);return btns;}},{key:'getTableRow',value:function getTableRow(){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;var reportdata=hrmScheduleDiffReport.reportdata;reportdata=(0,_mobx.toJS)(reportdata);var rows=[];!(0,_isEmpty2.default)(reportdata.titlerows)&&reportdata.titlerows.forEach(function(row){var cells=[];!(0,_isEmpty2.default)(row)&&row.forEach(function(cell){cells.push(_react2.default.createElement('td',{rowspan:cell.rowspan||'',colspan:cell.colspan||''},cell.value));});rows.push(_react2.default.createElement('tr',null,cells));});!(0,_isEmpty2.default)(reportdata.datarows)&&reportdata.datarows.forEach(function(row){var cells=[];!(0,_isEmpty2.default)(row)&&row.forEach(function(cell){cells.push(_react2.default.createElement('td',{className:'data',rowspan:cell.rowspan||'',colspan:cell.colspan||''},cell.value));});rows.push(_react2.default.createElement('tr',null,cells));});return rows;}},{key:'getBtns',value:function getBtns(){var _this2=this;return[_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('SIGININ');}},_i18n.i18n.label.signInDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('SIGINOUT');}},_i18n.i18n.label.signOutDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('BELATE');}},_i18n.i18n.label.lateDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('LEAVEEARLY');}},_i18n.i18n.label.earlyRetreatDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('ABSENT');}},_i18n.i18n.label.absenteeismDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('NOSIGN');}},_i18n.i18n.label.leakageOfSignatureDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('LEAVE');}},_i18n.i18n.label.leaveDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('EVECTION');}},_i18n.i18n.label.businessTripDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('OUTDAYS');}},_i18n.i18n.label.publicDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('OVERTIME');}},_i18n.i18n.label.overtimeWorkDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('OTHER');}},_i18n.i18n.label.attendanceAnomalyDetail()))];return btns;}},{key:'getDetialBtns',value:function getDetialBtns(){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;var btns=[];var btnExportExcel=_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmScheduleDiffReport.exportDetialExcel();}},_i18n.i18n.button.export());btns.push(btnExportExcel);return btns;}},{key:'getDetial',value:function getDetial(stsType){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;hrmScheduleDiffReport.stsType=stsType;hrmScheduleDiffReport.getTabTableData();hrmScheduleDiffReport.updateVisible(true);}},{key:'getReportData',value:function getReportData(params){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;hrmScheduleDiffReport.getReportData(params);}},{key:'render',value:function render(){var hrmScheduleDiffReport=this.props.hrmScheduleDiffReport;var title=hrmScheduleDiffReport.title,form=hrmScheduleDiffReport.form,table=hrmScheduleDiffReport.table,config=hrmScheduleDiffReport.config,loading=hrmScheduleDiffReport.loading,reportdata=hrmScheduleDiffReport.reportdata,visible=hrmScheduleDiffReport.visible,dialogTitle=hrmScheduleDiffReport.dialogTitle,lastname=hrmScheduleDiffReport.lastname,selectedKey=hrmScheduleDiffReport.selectedKey,setSelectedKey=hrmScheduleDiffReport.setSelectedKey,topTab=hrmScheduleDiffReport.topTab;var qSize=reportdata.qSize;reportdata=(0,_mobx.toJS)(reportdata);var cols=[];for(var i=0;i<qSize+13;i++){var width="6%";if(i==0||i==1)width="9%";cols.push(_react2.default.createElement('col',{style:{width:width}}));}return _react2.default.createElement('div',{className:'wea-hrm-schedulediffreport'},_react2.default.createElement(_ecCom.WeaDialog,{visible:visible,onCancel:function onCancel(){return hrmScheduleDiffReport.updateVisible(false);},onClo:true,closable:true,style:{width:900,height:window.innerHeight-250>500?500:window.innerHeight-250},title:dialogTitle,icon:'icon-coms-hrm',iconBgcolor:'#217346',buttons:this.getDetialBtns(),moreBtn:{datas:this.getDetailRightMenu()}},!(0,_isEmpty2.default)(topTab)&&_react2.default.createElement(_ecCom.WeaTab,{datas:topTab,keyParam:'key'//主键
,selectedKey:selectedKey,onChange:function onChange(key){return setSelectedKey(key);}}),_react2.default.createElement(_ecCom.WeaNewScroll,{height:window.innerHeight-250>500?500:window.innerHeight-250,ref:'scrollBar'},_react2.default.createElement(WeaTable,{comsWeaTableStore:table}))),_react2.default.createElement(_antd.Spin,{spinning:loading},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},_react2.default.createElement(_ecCom.WeaTop,{title:title(),loading:false,icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu(),onDropMenuClick:this.onRightMenuClick.bind(this)},_react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'wea-hrm-schedulediffreport-condition'},!(0,_isEmpty2.default)(config)&&_react2.default.createElement(_ecCom.WeaRadioGroup,{config:config,onChange:(0,_debounce2.default)(this.getReportData.bind(this),150)})),!(0,_isEmpty2.default)(reportdata)&&_react2.default.createElement('div',{className:'wea-hrm-schedulediffreport-content'},_react2.default.createElement('table',{className:'wea-hrm-schedulediffreport-table'},_react2.default.createElement('colgroup',null,cols),_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'title',colspan:qSize+13},reportdata.title)),this.getTableRow())),_react2.default.createElement('table',{border:'0',width:'100%'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',{align:'right',style:{height:50}},_i18n.i18n.label.reportDate(),'\uFF1A',Util.DateFormat(new Date(),"yyyy-MM-dd"))))))),!(0,_isEmpty2.default)(reportdata)&&_react2.default.createElement('div',{className:'wea-hrm-schedulediffreport-foot'},_react2.default.createElement('table',{className:'table-foot',border:'0',width:'100%'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',null,this.getBtns())))))))));}}]);return Main;}(_react2.default.Component),_class2.contextTypes={router:_reactRouter.routerShape},_temp))||_class)||_class);exports.default=Main;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class,_class2,_temp;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _comsMobx=__webpack_require__(10);__webpack_require__(254);var _reactRouter=__webpack_require__(57);var _debounce=__webpack_require__(49);var _debounce2=_interopRequireDefault(_debounce);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var TabPane=_antd.Tabs.TabPane;var Main=(_dec=(0,_mobxReact.inject)('hrmScheduleDiffReport4Formal'),_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.getDetailRightMenu=function(){var hrmScheduleDiffReport4Formal=_this.props.hrmScheduleDiffReport4Formal;var rightMenu=[];rightMenu.push({key:'1',content:_i18n.i18n.button.export(),icon:_react2.default.createElement('i',{className:'icon-coms-export'}),onClick:function onClick(){return hrmScheduleDiffReport4Formal.exportDetialExcel();}});return rightMenu;};var funcs=['getReportData'];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});return _this;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;this.init();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;if(this.props.location.key!==nextProps.location.key){this.init();}}},{key:'init',value:function init(){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;hrmScheduleDiffReport4Formal.getSearchCondition();}},{key:'doSearch',value:function doSearch(){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;hrmScheduleDiffReport4Formal.getData();}},{key:'getRightMenu',value:function getRightMenu(){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;var btns=[];var btnImportExcel={icon:_react2.default.createElement('i',{className:'icon-coms-export'}),content:_i18n.i18n.button.export()};btns.push(btnImportExcel);return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;switch(key){case'0':hrmScheduleDiffReport4Formal.exportExcel();break;case'1':break;}}},{key:'getTopButtons',value:function getTopButtons(){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;var btns=[];var btnExportExcel=_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmScheduleDiffReport4Formal.exportExcel();}},_i18n.i18n.button.export());btns.push(btnExportExcel);return btns;}},{key:'getTableRow',value:function getTableRow(){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;var reportdata=hrmScheduleDiffReport4Formal.reportdata;reportdata=(0,_mobx.toJS)(reportdata);var rows=[];!(0,_isEmpty2.default)(reportdata.titlerows)&&reportdata.titlerows.forEach(function(row){var cells=[];!(0,_isEmpty2.default)(row)&&row.forEach(function(cell){cells.push(_react2.default.createElement('td',{rowspan:cell.rowspan||'',colspan:cell.colspan||''},cell.value));});rows.push(_react2.default.createElement('tr',null,cells));});!(0,_isEmpty2.default)(reportdata.datarows)&&reportdata.datarows.forEach(function(row){var cells=[];!(0,_isEmpty2.default)(row)&&row.forEach(function(cell){cells.push(_react2.default.createElement('td',{className:'data',rowspan:cell.rowspan||'',colspan:cell.colspan||''},cell.value));});rows.push(_react2.default.createElement('tr',null,cells));});return rows;}},{key:'getBtns',value:function getBtns(){var _this4=this;var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;var reportdata=hrmScheduleDiffReport4Formal.reportdata;reportdata=(0,_mobx.toJS)(reportdata);var lateRuleData=[];var earlyRuleData=[];var lateRuleDataList=reportdata.lateRuleList;var earlyRuleDataList=reportdata.earlyRuleList;if(!(0,_isEmpty2.default)(lateRuleDataList)){lateRuleDataList.map(function(datas,i){var _this2=this;lateRuleData.push(_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this2.getDetial('BELATERULE',datas.reportname,datas.id);}},datas.reportname+_i18n.i18n.label.lateDetail())));},this);}if(!(0,_isEmpty2.default)(earlyRuleDataList)){earlyRuleDataList.map(function(datas,i){var _this3=this;earlyRuleData.push(_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this3.getDetial('LEAVEEARLYRULE',datas.reportname,datas.id);}},datas.reportname+_i18n.i18n.label.earlyRetreatDetail())));},this);}return[_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('SIGININ');}},_i18n.i18n.label.signInDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('SIGINOUT');}},_i18n.i18n.label.signOutDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('BELATE');}},_i18n.i18n.label.lateDetail())),lateRuleData,_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('ABSENTBELATE');}},_i18n.i18n.label.absentlateDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('LEAVEEARLY');}},_i18n.i18n.label.earlyRetreatDetail())),earlyRuleData,_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('ABSENT');}},_i18n.i18n.label.absenteeismDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('NOSIGN');}},_i18n.i18n.label.leakageOfSignatureDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('LEAVE');}},_i18n.i18n.label.leaveDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('EVECTION');}},_i18n.i18n.label.businessTripDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('OUTDAYS');}},_i18n.i18n.label.publicDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('OVERTIME');}},_i18n.i18n.label.overtimeWorkDetail())),_react2.default.createElement('span',{className:'btn'},_react2.default.createElement(_antd.Button,{onClick:function onClick(){return _this4.getDetial('OTHER');}},_i18n.i18n.label.attendanceAnomalyDetail()))];return btns;}},{key:'getDetialBtns',value:function getDetialBtns(){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;var btns=[];var btnExportExcel=_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmScheduleDiffReport4Formal.exportDetialExcel();}},_i18n.i18n.button.export());btns.push(btnExportExcel);return btns;}},{key:'getDetial',value:function getDetial(stsType,reportname,ruleid){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;hrmScheduleDiffReport4Formal.stsType=stsType;hrmScheduleDiffReport4Formal.reportname=reportname;hrmScheduleDiffReport4Formal.ruleid=ruleid||'';hrmScheduleDiffReport4Formal.getTabTableData();hrmScheduleDiffReport4Formal.updateVisible(true);}},{key:'getReportData',value:function getReportData(params){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;hrmScheduleDiffReport4Formal.getReportData(params);}},{key:'render',value:function render(){var hrmScheduleDiffReport4Formal=this.props.hrmScheduleDiffReport4Formal;var title=hrmScheduleDiffReport4Formal.title,form=hrmScheduleDiffReport4Formal.form,table=hrmScheduleDiffReport4Formal.table,config=hrmScheduleDiffReport4Formal.config,loading=hrmScheduleDiffReport4Formal.loading,reportdata=hrmScheduleDiffReport4Formal.reportdata,visible=hrmScheduleDiffReport4Formal.visible,dialogTitle=hrmScheduleDiffReport4Formal.dialogTitle,lastname=hrmScheduleDiffReport4Formal.lastname,selectedKey=hrmScheduleDiffReport4Formal.selectedKey,setSelectedKey=hrmScheduleDiffReport4Formal.setSelectedKey,topTab=hrmScheduleDiffReport4Formal.topTab;var qSize=reportdata.qSize;var lateRuleSize=(0,_isEmpty2.default)(reportdata.lateRuleSize)?0:reportdata.lateRuleSize;var earlyRuleSize=(0,_isEmpty2.default)(reportdata.earlyRuleSize)?0:reportdata.earlyRuleSize;reportdata=(0,_mobx.toJS)(reportdata);var cols=[];for(var i=0;i<lateRuleSize+earlyRuleSize+qSize+15;i++){var width="6%";if(i==0||i==1)width="9%";cols.push(_react2.default.createElement('col',{style:{width:width}}));}return _react2.default.createElement('div',{className:'wea-hrm-schedulediffreport'},_react2.default.createElement(_ecCom.WeaDialog,{visible:visible,onCancel:function onCancel(){return hrmScheduleDiffReport4Formal.updateVisible(false);},closable:true,style:{width:900,height:window.innerHeight-250>500?500:window.innerHeight-250},title:dialogTitle,icon:'icon-coms-hrm',iconBgcolor:'#217346',buttons:this.getDetialBtns(),moreBtn:{datas:this.getDetailRightMenu()}},!(0,_isEmpty2.default)(topTab)&&_react2.default.createElement(_ecCom.WeaTab,{datas:topTab,keyParam:'key'//主键
,selectedKey:selectedKey,onChange:function onChange(key){return setSelectedKey(key);}}),_react2.default.createElement(_ecCom.WeaNewScroll,{height:window.innerHeight-250>500?500:window.innerHeight-250,ref:'scrollBar'},_react2.default.createElement(WeaTable,{comsWeaTableStore:table}))),_react2.default.createElement(_antd.Spin,{spinning:loading},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},_react2.default.createElement(_ecCom.WeaTop,{title:title(),loading:false,icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu(),onDropMenuClick:this.onRightMenuClick.bind(this)},_react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'wea-hrm-schedulediffreport-condition'},!(0,_isEmpty2.default)(config)&&_react2.default.createElement(_ecCom.WeaRadioGroup,{config:config,onChange:(0,_debounce2.default)(this.getReportData.bind(this),150)})),!(0,_isEmpty2.default)(reportdata)&&_react2.default.createElement('div',{className:'wea-hrm-schedulediffreport-content'},_react2.default.createElement('table',{className:'wea-hrm-schedulediffreport-table'},_react2.default.createElement('colgroup',null,cols),_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',{className:'title',colspan:15+qSize+lateRuleSize+earlyRuleSize},reportdata.title)),this.getTableRow())),_react2.default.createElement('table',{border:'0',width:'100%'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',{align:'right',style:{height:50}},_i18n.i18n.label.reportDate(),'\uFF1A',Util.DateFormat(new Date(),"yyyy-MM-dd"))))))),!(0,_isEmpty2.default)(reportdata)&&_react2.default.createElement('div',{className:'wea-hrm-schedulediffreport-foot'},_react2.default.createElement('table',{className:'table-foot',border:'0',width:'100%'},_react2.default.createElement('tbody',null,_react2.default.createElement('tr',null,_react2.default.createElement('td',null,this.getBtns())))))))));}}]);return Main;}(_react2.default.Component),_class2.contextTypes={router:_reactRouter.routerShape},_temp))||_class)||_class);exports.default=Main;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class,_class2,_temp;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);__webpack_require__(493);var _reactRouter=__webpack_require__(57);var _debounce=__webpack_require__(49);var _debounce2=_interopRequireDefault(_debounce);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('hrmScheduleDiffMonthAttDetail'),_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.getDetailRightMenu=function(){var hrmScheduleDiffReport=_this.props.hrmScheduleDiffReport;var rightMenu=[];return rightMenu;};var funcs=['getReportData'];funcs.forEach(function(f){return _this[f]=_this[f].bind(_this);});return _this;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;hrmScheduleDiffMonthAttDetail.resetConfig();this.init();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;if(this.props.location.key!==nextProps.location.key){hrmScheduleDiffMonthAttDetail.resetConfig();this.init();}}},{key:'init',value:function init(){var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;var pDate=hrmScheduleDiffMonthAttDetail.pDate;hrmScheduleDiffMonthAttDetail.getSearchCondition({},function(config){var yearmonth=config[0];var com=_react2.default.createElement('div',{style:{lineHeight:'40px'}},_react2.default.createElement(_ecCom.WeaDatePicker,{arrow:true,type:'month',style:{marginRight:10},value:pDate,date:pDate,onChange:function onChange(value){return hrmScheduleDiffMonthAttDetail.changeDate(value);}}));yearmonth.options=[];yearmonth.com=com;});}},{key:'doSearch',value:function doSearch(){var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;hrmScheduleDiffMonthAttDetail.getData();}},{key:'exportExcel',value:function exportExcel(){var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;hrmScheduleDiffMonthAttDetail.exportExcel();}},{key:'getRightMenu',value:function getRightMenu(){var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;var btns=[];var btnImportExcel={icon:_react2.default.createElement('i',{className:'icon-coms-export'}),content:_i18n.i18n.button.export()};btns.push(btnImportExcel);return btns;}},{key:'onRightMenuClick',value:function onRightMenuClick(key){var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;switch(key){case'0':this.exportExcel();break;case'1':break;}}},{key:'getTopButtons',value:function getTopButtons(){var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;var btns=[];var btnExportExcel=_react2.default.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return hrmScheduleDiffMonthAttDetail.exportExcel();}},_i18n.i18n.button.export());btns.push(btnExportExcel);return btns;}},{key:'getTableRow',value:function getTableRow(){var _this2=this;var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;var reportdata=hrmScheduleDiffMonthAttDetail.reportdata;reportdata=(0,_mobx.toJS)(reportdata);var rows=[];!(0,_isEmpty2.default)(reportdata.titlerows)&&reportdata.titlerows.forEach(function(row){var cells=[];!(0,_isEmpty2.default)(row)&&row.forEach(function(cell){cells.push(_react2.default.createElement('td',{rowspan:cell.rowspan||'',colspan:cell.colspan||''},cell.value));});rows.push(_react2.default.createElement('tr',null,cells));});!(0,_isEmpty2.default)(reportdata.datarows)&&reportdata.datarows.forEach(function(row){var cells=[];!(0,_isEmpty2.default)(row)&&row.forEach(function(cell){var params={};var backgroundColor=cell.backgroundColor||'';var title=cell.title||'';if(cell.resourceid){params.resourceId=cell.resourceid;params.curDate=cell.currentdate;cells.push(_react2.default.createElement('td',{className:'data',style:{cursor:'pointer',backgroundColor:backgroundColor},title:title,onClick:function onClick(){_this2.getDetial(params);}},cell.value));}else{cells.push(_react2.default.createElement('td',{className:'data',style:{backgroundColor:backgroundColor},title:title},cell.value));}});rows.push(_react2.default.createElement('tr',null,cells));});return rows;}},{key:'getDetialBtns',value:function getDetialBtns(){return[];}},{key:'getDetial',value:function getDetial(params){var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;hrmScheduleDiffMonthAttDetail.getTableData(params);hrmScheduleDiffMonthAttDetail.updateVisible(true);}},{key:'getReportData',value:function getReportData(params){var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;hrmScheduleDiffMonthAttDetail.getReportData(params);}},{key:'render',value:function render(){var hrmScheduleDiffMonthAttDetail=this.props.hrmScheduleDiffMonthAttDetail;var title=hrmScheduleDiffMonthAttDetail.title,form=hrmScheduleDiffMonthAttDetail.form,config=hrmScheduleDiffMonthAttDetail.config,loading=hrmScheduleDiffMonthAttDetail.loading,reportdata=hrmScheduleDiffMonthAttDetail.reportdata,visible=hrmScheduleDiffMonthAttDetail.visible,dialogTitle=hrmScheduleDiffMonthAttDetail.dialogTitle,table=hrmScheduleDiffMonthAttDetail.table,table1=hrmScheduleDiffMonthAttDetail.table1,showFList=hrmScheduleDiffMonthAttDetail.showFList;reportdata=(0,_mobx.toJS)(reportdata);var cols=[];!(0,_isEmpty2.default)(reportdata.titlerows)&&reportdata.titlerows.forEach(function(row){var width="3%";cols.push(_react2.default.createElement('col',{style:{width:width}}));});return _react2.default.createElement('div',{className:'wea-hrm-schedulediffmonthreport'},_react2.default.createElement(_ecCom.WeaDialog,{visible:visible,onCancel:function onCancel(){return hrmScheduleDiffMonthAttDetail.updateVisible(false);},closable:true,style:{width:900,height:window.innerHeight-250>500?500:window.innerHeight-250},title:dialogTitle(),icon:'icon-coms-hrm',iconBgcolor:'#217346',buttons:this.getDetialBtns(),moreBtn:{datas:this.getDetailRightMenu()}},_react2.default.createElement(_ecCom.WeaNewScroll,{height:window.innerHeight-250>500?500:window.innerHeight-250,ref:'scrollBar'},!(0,_isEmpty2.default)(table)&&_react2.default.createElement(_ecCom.WeaTable,{dataSource:table.datas,columns:table.columns,pagination:false}),showFList&&!(0,_isEmpty2.default)(table1)&&_react2.default.createElement(_ecCom.WeaTable,{dataSource:table1.datas,columns:(0,_mobx.toJS)(table1.columns),pagination:false}))),_react2.default.createElement(_antd.Spin,{spinning:loading},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu(),onClick:this.onRightMenuClick.bind(this)},_react2.default.createElement(_ecCom.WeaTop,{title:title(),loading:false,icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',buttons:this.getTopButtons(),buttonSpace:10,showDropIcon:true,dropMenuDatas:this.getRightMenu(),onDropMenuClick:this.onRightMenuClick.bind(this)},_react2.default.createElement('div',{className:'content'},_react2.default.createElement('div',{className:'wea-hrm-schedulediffmonthreport-condition'},!(0,_isEmpty2.default)(config)&&_react2.default.createElement(_ecCom.WeaRadioGroup,{config:config,onChange:(0,_debounce2.default)(this.getReportData.bind(this),150)})),!(0,_isEmpty2.default)(reportdata)&&_react2.default.createElement('div',{className:'wea-hrm-schedulediffmonthreport-content'},_react2.default.createElement('table',{className:'wea-hrm-schedulediffmonthreport-table'},_react2.default.createElement('colgroup',null,cols),_react2.default.createElement('tbody',null,this.getTableRow()))))))));}}]);return Main;}(_react2.default.Component),_class2.contextTypes={router:_reactRouter.routerShape},_temp))||_class)||_class);exports.default=Main;

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;__webpack_require__(495);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);var _Chart=__webpack_require__(496);var _Chart2=_interopRequireDefault(_Chart);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var OrgChart=(_dec=(0,_mobxReact.inject)('hrmOrgChart'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){(0,_inherits3.default)(OrgChart,_Component);function OrgChart(props){(0,_classCallCheck3.default)(this,OrgChart);var _this=(0,_possibleConstructorReturn3.default)(this,(OrgChart.__proto__||(0,_getPrototypeOf2.default)(OrgChart)).call(this,props));_this.messageHandle=function(e){var store=_this.props.hrmOrgChart;if(e.data.act=='initOrgChart'){store.onInitOrgChart(e.data.status);}else if(e.data.act=='callChild'){store.showSpin(e.data.status);}};_this.init=function(){var refresh=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var store=_this.props.hrmOrgChart;var initData=store.initData;initData(refresh);};return _this;}(0,_createClass3.default)(OrgChart,[{key:'componentDidMount',value:function componentDidMount(){this.init();window.addEventListener('message',this.messageHandle,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('message',this.messageHandle,false);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location.key!==nextProps.location.key){this.init(true);}}},{key:'render',value:function render(){var store=this.props.hrmOrgChart;var containerInitFinished=store.containerInitFinished,topBtnAndMenu=store.topBtnAndMenu,spinning=store.spinning;var _topBtnAndMenu=topBtnAndMenu(),btns=_topBtnAndMenu.btns,menus=_topBtnAndMenu.menus;var topProps={title:_i18n.i18n.module.orgChart(),icon:_react2.default.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',showDropIcon:true,buttons:btns,dropMenuDatas:menus};return _react2.default.createElement('div',{className:'hrm_module_container orgChart'},containerInitFinished.init&&containerInitFinished.authorized&&_react2.default.createElement(_antd.Spin,{spinning:spinning},_react2.default.createElement(_ecCom.WeaTop,topProps,_react2.default.createElement(_Chart2.default,{store:store}))),containerInitFinished.init&&!containerInitFinished.authorized&&_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},_i18n.i18n.message.authFailed())));}}]);return OrgChart;}(_react.Component))||_class)||_class);exports.default=OrgChart;

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _Tabs=__webpack_require__(227);var _Tabs2=_interopRequireDefault(_Tabs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Chart=(0,_mobxReact.observer)(_class=function(_Component){(0,_inherits3.default)(Chart,_Component);function Chart(props){(0,_classCallCheck3.default)(this,Chart);return(0,_possibleConstructorReturn3.default)(this,(Chart.__proto__||(0,_getPrototypeOf2.default)(Chart)).call(this,props));}(0,_createClass3.default)(Chart,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'render',value:function render(){var store=this.props.store;var setIframe=store.setIframe,tabConfig=store.tabConfig,tabChangeHandle=store.tabChangeHandle,getTabIndex=store.getTabIndex,formTarget=store.formTarget,generateTabBtn=store.generateTabBtn,refreshTab=store.refreshTab,topBtnAndMenu=store.topBtnAndMenu;var _topBtnAndMenu=topBtnAndMenu(),btns=_topBtnAndMenu.btns,menus=_topBtnAndMenu.menus;var form=formTarget.conditionForm,fields=formTarget.conditionFormFields;var tabProps={tabConfig:tabConfig,tabChangeHandle:tabChangeHandle,activeTabInfo:{activeTabKey:tabConfig.activeTabKey,activeTabIndex:getTabIndex(tabConfig.tabs,tabConfig.activeTabKey)},store:store,conditionForm:form,conditionFormFields:fields,tabBtnDef:tabConfig.buttons};var iframeHeight=$('.wea-new-top-content').height()-47;iframeHeight+='px';return _react2.default.createElement('div',{className:'frame'},_react2.default.createElement(_Tabs2.default,tabProps,_react2.default.createElement('div',{className:'tabPane',style:{bottom:10}},_react2.default.createElement(_ecCom.WeaRightMenu,{datas:menus},_react2.default.createElement('iframe',{id:'orgChartFrame',src:'/hrm/hrm_e9/orgChart/orgChart.html',style:{border:'none'},width:'100%',height:'100%',ref:function ref(dom){return setIframe(dom);}})))));}}]);return Chart;}(_react.Component))||_class;exports.default=Chart;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _forEach=__webpack_require__(46);var _forEach2=_interopRequireDefault(_forEach);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var toJS=mobx.toJS;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var BindTokenKey=(_dec=(0,_mobxReact.inject)('bindTokenKey'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(BindTokenKey,_React$Component);function BindTokenKey(props){(0,_classCallCheck3.default)(this,BindTokenKey);return(0,_possibleConstructorReturn3.default)(this,(BindTokenKey.__proto__||(0,_getPrototypeOf2.default)(BindTokenKey)).call(this,props));}(0,_createClass3.default)(BindTokenKey,[{key:'componentDidMount',value:function componentDidMount(){var bindTokenKey=this.props.bindTokenKey;var requestFrom=this.props.location.query.requestFrom||'';var syncTokenKey=this.props.location.query.syncTokenKey||'';var dialogId=this.props.location.query.dialogId||'';var langid=this.props.location.query.langid||'';bindTokenKey.dialogId=dialogId;if(langid){_ecCom.WeaLocaleProvider.getLocaleLabelByLang(['common','hrm'],langid).then(function(){if(syncTokenKey=='1'){bindTokenKey.title=function(){return getLabel(129202,"令牌同步");};}bindTokenKey.getFormField({requestFrom:requestFrom,syncTokenKey:syncTokenKey,langid:langid});});}else{if(syncTokenKey=='1'){bindTokenKey.title=function(){return getLabel(129202,"令牌同步");};}bindTokenKey.getFormField({requestFrom:requestFrom,syncTokenKey:syncTokenKey,langid:langid});}}},{key:'getRightMenu',value:function getRightMenu(){var _this2=this;var arr=[{icon:React.createElement('i',{className:'icon-coms-Batch-delete'}),content:_i18n.i18n.button.save(),key:'save',onClick:function onClick(key){_this2.save();}}];return arr;}},{key:'save',value:function save(){var bindTokenKey=this.props.bindTokenKey;var userid=this.props.location.query.userid||'';var requestFrom=this.props.location.query.requestFrom||'';var syncTokenKey=this.props.location.query.syncTokenKey||'';bindTokenKey.save({userid:userid,requestFrom:requestFrom,syncTokenKey:syncTokenKey});}},{key:'getFormField',value:function getFormField(){var bindTokenKey=this.props.bindTokenKey;var form=bindTokenKey.form,formFields=bindTokenKey.formFields;var isFormInit=form.isFormInit;var group=[];isFormInit&&!(0,_isEmpty2.default)(formFields)&&toJS(formFields).forEach(function(c){var items=[];c.items.forEach(function(field){items.push({com:React.createElement(_ecCom.WeaFormItem,{label:''+field.label,error:form.getError(field),tipPosition:'bottom',labelCol:{span:''+window.HrmLabelCol},wrapperCol:{span:''+window.HrmWrapperCol}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form})),colSpan:1});});group.push(React.createElement(_ecCom.WeaSearchGroup,{center:true,items:items,showGroup:true,size:'middle'}));});return group;}},{key:'render',value:function render(){var _this3=this;var bindTokenKey=this.props.bindTokenKey;var title=bindTokenKey.title,date=bindTokenKey.date;var dialogId=this.props.location.query.dialogId||'';var requestFrom=this.props.location.query.requestFrom||'';return React.createElement(_ecCom.WeaRightMenu,{datas:this.getRightMenu()},React.createElement(_ecCom.WeaTop,{title:title(),loading:false,icon:React.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346'},React.createElement('div',null,this.getFormField(),React.createElement('div',{style:{color:'red',fontSize:'10px',paddingLeft:requestFrom=='system'?'100px':'200px'}},getLabel('386545',"注意：一个口令只能用一次")),dialogId!=''&&React.createElement(_ecCom.WeaDialogFooter,{buttons:React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this3.save();}},_i18n.i18n.button.save())}))));}}]);return BindTokenKey;}(React.Component))||_class)||_class);exports.default=BindTokenKey;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _FormInfo=__webpack_require__(243);var _FormInfo2=_interopRequireDefault(_FormInfo);var _i18n=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLocaleLabelByLang=_ecCom.WeaLocaleProvider.getLocaleLabelByLang;var RoleInfoSingle=(_dec=(0,_mobxReact.inject)('hrmForgetPassword'),_dec(_class=(0,_mobxReact.observer)(_class=function(_Component){(0,_inherits3.default)(RoleInfoSingle,_Component);function RoleInfoSingle(props){(0,_classCallCheck3.default)(this,RoleInfoSingle);var _this=(0,_possibleConstructorReturn3.default)(this,(RoleInfoSingle.__proto__||(0,_getPrototypeOf2.default)(RoleInfoSingle)).call(this,props));_this.getDialogInfo=function(){return top.window.getParentDialog();};_this.init=function(){var _this$props=_this.props,store=_this$props.hrmForgetPassword,location=_this$props.location;store.initData(location.query.langid,_this.getDialogInfo,function(){return _this.setState({show:true});});};_this.state={show:false};return _this;}(0,_createClass3.default)(RoleInfoSingle,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var location=this.props.location;setTimeout(function(){getLocaleLabelByLang('common,hrm',location.query.langid).then(function(){_this2.init();});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.init();}},{key:'render',value:function render(){var store=this.props.hrmForgetPassword;var refreshForm=store.refreshForm,formTarget=store.formTarget,itemRender=store.itemRender,step=store.step,topBtnAndMenu=store.topBtnAndMenu,spinning=store.spinning;var findPasswordForm=formTarget.findPasswordForm,findPasswordFormFields=formTarget.findPasswordFormFields,checkForm=formTarget.checkForm,checkFormFields=formTarget.checkFormFields,passwordForm=formTarget.passwordForm,passwordFormFields=formTarget.passwordFormFields;var _topBtnAndMenu=topBtnAndMenu(),btns=_topBtnAndMenu.btns,menus=_topBtnAndMenu.menus;return _react2.default.createElement(_antd.Spin,{spinning:spinning},_react2.default.createElement('div',{style:{height:245}},_react2.default.createElement('div',{style:{width:600,margin:'0px auto'}},step===1&&_react2.default.createElement(_FormInfo2.default,{center:false,form:findPasswordForm,formFields:findPasswordFormFields,itemRender:itemRender,menus:menus}),step===2&&_react2.default.createElement(_FormInfo2.default,{center:false,form:checkForm,formFields:checkFormFields,itemRender:itemRender,menus:menus}),step===3&&_react2.default.createElement(_FormInfo2.default,{center:false,form:passwordForm,formFields:passwordFormFields,itemRender:itemRender,menus:menus})),this.state.show&&_react2.default.createElement(_ecCom.WeaDialogFooter,{buttons:btns,moreBtn:{datas:menus}})));}}]);return RoleInfoSingle;}(_react.Component))||_class)||_class);exports.default=RoleInfoSingle;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _Top=__webpack_require__(500);var _Top2=_interopRequireDefault(_Top);var _MainDialog=__webpack_require__(513);var _MainDialog2=_interopRequireDefault(_MainDialog);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Applicant=(_dec=(0,_mobxReact.inject)('hrmApplicant'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Applicant,_React$Component);//todo
function Applicant(props){(0,_classCallCheck3.default)(this,Applicant);return(0,_possibleConstructorReturn3.default)(this,(Applicant.__proto__||(0,_getPrototypeOf2.default)(Applicant)).call(this,props));}(0,_createClass3.default)(Applicant,[{key:'componentWillMount',value:function componentWillMount(){if(window.location.href.indexOf('/spa/hrm/engine.html')>-1){document.title=getLabel('391168',"应聘人员");}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location&&this.props.location.key!==nextProps.location.key){this.props.hrmApplicant.refresh();}}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'init',value:function init(){var hrmApplicant=this.props.hrmApplicant,getAuth=hrmApplicant.getAuth,onresize=hrmApplicant.onresize;getAuth();window.addEventListener('resize',onresize);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var hrmApplicant=this.props.hrmApplicant,onresize=hrmApplicant.onresize;window.removeEventListener('resize',onresize);}},{key:'render',value:function render(){var hrmApplicant=this.props.hrmApplicant,main=hrmApplicant.main,loading=main.loading,authorized=main.authorized;if(!authorized){return _react2.default.createElement('div',{style:{height:'100%'}},loading?_react2.default.createElement('div',{className:'hrm-loading-center'},_react2.default.createElement(_antd.Spin,{spinning:loading,size:'large'})):_react2.default.createElement('div',{className:'hrm-wea-alert-page'},_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},getLabel(2012,'对不起，您暂时没有权限！')))));}else{return _react2.default.createElement('div',null,_react2.default.createElement(_Top2.default,null),_react2.default.createElement(_MainDialog2.default,null));}}}]);return Applicant;}(_react2.default.Component))||_class)||_class);exports.default=Applicant;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _RadioGroup=__webpack_require__(501);var _RadioGroup2=_interopRequireDefault(_RadioGroup);var _BarCharts=__webpack_require__(502);var _BarCharts2=_interopRequireDefault(_BarCharts);var _TabsWp=__webpack_require__(503);var _TabsWp2=_interopRequireDefault(_TabsWp);var _Footnote=__webpack_require__(512);var _Footnote2=_interopRequireDefault(_Footnote);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Top=(_dec=(0,_mobxReact.inject)('hrmApplicant'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Top,_React$Component);function Top(props){(0,_classCallCheck3.default)(this,Top);return(0,_possibleConstructorReturn3.default)(this,(Top.__proto__||(0,_getPrototypeOf2.default)(Top)).call(this,props));}(0,_createClass3.default)(Top,[{key:'componentDidMount',value:function componentDidMount(){this.props.hrmApplicant.getMenus();}},{key:'render',value:function render(){var hrmApplicant=this.props.hrmApplicant,top=hrmApplicant.top,menus=hrmApplicant.menus,radioGroup=hrmApplicant.radioGroup,barCharts=hrmApplicant.barCharts,tabs=hrmApplicant.tabs,title=top.title,buttons=menus.buttons,dropMenuDatas=menus.dropMenuDatas;return React.createElement(_ecCom.WeaTop,{title:title,icon:React.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',loading:radioGroup.loading||barCharts.loading||tabs.loading,buttons:buttons,showDropIcon:true,dropMenuDatas:dropMenuDatas},React.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas,collectParams:{favname:title,favouritetype:5}},React.createElement(_RadioGroup2.default,null),React.createElement(_BarCharts2.default,null),React.createElement(_TabsWp2.default,null),React.createElement(_Footnote2.default,null)));}}]);return Top;}(React.Component))||_class)||_class);exports.default=Top;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=(_dec=(0,_mobxReact.inject)('hrmApplicant'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(RadioGroup,_React$Component);function RadioGroup(props){(0,_classCallCheck3.default)(this,RadioGroup);return(0,_possibleConstructorReturn3.default)(this,(RadioGroup.__proto__||(0,_getPrototypeOf2.default)(RadioGroup)).call(this,props));}(0,_createClass3.default)(RadioGroup,[{key:'componentDidMount',value:function componentDidMount(){this.props.hrmApplicant.getRadioGroupDatas();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmApplicant.resetRadioGroup();}},{key:'render',value:function render(){var hrmApplicant=this.props.hrmApplicant,radioGroup=hrmApplicant.radioGroup,radioGroupCallBack=hrmApplicant.radioGroupCallBack,config=radioGroup.config;return React.createElement('div',{style:{padding:16}},config.length>0&&React.createElement(_ecCom.WeaRadioGroup,{config:config,onChange:function onChange(params){return radioGroupCallBack(params);}}));}}]);return RadioGroup;}(React.Component))||_class)||_class);exports.default=RadioGroup;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _util=__webpack_require__(128);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var BarCharts=(_dec=(0,_mobxReact.inject)('hrmApplicant'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(BarCharts,_React$Component);function BarCharts(props){(0,_classCallCheck3.default)(this,BarCharts);var _this=(0,_possibleConstructorReturn3.default)(this,(BarCharts.__proto__||(0,_getPrototypeOf2.default)(BarCharts)).call(this,props));_this.setRef=function(ref,alias){var hrmApplicant=_this.props.hrmApplicant,setRef=hrmApplicant.setRef;_this[alias]=ref;setRef({ref:ref,alias:alias,type:'barCharts'});};_this.chartAction=function(chart,index){chart.off('click');chart.on('click',function(params){return _this.handleChartAction(params,index);});};_this.handleChartAction=function(params,index){var hrmApplicant=_this.props.hrmApplicant,barCharts=hrmApplicant.barCharts,openDialog=hrmApplicant.openDialog,ids=barCharts.ids;var name=params.name,dataIndex=params.dataIndex;openDialog('bar',index=='0'?{value:ids[dataIndex],valueSpan:name,valueObj:[{id:ids[dataIndex],name:name}]}:{createMonth:name});};_this.downloadImg=function(index,title){var cvs=document.getElementsByTagName('canvas');(0,_util.downloadCvs2Img)({cvs:cvs[index],title:title});};_this.count=-1;return _this;}(0,_createClass3.default)(BarCharts,[{key:'componentDidMount',value:function componentDidMount(){// this.props.hrmApplicant.getBarChartsDatas();
}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;[0,1].map(function(val){_this2['echart'+val]&&_this2['echart'+val].paint();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmApplicant.resetBarCharts();}},{key:'render',value:function render(){var _this3=this;var hrmApplicant=this.props.hrmApplicant,barCharts=hrmApplicant.barCharts,openDialog=hrmApplicant.openDialog,charts=barCharts.charts;this.count=-1;return(0,_mobx.toJS)(charts).map(function(chart,index){var title=chart.title,option=chart.option;var bl1=option.series[0].data.length>0;bl1&&_this3.count++;var ct=_this3.count;return React.createElement('div',{style:{float:index==0?'left':'right',width:'49%',paddingLeft:index==0?16:0,paddingRight:index==0?0:16}},React.createElement(_ecCom.WeaReportCard,{title:title,onMoreClick:function onMoreClick(){return openDialog('more');},onDownloadClick:function onDownloadClick(){return bl1&&_this3.downloadImg(ct,title);},operations:index==1&&React.createElement('i',{className:'icon-coms-download2',style:{cursor:'pointer'},onClick:function onClick(){return bl1&&_this3.downloadImg(_this3.count,title);}})},React.createElement('div',{style:{height:380,position:'relative'}},bl1?React.createElement(_ecCom.WeaEchart,{ref:function ref(_ref){return _this3.setRef(_ref,'echart'+index);},option:option,useDefault:false,chartAction:function chartAction(chart){return _this3.chartAction(chart,index);}}):React.createElement('i',{className:'icon-coms-blank',style:{fontSize:50,position:'absolute',top:'50%',left:'50%',marginLeft:-25,marginTop:-50}},React.createElement('span',{style:{display:'block',fontSize:12}},getLabel(83553,'暂无数据'))))));});}}]);return BarCharts;}(React.Component))||_class)||_class);exports.default=BarCharts;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(38);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _slicedToArray2=__webpack_require__(504);var _slicedToArray3=_interopRequireDefault(_slicedToArray2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _Query=__webpack_require__(511);var _Query2=_interopRequireDefault(_Query);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TabPane=_antd.Tabs.TabPane;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var TabsWp=(_dec=(0,_mobxReact.inject)('hrmApplicant'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(TabsWp,_React$Component);function TabsWp(props){(0,_classCallCheck3.default)(this,TabsWp);var _this=(0,_possibleConstructorReturn3.default)(this,(TabsWp.__proto__||(0,_getPrototypeOf2.default)(TabsWp)).call(this,props));_this.setRef=function(ref,alias){var hrmApplicant=_this.props.hrmApplicant,setRef=hrmApplicant.setRef;_this[alias]=ref;setRef({ref:ref,alias:alias,type:'tabs'});};_this.chartAction=function(chart,index){chart.off('click');chart.on('click',function(params){return _this.handleChartAction(params,index);});};_this.handleChartAction=function(params,index){var hrmApplicant=_this.props.hrmApplicant,tab=hrmApplicant.tab,query=hrmApplicant.query,openDialog=hrmApplicant.openDialog,ids0=tab.ids0,ids1=tab.ids1,value=query.value;var name=params.name,dataIndex=params.dataIndex;var obj=void 0;if(index==0){obj={category:ids0[dataIndex]};}if(index==1){obj={educationlevel:ids1[dataIndex]};}var is_other=!name.includes('-')?true:false;var _ref=!is_other?name.split('(')[0].split('-'):[],_ref2=(0,_slicedToArray3.default)(_ref,2),f=_ref2[0],t=_ref2[1];if([2,3].includes(index)){var _obj;obj=(_obj={},(0,_defineProperty3.default)(_obj,index==2?'salaryNeed':'workTime',is_other?-1:f*(index==2?10000:1)),(0,_defineProperty3.default)(_obj,index==2?'salaryNeedto':'workTimeto',is_other?-1:t*(index==2?10000:1)),(0,_defineProperty3.default)(_obj,index==2?'salaryNeedeRand':'workTimeRand',(value?value:index==2?5:2)*(index==2?10000:1)),_obj);}openDialog('pie',obj,true);};return _this;}(0,_createClass3.default)(TabsWp,[{key:'componentDidMount',value:function componentDidMount(){// this.props.hrmApplicant.getTabsDatas();
}},{key:'componentDidUpdate',value:function componentDidUpdate(){var hrmApplicant=this.props.hrmApplicant,tabs=hrmApplicant.tabs,key=tabs.key;this['echart'+key]&&this['echart'+key].paint();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmApplicant.resetTabs();}},{key:'render',value:function render(){var _this2=this;var hrmApplicant=this.props.hrmApplicant,tabs=hrmApplicant.tabs,tabsCallback=hrmApplicant.tabsCallback,charts=tabs.charts,key=tabs.key;return React.createElement('div',{style:{float:'left',width:'100%',padding:16}},React.createElement(_antd.Tabs,{onChange:function onChange(key){return tabsCallback(key);},type:'card'},(0,_mobx.toJS)(charts).map(function(chart,index){var title=chart.title,option=chart.option;var bl1=option.series[0].data.length>0;return React.createElement(TabPane,{tab:title,key:index},React.createElement(_Query2.default,{title:title,index:index,bl1:bl1}),React.createElement('div',{style:{height:380}},bl1?React.createElement('div',{style:{height:'100%'}},key==index&&React.createElement(_ecCom.WeaEchart,{ref:function ref(_ref3){return _this2.setRef(_ref3,'echart'+index);},option:chart.option,useDefault:false,chartAction:function chartAction(chart){return _this2.chartAction(chart,index);}})):React.createElement('i',{className:'icon-coms-blank',style:{fontSize:50,position:'absolute',top:'50%',left:'50%',marginLeft:-25,marginTop:-50}},React.createElement('span',{style:{display:'block',fontSize:12}},getLabel(83553,'暂无数据')))));})));}}]);return TabsWp;}(React.Component))||_class)||_class);exports.default=TabsWp;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(505);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(508);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(506), __esModule: true };

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(116);
__webpack_require__(93);
module.exports = __webpack_require__(507);


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(194);
var ITERATOR = __webpack_require__(30)('iterator');
var Iterators = __webpack_require__(81);
module.exports = __webpack_require__(20).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(509), __esModule: true };

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(116);
__webpack_require__(93);
module.exports = __webpack_require__(510);


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(35);
var get = __webpack_require__(193);
module.exports = __webpack_require__(20).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _util=__webpack_require__(128);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Query=(_dec=(0,_mobxReact.inject)('hrmApplicant'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Query,_React$Component);function Query(props){(0,_classCallCheck3.default)(this,Query);var _this=(0,_possibleConstructorReturn3.default)(this,(Query.__proto__||(0,_getPrototypeOf2.default)(Query)).call(this,props));_this.downloadImg=function(index,title){var cvs=document.getElementsByTagName('canvas');(0,_util.downloadCvs2Img)({cvs:cvs[cvs.length-1],title:title});};return _this;}(0,_createClass3.default)(Query,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmApplicant.resetQuery();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,hrmApplicant=_props.hrmApplicant,title=_props.title,index=_props.index,bl1=_props.bl1,query=hrmApplicant.query,tabs=hrmApplicant.tabs,inputCallback=hrmApplicant.inputCallback,getTabsDatas=hrmApplicant.getTabsDatas,value=query.value,key=tabs.key;return React.createElement('div',{style:{textAlign:'right'}},(key=='2'||key=='3')&&React.createElement('span',null,React.createElement('span',null,key==2?getLabel('391163',"年薪区间"):getLabel('391165',"年限区间")),React.createElement(_ecCom.WeaInput,{value:value,defaultValue:key=='2'?'5':'2',style:{display:'inline-block',width:55,margin:'0 15px'},onChange:function onChange(value){return inputCallback(value);}}),React.createElement('span',null,key==2?getLabel('391164',"万元"):getLabel('26577',"年")),React.createElement('i',{className:'icon-coms-Refresh wea-f14',style:{margin:'0 10px',cursor:'pointer'},onClick:function onClick(){return getTabsDatas();}})),React.createElement('i',{className:'icon-coms-download2 wea-f14',style:{marginRight:15,cursor:'pointer'},onClick:function onClick(){return bl1&&_this2.downloadImg(index,title);}}));}}]);return Query;}(React.Component))||_class)||_class);exports.default=Query;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _util=__webpack_require__(128);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Footnote=function(_React$Component){(0,_inherits3.default)(Footnote,_React$Component);function Footnote(props){(0,_classCallCheck3.default)(this,Footnote);return(0,_possibleConstructorReturn3.default)(this,(Footnote.__proto__||(0,_getPrototypeOf2.default)(Footnote)).call(this,props));}(0,_createClass3.default)(Footnote,[{key:'render',value:function render(){return React.createElement('div',{style:{float:'right',paddingRight:16}},getLabel('391162',"本报表数据统计截止到: ")+' '+(0,_util.format)('yyyy-MM-dd hh:mm'));}}]);return Footnote;}(React.Component);exports.default=Footnote;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _Tab=__webpack_require__(514);var _Tab2=_interopRequireDefault(_Tab);var _Table=__webpack_require__(515);var _Table2=_interopRequireDefault(_Table);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MainDialog=(_dec=(0,_mobxReact.inject)('hrmApplicant'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(MainDialog,_React$Component);function MainDialog(props){(0,_classCallCheck3.default)(this,MainDialog);var _this=(0,_possibleConstructorReturn3.default)(this,(MainDialog.__proto__||(0,_getPrototypeOf2.default)(MainDialog)).call(this,props));_this.getChildren=function(){return React.createElement('div',null,React.createElement(_Tab2.default,null),React.createElement(_Table2.default,null));};return _this;}(0,_createClass3.default)(MainDialog,[{key:'render',value:function render(){var hrmApplicant=this.props.hrmApplicant,mainDialog=hrmApplicant.mainDialog,closeDialog=hrmApplicant.closeDialog,buttons=hrmApplicant.buttons,style=hrmApplicant.style,dropMenuDatas=hrmApplicant.dropMenuDatas,title=mainDialog.title,visible=mainDialog.visible;return React.createElement(_ecCom.WeaDialog,{title:title,icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:visible,hasScroll:true,onCancel:function onCancel(){return closeDialog();},buttons:buttons,style:style},React.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas},visible&&this.getChildren()));}}]);return MainDialog;}(React.Component))||_class)||_class);exports.default=MainDialog;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Tab=(_dec=(0,_mobxReact.inject)('hrmApplicant'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Tab,_React$Component);function Tab(props){(0,_classCallCheck3.default)(this,Tab);return(0,_possibleConstructorReturn3.default)(this,(Tab.__proto__||(0,_getPrototypeOf2.default)(Tab)).call(this,props));}(0,_createClass3.default)(Tab,[{key:'componentDidMount',value:function componentDidMount(){var hrmApplicant=this.props.hrmApplicant,mainDialog=hrmApplicant.mainDialog,type=mainDialog.type;type!='more'&&this.props.hrmApplicant.getSearchCondition();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmApplicant.resetTab();}},{key:'render',value:function render(){var hrmApplicant=this.props.hrmApplicant,tab=hrmApplicant.tab,buttonsAd=hrmApplicant.buttonsAd,changePanelStatus=hrmApplicant.changePanelStatus,searchsAd=hrmApplicant.searchsAd,handleSearch=hrmApplicant.handleSearch,mainDialog=hrmApplicant.mainDialog,setSearchBaseValue=hrmApplicant.setSearchBaseValue,isPanelShow=tab.isPanelShow,conditionCount=tab.conditionCount,form=tab.form,searchBaseValue=tab.searchBaseValue,type=mainDialog.type;return React.createElement(_ecCom.WeaTab,{searchType:type=='more'?['base']:['base','advanced'],showSearchAd:isPanelShow,hasMask:false,advanceHeight:Math.ceil(conditionCount/2)*52+20,buttonsAd:buttonsAd,searchsBaseValue:type=='more'?searchBaseValue:form.getFormParams().name,setShowSearchAd:function setShowSearchAd(b){return changePanelStatus(b);},hideSearchAd:function hideSearchAd(){return changePanelStatus(false);},searchsAd:searchsAd,onSearch:function onSearch(){return handleSearch();},onSearchChange:function onSearchChange(val){type=='more'?setSearchBaseValue(val):form.updateFields({name:val});}});}}]);return Tab;}(React.Component))||_class)||_class);exports.default=Tab;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var Table=(_dec=(0,_mobxReact.inject)('hrmApplicant'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Table,_React$Component);function Table(props){(0,_classCallCheck3.default)(this,Table);var _this=(0,_possibleConstructorReturn3.default)(this,(Table.__proto__||(0,_getPrototypeOf2.default)(Table)).call(this,props));_this.reRenderColumns=function(columns){columns.map(function(c){if(c.dataIndex=='count'){//TODO
c.render=function(t,r){var count=r.count,total=r.total;return React.createElement(_ecCom.WeaProgress,{percent:count/total*100,format:function format(){return count;},strokeColor:'#6FBCEA'});};}});};return _this;}(0,_createClass3.default)(Table,[{key:'componentDidMount',value:function componentDidMount(){this.props.hrmApplicant.getTableInfo();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmApplicant.resetTable();}},{key:'render',value:function render(){var _this2=this;var hrmApplicant=this.props.hrmApplicant,table=hrmApplicant.table,tableStore=table.tableStore;return React.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,needScroll:true,getColumns:function getColumns(columns){return _this2.reRenderColumns(columns);}});}}]);return Table;}(React.Component))||_class)||_class);exports.default=Table;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _Top=__webpack_require__(517);var _Top2=_interopRequireDefault(_Top);var _MainDialog=__webpack_require__(524);var _MainDialog2=_interopRequireDefault(_MainDialog);__webpack_require__(527);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Usedemand=(_dec=(0,_mobxReact.inject)('hrmUsedemand'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Usedemand,_React$Component);//todo
function Usedemand(props){(0,_classCallCheck3.default)(this,Usedemand);return(0,_possibleConstructorReturn3.default)(this,(Usedemand.__proto__||(0,_getPrototypeOf2.default)(Usedemand)).call(this,props));}(0,_createClass3.default)(Usedemand,[{key:'componentWillMount',value:function componentWillMount(){if(window.location.href.indexOf('/spa/hrm/engine.html')>-1){document.title=getLabel('6131',"用工需求");//todo
}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location&&this.props.location.key!==nextProps.location.key){this.props.hrmUsedemand.refresh();}}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'init',value:function init(){var hrmUsedemand=this.props.hrmUsedemand,getAuth=hrmUsedemand.getAuth,onresize=hrmUsedemand.onresize;getAuth();window.addEventListener('resize',onresize);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var hrmUsedemand=this.props.hrmUsedemand,onresize=hrmUsedemand.onresize;window.removeEventListener('resize',onresize);}},{key:'render',value:function render(){var hrmUsedemand=this.props.hrmUsedemand,main=hrmUsedemand.main,loading=main.loading,authorized=main.authorized;if(!authorized){return _react2.default.createElement('div',{style:{height:'100%'}},loading?_react2.default.createElement('div',{className:'hrm-loading-center'},_react2.default.createElement(_antd.Spin,{spinning:loading,size:'large'})):_react2.default.createElement('div',{className:'hrm-wea-alert-page'},_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},getLabel(2012,'对不起，您暂时没有权限！')))));}else{return _react2.default.createElement('div',null,_react2.default.createElement(_Top2.default,null),_react2.default.createElement(_MainDialog2.default,null));}}}]);return Usedemand;}(_react2.default.Component))||_class)||_class);exports.default=Usedemand;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _RadioGroup=__webpack_require__(518);var _RadioGroup2=_interopRequireDefault(_RadioGroup);var _Summary=__webpack_require__(519);var _Summary2=_interopRequireDefault(_Summary);var _BarCharts=__webpack_require__(520);var _BarCharts2=_interopRequireDefault(_BarCharts);var _TabsWp=__webpack_require__(521);var _TabsWp2=_interopRequireDefault(_TabsWp);var _Footnote=__webpack_require__(523);var _Footnote2=_interopRequireDefault(_Footnote);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Top=(_dec=(0,_mobxReact.inject)('hrmUsedemand'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Top,_React$Component);function Top(props){(0,_classCallCheck3.default)(this,Top);return(0,_possibleConstructorReturn3.default)(this,(Top.__proto__||(0,_getPrototypeOf2.default)(Top)).call(this,props));}(0,_createClass3.default)(Top,[{key:'componentDidMount',value:function componentDidMount(){this.props.hrmUsedemand.getMenus();}},{key:'render',value:function render(){var hrmUsedemand=this.props.hrmUsedemand,top=hrmUsedemand.top,menus=hrmUsedemand.menus,radioGroup=hrmUsedemand.radioGroup,barCharts=hrmUsedemand.barCharts,tabs=hrmUsedemand.tabs,title=top.title,buttons=menus.buttons,dropMenuDatas=menus.dropMenuDatas;return React.createElement(_ecCom.WeaTop,{title:title,icon:React.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',loading:radioGroup.loading||barCharts.loading||tabs.loading,buttons:buttons,showDropIcon:true,dropMenuDatas:dropMenuDatas},React.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas,collectParams:{favname:title,favouritetype:5}},React.createElement(_RadioGroup2.default,null),React.createElement(_Summary2.default,null),React.createElement(_BarCharts2.default,null),React.createElement(_TabsWp2.default,null),React.createElement(_Footnote2.default,null)));}}]);return Top;}(React.Component))||_class)||_class);exports.default=Top;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=(_dec=(0,_mobxReact.inject)('hrmUsedemand'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(RadioGroup,_React$Component);function RadioGroup(props){(0,_classCallCheck3.default)(this,RadioGroup);return(0,_possibleConstructorReturn3.default)(this,(RadioGroup.__proto__||(0,_getPrototypeOf2.default)(RadioGroup)).call(this,props));}(0,_createClass3.default)(RadioGroup,[{key:'componentDidMount',value:function componentDidMount(){this.props.hrmUsedemand.getRadioGroupDatas();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmUsedemand.resetRadioGroup();}},{key:'render',value:function render(){var hrmUsedemand=this.props.hrmUsedemand,radioGroup=hrmUsedemand.radioGroup,radioGroupCallBack=hrmUsedemand.radioGroupCallBack,config=radioGroup.config;return React.createElement('div',{style:{padding:16}},config.length>0&&React.createElement(_ecCom.WeaRadioGroup,{config:config,onChange:function onChange(params){return radioGroupCallBack(params);}}));}}]);return RadioGroup;}(React.Component))||_class)||_class);exports.default=RadioGroup;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _antd=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Summary=(_dec=(0,_mobxReact.inject)('hrmUsedemand'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Summary,_React$Component);function Summary(props){(0,_classCallCheck3.default)(this,Summary);return(0,_possibleConstructorReturn3.default)(this,(Summary.__proto__||(0,_getPrototypeOf2.default)(Summary)).call(this,props));}(0,_createClass3.default)(Summary,[{key:'componentDidMount',value:function componentDidMount(){// this.props.hrmUsedemand.getSummaryDatas();
}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmUsedemand.resetSummaryDatas();}},{key:'render',value:function render(){var hrmUsedemand=this.props.hrmUsedemand,summary=hrmUsedemand.summary,openDialog=hrmUsedemand.openDialog,countDatas=summary.countDatas;return React.createElement('div',{className:'use-demand-count'},countDatas.map(function(cd,i){var iconBgColor=cd.iconBgColor,number=cd.number,icon=cd.icon,isRise=cd.isRise,label=cd.label,title=cd.title,percent=cd.percent;return React.createElement('div',{className:'use-demand-count-item',style:{width:1/countDatas.length*100+'%'}},React.createElement('div',{className:'use-demand-count-item-left'},React.createElement('i',{className:icon+' use-demand-count-item-icon',style:{backgroundColor:iconBgColor}})),React.createElement('div',{className:'use-demand-count-item-right'},React.createElement('div',null,title),React.createElement('div',{className:'use-demand-count-item-number'},i=='0'?React.createElement('a',{onClick:function onClick(){return openDialog({type:'bar',field:{},index:'2'});}},number):number),React.createElement('div',{className:isRise?'use-demand-count-item-up':'use-demand-count-item-down'},React.createElement('span',null,React.createElement(_antd.Icon,{type:isRise?"caret-up":"caret-down"})),React.createElement('span',{className:'use-demand-count-item-percent'},percent),React.createElement('span',{className:'use-demand-count-item-desc'},label))));}));}}]);return Summary;}(React.Component))||_class)||_class);exports.default=Summary;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _util=__webpack_require__(195);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var BarCharts=(_dec=(0,_mobxReact.inject)('hrmUsedemand'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(BarCharts,_React$Component);function BarCharts(props){(0,_classCallCheck3.default)(this,BarCharts);var _this=(0,_possibleConstructorReturn3.default)(this,(BarCharts.__proto__||(0,_getPrototypeOf2.default)(BarCharts)).call(this,props));_this.setRef=function(ref,alias){var hrmUsedemand=_this.props.hrmUsedemand,setRef=hrmUsedemand.setRef;_this[alias]=ref;setRef({ref:ref,alias:alias,type:'barCharts'});};_this.chartAction=function(obj){var index=obj.index,chart=obj.chart;chart.off('click');chart.on('click',function(params){return _this.handleChartAction((0,_extends3.default)({},params,{index:index}));});};_this.handleChartAction=function(params){var hrmUsedemand=_this.props.hrmUsedemand,barCharts=hrmUsedemand.barCharts,openDialog=hrmUsedemand.openDialog,lIds=barCharts.lIds,rIds=barCharts.rIds;var name=params.name,dataIndex=params.dataIndex,index=params.index;var tIds=index=='0'?lIds:rIds;openDialog({type:'bar',field:{value:tIds[dataIndex],valueSpan:name,valueObj:[{id:tIds[dataIndex],name:name}]},index:index});};_this.downloadImg=function(index,title){var cvs=document.getElementsByTagName('canvas');(0,_util.downloadCvs2Img)({cvs:cvs[index],title:title});};_this.count=-1;return _this;}(0,_createClass3.default)(BarCharts,[{key:'componentDidMount',value:function componentDidMount(){// this.props.hrmUsedemand.getBarChartsDatas();
}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;[0,1,2].map(function(val){_this2['echart'+val]&&_this2['echart'+val].paint();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmUsedemand.resetBarCharts();}},{key:'render',value:function render(){var _this3=this;var hrmUsedemand=this.props.hrmUsedemand,barCharts=hrmUsedemand.barCharts,openDialog=hrmUsedemand.openDialog,charts=barCharts.charts;this.count=-1;return(0,_mobx.toJS)(charts).map(function(chart,index){var title=chart.title,option=chart.option;var bl1=option.series[0].data.length>0;bl1&&_this3.count++;var ct=_this3.count;var float=index==1?'right':'left',padding=index==2?16:index==0?'0 0 0 16px':'0 16px 0 0',width=index==2?'100%':'49%';return React.createElement('div',{style:{float:float,width:width,padding:padding}},React.createElement(_ecCom.WeaReportCard,{title:title,onMoreClick:function onMoreClick(){return openDialog({type:'more'+index});},onDownloadClick:function onDownloadClick(){return bl1&&_this3.downloadImg(ct,title);},operations:index==2&&React.createElement('i',{className:'icon-coms-download2',style:{cursor:'pointer'},onClick:function onClick(){return bl1&&_this3.downloadImg(_this3.count,title);}})},React.createElement('div',{style:{height:380,position:'relative'}},bl1?React.createElement(_ecCom.WeaEchart,{ref:function ref(_ref){return _this3.setRef(_ref,'echart'+index);},option:option,useDefault:false,chartAction:function chartAction(chart){return(index==0||index==1)&&_this3.chartAction({chart:chart,index:index});}}):React.createElement('i',{className:'icon-coms-blank',style:{fontSize:50,position:'absolute',top:'50%',left:'50%',marginLeft:-25,marginTop:-50}},React.createElement('span',{style:{display:'block',fontSize:12}},getLabel(83553,'暂无数据'))))));});}}]);return BarCharts;}(React.Component))||_class)||_class);exports.default=BarCharts;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _Query=__webpack_require__(522);var _Query2=_interopRequireDefault(_Query);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TabPane=_antd.Tabs.TabPane;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var TabsWp=(_dec=(0,_mobxReact.inject)('hrmUsedemand'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(TabsWp,_React$Component);function TabsWp(props){(0,_classCallCheck3.default)(this,TabsWp);var _this=(0,_possibleConstructorReturn3.default)(this,(TabsWp.__proto__||(0,_getPrototypeOf2.default)(TabsWp)).call(this,props));_this.setRef=function(ref,alias){var hrmUsedemand=_this.props.hrmUsedemand,setRef=hrmUsedemand.setRef;_this[alias]=ref;setRef({ref:ref,alias:alias,type:'tabs'});};return _this;}(0,_createClass3.default)(TabsWp,[{key:'componentDidMount',value:function componentDidMount(){// this.props.hrmUsedemand.getTabsDatas();
}},{key:'componentDidUpdate',value:function componentDidUpdate(){var hrmUsedemand=this.props.hrmUsedemand,tabs=hrmUsedemand.tabs,key=tabs.key;this['echart'+key]&&this['echart'+key].paint();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmUsedemand.resetTabs();}},{key:'render',value:function render(){var _this2=this;var hrmUsedemand=this.props.hrmUsedemand,tabs=hrmUsedemand.tabs,tabsCallback=hrmUsedemand.tabsCallback,charts=tabs.charts,key=tabs.key;return React.createElement('div',{style:{float:'left',width:'100%',padding:16}},React.createElement(_antd.Tabs,{onChange:function onChange(key){return tabsCallback(key);},type:'card'},(0,_mobx.toJS)(charts).map(function(chart,index){var title=chart.title,option=chart.option;var bl1=option.series[0].data.length>0;return React.createElement(TabPane,{tab:title,key:index},React.createElement(_Query2.default,{title:title,index:index,bl1:bl1}),React.createElement('div',{style:{height:380}},bl1?React.createElement('div',{style:{height:'100%'}},key==index&&React.createElement(_ecCom.WeaEchart,{ref:function ref(_ref){return _this2.setRef(_ref,'echart'+index);},option:chart.option,useDefault:false})):React.createElement('i',{className:'icon-coms-blank',style:{fontSize:50,position:'absolute',top:'50%',left:'50%',marginLeft:-25,marginTop:-50}},React.createElement('span',{style:{display:'block',fontSize:12}},getLabel(83553,'暂无数据')))));})));}}]);return TabsWp;}(React.Component))||_class)||_class);exports.default=TabsWp;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _util=__webpack_require__(195);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Query=(_dec=(0,_mobxReact.inject)('hrmUsedemand'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Query,_React$Component);function Query(props){(0,_classCallCheck3.default)(this,Query);var _this=(0,_possibleConstructorReturn3.default)(this,(Query.__proto__||(0,_getPrototypeOf2.default)(Query)).call(this,props));_this.downloadImg=function(index,title){var cvs=document.getElementsByTagName('canvas');(0,_util.downloadCvs2Img)({cvs:cvs[cvs.length-1],title:title});};return _this;}(0,_createClass3.default)(Query,[{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,index=_props.index,bl1=_props.bl1;return React.createElement('div',{style:{textAlign:'right'}},React.createElement('i',{className:'icon-coms-download2 wea-f14',style:{marginRight:15,cursor:'pointer'},onClick:function onClick(){return bl1&&_this2.downloadImg(index,title);}}));}}]);return Query;}(React.Component))||_class)||_class);exports.default=Query;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _util=__webpack_require__(195);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Footnote=function(_React$Component){(0,_inherits3.default)(Footnote,_React$Component);function Footnote(props){(0,_classCallCheck3.default)(this,Footnote);return(0,_possibleConstructorReturn3.default)(this,(Footnote.__proto__||(0,_getPrototypeOf2.default)(Footnote)).call(this,props));}(0,_createClass3.default)(Footnote,[{key:'render',value:function render(){return React.createElement('div',{style:{float:'right',paddingRight:16}},getLabel('391162',"本报表数据统计截止到: ")+' '+(0,_util.format)('yyyy-MM-dd hh:mm'));}}]);return Footnote;}(React.Component);exports.default=Footnote;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;//根据情况import组件
var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _Tab=__webpack_require__(525);var _Tab2=_interopRequireDefault(_Tab);var _Table=__webpack_require__(526);var _Table2=_interopRequireDefault(_Table);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MainDialog=(_dec=(0,_mobxReact.inject)('hrmUsedemand'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(MainDialog,_React$Component);function MainDialog(props){(0,_classCallCheck3.default)(this,MainDialog);var _this=(0,_possibleConstructorReturn3.default)(this,(MainDialog.__proto__||(0,_getPrototypeOf2.default)(MainDialog)).call(this,props));_this.getChildren=function(){return React.createElement('div',null,React.createElement(_Tab2.default,null),React.createElement(_Table2.default,null));};return _this;}(0,_createClass3.default)(MainDialog,[{key:'render',value:function render(){var hrmUsedemand=this.props.hrmUsedemand,mainDialog=hrmUsedemand.mainDialog,closeDialog=hrmUsedemand.closeDialog,buttons=hrmUsedemand.buttons,style=hrmUsedemand.style,dropMenuDatas=hrmUsedemand.dropMenuDatas,title=mainDialog.title,visible=mainDialog.visible;return React.createElement(_ecCom.WeaDialog,{title:title,icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:visible,hasScroll:true,onCancel:function onCancel(){return closeDialog();},buttons:buttons,style:style},React.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas},visible&&this.getChildren()));}}]);return MainDialog;}(React.Component))||_class)||_class);exports.default=MainDialog;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Tab=(_dec=(0,_mobxReact.inject)('hrmUsedemand'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Tab,_React$Component);function Tab(props){(0,_classCallCheck3.default)(this,Tab);return(0,_possibleConstructorReturn3.default)(this,(Tab.__proto__||(0,_getPrototypeOf2.default)(Tab)).call(this,props));}(0,_createClass3.default)(Tab,[{key:'componentDidMount',value:function componentDidMount(){var hrmUsedemand=this.props.hrmUsedemand,mainDialog=hrmUsedemand.mainDialog,type=mainDialog.type;type=='bar'&&this.props.hrmUsedemand.getSearchCondition();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmUsedemand.resetTab();}},{key:'render',value:function render(){var hrmUsedemand=this.props.hrmUsedemand,tab=hrmUsedemand.tab,buttonsAd=hrmUsedemand.buttonsAd,changePanelStatus=hrmUsedemand.changePanelStatus,searchsAd=hrmUsedemand.searchsAd,handleSearch=hrmUsedemand.handleSearch,mainDialog=hrmUsedemand.mainDialog,setSearchBaseValue=hrmUsedemand.setSearchBaseValue,isPanelShow=tab.isPanelShow,conditionCount=tab.conditionCount,form=tab.form,searchBaseValue=tab.searchBaseValue,type=mainDialog.type;return React.createElement(_ecCom.WeaTab,{searchType:type=='more0'||type=='more1'?['base']:['base','advanced'],showSearchAd:isPanelShow,hasMask:false,advanceHeight:Math.ceil(conditionCount/2)*52+20,buttonsAd:buttonsAd,searchsBaseValue:searchBaseValue,setShowSearchAd:function setShowSearchAd(b){return changePanelStatus(b);},hideSearchAd:function hideSearchAd(){return changePanelStatus(false);},searchsAd:searchsAd,onSearch:function onSearch(){return handleSearch();},onSearchChange:function onSearchChange(val){return setSearchBaseValue(val);}});}}]);return Tab;}(React.Component))||_class)||_class);exports.default=Tab;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var Table=(_dec=(0,_mobxReact.inject)('hrmUsedemand'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Table,_React$Component);function Table(props){(0,_classCallCheck3.default)(this,Table);var _this=(0,_possibleConstructorReturn3.default)(this,(Table.__proto__||(0,_getPrototypeOf2.default)(Table)).call(this,props));_this.reRenderColumns=function(columns){columns.map(function(c){if(c.dataIndex=='count'){//TODO
c.render=function(t,r){var count=r.count,total=r.total;return React.createElement(_ecCom.WeaProgress,{percent:count/total*100,format:function format(){return count;},strokeColor:'#6FBCEA'});};}});};return _this;}(0,_createClass3.default)(Table,[{key:'componentDidMount',value:function componentDidMount(){this.props.hrmUsedemand.getTableInfo();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmUsedemand.resetTable();}},{key:'render',value:function render(){var _this2=this;var hrmUsedemand=this.props.hrmUsedemand,table=hrmUsedemand.table,tableStore=table.tableStore;return React.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,needScroll:true,getColumns:function getColumns(columns){return _this2.reRenderColumns(columns);}});}}]);return Table;}(React.Component))||_class)||_class);exports.default=Table;

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _Top=__webpack_require__(529);var _Top2=_interopRequireDefault(_Top);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var TimeWageSummary=(_dec=(0,_mobxReact.inject)('hrmTimeWageSummary'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(TimeWageSummary,_React$Component);function TimeWageSummary(props){(0,_classCallCheck3.default)(this,TimeWageSummary);return(0,_possibleConstructorReturn3.default)(this,(TimeWageSummary.__proto__||(0,_getPrototypeOf2.default)(TimeWageSummary)).call(this,props));}(0,_createClass3.default)(TimeWageSummary,[{key:'componentWillMount',value:function componentWillMount(){if(window.location.href.indexOf('/spa/hrm/engine.html')>-1){document.title=getLabel('391166',"时间工资汇总");}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location&&this.props.location.key!==nextProps.location.key){this.props.hrmTimeWageSummary.refresh();}}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'init',value:function init(){var hrmTimeWageSummary=this.props.hrmTimeWageSummary,getAuth=hrmTimeWageSummary.getAuth;getAuth();}},{key:'render',value:function render(){var hrmTimeWageSummary=this.props.hrmTimeWageSummary,main=hrmTimeWageSummary.main,loading=main.loading,authorized=main.authorized;if(!authorized){return _react2.default.createElement('div',{style:{height:'100%'}},loading?_react2.default.createElement('div',{className:'hrm-loading-center'},_react2.default.createElement(_antd.Spin,{spinning:loading,size:'large'})):_react2.default.createElement('div',{className:'hrm-wea-alert-page'},_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},getLabel(2012,'对不起，您暂时没有权限！')))));}else{return _react2.default.createElement(_Top2.default,null);}}}]);return TimeWageSummary;}(_react2.default.Component))||_class)||_class);exports.default=TimeWageSummary;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _RadioGroup=__webpack_require__(530);var _RadioGroup2=_interopRequireDefault(_RadioGroup);var _Table=__webpack_require__(531);var _Table2=_interopRequireDefault(_Table);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Top=(_dec=(0,_mobxReact.inject)('hrmTimeWageSummary'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Top,_React$Component);function Top(props){(0,_classCallCheck3.default)(this,Top);return(0,_possibleConstructorReturn3.default)(this,(Top.__proto__||(0,_getPrototypeOf2.default)(Top)).call(this,props));}(0,_createClass3.default)(Top,[{key:'render',value:function render(){var hrmTimeWageSummary=this.props.hrmTimeWageSummary,top=hrmTimeWageSummary.top,menus=hrmTimeWageSummary.menus,table=hrmTimeWageSummary.table,radioGroup=hrmTimeWageSummary.radioGroup,title=top.title,buttons=menus.buttons,dropMenuDatas=menus.dropMenuDatas,tableStore=table.tableStore,hasDatas=table.hasDatas;return React.createElement(_ecCom.WeaTop,{title:title,icon:React.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',loading:tableStore.loading||radioGroup.loading,buttons:buttons,showDropIcon:true,dropMenuDatas:dropMenuDatas},React.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas,collectParams:{favname:title,favouritetype:5}},React.createElement('div',{style:{padding:16}},React.createElement(_RadioGroup2.default,null)),React.createElement('div',{style:{padding:'0 16px'}},hasDatas?React.createElement(_Table2.default,null):React.createElement('i',{className:'icon-coms-blank',style:{fontSize:50,position:'absolute',top:'50%',left:'50%',marginLeft:-25,marginTop:-50}},React.createElement('span',{style:{display:'block',fontSize:12}},getLabel(83553,'暂无数据'))))));}}]);return Top;}(React.Component))||_class)||_class);exports.default=Top;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=(_dec=(0,_mobxReact.inject)('hrmTimeWageSummary'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(RadioGroup,_React$Component);function RadioGroup(props){(0,_classCallCheck3.default)(this,RadioGroup);return(0,_possibleConstructorReturn3.default)(this,(RadioGroup.__proto__||(0,_getPrototypeOf2.default)(RadioGroup)).call(this,props));}(0,_createClass3.default)(RadioGroup,[{key:'componentDidMount',value:function componentDidMount(){this.props.hrmTimeWageSummary.getRadioGroupDatas();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmTimeWageSummary.resetRadioGroup();}},{key:'render',value:function render(){var hrmTimeWageSummary=this.props.hrmTimeWageSummary,radioGroup=hrmTimeWageSummary.radioGroup,radioGroupCallBack=hrmTimeWageSummary.radioGroupCallBack,config=radioGroup.config;return config.length>0&&React.createElement(_ecCom.WeaRadioGroup,{config:config,onChange:function onChange(params){return radioGroupCallBack(params);}});}}]);return RadioGroup;}(React.Component))||_class)||_class);exports.default=RadioGroup;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _comsMobx=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var Table=(_dec=(0,_mobxReact.inject)('hrmTimeWageSummary'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Table,_React$Component);function Table(props){(0,_classCallCheck3.default)(this,Table);return(0,_possibleConstructorReturn3.default)(this,(Table.__proto__||(0,_getPrototypeOf2.default)(Table)).call(this,props));}(0,_createClass3.default)(Table,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmTimeWageSummary.resetTable();}},{key:'render',value:function render(){var hrmTimeWageSummary=this.props.hrmTimeWageSummary,table=hrmTimeWageSummary.table,tableStore=table.tableStore,colNum=table.colNum;return React.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,needScroll:true,scroll:{x:colNum*100}});}}]);return Table;}(React.Component))||_class)||_class);exports.default=Table;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _Top=__webpack_require__(533);var _Top2=_interopRequireDefault(_Top);var _MainDialog=__webpack_require__(536);var _MainDialog2=_interopRequireDefault(_MainDialog);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var StaffPayrollSummary=(_dec=(0,_mobxReact.inject)('hrmStaffPayrollSummary'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(StaffPayrollSummary,_React$Component);function StaffPayrollSummary(props){(0,_classCallCheck3.default)(this,StaffPayrollSummary);return(0,_possibleConstructorReturn3.default)(this,(StaffPayrollSummary.__proto__||(0,_getPrototypeOf2.default)(StaffPayrollSummary)).call(this,props));}(0,_createClass3.default)(StaffPayrollSummary,[{key:'componentWillMount',value:function componentWillMount(){if(window.location.href.indexOf('/spa/hrm/engine.html')>-1){document.title=getLabel('391167',"人员工资汇总");}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location&&this.props.location.key!==nextProps.location.key){this.props.hrmStaffPayrollSummary.refresh();}}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'init',value:function init(){var hrmStaffPayrollSummary=this.props.hrmStaffPayrollSummary,getAuth=hrmStaffPayrollSummary.getAuth;getAuth();}},{key:'render',value:function render(){var hrmStaffPayrollSummary=this.props.hrmStaffPayrollSummary,main=hrmStaffPayrollSummary.main,loading=main.loading,authorized=main.authorized;if(!authorized){return _react2.default.createElement('div',{style:{height:'100%'}},loading?_react2.default.createElement('div',{className:'hrm-loading-center'},_react2.default.createElement(_antd.Spin,{spinning:loading,size:'large'})):_react2.default.createElement('div',{className:'hrm-wea-alert-page'},_react2.default.createElement(_ecCom.WeaAlertPage,null,_react2.default.createElement('div',{style:{color:'#000'}},getLabel(2012,'对不起，您暂时没有权限！')))));}else{return _react2.default.createElement('div',null,_react2.default.createElement(_Top2.default,null),_react2.default.createElement(_MainDialog2.default,null));}}}]);return StaffPayrollSummary;}(_react2.default.Component))||_class)||_class);exports.default=StaffPayrollSummary;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _RadioGroup=__webpack_require__(534);var _RadioGroup2=_interopRequireDefault(_RadioGroup);var _MainTable=__webpack_require__(535);var _MainTable2=_interopRequireDefault(_MainTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Top=(_dec=(0,_mobxReact.inject)('hrmStaffPayrollSummary'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Top,_React$Component);function Top(props){(0,_classCallCheck3.default)(this,Top);return(0,_possibleConstructorReturn3.default)(this,(Top.__proto__||(0,_getPrototypeOf2.default)(Top)).call(this,props));}(0,_createClass3.default)(Top,[{key:'render',value:function render(){var hrmStaffPayrollSummary=this.props.hrmStaffPayrollSummary,top=hrmStaffPayrollSummary.top,menus=hrmStaffPayrollSummary.menus,mainTable=hrmStaffPayrollSummary.mainTable,radioGroup=hrmStaffPayrollSummary.radioGroup,title=top.title,buttons=menus.buttons,dropMenuDatas=menus.dropMenuDatas,tableStore=mainTable.tableStore,hasDatas=mainTable.hasDatas;return React.createElement(_ecCom.WeaTop,{title:title,icon:React.createElement('i',{className:'icon-coms-hrm'}),iconBgcolor:'#217346',loading:tableStore.loading||radioGroup.loading,buttons:buttons,showDropIcon:true,dropMenuDatas:dropMenuDatas},React.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas,collectParams:{favname:title,favouritetype:5}},React.createElement('div',{style:{padding:16}},React.createElement(_RadioGroup2.default,null)),React.createElement('div',{style:{padding:'0 16px'}},hasDatas?React.createElement(_MainTable2.default,null):React.createElement('i',{className:'icon-coms-blank',style:{fontSize:50,position:'absolute',top:'50%',left:'50%',marginLeft:-25,marginTop:-50}},React.createElement('span',{style:{display:'block',fontSize:12}},getLabel(83553,'暂无数据'))))));}}]);return Top;}(React.Component))||_class)||_class);exports.default=Top;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioGroup=(_dec=(0,_mobxReact.inject)('hrmStaffPayrollSummary'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(RadioGroup,_React$Component);function RadioGroup(props){(0,_classCallCheck3.default)(this,RadioGroup);return(0,_possibleConstructorReturn3.default)(this,(RadioGroup.__proto__||(0,_getPrototypeOf2.default)(RadioGroup)).call(this,props));}(0,_createClass3.default)(RadioGroup,[{key:'componentDidMount',value:function componentDidMount(){this.props.hrmStaffPayrollSummary.getRadioGroupDatas();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmStaffPayrollSummary.resetRadioGroup();}},{key:'render',value:function render(){var hrmStaffPayrollSummary=this.props.hrmStaffPayrollSummary,radioGroup=hrmStaffPayrollSummary.radioGroup,radioGroupCallBack=hrmStaffPayrollSummary.radioGroupCallBack,config=radioGroup.config;return config.length>0&&React.createElement(_ecCom.WeaRadioGroup,{config:config,onChange:function onChange(params){return radioGroupCallBack(params);}});}}]);return RadioGroup;}(React.Component))||_class)||_class);exports.default=RadioGroup;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _comsMobx=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var MainTable=(_dec=(0,_mobxReact.inject)('hrmStaffPayrollSummary'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(MainTable,_React$Component);function MainTable(props){(0,_classCallCheck3.default)(this,MainTable);return(0,_possibleConstructorReturn3.default)(this,(MainTable.__proto__||(0,_getPrototypeOf2.default)(MainTable)).call(this,props));}(0,_createClass3.default)(MainTable,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmStaffPayrollSummary.resetTable({type:'main'});}},{key:'render',value:function render(){var hrmStaffPayrollSummary=this.props.hrmStaffPayrollSummary,mainTable=hrmStaffPayrollSummary.mainTable,_onOperatesClick=hrmStaffPayrollSummary.onOperatesClick,reRenderColumns=hrmStaffPayrollSummary.reRenderColumns,tableStore=mainTable.tableStore,colNum=mainTable.colNum;return React.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,needScroll:true,scroll:{x:colNum*100},getColumns:function getColumns(c){return reRenderColumns(c);},onOperatesClick:function onOperatesClick(record,index,operate){return _onOperatesClick(record,index,operate);}});}}]);return MainTable;}(React.Component))||_class)||_class);exports.default=MainTable;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _Tab=__webpack_require__(537);var _Tab2=_interopRequireDefault(_Tab);var _SubTable=__webpack_require__(538);var _SubTable2=_interopRequireDefault(_SubTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MainDialog=(_dec=(0,_mobxReact.inject)('hrmStaffPayrollSummary'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(MainDialog,_React$Component);function MainDialog(props){(0,_classCallCheck3.default)(this,MainDialog);var _this=(0,_possibleConstructorReturn3.default)(this,(MainDialog.__proto__||(0,_getPrototypeOf2.default)(MainDialog)).call(this,props));_this.getChildren=function(){return React.createElement('div',null,React.createElement(_Tab2.default,null),React.createElement(_SubTable2.default,null));};return _this;}(0,_createClass3.default)(MainDialog,[{key:'render',value:function render(){var hrmStaffPayrollSummary=this.props.hrmStaffPayrollSummary,mainDialog=hrmStaffPayrollSummary.mainDialog,closeDialog=hrmStaffPayrollSummary.closeDialog,buttons=hrmStaffPayrollSummary.buttons,style=hrmStaffPayrollSummary.style,dropMenuDatas=hrmStaffPayrollSummary.dropMenuDatas,title=mainDialog.title,visible=mainDialog.visible;return React.createElement(_ecCom.WeaDialog,{title:title,icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:visible,hasScroll:true,onCancel:function onCancel(){return closeDialog();},buttons:buttons,moreBtn:{datas:dropMenuDatas},style:style},React.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas},visible&&this.getChildren()));}}]);return MainDialog;}(React.Component))||_class)||_class);exports.default=MainDialog;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Tab=(_dec=(0,_mobxReact.inject)('hrmStaffPayrollSummary'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Tab,_React$Component);function Tab(props){(0,_classCallCheck3.default)(this,Tab);return(0,_possibleConstructorReturn3.default)(this,(Tab.__proto__||(0,_getPrototypeOf2.default)(Tab)).call(this,props));}(0,_createClass3.default)(Tab,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmStaffPayrollSummary.resetTab();}},{key:'render',value:function render(){var hrmStaffPayrollSummary=this.props.hrmStaffPayrollSummary,tab=hrmStaffPayrollSummary.tab,setSearchBaseValue=hrmStaffPayrollSummary.setSearchBaseValue,handleSearch=hrmStaffPayrollSummary.handleSearch,searchBaseValue=tab.searchBaseValue;return React.createElement(_ecCom.WeaTab,{searchType:['base'],searchsBaseValue:searchBaseValue,onSearch:function onSearch(){return handleSearch();},onSearchChange:function onSearchChange(val){return setSearchBaseValue(val);}});}}]);return Tab;}(React.Component))||_class)||_class);exports.default=Tab;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _comsMobx=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var SubTable=(_dec=(0,_mobxReact.inject)('hrmStaffPayrollSummary'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(SubTable,_React$Component);function SubTable(props){(0,_classCallCheck3.default)(this,SubTable);return(0,_possibleConstructorReturn3.default)(this,(SubTable.__proto__||(0,_getPrototypeOf2.default)(SubTable)).call(this,props));}(0,_createClass3.default)(SubTable,[{key:'componentDidMount',value:function componentDidMount(){this.props.hrmStaffPayrollSummary.getResourceSalaryList();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.hrmStaffPayrollSummary.resetTable({type:'sub'});}},{key:'render',value:function render(){var hrmStaffPayrollSummary=this.props.hrmStaffPayrollSummary,subTable=hrmStaffPayrollSummary.subTable,tableStore=subTable.tableStore,colNum=subTable.colNum;return React.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,needScroll:true,scroll:{x:colNum*100}});}}]);return SubTable;}(React.Component))||_class)||_class);exports.default=SubTable;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _Top=__webpack_require__(540);var _Top2=_interopRequireDefault(_Top);var _Dialog=__webpack_require__(544);var _Dialog2=_interopRequireDefault(_Dialog);var _index=__webpack_require__(550);var _index2=_interopRequireDefault(_index);__webpack_require__(552);__webpack_require__(553);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Group=(_dec=(0,_mobxReact.inject)('hrmImportCommon'),_dec2=(0,_mobxReact.inject)('hrmSpaGroup'),_dec(_class=_dec2(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Group,_React$Component);function Group(props){(0,_classCallCheck3.default)(this,Group);var _this=(0,_possibleConstructorReturn3.default)(this,(Group.__proto__||(0,_getPrototypeOf2.default)(Group)).call(this,props));_this.init=function(){var store=_this.props.hrmSpaGroup;store.reset();store.getHrmGroupForm();};return _this;}(0,_createClass3.default)(Group,[{key:'componentWillMount',value:function componentWillMount(){var query=this.props.location.query;var _props=this.props,hrmImportCommon=_props.hrmImportCommon,store=_props.hrmSpaGroup;store.setQueryParams(query);store.exportStore(hrmImportCommon,store);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location.key!==nextProps.location.key){this.init();}}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'render',value:function render(){var _props2=this.props,hrmImportCommon=_props2.hrmImportCommon,store=_props2.hrmSpaGroup,dialog=store.dialog,importDialog=hrmImportCommon.importDialog;return _react2.default.createElement('div',{className:'hrm-group'},_react2.default.createElement(_Top2.default,{store:store}),dialog.visible&&_react2.default.createElement(_Dialog2.default,{store:store}),importDialog.visible&&_react2.default.createElement(_index2.default,null));}}]);return Group;}(_react2.default.Component))||_class)||_class)||_class);exports.default=Group;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _ecCom=__webpack_require__(0);var _mobxReact=__webpack_require__(7);var _Content=__webpack_require__(541);var _Content2=_interopRequireDefault(_Content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Top=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Top,_React$Component);function Top(props){(0,_classCallCheck3.default)(this,Top);return(0,_possibleConstructorReturn3.default)(this,(Top.__proto__||(0,_getPrototypeOf2.default)(Top)).call(this,props));}(0,_createClass3.default)(Top,[{key:'render',value:function render(){var store=this.props.store,TOP=store.TOP,top=store.top,pageLoading=store.pageLoading,topButtons=store.topButtons,footerButtons=store.footerButtons,dropMenuDatas=store.dropMenuDatas;if(false){//隐藏头部
return React.createElement(_ecCom.WeaTop,(0,_extends3.default)({},TOP,top,{loading:pageLoading,buttons:topButtons,dropMenuDatas:dropMenuDatas}),React.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas},React.createElement(_Content2.default,{store:store})));}else{return React.createElement(_ecCom.WeaRightMenu,{datas:dropMenuDatas},React.createElement(_Content2.default,{store:store}),React.createElement(_ecCom.WeaDialogFooter,{buttons:footerButtons,moreBtn:{datas:[]}}));}}}]);return Top;}(React.Component))||_class;exports.default=Top;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _Form=__webpack_require__(255);var _Form2=_interopRequireDefault(_Form);var _Tab=__webpack_require__(542);var _Tab2=_interopRequireDefault(_Tab);var _Table=__webpack_require__(543);var _Table2=_interopRequireDefault(_Table);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Content,_React$Component);function Content(props){(0,_classCallCheck3.default)(this,Content);return(0,_possibleConstructorReturn3.default)(this,(Content.__proto__||(0,_getPrototypeOf2.default)(Content)).call(this,props));}(0,_createClass3.default)(Content,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var store=this.props.store,exportBrowserRef=store.exportBrowserRef;this.refs.browser&&exportBrowserRef(this.refs.browser);}},{key:'render',value:function render(){var store=this.props.store,hasTab=store.hasTab,tab=store.tab,pageForm=store.pageForm,BROWSER=store.BROWSER,selectedKey=tab.selectedKey;var c=void 0;if(selectedKey==='0'){c=React.createElement(_Form2.default,{datas:pageForm});}else{c=React.createElement('div',null,React.createElement(_Table2.default,{store:store}),React.createElement('div',{className:'hidden'},React.createElement(_ecCom.WeaBrowser,BROWSER)));}return React.createElement('div',null,hasTab&&React.createElement(_Tab2.default,{store:store}),c);}}]);return Content;}(React.Component))||_class;exports.default=Content;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Tab=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Tab,_React$Component);function Tab(props){(0,_classCallCheck3.default)(this,Tab);return(0,_possibleConstructorReturn3.default)(this,(Tab.__proto__||(0,_getPrototypeOf2.default)(Tab)).call(this,props));}(0,_createClass3.default)(Tab,[{key:'render',value:function render(){var store=this.props.store,TAB=store.TAB,tab=store.tab,tabDatas=store.tabDatas,searchsBaseValue=store.searchsBaseValue,searchType=store.searchType,tabButtons=store.tabButtons,form=tab.form;return React.createElement(_ecCom.WeaTab,(0,_extends3.default)({},TAB,tab,{datas:tabDatas,buttons:tabButtons,searchType:searchType,searchsBaseValue:searchsBaseValue,searchsAd:React.createElement('div',null,form.render())}));}}]);return Tab;}(React.Component))||_class;exports.default=Tab;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _mobxReact=__webpack_require__(7);var _comsMobx=__webpack_require__(10);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var Table=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Table,_React$Component);function Table(props){(0,_classCallCheck3.default)(this,Table);var _this=(0,_possibleConstructorReturn3.default)(this,(Table.__proto__||(0,_getPrototypeOf2.default)(Table)).call(this,props));_this.reRenderColumns=function(columns,store){var onDsporderChange=store.onDsporderChange;columns.map(function(c){if(c.dataIndex==='dsporder'){c.render=function(text,record){var randomFieldId=record.randomFieldId,dsporder=record.dsporder;return React.createElement(_ecCom.WeaInputNumber,{defaultValue:dsporder,onChange:function onChange(val){return onDsporderChange(val,randomFieldId);}});};}});};_this.onOperatesClick=function(record,rIndex,operate,store){var randomFieldId=record.randomFieldId,index=operate.index;var del=store.del;if(index==='0'){del(randomFieldId);}};return _this;}(0,_createClass3.default)(Table,[{key:'render',value:function render(){var _this2=this;var store=this.props.store,TABLE=store.TABLE,table=store.table;return React.createElement(WeaTable,(0,_extends3.default)({},TABLE,table,{scroll:{y:300},getColumns:function getColumns(columns){return _this2.reRenderColumns(columns,store);},onOperatesClick:function onOperatesClick(record,index,operate){return _this2.onOperatesClick(record,index,operate,store);}}));}}]);return Table;}(React.Component))||_class;exports.default=Table;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;// import Browser from './Browser';
var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _learn=__webpack_require__(256);var _DialogForm=__webpack_require__(546);var _DialogForm2=_interopRequireDefault(_DialogForm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Dialog=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Dialog,_React$Component);function Dialog(props){(0,_classCallCheck3.default)(this,Dialog);return(0,_possibleConstructorReturn3.default)(this,(Dialog.__proto__||(0,_getPrototypeOf2.default)(Dialog)).call(this,props));}(0,_createClass3.default)(Dialog,[{key:'render',value:function render(){var store=this.props.store,DIALOG=store.DIALOG,dialog=store.dialog,tab=store.tab,dialogStyle=store.dialogStyle,selectedKey=tab.selectedKey;var c=void 0;if(dialog.loading){c=React.createElement(_learn.Loading,null);}else{if(selectedKey==='1'){// c = <Browser store={store}/>;
}else{c=React.createElement(_DialogForm2.default,{store:store});}}return React.createElement(_ecCom.WeaDialog,(0,_extends3.default)({},DIALOG,dialog,{style:dialogStyle}),c);}}]);return Dialog;}(React.Component))||_class;exports.default=Dialog;

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_545__;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _mobxReact=__webpack_require__(7);var _sweetForm=__webpack_require__(547);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DialogForm=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(DialogForm,_React$Component);function DialogForm(props){(0,_classCallCheck3.default)(this,DialogForm);return(0,_possibleConstructorReturn3.default)(this,(DialogForm.__proto__||(0,_getPrototypeOf2.default)(DialogForm)).call(this,props));}(0,_createClass3.default)(DialogForm,[{key:'render',value:function render(){var store=this.props.store,dialog=store.dialog,FORMCONFIG=store.FORMCONFIG,_onFormElementsChange=store.onFormElementsChange,form=dialog.form;return React.createElement(_sweetForm.MagicForm,(0,_extends3.default)({},dialog,FORMCONFIG,{isFormInit:form.isFormInit,onFormElementsChange:function onFormElementsChange(datas){return _onFormElementsChange(datas);}}));}}]);return DialogForm;}(React.Component))||_class;exports.default=DialogForm;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SearchForm=exports.CompositeForm=exports.MagicForm=undefined;var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _keys=__webpack_require__(111);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _mobx=__webpack_require__(8);var _antd=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MagicForm=function(_React$Component){(0,_inherits3.default)(MagicForm,_React$Component);function MagicForm(props){(0,_classCallCheck3.default)(this,MagicForm);var _this=(0,_possibleConstructorReturn3.default)(this,(MagicForm.__proto__||(0,_getPrototypeOf2.default)(MagicForm)).call(this,props));_this.handleFormChange=function(cb){var _this$props=_this.props,onFormElementsChange=_this$props.onFormElementsChange,dynamicFields=_this$props.dynamicFields;dynamicFields&&dynamicFields.map(function(field){var activeKey=field.activeKey;if((0,_keys2.default)(cb)[0]===activeKey){_this.forceUpdate();}});//当父组件没有传onFormElementsChange属性时，不执行下面的回调函数。
if(!onFormElementsChange)return;onFormElementsChange(cb);};_this.forceUpdate=function(){_this.setState({usedAsForceUpdate:new Date()});};_this.canRender=function(domkey){var _this$props2=_this.props,dynamicFields=_this$props2.dynamicFields,form=_this$props2.form;//表单元素能否被渲染的标志：true -> 可以被渲染; false -> 不可以被渲染
var flag=true;dynamicFields.map(function(field){var passiveKey=field.passiveKey,activeKey=field.activeKey,showValue=field.showValue;var showValueArray=showValue.split(',');//判断是否为被联动的表单元素（被动）
if(domkey===passiveKey){var activeValue=form.getFormParams()[activeKey];if(!showValueArray.includes(activeValue)){flag=false;}}});return flag;};_this.getSubComponent=function(params){var _this$props3=_this.props,dirtyKeys=_this$props3.dirtyKeys,dirtyComponent=_this$props3.dirtyComponent,classNames=_this$props3.classNames,domkey=params.domkey,item=params.item,form=params.form,label=params.label;if(dirtyKeys&&dirtyKeys.includes(domkey)){return dirtyComponent(params);}else{return _react2.default.createElement('div',{className:_this.getClassName(domkey)},_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:item,form:form,formParams:form.getFormParams(),onChange:_this.handleFormChange}),_this.getSiblingComponent(domkey,form));}};_this.getClassName=function(domkey){var classNames=_this.props.classNames;return _this.isObjectHasDomkey(classNames,domkey)?classNames[domkey]:'';};_this.getSiblingComponent=function(domkey,form){var _this$props4=_this.props,staticTips=_this$props4.staticTips,dynamicTips=_this$props4.dynamicTips,transverseSiblingComponents=_this$props4.transverseSiblingComponents,longitudinalSiblingComponents=_this$props4.longitudinalSiblingComponents,customizations=_this$props4.customizations;var siblings=[];//静态提示
if(_this.isObjectHasDomkey(staticTips,domkey)){siblings.push(staticTips[domkey]);}//动态提示
if(_this.isObjectHasDomkey(dynamicTips,domkey)){var index=parseInt(form.getFormParams()[domkey])-1;var tipsLen=dynamicTips[domkey].length;var _index=void 0;if(index<0){_index=tipsLen-1;}else{_index=index;}siblings.push(_react2.default.createElement('p',{style:{padding:'5px 0'}},_react2.default.createElement('i',{className:'icon-coms-content-o'}),_react2.default.createElement('span',{style:{marginLeft:5}},dynamicTips[domkey].length>0&&dynamicTips[domkey][_index])));}//横向相邻组件
if(_this.isObjectHasDomkey(transverseSiblingComponents,domkey)){siblings.push(transverseSiblingComponents[domkey]);}//纵向相邻组件
if(_this.isObjectHasDomkey(longitudinalSiblingComponents,domkey)){siblings.push(longitudinalSiblingComponents[domkey]);}//自定义组件
if(_this.isObjectHasDomkey(customizations,domkey)){siblings.push(customizations[domkey]);}return siblings;};_this.isObjectHasDomkey=function(obj,domkey){return obj&&(0,_keys2.default)(obj).includes(domkey);};_this.state={usedAsForceUpdate:new Date()};return _this;}//监听表单元素事件的回调函数
//强制刷新组件
//判断当前表单元素能否被渲染
//获取WeaSwitch组件的相邻组件
//判断domkey是否在容器中
(0,_createClass3.default)(MagicForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,conditions=_props.conditions,form=_props.form,isFormInit=_props.isFormInit,dynamicFields=_props.dynamicFields,date=_props.date,dirtyKeys=_props.dirtyKeys,renderBlacklist=_props.renderBlacklist,labels=_props.labels,wrapperStyle=_props.wrapperStyle,errors=_props.errors,usedAsForceUpdate=this.state.usedAsForceUpdate;if(!isFormInit)return null;//WeaFormItem组件的容器
var formItemContainer=[];var translatedConditions=(0,_mobx.toJS)(conditions);//conditions数据类型：数组或者对象
var c=Array.isArray(translatedConditions)?translatedConditions[0]:conditions;c.items.map(function(item){var domkey=item.domkey;//判断当前表单元素是否需要被渲染
if(dynamicFields&&!_this2.canRender(domkey[0]))return;if(renderBlacklist&&renderBlacklist.includes(domkey[0]))return;if(labels&&(0,_keys2.default)(labels).includes(domkey[0])){item.label=labels[domkey[0]];}var isDirty=dirtyKeys?dirtyKeys.includes(domkey[0]):false;var error=void 0;if(errors){error=errors[domkey[0]];}else{error=!isDirty&&form.getError(item);}formItemContainer.push(_react2.default.createElement(_ecCom.WeaFormItem,{label:!isDirty?item.label:'',colon:!isDirty?true:false,labelCol:{span:6},wrapperCol:{span:18},error:error,tipPosition:'bottom',className:isDirty?'hrm-special-form':''},_this2.getSubComponent({domkey:domkey[0],label:item.label,item:item,form:form})));});return _react2.default.createElement('div',{className:'wea-form-item-group',style:wrapperStyle?wrapperStyle:{padding:'20px 15%'}},formItemContainer);}}]);return MagicForm;}(_react2.default.Component);//复合表单组件
var CompositeForm=function(_React$Component2){(0,_inherits3.default)(CompositeForm,_React$Component2);function CompositeForm(props){(0,_classCallCheck3.default)(this,CompositeForm);return(0,_possibleConstructorReturn3.default)(this,(CompositeForm.__proto__||(0,_getPrototypeOf2.default)(CompositeForm)).call(this,props));}(0,_createClass3.default)(CompositeForm,[{key:'render',value:function render(){var _this4=this;var conditions=this.props.conditions;return _react2.default.createElement('div',null,conditions.map(function(c){var title=c.title;return _react2.default.createElement(_ecCom.WeaSearchGroup,{showGroup:true,title:title,children:_react2.default.createElement(MagicForm,(0,_extends3.default)({},_this4.props,{conditions:c}))});}));}}]);return CompositeForm;}(_react2.default.Component);//高级搜索表单
var SearchForm=function(_React$Component3){(0,_inherits3.default)(SearchForm,_React$Component3);function SearchForm(props){(0,_classCallCheck3.default)(this,SearchForm);return(0,_possibleConstructorReturn3.default)(this,(SearchForm.__proto__||(0,_getPrototypeOf2.default)(SearchForm)).call(this,props));}(0,_createClass3.default)(SearchForm,[{key:'render',value:function render(){var _props2=this.props,form=_props2.form,conditions=_props2.conditions,isFormInit=_props2.isFormInit;if(!isFormInit)return null;var formItemContainer=[];conditions.map(function(c){c.items.map(function(item,index){formItemContainer.push(_react2.default.createElement(_antd.Col,{span:10,offset:1},_react2.default.createElement(_ecCom.WeaFormItem,{label:''+item.label,labelCol:{span:6},wrapperCol:{span:18},style:{paddingTop:20}},_react2.default.createElement(_comsMobx.WeaSwitch,{fieldConfig:item,form:form,formParams:form.getFormParams()}))));});});return _react2.default.createElement(_antd.Row,null,formItemContainer);}}]);return SearchForm;}(_react2.default.Component);exports.MagicForm=MagicForm;exports.CompositeForm=CompositeForm;exports.SearchForm=SearchForm;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(549);
module.exports = __webpack_require__(20).Object.keys;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(62);
var $keys = __webpack_require__(59);

__webpack_require__(142)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(38);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _pulicFunc=__webpack_require__(196);var _i18nbk=__webpack_require__(112);var _ImportResult=__webpack_require__(257);var _ImportResult2=_interopRequireDefault(_ImportResult);var _ImportHistory=__webpack_require__(551);var _ImportHistory2=_interopRequireDefault(_ImportHistory);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Import=(_dec=(0,_mobxReact.inject)('hrmImportCommon'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Import,_React$Component);function Import(props){(0,_classCallCheck3.default)(this,Import);var _this=(0,_possibleConstructorReturn3.default)(this,(Import.__proto__||(0,_getPrototypeOf2.default)(Import)).call(this,props));_this.getForm=function(){var hrmImportCommon=_this.props.hrmImportCommon,importDialog=hrmImportCommon.importDialog,condition=importDialog.condition,form=importDialog.form,isFormInit=form.isFormInit;var _arr=[];isFormInit&&condition.map(function(c,i){var arr=[];if(i==0){//基本信息
c.items.map(function(field,index){var key=field.domkey[0];var url=field.value?field.value:'';arr.push({com:React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:1,offset:6},React.createElement('div',{className:'hrm-import-circle',style:{paddingLeft:(0,_pulicFunc.IEVersion)()=='-1'?6:7,marginTop:15}},React.createElement('div',{style:{paddingTop:(0,_pulicFunc.IEVersion)()=='11'||(0,_pulicFunc.IEVersion)()=='edge'?5:2}},index+1))),React.createElement(_antd.Col,{span:14},React.createElement(_antd.Row,{style:{marginTop:15}},React.createElement(_antd.Col,{span:field.labelcol},field.label.length>14?field.label.slice(0,14)+'...':field.label,':'),React.createElement(_antd.Col,{span:field.fieldcol},_this.getElements(key,url,field))))),colSpan:1});});}if(i==1){//导入说明
c.items.map(function(field,index){var p=field.value;var url=field.link?field.link:'';arr.push({com:React.createElement(_antd.Row,null,React.createElement(_antd.Col,{span:1,offset:6,style:{marginTop:15}},React.createElement('div',{className:'hrm-import-circle',style:(0,_defineProperty3.default)({paddingLeft:(0,_pulicFunc.IEVersion)()=='-1'?6:7},'paddingLeft',index>8?3:6)},React.createElement('div',{style:{paddingTop:(0,_pulicFunc.IEVersion)()=='11'||(0,_pulicFunc.IEVersion)()=='edge'?5:2}},index+1))),React.createElement(_antd.Col,{span:14,style:{marginTop:15}},_this.getImportInstructions(p,url,index))),colSpan:1});});}_arr.push(React.createElement('div',{style:{color:'#484848'}},React.createElement(_ecCom.WeaSearchGroup,{needTigger:true,title:c.title,showGroup:c.defaultshow,items:arr,col:1})));});return _arr;};_this.getElements=function(key,url,field){var hrmImportCommon=_this.props.hrmImportCommon,setExcelFileNo=hrmImportCommon.setExcelFileNo,importDialog=hrmImportCommon.importDialog,setSelectedValue=hrmImportCommon.setSelectedValue,templetName=importDialog.templetName,selectedValue=importDialog.selectedValue,form=importDialog.form,_this$state=_this.state,upStatus=_this$state.upStatus,list=_this$state.list;var dom=void 0;if(key=='templet'){dom=_this.getTempletElement(url,selectedValue,templetName);}else if(key=='excelfile'){dom=React.createElement('div',null,React.createElement('div',{style:{float:'left',marginTop:-10}},React.createElement(_ecCom.WeaUpload,{uploadUrl:'/api/doc/upload/uploadFile',category:'string',limitType:'xls',datas:upStatus==='uploaded'?list:[],onChange:function onChange(id,list){_this.setState({list:list});setExcelFileNo(id);},onUploading:function onUploading(status){return _this.handleUploading(status);}},React.createElement(_antd.Button,null,_i18nbk.i18n.button.selectFile()))),React.createElement('div',{style:{float:'left',paddingLeft:10}},list.length==0?React.createElement('p',null,_i18nbk.i18n.label.noFileSelected()):list.map(function(file){return React.createElement('p',null,file.filename);})));}else{dom=React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:form.getFormParams()});}return dom;};_this.getImportInstructions=function(val,url,index){var hrmImportCommon=_this.props.hrmImportCommon,importDialog=hrmImportCommon.importDialog,templetName=importDialog.templetName,selectedValue=importDialog.selectedValue;var p=void 0;if(index==0){var dom=_this.getTempletElement(url,selectedValue,templetName);p=React.createElement('p',null,_i18nbk.i18n.label.downloadTemplateFirst(),'\uFF1A',dom);}else{p=React.createElement('p',null,val);}return p;};_this.getTempletElement=function(url,selectedValue,templetName){var dom=void 0;var urlArr=url.split(';');if(urlArr.length>1){if(selectedValue=='workcode'){dom=React.createElement('a',{href:urlArr[0]},templetName);}else{dom=React.createElement('a',{href:urlArr[1]},templetName);}}else{dom=React.createElement('a',{href:url},templetName);}return dom;};_this.handleUploading=function(status){_this.setState({upStatus:status});if(status=='uploading'){_this.setState({list:[]});}};_this.getButtons=function(){var hrmImportCommon=_this.props.hrmImportCommon,submitExcel=hrmImportCommon.submitExcel,queryRecord=hrmImportCommon.queryRecord,importDialog=hrmImportCommon.importDialog,upStatus=_this.state.upStatus;return[React.createElement(_antd.Button,{type:'primary',disabled:upStatus==='uploaded'?false:true,onClick:function onClick(){return submitExcel();}},_i18nbk.i18n.button.submit()),React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return queryRecord();}},_i18nbk.i18n.button.importHistoryQuery()),React.createElement(_ecCom.WeaMoreButton,null)];};_this.state={width:870,height:510,list:[],upStatus:''};return _this;}(0,_createClass3.default)(Import,[{key:'render',value:function render(){var _this2=this;var hrmImportCommon=this.props.hrmImportCommon,importDialog=hrmImportCommon.importDialog,resultDialog=hrmImportCommon.resultDialog,recordDialog=hrmImportCommon.recordDialog,setImportDialogVisible=hrmImportCommon.setImportDialogVisible,visible=importDialog.visible,title=importDialog.title,loading=importDialog.loading,_state=this.state,width=_state.width,height=_state.height;return React.createElement('div',null,React.createElement(_ecCom.WeaDialog,{title:title,icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:visible,closable:true,onCancel:function onCancel(){return setImportDialogVisible(false);},buttons:this.getButtons(),style:{width:width,height:height},onChangeHeight:function onChangeHeight(h){return _this2.setState({height:h});}},React.createElement(_antd.Spin,{spinning:loading},React.createElement(_ecCom.WeaNewScroll,{height:height},this.getForm()))),resultDialog.visible&&React.createElement(_ImportResult2.default,null),recordDialog.visible&&React.createElement(_ImportHistory2.default,null));}}]);return Import;}(React.Component))||_class)||_class);exports.default=Import;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _pulicFunc=__webpack_require__(196);var _i18nbk=__webpack_require__(112);var _ImportLog=__webpack_require__(258);var _ImportLog2=_interopRequireDefault(_ImportLog);var _ImportResult=__webpack_require__(257);var _ImportResult2=_interopRequireDefault(_ImportResult);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaTable=_comsMobx.WeaTableNew.WeaTable;var ImportHistory=(_dec=(0,_mobxReact.inject)('hrmImportCommon'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(ImportHistory,_React$Component);function ImportHistory(props){(0,_classCallCheck3.default)(this,ImportHistory);var _this=(0,_possibleConstructorReturn3.default)(this,(ImportHistory.__proto__||(0,_getPrototypeOf2.default)(ImportHistory)).call(this,props));_this.state={width:870,height:510};return _this;}(0,_createClass3.default)(ImportHistory,[{key:'reRenderColumns',value:function reRenderColumns(c){var hrmImportCommon=this.props.hrmImportCommon,jumpToImportResult=hrmImportCommon.jumpToImportResult;c.forEach(function(item){if(item.dataIndex=='operator'){item.render=function(text,record){return React.createElement('span',null,React.createElement('a',{style:{cursor:'pointer',color:'#4D7AD8'},onClick:function onClick(){return(0,_pulicFunc.jumpToHrmCard)(record.operator);}},record.operatorspan));};}if(item.dataIndex=='allnum'){item.render=function(text,record){return React.createElement('span',null,React.createElement('a',{style:{cursor:'pointer',color:'#4D7AD8'},onClick:function onClick(){return jumpToImportResult(record.randomFieldId);}},record.allnumspan));};}});}},{key:'getButtons',value:function getButtons(){var hrmImportCommon=this.props.hrmImportCommon,recordDialog=hrmImportCommon.recordDialog,queryLog=hrmImportCommon.queryLog,loading=recordDialog.loading;return[React.createElement(_antd.Button,{type:'primary',disabled:loading,onClick:function onClick(){return queryLog();}},_i18nbk.i18n.button.queryImportLog()),React.createElement(_ecCom.WeaMoreButton,null)];}},{key:'render',value:function render(){var _this2=this;var hrmImportCommon=this.props.hrmImportCommon,recordDialog=hrmImportCommon.recordDialog,logDialog=hrmImportCommon.logDialog,resultDialog=hrmImportCommon.resultDialog,setRecordDialogVisible=hrmImportCommon.setRecordDialogVisible,title=recordDialog.title,visible=recordDialog.visible,tableStore=recordDialog.tableStore,_state=this.state,width=_state.width,height=_state.height;return React.createElement('div',null,React.createElement(_ecCom.WeaDialog,{title:title,icon:'icon-coms-hrm',iconBgcolor:'#217346',visible:visible,closable:true,onCancel:function onCancel(){return setRecordDialogVisible(false);},buttons:this.getButtons(),style:{width:width,height:height},onChangeHeight:function onChangeHeight(h){return _this2.setState({height:h});}},React.createElement(WeaTable,{comsWeaTableStore:tableStore,hasOrder:true,needScroll:true,scroll:{y:height-80},rowKey:function rowKey(record,index){return index;},getColumns:function getColumns(c){return _this2.reRenderColumns(c);}})),logDialog.visible&&React.createElement(_ImportLog2.default,null),resultDialog.visible&&React.createElement(_ImportResult2.default,null));}}]);return ImportHistory;}(React.Component))||_class)||_class);exports.default=ImportHistory;

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _Form=__webpack_require__(255);var _Form2=_interopRequireDefault(_Form);var _learn=__webpack_require__(256);__webpack_require__(555);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var GroupAdvice=(_dec=(0,_mobxReact.inject)('hrmGroupAdvice'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(GroupAdvice,_React$Component);function GroupAdvice(props){(0,_classCallCheck3.default)(this,GroupAdvice);var _this=(0,_possibleConstructorReturn3.default)(this,(GroupAdvice.__proto__||(0,_getPrototypeOf2.default)(GroupAdvice)).call(this,props));_this.init=function(){var store=_this.props.hrmGroupAdvice;store.getOrgGroupSuggestForm();};return _this;}(0,_createClass3.default)(GroupAdvice,[{key:'componentWillMount',value:function componentWillMount(){var query=this.props.location.query;var store=this.props.hrmGroupAdvice;store.extractParamsFromURL(query);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.location.key!==nextProps.location.key){this.init();}}},{key:'componentDidMount',value:function componentDidMount(){this.init();}},{key:'render',value:function render(){var store=this.props.hrmGroupAdvice,f=store.f,footerButtons=store.footerButtons,loading=f.loading;if(loading){return _react2.default.createElement(_learn.Loading,null);}return _react2.default.createElement('div',{className:'groupAdvice'},_react2.default.createElement('div',{className:'form'},_react2.default.createElement(_Form2.default,{datas:f})),_react2.default.createElement(_ecCom.WeaDialogFooter,{buttons:footerButtons,moreBtn:{datas:[]}}));}}]);return GroupAdvice;}(_react2.default.Component))||_class)||_class);exports.default=GroupAdvice;

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(557);__webpack_require__(558);

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _checking=__webpack_require__(560);var _checking2=__webpack_require__(565);var _birthdayinfo=__webpack_require__(567);var _group=__webpack_require__(569);var _total=__webpack_require__(570);var _shift=__webpack_require__(585);var _outside=__webpack_require__(587);var _online=__webpack_require__(589);var _underling=__webpack_require__(591);var _trainrecord=__webpack_require__(593);var _rewardsrecord=__webpack_require__(595);var _finance=__webpack_require__(597);var _roleset=__webpack_require__(599);var _card=__webpack_require__(601);var _personal=__webpack_require__(602);var _work=__webpack_require__(603);var _password=__webpack_require__(604);var _systemCard=__webpack_require__(606);var _cardInfo=__webpack_require__(608);var _cardInfo4Formal=__webpack_require__(609);var _addressBook=__webpack_require__(610);var _add=__webpack_require__(618);var _systeminfo=__webpack_require__(620);var _addgroup=__webpack_require__(624);var _perStatusReport=__webpack_require__(626);var _changeReport=__webpack_require__(627);var _constrpsubsearch=__webpack_require__(628);var _rpsubsearch=__webpack_require__(630);var _schedulediffreport=__webpack_require__(632);var _schedulediffreport4Formal=__webpack_require__(633);var _schedulediffmonthattdetail=__webpack_require__(634);var _orgChart=__webpack_require__(636);var _bindtokenkey=__webpack_require__(638);var _forgetPassword=__webpack_require__(640);var _applicant=__webpack_require__(643);var _useDemand=__webpack_require__(645);var _timeWageSummary=__webpack_require__(647);var _staffPayrollSummary=__webpack_require__(649);var _secondaryVerify=__webpack_require__(651);var _spaGroup=__webpack_require__(654);var _importCommon=__webpack_require__(655);var _tax=__webpack_require__(657);var _groupAdvice=__webpack_require__(659);var hrmChecking=new _checking.HrmChecking();var hrmOldChecking=new _checking2.HrmOldChecking();var hrmBirthdayInfo=new _birthdayinfo.HrmBirthdayInfo();var hrmGroup=new _group.HrmGroup();var hrmResourceTotal=new _total.HrmResourceTotal();var hrmShift=new _shift.HrmShift();var hrmOutside=new _outside.HrmOutside();var hrmOnline=new _online.HrmOnline();var hrmUnderling=new _underling.HrmUnderling();var hrmTrainRecord=new _trainrecord.HrmTrainRecord();var hrmRewardsRecord=new _rewardsrecord.HrmRewardsRecord();var hrmFinance=new _finance.HrmFinance();var hrmRoleSet=new _roleset.HrmRoleSet();var hrmCard=new _card.HrmCard();var hrmPersonal=new _personal.HrmPersonal();var hrmWork=new _work.HrmWork();var hrmPassword=new _password.HrmPassword();var hrmSystemCard=new _systemCard.HrmSystemCard();var hrmCardInfo=new _cardInfo.HrmCardInfo();var hrmCardInfo4Formal=new _cardInfo4Formal.HrmCardInfo4Formal();var hrmAddressBook=new _addressBook.HrmAddressBook();var hrmAdd=new _add.HrmAdd();var hrmSystemInfo=new _systeminfo.HrmSystemInfo();var hrmAddGroup=new _addgroup.HrmAddGroup();var hrmPerStatusReport=new _perStatusReport.HrmPerStatusReport();var hrmChangeReport=new _changeReport.HrmChangeReport();var hrmConstRpSubSearch=new _constrpsubsearch.HrmConstRpSubSearch();var hrmRpSubSearch=new _rpsubsearch.HrmRpSubSearch();var hrmScheduleDiffReport=new _schedulediffreport.HrmScheduleDiffReport();var hrmScheduleDiffReport4Formal=new _schedulediffreport4Formal.HrmScheduleDiffReport4Formal();var hrmScheduleDiffMonthAttDetail=new _schedulediffmonthattdetail.HrmScheduleDiffMonthAttDetail();var bindTokenKey=new _bindtokenkey.BindTokenKey();var hrmApplicant=new _applicant.HrmApplicant();var hrmUsedemand=new _useDemand.HrmUsedemand();var hrmTimeWageSummary=new _timeWageSummary.HrmTimeWageSummary();var hrmStaffPayrollSummary=new _staffPayrollSummary.HrmStaffPayrollSummary();var hrmSecondaryVerify=new _secondaryVerify.HrmSecondaryVerify();var hrmImportCommon=new _importCommon.HrmImportCommon();module.exports={hrmChecking:hrmChecking,hrmOldChecking:hrmOldChecking,hrmBirthdayInfo:hrmBirthdayInfo,hrmGroup:hrmGroup,hrmResourceTotal:hrmResourceTotal,hrmShift:hrmShift,hrmOutside:hrmOutside,hrmOnline:hrmOnline,hrmUnderling:hrmUnderling,hrmTrainRecord:hrmTrainRecord,hrmRewardsRecord:hrmRewardsRecord,hrmFinance:hrmFinance,hrmRoleSet:hrmRoleSet,hrmCard:hrmCard,hrmPersonal:hrmPersonal,hrmWork:hrmWork,hrmPassword:hrmPassword,hrmSystemCard:hrmSystemCard,hrmCardInfo:hrmCardInfo,hrmCardInfo4Formal:hrmCardInfo4Formal,hrmAddressBook:hrmAddressBook,hrmAdd:hrmAdd,hrmSystemInfo:hrmSystemInfo,hrmAddGroup:hrmAddGroup,hrmPerStatusReport:hrmPerStatusReport,hrmChangeReport:hrmChangeReport,hrmConstRpSubSearch:hrmConstRpSubSearch,hrmRpSubSearch:hrmRpSubSearch,hrmScheduleDiffReport:hrmScheduleDiffReport,hrmScheduleDiffReport4Formal:hrmScheduleDiffReport4Formal,hrmScheduleDiffMonthAttDetail:hrmScheduleDiffMonthAttDetail,hrmOrgChart:_orgChart.hrmOrgChart,bindTokenKey:bindTokenKey,hrmForgetPassword:_forgetPassword.hrmForgetPassword,hrmApplicant:hrmApplicant,hrmUsedemand:hrmUsedemand,hrmTimeWageSummary:hrmTimeWageSummary,hrmStaffPayrollSummary:hrmStaffPayrollSummary,hrmSecondaryVerify:hrmSecondaryVerify,hrmSpaGroup:_spaGroup.hrmSpaGroup,hrmImportCommon:hrmImportCommon,hrmTax:_tax.hrmTax,hrmGroupAdvice:_groupAdvice.hrmGroupAdvice};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmChecking=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29;var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _checking=__webpack_require__(563);var API=_interopRequireWildcard(_checking);var _index=__webpack_require__(246);var Util=_interopRequireWildcard(_index);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _comsMobx=__webpack_require__(10);var _pulicFunc=__webpack_require__(564);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmChecking=exports.HrmChecking=(_class=function(){function HrmChecking(props){var _this=this;(0,_classCallCheck3.default)(this,HrmChecking);this.tabDatas=[{title:'考勤统计',key:"1"},{title:'考勤日历',key:"2"}];this.leftTitle='人员组织';this.dateTabDatas=[{title:'年',key:"1"},{title:'月',key:"2"}];this.stsType='';_initDefineProp(this,'hrmId',_descriptor,this);_initDefineProp(this,'newWorklist',_descriptor2,this);_initDefineProp(this,'visible',_descriptor3,this);_initDefineProp(this,'newVisible',_descriptor4,this);_initDefineProp(this,'table',_descriptor5,this);_initDefineProp(this,'yearData',_descriptor6,this);_initDefineProp(this,'calendarData',_descriptor7,this);_initDefineProp(this,'sData',_descriptor8,this);_initDefineProp(this,'hrmName',_descriptor9,this);_initDefineProp(this,'statusActiveType',_descriptor10,this);_initDefineProp(this,'calendarCheckedDay',_descriptor11,this);_initDefineProp(this,'loading',_descriptor12,this);_initDefineProp(this,'tabkey',_descriptor13,this);_initDefineProp(this,'dateTabkey',_descriptor14,this);_initDefineProp(this,'userRoot',_descriptor15,this);_initDefineProp(this,'pDate',_descriptor16,this);_initDefineProp(this,'pDate1',_descriptor17,this);_initDefineProp(this,'hasRight',_descriptor18,this);_initDefineProp(this,'chartOptions',_descriptor19,this);_initDefineProp(this,'groupitem2',_descriptor20,this);_initDefineProp(this,'groupitem3',_descriptor21,this);_initDefineProp(this,'groupitem4',_descriptor22,this);_initDefineProp(this,'groupitem5',_descriptor23,this);_initDefineProp(this,'getStatusList',_descriptor24,this);_initDefineProp(this,'getHrmKQSignInfo',_descriptor25,this);this.dialogHeight=790;this.kqDetailDialogHeight=500;this.setDialogHeight=function(h){_this.kqDetailDialogHeight=h;};this.ABSENCEDIALOG={icon:'icon-coms-hrm',iconBgcolor:'#217346',onCancel:function onCancel(){_this.absenceDialog.visible=false;},onChangeHeight:function onChangeHeight(h){_this.dialogHeight=h;},moreBtn:{datas:[]},style:{width:800,height:790},title:getLabel(507088,'未出勤明细')};_initDefineProp(this,'absenceDialog',_descriptor26,this);_initDefineProp(this,'absenceDetail',_descriptor27,this);_initDefineProp(this,'openAbsenceDialog',_descriptor28,this);_initDefineProp(this,'getHrmKQReportDetialInfo',_descriptor29,this);this.statusList=[{name:'全部',type:'ALL'},{name:'正常',type:'NORMAL'},{name:'迟到',type:'BELATE'},{name:'早退',type:'LEAVEEARLY'},{name:'旷工',type:'ABSENT'},{name:'漏签',type:'NOSIGN'},{name:'请假',type:'LEAVE'},{name:'出差',type:'EVECTION'},{name:'公出',type:'OUTDAYS'},{name:'加班',type:'OVERTIME'}];this.statusList.reverse();// this.statusList.forEach((item)=> {
//   const ic = Util.getIconColor(item.type);
//   item.icon = ic.icon;
//   item.color = ic.color;
//   item.name = ic.name;
//   if(ic.title){
//     item.title = ic.title;
//   }
// });
}(0,_createClass3.default)(HrmChecking,[{key:'handlerNewWorkflow',value:function handlerNewWorkflow(item){(0,_pulicFunc.onNewRequest)(item);this.newVisible=false;}},{key:'updateVisible',value:function updateVisible(v){this.visible=v;}},{key:'updateNewVisible',value:function updateNewVisible(v){this.newVisible=v;}},{key:'updateStsType',value:function updateStsType(v){this.stsType=v;}},{key:'handlerStatusClick',value:function handlerStatusClick(type){this.statusActiveType=type;}},{key:'updateCalendarCheckedDay',value:function updateCalendarCheckedDay(v){this.calendarCheckedDay=v;this.getHrmKQSignInfo();}},{key:'changeTabHandler',value:function changeTabHandler(key){this.tabkey=key;this.calendarCheckedDay=undefined;this.statusActiveType='ALL';}},{key:'changeDateTabHandler',value:function changeDateTabHandler(key){if(this.pDate){if(key=='1'){this.pDate=new _moment2.default().format('YYYY');}else{this.pDate=new _moment2.default().format('YYYY-MM');}}this.pDate1=new _moment2.default();this.dateTabkey=key;this.calendarCheckedDay=undefined;this.statusActiveType='ALL';}},{key:'updateDateTabkey',value:function updateDateTabkey(key){this.dateTabkey=key;}},{key:'changeDateHandler',value:function changeDateHandler(v){this.pDate=v;if(v.length==4)this.pDate1=new _moment2.default().year(v);this.statusActiveType='ALL';this.calendarCheckedDay=undefined;}},{key:'init',value:function init(){this.tabkey='1';this.dateTabkey='2';this.pDate=new _moment2.default().format('YYYY-MM');this.hrmId=undefined;this.hrmName=_ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;this.userRoot=undefined;}},{key:'updateUserRoot',value:function updateUserRoot(data){this.userRoot=data;}},{key:'updateHrmId',value:function updateHrmId(v){this.hrmId=v;}},{key:'updateHrmName',value:function updateHrmName(v){this.hrmName=v||_ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;}},{key:'getTableData',value:function getTableData(){var _this2=this;var params={};if(this.hrmId)params.resourceId=this.hrmId;if(this.pDate)params.typevalue=this.pDate;params.type=this.dateTabkey;params.kqtype=this.stsType;this.table=new TableStore();API.getTableData(params).then(function(datas){_this2.table.getDatas(datas.sessionkey,1);});}},{key:'getData',value:function getData(cb){var _this3=this;var params={};if(this.hrmId)params.resourceId=this.hrmId;if(this.pDate)params.typevalue=this.pDate;params.loaddata="1";params.type=this.dateTabkey;this.loading=true;if(this.tabkey=='1'){API.getKQReport(params).then(function(datas){if(datas.status=='1'){_this3.hasRight=true;if(datas.groupitem1){_this3.chartOptions.series[0].name=getLabel('16732',"出勤统计");_this3.chartOptions.series[0].label.normal.formatter=['{a|'+parseFloat(datas.groupitem1.value)+'}','{b|'+datas.groupitem1.name+'}'].join('\n');datas.groupitem1.items.forEach(function(i){i.value=parseFloat(i.value);});_this3.chartOptions.series[0].data=datas.groupitem1.items;var items=datas.groupitem1.items;var total=0;items.forEach(function(item){var value=item.value;total+=parseInt(value);});if(total===0){_this3.chartOptions.series[0].color='#ccc';}else{_this3.chartOptions.series[0].color=['#FC4B6C','#1E88E5'];}}_this3.groupitem2=datas.groupitem2&&datas.groupitem2.items||[];_this3.groupitem2.forEach(function(item){var ic=Util.getIcon(item.type);item.icon=ic.icon;item.color=ic.color;});_this3.groupitem3=datas.groupitem3&&datas.groupitem3.items||[];_this3.groupitem4=datas.groupitem4&&datas.groupitem4.items||[];_this3.groupitem5=datas.groupitem5&&datas.groupitem5.items||[];cb&&cb();}else{_this3.hasRight=false;}_this3.loading=false;});}else{API.getKQCarendarReport(params).then(function(datas){if(datas.status=='1'){if(_this3.dateTabkey=='1'){_this3.yearData=datas.result;}else{_this3.calendarData=datas.result;}_this3.hasRight=true;}else{_this3.hasRight=false;}_this3.loading=false;});}}},{key:'getHrmNewWorkflwList',value:function getHrmNewWorkflwList(){var _this4=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getHrmNewWorkflwList(params).then(function(datas){_this4.newWorklist=datas.result;});}},{key:'hasLeaveInfo',get:function get(){return this.groupitem5.length>0;}}]);return HrmChecking;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'hrmId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'newWorklist',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'visible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'newVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'yearData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'calendarData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'sData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'hrmName',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'statusActiveType',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'ALL';}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'calendarCheckedDay',[_mobx.observable],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'tabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'dateTabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'2';}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'userRoot',[_mobx.observable],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'pDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _moment2.default().format('YYYY-MM');}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'pDate1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _moment2.default();}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'hasRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'chartOptions',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{tooltip:{trigger:'item',formatter:"{a} <br/>{b}: {c} ({d}%)",position:'right'},series:[{type:'pie',name:getLabel('16732',"出勤统计"),radius:['60%','80%'],avoidLabelOverlap:false,label:{normal:{show:true,position:'center',formatter:['{a|'+this.count+'}','{b|'+this.countTxt+'}'].join('\n'),rich:{a:{color:'#484A4D',fontSize:24,lineHeight:24},b:{color:'#666',fontSize:11}}}},color:['#FC4B6C','#1E88E5'],data:[]}]};}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'groupitem2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'groupitem3',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'groupitem4',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'groupitem5',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'getStatusList',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){var arr=[];_this5.statusList.forEach(function(item){var ic=Util.getIconColor(item.type);arr.push((0,_extends3.default)({},ic,{type:item.type}));// item.icon = ic.icon;
// item.color = ic.color;
// item.name = ic.name;
// if(ic.title){
//   item.title = ic.title;
// }
});return arr;};}}),_applyDecoratedDescriptor(_class.prototype,'handlerNewWorkflow',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'handlerNewWorkflow'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateVisible',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateVisible'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateNewVisible',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateNewVisible'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateStsType',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateStsType'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'handlerStatusClick',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'handlerStatusClick'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateCalendarCheckedDay',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateCalendarCheckedDay'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeTabHandler',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'changeTabHandler'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeDateTabHandler',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'changeDateTabHandler'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateDateTabkey',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateDateTabkey'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeDateHandler',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'changeDateHandler'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateUserRoot',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateUserRoot'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateHrmId',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateHrmId'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateHrmName',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateHrmName'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTableData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getTableData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getData'),_class.prototype),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'getHrmKQSignInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(){var params={};var day=void 0;if(_this6.calendarCheckedDay.toString().length<2){day='0'+_this6.calendarCheckedDay;}else{day=_this6.calendarCheckedDay;}if(_this6.hrmId)params.resourceId=_this6.hrmId;if(_this6.pDate)params.date=_this6.pDate+'-'+day;API.getHrmKQSignInfo(params).then(function(datas){var data=datas.data;_this6.sData=data;});};}}),_applyDecoratedDescriptor(_class.prototype,'getHrmNewWorkflwList',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getHrmNewWorkflwList'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasLeaveInfo',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'hasLeaveInfo'),_class.prototype),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'absenceDialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{visible:false,loading:false};}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'absenceDetail',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{absenceDay:0,types:[],details:[]};}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'openAbsenceDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){_this7.absenceDialog.visible=true;_this7.getHrmKQReportDetialInfo();};}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'getHrmKQReportDetialInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){var params={type:_this8.dateTabkey,kqtype:'leaveDays'};_this8.absenceDialog.loading=true;if(_this8.hrmId){(0,_assign2.default)(params,{resourceId:_this8.hrmId});}if(_this8.pDate){(0,_assign2.default)(params,{typevalue:_this8.pDate});}API.getHrmKQReportDetialInfo(params).then(function(datas){['absenceDay','types','details'].forEach(function(v,index){_this8.absenceDetail[v]=datas[v];_this8.absenceDialog.loading=false;});});};}})),_class);

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(562);
var $Object = __webpack_require__(20).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(45);
var $getOwnPropertyDescriptor = __webpack_require__(147).f;

__webpack_require__(142)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getHrmKQReportDetialInfo=exports.getHrmNewWorkflwList=exports.getTableData=exports.getHrmKQSignInfo=exports.getKQCarendarReport=exports.getKQReport=undefined;var _ecCom=__webpack_require__(0);var getKQReport=exports.getKQReport=function getKQReport(params){return _ecCom.WeaTools.callApi('/api/kq/myattendance/getHrmKQReportInfo','POST',params);};var getKQCarendarReport=exports.getKQCarendarReport=function getKQCarendarReport(params){return _ecCom.WeaTools.callApi('/api/kq/myattendance/getHrmKQMonthReportInfo','POST',params);};var getHrmKQSignInfo=exports.getHrmKQSignInfo=function getHrmKQSignInfo(params){return _ecCom.WeaTools.callApi('/api/kq/myattendance/getHrmKQSignInfo','POST',params);};var getTableData=exports.getTableData=function getTableData(params){return _ecCom.WeaTools.callApi('/api/kq/myattendance/getHrmKQReportDetialInfo','POST',params);};var getHrmNewWorkflwList=exports.getHrmNewWorkflwList=function getHrmNewWorkflwList(params){return _ecCom.WeaTools.callApi('/api/hrm/kq/report/getHrmNewWorkflwList','GET',params);};var getHrmKQReportDetialInfo=exports.getHrmKQReportDetialInfo=function getHrmKQReportDetialInfo(params){return _ecCom.WeaTools.callApi('/api/kq/myattendance/getHrmKQReportDetialInfo','POST',params);};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.onNewRequest=exports.jumpToHrmContract=exports.jumpToHrmPost=exports.jumpToHrmSubCompany=exports.jumpToHrmDept=exports.jumpToHrmCard=exports.chkMail=exports.getUserName=exports.jsRewardsRecord2Detial=exports.jsHrmTrainApply=exports.jsTrainRecordShowDetail=exports.openWorkReport=exports.openFnaExpenseResourceDetail=exports.openFnaBudgetResourceDetail=exports.openHrmResourceView=exports.cptSearch=exports.openCRM=exports.doProjcSearch=exports.docSearch=exports.jsRequestView=exports.openFullWindowForXtable=exports.jsHrmResourceSystemView=exports.doAddWorkPlanByHrm=exports.addCoWork=exports.sendSmsMessage=exports.sendMail=exports.sendEmessage=undefined;exports.sendMsgToPC=sendMsgToPC;var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _i18n=__webpack_require__(251);var getLabel=_ecCom.WeaLocaleProvider.getLabel;var confirm=_antd.Modal.confirm;//发消息、发起群聊
function sendEmessage(emessageId){var isGroup=false;if(!!emessageId){if(emessageId.indexOf(",")>-1){isGroup=true;}}if(!emessageId){_antd.message.warning(SystemEnv.getHtmlNoteName(4780,readCookie("languageidweaver")));return;}if(emessageId.match(/,$/)){emessageId=emessageId.substring(0,emessageId.length-1);}var openType=isGroup?"2":"0";if(isGroup){confirm({content:SystemEnv.getHtmlNoteName(4781,readCookie("languageidweaver")),onOk:function onOk(){sendMsgToPC(emessageId,openType,'','');},onCancel:function onCancel(){}});}else{sendMsgToPC(emessageId,openType,'','');}}/**
 * 调用e-message发起会话
 * @param conventioners
 * @param openType
 * @param groupName
 * @param extra
 */function sendMsgToPC(conventioners,openType,groupName,extra,successCallBack,errorCallBack){$.ajax({url:'/social/im/SocialIMOperation.jsp?operation=openPCconversation',data:{conventioners:conventioners,openType:openType,groupName:groupName,extra:extra},type:'post',dataType:'json',contentType:'application/x-www-form-urlencoded; charset=utf-8',success:function success(data){if(data!=null){if(data.pcStatus==0&&data.webStatus==0){// pc和web都不在
_antd.Modal.warning({title:_i18n.i18n.confirm.systemhints(),content:getLabel('386482',"检查到您的web端和客户端的e-message不在线，请打开任意一端进行会话！")});}else if(data.webStatus==1){// web在线
if(window.top.$('#socialIMFrm').length>0){}else{if(!!window.ActiveXObject||'ActiveXObject'in window){_antd.Modal.warning({title:_i18n.i18n.confirm.systemhints(),content:getLabel('386483',"您发起的e-message聊天已经建立，<br>  请到主页进行消息发送！")});}}}else{// pc在线不作判断
}typeof successCallBack==='function'&&successCallBack(data);}else{_antd.Modal.warning({title:_i18n.i18n.confirm.systemhints(),content:getLabel('386484',"对话创建失败！")});typeof errorCallBack==='function'&&errorCallBack();}},error:function error(XMLHttpRequest,textStatus,errorThrown){_antd.Modal.warning({title:_i18n.i18n.confirm.systemhints(),content:getLabel('386485',"请求发送失败，请您检查当前网络！")});typeof errorCallBack==='function'&&errorCallBack();}});}//发送邮件
function sendMail(id){//openFullWindowForXtable("/email/new/MailInBox.jsp?opNewEmail=1&amp;isInternal=1&amp;internalto&id="+id);
window.open('/spa/email/static/index.html#/main/email/new?isInternal=1&internaltonew=[{"id":'+id+',"type":"resource"}]');}//发送短信
function sendSmsMessage(id){//openFullWindowForXtable("/sms/SmsMessageEdit.jsp?hrmid="+id);
window.open('/spa/smallApp/static/index.html#/main/sms/SendSms?hrmid='+id);}//新建协作
function addCoWork(id){//openFullWindowForXtable("/cowork/AddCoWork.jsp?hrmid=" + id);
window.open('/spa/cowork/static/index.html#/main/cowork/main?hrmid='+id);}//新建日程
function doAddWorkPlanByHrm(id){//openFullWindowForXtable("/workplan/data/WorkPlan.jsp?resourceid="+id+"&add=1")
window.open('/spa/workplan/static/index.html#/main/wp/workPlanCreateSingle?type=create&selectedUser='+id);}//系统信息
function jsHrmResourceSystemView(id){//window.open(`/spa/hrm/index.html#/main/hrm/systeminfo${window.WeaHrm4Formal?'4Formal':''}/${id}`);
window.open('/spa/hrm/index_mobx.html#/main/hrm/systeminfo/'+id);}//我的下属--流程
function jsRequestView(id){// openFullWindowForXtable("/workflow/request/RequestView.jsp?resourceid=" + id);
window.open('/spa/workflow/index_mobx.jsp#/main/workflow/listDoing?resourceid='+id);}//我的下属--文档
function docSearch(id){// openFullWindowForXtable('/docs/search/DocSearchTemp.jsp?docstatus=6&hrmresid=' + id);
window.open('/spa/document/static/index.html#/main/document/search?doccreaterid='+id+'&viewcondition=2');}//我的下属--项目
function doProjcSearch(id){// openFullWindowForXtable("/proj/search/SearchOperation.jsp?member=" + id);
window.open('/spa/prj/index.html#/main/prj/mineProject?search_resourceid='+id);}//我的下属--客户
function openCRM(id){// openFullWindowForXtable('/CRM/search/SearchOperation.jsp?destination=myAccount&resourceid=' + id);
window.open('/spa/crm/mobx/index.html#/main/crm/customer/hrmView?searchHrmId='+id);}//我的下属--资产
function cptSearch(id){// openFullWindowForXtable('/cpt/search/SearchOperation.jsp?resourceid=' + id + '&isdata=2');
window.open('/spa/cpt/index.html#/main/cpt/mycapital?hrmid='+id);}//我的下属--下属
function openHrmResourceView(id){//openFullWindowForXtable("/hrm/HrmTab.jsp?_fromURL=HrmResourceView&id="+id+"&srcid="+id);
window.open('/spa/hrm/index_mobx.html#/main/hrm/underling/'+id);}//我的下属--预算
function openFnaBudgetResourceDetail(id){openFullWindowForXtable("/fna/report/budget/FnaBudgetResourceDetail.jsp?resourceid="+id);}//我的下属--收支
function openFnaExpenseResourceDetail(id){// openFullWindowForXtable("/fna/report/expense/FnaExpenseResourceDetail.jsp?resourceid=" + id);
window.open('/fna/cm/rpt/PersonalPayments.jsp?hrmResourceID='+id);}//我的下属--工作报告
function openWorkReport(id){openFullWindowForXtable("/spa/develop/index_mobx.html?#/main/develop/growuplist?userid="+id);}//培训记录--详细信息
function jsTrainRecordShowDetail(id){var dialog=new window.top.Dialog();dialog.currentWindow=window;var url="/hrm/HrmDialogTab.jsp?_fromURL=HrmResourceTrainRecordBasic&isdialog=1&id="+id;dialog.Title=getLabel('386486',"培训记录详细信息");dialog.Width=800;dialog.Height=503;dialog.Drag=true;dialog.URL=url;dialog.show();}//培训记录--培训安排--申请
function jsHrmTrainApply(trainplanid,applyworkflowid){openFullWindowForXtable("/workflow/request/AddRequest.jsp?workflowid="+applyworkflowid+"&TrainPlanId="+trainplanid);}//考核奖惩--奖惩情况--详细信息
function jsRewardsRecord2Detial(id){//openFullWindowForXtable("/hrm/HrmDialogTab.jsp?_fromURL=HrmAwardEdit&id="+id+"&cmd=showdetail");
var dialog=new window.top.Dialog();dialog.currentWindow=window;dialog.Title=getLabel('386487',"奖惩信息");var url="/hrm/HrmDialogTab.jsp?_fromURL=HrmAwardEdit&id="+id+"&cmd=showdetail";dialog.Width=800;dialog.Height=500;dialog.Drag=true;dialog.URL=url;dialog.show();}function openFullWindowForXtable(url){var redirectUrl=url;var width=screen.availWidth-10;var height=screen.availHeight-60;//if (height == 768 ) height -= 75 ;
//if (height == 600 ) height -= 60 ;
var szFeatures="top=0,";szFeatures+="left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";//channelmode
window.open(redirectUrl,"",szFeatures);}var openFullWindowHaveBar=function openFullWindowHaveBar(url){var redirectUrl=url;var width=screen.availWidth-10;var height=screen.availHeight-50;var szFeatures="top=0,";szFeatures+="left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,toolbar=no,location=no,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";//channelmode
window.open(redirectUrl,"",szFeatures);};function getUserName(){try{var _vbsserial="";var _hCard=htactx.OpenDevice(1);//打开设备
if(_hCard==0){_antd.message.warning(getLabel('21607',"请确认您已经正确地安装了驱动程序并插入了usb令牌"));return _vbsserial;}try{_vbsserial=htactx.GetUserName(_hCard);//获取用户名
htactx.CloseDevice(_hCard);return _vbsserial;}catch(e){_antd.message.warning(getLabel('21607',"请确认您已经正确地安装了驱动程序并插入了usb令牌")+'2');htactx.CloseDevice(_hCard);return _vbsserial;}}catch(e){_antd.message.warning(getLabel('21607',"请确认您已经正确地安装了驱动程序并插入了usb令牌"));htactx.CloseDevice(hCard);return vbsserial;}}function chkMail(email){if(email==''){return true;}var pattern=/^(?:[a-z\d]+[_\-\+\.]?)*[a-z\d]+@(?:([a-z\d]+\-?)*[a-z\d]+\.)+([a-z]{2,})+$/i;var chkFlag=pattern.test(email);if(chkFlag){return true;}else{_antd.message.warning(getLabel('24570',"邮箱地址的格式不正确"));return false;}}function jumpToHrmCard(id){//window.open(`/spa/hrm/index.html#/main/hrm/resource${window.WeaHrm4Formal?'4Formal':''}/HrmResourceBase${window.WeaHrm4Formal?'4Formal':''}/${id}`);
window.open('/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/'+id);}function jumpToHrmDept(id){//window.open('/hrm/HrmTab.jsp?_fromURL=HrmDepartmentDsp&id=' + id);
window.open('/spa/hrm/engine.html#/hrmengine/organization?showTree=false&isView=1&type=department&id='+id);}function jumpToHrmSubCompany(id){//window.open('/hrm/HrmTab.jsp?_fromURL=HrmSubCompanyDsp&id=' + id);
window.open('/spa/hrm/engine.html#/hrmengine/organization?showTree=false&isView=1&type=subcompany&id='+id);}function jumpToHrmPost(id){// window.open('/hrm/HrmDialogTab.jsp?_fromURL=HrmJobTitlesEdit&id=' + id);
window.open('/spa/hrm/engine.html#/hrmengine/posts?id='+id);}function jumpToHrmJob(id){window.open('/spa/hrm/engine.html#/hrmengine/singleJob?id='+id);}function jumpToHrmContract(id){window.open('/hrm/contract/contract/HrmContractView.jsp?id='+id);}//新建流程
function onNewRequest(params){var wfid=params.wfid||'';var f_weaver_belongto_userid=params.f_weaver_belongto_userid||'';var beagenter=params.beagenter||'';var isagent=params.isagent||'';//计数
jQuery.post('/workflow/request/AddWorkflowUseCount.jsp',{wfid:wfid});var paramstr='workflowid='+wfid+'&isagent='+isagent+'&beagenter='+beagenter+'&f_weaver_belongto_userid='+f_weaver_belongto_userid+'&f_weaver_belongto_usertype=0';openFullWindowHaveBar('/workflow/request/CreateRequestForward.jsp?'+paramstr);}var openFullWindowHaveBarForWFList=function openFullWindowHaveBarForWFList(url,requestid){try{document.getElementById("wflist_"+requestid+"span").innerHTML="";}catch(e){}var redirectUrl=url;var width=screen.availWidth-10;var height=screen.availHeight-50;var szFeatures="top=0,left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,status=yes,toolbar=no,location=no,";szFeatures+="menubar=no,scrollbars=yes,resizable=yes";window.open(redirectUrl,"",szFeatures);};var viewDepartment=function viewDepartment(departmentid){jumpToHrmDept(departmentid);};var viewSubCompany=function viewSubCompany(subcompanyid){jumpToHrmSubCompany(subcompanyid);};window.viewDepartment=viewDepartment;window.viewSubCompany=viewSubCompany;window.openFullWindowHaveBarForWFList=openFullWindowHaveBarForWFList;exports.sendEmessage=sendEmessage;exports.sendMail=sendMail;exports.sendSmsMessage=sendSmsMessage;exports.addCoWork=addCoWork;exports.doAddWorkPlanByHrm=doAddWorkPlanByHrm;exports.jsHrmResourceSystemView=jsHrmResourceSystemView;exports.openFullWindowForXtable=openFullWindowForXtable;exports.jsRequestView=jsRequestView;exports.docSearch=docSearch;exports.doProjcSearch=doProjcSearch;exports.openCRM=openCRM;exports.cptSearch=cptSearch;exports.openHrmResourceView=openHrmResourceView;exports.openFnaBudgetResourceDetail=openFnaBudgetResourceDetail;exports.openFnaExpenseResourceDetail=openFnaExpenseResourceDetail;exports.openWorkReport=openWorkReport;exports.jsTrainRecordShowDetail=jsTrainRecordShowDetail;exports.jsHrmTrainApply=jsHrmTrainApply;exports.jsRewardsRecord2Detial=jsRewardsRecord2Detial;exports.getUserName=getUserName;exports.chkMail=chkMail;exports.jumpToHrmCard=jumpToHrmCard;exports.jumpToHrmDept=jumpToHrmDept;exports.jumpToHrmSubCompany=jumpToHrmSubCompany;exports.jumpToHrmPost=jumpToHrmPost;exports.jumpToHrmContract=jumpToHrmContract;exports.onNewRequest=onNewRequest;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmOldChecking=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22;var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _checking=__webpack_require__(566);var API=_interopRequireWildcard(_checking);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _comsMobx=__webpack_require__(10);var _pulicFunc=__webpack_require__(23);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmOldChecking=exports.HrmOldChecking=(_class=function(){function HrmOldChecking(props){(0,_classCallCheck3.default)(this,HrmOldChecking);this.tabDatas=[{title:'考勤统计',key:"1"},{title:'考勤日历',key:"2"}];this.leftTitle='人员组织';this.dateTabDatas=[{title:'年',key:"1"},{title:'月',key:"2"}];this.stsType='';_initDefineProp(this,'hrmId',_descriptor,this);_initDefineProp(this,'newWorklist',_descriptor2,this);_initDefineProp(this,'visible',_descriptor3,this);_initDefineProp(this,'newVisible',_descriptor4,this);_initDefineProp(this,'table',_descriptor5,this);_initDefineProp(this,'yearData',_descriptor6,this);_initDefineProp(this,'calendarData',_descriptor7,this);_initDefineProp(this,'hrmName',_descriptor8,this);_initDefineProp(this,'statusActiveType',_descriptor9,this);_initDefineProp(this,'calendarCheckedDay',_descriptor10,this);_initDefineProp(this,'loading',_descriptor11,this);_initDefineProp(this,'tabkey',_descriptor12,this);_initDefineProp(this,'dateTabkey',_descriptor13,this);_initDefineProp(this,'userRoot',_descriptor14,this);_initDefineProp(this,'pDate',_descriptor15,this);_initDefineProp(this,'pDate1',_descriptor16,this);_initDefineProp(this,'hasRight',_descriptor17,this);_initDefineProp(this,'chartOptions',_descriptor18,this);_initDefineProp(this,'groupitem2',_descriptor19,this);_initDefineProp(this,'groupitem3',_descriptor20,this);_initDefineProp(this,'groupitem4',_descriptor21,this);_initDefineProp(this,'getStatusList',_descriptor22,this);this.statusList=[{name:'全部',type:'ALL'},{name:'正常',type:'NORMAL'},{name:'迟到',type:'BELATE'},{name:'早退',type:'LEAVEEARLY'},{name:'旷工',type:'ABSENT'},{name:'漏签',type:'NOSIGN'},{name:'请假',type:'LEAVE'},{name:'出差',type:'EVECTION'},{name:'公出',type:'OUTDAYS'},{name:'加班',type:'OVERTIME'},{name:'异常',type:'OTHER'}];this.statusList.reverse();// this.statusList.forEach((item)=> {
//   const ic = Util.getIconColor(item.type);
//   item.icon = ic.icon;
//   item.color = ic.color;
//   item.name = ic.name;
//   if(ic.title){
//     item.title = ic.title;
//   }
// });
}(0,_createClass3.default)(HrmOldChecking,[{key:'handlerNewWorkflow',value:function handlerNewWorkflow(item){(0,_pulicFunc.onNewRequest)(item);this.newVisible=false;}},{key:'updateVisible',value:function updateVisible(v){this.visible=v;}},{key:'updateNewVisible',value:function updateNewVisible(v){this.newVisible=v;}},{key:'updateStsType',value:function updateStsType(v){this.stsType=v;}},{key:'handlerStatusClick',value:function handlerStatusClick(type){this.statusActiveType=type;}},{key:'updateCalendarCheckedDay',value:function updateCalendarCheckedDay(v){this.calendarCheckedDay=v;}},{key:'changeTabHandler',value:function changeTabHandler(key){this.tabkey=key;this.calendarCheckedDay=undefined;this.statusActiveType='ALL';}},{key:'changeDateTabHandler',value:function changeDateTabHandler(key){if(this.pDate){if(key=='1'){this.pDate=new _moment2.default().format('YYYY');}else{this.pDate=new _moment2.default().format('YYYY-MM');}}this.pDate1=new _moment2.default();this.dateTabkey=key;this.calendarCheckedDay=undefined;this.statusActiveType='ALL';}},{key:'updateDateTabkey',value:function updateDateTabkey(key){this.dateTabkey=key;}},{key:'changeDateHandler',value:function changeDateHandler(v){this.pDate=v;if(v.length==4)this.pDate1=new _moment2.default().year(v);this.statusActiveType='ALL';this.calendarCheckedDay=undefined;}},{key:'init',value:function init(){this.tabkey='1';this.dateTabkey='2';this.pDate=new _moment2.default().format('YYYY-MM');this.hrmId=undefined;this.hrmName=_ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;this.userRoot=undefined;}},{key:'updateUserRoot',value:function updateUserRoot(data){this.userRoot=data;}},{key:'updateHrmId',value:function updateHrmId(v){this.hrmId=v;}},{key:'updateHrmName',value:function updateHrmName(v){this.hrmName=v||_ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;}},{key:'getTableData',value:function getTableData(){var _this=this;var params={};if(this.hrmId)params.resourceId=this.hrmId;if(this.pDate)params.typevalue=this.pDate;params.type=this.dateTabkey;params.kqtype=this.stsType;API.getTableData(params).then(function(datas){_this.table.getDatas(datas.sessionkey,1);});}},{key:'getData',value:function getData(cb){var _this2=this;var params={};if(this.hrmId)params.resourceId=this.hrmId;if(this.pDate)params.typevalue=this.pDate;params.loaddata="1";params.type=this.dateTabkey;this.loading=true;if(this.tabkey=='1'){API.getKQReport(params).then(function(datas){if(datas.status=='1'){_this2.hasRight=true;if(datas.groupitem1){_this2.chartOptions.series[0].name=getLabel('16732',"出勤统计");_this2.chartOptions.series[0].label.normal.formatter=['{a|'+parseFloat(datas.groupitem1.value)+'}','{b|'+datas.groupitem1.name+'}'].join('\n');datas.groupitem1.items.forEach(function(i){i.value=parseFloat(i.value);});_this2.chartOptions.series[0].data=datas.groupitem1.items;}_this2.groupitem2=datas.groupitem2.items;_this2.groupitem2.forEach(function(item){var ic=Util.getIcon(item.type);item.icon=ic.icon;item.color=ic.color;});_this2.groupitem3=datas.groupitem3.items;_this2.groupitem4=datas.groupitem4.items;cb&&cb();}else{_this2.hasRight=false;}_this2.loading=false;});}else{API.getKQCarendarReport(params).then(function(datas){if(datas.status=='1'){if(_this2.dateTabkey=='1'){_this2.yearData=datas.result;}else{_this2.calendarData=datas.result;}_this2.hasRight=true;}else{_this2.hasRight=false;}_this2.loading=false;});}}},{key:'getHrmNewWorkflwList',value:function getHrmNewWorkflwList(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getHrmNewWorkflwList(params).then(function(datas){_this3.newWorklist=datas.result;});}}]);return HrmOldChecking;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'hrmId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'newWorklist',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'visible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'newVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'yearData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'calendarData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'hrmName',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'statusActiveType',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'ALL';}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'calendarCheckedDay',[_mobx.observable],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'tabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'dateTabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'2';}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'userRoot',[_mobx.observable],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'pDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _moment2.default().format('YYYY-MM');}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'pDate1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _moment2.default();}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'hasRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'chartOptions',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{tooltip:{trigger:'item',formatter:"{a} <br/>{b}: {c} ({d}%)",position:'right'},series:[{type:'pie',name:getLabel('16732',"出勤统计"),radius:['60%','80%'],avoidLabelOverlap:false,label:{normal:{show:true,position:'center',formatter:['{a|'+this.count+'}','{b|'+this.countTxt+'}'].join('\n'),rich:{a:{color:'#484A4D',fontSize:24,lineHeight:24},b:{color:'#666',fontSize:11}}}},color:['#FC4B6C','#1E88E5'],data:[]}]};}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'groupitem2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'groupitem3',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'groupitem4',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'getStatusList',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){var arr=[];_this4.statusList.forEach(function(item){var ic=Util.getIconColor(item.type);arr.push((0,_extends3.default)({},ic,{type:item.type}));// item.icon = ic.icon;
// item.color = ic.color;
// item.name = ic.name;
// if(ic.title){
//   item.title = ic.title;
// }
});return arr;};}}),_applyDecoratedDescriptor(_class.prototype,'handlerNewWorkflow',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'handlerNewWorkflow'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateVisible',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateVisible'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateNewVisible',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateNewVisible'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateStsType',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateStsType'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'handlerStatusClick',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'handlerStatusClick'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateCalendarCheckedDay',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateCalendarCheckedDay'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeTabHandler',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'changeTabHandler'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeDateTabHandler',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'changeDateTabHandler'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateDateTabkey',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateDateTabkey'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeDateHandler',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'changeDateHandler'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateUserRoot',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateUserRoot'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateHrmId',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateHrmId'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateHrmName',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateHrmName'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTableData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getTableData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getHrmNewWorkflwList',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getHrmNewWorkflwList'),_class.prototype)),_class);

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getHrmNewWorkflwList=exports.getTableData=exports.getKQCarendarReport=exports.getKQReport=undefined;var _ecCom=__webpack_require__(0);var getKQReport=exports.getKQReport=function getKQReport(params){return _ecCom.WeaTools.callApi('/api/hrm/kq/report/getHrmKQReportInfo','POST',params);};var getKQCarendarReport=exports.getKQCarendarReport=function getKQCarendarReport(params){return _ecCom.WeaTools.callApi('/api/hrm/kq/report/getHrmKQMonthReportInfo','POST',params);};var getTableData=exports.getTableData=function getTableData(params){return _ecCom.WeaTools.callApi('/api/hrm/kq/report/getHrmKQReportDetialInfo','POST',params);};var getHrmNewWorkflwList=exports.getHrmNewWorkflwList=function getHrmNewWorkflwList(params){return _ecCom.WeaTools.callApi('/api/hrm/kq/report/getHrmNewWorkflwList','GET',params);};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmBirthdayInfo=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _birthdayinfo=__webpack_require__(568);var API=_interopRequireWildcard(_birthdayinfo);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmBirthdayInfo=exports.HrmBirthdayInfo=(_class=function(){function HrmBirthdayInfo(){(0,_classCallCheck3.default)(this,HrmBirthdayInfo);this.title=function(){return getLabel('22744',"人员生日");};_initDefineProp(this,'verified',_descriptor,this);_initDefineProp(this,'hasRight',_descriptor2,this);_initDefineProp(this,'form',_descriptor3,this);_initDefineProp(this,'table',_descriptor4,this);_initDefineProp(this,'condition',_descriptor5,this);_initDefineProp(this,'showSearchAd',_descriptor6,this);_initDefineProp(this,'searchParamsAd',_descriptor7,this);}(0,_createClass3.default)(HrmBirthdayInfo,[{key:'getHasRight',value:function getHasRight(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getHasRight(params).then(function(data){_this.hasRight=data.hasRight;if(data.hasRight){_this.getSearchCondition();_this.getSearchList();}_this.verified=true;});}},{key:'getSearchCondition',value:function getSearchCondition(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.form=new _comsMobx.WeaForm();API.getSearchCondition(params).then(function(data){_this2.condition=data.conditions;_this2.form.initFormFields(data.conditions);_this2.form.isFormInit&&_this2.form.updateFields({bMonth:{value:new _moment2.default().format('MM')}});});}},{key:'doSearch',value:function doSearch(){var formParams=this.form.getFormParams();formParams.search="search";this.getSearchList(formParams);}},{key:'getSearchList',value:function getSearchList(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.table=new TableStore();API.getSearchList(params).then(function(data){_this3.table.getDatas(data.sessionkey,1);});}},{key:'setShowSearchAd',value:function setShowSearchAd(bool){this.showSearchAd=bool;}},{key:'getFormParams',value:function getFormParams(){return this.form.getFormParams();}},{key:'getMonth',value:function getMonth(){var options=[];options.push({key:"",showname:""});var tempMonth="";for(var i=1;i<=12;i++){tempMonth=i<10?"0"+i:""+i;options.push({key:tempMonth,showname:tempMonth});}return options;}},{key:'getDay',value:function getDay(){var options=[];options.push({key:"",showname:""});var tempDay="";for(var i=1;i<=30;i++){tempDay=i<10?"0"+i:""+i;options.push({key:tempDay,showname:tempDay});}return options;}}]);return HrmBirthdayInfo;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'verified',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'hasRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'condition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'showSearchAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'searchParamsAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'getHasRight',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getHasRight'),_class.prototype)),_class);

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getSearchList=exports.getSearchCondition=exports.getHasRight=undefined;var _ecCom=__webpack_require__(0);var getHasRight=exports.getHasRight=function getHasRight(params){return _ecCom.WeaTools.callApi('/api/hrm/birthdayinfo/hasRight','GET',params);};var getSearchCondition=exports.getSearchCondition=function getSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/birthdayinfo/getSearchCondition','GET',params);};var getSearchList=exports.getSearchList=function getSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/birthdayinfo/getSearchResult','POST',params);};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmGroup=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33,_descriptor34,_descriptor35,_descriptor36,_descriptor37,_descriptor38,_descriptor39,_descriptor40,_descriptor41,_descriptor42,_descriptor43,_descriptor44,_descriptor45,_descriptor46,_descriptor47,_descriptor48,_descriptor49,_descriptor50,_descriptor51,_descriptor52,_descriptor53,_descriptor54,_descriptor55,_descriptor56,_descriptor57,_descriptor58,_descriptor59,_descriptor60;var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _hrmgroup=__webpack_require__(259);var Api=_interopRequireWildcard(_hrmgroup);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var toJS=mobx.toJS;var TableStore=_comsMobx.WeaTableNew.TableStore;var confirm=_antd.Modal.confirm;var HrmGroup=exports.HrmGroup=(_class=function(){function HrmGroup(){(0,_classCallCheck3.default)(this,HrmGroup);_initDefineProp(this,'editTabKey',_descriptor,this);_initDefineProp(this,'suggestTabKey',_descriptor2,this);_initDefineProp(this,'condition1',_descriptor3,this);_initDefineProp(this,'condition2',_descriptor4,this);_initDefineProp(this,'condition3',_descriptor5,this);_initDefineProp(this,'condition4',_descriptor6,this);_initDefineProp(this,'condition5',_descriptor7,this);_initDefineProp(this,'condition6',_descriptor8,this);_initDefineProp(this,'condition7',_descriptor9,this);_initDefineProp(this,'isSuggestDialogShow',_descriptor10,this);_initDefineProp(this,'isPanelOneShow',_descriptor11,this);_initDefineProp(this,'isPanelTwoShow',_descriptor12,this);_initDefineProp(this,'isPanelThreeShow',_descriptor13,this);_initDefineProp(this,'isNewDialogShow',_descriptor14,this);_initDefineProp(this,'isEditDialogShow',_descriptor15,this);_initDefineProp(this,'isMadalShow',_descriptor16,this);_initDefineProp(this,'isImportBaseDialogShow',_descriptor17,this);_initDefineProp(this,'isImportMemberDialogShow',_descriptor18,this);_initDefineProp(this,'isShareDialogShow',_descriptor19,this);_initDefineProp(this,'isImportInfoDialogShow',_descriptor20,this);_initDefineProp(this,'isImportHistoryDialogShow',_descriptor21,this);_initDefineProp(this,'isImportMemInfoDialogShow',_descriptor22,this);_initDefineProp(this,'form1',_descriptor23,this);_initDefineProp(this,'form2',_descriptor24,this);_initDefineProp(this,'form3',_descriptor25,this);_initDefineProp(this,'form4',_descriptor26,this);_initDefineProp(this,'form5',_descriptor27,this);_initDefineProp(this,'form6',_descriptor28,this);_initDefineProp(this,'form7',_descriptor29,this);_initDefineProp(this,'tableStore1',_descriptor30,this);_initDefineProp(this,'tableStore2',_descriptor31,this);_initDefineProp(this,'tableStore3',_descriptor32,this);_initDefineProp(this,'tableStore4',_descriptor33,this);_initDefineProp(this,'groupid',_descriptor34,this);_initDefineProp(this,'memberid',_descriptor35,this);_initDefineProp(this,'typeid',_descriptor36,this);_initDefineProp(this,'excelfile',_descriptor37,this);_initDefineProp(this,'list',_descriptor38,this);_initDefineProp(this,'upStatus',_descriptor39,this);_initDefineProp(this,'importStatus',_descriptor40,this);_initDefineProp(this,'currentIndex',_descriptor41,this);_initDefineProp(this,'logFilePath',_descriptor42,this);_initDefineProp(this,'loading',_descriptor43,this);_initDefineProp(this,'columns',_descriptor44,this);_initDefineProp(this,'dataSource',_descriptor45,this);_initDefineProp(this,'action',_descriptor46,this);_initDefineProp(this,'delFileNum',_descriptor47,this);_initDefineProp(this,'suggestid',_descriptor48,this);_initDefineProp(this,'hasTrumpet',_descriptor49,this);_initDefineProp(this,'hasHint',_descriptor50,this);_initDefineProp(this,'height',_descriptor51,this);_initDefineProp(this,'orderArr',_descriptor52,this);_initDefineProp(this,'rowIdArr',_descriptor53,this);_initDefineProp(this,'valArr',_descriptor54,this);_initDefineProp(this,'checkBoxVal',_descriptor55,this);_initDefineProp(this,'hasWeaTop',_descriptor56,this);_initDefineProp(this,'selectvalue',_descriptor57,this);_initDefineProp(this,'scopeValue',_descriptor58,this);_initDefineProp(this,'isImportStop',_descriptor59,this);_initDefineProp(this,'hasAuthority',_descriptor60,this);}(0,_createClass3.default)(HrmGroup,[{key:'updateFormFields',value:function updateFormFields(arg,val){if(arg=='1')this.form1.updateFields({name:{value:val}});if(arg=='2')this.form2.updateFields({resourcename:{value:val}});if(arg=='3')this.form4.updateFields({excelfile:{value:val}});if(arg=='4')this.form5.updateFields({excelfile:{value:val}});if(arg=='5')this.form7.updateFields({suggesttitle:{value:val}});if(arg=='6')this.form6.updateFields({seclevel__seclevelTo:{value:val}});}},{key:'tabClick',value:function tabClick(key){this.editTabKey=key;if(key=='0'){this.getPanelForm('1');}if(key=='1'){this.getPanelForm('2');this.getTableInfo('2');}if(key=='2'){this.getTableInfo('3');}}},{key:'suggestTabClick',value:function suggestTabClick(key){this.suggestTabKey=key;this.getTableInfo('7');}},{key:'tabReset',value:function tabReset(){this.editTabKey='0';}},{key:'getPanelForm',value:function getPanelForm(arg){var _this2=this;var params=void 0;if(arg=='1')params={cmd:'base'};if(arg=='2')params={cmd:'member'};if(arg=='3')params={cmd:'suggest'};Api.getSearchCondition(params).then(function(data){if(arg=='1'){_this2.condition1=data.condition;_this2.form1.initFormFields(data.condition);}if(arg=='2'){_this2.condition2=data.condition;_this2.form2.initFormFields(data.condition);}if(arg=='3'){_this2.condition7=data.condition;_this2.form7.initFormFields(data.condition);}});}},{key:'getForm',value:function getForm(arg){var _this3=this;var params=void 0;if(arg=='1'||arg=='2'){params={cmd:'base'};}if(arg=='2'){params.groupid=this.groupid;}if(arg=='3'){params={cmd:'importbase'};}if(arg=='4'){params={cmd:'importmember'};}if(arg=='5'){params={cmd:'share'};}Api.getFormCondition(params).then(function(data){if(arg=='1'||arg=='2'){_this3.condition3=data.condition;_this3.form3.initFormFields(data.condition);}if(arg=='1'){_this3.setNewDialogStatus(true);}if(arg=='2'){_this3.setNewDialogStatus(false);_this3.setEditDialogStatus(true);}if(arg=='3'){_this3.condition4=data.condition;_this3.form4.initFormFields([data.condition[0]]);_this3.setImportBaseDialogStatus(true);}if(arg=='4'){_this3.condition5=data.condition;_this3.form5.initFormFields([data.condition[0]]);_this3.setImportMemberDialogStatus(true);}if(arg=='5'){data.condition[0].items=_this3.putElementToLast('rolelevel',data.condition[0].items);_this3.condition6=data.condition;_this3.form6.initFormFields(data.condition);_this3.setShareDialogStatus(true);}});}},{key:'getTableInfo',value:function getTableInfo(arg){var _this4=this;var params=void 0;if(arg=='1'){params=(0,_extends3.default)({cmd:'base'},this.form1.getFormParams());}if(arg=='2'){params=(0,_extends3.default)({cmd:'member',groupid:this.groupid},this.form2.getFormParams());}if(arg=='3'){params={cmd:'share',groupid:this.groupid};}if(arg=='4'){params={cmd:'importbaseresult',currentIndex:this.currentIndex};}if(arg=='5'){params={cmd:'importhistory',importtype:'group'};}if(arg=='6'){params={cmd:'importmemberresult',currentIndex:this.currentIndex};}if(arg=='7'){params=(0,_extends3.default)({cmd:'suggest',status:(parseInt(this.suggestTabKey)-3).toString()},this.form7.getFormParams());}Api.getSearchResult(params).then(function(data){if(data.status=='-1'&&arg!=='5'){if(data.message)_antd.message.warning(data.message);_this4.loading=false;return false;}if(data.status=='-1'&&arg=='5'){_this4.setAuthorityStatus(false);_this4.loading=false;return false;}_this4.setAuthorityStatus(true);if(arg=='1'){_this4.tableStore1.getDatas(data.sessionkey,1);}if(arg=='2'){_this4.tableStore2.getDatas(data.sessionkey,1);}if(arg=='3'){_this4.tableStore3.getDatas(data.sessionkey,1);}if(arg=='4'||arg=='6'){var is=data.importStatus;_this4.importStatus=is;if(is=='over'&&data.logFilePath){_this4.logFilePath=data.logFilePath;}if(data.items){_this4.dataSource=_this4.dataSource.concat(data.items);_this4.currentIndex=_this4.dataSource.length;}_this4.columns=data.columns;}if(arg=='5'){data.columns[0].width='40%';data.columns[1].width='40%';data.columns[2].width='20%';if(data.items.length==0)_this4.loading=false;_this4.columns=data.columns;_this4.dataSource=data.items;_this4.action=data.action;}if((arg=='4'||arg=='5'||arg=='6')&&data.items&&data.items.length>0){_this4.loading=false;}if(arg=='7'){_this4.tableStore4.getDatas(data.sessionkey,1);}});}},{key:'save',value:function save(arg){var _this5=this;var params=void 0;if(arg=='1'||arg=='2'||arg=='9'){params=this.form3.getFormParams();if(!params.name){_antd.message.warning(getLabel('386497',"必填信息不完整！"));return false;}params=(0,_extends3.default)({cmd:'base'},params);}if(arg=='9'){params=(0,_extends3.default)({groupid:this.groupid},params);}if(arg=='3'){params={cmd:'member',groupid:this.groupid,members:this.memberid};}if(arg=='4'){params=this.form6.getFormParams();var sharetype=params.sharetype;var jobtitlelevel=params.jobtitlelevel;if((sharetype=='2'||sharetype=='3'||sharetype=='4'||sharetype=='8'||sharetype=='5')&&(!('seclevel'in params)||!('seclevelTo'in params))){params.seclevel=this.scopeValue[0];params.seclevelTo=this.scopeValue[1];}if(sharetype=='1'&&!params.rsid||sharetype=='2'&&(!params.sbid||params.seclevel==undefined||params.seclevelTo==undefined)||sharetype=='3'&&(!params.did||params.seclevel==undefined||params.seclevelTo==undefined)||sharetype=='4'&&!params.rid||sharetype=='7'&&!params.jobtitle||sharetype=='7'&&jobtitlelevel=='1'&&!params.jobtitledepartment||sharetype=='7'&&jobtitlelevel=='2'&&!params.jobtitlesubcompany||sharetype=='8'&&!params.customid){_antd.message.warning(getLabel('386497',"必填信息不完整！"));return false;}params=(0,_extends3.default)({cmd:'share',groupid:this.groupid},params,{'alllevel':this.checkBoxVal,'rolelevel':(parseInt(this.selectvalue)-1).toString()});}if(arg=='5'){params=(0,_extends3.default)({cmd:'importbase',importtype:'group',creater:''},this.form4.getFormParams());}if(arg=='6'){params=(0,_extends3.default)({cmd:'importmember',groupid:this.groupid},this.form5.getFormParams());}if(arg=='5'||arg=='6'){if(this.importStatus=='over')this.importStatusReset();if(this.isImportStop)this.importStopReset();setTimeout(function(){return _this5.timer(arg);},1000);}if(arg=='7'){params={cmd:'doAdd',id:this.suggestid};}if(arg=='8'){params={cmd:'doChange',id:this.suggestid};}if(arg=='10'){var arr=this.dataFilter(toJS(this.rowIdArr),toJS(this.valArr));for(var i=0;i<arr.length;i++){if(parseInt(arr[i])<0){_antd.message.warning(getLabel('386498',"排序值不能小于0！"));return false;}}var result=this.dataFilter(toJS(this.rowIdArr),toJS(this.orderArr));params={cmd:'saveDspOrder',dspOrder:result};}Api.saveForm(params).then(function(data){if(data.status=='1'){if(data.message)_antd.message.success(data.message);if(data.groupid){_this5.groupid=data.groupid;}if(arg=='1'||arg=='2'){_this5.setNewDialogStatus(false);_this5.getTableInfo('1');}if(arg=='2'){_this5.setEditDialogStatus(true);_this5.getForm('2');}if(arg=='3'){_this5.getTableInfo('1');_this5.getTableInfo('2');}if(arg=='4'){_this5.setShareDialogStatus(false);_this5.getTableInfo('3');_this5.shareFormReset();}if(arg=='7'){_this5.getTableInfo('7');_this5.getTableInfo('1');_this5.getTableInfo('2');}if(arg=='8'){_this5.getTableInfo('7');}if(arg=='9'){_this5.setEditDialogStatus(false);_this5.getTableInfo('1');}if(arg=='10'){_this5.setEditDialogStatus(false);_this5.getTableInfo('1');}}else{if(data.message)_antd.message.warning(data.message);return false;}});}},{key:'putElementToLast',value:function putElementToLast(domkey,arr){var index=this.getIndex(domkey,arr);if(index){var ele=arr.splice(index,1);arr.push(ele[0]);}else{return false;}return arr;}},{key:'getIndex',value:function getIndex(domkey,arr){var index=void 0;for(var i=0;i<arr.length;i++){if(domkey==arr[i].domkey[0]){index=i;}}return index;}},{key:'delete',value:function _delete(arg,tag1,tag2){var _this6=this;var params=void 0;if(arg=='1'){params={cmd:'base',groupid:this.groupid};}if(arg=='2'){params={cmd:'member',groupid:this.groupid,id:this.memberid};}if(arg=='3'){params={cmd:'share',groupid:this.groupid,id:this.typeid};}if(arg=='4'){params={cmd:'importhistory',filename:this.delFileNum};}if(arg=='5'){params={cmd:'doDel',id:this.suggestid};}Api.deleteTableRow(params).then(function(data){if(tag1=='batch'&&tag2=='last'){if(data.status=='1'){if(data.message)_antd.message.success(data.message);_this6.getTableInfo('1');if(arg=='2'){_this6.getTableInfo('2');}if(arg=='3'){_this6.getTableInfo('3');}}else{if(data.message)_antd.message.warning(data.message);return false;}}if(tag1!=='batch'&&data.status=='1'){if(data.message)_antd.message.success(data.message);_this6.getTableInfo('1');if(arg=='2'){_this6.getTableInfo('2');}if(arg=='3'){_this6.getTableInfo('3');}if(arg=='4'){_this6.getTableInfo('5');}if(arg=='5'){_this6.getTableInfo('7');_this6.getTableInfo('2');}}else{if(data.message)_antd.message.warning(data.message);return false;}});}},{key:'hasSuggestHint',value:function hasSuggestHint(){var _this7=this;var params={cmd:'isHasSuggest'};Api.getSearchResult(params).then(function(data){if(data.isHas==1){_this7.setTrumpet(true);_this7.getPanelForm('3');_this7.getTableInfo('7');}else{_this7.setTrumpet(false);}if(data.isHasNew==1){_this7.setHint(true);}else{_this7.setHint(false);}});}},{key:'timer',value:function timer(arg){var _this8=this;var t=setInterval(function(){if(_this8.importStatus=='over'){clearInterval(t);_this8.importStatusReset();_this8.currentIndexReset();if(!_this8.isImportStop){_antd.message.success(getLabel('386988',"导入完成！"));}_this8.getTableInfo('2');_this8.getTableInfo('1');return false;}arg=='5'?_this8.getTableInfo('4'):_this8.getTableInfo('6');},1000);}},{key:'dataFilter',value:function dataFilter(arr,_arr){var _arr_=[];for(var i=0;i<arr.length;i++){if(arr.indexOf(arr[i])==arr.lastIndexOf(arr[i])){if(_arr_.indexOf(_arr[i])==-1){_arr_.push(_arr[i]);}}else{var index=arr.lastIndexOf(arr[i]);if(_arr_.indexOf(_arr[index])==-1){_arr_.push(_arr[index]);}}}return _arr_;}},{key:'showConfirm',value:function showConfirm(arg,bool){var _this=this;confirm({title:_i18n.i18n.confirm.defaultTitle(),content:getLabel('386499',"文件导入未完成，您确定要关闭当前弹出框吗?"),okText:_i18n.i18n.button.ok(),cancelText:_i18n.i18n.button.cancel(),onOk:function onOk(){if(arg=='1')_this.isImportInfoDialogShow=false;if(arg=='2')_this.isImportMemInfoDialogShow=false;_this.loadingReset();_this.colAndDsReset();_this.logFilePathReset();if(_this.importStatus=='importing'){_this.importStatus='over';_this.setImportStopStatus(true);}},onCancel:function onCancel(){return false;}});}},{key:'setSuggestDialogStatus',value:function setSuggestDialogStatus(bool){this.isSuggestDialogShow=bool;this.hasSuggestHint();this.form7.reset();}},{key:'setPanelOneStatus',value:function setPanelOneStatus(bool){this.isPanelOneShow=bool;}},{key:'setPanelTwoStatus',value:function setPanelTwoStatus(bool){this.isPanelTwoShow=bool;}},{key:'setPanelThreeStatus',value:function setPanelThreeStatus(bool){this.isPanelThreeShow=bool;}},{key:'setNewDialogStatus',value:function setNewDialogStatus(bool){this.isNewDialogShow=bool;}},{key:'setEditDialogStatus',value:function setEditDialogStatus(bool){this.isEditDialogShow=bool;this.form2.reset();}},{key:'setGroupId',value:function setGroupId(groupid){this.groupid=groupid;}},{key:'setMemberId',value:function setMemberId(memberid){this.memberid=memberid;}},{key:'setTypeId',value:function setTypeId(typeid){this.typeid=typeid;}},{key:'setMadalStatus',value:function setMadalStatus(bool){this.isMadalShow=bool;}},{key:'setWeaTopStatus',value:function setWeaTopStatus(bool){this.hasWeaTop=bool;}},{key:'setImportBaseDialogStatus',value:function setImportBaseDialogStatus(bool){this.isImportBaseDialogShow=bool;if(!bool){this.upStatusReset();this.excelfileReset();this.listReset();}}},{key:'setImportMemberDialogStatus',value:function setImportMemberDialogStatus(bool){this.isImportMemberDialogShow=bool;if(!bool){this.upStatusReset();this.excelfileReset();this.listReset();}}},{key:'setShareDialogStatus',value:function setShareDialogStatus(bool){this.isShareDialogShow=bool;this.shareFormReset();}},{key:'setImportInfoDialogStatus',value:function setImportInfoDialogStatus(bool){if(bool){this.isImportInfoDialogShow=true;}else{if(this.importStatus=='importing'){this.showConfirm('1',false);}else{this.isImportInfoDialogShow=false;this.importStatus='over';this.setImportStopStatus(false);this.loadingReset();this.colAndDsReset();this.logFilePathReset();}}}},{key:'setImportHistoryDialogStatus',value:function setImportHistoryDialogStatus(bool){this.isImportHistoryDialogShow=bool;if(!bool){this.loadingReset();this.colAndDsReset();this.actionReset();}}},{key:'setImportMemInfoDialogStatus',value:function setImportMemInfoDialogStatus(bool){if(bool){this.isImportMemInfoDialogShow=true;}else{if(this.importStatus=='importing'){this.showConfirm('2',false);}else{this.isImportMemInfoDialogShow=false;this.importStatus='over';this.setImportStopStatus(false);this.loadingReset();this.colAndDsReset();this.logFilePathReset();}}}},{key:'setImportStopStatus',value:function setImportStopStatus(bool){this.isImportStop=bool;}},{key:'setExcelfile',value:function setExcelfile(excelfile){this.excelfile=excelfile;}},{key:'setList',value:function setList(list){this.list=list;}},{key:'setUpStatus',value:function setUpStatus(upStatus){this.upStatus=upStatus;}},{key:'setDelFileNum',value:function setDelFileNum(delFileNum){this.delFileNum=delFileNum;}},{key:'setSuggestId',value:function setSuggestId(suggestid){this.suggestid=suggestid;}},{key:'setTrumpet',value:function setTrumpet(bool){this.hasTrumpet=bool;}},{key:'setHint',value:function setHint(bool){this.hasHint=bool;}},{key:'setAuthorityStatus',value:function setAuthorityStatus(bool){this.hasAuthority=bool;}},{key:'setDsporderArr',value:function setDsporderArr(val,rowData){if(val<0){_antd.message.warning(getLabel('386498',"排序值不能小于0！"));}this.rowIdArr.push(rowData.id);this.orderArr.push(rowData.id+'-'+val);this.valArr.push(val);}},{key:'setImportStatus',value:function setImportStatus(status){this.importStatus=status;}},{key:'setCheckBoxVal',value:function setCheckBoxVal(val){this.checkBoxVal=val;}},{key:'setSelectValue',value:function setSelectValue(val){this.selectvalue=val;}},{key:'setScopeValue',value:function setScopeValue(scopeValue){this.scopeValue=scopeValue;this.updateFormFields('6',scopeValue);}},{key:'loadingReset',value:function loadingReset(){this.loading=true;}},{key:'importStatusReset',value:function importStatusReset(){this.importStatus='';}},{key:'colAndDsReset',value:function colAndDsReset(){this.columns=[];this.dataSource=[];}},{key:'actionReset',value:function actionReset(){this.action={};}},{key:'upStatusReset',value:function upStatusReset(){this.upStatus='';}},{key:'logFilePathReset',value:function logFilePathReset(){this.logFilePath='';}},{key:'currentIndexReset',value:function currentIndexReset(){this.currentIndex='0';}},{key:'excelfileReset',value:function excelfileReset(){this.excelfile='';}},{key:'listReset',value:function listReset(){this.list=[];}},{key:'selectValueReset',value:function selectValueReset(){this.selectvalue='1';}},{key:'scopeValueReset',value:function scopeValueReset(){this.scopeValue=[10,100];}},{key:'checkBoxValReset',value:function checkBoxValReset(){this.checkBoxVal=0;}},{key:'shareFormReset',value:function shareFormReset(){this.form6.reset();this.form6.updateFields({sharetype:{value:'1'}});this.checkBoxValReset();this.selectValueReset();this.scopeValueReset();}},{key:'importStopReset',value:function importStopReset(){this.isImportStop=false;}},{key:'changeHeight',value:function changeHeight(height){this.height=height;}}]);return HrmGroup;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'editTabKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'suggestTabKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'3';}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'condition1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'condition2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'condition3',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'condition4',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'condition5',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'condition6',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'condition7',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'isSuggestDialogShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'isPanelOneShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'isPanelTwoShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'isPanelThreeShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'isNewDialogShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'isEditDialogShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'isMadalShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'isImportBaseDialogShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'isImportMemberDialogShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'isShareDialogShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'isImportInfoDialogShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'isImportHistoryDialogShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'isImportMemInfoDialogShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'form1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'form2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'form3',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'form4',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'form5',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'form6',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'form7',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'tableStore1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'tableStore2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'tableStore3',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor33=_applyDecoratedDescriptor(_class.prototype,'tableStore4',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor34=_applyDecoratedDescriptor(_class.prototype,'groupid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor35=_applyDecoratedDescriptor(_class.prototype,'memberid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor36=_applyDecoratedDescriptor(_class.prototype,'typeid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor37=_applyDecoratedDescriptor(_class.prototype,'excelfile',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor38=_applyDecoratedDescriptor(_class.prototype,'list',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor39=_applyDecoratedDescriptor(_class.prototype,'upStatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor40=_applyDecoratedDescriptor(_class.prototype,'importStatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor41=_applyDecoratedDescriptor(_class.prototype,'currentIndex',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor42=_applyDecoratedDescriptor(_class.prototype,'logFilePath',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor43=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor44=_applyDecoratedDescriptor(_class.prototype,'columns',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor45=_applyDecoratedDescriptor(_class.prototype,'dataSource',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor46=_applyDecoratedDescriptor(_class.prototype,'action',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor47=_applyDecoratedDescriptor(_class.prototype,'delFileNum',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor48=_applyDecoratedDescriptor(_class.prototype,'suggestid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor49=_applyDecoratedDescriptor(_class.prototype,'hasTrumpet',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor50=_applyDecoratedDescriptor(_class.prototype,'hasHint',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor51=_applyDecoratedDescriptor(_class.prototype,'height',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 510;}}),_descriptor52=_applyDecoratedDescriptor(_class.prototype,'orderArr',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor53=_applyDecoratedDescriptor(_class.prototype,'rowIdArr',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor54=_applyDecoratedDescriptor(_class.prototype,'valArr',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor55=_applyDecoratedDescriptor(_class.prototype,'checkBoxVal',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor56=_applyDecoratedDescriptor(_class.prototype,'hasWeaTop',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor57=_applyDecoratedDescriptor(_class.prototype,'selectvalue',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor58=_applyDecoratedDescriptor(_class.prototype,'scopeValue',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[10,100];}}),_descriptor59=_applyDecoratedDescriptor(_class.prototype,'isImportStop',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor60=_applyDecoratedDescriptor(_class.prototype,'hasAuthority',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'updateFormFields',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateFormFields'),_class.prototype)),_class);

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmResourceTotal=undefined;var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _keys=__webpack_require__(111);var _keys2=_interopRequireDefault(_keys);var _toConsumableArray2=__webpack_require__(74);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _defineProperty4=__webpack_require__(38);var _defineProperty5=_interopRequireDefault(_defineProperty4);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _hrmresourcetotal=__webpack_require__(571);var API=_interopRequireWildcard(_hrmresourcetotal);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _baseStore=__webpack_require__(129);var _baseStore2=_interopRequireDefault(_baseStore);var _i18n=__webpack_require__(11);var _ecCom=__webpack_require__(0);var _lodash=__webpack_require__(65);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty3.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var TableStore=_comsMobx.WeaTableNew.TableStore;var HrmResourceTotal=exports.HrmResourceTotal=(_class=function(_HrmBaseStore){(0,_inherits3.default)(HrmResourceTotal,_HrmBaseStore);function HrmResourceTotal(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,HrmResourceTotal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=HrmResourceTotal.__proto__||(0,_getPrototypeOf2.default)(HrmResourceTotal)).call.apply(_ref,[this].concat(args))),_this),_this.title=function(){return getLabel('30804',"工作历程");},_initDefineProp(_this,'verified',_descriptor,_this),_initDefineProp(_this,'hasRight',_descriptor2,_this),_initDefineProp(_this,'loading',_descriptor3,_this),_initDefineProp(_this,'condition',_descriptor4,_this),_initDefineProp(_this,'hrmId',_descriptor5,_this),_initDefineProp(_this,'tableList',_descriptor6,_this),_this.tabConfig={tabs:[{color:'#000000',groupId:'roleList',title:'',viewCondition:'1',searchType:['base','advanced'],searchKey:'',doSearch:function doSearch(params){return _this.doSearch(params);}}],tabChangeHandle:_this.setActiveTab,keyParam:'viewCondition',activeTabKey:'1'},_this.otherListCondition={},_this.fields=[],_this.authSearchCondition={},_this.fromid='',_this.selectedTableItem={record:null,index:-1},_this.dialogParams=(0,_extends3.default)({},_this.dialogPropsDef,{style:{width:820,height:650},buttons:[],onCancel:function onCancel(){_this.dialogParams.visible=false;},table:new TableStore(),treeData:[],cType:'table'}),_this.initData=function(){_this.containerInitFinished=(0,_extends3.default)({},_this.containerInitFinished,{init:true});_this.showTable=false;_this.clearTableData();_this.getFormInfo();},_this.setTableColTitle=function(){_this.tableConfig.columns.map(function(c){if(typeof c.title=='function')c.title=c.title();});},_this.getFormInfo=function(){API.getFormInfo().then(function(data){if(data.status==='1'){if((0,_lodash.has)(data,'formField')&&data.formField.length>0){_this.fields=data.formField[0].items;_this.setFormData('searchForm',data.formField);_this.refreshForm=new Date().getTime();}}},function(error){});},_this.getSearchGroupItem=function(){var items=[];if(_this.formTarget.searchForm!=null&&_this.formTarget.searchForm.isFormInit){var formParams=_this.formTarget.searchForm.getFormParams();items.push({com:React.createElement(_ecCom.WeaFormItem,{labelCol:{span:0},wrapperCol:{span:24}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:_this.fields[0],form:_this.formTarget.searchForm,onChange:_this.onChangeTransferType})),col:2});var browserFieldDomKey=formParams.transferType+'id';var index=(0,_lodash.findIndex)(_this.fields,{domkey:[browserFieldDomKey]});if(index>=0){var field=_this.fields[index];items.push({com:React.createElement(_ecCom.WeaFormItem,{labelCol:{span:0},wrapperCol:{span:24}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:_this.formTarget.searchForm,onChange:_this.onBrowserChangeHandle})),col:2});}}return items;},_this.convertTreeData=function(datas){var pid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var newDatas=[];datas&&!(0,_lodash.isEmpty)(datas)&&datas.map(function(item,index){for(var key in datas[index]){var v=datas[index][key];try{newDatas.push({childs:_this.convertTreeData(v.submenus,String(v.categoryid)),domid:String(v.categoryid),haschild:v.hasChildren,isopen:v.isOpen,key:String(v.categoryid),name:v.name,pid:pid,canClick:true});}catch(e){}}});return newDatas;},_this.onCheckBoxChange=function(val,key){_this.otherListCondition[key]=val;var formParams=_this.formTarget.conditionForm.getFormParams();_this.doSearch((0,_extends3.default)({},formParams));},_initDefineProp(_this,'onSelectHandle',_descriptor7,_this),_this.setTreeCheckedKeys=function(ids){_this.treeProps.checkedKeys=ids;},_initDefineProp(_this,'setActiveTab',_descriptor8,_this),_initDefineProp(_this,'doSearch',_descriptor9,_this),_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(HrmResourceTotal,[{key:'getHasRight',value:function getHasRight(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getHasRight(params).then(function(data){_this2.loading=true;_this2.hasRight=data.hasRight;if(_this2.hasRight){_this2.getHrmResourceTotal();}_this2.verified=true;});}},{key:'getHrmResourceTotal',value:function getHrmResourceTotal(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};params.id=this.hrmId;API.getHrmResourceTotal(params).then(function(data){_this3.condition=data.conditions;_this3.loading=false;});}}]);return HrmResourceTotal;}(_baseStore2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'verified',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'hasRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'condition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'hrmId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'tableList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'getHasRight',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getHasRight'),_class.prototype),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'onSelectHandle',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(record,index){_this4.selectedTableItem={record:record,index:index};delete _this4.formTarget.conditionForm;delete _this4.formTarget.conditionFormFields;var params={fromid:_this4.hrmId,isFromTotal:1,isHidden:true};if(record.codeName==='Temail001'){(0,_assign2.default)(params,{folderid:0});}else if(record.codeName==='Temail002'){(0,_assign2.default)(params,{folderid:-1});}API.initModuleData(record.codeName,params).then(function(rs){try{rs.map(function(result,index){console.log("result",result);if(result.status==='1'){switch(index){case 0:if(_this4.tabConfig.tabs.length>1)_this4.tabConfig.tabs=(0,_lodash.dropRight)(_this4.tabConfig.tabs,_this4.tabConfig.tabs.length-1);_this4.tabConfig.tabs[0].groupId='1';_this4.tabConfig.tabs[0].title='';_this4.tabConfig.activeTabKey='1';_this4.tabConfig.tabSearchKey='';_this4.tabConfig.buttons=[];_this4.setFormData('conditionForm',result.condition);if(Array.isArray(result.condition)&&result.condition[0].items!=null){_this4.tabConfig.tabs[0].searchType=['base','advanced'];_this4.tabConfig.tabs[0].searchKey=result.condition[0].items[0].domkey[0];}else{_this4.tabConfig.tabs[0].searchType=['base'];_this4.tabConfig.tabs[0].searchKey='categoryname';}_this4.dialogParams=(0,_extends3.default)({},_this4.dialogParams,_this4.dialogPropsDef,{title:''+_i18n.i18n.label.select()+record.label});if((0,_lodash.has)(result,'tab')){result.tab.map(function(tab,i){if(i===0){(0,_assign2.default)(_this4.tabConfig.tabs[0],{title:tab.title,viewCondition:tab.key,groupId:tab.key});}else{var t=(0,_lodash.cloneDeep)(_this4.tabConfig.tabs[0]);(0,_assign2.default)(t,{title:tab.title,viewCondition:tab.key,groupId:tab.key});_this4.tabConfig.tabs.push(t);}});_this4.tabConfig.tabSearchKey=result.tabSearchKey;}if((0,_lodash.has)(result,'tabBtns')){var btns=[];result.tabBtns.map(function(def){btns.push(React.createElement(_ecCom.WeaCheckbox,(0,_extends3.default)({},def,{onChange:function onChange(val){return _this4.onCheckBoxChange(val,def.id);}})));});_this4.tabConfig.buttons=btns;}break;case 1:if((0,_lodash.has)(result,'sessionkey')){var tableName=record.codeName;_this4.tableList[tableName]=new TableStore();_this4.tableList[tableName].getDatas(result.sessionkey,1);_this4.dialogParams.table=_this4.tableList[tableName];_this4.dialogParams.cType='table';}else{_this4.dialogParams.cType='tree';try{_this4.dialogParams.treeData=_this4.convertTreeData(JSON.parse(result.treeDataJson));}catch(e){_this4.dialogParams.treeData=[];}}_this4.dialogParams.visible=true;break;default:break;}}});}catch(e){}},function(error){});};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'setActiveTab',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(key){_this5.tabConfig.activeTabKey=key||_this5.tabConfig.tabs[0].viewCondition;var tabIndex=_this5.getTabIndex(_this5.tabConfig.tabs,key);if(tabIndex<0)return;_this5.refreshDialog=new Date().getTime();var formParams=_this5.formTarget.conditionForm.getFormParams();_this5.doSearch((0,_extends3.default)({},formParams));};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'doSearch',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(params){params=params||{};if(_this6.tabConfig.tabSearchKey!='')(0,_assign2.default)(params,(0,_defineProperty5.default)({},_this6.tabConfig.tabSearchKey,_this6.tabConfig.activeTabKey));[].concat((0,_toConsumableArray3.default)((0,_keys2.default)(_this6.otherListCondition))).map(function(k){(0,_assign2.default)(params,(0,_defineProperty5.default)({},k,_this6.otherListCondition[k]));});API.getList(_this6.selectedTableItem.record.codeName,(0,_extends3.default)({},params,{fromid:_this6.hrmId,isFromTotal:1,isHidden:true})).then(function(data){if(data.status==='1'){// this.dialogParams.table.getDatas(data.sessionkey, 1);
if((0,_lodash.has)(data,'sessionkey')){_this6.dialogParams.table.getDatas(data.sessionkey,1);}else{try{_this6.dialogParams.treeData=_this6.convertTreeData(JSON.parse(data.treeDataJson));}catch(e){_this6.dialogParams.treeData=[];}}}},function(error){});};}})),_class);

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.initModuleData=exports.getList=exports.getCondition=exports.getTableData=exports.getFormInfo=exports.getHrmResourceTotal=exports.getHasRight=undefined;var _promise=__webpack_require__(75);var _promise2=_interopRequireDefault(_promise);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getHasRight=exports.getHasRight=function getHasRight(params){return _ecCom.WeaTools.callApi('/api/hrm/resource/total/hasRight','GET',params);};var getHrmResourceTotal=exports.getHrmResourceTotal=function getHrmResourceTotal(params){return _ecCom.WeaTools.callApi('/api/hrm/resource/total/getHrmResourceTotal','GET',params);};var getFormInfo=exports.getFormInfo=function getFormInfo(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/permissionsearch/getPermissionSearchForm','GET',params);};var getTableData=exports.getTableData=function getTableData(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/permissionsearch/getPermissionSearchResult','POST',params);};var getCondition=exports.getCondition=function getCondition(urlParams,params){return _ecCom.WeaTools.callApi('/api/hrm/permissiontoadjustbrowser/condition/'+urlParams,'GET',params);};var getList=exports.getList=function getList(urlParams,params){return _ecCom.WeaTools.callApi('/api/hrm/permissiontoadjustbrowser/list/'+urlParams,'GET',params);};var initModuleData=exports.initModuleData=function initModuleData(urlParams,params){return _promise2.default.all([getCondition(urlParams),getList(urlParams,params)]);};

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(204);
__webpack_require__(93);
__webpack_require__(116);
__webpack_require__(573);
__webpack_require__(581);
__webpack_require__(582);
module.exports = __webpack_require__(20).Promise;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(61);
var global = __webpack_require__(25);
var ctx = __webpack_require__(53);
var classof = __webpack_require__(194);
var $export = __webpack_require__(31);
var isObject = __webpack_require__(36);
var aFunction = __webpack_require__(76);
var anInstance = __webpack_require__(574);
var forOf = __webpack_require__(575);
var speciesConstructor = __webpack_require__(260);
var task = __webpack_require__(261).set;
var microtask = __webpack_require__(577)();
var newPromiseCapabilityModule = __webpack_require__(197);
var perform = __webpack_require__(262);
var userAgent = __webpack_require__(578);
var promiseResolve = __webpack_require__(263);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(30)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(579)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(115)($Promise, PROMISE);
__webpack_require__(580)(PROMISE);
Wrapper = __webpack_require__(20)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(250)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(53);
var call = __webpack_require__(248);
var isArrayIter = __webpack_require__(249);
var anObject = __webpack_require__(35);
var toLength = __webpack_require__(88);
var getIterFn = __webpack_require__(193);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 576 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(25);
var macrotask = __webpack_require__(261).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(60)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(25);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(47);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(25);
var core = __webpack_require__(20);
var dP = __webpack_require__(39);
var DESCRIPTORS = __webpack_require__(37);
var SPECIES = __webpack_require__(30)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(31);
var core = __webpack_require__(20);
var global = __webpack_require__(25);
var speciesConstructor = __webpack_require__(260);
var promiseResolve = __webpack_require__(263);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(31);
var newPromiseCapability = __webpack_require__(197);
var perform = __webpack_require__(262);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.exportExcel=exports.checkAuthAndDetach=exports.detachable=exports.authorized=undefined;var _promise=__webpack_require__(75);var _promise2=_interopRequireDefault(_promise);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 获取权限
 * @param  {[type]} moduleName [模块名]
 * @param  {Object} params     [description]
 * @return {[type]}            [description]
 */var authorized=exports.authorized=function authorized(moduleName){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var apiMethod=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'getHasRight';return _ecCom.WeaTools.callApi('/api/hrm/'+moduleName+'/'+apiMethod,'POST',params);};/**
 * 应用分权
 */var detachable=exports.detachable=function detachable(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/common/getDetachable','GET',params);};var checkAuthAndDetach=exports.checkAuthAndDetach=function checkAuthAndDetach(moduleName){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var apiMethod=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'getHasRight';return _promise2.default.all([authorized(moduleName,params={},apiMethod||'getHasRight'),detachable()]);};var exportExcel=exports.exportExcel=function exportExcel(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/ec/dev/table/export','POST',params);};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmShift=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9;var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _shift=__webpack_require__(586);var API=_interopRequireWildcard(_shift);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmShift=exports.HrmShift=(_class=function(){function HrmShift(){(0,_classCallCheck3.default)(this,HrmShift);this.title=function(){return getLabel('125798',"我的排班");};this.newChecking=function(){return getLabel('385037',"新建考勤流程");};this.leftTitle=function(){return getLabel('32997',"人员组织");};this.dateTabDatas=[{title:'年',key:"1"},{title:'月',key:"2"}];this.hrmId=undefined;_initDefineProp(this,'yearData',_descriptor,this);_initDefineProp(this,'calendarData',_descriptor2,this);_initDefineProp(this,'hrmName',_descriptor3,this);_initDefineProp(this,'loading',_descriptor4,this);_initDefineProp(this,'dateTabkey',_descriptor5,this);_initDefineProp(this,'userRoot',_descriptor6,this);_initDefineProp(this,'pDate',_descriptor7,this);_initDefineProp(this,'hasRight',_descriptor8,this);_initDefineProp(this,'canSearch',_descriptor9,this);}(0,_createClass3.default)(HrmShift,[{key:'changeDateTabHandler',value:function changeDateTabHandler(key){if(this.pDate){if(key=='1'){this.pDate=new _moment2.default().format('YYYY');}else{this.pDate=new _moment2.default().format('YYYY-MM');}}this.dateTabkey=key;}},{key:'updateDateTabkey',value:function updateDateTabkey(key){this.dateTabkey=key;}},{key:'changeDateHandler',value:function changeDateHandler(v){this.pDate=v;}},{key:'init',value:function init(){this.dateTabkey='2';this.pDate=new _moment2.default().format('YYYY-MM');this.hrmId=undefined;this.hrmName=_ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;this.userRoot=undefined;}},{key:'updateUserRoot',value:function updateUserRoot(data){this.userRoot=data;}},{key:'updateHrmId',value:function updateHrmId(v){this.hrmId=v;}},{key:'updateHrmName',value:function updateHrmName(v){this.hrmName=v||_ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;}},{key:'getData',value:function getData(cb){var _this=this;var params={};if(this.hrmId)params.resourceId=this.hrmId;if(this.pDate)params.typevalue=this.pDate;params.loaddata="1";params.type=this.dateTabkey;this.loading=true;API.getKQCarendarReport(params).then(function(datas){if(datas.status=='1'){if(_this.dateTabkey=='1'){_this.yearData=datas.result;}else{_this.calendarData=datas.result;}_this.hasRight=true;}else{_this.hasRight=false;}_this.loading=false;});}}]);return HrmShift;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'yearData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'calendarData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'hrmName',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'dateTabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'2';}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'userRoot',[_mobx.observable],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'pDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _moment2.default().format('YYYY-MM');}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'hasRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'canSearch',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'changeDateTabHandler',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'changeDateTabHandler'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateDateTabkey',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateDateTabkey'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeDateHandler',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'changeDateHandler'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateUserRoot',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateUserRoot'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateHrmId',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateHrmId'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateHrmName',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateHrmName'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getData'),_class.prototype)),_class);

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getKQCarendarReport=undefined;var _ecCom=__webpack_require__(0);var getKQCarendarReport=exports.getKQCarendarReport=function getKQCarendarReport(params){return _ecCom.WeaTools.callApi('/api/hrm/kq/schedule/getHrmScheduleReportInfo','POST',params);};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmOutside=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17;var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _outside=__webpack_require__(588);var API=_interopRequireWildcard(_outside);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _comsMobx=__webpack_require__(10);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var TableStore=_comsMobx.WeaTableNew.TableStore;var HrmOutside=exports.HrmOutside=(_class=function(){function HrmOutside(){(0,_classCallCheck3.default)(this,HrmOutside);this.title=function(){return getLabel('82634',"外勤签到");};this.hrmId=undefined;this.leftTitle=function(){return getLabel('32997',"人员组织");};this.tabDatas=function(){return[{title:getLabel('387101',"时间视图"),key:"1"},{title:getLabel('387102',"地图视图"),key:"2"},{title:getLabel('387103',"明细"),key:"3"}];};this.dateTabDatas=function(){return[{title:_i18n.i18n.label.today(),key:"1"},{title:_i18n.i18n.label.yesterday(),key:"2"},{title:_i18n.i18n.label.tsmth(),key:"3"}];};this.dateTabDatas1=function(){return[{title:_i18n.i18n.label.today(),key:"1"},{title:_i18n.i18n.label.yesterday(),key:"2"}];};this.signTitle=function(){return getLabel('386501',"同时显示移动端考勤记录");};_initDefineProp(this,'showSignInfo',_descriptor,this);_initDefineProp(this,'pDate',_descriptor2,this);_initDefineProp(this,'dateTabkey',_descriptor3,this);_initDefineProp(this,'hrmName',_descriptor4,this);_initDefineProp(this,'loading',_descriptor5,this);_initDefineProp(this,'userRoot',_descriptor6,this);_initDefineProp(this,'hasRight',_descriptor7,this);_initDefineProp(this,'tabkey',_descriptor8,this);_initDefineProp(this,'visible',_descriptor9,this);_initDefineProp(this,'positionObj',_descriptor10,this);_initDefineProp(this,'mapData',_descriptor11,this);_initDefineProp(this,'timeData',_descriptor12,this);_initDefineProp(this,'table',_descriptor13,this);_initDefineProp(this,'dataKey',_descriptor14,this);_initDefineProp(this,'orgTreeIsMult',_descriptor15,this);_initDefineProp(this,'orgTreeCheckedDatas',_descriptor16,this);_initDefineProp(this,'radioGroupParams',_descriptor17,this);this.config=function(){return[{label:_i18n.i18n.label.date(),options:[{key:'0',showname:_i18n.i18n.label.all()},{key:'1',showname:_i18n.i18n.label.today(),selected:true},{key:'2',showname:_i18n.i18n.label.tswk()},{key:'3',showname:_i18n.i18n.label.tsmth()},{key:'4',showname:_i18n.i18n.label.tssn()},{key:'5',showname:_i18n.i18n.label.tsyr()},{key:'7',showname:_i18n.i18n.label.preMonth()},{key:'8',showname:_i18n.i18n.label.preYear()},{key:'6',showname:_i18n.i18n.label.dateRange()}],domkey:['typeselect'],selectLinkageDatas:{'6':{conditionType:'RANGEPICKER',domkey:['fromDate','toDate']}}},{label:_i18n.i18n.label.kqType(),options:[{key:'0',showname:_i18n.i18n.label.all()},{key:'2',showname:getLabel('82634',"外勤签到"),selected:true},{key:'1',showname:getLabel('386502',"移动端考勤")}],domkey:['signtype']}];};this.handleViewClick=function(id){API.getShowSignImg({id:id}).then(function(datas){var signImgIds=datas.signImgIds;if(signImgIds){var imgPool=signImgIds.split(',').map(function(id){return'/weaver/weaver.file.FileDownload?fileid='+id;});var indexNum=0;if(window.IMCarousel){window.IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,window.top);}else{loadjs(["/social/js/drageasy/drageasy.js","/social/js/bootstrap/js/bootstrap.js?v=20171218","/social/im/js/IMUtil_wev8.js","/social/js/imcarousel/imcarousel.js"],function(){window.IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,window.top);});}}});};}(0,_createClass3.default)(HrmOutside,[{key:'init',value:function init(){this.hrmId=undefined;this.showSignInfo='0';this.tabkey='1';this.dateTabkey='1';this.visible=false;this.pDate=new _moment2.default().format('YYYY-MM-DD');this.hrmName=_ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;this.userRoot=undefined;this.orgTreeIsMult='0';this.orgTreeCheckedDatas=[];}},{key:'updateOrgTreeIsMult',value:function updateOrgTreeIsMult(v){this.orgTreeIsMult=v;}},{key:'updateOrgTreeCheckedDatas',value:function updateOrgTreeCheckedDatas(){var v=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];this.orgTreeCheckedDatas=v;}},{key:'updatePosition',value:function updatePosition(obj){this.positionObj=obj;}},{key:'updateVisible',value:function updateVisible(v){this.visible=v;}},{key:'handlerCheckbox',value:function handlerCheckbox(v){this.showSignInfo=v;this.getData();}},{key:'changeTab',value:function changeTab(key){this.tabkey=key;this.dateTabkey='1';this.pDate=new _moment2.default().format('YYYY-MM-DD');this.showSignInfo='0';}},{key:'changeDate',value:function changeDate(v1,v2){this.pDate=v2;}},{key:'changeDateTab',value:function changeDateTab(key){this.dateTabkey=key;var current=new _moment2.default();if(key==1){this.pDate=current.format('YYYY-MM-DD');}else if(key==2){this.pDate=current.subtract(1,'days').format('YYYY-MM-DD');}else{this.pDate=current.format('YYYY-MM');}}},{key:'updateUserRoot',value:function updateUserRoot(data){this.userRoot=data;}},{key:'updateHrmId',value:function updateHrmId(v){this.hrmId=v;}},{key:'updateHrmName',value:function updateHrmName(v){this.hrmName=v||_ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;}},{key:'exportExcel',value:function exportExcel(dataKey){//this.table.exportAll('',this.title);
this.table.exportAll();}},{key:'getData',value:function getData(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(this.hrmId)params.resourceId=this.hrmId;params.loaddata="1";this.loading=true;if(this.tabkey=='3'){params=(0,_extends3.default)({},params,this.radioGroupParams);if(!params.typeselect||params.typeselect=='')params.typeselect=1;if(!params.signtype||params.signtype=='')params.signtype=2;params.cmd='detialData';}else{params.fromDate=this.pDate;params.toDate=this.pDate;params.signtype=this.showSignInfo;if(this.tabkey=='1'){params.cmd='timeData';}else if(this.tabkey=='2'){params.cmd='mapData';}}API.getHrmMobileSignInInfo(params).then(function(datas){if(datas.status=='1'){_this.hasRight=true;if(_this.tabkey=='1'){_this.timeData=datas.result||[];}else if(_this.tabkey=='2'){_this.mapData=datas.result||[];}else if(_this.tabkey=='3'){_this.table.getDatas(datas.sessionkey,1);_this.dataKey=datas.sessionkey;}}else{_this.hasRight=false;}_this.loading=false;});}}]);return HrmOutside;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'showSignInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'pDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _moment2.default().format('YYYY-MM-DD');}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'dateTabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'hrmName',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _ecCom.WeaTools.ls.getJSONObj('theme-account')&&_ecCom.WeaTools.ls.getJSONObj('theme-account').username||undefined;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'userRoot',[_mobx.observable],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'hasRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'tabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'visible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'positionObj',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'mapData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'timeData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'dataKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'orgTreeIsMult',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'orgTreeCheckedDatas',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'radioGroupParams',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateOrgTreeIsMult',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateOrgTreeIsMult'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateOrgTreeCheckedDatas',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateOrgTreeCheckedDatas'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updatePosition',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updatePosition'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateVisible',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateVisible'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'handlerCheckbox',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'handlerCheckbox'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeTab',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'changeTab'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeDate',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'changeDate'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateUserRoot',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateUserRoot'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateHrmId',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateHrmId'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateHrmName',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateHrmName'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'exportExcel',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'exportExcel'),_class.prototype)),_class);

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getShowSignImg=exports.exportExcel=exports.getHrmMobileSignInInfo=undefined;var _ecCom=__webpack_require__(0);var getHrmMobileSignInInfo=exports.getHrmMobileSignInInfo=function getHrmMobileSignInInfo(params){return _ecCom.WeaTools.callApi('/api/hrm/kq/mobilesignin/getHrmMobileSignInInfo','POST',params);};//导出excel
var exportExcel=exports.exportExcel=function exportExcel(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/ec/dev/table/export','POST',{dataKey:params});};var getShowSignImg=exports.getShowSignImg=function getShowSignImg(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/kq/mobilesignin/getShowSignImg','GET',params);};

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmOnline=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _online=__webpack_require__(590);var API=_interopRequireWildcard(_online);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var confirm=_antd.Modal.confirm;var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmOnline=exports.HrmOnline=(_class=function(){function HrmOnline(){(0,_classCallCheck3.default)(this,HrmOnline);this.title=function(){return getLabel('20536',"在线人员");};_initDefineProp(this,'form',_descriptor,this);_initDefineProp(this,'table',_descriptor2,this);_initDefineProp(this,'condition',_descriptor3,this);_initDefineProp(this,'showSearchAd',_descriptor4,this);_initDefineProp(this,'searchParamsAd',_descriptor5,this);_initDefineProp(this,'dataKey',_descriptor6,this);}(0,_createClass3.default)(HrmOnline,[{key:'getData',value:function getData(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.getSearchCondition();this.getSearchList();}},{key:'getSearchCondition',value:function getSearchCondition(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getSearchCondition(params).then(function(data){_this.condition=data.condition;_this.form.initFormFields(data.condition);});}},{key:'doSearch',value:function doSearch(){var formParams=this.form.getFormParams();formParams.search="search";this.getSearchList(formParams);}},{key:'getSearchList',value:function getSearchList(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getSearchList(params).then(function(data){_this2.dataKey=data.sessionkey;_this2.table.getDatas(data.sessionkey,1);});}//强制下线
},{key:'forcedOffline',value:function forcedOffline(id){var __this=this;confirm({title:_i18n.i18n.confirm.systemhints(),content:getLabel('81904',"确定要将该用户强制下线吗？"),onOk:function onOk(){jQuery.ajax({url:"/js/hrm/getdata.jsp?cmd=userOffline&uid="+id,type:"post",async:false,complete:function complete(xhr,status){__this.update();}});},onCancel:function onCancel(){}});}},{key:'update',value:function update(){this.table.getDatas(this.dataKey,1);//刷新table
}},{key:'setShowSearchAd',value:function setShowSearchAd(bool){this.showSearchAd=bool;}},{key:'getFormParams',value:function getFormParams(){return this.form.getFormParams();}}]);return HrmOnline;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'condition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'showSearchAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'searchParamsAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'dataKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getData'),_class.prototype)),_class);

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getSearchList=exports.getSearchCondition=undefined;var _ecCom=__webpack_require__(0);var getSearchCondition=exports.getSearchCondition=function getSearchCondition(){return _ecCom.WeaTools.callApi('/api/hrm/online/getSearchCondition','GET');};var getSearchList=exports.getSearchList=function getSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/online/getSearchResult','POST',params);};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmUnderling=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _underling=__webpack_require__(592);var API=_interopRequireWildcard(_underling);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var HrmUnderling=exports.HrmUnderling=(_class=function(){function HrmUnderling(){(0,_classCallCheck3.default)(this,HrmUnderling);_initDefineProp(this,'title',_descriptor,this);_initDefineProp(this,'id',_descriptor2,this);_initDefineProp(this,'lastname',_descriptor3,this);_initDefineProp(this,'table',_descriptor4,this);_initDefineProp(this,'showAllLevel',_descriptor5,this);}(0,_createClass3.default)(HrmUnderling,[{key:'getSearchList',value:function getSearchList(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};params.id=this.id;params.lastname=this.lastname;params.showAllLevel=this.showAllLevel;API.getSearchList(params).then(function(data){_this.table.getDatas(data.sessionkey,1);_this.title=data.lastname+_i18n.i18n.label.subordinated();});}},{key:'changeShowAllLevel',value:function changeShowAllLevel(){this.showAllLevel=!this.showAllLevel;this.getSearchList();}}]);return HrmUnderling;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'title',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'id',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'lastname',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'showAllLevel',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'getSearchList',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getSearchList'),_class.prototype)),_class);

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveQuickMenu=exports.getQuickMenu=exports.getSearchList=undefined;var _ecCom=__webpack_require__(0);var getSearchList=exports.getSearchList=function getSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/subordinateinfo/getSearchResult','POST',params);};var getQuickMenu=exports.getQuickMenu=function getQuickMenu(){return _ecCom.WeaTools.callApi('/api/hrm/subordinateinfo/getQuickMenu','GET');};var saveQuickMenu=exports.saveQuickMenu=function saveQuickMenu(params){return _ecCom.WeaTools.callApi('/api/hrm/subordinateinfo/saveQuickMenu','POST',params);};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmTrainRecord=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _trainrecord=__webpack_require__(594);var API=_interopRequireWildcard(_trainrecord);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var HrmTrainRecord=exports.HrmTrainRecord=(_class=function(){function HrmTrainRecord(){(0,_classCallCheck3.default)(this,HrmTrainRecord);this.title=_i18n.i18n.module.trainRecord;this.tabDatas=[{title:'培训记录',key:"1"},{title:'培训安排',key:"2"}];_initDefineProp(this,'form',_descriptor,this);_initDefineProp(this,'table',_descriptor2,this);_initDefineProp(this,'condition',_descriptor3,this);_initDefineProp(this,'showSearchAd',_descriptor4,this);_initDefineProp(this,'searchParamsAd',_descriptor5,this);_initDefineProp(this,'tabkey',_descriptor6,this);}(0,_createClass3.default)(HrmTrainRecord,[{key:'getData',value:function getData(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.getSearchCondition();this.getSearchList();}},{key:'getSearchCondition',value:function getSearchCondition(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(this.tabkey)params.tabkey=this.tabkey;API.getSearchCondition(params).then(function(data){_this.condition=data.condition;_this.form.initFormFields(data.condition);});}},{key:'doSearch',value:function doSearch(){var formParams=this.form.getFormParams();formParams.search="search";this.getSearchList(formParams);}},{key:'getSearchList',value:function getSearchList(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(this.tabkey)params.tabkey=this.tabkey;API.getSearchList(params).then(function(data){_this2.table.getDatas(data.sessionkey,1);});}},{key:'changeTab',value:function changeTab(key){this.tabkey=key;this.form=new _comsMobx.WeaForm();this.setShowSearchAd(false);this.getData();}},{key:'setShowSearchAd',value:function setShowSearchAd(bool){this.showSearchAd=bool;}},{key:'getFormParams',value:function getFormParams(){return this.form.getFormParams();}}]);return HrmTrainRecord;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'condition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'showSearchAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'searchParamsAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'tabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getData'),_class.prototype)),_class);

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getSearchList=exports.getSearchCondition=undefined;var _ecCom=__webpack_require__(0);var getSearchCondition=exports.getSearchCondition=function getSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/trainrecord/getSearchCondition','GET',params);};var getSearchList=exports.getSearchList=function getSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/trainrecord/getSearchResult','POST',params);};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmRewardsRecord=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _rewardsrecord=__webpack_require__(596);var API=_interopRequireWildcard(_rewardsrecord);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmRewardsRecord=exports.HrmRewardsRecord=(_class=function(){function HrmRewardsRecord(){(0,_classCallCheck3.default)(this,HrmRewardsRecord);this.title=function(){return getLabel('16065',"奖惩考核");};this.tabDatas=function(){return[{title:getLabel('32740',"我的成绩"),key:"1"},{title:getLabel('15682',"奖惩情况"),key:"2"}];};_initDefineProp(this,'form',_descriptor,this);_initDefineProp(this,'table',_descriptor2,this);_initDefineProp(this,'tabkey',_descriptor3,this);_initDefineProp(this,'tableinfo',_descriptor4,this);_initDefineProp(this,'isshowrecord',_descriptor5,this);}(0,_createClass3.default)(HrmRewardsRecord,[{key:'getData',value:function getData(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.getSearchList();}},{key:'doSearch',value:function doSearch(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};params.search="search";this.getSearchList(params);}},{key:'getSearchList',value:function getSearchList(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(this.tabkey)params.tabkey=this.tabkey;if(this.tabkey=='1'){API.getRewardsRecord1Tables(params).then(function(data){_this.tableinfo=data.tables;_this.isshowrecord=data.isShowRecord;});}API.getSearchList(params).then(function(data){_this.table.getDatas(data.sessionkey);});}},{key:'changeTab',value:function changeTab(key){this.tabkey=key;this.form=new _comsMobx.WeaForm();this.getData();}},{key:'getFormParams',value:function getFormParams(){return this.form.getFormParams();}}]);return HrmRewardsRecord;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'tabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'tableinfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'isshowrecord',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getData'),_class.prototype)),_class);

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getSearchList=exports.getRewardsRecord1Tables=undefined;var _ecCom=__webpack_require__(0);var getRewardsRecord1Tables=exports.getRewardsRecord1Tables=function getRewardsRecord1Tables(params){return _ecCom.WeaTools.callApi('/api/hrm/rewardsrecord/getTrainRewardsRecord1Tables','GET',params);};var getSearchList=exports.getSearchList=function getSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/rewardsrecord/getSearchResult','POST',params);};

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmFinance=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _finance=__webpack_require__(598);var API=_interopRequireWildcard(_finance);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _antd=__webpack_require__(6);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _i18n=__webpack_require__(11);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmFinance=exports.HrmFinance=(_class=function(){function HrmFinance(){(0,_classCallCheck3.default)(this,HrmFinance);this.title=function(){return getLabel('16416',"我的工资");};_initDefineProp(this,'tabDatas',_descriptor,this);_initDefineProp(this,'isEditor',_descriptor2,this);_initDefineProp(this,'form',_descriptor3,this);_initDefineProp(this,'buttons',_descriptor4,this);_initDefineProp(this,'formFields',_descriptor5,this);_initDefineProp(this,'table',_descriptor6,this);_initDefineProp(this,'tabkey',_descriptor7,this);_initDefineProp(this,'hrmId',_descriptor8,this);}(0,_createClass3.default)(HrmFinance,[{key:'getTabInfo',value:function getTabInfo(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _this=this;params.id=this.hrmId;API.getTabInfo(params).then(function(data){_this2.tabDatas=data.tabs;if(!(0,_isEmpty2.default)(data.tabs)){_this2.tabkey=data.tabs[0].key;}_this.getData(params);});}},{key:'getData',value:function getData(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getFormField(params).then(function(data){_this3.formFields=data.fieldgroup;_this3.buttons=data.buttons;_this3.hrmId=data.hrmId;_this3.form.initFormFields(_this3.formFields);});API.getSearchList({id:this.hrmId,tabkey:this.tabkey}).then(function(data){_this3.table=data.table;});}},{key:'edit',value:function edit(){this.formFields&&this.formFields.forEach(function(c){c.items.forEach(function(field){field.viewAttr=2;if(field.conditionType=='BROWSER'){field.browserConditionParam.viewAttr=2;}});});this.isEditor=true;this.tabkey='1';}},{key:'save',value:function save(){var _this4=this;var formParams=this.form.getFormParams();API.saveFormFields((0,_extends3.default)({id:this.hrmId},formParams)).then(function(data){if(data.status=='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this4.init();_this4.getData({id:_this4.hrmId});}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'init',value:function init(){this.tabkey='1';this.isEditor=false;this.form=new _comsMobx.WeaForm();}},{key:'changeTab',value:function changeTab(key){this.tabkey=key;this.getData();}},{key:'getFormParams',value:function getFormParams(){return this.form.getFormParams();}}]);return HrmFinance;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'tabDatas',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isEditor',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'buttons',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'formFields',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'tabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'hrmId',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'getTabInfo',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getTabInfo'),_class.prototype)),_class);

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveFormFields=exports.getSearchList=exports.getFormField=exports.getTabInfo=undefined;var _ecCom=__webpack_require__(0);var getTabInfo=exports.getTabInfo=function getTabInfo(params){return _ecCom.WeaTools.callApi('/api/hrm/finance/getTabInfo','GET',params);};var getFormField=exports.getFormField=function getFormField(params){return _ecCom.WeaTools.callApi('/api/hrm/finance/getHrmFinanceFields','GET',params);};var getSearchList=exports.getSearchList=function getSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/finance/getHrmResourceSalaryLog','GET',params);};var saveFormFields=exports.saveFormFields=function saveFormFields(params){return _ecCom.WeaTools.callApi('/api/hrm/finance/save','POST',params);};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmRoleSet=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _roleset=__webpack_require__(600);var API=_interopRequireWildcard(_roleset);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var confirm=_antd.Modal.confirm;var TableStore=_comsMobx.WeaTableNew.TableStore;var HrmRoleSet=exports.HrmRoleSet=(_class=function(){function HrmRoleSet(){(0,_classCallCheck3.default)(this,HrmRoleSet);_initDefineProp(this,'verified',_descriptor,this);_initDefineProp(this,'hasRight',_descriptor2,this);_initDefineProp(this,'dialogShow',_descriptor3,this);_initDefineProp(this,'isEditor',_descriptor4,this);_initDefineProp(this,'table',_descriptor5,this);_initDefineProp(this,'form',_descriptor6,this);_initDefineProp(this,'formFields',_descriptor7,this);_initDefineProp(this,'dataKey',_descriptor8,this);}(0,_createClass3.default)(HrmRoleSet,[{key:'getData',value:function getData(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.getFormField();this.getSearchList(params);}},{key:'getFormField',value:function getFormField(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getFormField(params).then(function(data){_this2.formFields=data.condition;_this2.hasRight=data.hasRight;_this2.verified=true;_this2.form.initFormFields(_this2.formFields);});}},{key:'getSearchList',value:function getSearchList(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getSearchList(params).then(function(data){_this3.dataKey=data.sessionkey;_this3.table.getDatas(_this3.dataKey,1);});}},{key:'save',value:function save(hrmId){var _this4=this;var formParams=this.form.getFormParams();var rolesid=formParams.rolesid||'';if(rolesid==''){_antd.message.warning(_i18n.i18n.message.requireFieldNone());return false;}API.saveFormFields((0,_extends3.default)({id:hrmId},formParams)).then(function(data){if(data.status=='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this4.init();_this4.update();}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'onCancel',value:function onCancel(){this.dialogShow=false;this.form=new _comsMobx.WeaForm();}},{key:'update',value:function update(){this.table.getDatas(this.dataKey,1);//刷新table
}},{key:'edit',value:function edit(id){this.dialogShow=true;this.isEditor=true;this.getFormField({id:id});}},{key:'add',value:function add(){this.dialogShow=true;this.isEditor=false;this.getFormField();}},{key:'delBatch',value:function delBatch(ids){if(ids==''){_antd.message.warning(_i18n.i18n.message.pleaseSelectDelRecord());return false;}var _this=this;confirm({title:_i18n.i18n.confirm.systemhints(),content:_i18n.i18n.confirm.batchDeleteConfirm(),onOk:function onOk(){var idArr=ids.split(",");var ajaxNum=0;for(var i=0;i<idArr.length;i++){ajaxNum++;_ecCom.WeaTools.callApi('/api/hrm/roleset/delete','POST',{id:idArr[i]}).then(function(data){if(data.status=='1'){ajaxNum--;if(ajaxNum==0){_antd.message.success(_i18n.i18n.message.deleteSuccess());_this.update();}}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},onCancel:function onCancel(){}});}},{key:'del',value:function del(id){var _this=this;confirm({title:_i18n.i18n.confirm.systemhints(),content:_i18n.i18n.confirm.delete(),onOk:function onOk(){var _this5=this;_ecCom.WeaTools.callApi('/api/hrm/roleset/delete','POST',{id:id}).then(function(data){if(data.status=='1'){_antd.message.success(_i18n.i18n.message.deleteSuccess());_this5.update();}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});},onCancel:function onCancel(){}});}},{key:'init',value:function init(){this.isEditor=false;this.dialogShow=false;this.form=new _comsMobx.WeaForm();}},{key:'getFormParams',value:function getFormParams(){return this.form.getFormParams();}}]);return HrmRoleSet;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'verified',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'hasRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'dialogShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'isEditor',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'formFields',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'dataKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getData'),_class.prototype)),_class);

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveFormFields=exports.getSearchList=exports.getFormField=undefined;var _ecCom=__webpack_require__(0);var getFormField=exports.getFormField=function getFormField(params){return _ecCom.WeaTools.callApi('/api/hrm/roleset/getHrmRoleSetForm','GET',params);};var getSearchList=exports.getSearchList=function getSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/roleset/getSearchResult','POST',params);};var saveFormFields=exports.saveFormFields=function saveFormFields(params){return _ecCom.WeaTools.callApi('/api/hrm/roleset/save','POST',params);};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmCard=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15;var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _card=__webpack_require__(130);var API=_interopRequireWildcard(_card);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var HrmCard=exports.HrmCard=(_class=function(){function HrmCard(){var _this=this;(0,_classCallCheck3.default)(this,HrmCard);_initDefineProp(this,'spinning',_descriptor,this);_initDefineProp(this,'tabInfo',_descriptor2,this);_initDefineProp(this,'tabKey',_descriptor3,this);_initDefineProp(this,'verified',_descriptor4,this);_initDefineProp(this,'isAdmin',_descriptor5,this);_initDefineProp(this,'dialogParams',_descriptor6,this);_initDefineProp(this,'portraitSettingVisible',_descriptor7,this);_initDefineProp(this,'info',_descriptor8,this);_initDefineProp(this,'uploadPortrailAuth',_descriptor9,this);_initDefineProp(this,'topButtons',_descriptor10,this);_initDefineProp(this,'topRightMenus',_descriptor11,this);_initDefineProp(this,'topShowDropIcon',_descriptor12,this);_initDefineProp(this,'setTopButtons',_descriptor13,this);_initDefineProp(this,'setTopRightMenus',_descriptor14,this);_initDefineProp(this,'setTopShowDropIcon',_descriptor15,this);this.showPortraitSetting=function(){_this.dialogParams.time=new Date().getTime();_this.dialogParams.visible=true;};this.getDialogOpButtons=function(event){var buttons=[];buttons.push(React.createElement(_antd.Button,{type:'primary',onClick:event.ok},_i18n.i18n.button.ok()));buttons.push(React.createElement(_antd.Button,{type:'default',onClick:function onClick(){event.cancel();_this.onCancel();}},_i18n.i18n.button.cancel()));return buttons;};this.onOk=function(data){if(_this.spinning)return;_this.spinning=true;API.saveUserIcon({userId:_this.userId,imageDataUrl:data}).then(function(data){_this.spinning=false;if(data.status==='1'){// this.info.messagerurl = data.messagerurl;
API.getResourceBaseTitle({id:_this.userId}).then(function(data){_this.info=data.result;});_this.onCancel();}else{message.error(data.message);}},function(error){_this.spinning=false;});};this.onCancel=function(){_this.dialogParams.onCancel();};}(0,_createClass3.default)(HrmCard,[{key:'setTopButtons',value:function setTopButtons(){}},{key:'changeTab',value:function changeTab(key){this.tabKey=key;}},{key:'init',value:function init(key){this.tabKey=key||'cardInfo';}},{key:'verifyIsAdmin',value:function verifyIsAdmin(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.isAdmin(params).then(function(data){_this2.verified=true;_this2.isAdmin=data.isAdmin;});}},{key:'getTabBaseInfo',value:function getTabBaseInfo(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};params.isMobx="1";API.getResourceBaseTitle(params).then(function(data){_this3.info=data.result;_this3.userId=data.id;API.uploadPortrailAuth({userId:_this3.userId}).then(function(data){_this3.uploadPortrailAuth=data.hasRight;});});if(window.WeaHrm4Formal){API.getHrmResourceTab4Formal(params).then(function(data){_this3.tabInfo=data;});}else{API.getHrmResourceTab(params).then(function(data){_this3.tabInfo=data;});}}},{key:'getData',value:function getData(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.userId=params.id;this.getTabBaseInfo(params);}}]);return HrmCard;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'spinning',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'tabInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'tabKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'cardInfo';}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'verified',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'isAdmin',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'dialogParams',[_mobx.observable],{enumerable:true,initializer:function initializer(){var _this4=this;return{icon:"icon-coms-hrm",iconBgcolor:"#217346",visible:false,title:_i18n.i18n.label.uploadPortrait,style:{width:414,height:300},onCancel:function onCancel(){_this4.dialogParams.visible=false;}};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'portraitSettingVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'info',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'uploadPortrailAuth',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'topButtons',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'topRightMenus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'topShowDropIcon',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'setTopButtons',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(getBtns){_this5.topButtons=getBtns;};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'setTopRightMenus',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(getMenus){_this6.topRightMenus=getMenus;};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'setTopShowDropIcon',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(bool){_this7.topShowDropIcon=bool;};}}),_applyDecoratedDescriptor(_class.prototype,'changeTab',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'changeTab'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'verifyIsAdmin',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'verifyIsAdmin'),_class.prototype)),_class);

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmPersonal=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _card=__webpack_require__(130);var API=_interopRequireWildcard(_card);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _comsMobx=__webpack_require__(10);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _antd=__webpack_require__(6);var _forEach=__webpack_require__(46);var _forEach2=_interopRequireDefault(_forEach);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var HrmPersonal=exports.HrmPersonal=(_class=function(){function HrmPersonal(){(0,_classCallCheck3.default)(this,HrmPersonal);_initDefineProp(this,'hrmId',_descriptor,this);_initDefineProp(this,'conditions',_descriptor2,this);_initDefineProp(this,'tableInfo',_descriptor3,this);_initDefineProp(this,'tabInfo',_descriptor4,this);_initDefineProp(this,'isEditor',_descriptor5,this);_initDefineProp(this,'buttons',_descriptor6,this);_initDefineProp(this,'loading',_descriptor7,this);_initDefineProp(this,'tabkey',_descriptor8,this);_initDefineProp(this,'form',_descriptor9,this);_initDefineProp(this,'date',_descriptor10,this);}(0,_createClass3.default)(HrmPersonal,[{key:'edit',value:function edit(){this.isEditor=true;this.getData();this.getTabInfo();this.tabkey='0';}},{key:'save',value:function save(){var _this=this;var pDatas=this.form.getFormParams();var flag=false;this.form.validateForm().then(function(f){if(f.isValid){if(_this.personalEditTables){if(_this.personalEditTables.refs.edit.doRequiredCheck().pass){_this.tableInfo&&_this.tableInfo.forEach(function(t){t.tabinfo.datas=t.tabinfo.datas||[];pDatas[t.tabinfo.rownum]=t.tabinfo.datas.length;t.tabinfo&&t.tabinfo.datas&&t.tabinfo.datas.forEach(function(item,index){!(0,_isEmpty2.default)(item)&&(0,_forEach2.default)(item,function(value,key){pDatas[key+'_'+index]=value;});});});API.editResource((0,_extends3.default)({operation:'editpersonalinfo',id:_this.hrmId},pDatas)).then(function(data){if(data.status=='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this.init();_this.getData();}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}}else{API.editResource((0,_extends3.default)({operation:'editpersonalinfo',id:_this.hrmId},pDatas)).then(function(data){if(data.status=='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this.init();_this.getData();}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}}else{f.showErrors();_this.setDate(new Date());}});}},{key:'changeTab',value:function changeTab(key){this.tabkey=key;}},{key:'init',value:function init(){this.tabkey='0';this.isEditor=false;this.form=new _comsMobx.WeaForm();}},{key:'updateTableInfo',value:function updateTableInfo(data){this.tableInfo=data;}},{key:'updateTabkey',value:function updateTabkey(key){this.tabkey=key;}},{key:'getTabInfo',value:function getTabInfo(){var _this2=this;this.tabInfo=[];this.tableInfo&&this.tableInfo.forEach(function(c,idx){if(!c.hide){_this2.tabInfo.push({key:''+idx,title:c.tabname});}});if(!(0,_isEmpty2.default)(this.tabInfo))this.tabkey=this.tabInfo[0].key;}},{key:'getData',value:function getData(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.loading=true;params.id=this.hrmId;params.viewAttr=this.isEditor?2:1;params.is_multilang_set=this.isEditor;params.operation='getResourcePesonalView';API.getResourceCard(params).then(function(data){_this3.loading=false;_this3.form.initFormFields(data.result.conditions);_this3.conditions=data.result.conditions;_this3.tableInfo=data.result.tables;_this3.getTabInfo();_this3.buttons=data.result.buttons;_this3.hrmId=data.result.id;});}},{key:'setPersonalEditTables',value:function setPersonalEditTables(ref){this.personalEditTables=ref;}},{key:'setDate',value:function setDate(date){this.date=date;}}]);return HrmPersonal;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'hrmId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'conditions',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'tableInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'tabInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'isEditor',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'buttons',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'tabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'edit',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'edit'),_class.prototype)),_class);

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmWork=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _card=__webpack_require__(130);var API=_interopRequireWildcard(_card);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _comsMobx=__webpack_require__(10);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _antd=__webpack_require__(6);var _forEach=__webpack_require__(46);var _forEach2=_interopRequireDefault(_forEach);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var HrmWork=exports.HrmWork=(_class=function(){function HrmWork(){var _this=this;(0,_classCallCheck3.default)(this,HrmWork);_initDefineProp(this,'hrmId',_descriptor,this);_initDefineProp(this,'conditions',_descriptor2,this);_initDefineProp(this,'tableInfo',_descriptor3,this);_initDefineProp(this,'tabInfo',_descriptor4,this);_initDefineProp(this,'isEditor',_descriptor5,this);_initDefineProp(this,'buttons',_descriptor6,this);_initDefineProp(this,'loading',_descriptor7,this);_initDefineProp(this,'tabkey',_descriptor8,this);_initDefineProp(this,'form',_descriptor9,this);_initDefineProp(this,'date',_descriptor10,this);this.getToday=function(){var now=new Date();//当前日期
var nowYear=now.getFullYear();//当前年
var nowMonth=now.getMonth();//当前月
var nowDay=now.getDate();//当前日
var today=_this.formatDate(new Date(nowYear,nowMonth,nowDay));//今天
return today;};}(0,_createClass3.default)(HrmWork,[{key:'edit',value:function edit(){this.isEditor=true;this.getData();this.getTabInfo();this.tabkey='0';}},{key:'save',value:function save(){var _this2=this;var pDatas=this.form.getFormParams();var flag=false;this.form.validateForm().then(function(f){if(f.isValid){if(_this2.workEditTables){if(_this2.workEditTables.refs.edit.doRequiredCheck().pass){_this2.tableInfo&&_this2.tableInfo.forEach(function(t){t.tabinfo.datas=t.tabinfo.datas||[];pDatas[t.tabinfo.rownum]=t.tabinfo.datas.length;t.tabinfo&&t.tabinfo.datas&&t.tabinfo.datas.forEach(function(item,index){!(0,_isEmpty2.default)(item)&&(0,_forEach2.default)(item,function(value,key){pDatas[key+'_'+index]=value;});});});API.editResource((0,_extends3.default)({operation:'editworkinfo',id:_this2.hrmId},pDatas)).then(function(data){if(data.status=='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this2.init();_this2.getData();}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}}else{API.editResource((0,_extends3.default)({operation:'editworkinfo',id:_this2.hrmId},pDatas)).then(function(data){if(data.status=='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this2.init();_this2.getData();}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}}else{f.showErrors();_this2.setDate(new Date());}});}},{key:'changeTab',value:function changeTab(key){this.tabkey=key;}},{key:'init',value:function init(){this.tabkey='0';this.isEditor=false;this.form=new _comsMobx.WeaForm();}},{key:'updateTableInfo',value:function updateTableInfo(data){this.tableInfo=data;}},{key:'updateTabkey',value:function updateTabkey(key){this.tabkey=key;}},{key:'calYear',value:function calYear(startdate){var value=0.00;if(startdate){var beginTime=new Date(startdate).getTime();var endTime=new Date(this.getToday()).getTime();if(endTime>beginTime){value=((endTime-beginTime)/(24*3600*1000*365.0)).toFixed(2);}}return value;}},{key:'formatDate',value:function formatDate(date){var yy=date.getFullYear();var mm=date.getMonth()+1;var dd=date.getDate();return yy+"-"+this.adjust(mm)+"-"+this.adjust(dd);}},{key:'adjust',value:function adjust(num){if(num<10){return"0"+num;}else{return""+num;}}},{key:'getTabInfo',value:function getTabInfo(){var _this3=this;this.tabInfo=[];this.tableInfo&&this.tableInfo.forEach(function(c,idx){if(!c.hide){_this3.tabInfo.push({key:''+idx,title:c.tabname});}});if(!(0,_isEmpty2.default)(this.tabInfo))this.tabkey=this.tabInfo[0].key;}},{key:'getData',value:function getData(){var _this4=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.loading=true;params.id=this.hrmId;params.viewAttr=this.isEditor?2:1;params.is_multilang_set=this.isEditor;params.operation='getResourceWorkView';API.getResourceCard(params).then(function(data){_this4.loading=false;_this4.form.initFormFields(data.result.conditions);_this4.conditions=data.result.conditions;_this4.tableInfo=data.result.tables;_this4.getTabInfo(_this4.tabInfo);_this4.buttons=data.result.buttons;_this4.hrmId=data.result.id;});}},{key:'setWorkEditTables',value:function setWorkEditTables(ref){this.workEditTables=ref;}},{key:'setDate',value:function setDate(date){this.date=date;}}]);return HrmWork;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'hrmId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'conditions',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'tableInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'tabInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'isEditor',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'buttons',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'tabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'edit',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'edit'),_class.prototype)),_class);

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmPassword=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12;var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _password=__webpack_require__(605);var Api=_interopRequireWildcard(_password);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmPassword=exports.HrmPassword=(_class=function(){function HrmPassword(){(0,_classCallCheck3.default)(this,HrmPassword);_initDefineProp(this,'tabKey',_descriptor,this);_initDefineProp(this,'isPwdVerifyDialogShow',_descriptor2,this);_initDefineProp(this,'isPwdSecuritySettingShow',_descriptor3,this);_initDefineProp(this,'current',_descriptor4,this);_initDefineProp(this,'columns',_descriptor5,this);_initDefineProp(this,'datasource',_descriptor6,this);_initDefineProp(this,'answerArray',_descriptor7,this);_initDefineProp(this,'isSetted',_descriptor8,this);_initDefineProp(this,'secStatus',_descriptor9,this);_initDefineProp(this,'isModifyBtnClick',_descriptor10,this);_initDefineProp(this,'pwdCopy',_descriptor11,this);_initDefineProp(this,'hrmId',_descriptor12,this);}(0,_createClass3.default)(HrmPassword,[{key:'doOpen',value:function doOpen(arg){if(arg=='1')this.isPwdVerifyDialogShow=true;if(arg=='2')this.isPwdSecuritySettingShow=true;}},{key:'doClose',value:function doClose(arg){if(arg=='1')this.isPwdVerifyDialogShow=false;if(arg=='2')this.isPwdSecuritySettingShow=false;}},{key:'plus',value:function plus(){this.current=this.current+1;}},{key:'minus',value:function minus(){this.current=this.current-1;}},{key:'reset',value:function reset(){this.current=0;}},{key:'setPwdCopy',value:function setPwdCopy(pwd){this.pwdCopy=pwd;}},{key:'setModifyBtnStatus',value:function setModifyBtnStatus(bool){this.isModifyBtnClick=bool;}},{key:'getTableEditInfo',value:function getTableEditInfo(){var _this=this;var params={};Api.getTableEditInfo(params).then(function(data){if(data){_this.columns=data.tableinfo.columns;var ds=data.tableinfo.datas;if(ds&&ds.length==0){_this.datasource.push({question:'',answer:''});}else{_this.datasource=data.tableinfo.datas;}}});}},{key:'getSecuritySettingStatus',value:function getSecuritySettingStatus(){var _this2=this;Api.isSecutitySetting().then(function(data){_this2.secStatus=data.secStatus;_this2.isSetted=data.isSetted;});}},{key:'pushAnswer',value:function pushAnswer(answer){this.answerArray.push(answer);}},{key:'save',value:function save(params){var _this3=this;Api.securityQaSave(params).then(function(data){if(data.result=='true'){_antd.message.success(getLabel('386524',"密保问题保存成功！"));Api.setSecSettingStatus({pswd:_this3.pwdCopy,checked:true}).then(function(data){if(data.result=='true'){_this3.secStatus=true;_this3.isSetted=true;}});}});}},{key:'setSecutityStatus',value:function setSecutityStatus(pwd){var _this4=this;var params={pswd:pwd};if(this.secStatus){params.checked=false;}else{params.checked=true;}Api.setSecSettingStatus(params).then(function(data){if(data.result=='true'){_this4.secStatus=!_this4.secStatus;_this4.doClose('1');}else{if(data.message){_antd.message.warning(data.message);}else{_antd.message.warning(getLabel('386525',"密码校验不通过，请重新输入！"));}}});}}]);return HrmPassword;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'tabKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isPwdVerifyDialogShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'isPwdSecuritySettingShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'current',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'columns',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'datasource',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'answerArray',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'isSetted',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'secStatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'isModifyBtnClick',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'pwdCopy',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'hrmId',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'doOpen',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'doOpen'),_class.prototype)),_class);

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setSecSettingStatus=exports.securityQaSave=exports.isSecutitySetting=exports.getTableEditInfo=undefined;var _ecCom=__webpack_require__(0);var getTableEditInfo=exports.getTableEditInfo=function getTableEditInfo(params){return _ecCom.WeaTools.callApi('/api/hrm/password/getPasswordQuestion','POST',params);};var isSecutitySetting=exports.isSecutitySetting=function isSecutitySetting(params){return _ecCom.WeaTools.callApi('/api/hrm/password/isSettedQuestion','GET',params);};var securityQaSave=exports.securityQaSave=function securityQaSave(params){return _ecCom.WeaTools.callApi('/api/hrm/password/insertQuestion','POST',params);};var setSecSettingStatus=exports.setSecSettingStatus=function setSecSettingStatus(params){return _ecCom.WeaTools.callApi('/api/hrm/password/changePswSwitch','POST',params);};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmSystemCard=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19;var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _systemCard=__webpack_require__(607);var Api=_interopRequireWildcard(_systemCard);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var HrmSystemCard=exports.HrmSystemCard=(_class=function(){function HrmSystemCard(){var _this=this;(0,_classCallCheck3.default)(this,HrmSystemCard);_initDefineProp(this,'tabKey',_descriptor,this);_initDefineProp(this,'headerColumns',_descriptor2,this);_initDefineProp(this,'sessionkey',_descriptor3,this);_initDefineProp(this,'condition1',_descriptor4,this);_initDefineProp(this,'condition2',_descriptor5,this);_initDefineProp(this,'form1',_descriptor6,this);_initDefineProp(this,'form2',_descriptor7,this);_initDefineProp(this,'isPanelShow',_descriptor8,this);_initDefineProp(this,'isSecSettingShow',_descriptor9,this);_initDefineProp(this,'tableStore',_descriptor10,this);_initDefineProp(this,'isPassVerification',_descriptor11,this);_initDefineProp(this,'isSecSetting',_descriptor12,this);_initDefineProp(this,'loginId',_descriptor13,this);_initDefineProp(this,'hrmId',_descriptor14,this);_initDefineProp(this,'isSecondaryVerifyUsed',_descriptor15,this);_initDefineProp(this,'isSecondaryVerifySetted',_descriptor16,this);_initDefineProp(this,'hasRight',_descriptor17,this);_initDefineProp(this,'loading',_descriptor18,this);_initDefineProp(this,'getHasRight',_descriptor19,this);this.getSecondaryVerifyPwdInfo=function(){Api.isUseSecondaryPwd({id:_this.hrmId//系统管理员id为1
}).then(function(cb){var isSetted=cb.isSetted,isUse=cb.isUse;_this.isSecondaryVerifySetted=isSetted;_this.isSecondaryVerifyUsed=isUse;});};this.saveSecondaryPasswordSetting=function(useSecondaryPwd){Api.saveUseSecondaryPwd({id:_this.hrmId,//系统管理员id为1
useSecondaryPwd:useSecondaryPwd//useSecondaryPwd:true -> 启用 false -> 停用
}).then(function(cb){var sign=cb.sign;if(sign!=='1'){_antd.message.warning(cb.message);return;}// this.isSecondaryVerifyUsed = useSecondaryPwd;
_this.getSecondaryVerifyPwdInfo();});};}(0,_createClass3.default)(HrmSystemCard,[{key:'tabClick',value:function tabClick(key){this.tabKey=key;this.getHeaderColumn(key);this.updateFormFields('','1');this.updateFormFields(key,'2');this.updateFormFields('','3');this.getTableInfo(key);}},{key:'getHeaderColumn',value:function getHeaderColumn(key){var _this2=this;var params={type:key};Api.getHeaderColumn(params).then(function(data){if(data){_this2.headerColumns=data;}});}},{key:'getTableInfo',value:function getTableInfo(key){var _this3=this;var params=void 0;if(key){params={type:key};}else{params=this.form1.getFormParams();}if('type'in params&&params.type!=='6'&&params.type!=='8')this.tabKey=params.type;if('type'in params&&(params.type=='6'||params.type=='8'))this.tabKey='0';this.tableStore=new TableStore();Api.getTableInfo(params).then(function(data){_this3.tableStore.getDatas(data.sessionkey);});}},{key:'getSearchCondition',value:function getSearchCondition(){var _this4=this;Api.getSearchCondition().then(function(data){_this4.condition1=data.condition;_this4.form1=new _comsMobx.WeaForm();_this4.form1.initFormFields(data.condition);});}},{key:'getSecSettingCondition',value:function getSecSettingCondition(params){var _this5=this;Api.getSecSettingCondition(params).then(function(data){_this5.isSecSetting=data.secSettings;_this5.condition2=data.condition;_this5.hrmId=data.hrmId;_this5.form2=new _comsMobx.WeaForm();_this5.form2.initFormFields(data.condition);//获取二次验证密码信息：是否设置、是否启用
_this5.getSecondaryVerifyPwdInfo();});}//获取二次验证密码信息：是否设置、是否启用
//保存二次验证密码设置
},{key:'setShowSearchAd',value:function setShowSearchAd(bool){this.isPanelShow=bool;}},{key:'hideSearchAd',value:function hideSearchAd(){this.isPanelShow=false;}},{key:'setDialogShow',value:function setDialogShow(){this.isSecSettingShow=true;}},{key:'hideDialog',value:function hideDialog(){this.isSecSettingShow=false;}},{key:'reset',value:function reset(){this.form2.reset();}},{key:'setLoginId',value:function setLoginId(loginId){this.loginId=loginId;}},{key:'updateFormFields',value:function updateFormFields(v,f){if(f=='1'){this.form1.updateFields({relatedname:{value:v}});}if(f=='2'){this.form1.updateFields({type__startdate__startdateto:{value:[v]}});}if(f=='3'){this.form1.updateFields({typeid:{value:[v]}});}}},{key:'save',value:function save(){var _this6=this;var params=(0,_extends3.default)({loginid:this.loginId},this.form2.getFormParams());Api.secSettingSave(params).then(function(data){if(data.status=='1'){_antd.message.success('安全设置项保存成功!');_this6.hideDialog();}else{_antd.message.success('安全设置项保存失败!');}});}}]);return HrmSystemCard;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'tabKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'headerColumns',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'sessionkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'condition1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'condition2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'form1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'form2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'isPanelShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'isSecSettingShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'tableStore',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'isPassVerification',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'isSecSetting',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'loginId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'hrmId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'isSecondaryVerifyUsed',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'isSecondaryVerifySetted',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'hasRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'tabClick',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'tabClick'),_class.prototype),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'getHasRight',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){_this7.loading=true;Api.getHasRight().then(function(data){var hasRight=data.hasRight;_this7.hasRight=hasRight;_this7.loading=false;if(hasRight){_this7.setShowSearchAd(false);_this7.getHeaderColumn(_this7.tabKey);_this7.getSearchCondition();_this7.getTableInfo('1');}});};}})),_class);

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveUseSecondaryPwd=exports.isUseSecondaryPwd=exports.secSettingSave=exports.getSecSettingCondition=exports.getSearchCondition=exports.getTableInfo=exports.getHeaderColumn=exports.getHasRight=undefined;var _ecCom=__webpack_require__(0);var getHasRight=exports.getHasRight=function getHasRight(params){return _ecCom.WeaTools.callApi('/api/hrm/sysadmin/hasRight','GET',params);};var getHeaderColumn=exports.getHeaderColumn=function getHeaderColumn(params){return _ecCom.WeaTools.callApi('/api/hrm/sysadmin/getResourceItem','GET',params);};var getTableInfo=exports.getTableInfo=function getTableInfo(params){return _ecCom.WeaTools.callApi('/api/hrm/sysadmin/getPagingResult','POST',params);};var getSearchCondition=exports.getSearchCondition=function getSearchCondition(){return _ecCom.WeaTools.callApi('/api/hrm/sysadmin/getSearchCondition','GET');};var getSecSettingCondition=exports.getSecSettingCondition=function getSecSettingCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/sysadmin/getHrmSystemSecuritySetting','GET',params);};var secSettingSave=exports.secSettingSave=function secSettingSave(params){return _ecCom.WeaTools.callApi('/api/hrm/sysadmin/save','POST',params);};var isUseSecondaryPwd=exports.isUseSecondaryPwd=function isUseSecondaryPwd(params){return _ecCom.WeaTools.callApi('/api/hrm/secondarypwd/isUseSecondaryPwd','GET',params);};var saveUseSecondaryPwd=exports.saveUseSecondaryPwd=function saveUseSecondaryPwd(params){return _ecCom.WeaTools.callApi('/api/hrm/secondarypwd/saveUseSecondaryPwd','POST',params);};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmCardInfo=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _promise=__webpack_require__(75);var _promise2=_interopRequireDefault(_promise);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15;var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _ecCom=__webpack_require__(0);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _isArray=__webpack_require__(29);var _isArray2=_interopRequireDefault(_isArray);var _util=__webpack_require__(17);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var toJS=mobx.toJS;var confirm=_antd.Modal.confirm;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmCardInfo=exports.HrmCardInfo=(_class=function(){function HrmCardInfo(){(0,_classCallCheck3.default)(this,HrmCardInfo);_initDefineProp(this,'modelItems',_descriptor,this);_initDefineProp(this,'infoGroup',_descriptor2,this);_initDefineProp(this,'imgSrc',_descriptor3,this);_initDefineProp(this,'sendButtons',_descriptor4,this);_initDefineProp(this,'accountInfo',_descriptor5,this);_initDefineProp(this,'showSQR',_descriptor6,this);_initDefineProp(this,'showBigImg',_descriptor7,this);_initDefineProp(this,'showAccountInfo',_descriptor8,this);_initDefineProp(this,'isEditor',_descriptor9,this);_initDefineProp(this,'buttons',_descriptor10,this);_initDefineProp(this,'hideBelongto',_descriptor11,this);_initDefineProp(this,'rightMenus',_descriptor12,this);_initDefineProp(this,'conditioninfo',_descriptor13,this);_initDefineProp(this,'form',_descriptor14,this);_initDefineProp(this,'QRCodeOptions',_descriptor15,this);this.hrmId=undefined;}//   @observable infoGroup2 = []
(0,_createClass3.default)(HrmCardInfo,[{key:'updateHideBelongto',value:function updateHideBelongto(bool){this.hideBelongto=bool;}},{key:'updateShowAccountInfo',value:function updateShowAccountInfo(bool){this.showAccountInfo=bool;}},{key:'updateShowBigImg',value:function updateShowBigImg(bool){this.showBigImg=bool;}},{key:'updateIsEditor',value:function updateIsEditor(bool){this.isEditor=bool||false;}},{key:'updateShowSQR',value:function updateShowSQR(bool){this.showSQR=bool;}},{key:'format',value:function format(datas){var infoGroup=[];//信息组
var imgSrc=null;//人员照片
var sendButtons=[];var accountInfo=[];var hrmInfo=[];datas&&datas.forEach(function(d){if(d.id=='item1'){hrmInfo=d.items;}if(d.id=='item2'){d.items.forEach(function(d2){d2.name=='resourceimageid'&&(imgSrc=d2.value);(0,_isArray2.default)(d2.options)&&(sendButtons=d2.options);d2.accountinfo&&(accountInfo=d2.accountinfo);});}if(d.id!='item1'&&d.id!='item2'&&d.id!='item3'){infoGroup.push(d);}});this.infoGroup=infoGroup;this.imgSrc=imgSrc;this.sendButtons=sendButtons;this.accountInfo=accountInfo;}},{key:'edit',value:function edit(hrmId){var _this=this;_ecCom.WeaTools.callApi('/api/hrm/resource/getResourceCard','GET',{operation:'getResourceBaseView',is_multilang_set:true,viewattr:2,id:hrmId}).then(function(data){_this.form=new _comsMobx.WeaForm();_this.form.initFormFields(data.result.conditions);var resourceimageid=(0,_util.getFormParamValue)(data.result.conditions,'resourceimageid');_this.form.updateFields({resourceimageid:{name:'resourceimageid',value:resourceimageid}});var params=_this.form.getFormParams();_this.conditioninfo=data.result.conditions;_this.hrmId=data.result.id;_this.editcontact=data.result.editcontact;var accounttype=params.accounttype||'0';_this.hideBelongto=accounttype=='0';});this.isEditor=true;}},{key:'saveEditCard',value:function saveEditCard(cb){var __this=this;var fieldParams=this.form.getFormParams();var conditioninfo=this.conditioninfo;var editcontact=this.editcontact;var hrmId=this.hrmId;var lastname=fieldParams.lastname||'';var workcode=fieldParams.workcode||'';var managerid=fieldParams.managerid||'';var accounttype=fieldParams.accounttype||'';var belongto=fieldParams.belongto||'';var email=fieldParams.email||'';if(!PublicFunc.chkMail(email))return false;if((0,_util.validate)(conditioninfo,fieldParams)){//选次账号后，必须选主账号
if(accounttype&&accounttype==1){if(!belongto||belongto==''){_antd.message.warning(getLabel('386411',"主账号未填写"));return;}}if(managerid==''&&(!editcontact||editcontact=='')){confirm({title:_i18n.i18n.confirm.systemhints(),content:getLabel('16072',"此员工还没有输入直接上级，确定不输入吗？"),onOk:function onOk(){_ecCom.WeaTools.callApi('/api/hrm/resource/hrmResourceCheck','GET',(0,_extends3.default)({id:hrmId,lastname:lastname,workcode:workcode,managerid:managerid})).then(function(data){if(data.status=='-1'){if(data.messagetype=='confirm'){confirm({title:_i18n.i18n.confirm.systemhints(),content:data.message,onOk:function onOk(){__this.doSave(cb);},onCancel:function onCancel(){}});}else{_antd.message.warning(data.message);}}else{__this.doSave(cb);}},function(error){_antd.message.warning(error.message);});},onCancel:function onCancel(){}});}else{_ecCom.WeaTools.callApi('/api/hrm/resource/hrmResourceCheck','GET',(0,_extends3.default)({id:hrmId,lastname:lastname,workcode:workcode,managerid:managerid})).then(function(data){if(data.status=='-1'){if(data.messagetype=='confirm'){confirm({title:_i18n.i18n.confirm.systemhints(),content:data.message,onOk:function onOk(){__this.doSave(cb);},onCancel:function onCancel(){}});}else{_antd.message.warning(data.message);}}else{__this.doSave(cb);}},function(error){_antd.message.warning(error.message);});}}}},{key:'doSave',value:function doSave(cb){var _this2=this;var __this=this;var fieldParams=this.form.getFormParams();var conditioninfo=this.conditioninfo;var editcontact=this.editcontact;var hrmId=this.hrmId;_ecCom.WeaTools.callApi('/api/hrm/resource/editResource','POST',(0,_extends3.default)({operation:'editresourcebasicinfo',id:hrmId,editcontact:editcontact},fieldParams)).then(function(data){if(data.status=='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this2.isEditor=false;_this2.getData(hrmId);cb();}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'getRightMenu',value:function getRightMenu(hrmId){var _this3=this;_ecCom.WeaTools.callApi('/api/hrm/resource/getRightMenu','GET',{id:hrmId}).then(function(data){_this3.rightMenus=data.rightMenus;});}},{key:'qrcode',value:function qrcode(hrmId){var _this4=this;_ecCom.WeaTools.callApi('/api/hrm/resource/getQRCode','GET',{id:hrmId}).then(function(obj){_this4.QRCodeOptions=obj.options;}).catch(function(err){_antd.message.error(err);});}},{key:'getData',value:function getData(hrmId){var _this5=this;this.hideBelongto=true;_promise2.default.all([_ecCom.WeaTools.callApi('/api/hrm/resource/getResourceCard','GET',{operation:'getResourceBaseView',id:hrmId,noLoadData:1}),_ecCom.WeaTools.callApi('/api/hrm/resource/getResourceCard','GET',{operation:'getResourceBaseView',id:hrmId,cmd:'getResourceBaseData',noLoadData:1}),_ecCom.WeaTools.callApi('/api/hrm/resource/getHrmResourceItem','GET',{id:hrmId,noLoadData:1})]).then(function(res){_this5.format(res[0].result);_this5.buttons=res[0].buttons;_this5.modelItems=res[2];_ecCom.WeaTools.callApi('/api/hrm/resource/getResourceCard','GET',{operation:'getResourceBaseView',id:hrmId}).then(function(datas){_this5.format(datas.result);_this5.validate=datas.validate;}),_ecCom.WeaTools.callApi('/api/hrm/resource/getResourceCard','GET',{operation:'getResourceBaseView',id:hrmId,cmd:'getResourceBaseData'}).then(function(datas){_this5.format(datas.result);});_ecCom.WeaTools.callApi('/api/hrm/resource/getHrmResourceItem','GET',{id:hrmId}).then(function(datas){_this5.modelItems=datas;});_this5.qrcode(hrmId);});}}]);return HrmCardInfo;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'modelItems',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'infoGroup',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'imgSrc',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'sendButtons',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'accountInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'showSQR',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'showBigImg',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'showAccountInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'isEditor',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'buttons',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'hideBelongto',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'rightMenus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'conditioninfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'QRCodeOptions',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'updateHideBelongto',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateHideBelongto'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateShowAccountInfo',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateShowAccountInfo'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateShowBigImg',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateShowBigImg'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateIsEditor',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateIsEditor'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateShowSQR',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateShowSQR'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'edit',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'edit'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getRightMenu',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getRightMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'qrcode',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'qrcode'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getData'),_class.prototype)),_class);

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmCardInfo4Formal=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _promise=__webpack_require__(75);var _promise2=_interopRequireDefault(_promise);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24;var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _ecCom=__webpack_require__(0);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _util=__webpack_require__(17);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _card=__webpack_require__(130);var api=_interopRequireWildcard(_card);var _i18n=__webpack_require__(11);var _lodash=__webpack_require__(65);var _isArray=__webpack_require__(29);var _isArray2=_interopRequireDefault(_isArray);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var toJS=mobx.toJS;var confirm=_antd.Modal.confirm;var HrmCardInfo4Formal=exports.HrmCardInfo4Formal=(_class=function(){function HrmCardInfo4Formal(){(0,_classCallCheck3.default)(this,HrmCardInfo4Formal);_initDefineProp(this,'isSelf',_descriptor,this);_initDefineProp(this,'modelItems',_descriptor2,this);_initDefineProp(this,'infoGroup',_descriptor3,this);_initDefineProp(this,'infoGroup2',_descriptor4,this);_initDefineProp(this,'imgSrc',_descriptor5,this);_initDefineProp(this,'sendButtons',_descriptor6,this);_initDefineProp(this,'accountInfo',_descriptor7,this);_initDefineProp(this,'showSQR',_descriptor8,this);_initDefineProp(this,'showBigImg',_descriptor9,this);_initDefineProp(this,'showAccountInfo',_descriptor10,this);_initDefineProp(this,'isEditor',_descriptor11,this);_initDefineProp(this,'buttons',_descriptor12,this);_initDefineProp(this,'hideBelongto',_descriptor13,this);_initDefineProp(this,'rightMenus',_descriptor14,this);_initDefineProp(this,'conditioninfo',_descriptor15,this);_initDefineProp(this,'form',_descriptor16,this);_initDefineProp(this,'QRCodeOptions',_descriptor17,this);_initDefineProp(this,'hasQRCode',_descriptor18,this);_initDefineProp(this,'remarkInfo',_descriptor19,this);_initDefineProp(this,'tagInfo',_descriptor20,this);_initDefineProp(this,'visibleWeiXin',_descriptor21,this);this.hrmId=undefined;_initDefineProp(this,'saveRemark',_descriptor22,this);_initDefineProp(this,'saveTag',_descriptor23,this);_initDefineProp(this,'delTag',_descriptor24,this);}(0,_createClass3.default)(HrmCardInfo4Formal,[{key:'updateVisibleWeiXin',value:function updateVisibleWeiXin(bool){this.visibleWeiXin=bool;}},{key:'updateHideBelongto',value:function updateHideBelongto(bool){this.hideBelongto=bool;}},{key:'updateShowAccountInfo',value:function updateShowAccountInfo(bool){this.showAccountInfo=bool;}},{key:'updateShowBigImg',value:function updateShowBigImg(bool){this.showBigImg=bool;}},{key:'updateIsEditor',value:function updateIsEditor(bool){this.isEditor=bool||false;}},{key:'updateShowSQR',value:function updateShowSQR(bool){this.showSQR=bool;}},{key:'format',value:function format(datas){var _this=this;var infoGroup=[];//信息组
var imgSrc=null;//人员照片
var sendButtons=[];var accountInfo=[];var hrmInfo=[];datas&&datas.forEach(function(d){if(d.id=='item1'){hrmInfo=d.items;}if(d.id=='item2'){d.items.forEach(function(d2){d2.name=='resourceimageid'&&(imgSrc=d2.value);(0,_isArray2.default)(d2.options)&&(sendButtons=d2.options);d2.accountinfo&&(accountInfo=d2.accountinfo);});}//old
if(d.id=='item4'||d.id=='item5')infoGroup.push(d);//专长介绍-modify by sunjun
if(d.id==='item6'){_this.remarkInfo=d.items[0];_this.tagInfo=d.items[1];}});this.infoGroup=infoGroup;this.imgSrc=imgSrc;this.sendButtons=sendButtons;this.accountInfo=accountInfo;}},{key:'edit',value:function edit(hrmId){var _this2=this;_ecCom.WeaTools.callApi('/api/hrm/resource/getResourceCard','GET',{operation:'getResourceBaseView',//isFormal: '1',
is_multilang_set:true,viewattr:2,id:hrmId}).then(function(data){_this2.form=new _comsMobx.WeaForm();_this2.form.initFormFields(data.result.conditions);var resourceimageid=(0,_util.getFormParamValue)(data.result.conditions,'resourceimageid');_this2.form.updateFields({resourceimageid:{name:'resourceimageid',value:resourceimageid}});var params=_this2.form.getFormParams();_this2.conditioninfo=data.result.conditions;_this2.hrmId=data.result.id;_this2.editcontact=data.result.editcontact;var accounttype=params.accounttype||'0';_this2.hideBelongto=accounttype=='0';});this.isEditor=true;}},{key:'saveEditCard',value:function saveEditCard(cb){var __this=this;var fieldParams=this.form.getFormParams();var conditioninfo=this.conditioninfo;var editcontact=this.editcontact;var hrmId=this.hrmId;var lastname=fieldParams.lastname||'';var workcode=fieldParams.workcode||'';var managerid=fieldParams.managerid||'';var accounttype=fieldParams.accounttype||'';var belongto=fieldParams.belongto||'';var email=fieldParams.email||'';if(!PublicFunc.chkMail(email))return false;if((0,_util.validate)(conditioninfo,fieldParams)){//选次账号后，必须选主账号
if(accounttype&&accounttype==1){if(!belongto||belongto==''){_antd.message.warning(getLabel('386411',"主账号未填写"));return;}}if(managerid==''&&(!editcontact||editcontact=='')){confirm({title:_i18n.i18n.confirm.systemhints(),content:getLabel('16072',"此员工还没有输入直接上级，确定不输入吗？"),onOk:function onOk(){_ecCom.WeaTools.callApi('/api/hrm/resource/hrmResourceCheck','GET',(0,_extends3.default)({id:hrmId,lastname:lastname,workcode:workcode,managerid:managerid})).then(function(data){if(data.status=='-1'){if(data.messagetype=='confirm'){confirm({title:_i18n.i18n.confirm.systemhints(),content:data.message,onOk:function onOk(){__this.doSave(cb);},onCancel:function onCancel(){}});}else{_antd.message.warning(data.message);}}else{__this.doSave(cb);}},function(error){_antd.message.warning(error.message);});},onCancel:function onCancel(){}});}else{_ecCom.WeaTools.callApi('/api/hrm/resource/hrmResourceCheck','GET',(0,_extends3.default)({id:hrmId,lastname:lastname,workcode:workcode,managerid:managerid})).then(function(data){if(data.status=='-1'){if(data.messagetype=='confirm'){confirm({title:_i18n.i18n.confirm.systemhints(),content:data.message,onOk:function onOk(){__this.doSave(cb);},onCancel:function onCancel(){}});}else{_antd.message.warning(data.message);}}else{__this.doSave(cb);}},function(error){_antd.message.warning(error.message);});}}}},{key:'doSave',value:function doSave(cb){var _this3=this;var fieldParams=this.form.getFormParams();var editcontact=this.editcontact;var hrmId=this.hrmId;_ecCom.WeaTools.callApi('/api/hrm/resource/editResource','POST',(0,_extends3.default)({operation:'editresourcebasicinfo',id:hrmId,//isFormal: '1',
editcontact:editcontact},fieldParams)).then(function(data){if(data.status=='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this3.isEditor=false;_this3.getData(hrmId);cb();}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'getRightMenu',value:function getRightMenu(hrmId){var _this4=this;_ecCom.WeaTools.callApi('/api/hrm/resource/getRightMenu','GET',{id:hrmId}).then(function(data){_this4.rightMenus=data.rightMenus;});}},{key:'qrcode',value:function qrcode(hrmId){var _this5=this;_ecCom.WeaTools.callApi('/api/hrm/resource/getQRCode','GET',{id:hrmId}).then(function(obj){_this5.QRCodeOptions=obj.options;}).catch(function(err){_antd.message.error(err);});}},{key:'getData',value:function getData(hrmId){var _this6=this;this.hrmId=hrmId;this.hideBelongto=true;_promise2.default.all([_ecCom.WeaTools.callApi('/api/hrm/resource4formal/getResourceCard','GET',{operation:'getResourceBaseView',id:hrmId,noLoadData:1}),_ecCom.WeaTools.callApi('/api/hrm/resource4formal/getResourceCard','GET',{operation:'getResourceBaseView',id:hrmId,cmd:'getResourceBaseData',noLoadData:1}),_ecCom.WeaTools.callApi('/api/hrm/resource/getHrmResourceItem','GET',{id:hrmId,noLoadData:1})]).then(function(res){_this6.isSelf=res[0].isSelf||false;_this6.format(res[0].result);_this6.infoGroup2=res[1].result;_this6.buttons=res[0].buttons;_this6.modelItems=res[2];_ecCom.WeaTools.callApi('/api/hrm/resource4formal/getResourceCard','GET',{operation:'getResourceBaseView',id:hrmId}).then(function(datas){_this6.format(datas.result);_this6.validate=datas.validate;}),_ecCom.WeaTools.callApi('/api/hrm/resource4formal/getResourceCard','GET',{operation:'getResourceBaseView',id:hrmId,cmd:'getResourceBaseData'}).then(function(datas){_this6.infoGroup2=datas.result;});_ecCom.WeaTools.callApi('/api/hrm/resource/getHrmResourceItem','GET',{id:hrmId}).then(function(datas){_this6.modelItems=datas;});_this6.qrcode(hrmId);});}}]);return HrmCardInfo4Formal;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'isSelf',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'modelItems',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'infoGroup',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'infoGroup2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'imgSrc',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'sendButtons',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'accountInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'showSQR',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'showBigImg',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'showAccountInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'isEditor',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'buttons',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'hideBelongto',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'rightMenus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'conditioninfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'QRCodeOptions',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'hasQRCode',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'remarkInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'tagInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'visibleWeiXin',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'updateVisibleWeiXin',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateVisibleWeiXin'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateShowAccountInfo',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateShowAccountInfo'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateShowBigImg',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateShowBigImg'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateIsEditor',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateIsEditor'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateShowSQR',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateShowSQR'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'edit',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'edit'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getRightMenu',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getRightMenu'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'qrcode',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'qrcode'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getData'),_class.prototype),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'saveRemark',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(params){api.saveRemark(params).then(function(data){if(data.status==='1'){_this7.remarkInfo.value=params.remark;_antd.message.success(_i18n.i18n.message.saveSuccess());}else _antd.message.error(data.message);},function(error){});};}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'saveTag',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this8=this;return function(dom){var params={tag:dom.value};if(params.tag===''||params.tag.trim().length===0)return;_this8.hrmId!=''&&(0,_assign2.default)(params,{id:_this8.hrmId});var arr=toJS(_this8.tagInfo.value);if((0,_lodash.indexOf)(arr,params.tag)>=0){_antd.message.error(getLabel('386438',"已存在相同标签"));dom.value='';}else{api.saveTag(params).then(function(data){if(data.status==='1'){dom.value='';_antd.message.success(_i18n.i18n.message.saveSuccess());_this8.tagInfo.value.push(params.tag);}else _antd.message.error(data.message);},function(error){});}};}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'delTag',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this9=this;return function(params){_this9.hrmId!=''&&(0,_assign2.default)(params,{id:_this9.hrmId});api.delTag(params).then(function(data){if(data.status==='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this9.tagInfo.value.splice((0,_lodash.indexOf)(_this9.tagInfo.value,params.tag),1);}else _antd.message.error(data.message);},function(error){});};}})),_class);

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmAddressBook=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33,_descriptor34,_descriptor35,_descriptor36,_descriptor37,_descriptor38,_descriptor39,_descriptor40,_descriptor41,_descriptor42,_descriptor43,_descriptor44,_descriptor45,_descriptor46,_descriptor47,_descriptor48,_descriptor49,_descriptor50,_descriptor51,_descriptor52,_descriptor53,_descriptor54,_descriptor55,_descriptor56,_descriptor57,_descriptor58,_descriptor59,_descriptor60,_descriptor61;var _mobx=__webpack_require__(8);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _remove=__webpack_require__(611);var _remove2=_interopRequireDefault(_remove);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _addressbook=__webpack_require__(616);var API=_interopRequireWildcard(_addressbook);var _data=__webpack_require__(617);var _data2=_interopRequireDefault(_data);var _i18n=__webpack_require__(11);var _ecCom=__webpack_require__(0);var _baseStore=__webpack_require__(129);var _baseStore2=_interopRequireDefault(_baseStore);var _lodash=__webpack_require__(65);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var confirm=_antd.Modal.confirm;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmAddressBook=exports.HrmAddressBook=(_class=function(_HrmBaseStore){(0,_inherits3.default)(HrmAddressBook,_HrmBaseStore);function HrmAddressBook(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,HrmAddressBook);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=HrmAddressBook.__proto__||(0,_getPrototypeOf2.default)(HrmAddressBook)).call.apply(_ref,[this].concat(args))),_this),_this.title=_i18n.i18n.module.addressBook,_initDefineProp(_this,'form',_descriptor,_this),_initDefineProp(_this,'table',_descriptor2,_this),_initDefineProp(_this,'dataKey',_descriptor3,_this),_initDefineProp(_this,'tabs',_descriptor4,_this),_initDefineProp(_this,'tabkey',_descriptor5,_this),_initDefineProp(_this,'showSearchAd',_descriptor6,_this),_initDefineProp(_this,'visible1',_descriptor7,_this),_initDefineProp(_this,'visible2',_descriptor8,_this),_initDefineProp(_this,'templeteValue',_descriptor9,_this),_initDefineProp(_this,'conditioninfo',_descriptor10,_this),_initDefineProp(_this,'conditioninfoAll',_descriptor11,_this),_initDefineProp(_this,'showAllCondition',_descriptor12,_this),_initDefineProp(_this,'transferDatas',_descriptor13,_this),_initDefineProp(_this,'transferOptions',_descriptor14,_this),_initDefineProp(_this,'transferKeys',_descriptor15,_this),_initDefineProp(_this,'transferleftIptVal',_descriptor16,_this),_initDefineProp(_this,'transferRightIptVal',_descriptor17,_this),_initDefineProp(_this,'transferSelectedKey',_descriptor18,_this),_initDefineProp(_this,'showAllLevel',_descriptor19,_this),_initDefineProp(_this,'rightMenus',_descriptor20,_this),_initDefineProp(_this,'defaultShowLeft',_descriptor21,_this),_initDefineProp(_this,'searchFrom',_descriptor22,_this),_initDefineProp(_this,'searchKeyWord',_descriptor23,_this),_initDefineProp(_this,'subcompanyid1',_descriptor24,_this),_initDefineProp(_this,'departmentid',_descriptor25,_this),_initDefineProp(_this,'virtualtype',_descriptor26,_this),_initDefineProp(_this,'companysId',_descriptor27,_this),_initDefineProp(_this,'spinning',_descriptor28,_this),_initDefineProp(_this,'templates',_descriptor29,_this),_initDefineProp(_this,'filterLeft',_descriptor30,_this),_initDefineProp(_this,'filterRight',_descriptor31,_this),_this.selectedKeys=[],_this.fields=[],_initDefineProp(_this,'realPath',_descriptor32,_this),_initDefineProp(_this,'keyfield',_descriptor33,_this),_initDefineProp(_this,'refreshTransfer',_descriptor34,_this),_initDefineProp(_this,'templateStore',_descriptor35,_this),_initDefineProp(_this,'fieldSettingDialogParams',_descriptor36,_this),_initDefineProp(_this,'saveFormDialogParams',_descriptor37,_this),_initDefineProp(_this,'editDialogParams',_descriptor38,_this),_initDefineProp(_this,'selectedTemplate',_descriptor39,_this),_this.selectedGroup='0',_this.selectOptions=[{key:'0',selected:true,showname:'全部'}],_this.getSaveTemplateForm=function(){return[{"title":"基本信息","defaultshow":true,"items":[{"colSpan":2,"conditionType":"INPUT","detailtype":1,"domkey":["name"],"fieldcol":12,"isQuickSearch":false,"label":getLabel('388384',"导出模板名称"),rules:"required|string","labelcol":6,"precision":0,"viewAttr":3,otherParams:(0,_extends3.default)({},window.inputType)}]}];},_initDefineProp(_this,'getDialogBtn',_descriptor40,_this),_initDefineProp(_this,'setSelectedKeys',_descriptor41,_this),_initDefineProp(_this,'getDisplayColumns',_descriptor42,_this),_initDefineProp(_this,'loadTemplateFields',_descriptor43,_this),_initDefineProp(_this,'onTransChange',_descriptor44,_this),_initDefineProp(_this,'searchField',_descriptor45,_this),_initDefineProp(_this,'clearState',_descriptor46,_this),_initDefineProp(_this,'initExportSetting',_descriptor47,_this),_initDefineProp(_this,'setRealPath',_descriptor48,_this),_initDefineProp(_this,'setKeyField',_descriptor49,_this),_initDefineProp(_this,'setSelectedGroup',_descriptor50,_this),_initDefineProp(_this,'getSelectedGroup',_descriptor51,_this),_initDefineProp(_this,'getTransferData',_descriptor52,_this),_initDefineProp(_this,'showSaveForm',_descriptor53,_this),_initDefineProp(_this,'saveForm',_descriptor54,_this),_initDefineProp(_this,'templateManager',_descriptor55,_this),_initDefineProp(_this,'loadTemplateTable',_descriptor56,_this),_initDefineProp(_this,'doExport',_descriptor57,_this),_initDefineProp(_this,'editTemplate',_descriptor58,_this),_initDefineProp(_this,'saveTemplate',_descriptor59,_this),_this.saveAsId='',_initDefineProp(_this,'saveAs',_descriptor60,_this),_initDefineProp(_this,'deleteTemplate',_descriptor61,_this),_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(HrmAddressBook,[{key:'getRightMenuConfig',value:function getRightMenuConfig(){var _this2=this;API.getRightMenuConfig().then(function(data){if(data.status=='1'){_this2.rightMenus=data.rightMenus;_this2.defaultShowLeft=data.defaultShowLeft;}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'changeShowAllLevel',value:function changeShowAllLevel(){this.showAllLevel=!this.showAllLevel;this.getData();}},{key:'updateTransferleftIptVal',value:function updateTransferleftIptVal(v){this.transferleftIptVal=v;}},{key:'updateTransferRightptVal',value:function updateTransferRightptVal(v){this.transferRightIptVal=v;}},{key:'updateTransferSelectedKey',value:function updateTransferSelectedKey(v){this.transferSelectedKey=v;}},{key:'updateTransferKeys',value:function updateTransferKeys(v){this.transferKeys=v;}},{key:'updateShowAllCondition',value:function updateShowAllCondition(v){this.showAllCondition=v;this.form=new _comsMobx.WeaForm();if(this.showAllCondition){this.form.initFormFields(this.conditioninfoAll);}else{this.form.initFormFields(this.conditioninfo);}}},{key:'updateTempleteValue',value:function updateTempleteValue(v){this.templeteValue=v;}},{key:'updateVisible1',value:function updateVisible1(bool){this.visible1=bool;}},{key:'updateVisible2',value:function updateVisible2(bool){this.visible2=bool;}},{key:'updateTabkey',value:function updateTabkey(key){this.tabkey=key;this.showAllLevel=false;this.searchFrom='';this.searchKeyWord='';this.getData();}},{key:'saveTemplete',value:function saveTemplete(){var _this3=this;var __this=this;var templeteValue=this.templeteValue||'';if(templeteValue==''){_antd.message.error(_i18n.i18n.message.requireFieldNone());return;}var params=this.form.getFormParams();params.opera="insert";params.mouldname=templeteValue;API.saveHrmSearchCondition(params).then(function(data){if(data.status=='1'){var tabkey=data.id;__this.updateTabkey(tabkey);__this.updateVisible2(!_this3.visible2);__this.updateTempleteValue('');__this.updateShowSearchAd(false);_antd.message.success(_i18n.i18n.message.saveSuccess());}else{_antd.message.error(data.message);}},function(error){_antd.message.error(error.message);});}},{key:'saveHrmSearchUserDefine',value:function saveHrmSearchUserDefine(){var _this4=this;var __this=this;var params={};!(0,_isEmpty2.default)((0,_mobx.toJS)(this.transferKeys))&&(0,_mobx.toJS)(this.transferKeys).forEach(function(c){if(c.endsWith("select"))c=c.replace("select","");var paramName="has"+c;params[paramName]='1';});API.saveHrmSearchUserDefine(params).then(function(data){if(data.status=='1'){__this.updateVisible1(!_this4.visible1);__this.updateShowSearchAd(false);__this.getConditions();_antd.message.success(_i18n.i18n.message.saveSuccess());}else{_antd.message.error(data.message);}},function(error){_antd.message.error(error.message);});}},{key:'getTabs',value:function getTabs(){var _this5=this;var params={};params.virtualtype=this.virtualtype;API.getHrmSearchMoudleList(params).then(function(data){if(data.status=='1'){_this5.tabs=data.tabs;}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'deleteTabs',value:function deleteTabs(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var __this=this;confirm({title:_i18n.i18n.confirm.systemhints(),content:_i18n.i18n.confirm.remove(),onOk:function onOk(){API.saveHrmSearchCondition(params).then(function(data){if(data.status=='1'){__this.updateTabkey('default_3');_antd.message.success(_i18n.i18n.message.deleteSuccess());}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});},onCancel:function onCancel(){}});}},{key:'formatTransfer',value:function formatTransfer(){var transferDatas=[];var transferKeys=[];var transferOptions=[{key:"",showname:""}];this.transferSelectedKey='0';this.transferleftIptVal='';this.transferRightIptVal='';!(0,_isEmpty2.default)((0,_mobx.toJS)(this.conditioninfoAll))&&(0,_mobx.toJS)(this.conditioninfoAll).forEach(function(c,idx){transferOptions.push({key:''+idx,showname:c.title});c.items.forEach(function(i){transferDatas.push({id:i.domkey[0],label:i.label,title:c.title,idx:''+idx});});});!(0,_isEmpty2.default)((0,_mobx.toJS)(this.conditioninfo))&&(0,_mobx.toJS)(this.conditioninfo).forEach(function(c,idx){c.items.forEach(function(i){transferKeys.push(i.domkey[0]);});});this.transferDatas=transferDatas;this.transferKeys=transferKeys;this.transferOptions=transferOptions;}},{key:'getConditions',value:function getConditions(cb){var _this6=this;var params={};params.mouldid=this.tabkey||'default_3';this.form=new _comsMobx.WeaForm();this.showAllCondition=false;API.getSearchCondition(params).then(function(data){_this6.conditioninfoAll=data.condition;_this6.conditioninfo=data.defaultcondition||[];if((0,_isEmpty2.default)(_this6.conditioninfo)){var c=(0,_cloneDeep2.default)(data.condition);c[0].title=_i18n.i18n.label.commonConditions();_this6.conditioninfo=[c[0]];}_this6.form.initFormFields(_this6.conditioninfo);if(_this6.searchFrom=='quickSearch'){_this6.tabkey='default_3';_this6.form.updateFields({resourcename:{name:'resourcename',value:_this6.searchKeyWord}});}_this6.showAllCondition=false;cb&&cb();});}},{key:'getSearchList',value:function getSearchList(){var _this7=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var formParams=this.form.getFormParams();params.tabkey=this.tabkey||'default_3';params.showAllLevel=this.showAllLevel?'1':'0';params.virtualtype=this.virtualtype;params=(0,_extends3.default)({},params,formParams);this.searchParams=params;this.table=new TableStore();API.getSearchList(params).then(function(data){_this7.table.setSelectedRowKeys([]);_this7.table.getDatas(data.sessionkey,1);_this7.dataKey=data.sessionkey;});}},{key:'updateShowSearchAd',value:function updateShowSearchAd(bool){this.showSearchAd=bool;}},{key:'exportExcel',value:function exportExcel(){//this.table.exportAll('','通讯录');
this.table.exportAll();}},{key:'doSearch',value:function doSearch(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.subcompanyid1=params.subcompanyid1;this.departmentid=params.departmentid;this.table.tableUpdate({datas:[]});this.updateShowSearchAd(false);this.getSearchList(params);}},{key:'reSearch',value:function reSearch(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.form.reset();this.updateShowSearchAd(true);}},{key:'getData',value:function getData(){var _this8=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.table.tableUpdate({datas:[]});this.getTabs();this.getConditions(function(){_this8.getSearchList(params);});// if(this.tabkey=='default_1'||this.tabkey=='default_2'||this.tabkey=='default_3'){
//   this.getConditions();
//   this.getSearchList();
// }else{
//   this.getConditions(()=> {
//     this.getSearchList();
//   });
// }
}//导出excel
//left head searchKey
//rightt head searchKey
//transfer selectedKeys
//all column fields
},{key:'selectVirtual',value:function selectVirtual(v){this.virtualtype=v;this.companysId=v;}},{key:'showGroup',get:function get(){return!this.editDialogParams.visible;}},{key:'multiDelete',get:function get(){return this.templateStore.selectedRowKeys.length===0;}}]);return HrmAddressBook;}(_baseStore2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'dataKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'tabs',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'tabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'default_3';}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'showSearchAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'visible1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'visible2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'templeteValue',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'conditioninfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'conditioninfoAll',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'showAllCondition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'transferDatas',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'transferOptions',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'transferKeys',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'transferleftIptVal',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'transferRightIptVal',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'transferSelectedKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'showAllLevel',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'rightMenus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'defaultShowLeft',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'searchFrom',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'searchKeyWord',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'subcompanyid1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'departmentid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'virtualtype',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'companysId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_applyDecoratedDescriptor(_class.prototype,'getRightMenuConfig',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getRightMenuConfig'),_class.prototype),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'spinning',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'templates',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'filterLeft',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'filterRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'realPath',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{depRealPath:'0',subCompRealPath:'0'};}}),_descriptor33=_applyDecoratedDescriptor(_class.prototype,'keyfield',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor34=_applyDecoratedDescriptor(_class.prototype,'refreshTransfer',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Date().getTime();}}),_descriptor35=_applyDecoratedDescriptor(_class.prototype,'templateStore',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor36=_applyDecoratedDescriptor(_class.prototype,'fieldSettingDialogParams',[_mobx.observable],{enumerable:true,initializer:function initializer(){var _this9=this;return{key:new Date().getTime(),visible:false,moduleName:'hrm',title:'导出字段设置',onCancel:function onCancel(){return _this9.fieldSettingDialogParams.visible=false;},style:{width:720,height:520},className:'exportSetting'};}}),_descriptor37=_applyDecoratedDescriptor(_class.prototype,'saveFormDialogParams',[_mobx.observable],{enumerable:true,initializer:function initializer(){var _this10=this;return{key:new Date().getTime(),visible:false,moduleName:'hrm',title:'存为模板',onCancel:function onCancel(){return _this10.saveFormDialogParams.visible=false;},style:{width:400,height:80},className:'formSetting'};}}),_descriptor38=_applyDecoratedDescriptor(_class.prototype,'editDialogParams',[_mobx.observable],{enumerable:true,initializer:function initializer(){var _this11=this;return{key:new Date().getTime(),visible:false,moduleName:'hrm',title:'导出模板管理',onCancel:function onCancel(){return _this11.editDialogParams.visible=false;},style:{width:600,height:520},className:'edit'};}}),_descriptor39=_applyDecoratedDescriptor(_class.prototype,'selectedTemplate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor40=_applyDecoratedDescriptor(_class.prototype,'getDialogBtn',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this12=this;return function(){var buttons=[],menus=[];if(_this12.saveFormDialogParams.visible){buttons=[React.createElement(_antd.Button,{type:'primary',op:'save',onClick:function onClick(){return _this12.saveForm();}},_i18n.i18n.button.save())];}else if(_this12.fieldSettingDialogParams.visible&&_this12.editDialogParams.visible){buttons=[React.createElement(_antd.Button,{type:'primary',op:'save',onClick:function onClick(){return _this12.saveTemplate();}},_i18n.i18n.button.save())];}else{buttons=[React.createElement(_antd.Button,{type:'primary',op:'export',onClick:function onClick(){return _this12.doExport();}},getLabel('17416',"导出")),React.createElement(_antd.Button,{type:'primary',op:'save',onClick:function onClick(){return _this12.showSaveForm();}},_i18n.i18n.button.saveAsTemplate()),React.createElement(_antd.Button,{type:'primary',op:'setting',onClick:function onClick(){return _this12.templateManager();}},getLabel('17857',"模板管理"))];}buttons.map(function(btn,index){var props=btn.props;menus.push({key:index.toString(),content:props.children,icon:React.createElement('i',{className:_this12.menuIconCollection[props.op]}),onClick:props.onClick});});return{buttons:buttons,menus:menus};};}}),_descriptor41=_applyDecoratedDescriptor(_class.prototype,'setSelectedKeys',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this13=this;return function(keys){_this13.selectedKeys=keys;_this13.refreshTransfer=new Date().getTime();};}}),_descriptor42=_applyDecoratedDescriptor(_class.prototype,'getDisplayColumns',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this14=this;return function(){_this14.timer=setInterval(function(){var _toJS=_this14.toJS(_this14.table),columns=_toJS.columns;if(columns.length>0){clearInterval(_this14.timer);var keys=[];columns.map(function(c){if(c.dataIndex!='id'&&c.dataIdex!='randomFieldId'&&c.display==='true')keys.push(c.dataIndex);});_this14.realPath.depRealPath='0';_this14.realPath.subCompRealPath='0';_this14.keyfield='1';_this14.setSelectedKeys(keys);}},100);};}}),_descriptor43=_applyDecoratedDescriptor(_class.prototype,'loadTemplateFields',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this15=this;return function(key){_this15.selectedTemplate=key;if(key==='-1'){_this15.setSelectedKeys([]);_this15.realPath.depRealPath='0';_this15.realPath.subCompRealPath='0';_this15.keyfield='1';}else if(key==='0'){_this15.getDisplayColumns();}else if(_this15.templates&&_this15.templates.length>0){_this15.realPath.depRealPath=_this15.templates[_this15.selectedTemplate].depRealPath.toString();_this15.realPath.subCompRealPath=_this15.templates[_this15.selectedTemplate].subCompRealPath.toString();_this15.keyfield=_this15.templates[_this15.selectedTemplate].keyfield.toString();_this15.setSelectedKeys(_this15.templates[_this15.selectedTemplate].fields.split(','));}};}}),_descriptor44=_applyDecoratedDescriptor(_class.prototype,'onTransChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this16=this;return function(keys,datas){_this16.selectedKeys=keys;};}}),_descriptor45=_applyDecoratedDescriptor(_class.prototype,'searchField',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this17=this;return function(t){var left=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;if(left)_this17.filterLeft=t;else _this17.filterRight=t;};}}),_descriptor46=_applyDecoratedDescriptor(_class.prototype,'clearState',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this18=this;return function(){_this18.saveFormTitle='';_this18.selectedKeys.length=0;_this18.fields.length=0;_this18.selectedGroup='0';_this18.selectedTemplate='0';_this18.filterLeft='';_this18.filterRight='';_this18.selectOptions.splice(1,_this18.selectOptions.length);_this18.selectOptions[0].showname=getLabel(82857,'全部');};}}),_descriptor47=_applyDecoratedDescriptor(_class.prototype,'initExportSetting',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this19=this;return function(){_this19.spinning=true;_this19.clearState();API.initExportSetting().then(function(rs){rs.map(function(data,index){if(data.status==='1'){switch(index){case 0:data.conditions.map(function(group,idx){_this19.selectOptions.push({key:(idx+1).toString(),selected:false,showname:group.title});group.items.map(function(f){_this19.fields.push({id:f.fieldname,name:f.fieldlabel,gName:group.title});});});break;case 1:_this19.templates=data.items;_this19.getDisplayColumns();break;}}});_this19.spinning=false;_this19.fieldSettingDialogParams.visible=true;},function(error){return _this19.spinning=false;});};}}),_descriptor48=_applyDecoratedDescriptor(_class.prototype,'setRealPath',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this20=this;return function(isDepartment,v){// if(isDepartment)
_this20.realPath.depRealPath=v;// else
_this20.realPath.subCompRealPath=v;};}}),_descriptor49=_applyDecoratedDescriptor(_class.prototype,'setKeyField',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this21=this;return function(v){return _this21.keyfield=v;};}}),_descriptor50=_applyDecoratedDescriptor(_class.prototype,'setSelectedGroup',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this22=this;return function(v){return _this22.selectedGroup=v;};}}),_descriptor51=_applyDecoratedDescriptor(_class.prototype,'getSelectedGroup',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this23=this;return function(v){return _this23.selectOptions[_this23.selectedGroup];};}}),_descriptor52=_applyDecoratedDescriptor(_class.prototype,'getTransferData',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this24=this;return function(){return _this24.fields;};}}),_descriptor53=_applyDecoratedDescriptor(_class.prototype,'showSaveForm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this25=this;return function(){var saveAs=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(_this25.spinning)return;if(_this25.selectedKeys.length===0){_antd.message.error(getLabel('388383',"请选择导出字段"));return;}_this25.setFormData('saveForm',_this25.getSaveTemplateForm());if(_this25.formTarget.saveForm.isFormInit){_this25.saveFormDialogParams.visible=true;_this25.saveFormDialogParams.key=new Date().getTime();}};}}),_descriptor54=_applyDecoratedDescriptor(_class.prototype,'saveForm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this26=this;return function(){if(_this26.spinning)return;_this26.formTarget.saveForm.validateForm().then(function(f){if(f.isValid){_this26.saveFormDialogParams.visible=false;_this26.spinning=true;var formParams=_this26.formTarget.saveForm.getFormParams();var params=(0,_extends3.default)({},formParams);var apiFuc=void 0;if(_this26.saveAsId!=''){(0,_assign2.default)(params,{id:_this26.saveAsId});apiFuc=API.saveAs;}else{(0,_assign2.default)(params,(0,_extends3.default)({fields:_this26.selectedKeys.join(",")},_this26.realPath,{keyfield:_this26.keyfield}));apiFuc=API.saveTemplate;}apiFuc(params).then(function(data){if(data.status==='1'){_this26.saveAsId='';_antd.message.success(_i18n.i18n.message.saveSuccess());if(_this26.editDialogParams.visible){_this26.loadTemplateTable();_this26.fieldSettingDialogParams.visible=false;}else{API.getTemplate().then(function(data){if(data.status==='1'){_this26.templates=data.items;_this26.selectedTemplate=(_this26.templates.length-1).toString();_this26.realPath.depRealPath=_this26.templates[_this26.selectedTemplate].depRealPath.toString();_this26.realPath.subCompRealPath=_this26.templates[_this26.selectedTemplate].subCompRealPath.toString();_this26.keyfield=_this26.templates[_this26.selectedTemplate].keyfield.toString();;_this26.setSelectedKeys(_this26.templates[_this26.selectedTemplate].fields.split(','));}});}}else{_antd.message.error(data.message);}_this26.spinning=false;},function(error){_this26.spinning=false;_antd.message.error(_i18n.i18n.message.actionError());});}else{f.showErrors();_this26.showError=new Date().getTime();}});};}}),_descriptor55=_applyDecoratedDescriptor(_class.prototype,'templateManager',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this27=this;return function(){if(_this27.spinning)return;_this27.loadTemplateTable(function(){_this27.editDialogParams.visible=true;_this27.fieldSettingDialogParams.visible=false;});};}}),_descriptor56=_applyDecoratedDescriptor(_class.prototype,'loadTemplateTable',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this28=this;return function(callback,paramas){API.getTemplateTable(paramas).then(function(data){if(data.status==="1"){_this28.templateStore=new TableStore();_this28.templateStore.getDatas(data.sessionkey);callback&&callback();}});};}}),_descriptor57=_applyDecoratedDescriptor(_class.prototype,'doExport',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this29=this;return function(){if(_this29.spinning)return;_this29.spinning=true;var params=(0,_extends3.default)({},_this29.searchParams);var arr=[];if(_this29.realPath.depRealPath==='1')arr.push('department');if(_this29.realPath.subCompRealPath==='1')arr.push('subcompany');params.needRealPath=arr.join(',');params.keyfield=_this29.keyfield;API.getSearchList(params).then(function(data){if(data.sessionkey!=null||data.sessionkey!=''){var keys=(0,_cloneDeep2.default)(_this29.selectedKeys);var _arr=[];['subcompanyid1','departmentid'].map(function(key){if(_this29.selectedKeys.indexOf(key)>-1){_arr.push(key);(0,_remove2.default)(keys,function(k){return k===key;});}});_arr=_arr.concat(keys);var fields=_arr.join(',');// const downloadUrl='/api/ec/dev/table/export';
// let formElement = document.createElement('form'); 
// formElement.style.display = "display:none;"; 
// formElement.method = 'post'; 
// formElement.action = downloadUrl; 
// let inputElement = document.createElement('input'); 
// inputElement.type = 'hidden'; 
// inputElement.name = "dataKey" ; 
// inputElement.value = data.sessionkey; 
// formElement.appendChild(inputElement);
// inputElement = document.createElement('input'); 
// inputElement.type = 'hidden'; 
// inputElement.name = "fields" ; 
// inputElement.value = fields; 
// formElement.appendChild(inputElement); 
// inputElement = document.createElement('input'); 
// inputElement.type = 'hidden'; 
// inputElement.name = "filename" ; 
// inputElement.value = i18n.module.addressBook(); 
// formElement.appendChild(inputElement); 
// document.body.appendChild(formElement); 
// formElement.submit(); 
// document.body.removeChild(formElement);
var p={dataKey:data.sessionkey,fields:fields};API.exportExcel(p).then(function(data){if(data.status){_ecCom.WeaTools.downloadFile(data.url,"GET");}else{}_this29.spinning=false;},function(error){_this29.spinning=false;_antd.message.error(_i18n.i18n.message.actionError());});_this29.spinning=false;}else{_this29.spinning=false;_antd.message.error(_i18n.i18n.message.actionError());}},function(error){_this29.spinning=false;_antd.message.error(_i18n.i18n.message.actionError());});};}}),_descriptor58=_applyDecoratedDescriptor(_class.prototype,'editTemplate',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this30=this;return function(record){_this30.editTarget=record;if(record!=null){_this30.selectedKeys=record.fields.split(',');_this30.realPath.depRealPath=record.deprealpath.toString();_this30.realPath.subCompRealPath=record.subcomprealpath.toString();_this30.keyfield=record.keyfield.toString();}else{_this30.selectedKeys=[];_this30.realPath.depRealPath='0';_this30.realPath.subCompRealPath='0';_this30.keyfield='1';}_this30.fieldSettingDialogParams.key=new Date().getTime();_this30.fieldSettingDialogParams.visible=true;};}}),_applyDecoratedDescriptor(_class.prototype,'showGroup',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'showGroup'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'multiDelete',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'multiDelete'),_class.prototype),_descriptor59=_applyDecoratedDescriptor(_class.prototype,'saveTemplate',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this31=this;return function(){if(_this31.editTarget!=null){if(_this31.selectedKeys.length===0){_antd.message.error(getLabel('388383',"请选择导出字段"));return;}var params=(0,_extends3.default)({fields:_this31.selectedKeys.join(",")},_this31.realPath,{keyfield:_this31.keyfield,id:_this31.editTarget.id,name:_this31.editTarget.name});API.saveTemplate(params).then(function(data){if(data.status==='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this31.loadTemplateTable();_this31.fieldSettingDialogParams.visible=false;}else{_antd.message.error(data.message);}},function(error){return _antd.message.error(_i18n.i18n.message.actionError());});}else{_this31.showSaveForm();}};}}),_descriptor60=_applyDecoratedDescriptor(_class.prototype,'saveAs',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this32=this;return function(id){_this32.saveAsId=id;_this32.setFormData('saveForm',_this32.getSaveTemplateForm());if(_this32.formTarget.saveForm.isFormInit){_this32.saveFormDialogParams.visible=true;_this32.saveFormDialogParams.key=new Date().getTime();}};}}),_descriptor61=_applyDecoratedDescriptor(_class.prototype,'deleteTemplate',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this33=this;return function(params){var content=void 0;if((0,_lodash.has)(params,'id')){content=_i18n.i18n.confirm.delete();}else{content=_i18n.i18n.confirm.batchDeleteConfirm();params={id:_this33.templateStore.selectedRowKeys.join(',')};}_this33.confirmInfo({content:content,onOk:function onOk(){API.deleteTemplate(params).then(function(data){if(data.status==='1'){_antd.message.success(_i18n.i18n.message.deleteSuccess());_this33.loadTemplateTable();}else{_antd.message.error(data.message);}},function(error){return _antd.message.error(_i18n.i18n.message.actionError());});}});};}})),_class);

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(230),
    basePullAt = __webpack_require__(612);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(613),
    isIndex = __webpack_require__(159);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(165),
    last = __webpack_require__(614),
    parent = __webpack_require__(615),
    toKey = __webpack_require__(98);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 614 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(164),
    baseSlice = __webpack_require__(239);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.initExportSetting=exports.saveAs=exports.deleteTemplate=exports.saveTemplate=exports.getTemplateTable=exports.getTemplate=exports.getFields=exports.exportExcel=exports.getRightMenuConfig=exports.saveHrmSearchUserDefine=exports.customQueryCondition=exports.getHrmSearchMoudleList=exports.saveHrmSearchCondition=exports.queryFieldsTree=exports.getSearchList=exports.getSearchCondition=exports.getTabs=undefined;var _promise=__webpack_require__(75);var _promise2=_interopRequireDefault(_promise);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getTabs=exports.getTabs=function getTabs(params){return _ecCom.WeaTools.callApi('/api/hrm/search/getTabs','GET',params);};var getSearchCondition=exports.getSearchCondition=function getSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/search/getHrmSearchCondition','GET',params);};var getSearchList=exports.getSearchList=function getSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/search/getHrmSearchResult','POST',params);};var queryFieldsTree=exports.queryFieldsTree=function queryFieldsTree(params){return _ecCom.WeaTools.callApi('/api/hrm/base/getHrmSearchTree','GET',params);};var saveHrmSearchCondition=exports.saveHrmSearchCondition=function saveHrmSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/search/saveHrmSearchCondition','POST',params);};var getHrmSearchMoudleList=exports.getHrmSearchMoudleList=function getHrmSearchMoudleList(params){return _ecCom.WeaTools.callApi('/api/hrm/search/getHrmSearchMoudleList','GET',params);};var customQueryCondition=exports.customQueryCondition=function customQueryCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/search/getHrmSearchUserDefine','GET',params);};var saveHrmSearchUserDefine=exports.saveHrmSearchUserDefine=function saveHrmSearchUserDefine(params){return _ecCom.WeaTools.callApi('/api/hrm/search/saveHrmSearchUserDefine','POST',params);};var getRightMenuConfig=exports.getRightMenuConfig=function getRightMenuConfig(params){return _ecCom.WeaTools.callApi('/api/hrm/search/getRightMenu','GET',params);};var exportExcel=exports.exportExcel=function exportExcel(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/ec/dev/table/export','POST',params);};var getFields=exports.getFields=function getFields(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/search/getFields','GET',params);};var getTemplate=exports.getTemplate=function getTemplate(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/resourceExportTemplate/getTemplate','GET',params);};var getTemplateTable=exports.getTemplateTable=function getTemplateTable(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/resourceExportTemplate/getTemplateTable','GET',params);};var saveTemplate=exports.saveTemplate=function saveTemplate(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/resourceExportTemplate/saveTemplate','POST',params);};var deleteTemplate=exports.deleteTemplate=function deleteTemplate(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/resourceExportTemplate/deleteTemplate','POST',params);};var saveAs=exports.saveAs=function saveAs(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/resourceExportTemplate/saveAs','POST',params);};var initExportSetting=exports.initExportSetting=function initExportSetting(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _promise2.default.all([getFields(),getTemplate(params)]);};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={"conditioninfo":[{"defaultshow":true,"items":[{"colSpan":2,"conditionType":"INPUT","domkey":["requestname"],"fieldcol":18,"isQuickSearch":false,"label":"标题","labelcol":6,"viewAttr":2},{"colSpan":2,"conditionType":"INPUT","domkey":["wfcode"],"fieldcol":18,"isQuickSearch":false,"label":"流程编号","labelcol":6,"viewAttr":2},{"browserConditionParam":{"completeParams":{},"conditionDataParams":{},"dataParams":{},"destDataParams":{},"hasAddBtn":false,"hasAdvanceSerach":true,"idSeparator":",","isAutoComplete":1,"isDetail":0,"isMultCheckbox":false,"isSingle":true,"pageSize":10,"quickSearchName":"","title":"工作流","type":"-99991","viewAttr":2},"colSpan":2,"conditionType":"BROWSER","domkey":["workflowid"],"fieldcol":18,"isQuickSearch":false,"label":"工作流","labelcol":6,"viewAttr":2},{"colSpan":2,"conditionType":"DATE","domkey":["createdateselect","createdatefrom","createdateto"],"fieldcol":18,"isQuickSearch":false,"label":"创建日期","labelcol":6,"options":[{"key":"0","selected":true,"showname":"全部"},{"key":"1","selected":false,"showname":"今天"},{"key":"2","selected":false,"showname":"本周"},{"key":"3","selected":false,"showname":"本月"},{"key":"4","selected":false,"showname":"本季"},{"key":"5","selected":false,"showname":"本年"},{"key":"6","selected":false,"showname":"指定日期范围"}],"viewAttr":2},{"colSpan":2,"conditionType":"SELECT_LINKAGE","domkey":["creatertype","createrid","createrid2"],"fieldcol":18,"isQuickSearch":false,"label":"创建人","labelcol":6,"options":[{"key":"0","selected":true,"showname":"员工"},{"key":"1","selected":false,"showname":"客户"}],"selectLinkageDatas":{"0":{"browserConditionParam":{"completeParams":{},"conditionDataParams":{},"dataParams":{},"destDataParams":{},"hasAddBtn":false,"hasAdvanceSerach":true,"idSeparator":",","isAutoComplete":1,"isDetail":0,"isMultCheckbox":false,"isSingle":true,"linkUrl":"/hrm/resource/HrmResource.jsp?id=","pageSize":10,"quickSearchName":"","title":"人力资源","type":"hrmgroup","viewAttr":2},"colSpan":2,"conditionType":"BROWSER","domkey":["createrid"],"fieldcol":18,"isQuickSearch":false,"label":"null","labelcol":6,"viewAttr":2},"1":{"browserConditionParam":{"completeParams":{},"conditionDataParams":{},"dataParams":{},"destDataParams":{},"hasAddBtn":false,"hasAdvanceSerach":true,"idSeparator":",","isAutoComplete":1,"isDetail":0,"isMultCheckbox":false,"isSingle":true,"linkUrl":"/CRM/data/ViewCustomer.jsp?isrequest=1&CustomerID=","pageSize":10,"quickSearchName":"","title":"客户","type":"7","viewAttr":2},"colSpan":2,"conditionType":"BROWSER","domkey":["createrid2"],"fieldcol":18,"isQuickSearch":false,"label":"null","labelcol":6,"viewAttr":2}},"viewAttr":2},{"colSpan":2,"conditionType":"INPUT","domkey":["workcode"],"fieldcol":18,"isQuickSearch":false,"label":"创建人编号","labelcol":6,"viewAttr":2}],"title":"基本条件"},{"defaultshow":true,"items":[{"browserConditionParam":{"completeParams":{},"conditionDataParams":{},"dataParams":{},"destDataParams":{},"hasAddBtn":false,"hasAdvanceSerach":true,"idSeparator":",","isAutoComplete":1,"isDetail":0,"isMultCheckbox":false,"isSingle":true,"linkUrl":"/hrm/company/HrmDepartmentDsp.jsp?id=","pageSize":10,"quickSearchName":"","tabs":[{"isSearch":false,"key":"2","name":"组织结构","selected":false},{"dataParams":{"list":"1"},"isSearch":true,"key":"1","name":"按列表","selected":false}],"title":"部门","type":"4","viewAttr":2},"colSpan":2,"conditionType":"BROWSER","domkey":["ownerdepartmentid"],"fieldcol":18,"isQuickSearch":false,"label":"创建人部门","labelcol":6,"viewAttr":2},{"browserConditionParam":{"completeParams":{},"conditionDataParams":{},"dataParams":{},"destDataParams":{},"hasAddBtn":false,"hasAdvanceSerach":true,"idSeparator":",","isAutoComplete":1,"isDetail":0,"isMultCheckbox":false,"isSingle":true,"linkUrl":"/hrm/company/HrmSubCompanyDsp.jsp?id=","pageSize":10,"quickSearchName":"","tabs":[{"isSearch":false,"key":"2","name":"组织结构","selected":false},{"dataParams":{"list":"1"},"isSearch":true,"key":"1","name":"按列表","selected":false}],"title":"分部","type":"164","viewAttr":2},"colSpan":2,"conditionType":"BROWSER","domkey":["creatersubcompanyid"],"fieldcol":18,"isQuickSearch":false,"label":"创建人分部","labelcol":6,"viewAttr":2},{"browserConditionParam":{"completeParams":{},"conditionDataParams":{},"dataParams":{},"destDataParams":{},"hasAddBtn":false,"hasAdvanceSerach":true,"idSeparator":",","isAutoComplete":1,"isDetail":0,"isMultCheckbox":false,"isSingle":true,"pageSize":10,"quickSearchName":"","title":"路径类型","type":"wftype","viewAttr":2},"colSpan":2,"conditionType":"BROWSER","domkey":["workflowtype"],"fieldcol":18,"isQuickSearch":false,"label":"类型","labelcol":6,"viewAttr":2},{"colSpan":2,"conditionType":"SELECT","domkey":["requestlevel"],"fieldcol":18,"isQuickSearch":false,"label":"紧急程度","labelcol":6,"options":[{"key":"","selected":true,"showname":""},{"key":"0","selected":false,"showname":"正常"},{"key":"1","selected":false,"showname":"重要"},{"key":"2","selected":false,"showname":"紧急"}],"viewAttr":2},{"colSpan":2,"conditionType":"DATE","domkey":["recievedateselect","recievedatefrom","recievedateto"],"fieldcol":18,"isQuickSearch":false,"label":"接收日期","labelcol":6,"options":[{"key":"0","selected":true,"showname":"全部"},{"key":"1","selected":false,"showname":"今天"},{"key":"2","selected":false,"showname":"本周"},{"key":"3","selected":false,"showname":"本月"},{"key":"4","selected":false,"showname":"本季"},{"key":"5","selected":false,"showname":"本年"},{"key":"6","selected":false,"showname":"指定日期范围"}],"viewAttr":2},{"colSpan":2,"conditionType":"SELECT","domkey":["wfstatu"],"fieldcol":18,"isQuickSearch":false,"label":"流程状态","labelcol":6,"options":[{"key":"1","selected":true,"showname":"有效"},{"key":"0","selected":false,"showname":"无效"},{"key":"2","selected":false,"showname":"全部"}],"viewAttr":2},{"colSpan":2,"conditionType":"SELECT","domkey":["nodetype"],"fieldcol":18,"isQuickSearch":false,"label":"节点类型","labelcol":6,"options":[{"key":"","selected":true,"showname":""},{"key":"0","selected":false,"showname":"创建"},{"key":"1","selected":false,"showname":"批准"},{"key":"2","selected":false,"showname":"提交"},{"key":"3","selected":false,"showname":"归档"}],"viewAttr":2},{"browserConditionParam":{"completeParams":{},"conditionDataParams":{},"dataParams":{},"destDataParams":{},"hasAddBtn":false,"hasAdvanceSerach":true,"idSeparator":",","isAutoComplete":1,"isDetail":0,"isMultCheckbox":false,"isSingle":true,"linkUrl":"/hrm/resource/HrmResource.jsp?id=","pageSize":10,"quickSearchName":"","title":"人力资源","type":"1","viewAttr":2},"colSpan":2,"conditionType":"BROWSER","domkey":["unophrmid"],"fieldcol":18,"isQuickSearch":false,"label":"未操作者","labelcol":6,"viewAttr":2},{"browserConditionParam":{"completeParams":{},"conditionDataParams":{},"dataParams":{},"destDataParams":{},"hasAddBtn":false,"hasAdvanceSerach":true,"idSeparator":",","isAutoComplete":1,"isDetail":0,"isMultCheckbox":false,"isSingle":true,"linkUrl":"/docs/docs/DocDsp.jsp?isrequest=1&id=","pageSize":10,"quickSearchName":"","title":"文档","type":"9","viewAttr":2},"colSpan":2,"conditionType":"BROWSER","domkey":["docids"],"fieldcol":18,"isQuickSearch":false,"label":"相关文档","labelcol":6,"viewAttr":2},{"browserConditionParam":{"completeParams":{},"conditionDataParams":{},"dataParams":{},"destDataParams":{},"hasAddBtn":false,"hasAdvanceSerach":true,"idSeparator":",","isAutoComplete":1,"isDetail":0,"isMultCheckbox":false,"isSingle":true,"linkUrl":"/hrm/resource/HrmResource.jsp?id=","pageSize":10,"quickSearchName":"","title":"人力资源","type":"1","viewAttr":2},"colSpan":2,"conditionType":"BROWSER","domkey":["hrmcreaterid"],"fieldcol":18,"isQuickSearch":false,"label":"人力资源","labelcol":6,"viewAttr":2},{"browserConditionParam":{"completeParams":{},"conditionDataParams":{},"dataParams":{},"destDataParams":{},"hasAddBtn":false,"hasAdvanceSerach":true,"idSeparator":",","isAutoComplete":1,"isDetail":0,"isMultCheckbox":false,"isSingle":true,"linkUrl":"/CRM/data/ViewCustomer.jsp?isrequest=1&CustomerID=","pageSize":10,"quickSearchName":"","title":"客户","type":"7","viewAttr":2},"colSpan":2,"conditionType":"BROWSER","domkey":["crmids"],"fieldcol":18,"isQuickSearch":false,"label":"相关客户","labelcol":6,"viewAttr":2},{"browserConditionParam":{"completeParams":{},"conditionDataParams":{},"dataParams":{},"destDataParams":{},"hasAddBtn":false,"hasAdvanceSerach":true,"idSeparator":",","isAutoComplete":1,"isDetail":0,"isMultCheckbox":false,"isSingle":true,"linkUrl":"/proj/data/ViewProject.jsp?isrequest=1&ProjID=","pageSize":10,"quickSearchName":"","title":"项目","type":"8","viewAttr":2},"colSpan":2,"conditionType":"BROWSER","domkey":["proids"],"fieldcol":18,"isQuickSearch":false,"label":"相关项目","labelcol":6,"viewAttr":2}],"title":"工作信息"}]};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmAdd=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _toConsumableArray2=__webpack_require__(74);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33;var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _add=__webpack_require__(619);var API=_interopRequireWildcard(_add);var _util=__webpack_require__(17);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _forEach=__webpack_require__(46);var _forEach2=_interopRequireDefault(_forEach);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var confirm=_antd.Modal.confirm;var TableStore=_comsMobx.WeaTableNew.TableStore;var toJS=mobx.toJS;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmAdd=exports.HrmAdd=(_class=function(){function HrmAdd(){var _this=this;(0,_classCallCheck3.default)(this,HrmAdd);_initDefineProp(this,'title',_descriptor,this);_initDefineProp(this,'hasRight',_descriptor2,this);_initDefineProp(this,'verified',_descriptor3,this);_initDefineProp(this,'simpleVisible',_descriptor4,this);_initDefineProp(this,'fullVisible',_descriptor5,this);_initDefineProp(this,'formSearch',_descriptor6,this);_initDefineProp(this,'formSimple',_descriptor7,this);_initDefineProp(this,'formFull',_descriptor8,this);_initDefineProp(this,'table',_descriptor9,this);_initDefineProp(this,'condition',_descriptor10,this);_initDefineProp(this,'showSearchAd',_descriptor11,this);_initDefineProp(this,'searchParamsAd',_descriptor12,this);_initDefineProp(this,'dataKey',_descriptor13,this);_initDefineProp(this,'passwordComplexity',_descriptor14,this);_initDefineProp(this,'minpasslen',_descriptor15,this);_initDefineProp(this,'canSave',_descriptor16,this);_initDefineProp(this,'loading',_descriptor17,this);_initDefineProp(this,'hrmId',_descriptor18,this);_initDefineProp(this,'conditionInfo',_descriptor19,this);_initDefineProp(this,'saveAndNew',_descriptor20,this);_initDefineProp(this,'updateScroll',_descriptor21,this);_initDefineProp(this,'current',_descriptor22,this);_initDefineProp(this,'conditionInfo0',_descriptor23,this);_initDefineProp(this,'conditionInfo1',_descriptor24,this);_initDefineProp(this,'conditionInfo2',_descriptor25,this);_initDefineProp(this,'conditionInfo3',_descriptor26,this);_initDefineProp(this,'tableInfo1',_descriptor27,this);_initDefineProp(this,'tableInfo2',_descriptor28,this);_initDefineProp(this,'tabInfo1',_descriptor29,this);_initDefineProp(this,'tabInfo2',_descriptor30,this);_initDefineProp(this,'tabkey1',_descriptor31,this);_initDefineProp(this,'tabkey2',_descriptor32,this);_initDefineProp(this,'departmentid',_descriptor33,this);this.getToday=function(){var now=new Date();//当前日期
var nowYear=now.getFullYear();//当前年
var nowMonth=now.getMonth();//当前月
var nowDay=now.getDate();//当前日
var today=_this.formatDate(new Date(nowYear,nowMonth,nowDay));//今天
return today;};}(0,_createClass3.default)(HrmAdd,[{key:'updateTabkey',value:function updateTabkey(key){var current=this.current;if(current==1)this.tabkey1=key;if(current==2)this.tabkey2=key;}},{key:'getTabInfo',value:function getTabInfo(){var _this2=this;this.tabInfo1=[];this.tabInfo2=[];this.tableInfo1&&this.tableInfo1.forEach(function(c,idx){_this2.tabInfo1.push({key:''+idx,title:c.tabname});});this.tableInfo2&&this.tableInfo2.forEach(function(c,idx){_this2.tabInfo2.push({key:''+idx,title:c.tabname});});}},{key:'getData',value:function getData(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.getSearchCondition();this.getSearchList();}},{key:'checkRight',value:function checkRight(){var _this3=this;this.verified=false;API.hasRight().then(function(data){_this3.hasRight=data.hasRight;_this3.verified=true;});}},{key:'getSearchCondition',value:function getSearchCondition(){var _this4=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getSearchCondition(params).then(function(data){_this4.formSearch=new _comsMobx.WeaForm();_this4.condition=data.condition;_this4.formSearch.initFormFields(data.condition);});}},{key:'doSearch',value:function doSearch(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var formParams=this.formSearch.getFormParams();formParams.search="search";this.getSearchList((0,_extends3.default)({},params,formParams));}},{key:'getSearchList',value:function getSearchList(){var _this5=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getSearchList(params).then(function(data){_this5.dataKey=data.sessionkey;_this5.table.getDatas(data.sessionkey,1);});}},{key:'getHrmResourceAddForm',value:function getHrmResourceAddForm(){var _this6=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.loading=true;var type=params.type;params.departmentid=this.departmentid;API.getHrmResourceAddForm(params).then(function(data){_this6.loading=false;if(type=='simple'){_this6.saveAndNew=false;_this6.conditionInfo=data.condition;_this6.formSimple=new _comsMobx.WeaForm();_this6.formSimple.initFormFields(data.condition);var resourceimageid=(0,_util.getFormParamValue)(data.condition,'resourceimageid');_this6.formSimple.updateFields({resourceimageid:{name:'resourceimageid',value:resourceimageid}});}else{_this6.conditionInfo0=data.basecondition;_this6.conditionInfo1=data.personalcondition||[];_this6.conditionInfo2=data.workcondition||[];_this6.conditionInfo3=data.systeminfocondition||[];_this6.tableInfo1=data.personaltables||[];_this6.tableInfo2=data.worktables||[];_this6.getTabInfo();_this6.tabkey1=0;_this6.tabkey2=0;_this6.hrmId=data.hrmId;var conditions=[].concat((0,_toConsumableArray3.default)(_this6.conditionInfo0),(0,_toConsumableArray3.default)(_this6.conditionInfo1),(0,_toConsumableArray3.default)(_this6.conditionInfo2),(0,_toConsumableArray3.default)(_this6.conditionInfo3));_this6.formFull=new _comsMobx.WeaForm();_this6.formFull.initFormFields(conditions);var _resourceimageid=(0,_util.getFormParamValue)(conditions,'resourceimageid');_this6.formFull.updateFields({resourceimageid:{name:'resourceimageid',value:_resourceimageid}});}_this6.passwordComplexity=data.passwordComplexity;_this6.minpasslen=data.minpasslen;});}},{key:'update',value:function update(){this.table.tableUpdate({datas:[]});//清空缓存
this.table.getDatas(this.dataKey,1);//刷新table
}},{key:'setShowSearchAd',value:function setShowSearchAd(bool){this.showSearchAd=bool;}},{key:'save',value:function save(){var __this=this;var conditionInfo=this.conditionInfo;var formParams=this.formSimple.getFormParams();var lastname=formParams.lastname||'';var workcode=formParams.workcode||'';var managerid=formParams.managerid||'';var accounttype=formParams.accounttype||'';var belongto=formParams.belongto||'';var email=formParams.email||'';if((0,_util.validate)(conditionInfo,formParams)){//选次账号后，必须选主账号
if(accounttype&&accounttype==1){if(!belongto||belongto==''){_antd.message.warning(getLabel('386411',"主账号未填写"));return;}}if(!this.checkPassword())return;if(!PublicFunc.chkMail(email))return false;if(managerid==''){confirm({title:_i18n.i18n.confirm.systemhints(),content:getLabel('16072',"此员工还没有输入直接上级，确定不输入吗？"),onOk:function onOk(){_ecCom.WeaTools.callApi('/api/hrm/resource/hrmResourceCheck','GET',(0,_extends3.default)({lastname:lastname,workcode:workcode,managerid:managerid})).then(function(data){if(data.status=='-1'){if(data.messagetype=='confirm'){confirm({title:_i18n.i18n.confirm.systemhints(),content:data.message,onOk:function onOk(){__this.doSave();},onCancel:function onCancel(){}});}else{_antd.message.warning(data.message);}}else{__this.doSave();}},function(error){_antd.message.warning(error.message);});},onCancel:function onCancel(){}});}else{_ecCom.WeaTools.callApi('/api/hrm/resource/hrmResourceCheck','GET',(0,_extends3.default)({lastname:lastname,workcode:workcode,managerid:managerid})).then(function(data){if(data.status=='-1'){if(data.messagetype=='confirm'){confirm({title:_i18n.i18n.confirm.systemhints(),content:data.message,onOk:function onOk(){__this.doSave();},onCancel:function onCancel(){}});}else{_antd.message.warning(data.message);}}else{__this.doSave();}},function(error){_antd.message.warning(error.message);});}}}},{key:'myvalidate',value:function myvalidate(cb){var current=this.current;var formFull=this.formFull;var formParams=formFull.getFormParams();if(current==0){var conditionInfo0=this.conditionInfo0;var lastname=formParams.lastname||'';var workcode=formParams.workcode||'';var managerid=formParams.managerid||'';var accounttype=formParams.accounttype||'';var belongto=formParams.belongto||'';var email=formParams.email||'';if((0,_util.validate)(conditionInfo0,formParams)){//选次账号后，必须选主账号
if(accounttype&&accounttype==1){if(!belongto||belongto==''){_antd.message.warning(getLabel('386411',"主账号未填写"));return;}}if(!PublicFunc.chkMail(email))return false;if(managerid==''){confirm({title:_i18n.i18n.confirm.systemhints(),content:getLabel('16072',"此员工还没有输入直接上级，确定不输入吗？"),onOk:function onOk(){_ecCom.WeaTools.callApi('/api/hrm/resource/hrmResourceCheck','GET',(0,_extends3.default)({lastname:lastname,workcode:workcode,managerid:managerid})).then(function(data){if(data.status=='-1'){if(data.messagetype=='confirm'){confirm({title:_i18n.i18n.confirm.systemhints(),content:data.message,onOk:function onOk(){cb();},onCancel:function onCancel(){}});}else{_antd.message.warning(data.message);}}else{cb();}},function(error){_antd.message.warning(error.message);});},onCancel:function onCancel(){}});}else{_ecCom.WeaTools.callApi('/api/hrm/resource/hrmResourceCheck','GET',(0,_extends3.default)({lastname:lastname,workcode:workcode,managerid:managerid})).then(function(data){if(data.status=='-1'){if(data.messagetype=='confirm'){confirm({title:_i18n.i18n.confirm.systemhints(),content:data.message,onOk:function onOk(){cb();},onCancel:function onCancel(){}});}else{_antd.message.warning(data.message);}}else{cb();}},function(error){_antd.message.warning(error.message);});}}}else{if((0,_util.validate)(this['conditionInfo'+this.current],formParams)){cb();}}}},{key:'saveFull',value:function saveFull(){var formParams=this.formFull.getFormParams();if(!this.checkPassword())return false;this.doSaveFull();}},{key:'doSaveFull',value:function doSaveFull(){var _this7=this;var canSave=this.canSave;if(canSave){this.canSave=false;var pDatas=this.formFull.getFormParams();var saveAndNew=this.saveAndNew;var tableInfo1=this.tableInfo1;var tableInfo2=this.tableInfo2;tableInfo1&&tableInfo1.forEach(function(t){t.tabinfo.datas=t.tabinfo.datas||[];pDatas[t.tabinfo.rownum]=t.tabinfo.datas.length;t.tabinfo&&t.tabinfo.datas&&t.tabinfo.datas.forEach(function(item,index){!(0,_isEmpty2.default)(item)&&(0,_forEach2.default)(item,function(value,key){pDatas[key+'_'+index]=value;});});});tableInfo2&&tableInfo2.forEach(function(t){t.tabinfo.datas=t.tabinfo.datas||[];pDatas[t.tabinfo.rownum]=t.tabinfo.datas.length;t.tabinfo&&t.tabinfo.datas&&t.tabinfo.datas.forEach(function(item,index){!(0,_isEmpty2.default)(item)&&(0,_forEach2.default)(item,function(value,key){pDatas[key+'_'+index]=value;});});});_ecCom.WeaTools.callApi('/api/hrm/resource/add/save','POST',pDatas).then(function(data){_this7.canSave=true;if(data.status=='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this7.conditionInfo0=[];_this7.conditionInfo1=[];_this7.conditionInfo2=[];_this7.conditionInfo3=[];_this7.tableInfo1=[];_this7.tableInfo2=[];_this7.passwordComplexity="0";_this7.minpasslen=1;_this7.hrmId='';_this7.fullVisible=false;_this7.update();}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}}},{key:'updateKey',value:function updateKey(){var formParams=this.formFull.getFormParams();var needusb=formParams.userUsbType;if(needusb=="2"){var returnstr=this.getUserName()||'';if(returnstr!=""){this.formFull.updateFields({loginid:{name:'loginid',value:returnstr}});}}else if(needusb=="3"){this.bindTokenKey();}}},{key:'bindTokenKey',value:function bindTokenKey(){var hrmId=this.hrmId.hrmId;var url="/login/bindTokenKey.jsp?requestFrom=system&userid="+hrmId;var redirectUrl=url;var width=800;var height=600;var szFeatures="top=0,";szFeatures+="left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";//channelmode
window.open(redirectUrl,"",szFeatures);}},{key:'getUserName',value:function getUserName(){try{var _vbsserial="";var _hCard=htactx.OpenDevice(1);//打开设备
if(_hCard==0){_antd.message.warning(getLabel('21607',"请确认您已经正确地安装了驱动程序并插入了usb令牌"));return _vbsserial;}try{_vbsserial=htactx.GetUserName(_hCard);//获取用户名
htactx.CloseDevice(_hCard);return _vbsserial;}catch(e){_antd.message.warning(getLabel('21607',"请确认您已经正确地安装了驱动程序并插入了usb令牌")+'2');htactx.CloseDevice(_hCard);return _vbsserial;}}catch(e){_antd.message.warning(getLabel('21607',"请确认您已经正确地安装了驱动程序并插入了usb令牌"));htactx.CloseDevice(hCard);return vbsserial;}}},{key:'doSave',value:function doSave(){var _this8=this;var canSave=this.canSave;if(canSave){this.canSave=false;var saveAndNew=this.saveAndNew;var formParams=this.formSimple.getFormParams();_ecCom.WeaTools.callApi('/api/hrm/resource/add/save','POST',(0,_extends3.default)({type:'simple'},toJS(formParams))).then(function(data){_this8.canSave=true;if(data.status=='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());if(!saveAndNew){_this8.simpleVisible=false;}else{_this8.conditionInfo=[];_this8.getHrmResourceAddForm({'type':'simple'});}_this8.update();}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}}},{key:'onTabChange',value:function onTabChange(key){var current=this.current;if(current===1)this.tabkey1=key;if(current===2)this.tabkey2=key;}},{key:'tableEditChange',value:function tableEditChange(data){var current=this.current;var tabkey1=this.tabkey1;var tabkey2=this.tabkey2;var tableInfo1=this.tableInfo1;var tableInfo2=this.tableInfo2;var tableInfo=void 0,key=void 0;if(current===1){key=tabkey1||0;tableInfo1=toJS(tableInfo1);tableInfo=(0,_cloneDeep2.default)(tableInfo1);tableInfo[Number(key)].tabinfo.datas=data;this.tableInfo1=tableInfo;}if(current===2){key=tabkey2||0;tableInfo2=toJS(tableInfo2);tableInfo=(0,_cloneDeep2.default)(tableInfo2);tableInfo[Number(key)].tabinfo.datas=data;this.tableInfo2=tableInfo;}}},{key:'doSaveAndNew',value:function doSaveAndNew(){this.saveAndNew=true;this.save();}},{key:'openFullmode',value:function openFullmode(){this.conditionInfo=[];this.simpleVisible=false;this.fullVisible=true;}},{key:'checkPassword',value:function checkPassword(){var passwordComplexity=this.passwordComplexity;var minpasslen=this.minpasslen;var formParams={};if(this.simpleVisible){formParams=this.formSimple.getFormParams();}else{formParams=this.formFull.getFormParams();}var loginid=formParams.loginid||'';//登录名
var cs=formParams.password||'';//新密码
var cs1=formParams.password1||'';//确认密码
var checkpass=true;if(cs=='')return checkpass;if(formParams.loginid&&loginid==''){_antd.message.warning(getLabel('386412',"登录名不能为空!"));return false;}if(cs.length<minpasslen){_antd.message.warning(getLabel('386413',"密码长度不能小于")+minpasslen);return false;}if(cs!=cs1){_antd.message.warning(getLabel('386414',"密码确认不正确"));return false;}if(passwordComplexity=="1"){var complexity11=/[a-z]+/;var complexity12=/[A-Z]+/;var complexity13=/\d+/;if(cs!=""){if(complexity11.test(cs)&&complexity12.test(cs)&&complexity13.test(cs)){checkpass=true;}else{_antd.message.warning(getLabel('31863',"新密码不符合要求，必须为字母大写、字母小写、数字组合！请重新输入！"));checkpass=false;}}}else if(passwordComplexity=="2"){var complexity21=/[a-zA-Z_]+/;var complexity22=/\W+/;var complexity23=/\d+/;if(cs!=""){if(complexity21.test(cs)&&complexity22.test(cs)&&complexity23.test(cs)){checkpass=true;}else{_antd.message.warning(getLabel('83716',"新密码不符合要求，必须为字母、数字、特殊字符组合！请重新输入！"));checkpass=false;}}}return checkpass;}},{key:'calYear',value:function calYear(startdate){var value=0.00;if(startdate){var beginTime=new Date(startdate).getTime();var endTime=new Date(this.getToday()).getTime();if(endTime>beginTime){value=((endTime-beginTime)/(24*3600*1000*365.0)).toFixed(2);}}return value;}},{key:'formatDate',value:function formatDate(date){var yy=date.getFullYear();var mm=date.getMonth()+1;var dd=date.getDate();return yy+"-"+this.adjust(mm)+"-"+this.adjust(dd);}},{key:'adjust',value:function adjust(num){if(num<10){return"0"+num;}else{return""+num;}}}]);return HrmAdd;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'title',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _i18n.i18n.module.createResource;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'hasRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'verified',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'simpleVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'fullVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'formSearch',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'formSimple',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'formFull',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'condition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'showSearchAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'searchParamsAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'dataKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'passwordComplexity',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"0";}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'minpasslen',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'canSave',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'hrmId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'conditionInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'saveAndNew',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'updateScroll',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'current',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'conditionInfo0',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'conditionInfo1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'conditionInfo2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'conditionInfo3',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'tableInfo1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'tableInfo2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'tabInfo1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'tabInfo2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'tabkey1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'tabkey2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor33=_applyDecoratedDescriptor(_class.prototype,'departmentid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'getData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getData'),_class.prototype)),_class);

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getHrmResourceAddForm=exports.getSearchList=exports.getSearchCondition=exports.hasRight=undefined;var _ecCom=__webpack_require__(0);var hasRight=exports.hasRight=function hasRight(){return _ecCom.WeaTools.callApi('/api/hrm/resource/add/hasRight','GET');};var getSearchCondition=exports.getSearchCondition=function getSearchCondition(){return _ecCom.WeaTools.callApi('/api/hrm/search/getHrmSearchCondition','GET');};var getSearchList=exports.getSearchList=function getSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/search/getHrmSearchResult','POST',params);};var getHrmResourceAddForm=exports.getHrmResourceAddForm=function getHrmResourceAddForm(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _ecCom.WeaTools.callApi('/api/hrm/resource/add/getHrmResourceAddForm','GET',params);};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmSystemInfo=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14;var _antd=__webpack_require__(6);var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _comsMobx=__webpack_require__(10);var _systeminfo=__webpack_require__(621);var API=_interopRequireWildcard(_systeminfo);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _isNaN2=__webpack_require__(622);var _isNaN3=_interopRequireDefault(_isNaN2);var _ecCom=__webpack_require__(0);var _pulicFunc=__webpack_require__(23);var PublicFunc=_interopRequireWildcard(_pulicFunc);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var toJS=mobx.toJS;var HrmSystemInfo=exports.HrmSystemInfo=(_class=function(){function HrmSystemInfo(){(0,_classCallCheck3.default)(this,HrmSystemInfo);this.title=_i18n.i18n.label.sysInfo;this.viewDate=new _moment2.default().format('YYYY-MM-DD');this.pickerValue=new _moment2.default().add(1,'day').format('YYYY-MM-DD');_initDefineProp(this,'hrmId',_descriptor,this);_initDefineProp(this,'isEditor',_descriptor2,this);_initDefineProp(this,'checkValue',_descriptor3,this);_initDefineProp(this,'inputVlaue',_descriptor4,this);_initDefineProp(this,'selectValue',_descriptor5,this);_initDefineProp(this,'form',_descriptor6,this);_initDefineProp(this,'buttons',_descriptor7,this);_initDefineProp(this,'formFields',_descriptor8,this);_initDefineProp(this,'settings',_descriptor9,this);_initDefineProp(this,'weekInfo',_descriptor10,this);_initDefineProp(this,'date',_descriptor11,this);_initDefineProp(this,'isSelef',_descriptor12,this);_initDefineProp(this,'options',_descriptor13,this);_initDefineProp(this,'bodyConf',_descriptor14,this);}(0,_createClass3.default)(HrmSystemInfo,[{key:'init',value:function init(){this.isEditor=false;this.checkValue='0';this.inputVlaue='';this.selectValue='0';this.form=new _comsMobx.WeaForm();this.buttons={};this.formFields=[];this.settings={};this.weekInfo={};}},{key:'getFormField',value:function getFormField(){var _this=this;var params={id:this.hrmId};API.getFormField(params).then(function(data){_this.buttons=data.buttons;_this.formFields=data.condition;_this.checkValue=data.needauto,_this.pickerValue=data.enableDate,_this.selectValue=data.enableUsbType,_this.inputVlaue=data.enableDate&&data.enableDate!=''&&(0,_moment2.default)(data.enableDate).diff((0,_moment2.default)(),'days')+1,_this.settings=data.settings;_this.isSelef=data.isSelef;_this.form.initFormFields(data.condition);});}},{key:'getWeekInfo',value:function getWeekInfo(v){var _this2=this;var params={id:this.hrmId,datefrom:v};API.getWeekInfo(params).then(function(data){_this2.weekInfo=data;});}},{key:'getDateLabel',value:function getDateLabel(){var str=this.viewDate;if(new _moment2.default().format('YYYY-MM-DD')==this.viewDate)str='今天';return str;}},{key:'onCheckChange',value:function onCheckChange(v){this.checkValue=v;}},{key:'onInputChange',value:function onInputChange(v){if(v&&!(0,_isNaN3.default)(parseInt(v))&&parseInt(v)>0){this.inputVlaue=v;this.pickerValue=new _moment2.default().add(parseInt(v),'day').format('YYYY-MM-DD');}else{this.inputVlaue='';}}},{key:'onPickerChange',value:function onPickerChange(v){this.pickerValue=v;this.inputVlaue=(0,_moment2.default)(v).diff((0,_moment2.default)(),'days')+1;}},{key:'onSelectChange',value:function onSelectChange(v){this.selectValue=v;}},{key:'edit',value:function edit(){var _this3=this;var formParams=this.getFormParams();var usbState=formParams.usbstate||'';this.formFields&&this.formFields.forEach(function(c){c.items.forEach(function(field){var domkey=field.domkey[0]||'';if(usbState=='0'&&(domkey=='tokenKey'||domkey=='serial')||domkey==='validatecode'){field.viewAttr=3;}else{field.viewAttr=2;}if(field.conditionType=='BROWSER'){field.browserConditionParam.viewAttr=2;}if(domkey==='classification'&&_this3.isSelef){field.viewAttr=1;}});});this.isEditor=true;}},{key:'doSave',value:function doSave(){var formParams=this.form.getFormParams();var userUsbType=formParams.userUsbType||'';var usbstate=formParams.usbstate||'';var tokenKey=formParams.tokenKey||'';var hrmId=this.hrmId;if(!this.beforeSave())return false;var __this=this;if(userUsbType=="3"&&usbstate!="1"&&tokenKey!=""){//动态令牌
var params={};params.id=hrmId;params.tokenKey=tokenKey;_ecCom.WeaTools.callApi('/api/hrm/sysadmin/checkIsUsed','POST',params).then(function(data){if(data.isUsed){_antd.message.warning('令牌序列号已经绑定给'+data.lastname+'，不能重复绑定！');}else{__this.doAjaxSave();}});}else{__this.doAjaxSave();}}},{key:'doAjaxSave',value:function doAjaxSave(){var _this4=this;var hrmId=this.hrmId;var formParams=this.form.getFormParams();var params={needauto:this.checkValue,enableDate:this.pickerValue,enableUsbType:this.selectValue};params=(0,_extends3.default)({id:hrmId},params,formParams);var validatecode=formParams.validatecode;if(!validatecode){_antd.message.warning(getLabel(386319,'必填字段不完整！'));return;}API.doSave(params).then(function(data){if(data.status=='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this4.isEditor=false;_this4.getFormField();_this4.form.updateFields({validatecode:{value:''}});}else{_antd.message.warning(data.message);}_this4.date=new Date();},function(error){_antd.message.warning(error.message);});}},{key:'backCard',value:function backCard(){this.form.updateFields({validatecode:{value:''}});var hrmId=this.hrmId;this.isEditor=false;this.getFormField({hrmId:hrmId});}},{key:'updateKey',value:function updateKey(){var formParams=this.form.getFormParams();var needusb=formParams.userUsbType||'';if(needusb=="2"){var returnstr=PublicFunc.getUserName()||'';if(returnstr!=""){form.updateFields((0,_extends3.default)({},formParams,{loginid:{name:'loginid',value:returnstr}}));}}else if(needusb=="3"){this.bindTokenKey();}}},{key:'bindTokenKey',value:function bindTokenKey(){var hrmId=this.hrmId;var title="";var url="/spa/hrm/index_mobx.html#/main/hrm/BindTokenKey?requestFrom=system&userid="+hrmId;var dialog=ecCom.WeaTools.createDialog({title:title,url:url,style:{width:700,height:365}});dialog.show();}},{key:'beforeSave',value:function beforeSave(){var formParams=this.form.getFormParams();var userAgent=navigator.userAgent;//取得浏览器的userAgent字符串
var isOpera=userAgent.indexOf("Opera")>-1;//判断是否Opera浏览器
var isIE=userAgent.indexOf("compatible")>-1&&userAgent.indexOf("MSIE")>-1&&!isOpera;//判断是否IE浏览器
var userUsbType=formParams.userUsbType||'';var usbstate=formParams.usbstate||'';var serial=formParams.serial||'';var tokenKey=formParams.tokenKey||'';var loginid=formParams.loginid||'';var email=formParams.email||'';var needauto=this.checkValue||'';var enableDate=this.pickerValue||'';var username="";if(userUsbType==2){if(!isIE){_antd.message.warning("您的浏览器不支持修改使用海泰key的账号密码，请使用IE浏览器");return false;}//读取硬件usbkey赋值
username=PublicFunc.getUserName();if(username=='')return false;}if(usbstate!="1"){var flag=true;if(userUsbType=="2"&&serial==""){flag=false;}else if(userUsbType=="3"&&tokenKey==""){flag=false;}if(!flag){_antd.message.warning(_i18n.i18n.message.requireFieldNone());return false;}}if(needauto=='1'&&enableDate==''){_antd.message.warning(_i18n.i18n.message.requireFieldNone());return false;}if(tokenKey!=""&&(!this.isdigit(tokenKey)||tokenKey.length!=10)){_antd.message.warning(getLabel(387344,"令牌序列号必须为10位数字！"));return false;}if(loginid.indexOf(" ")!=-1||loginid.indexOf(";")!=-1||loginid.indexOf("--")!=-1||loginid.indexOf("'")!=-1){_antd.message.warning(getLabel(387345,"登录名中不能有“空格、分号、--、单引号”字符"));return false;}if("2"==userUsbType){//海泰key
if(loginid!=username){_antd.message.warning(getLabel(387346,"系统用户名与Key中的不匹配！"));return false;}}if(!this.checkPassword())return false;if(!PublicFunc.chkMail(email))return false;return true;}},{key:'isdigit',value:function isdigit(s){var r,re;re=/\d*/i;//\d表示数字,*表示匹配多个数字
r=s.match(re);return r==s?true:false;}},{key:'checkPassword',value:function checkPassword(){var formParams=this.form.getFormParams();var cs=formParams.password||'';//新密码
var cs1=formParams.password1||'';//确认密码
var passwordComplexity=this.settings.passwordComplexity;var minpasslen=this.settings.minpasslen;var checkpass=true;if(cs==''||cs=="qwertyuiop")return checkpass;if(cs.length<minpasslen){_antd.message.warning(getLabel(387347,"密码长度不能小于")+minpasslen);return false;}if(cs!=cs1){_antd.message.warning(getLabel(387351,"密码确认不正确"));return false;}if(passwordComplexity=="1"){var complexity11=/[a-z]+/;var complexity12=/[A-Z]+/;var complexity13=/\d+/;if(cs!=""){if(complexity11.test(cs)&&complexity12.test(cs)&&complexity13.test(cs)){checkpass=true;}else{_antd.message.warning(getLabel(387352,"新密码不符合要求，必须为字母大写、字母小写、数字组合！请重新输入！"));checkpass=false;}}}else if(passwordComplexity=="2"){var complexity21=/[a-zA-Z_]+/;var complexity22=/\W+/;var complexity23=/\d+/;if(cs!=""){if(complexity21.test(cs)&&complexity22.test(cs)&&complexity23.test(cs)){checkpass=true;}else{_antd.message.warning(getLabel(387353,"新密码不符合要求，必须为字母、数字、特殊字符组合！请重新输入！"));checkpass=false;}}}return checkpass;}},{key:'onPickerHandler',value:function onPickerHandler(v){v=new _moment2.default(v).format('YYYY-MM-DD');this.getWeekInfo(v);this.viewDate=v;}},{key:'getFormParams',value:function getFormParams(){return this.form.getFormParams();}}]);return HrmSystemInfo;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'hrmId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'isEditor',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'checkValue',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'inputVlaue',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'selectValue',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'buttons',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'formFields',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'settings',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'weekInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Date();}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'isSelef',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'options',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[{key:'0',showname:'启用'},{key:'2',showname:'网段策略'}];}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'bodyConf',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[{title:'签到信息',icon:'icon-Human-resources-Sign-in-information',fields:['signintime','signinip'],isRow:false,fieldsConf:[{title:'时间',icon:'icon-Human-resources-late'},{title:'IP',icon:'icon-Human-resources-IP',isIp:true}]},{title:'签退信息',icon:'icon-Human-resources-Sign-out',fields:['signouttime','signoutip'],isRow:false,fieldsConf:[{title:'时间',icon:'icon-Human-resources-late'},{title:'IP',icon:'icon-Human-resources-IP',isIp:true}]},{title:'微博填写',icon:'icon-Human-resources-micro-blog',fields:['blogcreated'],isRow:true,fieldsConf:[{title:'时间',icon:'icon-Human-resources-late'}]},{title:'出差信息',icon:'icon-Human-resources-business-travel',fields:['businesstravelbegin','businesstravelend'],isRow:false,fieldsConf:[{title:'开始',icon:'icon-Human-resources-late'},{title:'结束',icon:'icon-Human-resources-late'}]},{title:'移动签到',icon:'icon-Human-resources-Mobile-sign-in',fields:['mobilesignaddr'],isRow:true,fieldsConf:[{title:'地址',icon:'icon-Human-resources-Mobile-sign-in'}]}];}}),_applyDecoratedDescriptor(_class.prototype,'init',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'init'),_class.prototype)),_class);

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.doSave=exports.getWeekInfo=exports.getFormField=undefined;var _ecCom=__webpack_require__(0);var getFormField=exports.getFormField=function getFormField(params){return _ecCom.WeaTools.callApi('/api/hrm/systeminfo/getHrmSystemInfoForm','GET',params);};var getWeekInfo=exports.getWeekInfo=function getWeekInfo(params){return _ecCom.WeaTools.callApi('/api/hrm/systeminfo/getWeekInfo','GET',params);};var doSave=exports.doSave=function doSave(params){return _ecCom.WeaTools.callApi('/api/hrm/systeminfo/save','POST',params);};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(623);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(82),
    isObjectLike = __webpack_require__(55);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmAddGroup=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12;var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _addgroup=__webpack_require__(625);var Api=_interopRequireWildcard(_addgroup);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmAddGroup=exports.HrmAddGroup=(_class=function(){function HrmAddGroup(){(0,_classCallCheck3.default)(this,HrmAddGroup);_initDefineProp(this,'condition',_descriptor,this);_initDefineProp(this,'form',_descriptor2,this);_initDefineProp(this,'hrmId',_descriptor3,this);_initDefineProp(this,'btnName1',_descriptor4,this);_initDefineProp(this,'btnName2',_descriptor5,this);this.title=function(){return getLabel('386431',"我的常用组");};_initDefineProp(this,'columns1',_descriptor6,this);_initDefineProp(this,'dataSource1',_descriptor7,this);_initDefineProp(this,'columns2',_descriptor8,this);_initDefineProp(this,'dataSource2',_descriptor9,this);_initDefineProp(this,'groupid',_descriptor10,this);_initDefineProp(this,'key',_descriptor11,this);_initDefineProp(this,'authority',_descriptor12,this);}(0,_createClass3.default)(HrmAddGroup,[{key:'getForm',value:function getForm(){var _this=this;var params={cmd:'hrmgroups'};Api.getSearchCondition(params).then(function(data){_this.setBtnName('1',data.btn1);_this.setBtnName('2',data.btn2);_this.condition=data.condition;_this.form.initFormFields(data.condition);});}},{key:'getTableInfo',value:function getTableInfo(){var _this2=this;var params={cmd:'hrmCardGroup',id:this.hrmId};Api.getSearchResult(params).then(function(data){if(data.authority)_this2.setAuthorityStatus(data.authority);if(data.groupName)_this2.setTitle(data.groupName);if(data.priGroup&&data.priGroup.columns)_this2.setColumns('1',data.priGroup.columns);if(data.priGroup&&data.priGroup.items)_this2.setDataSource('1',data.priGroup.items);if(data.pubGroup&&data.pubGroup.columns)_this2.setColumns('2',data.pubGroup.columns);if(data.pubGroup&&data.pubGroup.items)_this2.setDataSource('2',data.pubGroup.items);});}},{key:'add',value:function add(){var _this3=this;var formParams=this.form.getFormParams();if(!formParams.groupsid){_antd.message.warning(getLabel('386432',"请选择常用组！"));return false;}var params={cmd:'addGroups',method:'addGroups',groupid:formParams.groupsid,userid:this.hrmId};Api.save(params).then(function(data){if(data.status==1){_antd.message.success(data.message);_this3.getTableInfo();_this3.form.reset();}else{_antd.message.warning(data.message);}});}},{key:'delete',value:function _delete(){var params={cmd:'delGroup',method:'delGroup',groupid:this.groupid,userid:this.hrmId};Api.deleteTableRow(params).then(function(data){if(data.status=='1'){_antd.message.success(data.message);}else{_antd.message.warning(data.message);}});}},{key:'setHrmId',value:function setHrmId(hrmId){this.hrmId=hrmId;}},{key:'setBtnName',value:function setBtnName(arg,btnName){if(arg=='1')this.btnName1=btnName;if(arg=='2')this.btnName2=btnName;}},{key:'setColumns',value:function setColumns(arg,columns){if(arg=='1')this.columns1=columns;if(arg=='2')this.columns2=columns;}},{key:'setDataSource',value:function setDataSource(arg,dataSource){if(arg=='1')this.dataSource1=dataSource;if(arg=='2')this.dataSource2=dataSource;}},{key:'setTitle',value:function setTitle(title){this.title=title;}},{key:'setGroupId',value:function setGroupId(groupid){this.groupid=groupid;}},{key:'setKey',value:function setKey(key){this.key=key;}},{key:'setAuthorityStatus',value:function setAuthorityStatus(bool){this.authority=bool;}}]);return HrmAddGroup;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'condition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'hrmId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'btnName1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'添加';}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'btnName2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'常用组设置';}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'columns1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'dataSource1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'columns2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'dataSource2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'groupid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'key',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'authority',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'getForm',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getForm'),_class.prototype)),_class);

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getSearchResult=exports.deleteTableRow=exports.save=exports.getSearchCondition=undefined;var _ecCom=__webpack_require__(0);var getSearchCondition=exports.getSearchCondition=function getSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/group/getSearchCondition','GET',params);};var save=exports.save=function save(params){return _ecCom.WeaTools.callApi('/api/hrm/group/save','POST',params);};var deleteTableRow=exports.deleteTableRow=function deleteTableRow(params){return _ecCom.WeaTools.callApi('/api/hrm/group/delete','POST',params);};var getSearchResult=exports.getSearchResult=function getSearchResult(params){return _ecCom.WeaTools.callApi('/api/hrm/group/getSearchResult','POST',params);};

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmPerStatusReport=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28;var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _report=__webpack_require__(264);var Api=_interopRequireWildcard(_report);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var TableStore=_comsMobx.WeaTableNew.TableStore;var HrmPerStatusReport=exports.HrmPerStatusReport=(_class=function(){function HrmPerStatusReport(){(0,_classCallCheck3.default)(this,HrmPerStatusReport);_initDefineProp(this,'condition1',_descriptor,this);_initDefineProp(this,'params',_descriptor2,this);_initDefineProp(this,'countDatas',_descriptor3,this);_initDefineProp(this,'option1',_descriptor4,this);_initDefineProp(this,'option2',_descriptor5,this);_initDefineProp(this,'tabKey',_descriptor6,this);_initDefineProp(this,'interval',_descriptor7,this);_initDefineProp(this,'title',_descriptor8,this);_initDefineProp(this,'isIntervalShow',_descriptor9,this);_initDefineProp(this,'pathname',_descriptor10,this);_initDefineProp(this,'deadline',_descriptor11,this);_initDefineProp(this,'linkName',_descriptor12,this);this.chartTitle1=_i18n.i18n.label.ranking;this.chartTitle2=_i18n.i18n.label.ranking;_initDefineProp(this,'isEchartsShow',_descriptor13,this);_initDefineProp(this,'isLeftEchartsShow',_descriptor14,this);_initDefineProp(this,'isRightEchartsShow',_descriptor15,this);_initDefineProp(this,'visible',_descriptor16,this);_initDefineProp(this,'cmd',_descriptor17,this);_initDefineProp(this,'tableStore',_descriptor18,this);_initDefineProp(this,'strokeColor',_descriptor19,this);_initDefineProp(this,'searchCondition',_descriptor20,this);_initDefineProp(this,'href',_descriptor21,this);_initDefineProp(this,'ids',_descriptor22,this);_initDefineProp(this,'yAxisData',_descriptor23,this);_initDefineProp(this,'linkList',_descriptor24,this);_initDefineProp(this,'paramsStr',_descriptor25,this);_initDefineProp(this,'winWidth',_descriptor26,this);_initDefineProp(this,'isApiOneFinished',_descriptor27,this);_initDefineProp(this,'isApiTwoFinished',_descriptor28,this);}(0,_createClass3.default)(HrmPerStatusReport,[{key:'getSearchCondition',value:function getSearchCondition(){var _this=this;var params={cmd:'baseStatus'};Api.getSearchCondition(params).then(function(data){_this.condition1=data.items;_this.setApiOneFinishedStatus(true);});}},{key:'setParams',value:function setParams(params){this.params=params;if(params.dateselect=='6'&&(!params.fromdate||!params.enddate)){return false;}if(params.company=='1'&&!params.subcompanyid){return false;}if(params.company=='2'&&!params.departmentid){return false;}if(params.local=='1'&&!params.location){return false;}this.getData();}},{key:'getData',value:function getData(tag){var _this2=this;var cmd=void 0;if(!tag){cmd=this.getWholeCmd(this.pathname,this.tabKey);}else{if(tag=='left')cmd='JobGroupRpDetail';if(tag=='right')cmd='JobActivityRpDetail';if(tag=='departmentStatistics')cmd='DepartmentRpAll';if(tag=='postStatistics')cmd='JobRpAll';if(tag=='search')cmd=this.cmd;this.setVisible(true);}var p=(0,_extends3.default)({cmd:cmd},this.params);if(this.searchCondition){p.keyword=this.searchCondition;this.objToStr((0,_extends3.default)({},this.params,{keyword:this.searchCondition}));}if(this.pathname=='basicConditionAnalysis'&&(this.tabKey=='1'||this.tabKey=='3'||this.tabKey=='7')&&!this.nonZeroVerification()){p.agearea=this.interval;}this.setCmd(cmd);this.setHref('/api/hrm/resourceState/downloadExcel?cmd='+this.getHref()+this.paramsStr);this.setStrokeColor(this.getColor());this.objToStr(this.params);Api.getSearchResult(p).then(function(data){if(!data){_antd.message.warning(_i18n.i18n.message.dataNone());return false;}_this2.setApiTwoFinishedStatus(true);if(data.sessionkey){_this2.tableStore.getDatas(data.sessionkey,1);return false;}if(data.countDatas){_this2.setCountDatas(data.countDatas);}if(data.linkList){_this2.linkList=data.linkList;}if(_this2.pathname=='departmentStatistics'&&data.option&&data.option.yAxis){data.option.yAxis.triggerEvent=true;_this2.setIds(_this2.getIds(data.option.yAxis.data));_this2.setyAxisData(_this2.getNewYAxisData(data.option.yAxis.data));data.option.yAxis.data=_this2.yAxisData;}if(data.option&&data.option.series&&data.option.series[0].data&&data.option.series[0].data.length>0){if(data.option.xAxis&&data.option.yAxis&&data.option.series[0].type=='bar'){data.option.series[0].barWidth=_this2.setBarWidth(data.option.series[0].data);data.option.series[0].itemStyle=_this2.getItemStyle();data.option.tooltip={};data.option.xAxis.splitLine={show:false};data.option.yAxis.axisLabel=_this2.getAxisLabel();data.option.yAxis.axisPointer=_this2.getAxisPointer();}if(data.option.series[0].type=='pie'){var datas=data.option.series[0].data;for(var i=0;i<datas.length;i++){data.option.series[0].data[i].label=_this2.getLabel();}data.option.tooltip=_this2.getToolTipForPieChart();data.option.series[0].selectedOffset=0;data.option.legend.selectedMode=false;}_this2.setOption(data.option,'1');_this2.setEchartsShowStatus(true);}else{_this2.setEchartsShowStatus(false);}if(data.optionX&&data.optionX.series&&data.optionX.xAxis&&data.optionX.yAxis&&data.optionX.series[0].data&&data.optionX.series[0].data.length>0){data.optionX.series[0].barWidth=_this2.setBarWidth(data.optionX.series[0].data);data.optionX.series[0].itemStyle=_this2.getItemStyle();data.optionX.tooltip={};data.optionX.xAxis.splitLine={show:false};data.optionX.yAxis.axisLabel=_this2.getAxisLabel();data.optionX.yAxis.axisPointer=_this2.getAxisPointer();_this2.setLeftEchartsShowStatus(true);_this2.setOption(data.optionX,'1');}else{_this2.setLeftEchartsShowStatus(false);}if(data.optionY&&data.optionY.series&&data.optionY.xAxis&&data.optionY.yAxis&&data.optionY.series[0].data&&data.optionY.series[0].data.length>0){data.optionY.series[0].barWidth=_this2.setBarWidth(data.optionY.series[0].data);data.optionY.series[0].itemStyle=_this2.getItemStyle();data.optionY.tooltip={};data.optionY.xAxis.splitLine={show:false};data.optionY.yAxis.axisLabel=_this2.getAxisLabel();data.optionY.yAxis.axisPointer=_this2.getAxisPointer();_this2.setRightEchartsShowStatus(true);_this2.setOption(data.optionY,'2');}else{_this2.setRightEchartsShowStatus(false);}if(data.title&&data.title.foottitle){_this2.setDeadLine(data.title.foottitle);}if(data.title&&data.title.btn){_this2.setLinkName(data.title.btn);}if(data.title&&data.title.title){_this2.setChartTitle(data.title.title,'1');}if(data.title&&data.title.leftTitle){_this2.setChartTitle(data.title.leftTitle,'1');}if(data.title&&data.title.rightTitle){_this2.setChartTitle(data.title.rightTitle,'2');}});}},{key:'setBarWidth',value:function setBarWidth(datas){var len=datas.length;switch(len){case 1:return'30%';case 2:return'40%';case 3:return'50%';case 4:return'60%';default:return'80%';}}},{key:'nonZeroVerification',value:function nonZeroVerification(){if(this.tabKey=='1'&&this.interval<0){_antd.message.warning(getLabel('386441',"年龄区间不能小于0！"));return false;}if(this.tabKey=='3'&&this.interval<0){_antd.message.warning(getLabel('386442',"工龄区间不能小于0！"));return false;}if(this.tabKey=='7'&&this.interval<0){_antd.message.warning(getLabel('386443',"职级区间不能小于0！"));return false;}}},{key:'getBasicCmd',value:function getBasicCmd(key){switch(key){case'1':return'AgeRp';case'2':return'SexRp';case'3':return'SeniorityRp';case'4':return'EduRp';case'5':return'WedlockRp';case'6':return'JobCallRp';case'7':return'JobLevelRp';case'10':return'UserKindRp';case'11':return'StatusRp';case'12':return'SecLevelRp';}}},{key:'getWholeCmd',value:function getWholeCmd(pathname,key){switch(pathname){case'basicConditionAnalysis':return this.getBasicCmd(key);case'departmentStatistics':return'DepartmentRp';case'postStatistics':return'JobRp';case'jobStatusStatistics':return'JobActivityAndGroupRp';}}},{key:'getChartTitle',value:function getChartTitle(){switch(this.cmd){case'DepartmentRpAll':return getLabel('386444',"人数最多的部门排名");case'JobRpAll':return getLabel('386445',"人数最多的岗位排名");case'JobGroupRpDetail':return getLabel('386446',"人数最多的职务类别排名");case'JobActivityRpDetail':return getLabel('386447',"人数最多的职务排名");}}},{key:'getTabName',value:function getTabName(){switch(this.tabKey){case'1':return getLabel('386388',"年龄状况");case'2':return getLabel('386389',"性别状况");case'3':return getLabel('386390',"工龄状况");case'4':return getLabel('386391',"学历状况");case'5':return getLabel('469',"婚姻状况");case'6':return getLabel('386392',"职称统计");case'7':return getLabel('386393',"职级统计");case'10':return getLabel('804',"用工性质");case'11':return getLabel('386394',"状态统计");case'12':return getLabel('683',"安全级别");}}},{key:'setKey',value:function setKey(key){this.tabKey=key;if(key=='1'||key=='3'||key=='7'){this.setIntervalShow(true);}else{this.setIntervalShow(false);}if(key=='1')this.setGap('10');if(key=='3')this.setGap('2');if(key=='7')this.setGap('5');}},{key:'getLabel',value:function getLabel(){return{normal:{formatter:['{b} | {c} | {d}%'].join('\n')}};}},{key:'getItemStyle',value:function getItemStyle(){return{normal:{color:'#6FBCEA'}};}},{key:'getAxisPointer',value:function getAxisPointer(){return{formatter:function formatter(params){return params.value;}};}},{key:'getAxisLabel',value:function getAxisLabel(){var that=this;return{formatter:function formatter(value){var len=that.getByteLen(value);if(len>12){return that.getCutStr(value,12)+'...';}else{return value;}}};}},{key:'getToolTipForPieChart',value:function getToolTipForPieChart(){return{trigger:'item',formatter:"{b} : {c} ({d}%)"};}},{key:'getByteLen',value:function getByteLen(val){var len=0;for(var i=0;i<val.length;i++){var a=val.charAt(i);if(a.match(/[^\x00-\xff]/ig)!=null){len+=2;}else{len+=1;}}return len;}},{key:'getCutStr',value:function getCutStr(value,len){var arr=value.split('');var cutArr=[];var count=0;for(var i=0;i<arr.length;i++){if(this.checkIsChinese(arr[i])&&count<len){cutArr.push(arr[i]);count+=2;}if(!this.checkIsChinese(arr[i])&&count<len){cutArr.push(arr[i]);count+=1;}}return cutArr.join('');}},{key:'checkIsChinese',value:function checkIsChinese(val){var reg=new RegExp('[\\u4E00-\\u9FFF]+',"g");if(reg.test(val))return true;}},{key:'pathToTitle',value:function pathToTitle(){switch(this.pathname){case'basicConditionAnalysis':this.setTitle(getLabel('382087',"基本状况分析"));break;case'departmentStatistics':this.setTitle(getLabel('382094',"部门人数统计"));break;case'postStatistics':this.setTitle(getLabel('382095',"岗位人数统计"));break;case'jobStatusStatistics':this.setTitle(getLabel('382096',"职务状况统计"));break;default:this.setTitle(getLabel('386448',"数据统计与分析"));}}},{key:'getColor',value:function getColor(){switch(this.cmd){case'DepartmentRpAll':return'#7DC756';case'JobRpAll':return'#AC7CFF';default:return'#FF7F50';}}},{key:'getHref',value:function getHref(){switch(this.cmd){case'DepartmentRpAll':return'DepartmentRp';case'JobRpAll':return'JobRp';case'JobGroupRpDetail':return'JobGroupRp';case'JobActivityRpDetail':return'JobActivityRp';}}},{key:'isEmptyObject',value:function isEmptyObject(obj){for(var key in obj){return false;}return true;}},{key:'objToStr',value:function objToStr(obj){var str='';if(!this.isEmptyObject(obj)){for(var key in obj){str=str+'&'+key+'='+obj[key];}}this.setParamsStr(str);}},{key:'getIds',value:function getIds(datas){var arr=[];if(!(datas instanceof Array)){return false;}for(var i=0;i<datas.length;i++){var id=datas[i].substring(datas[i].indexOf('{')+1,datas[i].indexOf('}')).split(':')[1];arr.push(id);}return arr;}},{key:'getNewYAxisData',value:function getNewYAxisData(datas){var arr=[];if(!(datas instanceof Array)){return false;}for(var i=0;i<datas.length;i++){var data=datas[i].split('{')[0].replace(/\s+/g,"");arr.push(data);}return arr;}},{key:'getCurWindowWidth',value:function getCurWindowWidth(){var that=this;window.onresize=function(){if(window.innerWidth){that.setWinWidth(window.innerWidth);}else if(document.body&&document.body.clientWidth){that.setWinWidth(document.body.clientWidth);}};}},{key:'setIntervalShow',value:function setIntervalShow(bool){this.isIntervalShow=bool;}},{key:'setCountDatas',value:function setCountDatas(countDatas){this.countDatas=countDatas;}},{key:'setOption',value:function setOption(option,arg){if(arg=='1')this.option1=option;if(arg=='2')this.option2=option;}},{key:'setGap',value:function setGap(interval){this.interval=interval;}},{key:'setTitle',value:function setTitle(title){this.title=title;}},{key:'setDeadLine',value:function setDeadLine(deadline){this.deadline=deadline;}},{key:'setLinkName',value:function setLinkName(linkName){this.linkName=linkName;}},{key:'setChartTitle',value:function setChartTitle(chartTitle,arg){if(arg=='1')this.chartTitle1=chartTitle;if(arg=='2')this.chartTitle2=chartTitle;}},{key:'setEchartsShowStatus',value:function setEchartsShowStatus(bool){this.isEchartsShow=bool;}},{key:'setLeftEchartsShowStatus',value:function setLeftEchartsShowStatus(bool){this.isLeftEchartsShow=bool;}},{key:'setRightEchartsShowStatus',value:function setRightEchartsShowStatus(bool){this.isRightEchartsShow=bool;}},{key:'setPathName',value:function setPathName(pathname){this.pathname=pathname;}},{key:'setVisible',value:function setVisible(bool){this.visible=bool;if(!bool){this.searchConditionReset();}}},{key:'setCmd',value:function setCmd(cmd){this.cmd=cmd;}},{key:'setStrokeColor',value:function setStrokeColor(color){this.strokeColor=color;}},{key:'setSearchCondition',value:function setSearchCondition(condition){this.searchCondition=condition;}},{key:'searchConditionReset',value:function searchConditionReset(){this.searchCondition='';}},{key:'setHref',value:function setHref(href){this.href=href;}},{key:'setIds',value:function setIds(ids){this.ids=ids;}},{key:'setyAxisData',value:function setyAxisData(yAxisData){this.yAxisData=yAxisData;}},{key:'setParamsStr',value:function setParamsStr(str){this.paramsStr=str;}},{key:'setApiOneFinishedStatus',value:function setApiOneFinishedStatus(bool){this.isApiOneFinished=bool;}},{key:'setApiTwoFinishedStatus',value:function setApiTwoFinishedStatus(bool){this.isApiTwoFinished=bool;}},{key:'setWinWidth',value:function setWinWidth(winWidth){this.winWidth=winWidth;}},{key:'optionReset',value:function optionReset(){this.option1={};}},{key:'conditionReset',value:function conditionReset(){this.condition1=[];}},{key:'paramReset',value:function paramReset(){this.params={};}},{key:'apiFinishedStatusReset',value:function apiFinishedStatusReset(){this.isApiOneFinished=false;this.isApiTwoFinished=false;}},{key:'tabKeyReset',value:function tabKeyReset(){this.tabKey='1';}}]);return HrmPerStatusReport;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'condition1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'params',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'countDatas',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'option1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'option2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'tabKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'interval',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'10';}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'title',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'isIntervalShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'pathname',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'basicConditionAnalysis';}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'deadline',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'暂无';}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'linkName',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'更多';}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'isEchartsShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'isLeftEchartsShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'isRightEchartsShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'visible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'cmd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'tableStore',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'strokeColor',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'#FF7F50';}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'searchCondition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'href',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'ids',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'yAxisData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'linkList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'paramsStr',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'winWidth',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'isApiOneFinished',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'isApiTwoFinished',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'getSearchCondition',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getSearchCondition'),_class.prototype)),_class);

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmChangeReport=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33,_descriptor34,_descriptor35,_descriptor36,_descriptor37,_descriptor38,_descriptor39,_descriptor40,_descriptor41,_descriptor42,_descriptor43;var _mobx=__webpack_require__(8);var mobx=_interopRequireWildcard(_mobx);var _report=__webpack_require__(264);var Api=_interopRequireWildcard(_report);var _comsMobx=__webpack_require__(10);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var toJS=mobx.toJS;var TableStore=_comsMobx.WeaTableNew.TableStore;var HrmChangeReport=exports.HrmChangeReport=(_class=function(){function HrmChangeReport(){(0,_classCallCheck3.default)(this,HrmChangeReport);_initDefineProp(this,'params',_descriptor,this);_initDefineProp(this,'condition',_descriptor2,this);_initDefineProp(this,'conditionOfAdSearch',_descriptor3,this);_initDefineProp(this,'singleSearchCondition',_descriptor4,this);_initDefineProp(this,'countDatas',_descriptor5,this);_initDefineProp(this,'option1',_descriptor6,this);_initDefineProp(this,'option2',_descriptor7,this);_initDefineProp(this,'option3',_descriptor8,this);_initDefineProp(this,'pathname',_descriptor9,this);_initDefineProp(this,'deadline',_descriptor10,this);_initDefineProp(this,'linkName',_descriptor11,this);_initDefineProp(this,'title',_descriptor12,this);this.chartTitle1=_i18n.i18n.label.ranking;this.chartTitle2=_i18n.i18n.label.ranking;this.chartTitle3=_i18n.i18n.label.newTypeOfContract;_initDefineProp(this,'dialogTitle',_descriptor13,this);_initDefineProp(this,'isLeftEchartsShow',_descriptor14,this);_initDefineProp(this,'isRightEchartsShow',_descriptor15,this);_initDefineProp(this,'isPieChartsShow',_descriptor16,this);_initDefineProp(this,'visible1',_descriptor17,this);_initDefineProp(this,'visible2',_descriptor18,this);_initDefineProp(this,'tableStore',_descriptor19,this);_initDefineProp(this,'searchCondition',_descriptor20,this);_initDefineProp(this,'ids',_descriptor21,this);_initDefineProp(this,'idsForPie',_descriptor22,this);_initDefineProp(this,'yAxisData',_descriptor23,this);_initDefineProp(this,'nameSet',_descriptor24,this);_initDefineProp(this,'linkList',_descriptor25,this);_initDefineProp(this,'form',_descriptor26,this);_initDefineProp(this,'dpId',_descriptor27,this);_initDefineProp(this,'strokeColor',_descriptor28,this);_initDefineProp(this,'dataKey',_descriptor29,this);_initDefineProp(this,'yearmonth',_descriptor30,this);_initDefineProp(this,'contractTypeId',_descriptor31,this);_initDefineProp(this,'isNeedWeaTab',_descriptor32,this);_initDefineProp(this,'isNeedPieChart',_descriptor33,this);_initDefineProp(this,'tabKey',_descriptor34,this);_initDefineProp(this,'tabDatas',_descriptor35,this);_initDefineProp(this,'winWidth',_descriptor36,this);_initDefineProp(this,'gridData',_descriptor37,this);_initDefineProp(this,'isApiOneFinished',_descriptor38,this);_initDefineProp(this,'isApiTwoFinished',_descriptor39,this);_initDefineProp(this,'isColIdUnusual',_descriptor40,this);_initDefineProp(this,'loading',_descriptor41,this);_initDefineProp(this,'authorized',_descriptor42,this);_initDefineProp(this,'getRight',_descriptor43,this);}//For pie chart
//For pie chart
(0,_createClass3.default)(HrmChangeReport,[{key:'getSearchCondition',value:function getSearchCondition(idf){var _this=this;var params=void 0;if(idf=='radioGroup')params={cmd:this.getCmdForLoadWeaRadioGroup()};if(idf=='adSearch')params={cmd:this.getCmdForLoadAdSearch()};if(this.dpId&&this.pathname!=='transfer')params.departmentid=this.dpId;if(this.dpId&&this.pathname=='transfer'&&this.tabKey=='0')params.departmentIdIn=this.dpId;if(this.dpId&&this.pathname=='transfer'&&this.tabKey=='1')params.departmentIdOut=this.dpId;Api.getSfChangeSearchCondition(params,this.getIdfForSelectInterface()).then(function(data){if(!data){_antd.message.warning(_i18n.i18n.message.dataNone());return false;}_this.setApiOneFinishedStatus(true);//WeaRadioGroup's conditions
if(idf=='radioGroup'&&data.searchCondition){_this.condition=data.searchCondition;}//Advanced search's conditions
if(idf=='adSearch'&&data.searchCondition){_this.conditionOfAdSearch=data.searchCondition;_this.form.initFormFields(data.searchCondition);if(_this.dpId&&_this.pathname!=='transfer')_this.form.updateFields({departmentid:{value:_this.dpId}});//Bring departmentid to params of advanced search
if(_this.dpId&&_this.pathname=='transfer'&&_this.tabKey=='0')_this.form.updateFields({departmentIdIn:{value:_this.dpId}});if(_this.dpId&&_this.pathname=='transfer'&&_this.tabKey=='1')_this.form.updateFields({departmentIdOut:{value:_this.dpId}});}});}},{key:'getEchartsRelatedData',value:function getEchartsRelatedData(){var _this2=this;var cmd=this.getCmdForLoadPageContent();var p=(0,_extends3.default)({cmd:cmd},this.params);Api.getSfChangeSearchResult(p,this.getIdfForSelectInterface()).then(function(data){if(!data){_antd.message.warning(_i18n.i18n.message.dataNone());return false;}_this2.setApiTwoFinishedStatus(true);if(data.countDatas){_this2.setCountDatas(data.countDatas);}if(data.linkList){_this2.linkList=data.linkList;}//Filter yAxis data of left chart
if(data.optionX&&data.optionX.yAxis&&data.optionX.yAxis.data){var datas=data.optionX.yAxis.data;data.optionX.yAxis.triggerEvent=true;_this2.setIds(_this2.getIds(datas),'bar');_this2.setyAxisData(_this2.getNewYAxisData(datas),'bar');data.optionX.yAxis.data=_this2.yAxisData;}//Determine the left chart is show or not
if(data.optionX&&data.optionX.series&&data.optionX.xAxis&&data.optionX.yAxis&&data.optionX.series[0].data&&data.optionX.series[0].data.length>0){data.optionX.grid=_this2.getGrid();data.optionX.xAxis.splitLine={show:false};data.optionX.yAxis.axisPointer=_this2.getAxisPointer();data.optionX.yAxis.axisLabel=_this2.getAxisLabel();data.optionX.tooltip={};_this2.setGridData(_this2.getGrid());_this2.setLeftEchartsShowStatus(true);_this2.setOption(data.optionX,'1');}else{_this2.setLeftEchartsShowStatus(false);}//Determine the right chart is show or not
if(data.optionY&&data.optionY.series&&data.optionY.xAxis&&data.optionY.yAxis&&data.optionY.series[0].data&&data.optionY.series[0].data.length>0){data.optionY.series[0].label={};data.optionY.grid=_this2.getGrid();data.optionY.xAxis.axisPointer=_this2.getAxisPointer();data.optionY.yAxis.splitLine={show:false};data.optionY.tooltip={};_this2.setRightEchartsShowStatus(true);_this2.setOption(data.optionY,'2');}else{_this2.setRightEchartsShowStatus(false);}//Determine the pie chart is show or not
if(data.optionZ&&data.optionZ.series&&data.optionZ.series[0].data&&data.optionZ.series[0].type=='pie'){var _datas=data.optionZ.series[0].data;var arr=[];for(var i=0;i<_datas.length;i++){arr.push(_datas[i].name);}_this2.setIds(_this2.getIds(arr),'pie');_this2.setyAxisData(_this2.getNewYAxisData(arr),'pie');for(var _i=0;_i<_datas.length;_i++){data.optionZ.series[0].data[_i].label=_this2.getLabel();data.optionZ.series[0].data[_i].name=_this2.nameSet[_i];data.optionZ.legend.data[_i]=_this2.nameSet[_i];}}if(data.optionZ&&data.optionZ.series&&data.optionZ.series[0].data&&data.optionZ.series[0].data.length>0){_this2.setPieChartShowStatus(true);_this2.setOption(data.optionZ,'3');}else{_this2.setPieChartShowStatus(false);}//The following is related to title and something else
if(data.title&&data.title.foottitle){_this2.setDeadLine(data.title.foottitle);}if(data.title&&data.title.btn){_this2.setLinkName(data.title.btn);}if(data.title&&data.title.leftTitle){_this2.setChartTitle(data.title.leftTitle,'1');}if(data.title&&data.title.rightTitle){_this2.setChartTitle(data.title.rightTitle,'2');}if(data.title&&data.title.footLeftTitle){_this2.setChartTitle(data.title.footLeftTitle,'3');}});}},{key:'getTableInfo',value:function getTableInfo(idy,needTbStore){var _this3=this;var p=void 0;var cmd=this.getCmdForLoadTable(idy);var adSearchParams=this.form.getFormParams();//Params of advanced search
//Just click bar chart(left)
if(this.dpId&&this.isEmptyObject(adSearchParams)&&this.pathname!=='transfer'){p=(0,_extends3.default)({cmd:cmd},this.params,{departmentid:this.dpId});}if(this.dpId&&this.isEmptyObject(adSearchParams)&&this.pathname=='transfer'&&this.tabKey=='0'){p=(0,_extends3.default)({cmd:cmd},this.params,{departmentIdIn:this.dpId});}if(this.dpId&&this.isEmptyObject(adSearchParams)&&this.pathname=='transfer'&&this.tabKey=='1'){p=(0,_extends3.default)({cmd:cmd},this.params,{departmentIdOut:this.dpId});}//Just click bar chart(right)
if(this.yearmonth&&this.isEmptyObject(adSearchParams)){p=(0,_extends3.default)({cmd:cmd},this.params,{yearmonth:this.yearmonth});}//Click pie chart
if(this.contractTypeId&&this.isEmptyObject(adSearchParams)){p=(0,_extends3.default)({cmd:cmd},this.params,{contracttypeid:this.contractTypeId});}//Click bar chart, then set search params(left & right & pie)
if(!this.isEmptyObject(adSearchParams)){p=(0,_extends3.default)({cmd:cmd},this.params,adSearchParams);}//Just click more or num(more and num is a link)
if(!this.dpId&&!this.yearmonth&&!this.contractTypeId&&this.isEmptyObject(adSearchParams)&&!this.singleSearchCondition){p=(0,_extends3.default)({cmd:cmd},this.params);}//Click more, then set search params
if(this.singleSearchCondition){p=(0,_extends3.default)({cmd:cmd},this.params,{keyword:this.singleSearchCondition});}//Set progress's color
this.setStrokeColor(this.getColor());Api.getSfChangeSearchResult(p,this.getIdfForSelectInterface()).then(function(data){if(!data){_antd.message.warning(_i18n.i18n.message.dataNone());return false;}if(data.sessionkey){_this3.setSessionKey(data.sessionkey);if(needTbStore){_this3.tableStore=new TableStore();_this3.tableStore.getDatas(data.sessionkey,1);}else{_this3.exportExcel();}}});}},{key:'exportExcel',value:function exportExcel(){if(!this.dataKey){return false;}Api.exportExcel(this.dataKey).then(function(data){if(data.url){_ecCom.WeaTools.downloadFile(data.url,"GET");}});}//Click WeaRadioGroup to get data
},{key:'setParamsThenGetData',value:function setParamsThenGetData(params){if(this.verify(params)){this.params=params;this.getEchartsRelatedData();}}},{key:'verify',value:function verify(params){if(params.dateselect&&params.dateselect=='6'&&!params.year){return false;}if(params.startDateSelect&&params.startDateSelect=='6'&&!params.startYear){return false;}if(params.endDateSelect&&params.endDateSelect=='6'&&!params.endYear){return false;}if(params.company&&params.company=='1'&&!this.isSubCompanyIdExistent(params)){return false;}if(params.company&&params.company=='2'&&!this.isDepartmentIdExistent(params)){return false;}if(params.area1&&params.area1=='1'&&(!params.joblevel||!params.joblevelto)){return false;}if(params.area2&&params.area2=='1'&&(!params.currjoblevel||!params.currjoblevelto)){return false;}return true;}},{key:'isSubCompanyIdExistent',value:function isSubCompanyIdExistent(params){if(this.pathname!=='transfer'&&!params.subcompanyid||this.pathname=='transfer'&&(this.tabKey=='0'&&!params.subcompanyIdIn||this.tabKey=='1'&&!params.subcompanyIdOut)){return false;}return true;}},{key:'isDepartmentIdExistent',value:function isDepartmentIdExistent(params){if(this.pathname!=='transfer'&&!params.departmentid||this.pathname=='transfer'&&(this.tabKey=='0'&&!params.departmentIdIn||this.tabKey=='1'&&!params.departmentIdOut)){return false;}return true;}//Open or close dialog
},{key:'setVisible',value:function setVisible(arg,bool,param){//Click more
if(arg=='1')this.visible1=bool;if(arg=='1'&&bool){//Open
this.getTableInfo('more',true);// this.setDialogtitle(this.chartTitle1.split('(')[0]);
this.setDialogtitle(typeof this.chartTitle1=='function'?this.chartTitle1()+'(top 5)':this.chartTitle1);}if(arg=='1'&&!bool)this.setSingleShConditionReset();//Close
//Click bar chart
if(arg=='2'||arg=='3'||arg=='4'||arg=='5')this.visible2=bool;if(arg=='2'&&bool)this.setDpId(param);if(arg=='3'&&bool)this.setYearAndMonth(param);if(arg=='4'&&bool)this.setContractTypeId(param);if((arg=='2'||arg=='3'||arg=='4'||arg=='5')&&bool){//Open
this.getTableInfo('bar',true);this.getSearchCondition('adSearch');this.setDialogtitle(_i18n.i18n.label.specificInformation());}if((arg=='2'||arg=='3'||arg=='4'||arg=='5')&&!bool){//Close
this.form=new _comsMobx.WeaForm();if(this.dpId)this.dpIdReset();if(this.yearmonth)this.yearmonthReset();if(this.contractTypeId)this.contractTypeIdReset();}if(!bool)this.tableStore=new TableStore();}},{key:'tabClick',value:function tabClick(key){this.tabKey=key;this.apiFinishedStatusReset();this.getSearchCondition('radioGroup');this.getEchartsRelatedData();}},{key:'getSwitchCondition',value:function getSwitchCondition(){var p=void 0;if(this.pathname=='transfer'||this.pathname=='loss'||this.pathname=='contract'){p=this.pathname+'_'+this.tabKey;}else{p=this.pathname;}return p;}//Get id from yAxis data
},{key:'getIds',value:function getIds(datas){var arr=[];if(!(datas instanceof Array)){return false;}for(var i=0;i<datas.length;i++){var id=datas[i].substring(datas[i].indexOf('{')+1,datas[i].indexOf('}')).split(':')[1];arr.push(id);}return arr;}//Get new yAxis data without id, the new yAxis data will show on the page.
},{key:'getNewYAxisData',value:function getNewYAxisData(datas){var arr=[];if(!(datas instanceof Array)){return false;}for(var i=0;i<datas.length;i++){var data=datas[i].split('{')[0].replace(/\s+/g,"");arr.push(data);}return arr;}},{key:'isEmptyObject',value:function isEmptyObject(obj){for(var key in obj){return false;}return true;}//Set pathname, and estimate if the current page need WeaTab or PieChart.
//Last, set tab name when the current page has WeaTab.
},{key:'setPathName',value:function setPathName(pathname){this.pathname=pathname;if(pathname=='transfer'||pathname=='loss'||pathname=='contract'){this.setCurPageIfNeedWeaTab(true);}else{this.setCurPageIfNeedWeaTab(false);}if(pathname=='contract'){this.setCurPageIfNeedPieChart(true);}else{this.setCurPageIfNeedPieChart(false);}if(pathname=='transfer'){var tabDatas=[{key:'0',title:_i18n.i18n.label.intoStatistics()},{key:'1',title:_i18n.i18n.label.outOfStatistics()}];this.setTabDatas(tabDatas);}if(pathname=='loss'){var _tabDatas=[{key:'0',title:_i18n.i18n.label.lossStatistics()},{key:'1',title:_i18n.i18n.label.turnoverStatistics()},{key:'2',title:_i18n.i18n.label.dismissalStatistics()},{key:'3',title:_i18n.i18n.label.retirementStatistics()}];this.setTabDatas(_tabDatas);}if(pathname=='contract'){var _tabDatas2=[{key:'0',title:_i18n.i18n.label.newSignStatistics()},{key:'1',title:_i18n.i18n.label.expiryStatistics()}];this.setTabDatas(_tabDatas2);}}},{key:'getIdfForSelectInterface',value:function getIdfForSelectInterface(){if(this.pathname!=='contract'){return'staff';}return'contract';}},{key:'getLabel',value:function getLabel(){return{normal:{formatter:['{title|{b}}{abg|}',' {rate|{d}%}'].join('\n'),rich:{title:{color:'#666',align:'center'},abg:{width:'100%',align:'right',height:25},rate:{fontFamily:'Times New Roman'}}}};}},{key:'getAxisPointer',value:function getAxisPointer(){return{formatter:function formatter(params){return params.value;}};}},{key:'getAxisLabel',value:function getAxisLabel(){var that=this;return{formatter:function formatter(value){var len=that.getByteLen(value);if(len>12){return that.getCutStr(value,12)+'...';}else{return value;}}};}},{key:'getCutStr',value:function getCutStr(value,len){var arr=value.split('');var cutArr=[];var count=0;for(var i=0;i<arr.length;i++){if(this.checkIsChinese(arr[i])&&count<len){cutArr.push(arr[i]);count+=2;}if(!this.checkIsChinese(arr[i])&&count<len){cutArr.push(arr[i]);count+=1;}}return cutArr.join('');}},{key:'checkIsChinese',value:function checkIsChinese(val){var reg=new RegExp('[\\u4E00-\\u9FFF]+',"g");if(reg.test(val))return true;}},{key:'getGrid',value:function getGrid(){return{bottom:'3%',left:'3%',right:'4%',containLabel:true};}},{key:'getByteLen',value:function getByteLen(val){var len=0;for(var i=0;i<val.length;i++){var a=val.charAt(i);if(a.match(/[^\x00-\xff]/ig)!=null){len+=2;}else{len+=1;}}return len;}},{key:'getCurWindowWidth',value:function getCurWindowWidth(){var that=this;if(window.innerWidth){this.setWinWidth(window.innerWidth);}else if(document.body&&document.body.clientWidth){this.setWinWidth(document.body.clientWidth);}window.onresize=function(){if(window.innerWidth){that.setWinWidth(window.innerWidth);}else if(document.body&&document.body.clientWidth){that.setWinWidth(document.body.clientWidth);}};}},{key:'pathToTitle',value:function pathToTitle(){switch(this.pathname){case'add':this.setTitle(_i18n.i18n.label.newSituation());break;case'confirmation':this.setTitle(_i18n.i18n.label.correction());break;case'transfer':this.setTitle(_i18n.i18n.label.mobility());break;case'renew':this.setTitle(_i18n.i18n.label.renewTheSituation());break;case'rehire':this.setTitle(_i18n.i18n.label.returnOnTheSituation());break;case'loss':this.setTitle(_i18n.i18n.label.lossOfPersonnel());break;case'contract':this.setTitle(_i18n.i18n.label.contractSituation());break;default:this.setTitle(_i18n.i18n.module.resourceChange());}}//Set cmd of querying string parameters
},{key:'getCmdForLoadPageContent',value:function getCmdForLoadPageContent(){var p=this.getSwitchCondition();switch(p){case'add':return'addRp';case'confirmation':return'hireRp';case'transfer_0':return'transferIn';case'transfer_1':return'transferOut';case'renew':return'extendRp';case'rehire':return'rehireRp';case'loss_0':return'lossRp';case'loss_1':return'dismissRp';case'loss_2':return'reFireRp';case'loss_3':return'retireRp';case'contract_0':return'contractNewRp';case'contract_1':return'contractExpRp';}}},{key:'getCmdForLoadWeaRadioGroup',value:function getCmdForLoadWeaRadioGroup(){var p=this.getSwitchCondition();switch(p){case'add':return'addRpBase';case'confirmation':return'hireRpBase';case'transfer_0':return'transferIn';case'transfer_1':return'transferOut';case'renew':return'extendRpBase';case'rehire':return'rehireRpBase';case'loss_0':return'lossRpBase';case'loss_1':return'dismissRpBase';case'loss_2':return'reFireRpBase';case'loss_3':return'retireRpBase';case'contract_0':return'contractNewBase';case'contract_1':return'contractExpBase';}}},{key:'getCmdForLoadAdSearch',value:function getCmdForLoadAdSearch(){switch(this.pathname){case'add':return'addRpAdvance';case'confirmation':return'hireRpAdvance';case'transfer':return'transferRpAdvance';case'renew':return'extendRpAdvance';case'rehire':return'rehireRpAdvance';case'loss':return'lossRpAdvance';case'contract':return'contractRpAdvance';}}},{key:'getCmdForLoadTable',value:function getCmdForLoadTable(idy){var p=this.getSwitchCondition();switch(p+'_'+idy){case'add_bar':return'addRpDetail';case'add_more':return'addRpMore';case'confirmation_bar':return'hireRpDetail';case'confirmation_more':return'hireRpMore';case'transfer_0_bar':return'transferRpDetail';case'transfer_1_bar':return'transferRpDetail';case'transfer_0_more':return'transferInRpMore';case'transfer_1_more':return'transferOutRpMore';case'renew_bar':return'extendRpDetail';case'renew_more':return'extendRpMore';case'rehire_bar':return'rehireRpDetail';case'rehire_more':return'rehireRpMore';case'loss_0_bar':return'lossRpDetail';case'loss_1_bar':return'dismissRpDetail';case'loss_2_bar':return'reFireRpDetail';case'loss_3_bar':return'retireRpDetail';case'loss_0_more':return'lossRpMore';case'loss_1_more':return'dismissRpMore';case'loss_2_more':return'reFireRpMore';case'loss_3_more':return'retireRpMore';case'contract_0_bar':return'contractRpDetail';case'contract_1_bar':return'contractRpDetail';case'contract_0_more':return'contractRpMore';case'contract_1_more':return'contractRpMore';}}},{key:'getColor',value:function getColor(){switch(this.pathname){case'contract':return'#FF6702';default:return'#6FBCEA';}}},{key:'setOption',value:function setOption(option,arg){if(arg=='1')this.option1=option;if(arg=='2')this.option2=option;if(arg=='3')this.option3=option;}},{key:'setChartTitle',value:function setChartTitle(chartTitle,arg){if(arg=='1')this.chartTitle1=chartTitle;if(arg=='2')this.chartTitle2=chartTitle;if(arg=='3')this.chartTitle3=chartTitle;}},{key:'setIds',value:function setIds(ids,idf){if(idf=='bar')this.ids=ids;if(idf=='pie')this.idsForPie=ids;}},{key:'setyAxisData',value:function setyAxisData(data,idf){if(idf=='bar')this.yAxisData=data;if(idf=='pie')this.nameSet=data;}},{key:'setCurPageIfNeedPieChart',value:function setCurPageIfNeedPieChart(bool){this.isNeedPieChart=bool;}},{key:'setCountDatas',value:function setCountDatas(countDatas){this.countDatas=countDatas;}},{key:'setTitle',value:function setTitle(title){this.title=title;}},{key:'setDeadLine',value:function setDeadLine(deadline){this.deadline=deadline;}},{key:'setLinkName',value:function setLinkName(linkName){this.linkName=linkName;}},{key:'setLeftEchartsShowStatus',value:function setLeftEchartsShowStatus(bool){this.isLeftEchartsShow=bool;}},{key:'setRightEchartsShowStatus',value:function setRightEchartsShowStatus(bool){this.isRightEchartsShow=bool;}},{key:'setPieChartShowStatus',value:function setPieChartShowStatus(bool){this.isPieChartsShow=bool;}},{key:'setDialogtitle',value:function setDialogtitle(dialogTitle){this.dialogTitle=dialogTitle;}},{key:'setDpId',value:function setDpId(dpId){this.dpId=dpId;}},{key:'setStrokeColor',value:function setStrokeColor(color){this.strokeColor=color;}},{key:'setSingleSearchCondition',value:function setSingleSearchCondition(val){this.singleSearchCondition=val;}},{key:'setSingleShConditionReset',value:function setSingleShConditionReset(){this.singleSearchCondition='';}},{key:'getDialogTitle',value:function getDialogTitle(){return this.dialogTitle;}},{key:'setSessionKey',value:function setSessionKey(sessionkey){this.dataKey=sessionkey;}},{key:'setYearAndMonth',value:function setYearAndMonth(yearmonth){this.yearmonth=yearmonth;}},{key:'setContractTypeId',value:function setContractTypeId(contractTypeId){this.contractTypeId=contractTypeId;}},{key:'setCurPageIfNeedWeaTab',value:function setCurPageIfNeedWeaTab(bool){this.isNeedWeaTab=bool;}},{key:'setTabDatas',value:function setTabDatas(tabDatas){this.tabDatas=tabDatas;}},{key:'setWinWidth',value:function setWinWidth(winWidth){this.winWidth=winWidth;}},{key:'setApiOneFinishedStatus',value:function setApiOneFinishedStatus(bool){this.isApiOneFinished=bool;}},{key:'setApiTwoFinishedStatus',value:function setApiTwoFinishedStatus(bool){this.isApiTwoFinished=bool;}},{key:'setGridData',value:function setGridData(gridData){this.gridData=gridData;}},{key:'setColIdUnusualStatus',value:function setColIdUnusualStatus(){if(this.pathname=='transfer'){this.isColIdUnusual=true;}else{this.isColIdUnusual=false;}}},{key:'dpIdReset',value:function dpIdReset(){this.dpId='';}},{key:'yearmonthReset',value:function yearmonthReset(){this.yearmonth='';}},{key:'contractTypeIdReset',value:function contractTypeIdReset(){this.contractTypeId='';}},{key:'optionReset',value:function optionReset(){this.option1={};this.option2={};this.option3={};}},{key:'conditionReset',value:function conditionReset(){this.condition=[];}},{key:'paramReset',value:function paramReset(){this.params={};}},{key:'tabkeyReset',value:function tabkeyReset(){this.tabKey='0';}},{key:'apiFinishedStatusReset',value:function apiFinishedStatusReset(){this.isApiOneFinished=false;this.isApiTwoFinished=false;}}]);return HrmChangeReport;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'params',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'condition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'conditionOfAdSearch',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'singleSearchCondition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'countDatas',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'option1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'option2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'option3',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'pathname',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'deadline',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'linkName',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'更多';}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'title',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'dialogTitle',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _i18n.i18n.label.specificInformation;}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'isLeftEchartsShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'isRightEchartsShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'isPieChartsShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'visible1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'visible2',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'tableStore',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'searchCondition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'ids',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'idsForPie',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'yAxisData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'nameSet',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'linkList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'dpId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'strokeColor',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'#6FBCEA';}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'dataKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'yearmonth',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'contractTypeId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'isNeedWeaTab',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor33=_applyDecoratedDescriptor(_class.prototype,'isNeedPieChart',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor34=_applyDecoratedDescriptor(_class.prototype,'tabKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor35=_applyDecoratedDescriptor(_class.prototype,'tabDatas',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor36=_applyDecoratedDescriptor(_class.prototype,'winWidth',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor37=_applyDecoratedDescriptor(_class.prototype,'gridData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor38=_applyDecoratedDescriptor(_class.prototype,'isApiOneFinished',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor39=_applyDecoratedDescriptor(_class.prototype,'isApiTwoFinished',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor40=_applyDecoratedDescriptor(_class.prototype,'isColIdUnusual',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor41=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor42=_applyDecoratedDescriptor(_class.prototype,'authorized',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor43=_applyDecoratedDescriptor(_class.prototype,'getRight',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){_this4.loading=true;Api.getRight().then(function(rs){var hasRight=rs.hasRight;if(hasRight){_this4.authorized=true;}_this4.loading=false;}).catch(function(error){_antd.message.error(error);});};}}),_applyDecoratedDescriptor(_class.prototype,'getSearchCondition',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getSearchCondition'),_class.prototype)),_class);

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmConstRpSubSearch=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19;var _mobx=__webpack_require__(8);var _constrpsubsearch=__webpack_require__(629);var API=_interopRequireWildcard(_constrpsubsearch);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _ecCom=__webpack_require__(0);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var confirm=_antd.Modal.confirm;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmConstRpSubSearch=exports.HrmConstRpSubSearch=(_class=function(){function HrmConstRpSubSearch(){(0,_classCallCheck3.default)(this,HrmConstRpSubSearch);this.title=getLabel('15687',"个人信息");_initDefineProp(this,'verified',_descriptor,this);_initDefineProp(this,'hasRight',_descriptor2,this);_initDefineProp(this,'showResult',_descriptor3,this);_initDefineProp(this,'topTabkey',_descriptor4,this);_initDefineProp(this,'scopeId',_descriptor5,this);_initDefineProp(this,'scopeCmd',_descriptor6,this);_initDefineProp(this,'tabkey',_descriptor7,this);_initDefineProp(this,'templateid',_descriptor8,this);_initDefineProp(this,'form',_descriptor9,this);_initDefineProp(this,'table',_descriptor10,this);_initDefineProp(this,'tabDatas',_descriptor11,this);_initDefineProp(this,'config',_descriptor12,this);_initDefineProp(this,'visible',_descriptor13,this);_initDefineProp(this,'templeteValue',_descriptor14,this);_initDefineProp(this,'defaulttabkey',_descriptor15,this);_initDefineProp(this,'isReSave',_descriptor16,this);_initDefineProp(this,'isCustom',_descriptor17,this);_initDefineProp(this,'prePath',_descriptor18,this);_initDefineProp(this,'prePathName',_descriptor19,this);this.configbak=[];}(0,_createClass3.default)(HrmConstRpSubSearch,[{key:'getTabInfo',value:function getTabInfo(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cb=arguments[1];this.title="";this.tabkey='';this.tabDatas=[];this.verified=false;params.scopeId=this.scopeId;params.isCustom=this.isCustom;API.getTabInfo(params).then(function(data){_this.verified=true;if(data.status=='1'){_this.title=data.tabInfo[0].title;_this.topTabkey=data.tabInfo[0].key;_this.tabkey=data.tabInfo[0].key;_this.scopeCmd=data.tabInfo[0].key;_this.defaulttabkey=data.tabInfo[0].key;_this.tabDatas=data.tabInfo;_this.hasRight=true;cb&&cb();}else{_this.hasRight=false;//message.warning(data.message);
}},function(error){_antd.message.warning(error.message);});}},{key:'changeTab',value:function changeTab(key){this.tabkey=key;this.config=[];this.configbak=[];this.templateid="0";if(key&&key.split("_").length==3){var tmpValue=key.split("_");this.scopeCmd=tmpValue[1];this.templateid=tmpValue[2];}else{this.scopeCmd=key;}this.getCondition();}},{key:'changeTopTab',value:function changeTopTab(key){this.topTabkey=key;this.changeTab(key);}},{key:'updateTempleteValue',value:function updateTempleteValue(v){this.templeteValue=v;}},{key:'updateVisible',value:function updateVisible(bool){this.visible=bool;}},{key:'getCondition',value:function getCondition(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};params.scopeId=this.scopeId;params.cmd=this.scopeCmd;params.templateid=this.templateid;params.isCustom=this.isCustom;this.showResult=false;this.config=[];this.configbak=[];API.getCondition(params).then(function(data){if(data.status=='1'){_this2.config=data.condition;_this2.configbak=(0,_cloneDeep2.default)(data.condition);}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'doSearch',value:function doSearch(params){this.getSearchList(params);}},{key:'reSearch',value:function reSearch(){this.showResult=false;}},{key:'reset',value:function reset(){this.config=[];var __this=this;setTimeout(function(){__this.config=(0,_cloneDeep2.default)(__this.configbak);},0);}},{key:'saveTemplete',value:function saveTemplete(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var doSave=params.doSave||false;if(doSave){params.templateid=this.templateid;}else{var templeteValue=this.templeteValue||'';if(templeteValue==''){_antd.message.warning(_i18n.i18n.message.requireFieldNone());return;}}if(this.isReSave){params.cmd="ctrlc";}params.templateName=this.templeteValue;params.isCustom=this.isCustom;API.saveTemplete(params).then(function(data){if(data.status=='1'){if(doSave){}else{_this3.templateid=data.templateid;var tmpTabKey=params.scopeId+"_"+params.scopeCmd+"_"+data.templateid;_this3.updateVisible(false);_this3.templeteValue='';_this3.isReSave=false;_this3.getTabInfo({},function(){_this3.topTabkey=params.scopeCmd;_this3.changeTab(tmpTabKey);});}_antd.message.warning(_i18n.i18n.message.saveSuccess());}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'deleteTabs',value:function deleteTabs(){var __this=this;var params={};params.cmd="del";params.scopeId=this.scopeId;params.scopeCmd=this.scopeCmd;params.templateid=this.templateid;confirm({title:'系统提示',content:'确定要删除该页签吗？',onOk:function onOk(){API.saveTemplete(params).then(function(data){if(data.status=='1'){scopeId:1;__this.getTabInfo({},function(){__this.changeTopTab(params.scopeCmd);});_antd.message.warning("删除成功");}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});},onCancel:function onCancel(){}});}},{key:'importExcel',value:function importExcel(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};}},{key:'getSearchList',value:function getSearchList(){var _this4=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};params.scopeId=this.scopeId;params.isCustom=this.isCustom;if(this.isCustom=='1'){params.scopeCmd='0';}else{params.scopeCmd=this.scopeCmd;}API.getSearchList(params).then(function(data){if(data.status=='1'){_this4.table.getDatas(data.sessionkey,1);_this4.showResult=true;}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}}]);return HrmConstRpSubSearch;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'verified',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'hasRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'showResult',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'topTabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'15687';}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'scopeId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'scopeCmd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'tabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'15687';}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'templateid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"0";}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'tabDatas',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'config',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'visible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'templeteValue',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'defaulttabkey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'isReSave',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'isCustom',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'prePath',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'prePathName',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'getTabInfo',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getTabInfo'),_class.prototype)),_class);

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveTemplete=exports.getSearchList=exports.getCondition=exports.getTabInfo=undefined;var _ecCom=__webpack_require__(0);var getTabInfo=exports.getTabInfo=function getTabInfo(params){return _ecCom.WeaTools.callApi('/api/hrm/report/constrpsubsearch/getTabInfo','POST',params);};var getCondition=exports.getCondition=function getCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/report/constrpsubsearch/getCondition','POST',params);};var getSearchList=exports.getSearchList=function getSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/report/constrpsubsearch/getSearchList','POST',params);};var saveTemplete=exports.saveTemplete=function saveTemplete(params){return _ecCom.WeaTools.callApi('/api/hrm/report/constrpsubsearch/saveTemplete','POST',params);};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmRpSubSearch=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _rpsubsearch=__webpack_require__(631);var API=_interopRequireWildcard(_rpsubsearch);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmRpSubSearch=exports.HrmRpSubSearch=(_class=function(){function HrmRpSubSearch(){(0,_classCallCheck3.default)(this,HrmRpSubSearch);this.title=function(){return getLabel('17088',"自定义信息");};_initDefineProp(this,'verified',_descriptor,this);_initDefineProp(this,'hasRight',_descriptor2,this);_initDefineProp(this,'form',_descriptor3,this);_initDefineProp(this,'table',_descriptor4,this);_initDefineProp(this,'condition',_descriptor5,this);_initDefineProp(this,'showSearchAd',_descriptor6,this);_initDefineProp(this,'searchParamsAd',_descriptor7,this);}(0,_createClass3.default)(HrmRpSubSearch,[{key:'getHasRight',value:function getHasRight(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getHasRight(params).then(function(data){_this.hasRight=data.hasRight;if(data.hasRight){_this.getSearchCondition();_this.getSearchList();}_this.verified=true;});}},{key:'getSearchCondition',value:function getSearchCondition(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.form=new _comsMobx.WeaForm();API.getSearchCondition(params).then(function(data){_this2.condition=data.conditions;_this2.form.initFormFields(data.conditions);});}},{key:'doSearch',value:function doSearch(){var formParams=this.form.getFormParams();this.getSearchList(formParams);}},{key:'getSearchList',value:function getSearchList(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API.getSearchList(params).then(function(data){_this3.table.getDatas(data.sessionkey,1);});}},{key:'setShowSearchAd',value:function setShowSearchAd(bool){this.showSearchAd=bool;}},{key:'getFormParams',value:function getFormParams(){return this.form.getFormParams();}}]);return HrmRpSubSearch;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'verified',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'hasRight',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'condition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'showSearchAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'searchParamsAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'getHasRight',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getHasRight'),_class.prototype)),_class);

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getSearchList=exports.getSearchCondition=exports.getHasRight=undefined;var _ecCom=__webpack_require__(0);var getHasRight=exports.getHasRight=function getHasRight(params){return _ecCom.WeaTools.callApi('/api/hrm/report/rpsubsearch/hasRight','GET',params);};var getSearchCondition=exports.getSearchCondition=function getSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/report/rpsubsearch/getSearchCondition','GET',params);};var getSearchList=exports.getSearchList=function getSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/report/rpsubsearch/getSearchList','POST',params);};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmScheduleDiffReport=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17;var _mobx=__webpack_require__(8);var _schedulediffreport=__webpack_require__(265);var API=_interopRequireWildcard(_schedulediffreport);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var confirm=_antd.Modal.confirm;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmScheduleDiffReport=exports.HrmScheduleDiffReport=(_class=function(){function HrmScheduleDiffReport(){(0,_classCallCheck3.default)(this,HrmScheduleDiffReport);this.title=function(){return getLabel('16559',"考勤报表");};_initDefineProp(this,'dialogTitle',_descriptor,this);_initDefineProp(this,'loading',_descriptor2,this);_initDefineProp(this,'form',_descriptor3,this);_initDefineProp(this,'table',_descriptor4,this);_initDefineProp(this,'config',_descriptor5,this);_initDefineProp(this,'configbak',_descriptor6,this);_initDefineProp(this,'configall',_descriptor7,this);_initDefineProp(this,'reportdata',_descriptor8,this);_initDefineProp(this,'visible',_descriptor9,this);_initDefineProp(this,'lastname',_descriptor10,this);_initDefineProp(this,'radiogroupdata',_descriptor11,this);_initDefineProp(this,'fromDate',_descriptor12,this);_initDefineProp(this,'toDate',_descriptor13,this);_initDefineProp(this,'detialexcelurl',_descriptor14,this);_initDefineProp(this,'selectedKey',_descriptor15,this);_initDefineProp(this,'topTab',_descriptor16,this);_initDefineProp(this,'setSelectedKey',_descriptor17,this);}(0,_createClass3.default)(HrmScheduleDiffReport,[{key:'getSearchCondition',value:function getSearchCondition(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.config=[];this.configbak=[];this.configall=[];API.getSearchCondition(params).then(function(data){if(data.status=='1'){var c=(0,_cloneDeep2.default)(data.conditions);var tmpCondition=[];tmpCondition.push(c[0]);tmpCondition.push(c[1]);_this.configbak=(0,_cloneDeep2.default)(tmpCondition);_this.configall=data.conditions;_this.config=(0,_cloneDeep2.default)(tmpCondition);}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'updateVisible',value:function updateVisible(v){var params=this.radiogroupdata;var fromDate=this.fromDate||'';var toDate=this.toDate||'';var resourceid=params.resourceId||'';var departmentid=params.departmentId||'';var subcompanyid=params.subCompanyId||'';this.selectedKey='0';if(fromDate!=''&&toDate!=''){if(fromDate>toDate){_antd.message.warning(getLabel('386537',"开始日期不能大于结束日期"));return;}if(params.viewscope=='1'&&resourceid==""&&departmentid==""&&subcompanyid==""){_antd.message.warning(getLabel('386536',"请选择数据范围"));return;}}this.visible=v;}},{key:'updateDialogTitle',value:function updateDialogTitle(){this.dialogTitle="";if(this.stsType=='SIGININ'){this.dialogTitle=getLabel('20241',"签到明细");this.detialexcelurl="HrmScheduleDiffSignInDetail&tnum=20241";}else if(this.stsType=='SIGINOUT'){this.dialogTitle=getLabel('20242',"签退明细");this.detialexcelurl="HrmScheduleDiffSignOutDetail&tnum=20242";}else if(this.stsType=='BELATE'){this.dialogTitle=getLabel('20088',"迟到明细");this.detialexcelurl="HrmScheduleDiffBeLateDetail&tnum=20088";}else if(this.stsType=='LEAVEEARLY'){this.dialogTitle=getLabel('20089',"早退明细");this.detialexcelurl="HrmScheduleDiffLeaveEarlyDetail&tnum=20089";}else if(this.stsType=='ABSENT'){this.dialogTitle=getLabel('20090',"旷工明细");this.detialexcelurl="HrmScheduleDiffAbsentFromWorkDetail&tnum=20090";}else if(this.stsType=='NOSIGN'){this.dialogTitle=getLabel('20091',"漏签明细");this.detialexcelurl="HrmScheduleDiffNoSignDetail&tnum=20091";}else if(this.stsType=='LEAVE'){this.dialogTitle=getLabel('20092',"请假明细");this.detialexcelurl="HrmScheduleDiffLeaveDetail&tnum=20092";}else if(this.stsType=='EVECTION'){this.dialogTitle=getLabel('20093',"出差明细");this.detialexcelurl="HrmScheduleDiffEvectionDetail&tnum=20093";}else if(this.stsType=='OUTDAYS'){this.dialogTitle=getLabel('20094',"公出明细");this.detialexcelurl="HrmScheduleDiffOutDetail&tnum=20094";}else if(this.stsType=='OVERTIME'){this.dialogTitle=getLabel('33501',"加班明细");this.detialexcelurl="HrmScheduleOvertimeWorkDetail&tnum=33501";}else if(this.stsType=='OTHER'){this.dialogTitle=getLabel('386409',"考勤异常数据抵冲明细");this.detialexcelurl="HrmScheduleDiffOtherDetail&tnum=127655,17463";}}},{key:'getTableData',value:function getTableData(){var _this2=this;var params=this.radiogroupdata;params.kqtype=this.stsType;params.from='schedulediffreport';params.selectedKey=this.selectedKey;this.updateDialogTitle();API.getTableData(params).then(function(datas){_this2.table.getDatas(datas.sessionkey,1);});}},{key:'getHrmKQReportDetialTabInfo',value:function getHrmKQReportDetialTabInfo(){var _this3=this;var params=this.radiogroupdata;params.kqtype=this.stsType;API.getHrmKQReportDetialTabInfo(params).then(function(datas){_this3.topTab=(0,_cloneDeep2.default)(datas.tabs);_this3.selectedKey='0';});}},{key:'getTabTableData',value:function getTabTableData(){var _this4=this;API.getTabTableData().then(function(rs){rs.map(function(result,index){switch(index){case 0:_this4.getHrmKQReportDetialTabInfo();break;case 1:_this4.getTableData();break;}});});}},{key:'exportExcel',value:function exportExcel(){var params=this.radiogroupdata;var fromDate=this.fromDate||'';var toDate=this.toDate||'';var resourceid=params.resourceId||'';var departmentid=params.departmentId||'';var subcompanyid=params.subCompanyId||'';if(fromDate==''||toDate==''){_antd.message.error(getLabel('383565',"请选择日期范围"));return;}if(fromDate!=''&&toDate!=''){if(fromDate>toDate){_antd.message.warning(getLabel('386537',"开始日期不能大于结束日期"));return;}if(params.viewscope=='1'&&resourceid==""&&departmentid==""&&subcompanyid==""){_antd.message.warning(getLabel('386536',"请选择数据范围"));return;}}window.location.href="/hrm/report/schedulediff/HrmScheduleDiffReportExcelE9.jsp?cmd=HrmScheduleDiffReport&tnum=20078"+"&fromDate="+this.fromDate+"&toDate="+this.toDate+"&resourceId="+resourceid+"&departmentId="+departmentid+"&subCompanyId="+subcompanyid+"&viewscope="+params.viewscope;}},{key:'exportDetialExcel',value:function exportDetialExcel(){var params=this.radiogroupdata;var fromDate=this.fromDate||'';var toDate=this.toDate||'';var resourceid=params.resourceId||'';var departmentid=params.departmentId||'';var subcompanyid=params.subCompanyId||'';var url="/hrm/report/schedulediff/HrmScheduleDiffReportExcelE9.jsp?cmd="+this.detialexcelurl+"&fromDate="+this.fromDate+"&toDate="+this.toDate+"&resourceId="+resourceid+"&departmentId="+departmentid+"&subCompanyId="+subcompanyid+"&viewscope="+params.viewscope+"&selectedKey="+this.selectedKey;window.location.href=url;}},{key:'getReportData',value:function getReportData(){var _this5=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(params.viewscope=='1'){this.config=this.configall;var resourceid=params.resourceId||'';var departmentid=params.departmentId||'';var subcompanyid=params.subCompanyId||'';if(resourceid==''&&departmentid==''&&subcompanyid==''){//message.warning("请选择数据范围");
return false;}}else{this.config=this.configbak;params.resourceId='';params.departmentId='';params.subCompanyId='';}this.radiogroupdata=params;this.loading=true;API.getReportData(params).then(function(data){if(data.status=='1'){_this5.reportdata=data.reportdata;_this5.fromDate=data.fromDate;_this5.toDate=data.toDate;_this5.loading=false;}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}}]);return HrmScheduleDiffReport;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'dialogTitle',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'考勤明细';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'config',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'configbak',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'configall',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'reportdata',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'visible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'lastname',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'radiogroupdata',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'fromDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'toDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'detialexcelurl',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'selectedKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'topTab',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'getSearchCondition',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getSearchCondition'),_class.prototype),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'setSelectedKey',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(key){_this6.selectedKey=key;_this6.getTableData();};}})),_class);

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmScheduleDiffReport4Formal=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17;var _mobx=__webpack_require__(8);var _schedulediffreport=__webpack_require__(265);var API=_interopRequireWildcard(_schedulediffreport);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var confirm=_antd.Modal.confirm;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmScheduleDiffReport4Formal=exports.HrmScheduleDiffReport4Formal=(_class=function(){function HrmScheduleDiffReport4Formal(){(0,_classCallCheck3.default)(this,HrmScheduleDiffReport4Formal);this.title=function(){return getLabel('16559',"考勤报表");};_initDefineProp(this,'dialogTitle',_descriptor,this);_initDefineProp(this,'loading',_descriptor2,this);_initDefineProp(this,'form',_descriptor3,this);_initDefineProp(this,'table',_descriptor4,this);_initDefineProp(this,'config',_descriptor5,this);_initDefineProp(this,'configbak',_descriptor6,this);_initDefineProp(this,'configall',_descriptor7,this);_initDefineProp(this,'reportdata',_descriptor8,this);_initDefineProp(this,'visible',_descriptor9,this);_initDefineProp(this,'lastname',_descriptor10,this);_initDefineProp(this,'radiogroupdata',_descriptor11,this);_initDefineProp(this,'fromDate',_descriptor12,this);_initDefineProp(this,'toDate',_descriptor13,this);_initDefineProp(this,'detialexcelurl',_descriptor14,this);_initDefineProp(this,'selectedKey',_descriptor15,this);_initDefineProp(this,'topTab',_descriptor16,this);_initDefineProp(this,'setSelectedKey',_descriptor17,this);}(0,_createClass3.default)(HrmScheduleDiffReport4Formal,[{key:'getSearchCondition',value:function getSearchCondition(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.config=[];this.configbak=[];this.configall=[];API.getSearchCondition(params).then(function(data){if(data.status=='1'){var c=(0,_cloneDeep2.default)(data.conditions);var tmpCondition=[];tmpCondition.push(c[0]);tmpCondition.push(c[1]);_this.configbak=(0,_cloneDeep2.default)(tmpCondition);_this.configall=data.conditions;_this.config=(0,_cloneDeep2.default)(tmpCondition);}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'updateVisible',value:function updateVisible(v){var params=this.radiogroupdata;var fromDate=this.fromDate||'';var toDate=this.toDate||'';var resourceid=params.resourceId||'';var departmentid=params.departmentId||'';var subcompanyid=params.subCompanyId||'';this.selectedKey='0';if(fromDate!=''&&toDate!=''){if(fromDate>toDate){_antd.message.warning(getLabel('386537',"开始日期不能大于结束日期"));return;}if(params.viewscope=='1'&&resourceid==""&&departmentid==""&&subcompanyid==""){_antd.message.warning(getLabel('386536',"请选择数据范围"));return;}}this.visible=v;}},{key:'updateDialogTitle',value:function updateDialogTitle(){this.dialogTitle="";if(this.stsType=='SIGININ'){this.dialogTitle=getLabel('20241',"签到明细");this.detialexcelurl="HrmScheduleDiffSignInDetail&tnum=20241";}else if(this.stsType=='SIGINOUT'){this.dialogTitle=getLabel('20242',"签退明细");this.detialexcelurl="HrmScheduleDiffSignOutDetail&tnum=20242";}else if(this.stsType=='BELATE'){this.dialogTitle=getLabel('20088',"迟到明细");this.detialexcelurl="HrmScheduleDiffBeLateDetail&tnum=20088";}else if(this.stsType=='LEAVEEARLY'){this.dialogTitle=getLabel('20089',"早退明细");this.detialexcelurl="HrmScheduleDiffLeaveEarlyDetail&tnum=20089";}else if(this.stsType=='ABSENT'){this.dialogTitle=getLabel('20090',"旷工明细");this.detialexcelurl="HrmScheduleDiffAbsentFromWorkDetail&tnum=20090";}else if(this.stsType=='NOSIGN'){this.dialogTitle=getLabel('20091',"漏签明细");this.detialexcelurl="HrmScheduleDiffNoSignDetail&tnum=20091";}else if(this.stsType=='LEAVE'){this.dialogTitle=getLabel('20092',"请假明细");this.detialexcelurl="HrmScheduleDiffLeaveDetail&tnum=20092";}else if(this.stsType=='EVECTION'){this.dialogTitle=getLabel('20093',"出差明细");this.detialexcelurl="HrmScheduleDiffEvectionDetail&tnum=20093";}else if(this.stsType=='OUTDAYS'){this.dialogTitle=getLabel('20094',"公出明细");this.detialexcelurl="HrmScheduleDiffOutDetail&tnum=20094";}else if(this.stsType=='OVERTIME'){this.dialogTitle=getLabel('33501',"加班明细");this.detialexcelurl="HrmScheduleOvertimeWorkDetail&tnum=33501";}else if(this.stsType=='OTHER'){this.dialogTitle=getLabel('386409',"考勤异常数据抵冲明细");this.detialexcelurl="HrmScheduleDiffOtherDetail&tnum=127655,17463";}else if(this.stsType=='LEAVEEARLYRULE'){this.dialogTitle=this.reportname+getLabel('20089',"早退明细");this.detialexcelurl="HrmScheduleDiffLeaveEarlyDetail&tnum=20089";}else if(this.stsType=='BELATERULE'){this.dialogTitle=this.reportname+getLabel('20088',"迟到明细");this.detialexcelurl="HrmScheduleDiffBeLateDetail&tnum=20088";}else if(this.stsType=='ABSENTBELATE'){this.dialogTitle=getLabel('383164',"缺勤明细");this.detialexcelurl="HrmScheduleDiffAbsentBeLateDetail&tnum=383164";}}},{key:'getTableData',value:function getTableData(){var _this2=this;var params=this.radiogroupdata;params.kqtype=this.stsType;params.from='schedulediffreport';params.ruleid=this.ruleid;params.selectedKey=this.selectedKey;this.updateDialogTitle();API.getTableData(params).then(function(datas){_this2.table.getDatas(datas.sessionkey,1);});}},{key:'getHrmKQReportDetialTabInfo',value:function getHrmKQReportDetialTabInfo(){var _this3=this;var params=this.radiogroupdata;params.kqtype=this.stsType;API.getHrmKQReportDetialTabInfo(params).then(function(datas){_this3.topTab=(0,_cloneDeep2.default)(datas.tabs);_this3.selectedKey='0';});}},{key:'getTabTableData',value:function getTabTableData(){var _this4=this;API.getTabTableData().then(function(rs){rs.map(function(result,index){switch(index){case 0:_this4.getHrmKQReportDetialTabInfo();break;case 1:_this4.getTableData();break;}});});}},{key:'exportExcel',value:function exportExcel(){var params=this.radiogroupdata;var fromDate=this.fromDate||'';var toDate=this.toDate||'';var resourceid=params.resourceId||'';var departmentid=params.departmentId||'';var subcompanyid=params.subCompanyId||'';if(fromDate==''||toDate==''){_antd.message.error(getLabel('383565',"请选择日期范围"));return;}if(fromDate!=''&&toDate!=''){if(fromDate>toDate){_antd.message.warning(getLabel('386537',"开始日期不能大于结束日期"));return;}if(params.viewscope=='1'&&resourceid==""&&departmentid==""&&subcompanyid==""){_antd.message.warning(getLabel('386536',"请选择数据范围"));return;}}window.location.href="/hrm/report/schedulediff/HrmScheduleDiffReportExcelE9.jsp?cmd=HrmScheduleDiffReport&tnum=20078"+"&fromDate="+this.fromDate+"&toDate="+this.toDate+"&resourceId="+resourceid+"&departmentId="+departmentid+"&subCompanyId="+subcompanyid+"&viewscope="+params.viewscope;}},{key:'exportDetialExcel',value:function exportDetialExcel(){var params=this.radiogroupdata;var fromDate=this.fromDate||'';var toDate=this.toDate||'';var resourceid=params.resourceId||'';var departmentid=params.departmentId||'';var subcompanyid=params.subCompanyId||'';var url="/hrm/report/schedulediff/HrmScheduleDiffReportExcelE9.jsp?cmd="+this.detialexcelurl+"&fromDate="+this.fromDate+"&toDate="+this.toDate+"&resourceId="+resourceid+"&departmentId="+departmentid+"&subCompanyId="+subcompanyid+"&viewscope="+params.viewscope+"&ruleid="+(this.ruleid||'')+"&selectedKey="+this.selectedKey;window.location.href=url;}},{key:'getReportData',value:function getReportData(){var _this5=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(params.viewscope=='1'){this.config=this.configall;var resourceid=params.resourceId||'';var departmentid=params.departmentId||'';var subcompanyid=params.subCompanyId||'';if(resourceid==''&&departmentid==''&&subcompanyid==''){//message.warning("请选择数据范围");
return false;}}else{this.config=this.configbak;params.resourceId='';params.departmentId='';params.subCompanyId='';}this.radiogroupdata=params;this.loading=true;API.getReportData(params).then(function(data){if(data.status=='1'){_this5.reportdata=data.reportdata;_this5.fromDate=data.fromDate;_this5.toDate=data.toDate;_this5.loading=false;}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}}]);return HrmScheduleDiffReport4Formal;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'dialogTitle',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'考勤明细';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new TableStore();}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'config',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'configbak',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'configall',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'reportdata',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'visible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'lastname',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'radiogroupdata',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'fromDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'toDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'detialexcelurl',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'selectedKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'topTab',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'getSearchCondition',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getSearchCondition'),_class.prototype),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'setSelectedKey',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(key){_this6.selectedKey=key;_this6.getTableData();};}})),_class);

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmScheduleDiffMonthAttDetail=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14;var _mobx=__webpack_require__(8);var _schedulediffmonthattdetail=__webpack_require__(635);var API=_interopRequireWildcard(_schedulediffmonthattdetail);var _index=__webpack_require__(17);var Util=_interopRequireWildcard(_index);var _cloneDeep=__webpack_require__(26);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _antd=__webpack_require__(6);var _comsMobx=__webpack_require__(10);var _isEmpty=__webpack_require__(13);var _isEmpty2=_interopRequireDefault(_isEmpty);var _moment=__webpack_require__(22);var _moment2=_interopRequireDefault(_moment);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var confirm=_antd.Modal.confirm;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmScheduleDiffMonthAttDetail=exports.HrmScheduleDiffMonthAttDetail=(_class=function(){function HrmScheduleDiffMonthAttDetail(){(0,_classCallCheck3.default)(this,HrmScheduleDiffMonthAttDetail);this.title=function(){return getLabel('82801',"月考勤日历报表");};this.dialogTitle=function(){return getLabel('386477',"考勤明细");};_initDefineProp(this,'loading',_descriptor,this);_initDefineProp(this,'form',_descriptor2,this);_initDefineProp(this,'config',_descriptor3,this);_initDefineProp(this,'configbak',_descriptor4,this);_initDefineProp(this,'configall',_descriptor5,this);_initDefineProp(this,'reportdata',_descriptor6,this);_initDefineProp(this,'visible',_descriptor7,this);_initDefineProp(this,'lastname',_descriptor8,this);_initDefineProp(this,'radiogroupdata',_descriptor9,this);_initDefineProp(this,'showFList',_descriptor10,this);_initDefineProp(this,'pDate',_descriptor11,this);_initDefineProp(this,'table',_descriptor12,this);_initDefineProp(this,'table1',_descriptor13,this);_initDefineProp(this,'resourceId',_descriptor14,this);}(0,_createClass3.default)(HrmScheduleDiffMonthAttDetail,[{key:'getSearchCondition',value:function getSearchCondition(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cb=arguments[1];this.config=[];this.configbak=[];this.configall=[];this.resourceId="";API.getSearchCondition(params).then(function(data){if(data.status=='1'){var c=(0,_cloneDeep2.default)(data.conditions);var tmpCondition=[];tmpCondition.push(c[0]);tmpCondition.push(c[1]);cb(tmpCondition);cb(data.conditions);_this.configbak=(0,_cloneDeep2.default)(tmpCondition);_this.configall=data.conditions;_this.config=(0,_cloneDeep2.default)(tmpCondition);_this.resourceId=data.resourceId;}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'changeDate',value:function changeDate(v){v=new _moment2.default(v).format('YYYY-MM');this.pDate=v+"-01";var params=this.radiogroupdata;this.getReportData(params);}},{key:'resetConfig',value:function resetConfig(v){this.config=[];this.configbak=[];this.configall=[];this.pDate=new _moment2.default().format('YYYY-MM-DD');}},{key:'updateVisible',value:function updateVisible(v){this.visible=v;}},{key:'getTableData',value:function getTableData(params){var _this2=this;API.getTableData(params).then(function(data){if(data.status=='1'){_this2.table=data.table;_this2.table1=data.table1;_this2.showFList=data.showFList;_this2.loading=false;}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}},{key:'exportExcel',value:function exportExcel(){if(this.pDate){this.radiogroupdata.currentdate=this.pDate;}var params=this.radiogroupdata;var currentdate=params.currentdate||'';var resourceid=params.resourceId||'';var departmentid=params.departmentId||'';var subcompanyid=params.subCompanyId||'';if(params.viewscope=='0'){resourceid=this.resourceId||'';}if(params.viewscope=='1'&&resourceid==""&&departmentid==""&&subcompanyid==""){_antd.message.warning(getLabel('386536',"请选择数据范围"));return;}window.location.href="/hrm/report/schedulediff/HrmScheduleDiffReportExcelE9.jsp?cmd=HrmScheduleDiffMonthAttDetail&tnum=82801"+"&currentdate="+currentdate+"&resourceId="+resourceid+"&departmentId="+departmentid+"&subCompanyId="+subcompanyid+"&viewscope="+params.viewscope;}},{key:'getReportData',value:function getReportData(){var _this3=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(this.pDate){this.radiogroupdata.currentdate=this.pDate;}if(params.viewscope=='1'){this.config=this.configall;var resourceid=params.resourceId||'';var departmentid=params.departmentId||'';var subcompanyid=params.subCompanyId||'';if(resourceid==''&&departmentid==''&&subcompanyid==''){//message.warning("请选择数据范围");
return false;}}else{this.config=this.configbak;params.viewscope="0";params.resourceId='';params.departmentId='';params.subCompanyId='';}this.radiogroupdata=params;this.loading=true;API.getReportData(params).then(function(data){if(data.status=='1'){_this3.reportdata=data.reportdata;_this3.fromDate=data.fromDate;_this3.toDate=data.toDate;_this3.loading=false;}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}}]);return HrmScheduleDiffMonthAttDetail;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'config',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'configbak',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'configall',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'reportdata',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'visible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'lastname',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'radiogroupdata',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'showFList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'pDate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _moment2.default().format('YYYY-MM-DD');}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'table1',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'resourceId',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_applyDecoratedDescriptor(_class.prototype,'getSearchCondition',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getSearchCondition'),_class.prototype)),_class);

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getTableData=exports.getReportData=exports.getSearchCondition=undefined;var _ecCom=__webpack_require__(0);var getSearchCondition=exports.getSearchCondition=function getSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/schedulediffmonthattdetail/getSearchCondition','POST',params);};var getReportData=exports.getReportData=function getReportData(params){return _ecCom.WeaTools.callApi('/api/hrm/schedulediffmonthattdetail/getReportData','POST',params);};var getTableData=exports.getTableData=function getTableData(params){return _ecCom.WeaTools.callApi('/api/hrm/schedulediffmonthattdetail/getReportDetialData','POST',params);};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.hrmOrgChart=exports.HrmOrgChart=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(74);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _baseStore=__webpack_require__(129);var _baseStore2=_interopRequireDefault(_baseStore);var _orgChart=__webpack_require__(637);var api=_interopRequireWildcard(_orgChart);var _i18n=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var HrmOrgChart=exports.HrmOrgChart=(_class=function(_HrmBaseStore){(0,_inherits3.default)(HrmOrgChart,_HrmBaseStore);/********************* action list *********************/function HrmOrgChart(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,HrmOrgChart);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=HrmOrgChart.__proto__||(0,_getPrototypeOf2.default)(HrmOrgChart)).call.apply(_ref,[this].concat(args))),_this),_this.topBtnAndMenu=function(){var btns=[];var menus=[];btns.map(function(btn,index){var props=btn.props;menus.push({key:index.toString(),content:props.children,icon:React.createElement('i',{className:_this.menuIconCollection[props.op]}),onClick:props.onClick,disabled:props.disabled||false});});return{btns:btns,menus:[].concat(menus,(0,_toConsumableArray3.default)(_this.getBasicMenus()))};},_this.tabConfig={tabs:[],keyParam:'viewCondition',activeTabKey:'1'},_initDefineProp(_this,'spinning',_descriptor,_this),_initDefineProp(_this,'refreshOrgForm',_descriptor2,_this),_initDefineProp(_this,'refreshTab',_descriptor3,_this),_this.initData=function(){var refresh=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;_this.iframe=null;_this.containerInitFinished=(0,_extends3.default)({},_this.containerInitFinished,{authorized:true,init:true});_this.callInitData();},_this.callInitData=function(){if(_this.spinning)return;_this.spinning=true;api.initData().then(function(rs){rs.map(function(result,index){if(result.status==='1'){switch(index){case 0:_this.setFormData('orgForm',result.conditions);_this.refreshOrgForm=new Date().getTime();break;case 1:_this.setFormData('settingForm',result.conditions);break;case 2:_this.tabConfig.tabs.length=0;_this.tabConfig.buttons=_this.generateTabBtn();result.tabs.map(function(tab){_this.tabConfig.tabs.push({color:'#000000',groupId:tab.key,title:tab.title,viewCondition:tab.key,searchType:['advanced'],doSearch:function doSearch(params){return _this.getChartData(true);}});});_this.setActiveTab('1');break;}}});});},_this.generateTabBtn=function(){var _this$formTarget=_this.formTarget,orgForm=_this$formTarget.orgForm,orgFormFields=_this$formTarget.orgFormFields;return[React.createElement(_comsMobx.WeaSwitch,{fieldConfig:orgFormFields[0].items[0],form:orgForm,onChange:function onChange(){return _this.getChartData();}})];},_this.setIframe=function(iframe){if(iframe==null||_this.iframe!=null)return;_this.iframe=iframe;_this.callInitData();},_this.tabChangeHandle=function(key){_this.setActiveTab(key);},_initDefineProp(_this,'setActiveTab',_descriptor4,_this),_initDefineProp(_this,'getChartData',_descriptor5,_this),_this.onInitOrgChart=function(status){_this.spinning=false;switch(status){case 0:_antd.message.error(_i18n.i18n.message.dataNone());break;case-1:_antd.message.error(_i18n.i18n.message.dataConstructError());break;}},_this.showSpin=function(val){_this.spinning=val==='0';},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}/********************* unobservable list *********************//********************* unobservable list *********************//********************* dialog info setting *********************//********************* dialog info setting *********************//********************* observable list *********************//********************* observable list *********************//********************* computed list *********************//********************* computed list *********************//********************* action list *********************/return HrmOrgChart;}(_baseStore2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'spinning',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'refreshOrgForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Date().getTime();}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'refreshTab',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Date().getTime();}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'setActiveTab',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(key){_this2.tabConfig.activeTabKey=key||_this2.tabConfig.tabs[0].viewCondition;var tabIndex=_this2.getTabIndex(_this2.tabConfig.tabs,key);if(tabIndex<0)return;var cmd=void 0;switch(key){case'2':cmd='doc';break;case'3':cmd='customer';break;case'4':cmd='project';break;}api.getOrgChartSearchCondition({cmd:cmd}).then(function(data){if(data.status==='1'){_this2.setFormData('conditionForm',data.conditions);_this2.getChartData();}else{}_this2.refreshTab=new Date().getTime();},function(error){_this2.refreshTab=new Date().getTime();});};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'getChartData',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){var reset=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;_this3.spinning=true;var orgFormParams=_this3.formTarget.orgForm.getFormParams();var settingFormParams=_this3.formTarget.settingForm.getFormParams();var condtionFormParams=_this3.formTarget.conditionForm.getFormParams();var params=(0,_assign2.default)({},{arg0:orgFormParams.sOrg,arg1:settingFormParams.shownum,arg3:orgFormParams.sOrg<0?false:true,arg11:!reset?';;P':';;B'});switch(_this3.tabConfig.activeTabKey){case'1':(0,_assign2.default)(params,{arg4:reset?condtionFormParams.status:''});break;case'2':(0,_assign2.default)(params,{arg5:condtionFormParams.docStatus,arg10:'doc'});break;case'3':(0,_assign2.default)(params,{arg6:condtionFormParams.customerType,arg7:condtionFormParams.customerStatus,arg10:'customer'});break;case'4':(0,_assign2.default)(params,{arg8:condtionFormParams.workType,arg9:condtionFormParams.projectStatus,arg10:'project'});break;}api.getOrgChartData(params).then(function(data){if(data.status==='1'){var msgData={act:'orgChart',// 自定义的消息类型、行为，用于switch条件判断等。。
orgData:data.data,params:{sorgid:orgFormParams.sOrg,isShow:params.arg11,showNum:'true',shownum:settingFormParams.shownum}};var tryCount=0;var sendMsg=setInterval(function(){if($('#orgChartFrame')[0]!=null){clearInterval(sendMsg);$('#orgChartFrame')[0].contentWindow.postMessage(msgData,'*');}},500);}else{_this3.spinning=false;}},function(error){_this3.spinning=false;});};}})),_class);var hrmOrgChart=exports.hrmOrgChart=new HrmOrgChart();

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.initData=exports.getOrgChartDataAjax=exports.getOrgChartData=exports.getOrgChartSearchCondition=exports.getTab=exports.getOrgChartSet=exports.getOrgVirtualData=undefined;var _promise=__webpack_require__(75);var _promise2=_interopRequireDefault(_promise);var _ecCom=__webpack_require__(0);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getOrgVirtualData=exports.getOrgVirtualData=function getOrgVirtualData(params){return _ecCom.WeaTools.callApi('/api/hrm/orgchart/getOrgVirtualData','POST',params);};var getOrgChartSet=exports.getOrgChartSet=function getOrgChartSet(params){return _ecCom.WeaTools.callApi('/api/hrm/orgchart/getOrgChartSet','POST',params);};var getTab=exports.getTab=function getTab(params){return _ecCom.WeaTools.callApi('/api/hrm/orgchart/getTab','POST',params);};var getOrgChartSearchCondition=exports.getOrgChartSearchCondition=function getOrgChartSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/orgchart/getOrgChartSearchCondition','POST',params);};var getOrgChartData=exports.getOrgChartData=function getOrgChartData(params){return _ecCom.WeaTools.callApi('/api/hrm/orgchart/getOrgChartData','POST',params);};var getOrgChartDataAjax=exports.getOrgChartDataAjax=function getOrgChartDataAjax(params){return _ecCom.WeaTools.callApi('/api/hrm/orgchart/getOrgChartDataAjax','POST',params);};var initData=exports.initData=function initData(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _promise2.default.all([getOrgVirtualData(),getOrgChartSet(),getTab()]);};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BindTokenKey=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _bindtokenkey=__webpack_require__(639);var API=_interopRequireWildcard(_bindtokenkey);var _antd=__webpack_require__(6);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var confirm=_antd.Modal.confirm;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var BindTokenKey=exports.BindTokenKey=(_class=function(){function BindTokenKey(){(0,_classCallCheck3.default)(this,BindTokenKey);this.title=function(){return getLabel(386125,"令牌绑定");};_initDefineProp(this,'form',_descriptor,this);_initDefineProp(this,'formFields',_descriptor2,this);_initDefineProp(this,'date',_descriptor3,this);_initDefineProp(this,'dialogId',_descriptor4,this);}(0,_createClass3.default)(BindTokenKey,[{key:'getFormField',value:function getFormField(){var _this=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.form=new _comsMobx.WeaForm();API.getFormField(params).then(function(data){_this.formFields=data.formField;_this.form.initFormFields(_this.formFields);});}},{key:'save',value:function save(){var _this2=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var formParams=this.form.getFormParams();this.form.validateForm().then(function(f){if(f.isValid){if(params.syncTokenKey&&params.syncTokenKey=='1'){1;var tokenKey=formParams.tokenKey.trim()||'';var tokenKeyCode1=formParams.tokenKeyCode1.trim()||'';var tokenKeyCode2=formParams.tokenKeyCode2.trim()||'';if(tokenKey!=""&&(!_this2.isdigit(tokenKey)||tokenKey.length!=10)){_antd.message.warning(getLabel(83745,"令牌序列号必须为10位数字！"));tokenKey.focus();return false;}var tokenType="";var startNumber=tokenKey.substr(0,1);if(startNumber=="1"){//动联1代
tokenType="5";}else{_antd.message.warning(getLabel(129133,"令牌序列号不正确，请确认后输入"));return false;}if(tokenKeyCode1!=""&&(!_this2.isdigit(tokenKeyCode1)||tokenKeyCode1.length!=6)){_antd.message.warning(getLabel(129204,"动态口令")+'1'+getLabel(129205,"必须为6位数字"));return false;}if(tokenKeyCode2!=""&&(!_this2.isdigit(tokenKeyCode2)||tokenKeyCode2.length!=6)){_antd.message.warning(getLabel(129204,"动态口令")+'2'+getLabel(129205,"必须为6位数字"));return false;}if(tokenKeyCode1==tokenKeyCode2){_antd.message.warning(getLabel(129204,"动态口令")+'1'+getLabel(129206,"与动态口令")+'2'+getLabel(26250,"不能相同"));return false;}}else{var tokenKey1=formParams.tokenKey1.trim()||'';var tokenKey2=formParams.tokenKey2.trim()||'';var tokenKeyCode=formParams.tokenKeyCode.trim()||'';if(tokenKey1!=""&&(!_this2.isdigit(tokenKey1)||tokenKey1.length!=10)){_antd.message.warning(getLabel(83745,"令牌序列号必须为10位数字！"));return false;}if(tokenKey2!=""&&(!_this2.isdigit(tokenKey2)||tokenKey2.length!=10)){_antd.message.warning(getLabel('386433',"确认序列号必须为10位数字！"));return false;}if(tokenKey1!=tokenKey2){_antd.message.warning(getLabel('386434',"令牌序列号和确认令牌序列号不一致！"));return false;}if(tokenKeyCode!=""&&(!_this2.isdigit(tokenKeyCode)||tokenKeyCode.length!=6)){_antd.message.warning(getLabel('386435',"动态令牌口令必须为6位数字！"));return false;}}API.saveFormFields((0,_extends3.default)({},params,formParams)).then(function(data){if(data.status=='1'){_antd.message.success(data.message);setTimeout(function(){var dialog=top.window.getParentDialog();if(!dialog){if(_this2.dialogId&&window.top.window.dialogMapper&&window.top.window.dialogMapper[_this2.dialogId]){dialog=window.top.window.dialogMapper[_this2.dialogId];}}dialog.close();// 关闭。 会触发onCancel
},3000);}else{_antd.message.warning(data.message);}},function(error){_antd.message.warning(error.message);});}else{f.showErrors();_this2.date=new Date();}});}},{key:'isdigit',value:function isdigit(s){var r,re;re=/\d*/i;//\d表示数字,*表示匹配多个数字
r=s.match(re);return r==s?true:false;}}]);return BindTokenKey;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new _comsMobx.WeaForm();}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'formFields',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'dialogId',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'getFormField',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getFormField'),_class.prototype)),_class);

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveFormFields=exports.getFormField=undefined;var _ecCom=__webpack_require__(0);var getFormField=exports.getFormField=function getFormField(params){return _ecCom.WeaTools.callApi('/api/hrm/login/getBindTokenKeyForm','GET',params);};var saveFormFields=exports.saveFormFields=function saveFormFields(params){return _ecCom.WeaTools.callApi('/api/hrm/login/saveBindTokenKey','POST',params);};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.hrmForgetPassword=exports.HrmForgetPassword=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(74);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _baseStore=__webpack_require__(129);var _baseStore2=_interopRequireDefault(_baseStore);var _forgetPassword=__webpack_require__(641);var api=_interopRequireWildcard(_forgetPassword);var _Resend=__webpack_require__(642);var _Resend2=_interopRequireDefault(_Resend);var _i18n=__webpack_require__(11);var _ecCom=__webpack_require__(0);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var getLocaleLabelByLang=_ecCom.WeaLocaleProvider.getLocaleLabelByLang;var HrmForgetPassword=exports.HrmForgetPassword=(_class=function(_HrmBaseStore){(0,_inherits3.default)(HrmForgetPassword,_HrmBaseStore);/********************* action list *********************/function HrmForgetPassword(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,HrmForgetPassword);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=HrmForgetPassword.__proto__||(0,_getPrototypeOf2.default)(HrmForgetPassword)).call.apply(_ref,[this].concat(args))),_this),_this.topBtnAndMenu=function(){var btns=[];var menus=[];switch(_this.step){case 1:btns=[React.createElement(_antd.Button,{type:'primary',op:'nextStep',onClick:_this.forgotPasswordToNext},_i18n.i18n.button.nextStep())];break;case 2:btns=[React.createElement(_antd.Button,{type:'primary',op:'nextStep',onClick:_this.checkFormInfo},_i18n.i18n.button.verification())];break;case 3:btns=[React.createElement(_antd.Button,{type:'primary',op:'save',onClick:_this.save},_i18n.i18n.button.save())];break;}btns.map(function(btn,index){var props=btn.props;menus.push({key:index.toString(),content:props.children,icon:React.createElement('i',{className:_this.menuIconCollection[props.op]}),onClick:props.onClick,disabled:props.disabled||false});});return{btns:btns,menus:[].concat(menus,(0,_toConsumableArray3.default)(_this.getBasicMenus()))};},_this.itemRender={type:function type(field,textAreaProps,form,formParams){return React.createElement('div',null,React.createElement('div',{style:{float:'left',width:'60%'}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:(0,_extends3.default)({},field,textAreaProps),form:form,formParams:formParams,onChange:_this.onWfChange})));},loginid:function loginid(field,textAreaProps,form,formParams){return React.createElement('div',null,React.createElement('div',{style:{float:'left',width:'60%'}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:(0,_extends3.default)({},field,textAreaProps),form:form,formParams:formParams,onChange:_this.onWfChange})));},validatecode:function validatecode(field,textAreaProps,form,formParams){return React.createElement('div',null,React.createElement('div',{style:{float:'left',width:'60%'}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:(0,_extends3.default)({},field,textAreaProps),form:form,formParams:formParams,onChange:_this.onWfChange})),React.createElement('img',{style:{float:'right'},border:'0',align:'absmiddle',src:_this.verificationCode,onClick:_this.refreshVerificationCode,title:_i18n.i18n.label.preview()}));},answer:function answer(field,textAreaProps,form,formParams){return React.createElement('div',null,React.createElement(_comsMobx.WeaSwitch,{fieldConfig:(0,_extends3.default)({},field,textAreaProps),form:form,formParams:formParams,onChange:_this.onWfChange}),React.createElement('a',{style:{lineHeight:'30px'},onClick:_this.reset},_i18n.i18n.button.changeValidType()));},phoneCode:function phoneCode(field,textAreaProps,form,formParams){return React.createElement('div',null,React.createElement('div',{style:{width:'40%',float:'left'}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:(0,_extends3.default)({},field,textAreaProps),form:form,formParams:formParams,onChange:_this.onWfChange})),React.createElement(_Resend2.default,{store:_this}));},emailCode:function emailCode(field,textAreaProps,form,formParams){return _this.itemRender.phoneCode(field,textAreaProps,form,formParams);}},_this.t=60,_initDefineProp(_this,'refreshForm',_descriptor,_this),_initDefineProp(_this,'step',_descriptor2,_this),_initDefineProp(_this,'verificationCode',_descriptor3,_this),_initDefineProp(_this,'showTimeout',_descriptor4,_this),_initDefineProp(_this,'sendBtnLabel',_descriptor5,_this),_initDefineProp(_this,'spinning',_descriptor6,_this),_initDefineProp(_this,'getDialogInfo',_descriptor7,_this),_this.initData=function(langid,getDialogInfo,callback){_this.id=null;_this.langid=langid;_this.validatecode=null;_this.type=null;_this.targetInfo='';_this.step=1;_this.getDialogInfo=getDialogInfo;_this.spinning=true;api.getForgotPasswordForm({languageId:_this.langid}).then(function(data){if(data.status==='1'){_this.setFormData('findPasswordForm',data.conditions);_this.spinning=false;if(_this.formTarget.findPasswordForm.isFormInit){_this.refreshForm=new Date().getTime();callback&&callback();}}},function(error){return _this.spinning=false;});},_initDefineProp(_this,'refreshVerificationCode',_descriptor8,_this),_initDefineProp(_this,'reset',_descriptor9,_this),_initDefineProp(_this,'getValidateCodeParam',_descriptor10,_this),_initDefineProp(_this,'getInfoContent',_descriptor11,_this),_initDefineProp(_this,'forgotPasswordToNext',_descriptor12,_this),_initDefineProp(_this,'getCheckForm',_descriptor13,_this),_initDefineProp(_this,'checkFormInfo',_descriptor14,_this),_initDefineProp(_this,'doCheck',_descriptor15,_this),_initDefineProp(_this,'save',_descriptor16,_this),_initDefineProp(_this,'passwordVerification',_descriptor17,_this),_initDefineProp(_this,'resendVCode',_descriptor18,_this),_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}/********************* unobservable list *********************//********************* unobservable list *********************//********************* dialog info setting *********************//********************* dialog info setting *********************//********************* observable list *********************//********************* observable list *********************//********************* computed list *********************//********************* computed list *********************//********************* action list *********************/return HrmForgetPassword;}(_baseStore2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'refreshForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Date().getTime();}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'step',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'verificationCode',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'/weaver/weaver.file.MakeValidateCode?from=_forgort&isView=1&validatetype=0&validatenum=4&seriesnum_='+new Date().getTime();}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'showTimeout',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'sendBtnLabel',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'spinning',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'getDialogInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){return function(){};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'refreshVerificationCode',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){_this2.verificationCode='/weaver/weaver.file.MakeValidateCode?from=_forgort&isView=1&validatetype=0&validatenum=4&&seriesnum_='+new Date().getTime();};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'reset',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){_this3.spinning=true;api.getForgotPasswordForm({languageId:_this3.langid}).then(function(data){if(data.status==='1'){_this3.setFormData('findPasswordForm',data.conditions);_this3.spinning=false;_this3.id=null;_this3.validatecode=null;_this3.type=null;_this3.step=1;}},function(error){return _this3.spinning=false;});};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'getValidateCodeParam',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){var params=_this4.formTarget.findPasswordForm.getFormParams();return{validatecode:params.validatecode,loginid:params.loginid,languageId:_this4.langid};};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'getInfoContent',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(type){var content=type==='phoneCode'?_i18n.i18n.message.checkPhoneVCode():_i18n.i18n.message.checkMailVCode();content=content.replace('{params}',_this5.targetInfo);return content;};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'forgotPasswordToNext',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(){if(_this6.spinning)return;_this6.spinning=true;_this6.formTarget.findPasswordForm.validateForm().then(function(f){if(f.isValid){var formData=_this6.formTarget.findPasswordForm.getFormParams();api.forgotPasswordCheckMsg((0,_extends3.default)({},formData,{languageId:_this6.langid})).then(function(data){if(data.status==='1'){_this6.id=data.id;api.forgotPasswordToNext((0,_extends3.default)({id:_this6.id},formData,{languageId:_this6.langid})).then(function(data){if(data.status==='1'){_this6.targetInfo=data.id;if(formData.type!='-1'){_this6.hint({content:React.createElement('div',null,React.createElement('div',null,_this6.getInfoContent(formData.type)),React.createElement('div',null,_i18n.i18n.message.checkVCode()))});_this6.getCheckForm().then(function(data){if(data.status==='1'){_this6.setFormData('checkForm',data.conditions);_this6.step=2;if(['phoneCode','emailCode'].indexOf(formData.type)>-1){_this6.t=60;_this6.sendBtnLabel=_this6.t.toString()+'s';_this6.showTimeout=false;_this6.checkTimer=setInterval(function(){_this6.sendBtnLabel=(--_this6.t).toString()+'s';if(_this6.t===0){_this6.showTimeout=true;_this6.sendBtnLabel=_i18n.i18n.button.resend();clearInterval(_this6.checkTimer);}},1000);}}else{_this6.hint({content:data.message});_this6.refreshVerificationCode();}_this6.spinning=false;});}else{_this6.getCheckForm().then(function(data){if(data.status==='1'){_this6.setFormData('checkForm',data.conditions);_this6.step=2;}else{_this6.hint({content:data.message});_this6.refreshVerificationCode();}_this6.spinning=false;});}}else{_this6.hint({content:data.message});_this6.spinning=false;_this6.refreshVerificationCode();}},function(error){_this6.spinning=false;_this6.refreshVerificationCode();});}else{_this6.hint({content:data.message});_this6.refreshVerificationCode();_this6.spinning=false;}},function(error){_this6.spinning=false;_this6.refreshVerificationCode();});}else{_this6.spinning=false;_this6.refreshVerificationCode();f.showErrors();_this6.showError=new Date().getTime();}});};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'getCheckForm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){switch(_this7.formTarget.findPasswordForm.getFormParams().type){case'phoneCode':return api.confirmPhoneCodeForm(_this7.getValidateCodeParam());case'-1':return api.passwordQuestionForm(_this7.getValidateCodeParam());case'emailCode':return api.confirmEmailCodeForm(_this7.getValidateCodeParam());}};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'checkFormInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){if(_this8.spinning)return;_this8.spinning=true;_this8.formTarget.checkForm.validateForm().then(function(f){if(f.isValid){var formData=_this8.formTarget.checkForm.getFormParams();var findPasswordFormData=_this8.formTarget.findPasswordForm.getFormParams();var params=(0,_extends3.default)({id:_this8.id},findPasswordFormData,formData,{languageId:_this8.langid});_this8.doCheck(params).then(function(data){if(data.status==='1'){api.resetPasswordForm(params).then(function(data){if(data.status==='1'){_this8.setFormData('passwordForm',data.conditions);_this8.step=3;}else{_antd.message.error(data.message);_this8.refreshVerificationCode();}},function(error){_this8.refreshVerificationCode();});}else{_antd.message.error(data.message);_this8.refreshVerificationCode();}_this8.spinning=false;},function(error){_this8.spinning=false;_this8.refreshVerificationCode();});}else{_this8.spinning=false;f.showErrors();_this8.showError=new Date().getTime();_this8.refreshVerificationCode();}});};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'doCheck',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this9=this;return function(params){switch(_this9.formTarget.findPasswordForm.getFormParams().type){case'phoneCode':return api.confirmPhoneCodeToNext(params);case'-1':return api.passwordQuestionToNext(params);case'emailCode':return api.confirmEmailCodeToNext(params);}};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'save',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this10=this;return function(){if(_this10.spinning)return;_this10.spinning=true;_this10.formTarget.passwordForm.validateForm().then(function(f){if(f.isValid){var formData=_this10.formTarget.passwordForm.getFormParams();if(formData.newpswd!=formData.cfmpswd){_antd.message.error(_i18n.i18n.message.doubleCheckPwdFaild());_this10.spinning=false;_this10.refreshVerificationCode();return;}var fields=_this10.formTarget.passwordFormFields;var otherParams=fields[0].items[0].otherParams;if(!_this10.passwordVerification(formData.cfmpswd,otherParams.minpasslen,otherParams.passwordComplexity)){_this10.spinning=false;_this10.refreshVerificationCode();return;}api.saveResetPassword((0,_extends3.default)({id:_this10.id},_this10.formTarget.findPasswordForm.getFormParams(),_this10.formTarget.checkForm.getFormParams(),_this10.formTarget.passwordForm.getFormParams(),{languageId:_this10.langid})).then(function(data){if(data.status==='1'){_antd.message.success(_i18n.i18n.message.saveSuccess());_this10.getDialogInfo()&&_this10.getDialogInfo().close();}else{_antd.message.error(data.message);_this10.refreshVerificationCode();}});_this10.spinning=false;}else{_this10.spinning=false;f.showErrors();_this10.showError=new Date().getTime();_this10.refreshVerificationCode();}});};}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'passwordVerification',[_mobx.action],{enumerable:true,initializer:function initializer(){return function(val,minPassLen,passwordComplexity){var checkpass=true;if(val.length<minPassLen){_antd.message.error(_i18n.i18n.message.pwdLen()+minPassLen);return false;}else if(passwordComplexity=="1"){var complexity11=/[a-z]+/;var complexity12=/[A-Z]+/;var complexity13=/\d+/;if(complexity11.test(val)&&complexity12.test(val)&&complexity13.test(val)){checkpass=true;}else{_antd.message.error(_i18n.i18n.message.pwdType());checkpass=false;}}else if(passwordComplexity=="2"){var complexity21=/[a-zA-Z_]+/;var complexity22=/\W+/;var complexity23=/\d+/;if(complexity21.test(val)&&complexity22.test(val)&&complexity23.test(val)){checkpass=true;}else{_antd.message.error(_i18n.i18n.message.pwdType1());checkpass=false;}}return checkpass;};}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'resendVCode',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){if(_this11.spinning)return;if(_this11.showTimeout){_this11.spinning=true;var formData=_this11.formTarget.findPasswordForm.getFormParams();var checkFormParams=_this11.formTarget.checkForm.getFormParams();if(checkFormParams.validatecode===''){_this11.formTarget.checkForm.showError('validatecode',getLabel('84270',"请输入验证码"));_this11.spinning=false;_this11.refreshVerificationCode();return;}api.forgotPasswordToNext((0,_extends3.default)({id:_this11.id},formData,{languageId:_this11.langid,validatecode:checkFormParams.validatecode})).then(function(data){if(data.status==='1'){_this11.formTarget.checkForm.resetConditionValue();_this11.refreshVerificationCode();_this11.showTimeout=false;_this11.targetInfo=data.id;_this11.hint({content:React.createElement('div',null,React.createElement('div',null,_this11.getInfoContent(formData.type)),React.createElement('div',null,_i18n.i18n.message.checkVCode()))});_this11.t=60;_this11.sendBtnLabel=_this11.t.toString()+'s';_this11.checkTimer=setInterval(function(){_this11.sendBtnLabel=(--_this11.t).toString()+'s';if(_this11.t===0){_this11.showTimeout=true;_this11.sendBtnLabel=_i18n.i18n.button.resend();clearInterval(_this11.checkTimer);}},1000);}else{_this11.hint({content:data.message});_this11.refreshVerificationCode();}_this11.spinning=false;},function(error){_this11.spinning=false;_this11.refreshVerificationCode();});}};}})),_class);var hrmForgetPassword=exports.hrmForgetPassword=new HrmForgetPassword();

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.forgotPasswordCheckMsg=exports.confirmEmailCodeToNext=exports.confirmPhoneCodeToNext=exports.confirmEmailCodeForm=exports.confirmPhoneCodeForm=exports.saveResetPassword=exports.resetPasswordForm=exports.passwordQuestionToNext=exports.passwordQuestionForm=exports.forgotPasswordToNext=exports.getForgotPasswordForm=undefined;var _ecCom=__webpack_require__(0);var getForgotPasswordForm=exports.getForgotPasswordForm=function getForgotPasswordForm(params){return _ecCom.WeaTools.callApi('/api/hrm/forgotPassword/getForgotPasswordForm','POST',params);};var forgotPasswordToNext=exports.forgotPasswordToNext=function forgotPasswordToNext(params){return _ecCom.WeaTools.callApi('/api/hrm/forgotPassword/forgotPasswordToNext','POST',params);};var passwordQuestionForm=exports.passwordQuestionForm=function passwordQuestionForm(params){return _ecCom.WeaTools.callApi('/api/hrm/forgotPassword/passwordQuestionForm','POST',params);};var passwordQuestionToNext=exports.passwordQuestionToNext=function passwordQuestionToNext(params){return _ecCom.WeaTools.callApi('/api/hrm/forgotPassword/passwordQuestionToNext','POST',params);};var resetPasswordForm=exports.resetPasswordForm=function resetPasswordForm(params){return _ecCom.WeaTools.callApi('/api/hrm/forgotPassword/resetPasswordForm','POST',params);};var saveResetPassword=exports.saveResetPassword=function saveResetPassword(params){return _ecCom.WeaTools.callApi('/api/hrm/forgotPassword/saveResetPassword','POST',params);};var confirmPhoneCodeForm=exports.confirmPhoneCodeForm=function confirmPhoneCodeForm(params){return _ecCom.WeaTools.callApi('/api/hrm/forgotPassword/confirmPhoneCodeForm','POST',params);};var confirmEmailCodeForm=exports.confirmEmailCodeForm=function confirmEmailCodeForm(params){return _ecCom.WeaTools.callApi('/api/hrm/forgotPassword/confirmEmailCodeForm','POST',params);};var confirmPhoneCodeToNext=exports.confirmPhoneCodeToNext=function confirmPhoneCodeToNext(params){return _ecCom.WeaTools.callApi('/api/hrm/forgotPassword/confirmPhoneCodeToNext','POST',params);};var confirmEmailCodeToNext=exports.confirmEmailCodeToNext=function confirmEmailCodeToNext(params){return _ecCom.WeaTools.callApi('/api/hrm/forgotPassword/confirmEmailCodeToNext','POST',params);};var forgotPasswordCheckMsg=exports.forgotPasswordCheckMsg=function forgotPasswordCheckMsg(params){return _ecCom.WeaTools.callApi('/api/hrm/forgotPassword/forgotPasswordCheckMsg','POST',params);};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(9);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(7);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _i18n=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Resend=(0,_mobxReact.observer)(_class=function(_Component){(0,_inherits3.default)(Resend,_Component);function Resend(props){(0,_classCallCheck3.default)(this,Resend);return(0,_possibleConstructorReturn3.default)(this,(Resend.__proto__||(0,_getPrototypeOf2.default)(Resend)).call(this,props));}(0,_createClass3.default)(Resend,[{key:'render',value:function render(){var store=this.props.store;var showTimeout=store.showTimeout,t=store.t,resendVCode=store.resendVCode,sendBtnLabel=store.sendBtnLabel;return _react2.default.createElement('div',{style:{float:'left'}},showTimeout&&_react2.default.createElement('div',{style:{color:'red',float:'left',marginLeft:20}},_i18n.i18n.message.vCodeExpired()),_react2.default.createElement(_antd.Button,{type:t>0?'default':'primary',style:{float:'left',marginLeft:20},onClick:resendVCode},sendBtnLabel));}}]);return Resend;}(_react.Component))||_class;exports.default=Resend;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmApplicant=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _keys=__webpack_require__(111);var _keys2=_interopRequireDefault(_keys);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33,_descriptor34,_descriptor35;//TODO
var _applicant=__webpack_require__(644);var Api=_interopRequireWildcard(_applicant);var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _util=__webpack_require__(128);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var confirm=_antd.Modal.confirm;var getSearchsAd=_util.tabs.getSearchsAd,getButtonsAd=_util.tabs.getButtonsAd;var HrmApplicant=exports.HrmApplicant=(_class=function(){function HrmApplicant(){var _this2=this;(0,_classCallCheck3.default)(this,HrmApplicant);_initDefineProp(this,'main',_descriptor,this);_initDefineProp(this,'getAuth',_descriptor2,this);_initDefineProp(this,'grantAuth',_descriptor3,this);_initDefineProp(this,'stoploading',_descriptor4,this);this.refresh=function(){_this2.getRadioGroupDatas();};this.onresize=function(){var key=_this2.tabs.key;[0,1].map(function(val){_this2.barCharts['echart'+val]&&_this2.barCharts['echart'+val].chart&&_this2.barCharts['echart'+val].chart.resize();});_this2.tabs['echart'+key]&&_this2.tabs['echart'+key].chart&&_this2.tabs['echart'+key].chart.resize();};_initDefineProp(this,'top',_descriptor5,this);_initDefineProp(this,'getMenus',_descriptor6,this);_initDefineProp(this,'handleTopBtnsClick',_descriptor7,this);this.detailInfo=function(type){_this2.openDialog(type);};_initDefineProp(this,'radioGroup',_descriptor8,this);_initDefineProp(this,'getRadioGroupDatas',_descriptor9,this);_initDefineProp(this,'resetRadioGroup',_descriptor10,this);_initDefineProp(this,'radioGroupCallBack',_descriptor11,this);_initDefineProp(this,'barCharts',_descriptor12,this);_initDefineProp(this,'getBarChartsDatas',_descriptor13,this);_initDefineProp(this,'adjustCharts',_descriptor14,this);this.getYAxisData=function(datas){var nd=[],ids=[];datas.map(function(data){data.split(' ').map(function(d,i){if(i==0){nd.push(d);}else{ids.push(d.split(':')[1].split('}')[0]);}});});_this2.barCharts.ids=ids;return nd;};this.getAxisLabel=function(){var _this=_this2;return{formatter:function formatter(value){var len=_this.getValueLength(value);if(len>12){return _this.sliceValue(value,12)+'...';}else{return value;}}};};this.getValueLength=function(values){var len=0;values.split('').map(function(v,i){var a=v.charAt(i);if(a.match(/[^\x00-\xff]/ig)!=null){len+=2;}else{len+=1;}});return len;};_initDefineProp(this,'resetBarCharts',_descriptor15,this);_initDefineProp(this,'setRef',_descriptor16,this);_initDefineProp(this,'tabs',_descriptor17,this);_initDefineProp(this,'getTabsDatas',_descriptor18,this);this.adjustChart=function(charts){charts.map(function(chart,index){var option=chart.option,series=option.series,legend=option.legend;var arr=[];legend.data.map(function(d){arr.push(d.split('{')[0]);});option.legend.data=arr;var datas=series[0].data;var ids=[];datas.map(function(data){data.name.split('{').map(function(d,i){if(i==0){data.name=d;}else{ids.push(d.split(':')[1].split('}')[0]);}});data.label=_this2.formatLabel(datas.length);});_this2.tab['ids'+index]=ids;});};_initDefineProp(this,'resetTabs',_descriptor19,this);_initDefineProp(this,'tabsCallback',_descriptor20,this);_initDefineProp(this,'query',_descriptor21,this);_initDefineProp(this,'inputCallback',_descriptor22,this);_initDefineProp(this,'resetQuery',_descriptor23,this);_initDefineProp(this,'mainDialog',_descriptor24,this);_initDefineProp(this,'openDialog',_descriptor25,this);_initDefineProp(this,'closeDialog',_descriptor26,this);_initDefineProp(this,'tab',_descriptor27,this);_initDefineProp(this,'changePanelStatus',_descriptor28,this);_initDefineProp(this,'handleSearch',_descriptor29,this);_initDefineProp(this,'getSearchCondition',_descriptor30,this);_initDefineProp(this,'resetTab',_descriptor31,this);_initDefineProp(this,'setSearchBaseValue',_descriptor32,this);_initDefineProp(this,'table',_descriptor33,this);_initDefineProp(this,'getTableInfo',_descriptor34,this);_initDefineProp(this,'resetTable',_descriptor35,this);}//*************************Top*******************************
(0,_createClass3.default)(HrmApplicant,[{key:'sliceValue',value:function sliceValue(value,len){var _this3=this;var temp=[];var count=0;value.split('').map(function(val){if(count<len){temp.push(val);count+=_this3.checkIsChinese(val)?2:1;}});return temp.join('');}},{key:'checkIsChinese',value:function checkIsChinese(val){var reg=new RegExp('[\\u4E00-\\u9FFF]+',"g");if(reg.test(val))return true;}//*************************Tabs*******************************
},{key:'formatLabel',value:function formatLabel(length){if(length<10){return{normal:{formatter:['{title|{b}}{abg|}','{c} | {rate|{d}%}'].join('\n'),rich:{title:{color:'#666',align:'center'},abg:{width:'100%',align:'right',height:25},rate:{fontFamily:'Times New Roman'}}}};}else{return{normal:{formatter:['{b} | {c} | {d}%'].join('\n')}};}}//*************************Query*******************************
//*************************MainDialog*******************************
},{key:'menus',get:function get(){var _this4=this;var top=this.top.menu.filter(function(item){return item.isTop=='1';}),right=this.top.menu;var buttons=[],dropMenuDatas=[];top.map(function(item){buttons.push(React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this4.handleTopBtnsClick(item);}},item.menuName));//TODO
});right.map(function(item,index){var obj={key:item.menuFun,icon:React.createElement('i',{className:''+item.menuIcon}),content:item.menuName,onClick:function onClick(){return _this4[item.menuFun](item.menuFun);}};if(['log','collection'].includes(item.menuFun)){obj.disabled=true;}dropMenuDatas.push(obj);});return{buttons:buttons,dropMenuDatas:dropMenuDatas};}//*************************RadioGroup*******************************
//*************************BarCharts*******************************
},{key:'buttons',get:function get(){var tableStore=this.table.tableStore;var buttons=[React.createElement(_antd.Button,{type:'primary',disabled:tableStore.loading,onClick:function onClick(){return tableStore.exportAll();}},getLabel('28343',"导出Excel")),React.createElement(_ecCom.WeaMoreButton,{datas:this.dropMenuDatas})];return buttons;}},{key:'style',get:function get(){var type=this.mainDialog.type;return{width:type=='more'?800:1050,height:700};}},{key:'dropMenuDatas',get:function get(){var tableStore=this.table.tableStore,loading=tableStore.loading,exportAll=tableStore.exportAll,setColSetVisible=tableStore.setColSetVisible,tableColSet=tableStore.tableColSet;var datas=[];['0','1'].map(function(v){datas.push({key:v,disabled:loading,icon:React.createElement('i',{className:'icon-coms-'+(v=='0'?'export':'Custom')}),content:v=='0'?getLabel('28343',"导出Excel"):getLabel('32535','显示列定制'),onClick:function onClick(){return v=='0'?exportAll():setColSetVisible(true)&&tableColSet(true);}});});return datas;}//*************************Tab*******************************
},{key:'buttonsAd',get:function get(){var _this5=this;var form=this.tab.form;return getButtonsAd({form:form,search:function search(){return _this5.handleSearch();},cancel:function cancel(){return _this5.changePanelStatus();}});}},{key:'searchsAd',get:function get(){var _tab=this.tab,form=_tab.form,conditions=_tab.conditions,isFormInit=form.isFormInit;return getSearchsAd({isFormInit:isFormInit,conditions:conditions,form:form});}//*************************table*******************************
}]);return HrmApplicant;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'main',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{authorized:false,loading:true};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'getAuth',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(){Api.getAuth().then(function(cb){var status=cb.status,hasRight=cb.hasRight;if(status=='1'){hasRight&&_this6.grantAuth();_this6.stoploading();}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'grantAuth',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){_this7.main.authorized=true;};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'stoploading',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){_this8.main.loading=false;};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'top',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{title:getLabel('391168',"应聘人员"),menu:[]};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'getMenus',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this9=this;return function(){(0,_util.fetch)({Api:Api,name:'getButtonsMenu',logic:function logic(cb){_this9.top.menu=cb.btnMenu;}});};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'handleTopBtnsClick',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this10=this;return function(item){_this10[item.menuFun]&&_this10[item.menuFun](item.menuFun);};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'radioGroup',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{config:[],loading:false};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'getRadioGroupDatas',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){_this11.radioGroup.loading=true;(0,_util.fetch)({Api:Api,name:'getRadioGroupDatas',logic:function logic(cb){['config','loading'].map(function(v,i){_this11.radioGroup[v]=i==0?cb.conditions[0].items:false;});}});};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'resetRadioGroup',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this12=this;return function(){['config','loading'].map(function(v,i){_this12.radioGroup[v]=i==0?[]:false;});};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'radioGroupCallBack',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this13=this;return function(params){var createDateSelect=params.createDateSelect,createYear=params.createYear;_this13.radioGroup.params=params;if(createDateSelect=='6'&&!createYear){return;}['getBarChartsDatas','getTabsDatas'].map(function(f){_this13[f]();});};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'barCharts',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{charts:[],loading:false};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'getBarChartsDatas',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this14=this;return function(){_this14.barCharts.loading=true;(0,_util.fetch)({Api:Api,name:'getBarChartsDatas',fetchParams:_this14.radioGroup.params,logic:function logic(cb){_this14.adjustCharts(cb.charts);['charts','loading'].map(function(v,i){_this14.barCharts[v]=i==0?cb[v]:false;});}});};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'adjustCharts',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this15=this;return function(charts){var yAxis=charts[0].option.yAxis,series=charts[0].option.series,data=series[0].data;series[0].barWidth=data.length*9+'%';yAxis.data=_this15.getYAxisData(yAxis.data);charts[0].option.yAxis.axisLabel=_this15.getAxisLabel();};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'resetBarCharts',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this16=this;return function(){['charts','loading'].map(function(v,i){_this16.barCharts[v]=i==0?[]:false;});};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'setRef',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this17=this;return function(params){var ref=params.ref,alias=params.alias,type=params.type;if(type=='barCharts'){_this17.barCharts[alias]=ref;}else{_this17.tabs[alias]=ref;}};}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'tabs',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{charts:[],key:'0',loading:false};}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'getTabsDatas',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this18=this;return function(){_this18.tabs.loading=true;var params=_this18.radioGroup.params,key=_this18.tabs.key,value=_this18.query.value;var fetchParams=(0,_extends3.default)({},params);if(key=='2'){(0,_assign2.default)(fetchParams,{salaryNeedeRand:value?value:5});}if(key=='3'){(0,_assign2.default)(fetchParams,{workTimeRand:value?value:2});}(0,_util.fetch)({Api:Api,name:'getTabsDatas',fetchParams:fetchParams,logic:function logic(cb){var chart=cb.chart;_this18.adjustChart(chart);['charts','loading'].map(function(v,i){_this18.tabs[v]=i==0?chart:false;});}});};}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'resetTabs',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this19=this;return function(){['charts','key','loading'].map(function(v,i){_this19.tabs[v]=i==0?[]:i==1?'0':false;});};}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'tabsCallback',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this20=this;return function(key){_this20.tabs.key=key;_this20.getTabsDatas();};}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'query',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{value:''};}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'inputCallback',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this21=this;return function(value){_this21.query.value=value;};}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'resetQuery',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this22=this;return function(){_this22.query.value='';};}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'mainDialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{visible:false,title:''};}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'openDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this23=this;return function(type,field,isPie){var title=type=='more'?getLabel('391169',"应聘人最多岗位排名"):getLabel('15729',"具体信息");['type','title','visible'].map(function(v,i){_this23.mainDialog[v]=i==2?true:eval(v);});if(field&&!isPie){if((0,_keys2.default)(field).length>1){_this23.tab.field=field;_this23.barCharts.index='0';}else{_this23.barCharts.index='1';_this23.tab.createMonth=field;}}if(isPie){_this23.tab.pie_param=field;}};}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'closeDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this24=this;return function(){_this24.mainDialog.visible=false;};}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'tab',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{isPanelShow:false,conditionCount:10,//TODO
form:new _comsMobx.WeaForm(),conditions:[],searchBaseValue:''};}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'changePanelStatus',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this25=this;return function(bool){_this25.tab.isPanelShow=bool;};}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'handleSearch',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this26=this;return function(){var isPanelShow=_this26.tab.isPanelShow;isPanelShow&&_this26.changePanelStatus(false);_this26.getTableInfo();};}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'getSearchCondition',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this27=this;return function(){(0,_util.fetch)({Api:Api,name:'getSearchCondition',logic:function logic(cb){var conditions=cb.conditions;_this27.tab.conditions=conditions;_this27.tab.form.initFormFields(conditions);var _tab2=_this27.tab,field=_tab2.field,form=_tab2.form;field&&form.updateFields({jobtitleId:field});}});};}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'resetTab',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this28=this;return function(){var type=_this28.mainDialog.type;if(type=='more'){_this28.tab.searchBaseValue='';}else{['isPanelShow','conditions','form','field'].map(function(v,i){_this28.tab[v]=i==0?false:i==1?[]:i==2?new _comsMobx.WeaForm():'';});}};}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'setSearchBaseValue',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this29=this;return function(value){_this29.tab.searchBaseValue=value;};}}),_descriptor33=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{tableStore:new TableStore()};}}),_descriptor34=_applyDecoratedDescriptor(_class.prototype,'getTableInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this30=this;return function(){var _tab3=_this30.tab,form=_tab3.form,searchBaseValue=_tab3.searchBaseValue,field=_tab3.field,createMonth=_tab3.createMonth,pie_param=_tab3.pie_param,type=_this30.mainDialog.type,params=_this30.radioGroup.params,index=_this30.barCharts.index;var name=void 0,fetchParams=void 0;if(type=='more'){name='getApplyInfoRpList';fetchParams=(0,_extends3.default)({jobtitleName:searchBaseValue},params);}if(['bar','pie','detailInfo'].includes(type)){name='getDetailSearchList';if(form.isFormInit){fetchParams=form.getFormParams();}else{fetchParams=(0,_extends3.default)({},params);if(type=='bar'){(0,_assign2.default)(fetchParams,index=='0'?{jobtitleId:field.value}:createMonth);}if(type=='pie'){(0,_assign2.default)(fetchParams,pie_param);}}}(0,_util.fetch)({Api:Api,name:name,fetchParams:fetchParams,logic:function logic(cb){_this30.table.tableStore.getDatas(cb.sessionkey,1);}});};}}),_descriptor35=_applyDecoratedDescriptor(_class.prototype,'resetTable',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this31=this;return function(){_this31.table.tableStore=new TableStore();};}})),_class);

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getDetailSearchList=exports.getApplyInfoRpList=exports.getSearchCondition=exports.getTabsDatas=exports.getBarChartsDatas=exports.getRadioGroupDatas=exports.getButtonsMenu=exports.getAuth=undefined;var _ecCom=__webpack_require__(0);var getAuth=exports.getAuth=function getAuth(params){return _ecCom.WeaTools.callApi('/api/hrm/applyinfo/getHasRight','GET',params);};var getButtonsMenu=exports.getButtonsMenu=function getButtonsMenu(params){return _ecCom.WeaTools.callApi('/api/hrm/applyinforp/getRightMenu','GET',params);};var getRadioGroupDatas=exports.getRadioGroupDatas=function getRadioGroupDatas(params){return _ecCom.WeaTools.callApi('/api/hrm/applyinforp/getSearchCondition','GET',params);};var getBarChartsDatas=exports.getBarChartsDatas=function getBarChartsDatas(params){return _ecCom.WeaTools.callApi('/api/hrm/applyinforp/getRpResult','GET',params);};var getTabsDatas=exports.getTabsDatas=function getTabsDatas(params){return _ecCom.WeaTools.callApi('/api/hrm/applyinforp/getRpResult2','GET',params);};var getSearchCondition=exports.getSearchCondition=function getSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/applyinforp/getDetailSearchCondition','GET',params);};var getApplyInfoRpList=exports.getApplyInfoRpList=function getApplyInfoRpList(params){return _ecCom.WeaTools.callApi('/api/hrm/applyinforp/getMoreJobtitleList','GET',params);};var getDetailSearchList=exports.getDetailSearchList=function getDetailSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/applyinforp/getDetailSearchList','GET',params);};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmUsedemand=undefined;var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _extends3=__webpack_require__(12);var _extends4=_interopRequireDefault(_extends3);var _defineProperty4=__webpack_require__(38);var _defineProperty5=_interopRequireDefault(_defineProperty4);var _keys=__webpack_require__(111);var _keys2=_interopRequireDefault(_keys);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33,_descriptor34,_descriptor35;//TODO
var _useDemand=__webpack_require__(646);var Api=_interopRequireWildcard(_useDemand);var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty3.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var confirm=_antd.Modal.confirm;var HrmUsedemand=exports.HrmUsedemand=(_class=function(){function HrmUsedemand(){var _this2=this;(0,_classCallCheck3.default)(this,HrmUsedemand);_initDefineProp(this,'main',_descriptor,this);_initDefineProp(this,'getAuth',_descriptor2,this);_initDefineProp(this,'grantAuth',_descriptor3,this);_initDefineProp(this,'stoploading',_descriptor4,this);this.refresh=function(){_this2.getRadioGroupDatas();};this.onresize=function(){var key=_this2.tabs.key;[0,1,2].map(function(val){_this2.barCharts['echart'+val]&&_this2.barCharts['echart'+val].chart&&_this2.barCharts['echart'+val].chart.resize();});_this2.tabs['echart'+key]&&_this2.tabs['echart'+key].chart&&_this2.tabs['echart'+key].chart.resize();};_initDefineProp(this,'top',_descriptor5,this);_initDefineProp(this,'getMenus',_descriptor6,this);_initDefineProp(this,'handleTopBtnsClick',_descriptor7,this);this.exportExcel=function(){_this2.table.tableStore.exportAll();};_initDefineProp(this,'radioGroup',_descriptor8,this);_initDefineProp(this,'getRadioGroupDatas',_descriptor9,this);_initDefineProp(this,'resetRadioGroup',_descriptor10,this);_initDefineProp(this,'radioGroupCallBack',_descriptor11,this);_initDefineProp(this,'summary',_descriptor12,this);_initDefineProp(this,'getSummaryDatas',_descriptor13,this);_initDefineProp(this,'resetSummaryDatas',_descriptor14,this);_initDefineProp(this,'barCharts',_descriptor15,this);_initDefineProp(this,'getBarChartsDatas',_descriptor16,this);_initDefineProp(this,'adjustCharts',_descriptor17,this);this.getYAxisData=function(params){var datas=params.datas,index=params.index;var nd=[],tIds=[];datas.map(function(data){data.split(' ').map(function(d,i){if(i==0){nd.push(d);}else{tIds.push(d.split(':')[1].split('}')[0]);}});});_this2.barCharts[index=='0'?'lIds':'rIds']=tIds;return nd;};this.getAxisLabel=function(){var _this=_this2;return{formatter:function formatter(value){var len=_this.getValueLength(value);if(len>12){return _this.sliceValue(value,12)+'...';}else{return value;}}};};this.getValueLength=function(values){//TODO
var len=0;values.split('').map(function(v,i){var a=v.charAt(i);if(a.match(/[^\x00-\xff]/ig)!=null){len+=2;}else{len+=1;}});return len;};_initDefineProp(this,'resetBarCharts',_descriptor18,this);_initDefineProp(this,'setRef',_descriptor19,this);_initDefineProp(this,'tabs',_descriptor20,this);_initDefineProp(this,'getTabsDatas',_descriptor21,this);this.adjustChart=function(charts){charts.map(function(chart){var datas=chart.option.series[0].data;datas.map(function(d){d.label=_this2.formatLabel(datas.length);});});};_initDefineProp(this,'resetTabs',_descriptor22,this);_initDefineProp(this,'tabsCallback',_descriptor23,this);_initDefineProp(this,'mainDialog',_descriptor24,this);_initDefineProp(this,'openDialog',_descriptor25,this);_initDefineProp(this,'closeDialog',_descriptor26,this);_initDefineProp(this,'tab',_descriptor27,this);_initDefineProp(this,'changePanelStatus',_descriptor28,this);_initDefineProp(this,'handleSearch',_descriptor29,this);_initDefineProp(this,'getSearchCondition',_descriptor30,this);_initDefineProp(this,'resetTab',_descriptor31,this);_initDefineProp(this,'setSearchBaseValue',_descriptor32,this);_initDefineProp(this,'table',_descriptor33,this);_initDefineProp(this,'getTableInfo',_descriptor34,this);this.isEmptyObject=function(obj){if((0,_keys2.default)(obj)==0)return true;};_initDefineProp(this,'resetTable',_descriptor35,this);}//*************************Top*******************************
(0,_createClass3.default)(HrmUsedemand,[{key:'sliceValue',value:function sliceValue(value,len){var _this3=this;var temp=[];var count=0;value.split('').map(function(val){if(count<len){temp.push(val);count+=_this3.checkIsChinese(val)?2:1;}});return temp.join('');}},{key:'checkIsChinese',value:function checkIsChinese(val){var reg=new RegExp('[\\u4E00-\\u9FFF]+',"g");if(reg.test(val))return true;}//*************************Tabs*******************************
},{key:'formatLabel',value:function formatLabel(length){if(length<10){return{normal:{formatter:['{title|{b}}{abg|}','{c} | {rate|{d}%}'].join('\n'),rich:{title:{color:'#666',align:'center'},abg:{width:'100%',align:'right',height:25},rate:{fontFamily:'Times New Roman'}}}};}else{return{normal:{formatter:['{b} | {c} | {d}%'].join('\n')}};}}//*************************MainDialog*******************************
},{key:'menus',get:function get(){var _this4=this;var top=this.top.menu.filter(function(item){return item.isTop=='1';}),right=this.top.menu;var buttons=[],dropMenuDatas=[];var tableStore=this.table.tableStore;top.map(function(item){buttons.push(React.createElement(_antd.Button,{type:'primary',disabled:tableStore.loading,onClick:function onClick(){return _this4.handleTopBtnsClick(item);}},item.menuName));//TODO
});right.map(function(item,index){var obj={key:item.menuFun,icon:React.createElement('i',{className:''+item.menuIcon}),content:item.menuName,disabled:tableStore.loading,onClick:function onClick(){return _this4[item.menuFun](item.menuFun);}};if(item.menuFun=='log'||item.menuFun=='collection'){obj.disabled=true;}dropMenuDatas.push(obj);});return{buttons:buttons,dropMenuDatas:dropMenuDatas};}//*************************RadioGroup*******************************
//*************************Top*******************************
//*************************BarCharts*******************************
},{key:'buttons',get:function get(){var tableStore=this.table.tableStore;var buttons=[React.createElement(_antd.Button,{type:'primary',disabled:tableStore.loading,onClick:function onClick(){return tableStore.exportAll();}},getLabel('28343',"导出Excel")),React.createElement(_ecCom.WeaMoreButton,{datas:this.dropMenuDatas})];return buttons;}},{key:'style',get:function get(){var type=this.mainDialog.type;return{width:['more0','more1'].includes(type)?800:1050,height:700};}},{key:'dropMenuDatas',get:function get(){var tableStore=this.table.tableStore;var datas=[{key:'0',disabled:tableStore.loading,icon:React.createElement('i',{className:'icon-coms-export'}),content:getLabel('28343',"导出Excel"),onClick:function onClick(){return tableStore.exportAll();}},{key:'1',disabled:tableStore.loading,icon:React.createElement('i',{className:'icon-coms-Custom'}),content:getLabel('32535','显示列定制'),onClick:function onClick(){tableStore.setColSetVisible(true);tableStore.tableColSet(true);}}];return datas;}//*************************Tab*******************************
},{key:'buttonsAd',get:function get(){var _this5=this;var form=this.tab.form;var buttonsAd=[];[0,1,2].map(function(v){var func=v==0?'handleSearch':'changePanelStatus';var name=v==0?getLabel(82529,'搜索'):v==1?getLabel(27088,'重置'):getLabel(32694,'取消');buttonsAd.push(React.createElement(_antd.Button,{type:v==0?"primary":'',onClick:function onClick(){v==1?form.reset():_this5[func]();}},name));});return buttonsAd;}},{key:'searchsAd',get:function get(){var _tab=this.tab,form=_tab.form,conditions=_tab.conditions,field=_tab.field,isFormInit=form.isFormInit;var arr=[];isFormInit&&conditions.map(function(c){c.items.map(function(field,index){arr.push(React.createElement(_antd.Col,{span:10,offset:1},React.createElement('div',{style:{marginTop:20}},React.createElement(_ecCom.WeaFormItem,{label:''+field.label,labelCol:{span:6},wrapperCol:{span:18}},React.createElement(_comsMobx.WeaSwitch,{fieldConfig:field,form:form,formParams:form.getFormParams()})))));});});if(isFormInit&&field){var index=this.barCharts.index;form.updateFields((0,_defineProperty5.default)({},index=='0'?'departmentid':'jobtitleId',field));}return React.createElement(_antd.Row,null,arr);}//*************************table*******************************
}]);return HrmUsedemand;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'main',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{authorized:false,loading:true};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'getAuth',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(){Api.getAuth().then(function(cb){var status=cb.status,hasRight=cb.hasRight;if(status=='1'){hasRight&&_this6.grantAuth();_this6.getTableInfo();_this6.stoploading();}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'grantAuth',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){_this7.main.authorized=true;};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'stoploading',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){_this8.main.loading=false;};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'top',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{title:getLabel('6131',"用工需求"),//todo
menu:[]};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'getMenus',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this9=this;return function(){Api.getButtonsMenu().then(function(cb){var api_status=cb.api_status,btnMenu=cb.btnMenu;if(api_status){_this9.top.menu=btnMenu;}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'handleTopBtnsClick',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this10=this;return function(item){_this10[item.menuFun]&&_this10[item.menuFun](item.menuFun);};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'radioGroup',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{config:[],loading:false};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'getRadioGroupDatas',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){_this11.radioGroup.loading=true;_this11.radioGroup.config=[];Api.getRadioGroupDatas().then(function(cb){var api_status=cb.api_status,conditions=cb.conditions;if(api_status){_this11.radioGroup.config=conditions[0].items;_this11.radioGroup.loading=false;}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'resetRadioGroup',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this12=this;return function(){_this12.radioGroup.config=[];_this12.radioGroup.loading=false;};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'radioGroupCallBack',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this13=this;return function(params){var demandRegDateSelect=params.demandRegDateSelect,demandRegYear=params.demandRegYear,company=params.company,subcompanyid=params.subcompanyid,departmentid=params.departmentid,jobtitle=params.jobtitle,jobtitleId=params.jobtitleId;_this13.radioGroup.params=params;['getBarChartsDatas','getSummaryDatas','getTabsDatas'].map(function(f){var b1=demandRegDateSelect=='6'&&!demandRegYear,b2=company=='1'&&!subcompanyid||company=='2'&&!departmentid,b3=jobtitle=='1'&&!jobtitleId;if([b1,b2,b3].some(function(b){return b;})){return;}_this13[f]();});};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'summary',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{countDatas:[],loading:false};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'getSummaryDatas',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this14=this;return function(){_this14.summary.loading=true;var _radioGroup$params=_this14.radioGroup.params,params=_radioGroup$params===undefined?{}:_radioGroup$params;Api.getSummaryDatas(params).then(function(cb){var api_status=cb.api_status,countDatas=cb.countDatas;if(api_status){_this14.summary.countDatas=countDatas;_this14.summary.loading=false;}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'resetSummaryDatas',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this15=this;return function(){_this15.summary.config=[];_this15.summary.loading=false;};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'barCharts',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{charts:[],loading:false};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'getBarChartsDatas',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this16=this;return function(){_this16.barCharts.loading=true;var _radioGroup$params2=_this16.radioGroup.params,params=_radioGroup$params2===undefined?{}:_radioGroup$params2;Api.getBarChartsDatas(params).then(function(cb){var api_status=cb.api_status,charts=cb.charts;if(api_status){_this16.adjustCharts(charts);_this16.barCharts.charts=charts;_this16.barCharts.loading=false;}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'adjustCharts',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this17=this;return function(charts){[0,1].map(function(v){var yAxis=charts[v].option.yAxis,series=charts[v].option.series,data=series[0].data;series[0].barWidth=data.length*9+'%';yAxis.data=_this17.getYAxisData({datas:yAxis.data,index:v});charts[v].option.yAxis.axisLabel=_this17.getAxisLabel();});};}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'resetBarCharts',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this18=this;return function(){_this18.barCharts.charts=[];_this18.barCharts.loading=false;};}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'setRef',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this19=this;return function(params){var ref=params.ref,alias=params.alias,type=params.type;if(type=='barCharts'){_this19.barCharts[alias]=ref;}else{_this19.tabs[alias]=ref;}};}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'tabs',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{charts:[],key:'0',loading:false};}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'getTabsDatas',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this20=this;return function(){_this20.tabs.loading=true;var _radioGroup$params3=_this20.radioGroup.params,params=_radioGroup$params3===undefined?{}:_radioGroup$params3;Api.getTabsDatas(params).then(function(cb){var api_status=cb.api_status,charts=cb.charts;if(api_status){_this20.adjustChart(charts);_this20.tabs.charts=charts;_this20.tabs.loading=false;}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'resetTabs',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this21=this;return function(){_this21.tabs.charts=[];_this21.tabs.key='0';_this21.tabs.loading=false;};}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'tabsCallback',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this22=this;return function(key){_this22.tabs.key=key;_this22.getTabsDatas();};}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'mainDialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{visible:false,title:''};}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'openDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this23=this;return function(params){var type=params.type,field=params.field,index=params.index;_this23.mainDialog.type=type;_this23.mainDialog.visible=true;_this23.tab.field=field;//TODO 拼接field
_this23.barCharts.index=index;var title=void 0;if(type=='more0'){title=getLabel('391170',"需求最多部门排名");}else if(type=='more1'){title=getLabel('391171',"需求最多岗位排名");}else{title=getLabel('15729',"具体信息");}_this23.mainDialog.title=title;};}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'closeDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this24=this;return function(){_this24.mainDialog.visible=false;};}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'tab',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{isPanelShow:false,conditionCount:10,//TODO
form:new _comsMobx.WeaForm(),conditions:[],searchBaseValue:''};}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'changePanelStatus',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this25=this;return function(bool){_this25.tab.isPanelShow=bool;};}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'handleSearch',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this26=this;return function(){var isPanelShow=_this26.tab.isPanelShow;isPanelShow&&_this26.changePanelStatus(false);_this26.getTableInfo();};}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'getSearchCondition',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this27=this;return function(){Api.getSearchCondition().then(function(rs){var api_status=rs.api_status,conditions=rs.conditions;if(api_status){_this27.tab.conditions=conditions;_this27.tab.form.initFormFields(conditions);}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'resetTab',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this28=this;return function(){_this28.tab.isPanelShow=false;_this28.tab.conditions=[];_this28.tab.form=new _comsMobx.WeaForm();};}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'setSearchBaseValue',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this29=this;return function(value){_this29.tab.searchBaseValue=value;};}}),_descriptor33=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{tableStore:new TableStore()};}}),_descriptor34=_applyDecoratedDescriptor(_class.prototype,'getTableInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this30=this;return function(){var _tab2=_this30.tab,form=_tab2.form,searchBaseValue=_tab2.searchBaseValue,field=_tab2.field,type=_this30.mainDialog.type,params=_this30.radioGroup.params,index=_this30.barCharts.index;var func=void 0;var cParams=void 0;if(type=='more0'){func='getMoreDeptList';cParams=(0,_extends4.default)({departmentName:searchBaseValue},params);}else if(type=='more1'){func='getMoreJobtitleList';cParams=(0,_extends4.default)({jobtitleName:searchBaseValue},params);}else{func='getDetailSearchList';cParams=form.isFormInit?form.getFormParams():(0,_extends4.default)((0,_defineProperty5.default)({},index=='0'?'departmentid':'jobtitleId',field&&field.value),params);(0,_assign2.default)(cParams,{jobtitleName:searchBaseValue});}Api[func](cParams).then(function(cb){var api_status=cb.api_status,sessionkey=cb.sessionkey;if(api_status){_this30.table.tableStore.getDatas(sessionkey,1);}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}}),_descriptor35=_applyDecoratedDescriptor(_class.prototype,'resetTable',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this31=this;return function(){_this31.table.tableStore=new TableStore();};}})),_class);

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getDetailSearchList=exports.getSummaryDatas=exports.getMoreJobtitleList=exports.getMoreDeptList=exports.getSearchCondition=exports.getTabsDatas=exports.getBarChartsDatas=exports.getRadioGroupDatas=exports.getButtonsMenu=exports.getAuth=undefined;var _ecCom=__webpack_require__(0);var getAuth=exports.getAuth=function getAuth(params){return _ecCom.WeaTools.callApi('/api/hrm/applyinfo/getHasRight','GET',params);};var getButtonsMenu=exports.getButtonsMenu=function getButtonsMenu(params){return _ecCom.WeaTools.callApi('/api/hrm/usedemandrp/getRightMenu','GET',params);};var getRadioGroupDatas=exports.getRadioGroupDatas=function getRadioGroupDatas(params){return _ecCom.WeaTools.callApi('/api/hrm/usedemandrp/getSearchCondition','GET',params);};var getBarChartsDatas=exports.getBarChartsDatas=function getBarChartsDatas(params){return _ecCom.WeaTools.callApi('/api/hrm/usedemandrp/getRpResult','GET',params);};var getTabsDatas=exports.getTabsDatas=function getTabsDatas(params){return _ecCom.WeaTools.callApi('/api/hrm/usedemandrp/getRpResult2','GET',params);};var getSearchCondition=exports.getSearchCondition=function getSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/usedemandrp/getDetailSearchCondition','GET',params);};var getMoreDeptList=exports.getMoreDeptList=function getMoreDeptList(params){return _ecCom.WeaTools.callApi('/api/hrm/usedemandrp/getMoreDeptList','GET',params);};var getMoreJobtitleList=exports.getMoreJobtitleList=function getMoreJobtitleList(params){return _ecCom.WeaTools.callApi('/api/hrm/usedemandrp/getMoreJobtitleList','GET',params);};var getSummaryDatas=exports.getSummaryDatas=function getSummaryDatas(params){return _ecCom.WeaTools.callApi('/api/hrm/usedemandrp/getRpResult3','GET',params);};var getDetailSearchList=exports.getDetailSearchList=function getDetailSearchList(params){return _ecCom.WeaTools.callApi('/api/hrm/usedemandrp/getDetailSearchList','GET',params);};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmTimeWageSummary=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13;var _timeWage=__webpack_require__(648);var Api=_interopRequireWildcard(_timeWage);var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmTimeWageSummary=exports.HrmTimeWageSummary=(_class=function(){function HrmTimeWageSummary(){var _this=this;(0,_classCallCheck3.default)(this,HrmTimeWageSummary);_initDefineProp(this,'main',_descriptor,this);_initDefineProp(this,'getAuth',_descriptor2,this);_initDefineProp(this,'grantAuth',_descriptor3,this);_initDefineProp(this,'stoploading',_descriptor4,this);this.refresh=function(){_this.getRadioGroupDatas();};_initDefineProp(this,'top',_descriptor5,this);_initDefineProp(this,'handleTopBtnsClick',_descriptor6,this);_initDefineProp(this,'radioGroup',_descriptor7,this);_initDefineProp(this,'getRadioGroupDatas',_descriptor8,this);_initDefineProp(this,'resetRadioGroup',_descriptor9,this);_initDefineProp(this,'radioGroupCallBack',_descriptor10,this);_initDefineProp(this,'table',_descriptor11,this);_initDefineProp(this,'getTableInfo',_descriptor12,this);_initDefineProp(this,'resetTable',_descriptor13,this);this.fetch=function(params){var name=params.name,_params$fetchParams=params.fetchParams,fetchParams=_params$fetchParams===undefined?{}:_params$fetchParams,logic=params.logic;Api[name](fetchParams).then(function(cb){var api_status=cb.api_status;if(api_status){logic(cb);}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}//*************************Top*******************************
(0,_createClass3.default)(HrmTimeWageSummary,[{key:'menus',get:function get(){var _this2=this;var top=this.top.menu.filter(function(item){return item.isTop=='1';}),right=this.top.menu;var buttons=[],dropMenuDatas=[];top.map(function(item){buttons.push(React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this2.handleTopBtnsClick(item);}},item.menuName));});right.map(function(item,index){var obj={key:item.menuFun,icon:React.createElement('i',{className:''+item.menuIcon}),content:item.menuName,onClick:function onClick(){return _this2[item.menuFun](item.menuFun);}};if(['log','collection'].includes(item.menuFun)){obj.disabled=true;}dropMenuDatas.push(obj);});return{buttons:buttons,dropMenuDatas:dropMenuDatas};}//*************************RadioGroup*******************************
//*************************table*******************************
}]);return HrmTimeWageSummary;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'main',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{authorized:false,loading:true};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'getAuth',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){Api.getAuth().then(function(cb){var status=cb.status,hasRight=cb.hasRight;if(status=='1'){hasRight&&_this3.grantAuth();_this3.stoploading();}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'grantAuth',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){_this4.main.authorized=true;};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'stoploading',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){_this5.main.loading=false;};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'top',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{title:getLabel('391166',"时间工资汇总"),menu:[]};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'handleTopBtnsClick',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(item){_this6[item.menuFun]&&_this6[item.menuFun](item.menuFun);};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'radioGroup',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{config:[],loading:false};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'getRadioGroupDatas',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){['loading','config'].map(function(v,i){_this7.radioGroup[v]=i==0?true:[];});_this7.fetch({name:'getRadioGroupDatas',logic:function logic(cb){['config','loading'].map(function(v,i){_this7.radioGroup[v]=i==0?cb.conditions[0].items:false;});}});};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'resetRadioGroup',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){['config','loading'].map(function(v,i){_this8.radioGroup[v]=i==0?[]:false;});};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'radioGroupCallBack',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this9=this;return function(params){var payYearSelect=params.payYearSelect,payYear=params.payYear;_this9.radioGroup.params=params;if(payYearSelect=='6'&&!payYear){return;}_this9.getTableInfo();};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{tableStore:new TableStore(),colNum:0,hasDatas:true};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'getTableInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this10=this;return function(){_this10.fetch({name:'getTableInfo',fetchParams:_this10.radioGroup.params,logic:function logic(cb){var sessionkey=cb.sessionkey,_cb$colNum=cb.colNum,colNum=_cb$colNum===undefined?0:_cb$colNum,_cb$hasDatas=cb.hasDatas,hasDatas=_cb$hasDatas===undefined?true:_cb$hasDatas;_this10.table.hasDatas=hasDatas;if(hasDatas){_this10.table.tableStore=new TableStore();_this10.table.tableStore.getDatas(sessionkey,1);_this10.table.colNum=colNum;}}});};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'resetTable',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){_this11.table.tableStore=new TableStore();};}})),_class);

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getTableInfo=exports.getRadioGroupDatas=exports.getAuth=undefined;var _ecCom=__webpack_require__(0);var getAuth=exports.getAuth=function getAuth(params){return _ecCom.WeaTools.callApi('/api/hrm/timesalaryrp/getHasRight','GET',params);};var getRadioGroupDatas=exports.getRadioGroupDatas=function getRadioGroupDatas(params){return _ecCom.WeaTools.callApi('/api/hrm/timesalaryrp/getSearchCondition','GET',params);};var getTableInfo=exports.getTableInfo=function getTableInfo(params){return _ecCom.WeaTools.callApi('/api/hrm/timesalaryrp/getSearchResult','GET',params);};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmStaffPayrollSummary=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20;var _staffPayroll=__webpack_require__(650);var Api=_interopRequireWildcard(_staffPayroll);var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmStaffPayrollSummary=exports.HrmStaffPayrollSummary=(_class=function(){function HrmStaffPayrollSummary(){var _this=this;(0,_classCallCheck3.default)(this,HrmStaffPayrollSummary);_initDefineProp(this,'main',_descriptor,this);_initDefineProp(this,'getAuth',_descriptor2,this);_initDefineProp(this,'grantAuth',_descriptor3,this);_initDefineProp(this,'stoploading',_descriptor4,this);this.refresh=function(){_this.getRadioGroupDatas();};_initDefineProp(this,'top',_descriptor5,this);_initDefineProp(this,'radioGroup',_descriptor6,this);_initDefineProp(this,'getRadioGroupDatas',_descriptor7,this);_initDefineProp(this,'resetRadioGroup',_descriptor8,this);_initDefineProp(this,'radioGroupCallBack',_descriptor9,this);_initDefineProp(this,'mainTable',_descriptor10,this);_initDefineProp(this,'getDeptSalaryList',_descriptor11,this);this.onOperatesClick=function(record,index,operate){var departmentid=record.departmentid;_this.mainTable.departmentid=departmentid;_this.openDialog();};this.reRenderColumns=function(c){c.map(function(item){if(item.dataIndex=='departmentid'){item.render=function(t,r){var departmentid=r.departmentid,departmentidspan=r.departmentidspan;return React.createElement('a',{onClick:function onClick(){_this.mainTable.departmentid=departmentid;_this.openDialog();}},departmentidspan?departmentidspan:departmentid);};}});};_initDefineProp(this,'resetTable',_descriptor12,this);_initDefineProp(this,'mainDialog',_descriptor13,this);_initDefineProp(this,'openDialog',_descriptor14,this);_initDefineProp(this,'closeDialog',_descriptor15,this);_initDefineProp(this,'tab',_descriptor16,this);_initDefineProp(this,'setSearchBaseValue',_descriptor17,this);this.handleSearch=function(){_this.getResourceSalaryList();};_initDefineProp(this,'resetTab',_descriptor18,this);_initDefineProp(this,'subTable',_descriptor19,this);_initDefineProp(this,'getResourceSalaryList',_descriptor20,this);this.fetch=function(params){var name=params.name,_params$fetchParams=params.fetchParams,fetchParams=_params$fetchParams===undefined?{}:_params$fetchParams,logic=params.logic;Api[name](fetchParams).then(function(cb){var api_status=cb.api_status;if(api_status){logic(cb);}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}//*************************Top*******************************
(0,_createClass3.default)(HrmStaffPayrollSummary,[{key:'menus',get:function get(){var _this2=this;var top=this.top.menu.filter(function(item){return item.isTop=='1';}),right=this.top.menu;var buttons=[],dropMenuDatas=[];top.map(function(item){buttons.push(React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this2.handleTopBtnsClick(item);}},item.menuName));});right.map(function(item,index){var obj={key:item.menuFun,icon:React.createElement('i',{className:''+item.menuIcon}),content:item.menuName,onClick:function onClick(){return _this2[item.menuFun](item.menuFun);}};if(['log','collection'].includes(item.menuFun)){obj.disabled=true;}dropMenuDatas.push(obj);});return{buttons:buttons,dropMenuDatas:dropMenuDatas};}//*************************RadioGroup*******************************
//*************************MainTable*******************************
//*************************MainDialog*******************************
},{key:'buttons',get:function get(){var buttons=[];return buttons;}},{key:'style',get:function get(){return{width:800,height:700};}},{key:'dropMenuDatas',get:function get(){var datas=[];return datas;}//*************************Tab*******************************
//*************************SubTable*******************************
}]);return HrmStaffPayrollSummary;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'main',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{authorized:false,loading:true};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'getAuth',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){Api.getAuth().then(function(cb){var status=cb.status,hasRight=cb.hasRight;if(status=='1'){hasRight&&_this3.grantAuth();_this3.stoploading();}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'grantAuth',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){_this4.main.authorized=true;};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'stoploading',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){_this5.main.loading=false;};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'top',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{title:getLabel('391167',"人员工资汇总"),menu:[]};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'radioGroup',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{config:[],loading:false};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'getRadioGroupDatas',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(){['loading','config'].map(function(v,i){_this6.radioGroup[v]=i==0?true:[];});_this6.fetch({name:'getRadioGroupDatas',logic:function logic(cb){['config','loading'].map(function(v,i){_this6.radioGroup[v]=i==0?cb.conditions[0].items:false;});}});};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'resetRadioGroup',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){['config','loading'].map(function(v,i){_this7.radioGroup[v]=i==0?[]:false;});};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'radioGroupCallBack',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this8=this;return function(params){var department=params.department,deptId=params.deptId,payYearSelect=params.payYearSelect,payYear=params.payYear;_this8.radioGroup.params=params;if(department=='1'&&!deptId){return;}if(payYearSelect=='6'&&!payYear){return;}_this8.getDeptSalaryList();};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'mainTable',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{tableStore:new TableStore(),colNum:0,hasDatas:true};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'getDeptSalaryList',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this9=this;return function(){_this9.fetch({name:'getDeptSalaryList',fetchParams:_this9.radioGroup.params,logic:function logic(cb){var sessionkey=cb.sessionkey,colNum=cb.colNum,_cb$hasDatas=cb.hasDatas,hasDatas=_cb$hasDatas===undefined?true:_cb$hasDatas;_this9.mainTable.hasDatas=hasDatas;if(hasDatas){_this9.mainTable.tableStore=new TableStore();_this9.mainTable.tableStore.getDatas(sessionkey,1);_this9.mainTable.colNum=colNum;}}});};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'resetTable',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this10=this;return function(params){var type=params.type;_this10[type=='main'?'mainTable':'subTable'].tableStore=new TableStore();};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'mainDialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{visible:false,title:''};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'openDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){_this11.mainDialog.visible=true;_this11.mainDialog.title=getLabel('391160',"详细");};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'closeDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this12=this;return function(){_this12.mainDialog.visible=false;};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'tab',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{searchBaseValue:''};}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'setSearchBaseValue',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this13=this;return function(val){_this13.tab.searchBaseValue=val;};}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'resetTab',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this14=this;return function(){_this14.setSearchBaseValue('');};}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'subTable',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{tableStore:new TableStore(),colNum:0};}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'getResourceSalaryList',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this15=this;return function(){var params=_this15.radioGroup.params;_this15.fetch({name:'getResourceSalaryList',fetchParams:(0,_extends3.default)({name:_this15.tab.searchBaseValue},(0,_assign2.default)({},params,{deptId:_this15.mainTable.departmentid})),logic:function logic(cb){var sessionkey=cb.sessionkey,colNum=cb.colNum;_this15.subTable.tableStore=new TableStore();_this15.subTable.tableStore.getDatas(sessionkey,1);_this15.subTable.colNum=colNum;}});};}})),_class);

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getResourceSalaryList=exports.getDeptSalaryList=exports.getRadioGroupDatas=exports.getAuth=undefined;var _ecCom=__webpack_require__(0);var getAuth=exports.getAuth=function getAuth(params){return _ecCom.WeaTools.callApi('/api/hrm/deptsalaryrp/getHasRight','GET',params);};var getRadioGroupDatas=exports.getRadioGroupDatas=function getRadioGroupDatas(params){return _ecCom.WeaTools.callApi('/api/hrm/deptsalaryrp/getSearchCondition','GET',params);};var getDeptSalaryList=exports.getDeptSalaryList=function getDeptSalaryList(params){return _ecCom.WeaTools.callApi('/api/hrm/deptsalaryrp/getDeptSalaryList','GET',params);};var getResourceSalaryList=exports.getResourceSalaryList=function getResourceSalaryList(params){return _ecCom.WeaTools.callApi('/api/hrm/deptsalaryrp/getResourceSalaryList','GET',params);};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmSecondaryVerify=undefined;var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _defineProperty4=__webpack_require__(38);var _defineProperty5=_interopRequireDefault(_defineProperty4);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8;var _secondaryVerify=__webpack_require__(652);var Api=_interopRequireWildcard(_secondaryVerify);var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _pyUtil=__webpack_require__(653);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty3.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmSecondaryVerify=exports.HrmSecondaryVerify=(_class=function(){function HrmSecondaryVerify(){var _this=this;(0,_classCallCheck3.default)(this,HrmSecondaryVerify);_initDefineProp(this,'date',_descriptor,this);_initDefineProp(this,'setDate',_descriptor2,this);_initDefineProp(this,'secondaryVerify',_descriptor3,this);this.isSettedSecondaryPwd=function(){(0,_pyUtil.fetch)({Api:Api,name:'isSettedSecondaryPwd',logic:function logic(cb){var isSetted=cb.isSetted;_this.secondaryVerify.loading=false;_this.secondaryVerify.isSetted=isSetted;if(isSetted){_this.mainDialog.isPassLoginPassword=true;}}});};this.setSecondaryVerify=function(){_this.openDialog({type:'set'});};this.modifySecondaryPass=function(){_this.openDialog({type:'modify'});};_initDefineProp(this,'mainDialog',_descriptor4,this);this.getButtonName=function(){var isPassLoginPassword=_this.mainDialog.isPassLoginPassword;var name=void 0;if(!isPassLoginPassword){name=getLabel('504372',"下一步");}else{name=getLabel('504373','保存');}return name;};this.getBtnCallback=function(){var isPassLoginPassword=_this.mainDialog.isPassLoginPassword;if(!isPassLoginPassword){_this.checkPassword();}else{_this.saveSecondaryPassword();}};this.checkPassword=function(){var form=_this.formInfo.form;form.validateForm().then(function(f){if(f.isValid){(0,_pyUtil.fetch)({Api:Api,name:'checkPassword',fetchParams:(0,_extends3.default)({},form.getFormParams()),logic:function logic(cb){var result=cb.result;_this.mainDialog.isPassLoginPassword=result;if(result){_this.setDialogTitle({type:'modify'});_this.resetFormInfo();_this.getFormConditions();}else{form.showError('password',getLabel('504343',"登录密码错误"));}}});}else{f.showErrors();}});};this.saveSecondaryPassword=function(){var _formInfo=_this.formInfo,form=_formInfo.form,passwordComplexity=_formInfo.passwordComplexity,minpasslen=_formInfo.minpasslen,isOldPwdPass=_formInfo.isOldPwdPass,isEqualToLoginPass=_formInfo.isEqualToLoginPass,_form$getFormParams=form.getFormParams(),secondaryPwd1=_form$getFormParams.secondaryPwd1,newSecondaryPwd1=_form$getFormParams.newSecondaryPwd1,secondaryPwd2=_form$getFormParams.secondaryPwd2,newSecondaryPwd2=_form$getFormParams.newSecondaryPwd2;var pwd1=secondaryPwd1||newSecondaryPwd1,pwd2=secondaryPwd2||newSecondaryPwd2;var key=secondaryPwd1?'secondaryPwd1':'newSecondaryPwd1';form.validateForm().then(function(f){if(f.isValid){if(newSecondaryPwd1&&!isOldPwdPass){form.showError('oldSecondaryPwd',getLabel('504374',"旧密码校验不通过！"));return;}if(isEqualToLoginPass){form.showError(key,getLabel('504375',"二次验证密码不能和登录密码相同"));return;}if(!_this.isEqual(pwd1,pwd2)){form.showError(secondaryPwd2?'secondaryPwd2':'newSecondaryPwd2',getLabel('504376',"密码确认不正确！"));return;}if(passwordComplexity!='0'&&!_this.isPassRegExp(pwd1,passwordComplexity)){var msg=void 0;if(passwordComplexity=='1'){msg=getLabel('504377',"新密码不符合要求，必须为字母大写、字母小写、数字组合！");}if(passwordComplexity=='2'){msg=getLabel('504378',"新密码不符合要求，必须为字母、数字、特殊字符组合！");}form.showError(key,msg);return;}if(!_this.isReachMinLen(pwd1,minpasslen)){form.showError(key,''+getLabel('504379',"密码长度不能小于")+minpasslen);return;}(0,_pyUtil.fetch)({Api:Api,name:'saveSecondaryPwd',fetchParams:(0,_extends3.default)({},form.getFormParams()),logic:function logic(cb){var sign=cb.sign;if(sign=='1'){_antd.message.success(cb.message);_this.secondaryVerify.isSetted=true;_this.closeDialog();}else{_antd.message.warning(cb.message);_this.setDate();}}});}else{f.showErrors();}});};this.isEqual=function(secondaryPwd1,secondaryPwd2){if(secondaryPwd1!==secondaryPwd2){return false;}return true;};this.isPassRegExp=function(secondaryPwd1,passwordComplexity){var regExp=void 0;var isPassRegExp=true;if(passwordComplexity=='1'){regExp=[/[a-z]+/,/[A-Z]+/,/\d+/];}else{regExp=[/[a-zA-Z_]+/,/\W+/,/\d+/];}regExp.map(function(reg){if(!reg.test(secondaryPwd1)){isPassRegExp=false;}});return isPassRegExp;};this.isReachMinLen=function(secondaryPwd1,minpasslen){if(secondaryPwd1.length<minpasslen){return false;}return true;};this.getWidth=function(){var isPassLoginPassword=_this.mainDialog.isPassLoginPassword;var width=void 0;if(!isPassLoginPassword){width=600;}else{width=650;}return width;};this.getHeight=function(){var isPassLoginPassword=_this.mainDialog.isPassLoginPassword,c_len=_this.formInfo.c_len;var height=void 0;if(!isPassLoginPassword){height=90;}else{height=c_len===4?250:210;}return height;};this.getDropMenuIcon=function(isPassLoginPassword){var icon=void 0;if(!isPassLoginPassword){icon=React.createElement('i',{className:'icon-coms-Right'});}else{icon=React.createElement('i',{className:'icon-coms-Preservation'});}return icon;};this.getDropMenuContent=function(isPassLoginPassword){var name=void 0;if(!isPassLoginPassword){name=getLabel('504372',"下一步");}else{name=getLabel('504373','保存');}return name;};this.handleClick=function(isPassLoginPassword){if(!isPassLoginPassword){_this.checkPassword();}else{_this.saveSecondaryPassword();}};_initDefineProp(this,'openDialog',_descriptor5,this);_initDefineProp(this,'setDialogTitle',_descriptor6,this);_initDefineProp(this,'closeDialog',_descriptor7,this);_initDefineProp(this,'formInfo',_descriptor8,this);this.getFormConditions=function(){var isPassLoginPassword=_this.mainDialog.isPassLoginPassword;(0,_pyUtil.fetch)({Api:Api,name:!isPassLoginPassword?'getPasswordForm':'getSecondaryPwdForm',logic:function logic(cb){var conditions=cb.conditions,minpasslen=cb.minpasslen;if(minpasslen!==undefined){['minpasslen','passwordComplexity','title'].map(function(v){_this.formInfo[v]=cb[v];});}_this.handleConditions(conditions);_this.formInfo.c_len=conditions[0].items.length;_this.formInfo.conditions=conditions;_this.formInfo.form.initFormFields(conditions);_this.formInfo.loading=false;}});};this.handleConditions=function(conditions){var _formInfo2=_this.formInfo,passwordComplexity=_formInfo2.passwordComplexity,title=_formInfo2.title;conditions.map(function(c){c.items.map(function(item){var key=item.domkey[0];if(key!=='validatecode')item.otherParams={type:'password'};if(['secondaryPwd1','newSecondaryPwd1'].includes(key)){item.otherParams=(0,_assign2.default)(item.otherParams,{tip:title,passwordStrength:true});}});});};this.verifyPassword=function(params){var form=_this.formInfo.form,cb=params.cb,key=params.key;(0,_pyUtil.fetch)({Api:Api,name:key=='oldSecondaryPwd'?'checkOldSecondaryPwd':'checkNewSecondaryPwd',fetchParams:(0,_defineProperty5.default)({},key,cb),logic:function logic(cb){var result=cb.result;if(key=='oldSecondaryPwd'){_this.formInfo.isOldPwdPass=result;}else{_this.formInfo.isEqualToLoginPass=!result;}var msg=key=='oldSecondaryPwd'?getLabel('504374',"旧密码校验不通过！"):getLabel('504375',"二次验证密码不能和登录密码相同");if(!result){form.showError(key,msg);}}});};this.resetFormInfo=function(){_this.formInfo.conditions=[];_this.formInfo.form=new _comsMobx.WeaForm();_this.formInfo.loading=true;};this.resetSecondaryVerify=function(){_this.mainDialog.isPassLoginPassword=false;};}//*************************MainDialog********************************
(0,_createClass3.default)(HrmSecondaryVerify,[{key:'buttons',get:function get(){var _this2=this;var loading=this.formInfo.loading;var buttons=[React.createElement(_antd.Button,{type:'primary',disabled:loading,onClick:function onClick(){return _this2.getBtnCallback();}},this.getButtonName()),React.createElement(_ecCom.WeaMoreButton,{datas:this.dropMenuDatas})];return buttons;}},{key:'style',get:function get(){var style={width:this.getWidth(),height:this.getHeight()};return style;}},{key:'dropMenuDatas',get:function get(){var _this3=this,_dropMenuDatas$push;var isPassLoginPassword=this.mainDialog.isPassLoginPassword,loading=this.formInfo.loading;var dropMenuDatas=[];dropMenuDatas.push((_dropMenuDatas$push={key:'0',disabled:loading,icon:this.getDropMenuIcon(isPassLoginPassword),content:this.getDropMenuContent(isPassLoginPassword)},(0,_defineProperty5.default)(_dropMenuDatas$push,'disabled',loading),(0,_defineProperty5.default)(_dropMenuDatas$push,'onClick',function onClick(){return _this3.handleClick(isPassLoginPassword);}),_dropMenuDatas$push));return dropMenuDatas;}//*************************MainDialog********************************
}]);return HrmSecondaryVerify;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'date',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new Date();}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'setDate',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){_this4.date=new Date();};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'secondaryVerify',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{isSetted:false,loading:true};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'mainDialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{visible:false,title:'',isPassLoginPassword:false};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'openDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(params){_this5.setDialogTitle(params);_this5.mainDialog.visible=true;};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'setDialogTitle',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(params){var type=params.type;if(type=='set'){_this6.mainDialog.title=getLabel('504331',"请先输入登录密码");}if(type=='modify'){_this6.mainDialog.title=getLabel('504332',"二次验证密码设置");}};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'closeDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){_this7.mainDialog.visible=false;if(!_this7.secondaryVerify.isSetted){_this7.mainDialog.isPassLoginPassword=false;}};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'formInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{conditions:[],form:new _comsMobx.WeaForm(),loading:true,isOldPwdPass:false,isEqualToLoginPass:true,c_len:1};}})),_class);

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.checkNewSecondaryPwd=exports.checkOldSecondaryPwd=exports.saveSecondaryPwd=exports.checkPassword=exports.getSecondaryPwdForm=exports.getPasswordForm=exports.isSettedSecondaryPwd=undefined;var _ecCom=__webpack_require__(0);var isSettedSecondaryPwd=exports.isSettedSecondaryPwd=function isSettedSecondaryPwd(params){return _ecCom.WeaTools.callApi('/api/hrm/secondarypwd/isSettedSecondaryPwd','GET',params);};var getPasswordForm=exports.getPasswordForm=function getPasswordForm(params){return _ecCom.WeaTools.callApi('/api/hrm/secondarypwd/getPasswordForm','GET',params);};var getSecondaryPwdForm=exports.getSecondaryPwdForm=function getSecondaryPwdForm(params){return _ecCom.WeaTools.callApi('/api/hrm/secondarypwd/getSecondaryPwdForm','GET',params);};var checkPassword=exports.checkPassword=function checkPassword(params){return _ecCom.WeaTools.callApi('/api/hrm/secondarypwd/checkPassword','POST',params);};var saveSecondaryPwd=exports.saveSecondaryPwd=function saveSecondaryPwd(params){return _ecCom.WeaTools.callApi('/api/hrm/secondarypwd/saveSecondaryPwd','POST',params);};var checkOldSecondaryPwd=exports.checkOldSecondaryPwd=function checkOldSecondaryPwd(params){return _ecCom.WeaTools.callApi('/api/hrm/secondarypwd/checkOldSecondaryPwd','POST',params);};var checkNewSecondaryPwd=exports.checkNewSecondaryPwd=function checkNewSecondaryPwd(params){return _ecCom.WeaTools.callApi('/api/hrm/secondarypwd/checkNewSecondaryPwd','POST',params);};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetch=undefined;var _antd=__webpack_require__(6);var fetch=function fetch(params){var Api=params.Api,name=params.name,_params$fetchParams=params.fetchParams,fetchParams=_params$fetchParams===undefined?{}:_params$fetchParams,logic=params.logic;Api[name](fetchParams).then(function(cb){var api_status=cb.api_status;if(api_status){logic(cb);}else{_antd.message.error();}}).catch(function(error){_antd.message.error();});};exports.fetch=fetch;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.hrmSpaGroup=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _toConsumableArray2=__webpack_require__(74);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13;var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _hrmgroup=__webpack_require__(259);var api=_interopRequireWildcard(_hrmgroup);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var TableStore=_comsMobx.WeaTableNew.TableStore;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var confirm=_antd.Modal.confirm;var HrmSpaGroup=(_class=function(){function HrmSpaGroup(){var _this2=this;(0,_classCallCheck3.default)(this,HrmSpaGroup);this.TOP={showDropIcon:true,iconBgcolor:'#217346',icon:React.createElement('i',{className:'icon-coms-hrm'}),title:getLabel(81554,"常用组")};this.conf=[{func:'save',name:getLabel(86,'保存')},{func:'saveToDetail',name:getLabel(32159,'保存并进入详细设置')}];this.mConf=[{func:'importMember',name:getLabel(18596,'导入')},{func:'new',name:getLabel(82,'新建')},{func:'batchDel',name:getLabel(384127,'批量删除')}];this.getDisabled=function(type){var selectedKey=_this2.tab.selectedKey;var disabled=void 0;if(selectedKey==='0'){disabled=_this2.pageForm.loading;}else{var comsWeaTableStore=_this2.table.comsWeaTableStore,loading=comsWeaTableStore.loading,selectedRowKeys=comsWeaTableStore.selectedRowKeys;if(type==='batchDel'){disabled=selectedRowKeys.length===0;}else{disabled=loading;}}return disabled;};this.importStore=null;this.store=null;this.exportStore=function(importStore,store){_this2.importStore=importStore;_this2.store=store;};this.importMember=function(){var _importStore=_this2.importStore,setTempletName=_importStore.setTempletName,setImportDialogTitle=_importStore.setImportDialogTitle,setImportType=_importStore.setImportType,setImportDialogVisible=_importStore.setImportDialogVisible,setSourceStore=_importStore.setSourceStore,setOtherParams=_importStore.setOtherParams;setTempletName(getLabel(129833,'导入模板'));setImportDialogTitle(''+getLabel(382316,'常用组成员')+getLabel(18596,'导入'));setImportType('groupMember');setImportDialogVisible(true);setSourceStore(_this2.store);setOtherParams({groupid:_this2.groupId});};this.new=function(){var _tab=_this2.tab,selectedKey=_tab.selectedKey,ref=_tab.ref;if(selectedKey==='1'){ref&&ref.openModal();}if(selectedKey==='2'){_this2.dialog.visible=true;_this2.getShareScopeForm();}};_initDefineProp(this,'getShareScopeForm',_descriptor,this);this.batchDel=function(){var _this=_this2;confirm({title:getLabel('131329','信息确认'),content:getLabel('385625','确定要删除选择的记录吗？'),okText:getLabel('33703','确定'),cancelText:getLabel('32694','取消'),onOk:function onOk(){var selectedKey=_this.tab.selectedKey,comsWeaTableStore=_this.table.comsWeaTableStore,selectedRowKeys=comsWeaTableStore.selectedRowKeys;selectedRowKeys.forEach(function(id){_this.deleteTableRow(id);});},onCancel:function onCancel(){return false;}});};this.deleteTableRow=function(id){var selectedKey=_this2.tab.selectedKey;var params={groupid:_this2.groupId,id:id};if(selectedKey==='1'){(0,_assign2.default)(params,{cmd:'member'});}else{(0,_assign2.default)(params,{cmd:'share'});}if(_this2.f_weaver_belongto_userid){(0,_assign2.default)(params,{f_weaver_belongto_userid:_this2.f_weaver_belongto_userid});}api.deleteTableRow(params).then(function(data){var status=data.status;if(status==='1'){_antd.message.success(getLabel(506026,'删除成功'));_this2.getSearchList();}else{_antd.message.warning(getLabel(83473,'删除失败'));}},function(error){});};_initDefineProp(this,'pageForm',_descriptor2,this);_initDefineProp(this,'isPublicGroup',_descriptor3,this);_initDefineProp(this,'getHrmGroupForm',_descriptor4,this);_initDefineProp(this,'pageType',_descriptor5,this);this.groupId='';this.groupType='0';this.f_weaver_belongto_userid='';this.callback=function(type){var pDialog=top.window.getParentDialog();pDialog&&pDialog.callback(type);};this.save=function(){var selectedKey=_this2.tab.selectedKey;if(_this2.pageType==='2'&&selectedKey==='1'){_this2.saveTable(function(){return _this2.callback(1);});}else{_this2.saveForm(_this2.pageType,function(){return _this2.callback(0);});}};this.saveToDetail=function(){_this2.saveForm('2',function(){return _this2.callback(1);});};this.saveForm=function(type,callback){var form=_this2.pageForm.form;form.validateForm().then(function(f){if(f.isValid){var params=(0,_extends3.default)({cmd:'base'},form.getFormParams());if(_this2.pageType==='2'){(0,_assign2.default)(params,{groupid:_this2.groupId});}if(_this2.f_weaver_belongto_userid){(0,_assign2.default)(params,{f_weaver_belongto_userid:_this2.f_weaver_belongto_userid});}api.saveForm(params).then(function(data){var status=data.status,groupid=data.groupid;if(status==='1'){// message.success(data.message);
_this2.pageType=type;_this2.groupId=groupid;_this2.getHrmGroupForm();callback&&callback();}else{_antd.message.warning(data.message);}},function(error){});}else{f.showErrors();}});};this.buttonsAds=[getLabel(82529,'搜索'),getLabel(27088,'重置'),getLabel(32694,'取消')];this.TAB={advanceHeight:130,hasMask:false,keyParam:'key',setShowSearchAd:function setShowSearchAd(bool){return _this2.setShowSearchAd(bool);},onSearch:function onSearch(){return _this2.onSearch();},onSearchChange:function onSearchChange(val){return _this2.onSearchChange(val);},onChange:function onChange(key){return _this2.onTabChange(key);},buttonsAd:this.buttonsAds.map(function(name,index){var type=index===0&&"primary";var callback=void 0;if(index===0){callback=function callback(){return _this2.onSearch();};}else if(index===1){callback=function callback(){return _this2.tab.form.resetConditionValue();};}else{callback=_this2.setShowSearchAd;}return React.createElement(_antd.Button,{type:type,onClick:function onClick(){return callback(index===2&&false);}},name);})};_initDefineProp(this,'tab',_descriptor6,this);_initDefineProp(this,'setShowSearchAd',_descriptor7,this);this.onSearch=function(){_this2.getSearchList();_this2.setShowSearchAd(false);};this.onSearchChange=function(val){var form=_this2.tab.form;form.updateFields({resourcename:{value:val}});};this.onTabChange=function(key){_this2.tab.selectedKey=key;if(_this2.tab.showSearchAd){_this2.tab.showSearchAd=false;}if(key==='1'){_this2.getSearchForm();}else{_this2.getSearchList();}};_initDefineProp(this,'getSearchForm',_descriptor8,this);_initDefineProp(this,'exportBrowserRef',_descriptor9,this);this.TABLE={hasOrder:true,needScroll:true};this.changedOrder=[];_initDefineProp(this,'table',_descriptor10,this);_initDefineProp(this,'getSearchList',_descriptor11,this);_initDefineProp(this,'onDsporderChange',_descriptor12,this);this.saveTable=function(callback){var params={cmd:'saveDspOrder',groupid:_this2.groupId,dspOrder:_this2.changedOrder.toString()};if(_this2.f_weaver_belongto_userid){(0,_assign2.default)(params,{f_weaver_belongto_userid:_this2.f_weaver_belongto_userid});}api.saveForm(params).then(function(data){var status=data.status;if(status===1){_antd.message.success(data.message);_this2.getSearchList();_this2.changedOrder=[];callback&&callback();}else{_antd.message.warning(data.message);}},function(error){});};this.del=function(id){var _this=_this2;confirm({title:getLabel('131329','信息确认'),content:getLabel('83877','确定要删除吗？'),okText:getLabel('33703','确定'),cancelText:getLabel('32694','取消'),onOk:function onOk(){_this.deleteTableRow(id);},onCancel:function onCancel(){return false;}});};this.memberIds='';this.BROWSER={ref:'browser',type:17,title:getLabel(506041,'多人力资源'),hasAdvanceSerach:true,isSingle:false,onChange:function onChange(datas){_this2.memberIds=datas;_this2.saveDialogForm();}};this.DIALOG={hasScroll:true,icon:'icon-coms-hrm',iconBgcolor:'#217346',title:getLabel(125217,'添加成员'),onCancel:function onCancel(){_this2.dialog.visible=false;},moreBtn:{datas:[]},buttons:[React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this2.saveDialogForm();}},getLabel(30986,'保存'))]};_initDefineProp(this,'dialog',_descriptor13,this);this.saveDialogForm=function(){var selectedKey=_this2.tab.selectedKey;var callApi=function callApi(params){if(_this2.f_weaver_belongto_userid){(0,_assign2.default)(params,{f_weaver_belongto_userid:_this2.f_weaver_belongto_userid});}api.saveForm(params).then(function(data){var status=data.status;if(status==='1'){// message.success(data.message || getLabel(-1, '保存成功'));
_this2.dialog.visible=false;_this2.getSearchList();_this2.callback(1);}else{_antd.message.warning(data.message||getLabel(84544,'保存失败'));}},function(error){});};var params={groupid:_this2.groupId};if(selectedKey==='1'){(0,_assign2.default)(params,{cmd:'member',members:_this2.memberIds});callApi(params);}else{var form=_this2.dialog.form;var _form$getFormParams=form.getFormParams(),sharetype=_form$getFormParams.sharetype,jobtitlelevel=_form$getFormParams.jobtitlelevel,seclevelto=_form$getFormParams.seclevelto;(0,_assign2.default)(params,(0,_extends3.default)({cmd:'share'},form.getFormParams()));//兼容
(0,_assign2.default)(params,{seclevelTo:seclevelto});window.e9HideFormFieldKeys=[];var hideKeys=[];_this2.dialog.conditions.forEach(function(c){c.items.forEach(function(item){var conditionType=item.conditionType,domkey=item.domkey;var key=domkey[0];if(conditionType==='BROWSER'){hideKeys.push(key);}if(key==='customid'){hideKeys.push(key);}if(key==='seclevel'){hideKeys.push('seclevel__seclevelto');}});});var exclude=function exclude(validateKeys){validateKeys.forEach(function(validateKey){var index=hideKeys.findIndex(function(key){return key===validateKey;});hideKeys.splice(index,1);});};switch(sharetype){case'1'://人力资源
exclude(['rsid']);break;case'2'://分部
exclude(['sbid','seclevel__seclevelto']);break;case'3'://部门
exclude(['did','seclevel__seclevelto']);break;case'4'://角色
exclude(['rid','seclevel__seclevelto']);break;case'7'://岗位
var validateKeys=['jobtitle'];if(jobtitlelevel==='1'){validateKeys.push('jobtitledepartment');}if(jobtitlelevel==='2'){validateKeys.push('jobtitlesubcompany');}exclude(validateKeys);break;case'8'://客户
exclude(['customid','seclevel__seclevelto']);break;case'5'://所有人
exclude(['seclevel__seclevelto']);break;}window.e9HideFormFieldKeys=hideKeys;form.validateForm().then(function(f){if(f.isValid){callApi(params);}else{f.showErrors();_this2.dialog.date=new Date();}});};};this.TYPE=[{passiveKey:'rsid',//人力资源
activeKey:'sharetype',//类型
showValue:'1'},{passiveKey:'sbid',//分部
activeKey:'sharetype',//类型
showValue:'2'},{passiveKey:'alllevel',//包含下级
activeKey:'sharetype',//类型
showValue:'2'},{passiveKey:'did',//部门
activeKey:'sharetype',//类型
showValue:'3'},{passiveKey:'rid',//角色
activeKey:'sharetype',//类型
showValue:'4'},{passiveKey:'rolelevel',//角色级别
activeKey:'sharetype',//类型
showValue:'4'},{passiveKey:'jobtitle',//岗位
activeKey:'sharetype',//类型
showValue:'7'},{passiveKey:'jobtitlelevel',//岗位级别
activeKey:'sharetype',//类型
showValue:'7'},{passiveKey:'customid',//客户
activeKey:'sharetype',//类型
showValue:'8'},{passiveKey:'seclevel',//安全级别
activeKey:'sharetype',//类型
showValue:'2,3,4,8,5'}];this.JOBTITLE=[{passiveKey:'jobtitledepartment',//指定部门
activeKey:'jobtitlelevel',//岗位级别
showValue:'1'},{passiveKey:'jobtitlesubcompany',//指定分部
activeKey:'jobtitlelevel',//岗位级别
showValue:'2'}];this.FORMCONFIG={dynamicFields:[].concat((0,_toConsumableArray3.default)(this.TYPE),(0,_toConsumableArray3.default)(this.JOBTITLE))};this.setQueryParams=function(query){var groupId=query.groupId,groupType=query.groupType,f_weaver_belongto_userid=query.f_weaver_belongto_userid;if(groupId){_this2.groupId=groupId;_this2.pageType='2';}else{_this2.groupType=groupType&&groupType.toString();_this2.pageType='1';}_this2.f_weaver_belongto_userid=f_weaver_belongto_userid;};this.reset=function(){_this2.tab.selectedKey='0';};this.onFormElementsChange=function(datas){var form=_this2.dialog.form;if(datas.hasOwnProperty('sharetype')){var sharetype=datas.sharetype.value;if(sharetype!=='7'){form.updateFields({jobtitlelevel:'0'});}}};}(0,_createClass3.default)(HrmSpaGroup,[{key:'tConf',get:function get(){var c=void 0;if(this.pageType==='1'){c=this.conf;}else{var selectedKey=this.tab.selectedKey;var s=this.conf.slice(0,1);//保存
if(selectedKey==='0'){c=s;}else if(selectedKey==='1'){c=[].concat((0,_toConsumableArray3.default)(s),(0,_toConsumableArray3.default)(this.mConf));}else{c=this.mConf.slice(1);//新建和批量删除
}}return c;}},{key:'rConf',get:function get(){var icons=['icon-coms-Preservation','icon-coms-Flow-setting'];var rc=this.conf.map(function(c,i){return(0,_assign2.default)(c,{icon:icons[i]});});var c=void 0;if(this.pageType==='1'){c=rc;}else{var selectedKey=this.tab.selectedKey;var s=rc.slice(0,1);//保存
if(selectedKey==='0'){c=s;}else{var _icons=['icon-coms-download2','icon-coms-plus','icon-coms-Loss'];var rs=this.mConf.map(function(c,i){return(0,_assign2.default)(c,{icon:_icons[i]});});if(selectedKey==='1'){c=[].concat((0,_toConsumableArray3.default)(s),(0,_toConsumableArray3.default)(rs));}else{c=rs.slice(1);}}}return c;}},{key:'topButtons',get:function get(){var _this3=this;return this.tConf.map(function(item,index){var func=item.func,name=item.name;return React.createElement(_antd.Button,{type:'primary',disabled:_this3.getDisabled(func),onClick:function onClick(){return _this3[func]();}},name);});}},{key:'dropMenuDatas',get:function get(){var _this4=this;return this.rConf.map(function(item,index){var func=item.func,name=item.name,icon=item.icon;return{key:icon,disabled:_this4.getDisabled(func),icon:React.createElement('i',{className:''+icon}),content:name,onClick:function onClick(){return _this4[func]();}};});}},{key:'pageLoading',get:function get(){var selectedKey=this.tab.selectedKey;if(selectedKey==='0'){return this.pageForm.loading;}else{var comsWeaTableStore=this.table.comsWeaTableStore;return comsWeaTableStore.loading;}}},{key:'searchsBaseValue',get:function get(){var form=this.tab.form;return form.getFormParams().resourcename;}},{key:'searchType',get:function get(){var selectedKey=this.tab.selectedKey;if(selectedKey==='1'){return['base','advanced'];}else{return[];}}},{key:'hasTab',get:function get(){return this.pageType==='2';}},{key:'tabDatas',get:function get(){var DATAS=[{key:'0',title:getLabel(505832,'基本信息')},{key:'1',title:getLabel(125212,'成员')},{key:'2',title:getLabel(82752,'共享范围')}];var datas=void 0;if(this.isPublicGroup){datas=DATAS;}else{datas=DATAS.slice(0,2);}return datas;}},{key:'tabButtons',get:function get(){var _this5=this;var selectedKey=this.tab.selectedKey;var total=[{icon:'import',func:'importMember'},{icon:'add',func:'new'},{icon:'del',func:'batchDel'}];var t=void 0;if(selectedKey==='1'){t=total;}else if(selectedKey==='2'){t=total.slice(1);}else{t=[];}var btns=t.map(function(type,index){var icon=type.icon,func=type.func;return React.createElement(_ecCom.WeaButtonIcon,{buttonType:icon,type:'primary',disabled:_this5.getDisabled(func),onClick:_this5[func]});});return btns;}},{key:'dialogStyle',get:function get(){var selectedKey=this.tab.selectedKey;var style=void 0;if(selectedKey==='1'){style={width:500,height:120};}else{style={width:550,height:220};}return style;}},{key:'footerButtons',get:function get(){var selectedKey=this.tab.selectedKey;var btns=void 0;if(selectedKey==='0'){btns=this.topButtons;}else if(selectedKey==='1'){btns=this.topButtons.slice(0,1);}else{btns=[];}return btns;}}]);return HrmSpaGroup;}(),(_applyDecoratedDescriptor(_class.prototype,'tConf',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'tConf'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'rConf',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'rConf'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'topButtons',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'topButtons'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'dropMenuDatas',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'dropMenuDatas'),_class.prototype),_descriptor=_applyDecoratedDescriptor(_class.prototype,'getShareScopeForm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(){var params={cmd:'share'};if(_this6.f_weaver_belongto_userid){(0,_assign2.default)(params,{f_weaver_belongto_userid:_this6.f_weaver_belongto_userid});}api.getFormCondition(params).then(function(data){var condition=data.condition;condition.forEach(function(c){c.items.forEach(function(item){var domkey=item.domkey,conditionType=item.conditionType;var key=domkey[0];if(conditionType==='BROWSER'){(0,_assign2.default)(item,{rules:'required|string'});}if(key==='seclevel'){(0,_assign2.default)(item,{rules:'scopeRequired',startValue:10,endValue:100});}});});_this6.dialog.form=new _comsMobx.WeaForm();_this6.dialog.conditions=condition;_this6.dialog.form.initFormFields(condition);},function(error){});};}}),_applyDecoratedDescriptor(_class.prototype,'pageLoading',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'pageLoading'),_class.prototype),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'pageForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{form:new _comsMobx.WeaForm(),loading:false};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'isPublicGroup',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'getHrmGroupForm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){var params={cmd:'base'};if(_this7.pageType==='2'){(0,_assign2.default)(params,{groupid:_this7.groupId});}if(_this7.f_weaver_belongto_userid){(0,_assign2.default)(params,{f_weaver_belongto_userid:_this7.f_weaver_belongto_userid});}_this7.pageForm.loading=true;api.getFormCondition(params).then(function(data){var condition=data.condition;condition.map(function(c){c.items.map(function(item){var domkey=item.domkey;if(domkey[0]==='type'){if(_this7.pageType==='1'){item.value=_this7.groupType;}else{_this7.isPublicGroup=item.value==='1';}}});});_this7.pageForm.form=new _comsMobx.WeaForm();_this7.pageForm.form.setCondition(condition);_this7.pageForm.loading=false;},function(error){});};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'pageType',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'1';}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'tab',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{showSearchAd:false,form:new _comsMobx.WeaForm(),selectedKey:'0',ref:null};}}),_applyDecoratedDescriptor(_class.prototype,'searchsBaseValue',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'searchsBaseValue'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'searchType',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'searchType'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasTab',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'hasTab'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'tabDatas',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'tabDatas'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'tabButtons',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'tabButtons'),_class.prototype),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'setShowSearchAd',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this8=this;return function(bool){_this8.tab.showSearchAd=bool;};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'getSearchForm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this9=this;return function(){var params={cmd:'member'};if(_this9.f_weaver_belongto_userid){(0,_assign2.default)(params,{f_weaver_belongto_userid:_this9.f_weaver_belongto_userid});}api.getSearchCondition(params).then(function(data){var condition=data.condition;_this9.tab.form=new _comsMobx.WeaForm();_this9.tab.form.setCondition(condition);_this9.getSearchList();},function(error){});};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'exportBrowserRef',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this10=this;return function(ref){_this10.tab.ref=ref;};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{comsWeaTableStore:new TableStore()};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'getSearchList',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){var selectedKey=_this11.tab.selectedKey;var params={groupid:_this11.groupId};if(selectedKey==='1'){(0,_assign2.default)(params,(0,_extends3.default)({cmd:'member'},_this11.tab.form.getFormParams()));}else{(0,_assign2.default)(params,{cmd:'share'});}if(_this11.f_weaver_belongto_userid){(0,_assign2.default)(params,{f_weaver_belongto_userid:_this11.f_weaver_belongto_userid});}api.getSearchResult(params).then(function(data){var sessionkey=data.sessionkey;_this11.table.comsWeaTableStore=new TableStore();_this11.table.comsWeaTableStore.getDatas(sessionkey,1);},function(error){});};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'onDsporderChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this12=this;return function(val,rowId){var orders=[],ids=[];_this12.changedOrder.forEach(function(item){var a=item.split('-');ids.push(a[0]);orders.push(a[1]);});var index=ids.findIndex(function(id){return id===rowId;});if(index>-1){_this12.changedOrder.splice(index,1);}var v=rowId+'-'+val;_this12.changedOrder.push(v);};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'dialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{visible:false,loading:false,conditions:[],form:new _comsMobx.WeaForm(),date:new Date()};}}),_applyDecoratedDescriptor(_class.prototype,'dialogStyle',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'dialogStyle'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'footerButtons',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'footerButtons'),_class.prototype)),_class);var hrmSpaGroup=exports.hrmSpaGroup=new HrmSpaGroup();

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.HrmImportCommon=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(74);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32;var _importresource=__webpack_require__(656);var Api=_interopRequireWildcard(_importresource);var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _i18nbk=__webpack_require__(112);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var TableStore=_comsMobx.WeaTableNew.TableStore;var HrmImportCommon=exports.HrmImportCommon=(_class=function HrmImportCommon(){var _this=this;(0,_classCallCheck3.default)(this,HrmImportCommon);this.sourceStore=null;_initDefineProp(this,'pageName',_descriptor,this);_initDefineProp(this,'importType',_descriptor2,this);_initDefineProp(this,'importDialog',_descriptor3,this);_initDefineProp(this,'resultDialog',_descriptor4,this);_initDefineProp(this,'recordDialog',_descriptor5,this);_initDefineProp(this,'logDialog',_descriptor6,this);_initDefineProp(this,'getImportForm',_descriptor7,this);_initDefineProp(this,'getImportProcessInfo',_descriptor8,this);_initDefineProp(this,'getResultInfo',_descriptor9,this);_initDefineProp(this,'getRecordTable',_descriptor10,this);_initDefineProp(this,'getLogTable',_descriptor11,this);_initDefineProp(this,'submitImportInfo',_descriptor12,this);_initDefineProp(this,'getLogSearchPanelCondition',_descriptor13,this);_initDefineProp(this,'setExcelFileNo',_descriptor14,this);_initDefineProp(this,'submitExcel',_descriptor15,this);_initDefineProp(this,'queryRecord',_descriptor16,this);_initDefineProp(this,'queryLog',_descriptor17,this);_initDefineProp(this,'jumpToImportResult',_descriptor18,this);_initDefineProp(this,'setImportDialogVisible',_descriptor19,this);_initDefineProp(this,'setImportPage',_descriptor20,this);_initDefineProp(this,'setResultInfoDialogVisible',_descriptor21,this);_initDefineProp(this,'importDialogReset',_descriptor22,this);_initDefineProp(this,'resetResultDialogStatus',_descriptor23,this);_initDefineProp(this,'setRecordDialogVisible',_descriptor24,this);_initDefineProp(this,'setLogDialogVisible',_descriptor25,this);_initDefineProp(this,'setLogPanelStatus',_descriptor26,this);_initDefineProp(this,'searchLogInfo',_descriptor27,this);this.hasErrorInfo=function(errorInfo){if(errorInfo.length==0)return false;return true;};_initDefineProp(this,'setTempletName',_descriptor28,this);_initDefineProp(this,'setImportDialogTitle',_descriptor29,this);_initDefineProp(this,'setImportType',_descriptor30,this);_initDefineProp(this,'setSelectedValue',_descriptor31,this);_initDefineProp(this,'setScoll',_descriptor32,this);this.setSourceStore=function(store){_this.sourceStore=store;};this.setOtherParams=function(params){_this.otherParams=params;};}//设置标识，标识当前是那个页面在导入
,(_descriptor=_applyDecoratedDescriptor(_class.prototype,'pageName',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'importType',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'importDialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{visible:false,condition:[],form:new _comsMobx.WeaForm(),title:'',loading:true,templetName:'',selectedValue:'workcode'};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'resultDialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{title:_mobx.observable.ref(_i18nbk.i18n.label.importResult()),errorTip:_mobx.observable.ref(_i18nbk.i18n.message.selectImportTempleteError()),visible:false,index:1,datas:[],importStatus:'',pId:'',interval:'',tableStore:new TableStore(),errorInfo:[],succnum:0,failnum:0,loading:true,component:''};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'recordDialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{title:_mobx.observable.ref(_i18nbk.i18n.button.importHistoryQuery()),visible:false,tableStore:new TableStore()};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'logDialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{title:_mobx.observable.ref(_i18nbk.i18n.button.getImportLog()),visible:false,tableStore:new TableStore(),isPanelShow:false,form:new _comsMobx.WeaForm(),condition:[],loading:true};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'getImportForm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){_this2.importDialog.loading=true;var params={importType:_this2.importType};Api.getImportForm(params).then(function(rs){var status=rs.status,_rs$condition=rs.condition,condition=_rs$condition===undefined?[]:_rs$condition;if(status=='1'){_this2.importDialog.condition=condition;var copy=[].concat((0,_toConsumableArray3.default)(condition));copy.splice(1);copy[0].items.splice(2);_this2.importDialog.form.initFormFields(copy);_this2.importDialog.loading=false;}else{_antd.message.error(rs.message);}}).catch(function(error){_antd.message.error(error);});};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'getImportProcessInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){var params={importType:_this3.importType,index:_this3.resultDialog.index};Api.getImportProcessLog(params).then(function(rs){var datas=rs.datas,index=rs.index,_rs$pId=rs.pId,pId=_rs$pId===undefined?'':_rs$pId,status=rs.status;_this3.resultDialog.loading=false;if(status=='1'){var _resultDialog=_this3.resultDialog,importStatus=_resultDialog.importStatus,interval=_resultDialog.interval,errorInfo=_resultDialog.errorInfo,component=_resultDialog.component;component.scrollToLast();if(importStatus=='over'||importStatus=='error'){clearInterval(interval);if(!_this3.hasErrorInfo(errorInfo))_this3.getResultInfo();_this3.sourceStore&&_this3.sourceStore.getSearchList();return;}if(rs.importStatus=='over'||rs.importStatus=='error'){_this3.resultDialog.loading=true;}_this3.resultDialog.importStatus=rs.importStatus;if(pId)_this3.resultDialog.pId=pId;if(_this3.resultDialog.datas.length==0){_this3.resultDialog.datas=datas;}else{_this3.resultDialog.datas=[].concat((0,_toConsumableArray3.default)(_this3.resultDialog.datas),(0,_toConsumableArray3.default)(datas));}_this3.resultDialog.index=index;}});};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'getResultInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){var params={pId:_this4.resultDialog.pId};_this4.resultDialog.loading=true;Api.getImportResult(params).then(function(rs){var datas=rs.datas,status=rs.status,succnum=datas.succnum,failnum=datas.failnum,_datas$sessionkey=datas.sessionkey,sessionkey=_datas$sessionkey===undefined?'':_datas$sessionkey;if(status=='1'){_this4.resultDialog.succnum=succnum;_this4.resultDialog.failnum=failnum;sessionkey&&_this4.resultDialog.tableStore.getDatas(sessionkey,1);}_this4.resultDialog.loading=false;});};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'getRecordTable',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){var params={importType:_this5.importType};Api.getImportHistory(params).then(function(rs){var status=rs.status,sessionkey=rs.sessionkey;if(status=='1'){_this5.recordDialog.tableStore.getDatas(sessionkey,1);}else{_antd.message.error(rs.message);}}).catch(function(error){_antd.message.error(error);});};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'getLogTable',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(){var params=(0,_extends3.default)({importType:_this6.importType},_this6.logDialog.form.getFormParams());if(_this6.resultDialog.pId){params=(0,_extends3.default)({},params,{pId:_this6.resultDialog.pId});}Api.getImportLogDetail(params).then(function(rs){var status=rs.status,sessionkey=rs.sessionkey;if(status=='1'){_this6.logDialog.tableStore.getDatas(sessionkey,1);}else{_antd.message.error(rs.message);}}).catch(function(error){_antd.message.error(error);});};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'submitImportInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){var params={importType:_this7.importType,excelfile:_this7.importDialog.excelFileId,operateType:'add'};if(['group','groupMember'].includes(_this7.importType)){params=(0,_extends3.default)({},params,_this7.importDialog.form.getFormParams());}if(_this7.otherParams){(0,_assign2.default)(params,_this7.otherParams);}_this7.setResultInfoDialogVisible(true);Api.saveImport(params).then(function(rs){var status=rs.status,errorInfo=rs.errorInfo;if(status=='1'){if(_this7.hasErrorInfo(errorInfo)){_this7.resultDialog.errorInfo=errorInfo;_this7.resultDialog.importStatus='error';}}else{_antd.message.error(rs.message);}}).catch(function(error){_antd.message.error(error);});_this7.resultDialog.interval=setInterval(function(){return _this7.getImportProcessInfo();},2000);};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'getLogSearchPanelCondition',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){_this8.logDialog.loading=true;var params={importType:_this8.importType};Api.getImportLogSearchCondition(params).then(function(rs){var status=rs.status,searchCondition=rs.searchCondition;if(status=='1'){_this8.logDialog.condition=searchCondition;_this8.logDialog.form.initFormFields(searchCondition);}else{_antd.message.error(rs.message);}_this8.logDialog.loading=false;}).catch(function(error){_antd.message.error(error);});};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'setExcelFileNo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this9=this;return function(id){(0,_mobx.extendObservable)(_this9.importDialog,{excelFileId:id});};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'submitExcel',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this10=this;return function(){if(!_this10.importDialog.excelFileId){_antd.message.warning(_i18nbk.i18n.message.selectImportTemplete());return;}_this10.submitImportInfo();};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'queryRecord',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){_this11.setRecordDialogVisible(true);};}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'queryLog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this12=this;return function(){_this12.setLogDialogVisible(true);};}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'jumpToImportResult',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this13=this;return function(id){_this13.resultDialog.pId=id;_this13.resultDialog.importStatus='over';_this13.setResultInfoDialogVisible(true);_this13.getResultInfo();};}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'setImportDialogVisible',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this14=this;return function(bool){_this14.importDialog.visible=bool;if(bool){_this14.getImportForm();}else{_this14.importDialogReset();}};}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'setImportPage',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this15=this;return function(pageName){_this15.pageName=pageName;};}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'setResultInfoDialogVisible',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this16=this;return function(bool){_this16.resultDialog.visible=bool;if(!bool){clearInterval(_this16.resultDialog.interval);_this16.resetResultDialogStatus();}};}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'importDialogReset',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this17=this;return function(){_this17.importDialog.condition=[];_this17.importDialog.form=new _comsMobx.WeaForm();_this17.importDialog.selectedValue='workcode';_this17.importDialog.excelFileId='';};}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'resetResultDialogStatus',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this18=this;return function(){_this18.resultDialog.index=1;_this18.resultDialog.datas=[];_this18.resultDialog.importStatus='';_this18.resultDialog.pId='';_this18.resultDialog.interval='';_this18.resultDialog.errorInfo='';_this18.resultDialog.loading=true;};}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'setRecordDialogVisible',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this19=this;return function(bool){_this19.recordDialog.visible=bool;bool&&_this19.getRecordTable();};}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'setLogDialogVisible',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this20=this;return function(bool){_this20.logDialog.visible=bool;bool&&_this20.getLogTable();if(!bool){_this20.logDialog.isPanelShow=false;_this20.logDialog.form=new _comsMobx.WeaForm();_this20.logDialog.condition=[];}};}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'setLogPanelStatus',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this21=this;return function(bool){_this21.logDialog.isPanelShow=bool;bool&&_this21.logDialog.condition.length==0&&_this21.getLogSearchPanelCondition();};}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'searchLogInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this22=this;return function(){_this22.getLogTable();};}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'setTempletName',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this23=this;return function(templetName){_this23.importDialog.templetName=templetName;};}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'setImportDialogTitle',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this24=this;return function(title){_this24.importDialog.title=title;};}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'setImportType',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this25=this;return function(type){_this25.importType=type;};}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'setSelectedValue',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this26=this;return function(value){_this26.importDialog.selectedValue=value;};}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'setScoll',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this27=this;return function(component){_this27.resultDialog.component=component;};}})),_class);

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getImportLogSearchCondition=exports.getImportLogDetail=exports.getImportHistory=exports.getImportResult=exports.getImportProcessLog=exports.saveImport=exports.getImportForm=undefined;var _ecCom=__webpack_require__(0);//获取导入表单
var getImportForm=exports.getImportForm=function getImportForm(params){return _ecCom.WeaTools.callApi('/api/hrm/import/resource/getImportForm','GET',params);};//导入文件提交
var saveImport=exports.saveImport=function saveImport(params){return _ecCom.WeaTools.callApi('/api/hrm/import/resource/saveImport','POST',params);};//获取导入结果回调数据
var getImportProcessLog=exports.getImportProcessLog=function getImportProcessLog(params){return _ecCom.WeaTools.callApi('/api/hrm/importlog/getImportProcessLog','GET',params);};//获取导入结果
var getImportResult=exports.getImportResult=function getImportResult(params){return _ecCom.WeaTools.callApi('/api/hrm/importlog/getImportResult','GET',params);};//历史导入信息查询
var getImportHistory=exports.getImportHistory=function getImportHistory(params){return _ecCom.WeaTools.callApi('/api/hrm/importlog/getImportHistory','GET',params);};//导入日志
var getImportLogDetail=exports.getImportLogDetail=function getImportLogDetail(params){return _ecCom.WeaTools.callApi('/api/hrm/importlog/getImportColResultLog','GET',params);};//导入日志 - 高级搜索
var getImportLogSearchCondition=exports.getImportLogSearchCondition=function getImportLogSearchCondition(params){return _ecCom.WeaTools.callApi('/api/hrm/importlog/getHistorySearchCondition','GET',params);};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.hrmTax=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(15);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28;var _mobx=__webpack_require__(8);var _ecCom=__webpack_require__(0);var _comsMobx=__webpack_require__(10);var _antd=__webpack_require__(6);var _tax=__webpack_require__(658);var api=_interopRequireWildcard(_tax);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var confirm=_antd.Modal.confirm;var TableStore=_comsMobx.WeaTableNew.TableStore;var HrmTax=(_class=function(){function HrmTax(){var _this=this;(0,_classCallCheck3.default)(this,HrmTax);_initDefineProp(this,'cPage',_descriptor,this);this.TAXDEDUCTIONITEMS=['childEducation','continualEducation','loan','rent','supportOlder'];this.BASICINFOITEMS=['personalInfo','familyMember'];this.SEARCHGROUPS=[{title:getLabel(-1,'基本信息'),MENUS:[{src:'/images/tax/basic_info.png',label:getLabel(-1,'个人信息'),onMenuClick:function onMenuClick(){return _this.handleMenuClick('personalInfo');}},{src:'/images/tax/basic_info.png',label:getLabel(-1,'家庭成员'),onMenuClick:function onMenuClick(){return _this.handleMenuClick('familyMember');}}]},{title:getLabel(-1,'专项附加扣除填报'),MENUS:[{src:'/images/tax/child_edu.png',label:getLabel(-1,'子女教育'),onMenuClick:function onMenuClick(){return _this.handleMenuClick('childEducation');}},{src:'/images/tax/c_edu.png',label:getLabel(-1,'继续教育'),onMenuClick:function onMenuClick(){return _this.handleMenuClick('continualEducation');}},{src:'/images/tax/loan.png',label:getLabel(-1,'住房贷款利息'),onMenuClick:function onMenuClick(){return _this.handleMenuClick('loan');}},{src:'/images/tax/rent.png',label:getLabel(-1,'住房租金'),onMenuClick:function onMenuClick(){return _this.handleMenuClick('rent');}},{src:'/images/tax/support.png',label:getLabel(-1,'赡养老人'),onMenuClick:function onMenuClick(){return _this.handleMenuClick('supportOlder');}}]}];this.TOP={showDropIcon:true,iconBgcolor:'#217346',icon:React.createElement('i',{className:'icon-coms-hrm'}),title:getLabel(-1,'个税专项附加扣除信息填报')};this.hasTable=function(){var currentIndex=_this.step.currentIndex;if(_this.cPage==='familyMember'){return true;}if(['childEducation','supportOlder'].includes(_this.cPage)&&currentIndex===1){return true;}};this.hasPersonalForm=function(){var currentIndex=_this.step.currentIndex;if(_this.cPage==='personalInfo'){return true;}if(_this.TAXDEDUCTIONITEMS.includes(_this.cPage)){return true;}};this.hasConditionForm=function(){var currentIndex=_this.step.currentIndex;if(_this.cPage==='loan'){return true;}if(_this.TAXDEDUCTIONITEMS.includes(_this.cPage)&&currentIndex>0){return true;}};_initDefineProp(this,'tConf',_descriptor2,this);_initDefineProp(this,'rConf',_descriptor3,this);_initDefineProp(this,'getRightMenu',_descriptor4,this);this.filter=function(datas){var tConf=void 0,rConf=void 0;tConf=datas.filter(function(item){var bool=false;['isTop','isBatch'].forEach(function(prop){var b=parseInt(item[prop]);if(b){bool=true;}});return bool;});rConf=datas;return{tConf:tConf,rConf:rConf};};this.operatePersonalForm=function(isEdit){_this.controlUnderline(isEdit);_this.getRightMenu(isEdit);_this.formType='PF';_this.getForm(isEdit);};this.doEdit=function(){_this.operatePersonalForm('1');};this.doSave=function(){//表单验证通过后执行的逻辑
var callback=function callback(){_this.saveForm('personalForm',function(){_this.operatePersonalForm('0');});};_this.validateForm('personalForm',callback);};this.doCancel=function(){_this.operatePersonalForm('0');};this.doCreate=function(){_this.defineDialogTitle(getLabel(-1,'新建家庭成员'));_this.callDialogForm('DG');};this.preStep=function(){_this.changeStepComponentState(false);_this.getRightMenu();if(_this.step.currentIndex===1){_this.formType='CD';_this.getForm();}else{_this.formType='PF';_this.getForm();}};this.nextStep=function(){_this.changeStepComponentState(true);_this.getRightMenu();_this.formType='CD';_this.getForm();_this.step.currentIndex===1&&_this.getSearchList();};_initDefineProp(this,'changeStepComponentState',_descriptor5,this);this.callDialogForm=function(formType,id){_this.openDialog();_this.formType=formType;_this.getForm(id);};this.doDelete=function(){var comsWeaTableStore=_this.table.comsWeaTableStore,selectedRowKeys=comsWeaTableStore.selectedRowKeys;var callback=function callback(){var params={ids:selectedRowKeys.toString()};_this.delLogic(params);};_this.delConfirm(true,callback);};this.delConfirm=function(isBatch,callback){var content=void 0;if(isBatch){content=getLabel('385625','确定要删除选择的记录吗？');}else{content=getLabel('83877','确定要删除吗？');}confirm({title:getLabel('131329','信息确认'),content:content,okText:getLabel('33703','确定'),cancelText:getLabel('32694','取消'),onOk:function onOk(){callback&&callback();},onCancel:function onCancel(){return false;}});};this.delLogic=function(params){api.del(_this.cPage,params).then(function(data){var status=data.status;if(status==='1'){_antd.message.success(-1,'删除成功');_this.getSearchList();}else{_antd.message.warning(-1,'删除失败');}});};this.saveForm=function(formType,callback){var form=_this[formType].form;//后端默认取当前登录人员的id，因此这里不需要传人员id。
var params=(0,_extends3.default)({},form.getFormParams());api.save(_this.cPage,params).then(function(data){var status=data.status;if(status==='1'){_antd.message.success(getLabel(-1,'保存成功'));callback&&callback();}else{_antd.message.warning(getLabel(-1,'保存失败'));}},function(error){});};this.getDisabled=function(func){var loading=_this.personalForm.loading,comsWeaTableStore=_this.table.comsWeaTableStore;var b=void 0;if(['doEdit'].includes(func)){b=loading;}if(['doCreate'].includes(func)){b=comsWeaTableStore.loading;}if(['doDelete'].includes(func)){b=comsWeaTableStore.selectedRowKeys.length===0;}return b;};_initDefineProp(this,'handleMenuClick',_descriptor6,this);this.storagePageType=function(type){_this.temp=type;};this.formType='PF';this.callFormAPIParams={};_initDefineProp(this,'personalForm',_descriptor7,this);_initDefineProp(this,'dialogForm',_descriptor8,this);_initDefineProp(this,'conditionForm',_descriptor9,this);_initDefineProp(this,'getForm',_descriptor10,this);this.setParamsToCallFormAPI=function(val){//判断是否调用个人信息表单
var isCallPersonalForm=_this.isCallPersonalForm();//判断是否调用弹框内表单
var isCallDialogForm=_this.isCallDialogForm();//判断是否调用条件表单
var isCallCondtionForm=_this.isCallCondtionForm();if(isCallPersonalForm){(0,_assign2.default)(_this.callFormAPIParams,{edit:val});_this.personalForm.loading=true;}if(isCallDialogForm){if(val){(0,_assign2.default)(_this.callFormAPIParams,{id:val});}_this.dialogForm.loading=true;}};this.isCallPersonalForm=function(type){return['PF','PFDG'].includes(_this.formType);};this.isEdit=function(val){return val==='1';};this.isCallDialogForm=function(type){return['PFDG','DG'].includes(_this.formType);};this.isCallCondtionForm=function(){return _this.formType==='CD';};this.hasAddBtn=function(conditions){var b=false;conditions.forEach(function(c){c.items.forEach(function(item){var otherParams=item.otherParams;if(otherParams&&otherParams.hasAddBtn){b=true;}});});return b;};this.addAddBtnEventListener=function(conditions){conditions.forEach(function(c){c.items.forEach(function(item){var otherParams=item.otherParams;if(otherParams&&otherParams.hasAddBtn){item.addOnClick=function(){_this.defineDialogTitle(getLabel(-1,'新建家庭成员'));_this.openDialog();_this.formType='DG';_this.getForm();};}});});};this.initForm=function(obj,condition){_this[obj].form=new _comsMobx.WeaForm();_this[obj].form.setCondition(condition);_this[obj].conditions=condition;_this[obj].loading=false;};this.controlUnderline=function(isEdit){_this.personalForm.isEdit=isEdit;};this.buttonsAds=[getLabel(82529,'搜索'),getLabel(27088,'重置'),getLabel(32694,'取消')];this.TAB={advanceHeight:170,hasMask:false,keyParam:'key',setShowSearchAd:function setShowSearchAd(bool){return _this.setShowSearchAd(bool);},onSearch:function onSearch(){return _this.onSearch();},onSearchChange:function onSearchChange(val){return _this.onSearchChange(val);},onChange:function onChange(key){return _this.onTabChange(key);},buttonsAd:this.buttonsAds.map(function(name,index){var type=index===0&&"primary";var callback=void 0;if(index===0){callback=function callback(){return _this.onSearch();};}else if(index===1){callback=function callback(){return _this.tab.form.resetConditionValue();};}else{callback=_this.setShowSearchAd;}return React.createElement(_antd.Button,{type:type,onClick:function onClick(){return callback(index===2&&false);}},name);})};_initDefineProp(this,'tab',_descriptor11,this);_initDefineProp(this,'onSearchChange',_descriptor12,this);_initDefineProp(this,'onSearch',_descriptor13,this);_initDefineProp(this,'onTabChange',_descriptor14,this);_initDefineProp(this,'setShowSearchAd',_descriptor15,this);this.TABLE={hasOrder:true,needScroll:true};_initDefineProp(this,'table',_descriptor16,this);_initDefineProp(this,'getSearchList',_descriptor17,this);this.getParamsToCallTableAPI=function(){var params={};if(_this.cPage==='familyMember'){(0,_assign2.default)(params,{lastname:_this.searchsBaseValue});}if(_this.cPage==='childEducation'){var form=_this.conditionForm.form;(0,_assign2.default)(params,{year:form.getFormParams().year});}return params;};this.edit=function(id){_this.defineDialogTitle(getLabel(-1,'编辑家庭成员'));_this.callDialogForm('DG',id);};this.del=function(id){//删除确认通过后，执行的回调函数
var callback=function callback(){var params={ids:id};_this.delLogic(params);};_this.delConfirm(false,callback);};this.DIALOG={hasScroll:true,onCancel:function onCancel(){return _this.closeDialog();}};_initDefineProp(this,'dialog',_descriptor18,this);_initDefineProp(this,'subDialog',_descriptor19,this);_initDefineProp(this,'openDialog',_descriptor20,this);_initDefineProp(this,'closeDialog',_descriptor21,this);_initDefineProp(this,'defineDialogTitle',_descriptor22,this);_initDefineProp(this,'goToDetailPage',_descriptor23,this);_initDefineProp(this,'preInfo',_descriptor24,this);_initDefineProp(this,'getPreInfo',_descriptor25,this);this.getImgSrc=function(type,index){var src=void 0;switch(type){case'childEducation':if(index===0){src='/images/tax/cedu_01.png';}else{src='/images/tax/cedu_02.png';}}return src;};_initDefineProp(this,'validateForm',_descriptor26,this);this.saveDialogForm=function(){//弹框内表单校验通过后，执行的回调函数。
var callback=function callback(){_this.saveForm('dialogForm',function(){_this.closeDialog();if(_this.isRefreshTable()){_this.getSearchList();}else{_this.controlUnderline('0');_this.formType='PF';_this.getForm('0');}});};_this.validateForm('dialogForm',callback);};this.isRefreshTable=function(){var currentIndex=_this.step.currentIndex;//保存家庭成员
if(_this.cPage==='familyMember'){return true;}//添加子女教育信息、新建家庭成员
if(['childEducation','supportOlder'].includes(_this.cPage)&&currentIndex===1){return true;}};_initDefineProp(this,'step',_descriptor27,this);_initDefineProp(this,'getStep',_descriptor28,this);this.modify=function(){_this.controlUnderline('1');_this.defineDialogTitle(getLabel(-1,'修改个人信息'));_this.openDialog();_this.formType='PFDG';_this.getForm('1');};this.buttonIcons=[{buttonType:'add',type:'primary',onClick:function onClick(){return _this.addChildEducationInfo();}},{buttonType:'del',type:'primary',disabled:true,onClick:function onClick(){return _this.delChildEducationInfo();}}];this.addChildEducationInfo=function(){_this.defineDialogTitle(getLabel(-1,'添加子女教育信息'));_this.openDialog();_this.formType='DG';_this.getForm();};this.delChildEducationInfo=function(){};this.childrenReduceTip=[getLabel(-1,'有子女符合以下两个条件之一：'),getLabel(-1,'扣除年度有子女满3岁且处于小学入学前阶段；'),getLabel(-1,'扣除年度有子女正接受全日制学历教育。')];}//专项附加扣除填报
//基本信息
(0,_createClass3.default)(HrmTax,[{key:'breadcrumb',get:function get(){var _this2=this;var a=void 0;var f={name:getLabel(-1,'信息填报'),onClick:function onClick(){_this2.cPage='main';}};switch(this.cPage){case'main':a=[];break;case'personalInfo':var isEdit=this.personalForm.isEdit;if(isEdit==='0'){a=[f,{name:getLabel(-1,'个人信息')}];}else{a=[{name:getLabel(-1,'个税专项附加扣除信息填报'),onClick:function onClick(){_this2.cPage='main';}},{name:getLabel(-1,'基本信息填报')}];}break;case'familyMember':a=[f,{name:getLabel(-1,'家庭成员')}];break;case'childEducation':a=[f,{name:getLabel(-1,'子女教育')}];break;case'continualEducation':a=[f,{name:getLabel(-1,'继续教育')}];break;case'loan':a=[f,{name:getLabel(-1,'住房贷款利息')}];break;case'rent':a=[f,{name:getLabel(-1,'住房租金')}];break;case'supportOlder':a=[f,{name:getLabel(-1,'赡养老人')}];break;}return a;}},{key:'pageLoading',get:function get(){var comsWeaTableStore=this.table.comsWeaTableStore;var loading=void 0;var hasTable=this.hasTable();var hasPersonalForm=this.hasPersonalForm();var hasConditionForm=this.hasConditionForm();var tloading=comsWeaTableStore.loading;var ploading=this.personalForm.loading;var cloading=this.conditionForm.loading;//页面中只包含纯列表
if(hasTable&&!hasConditionForm){loading=tloading;}//页面中即包含列表，也包含条件表单
if(hasTable&&hasConditionForm){loading=tloading||cloading;}//只包含个人信息表单
if(hasPersonalForm&&!hasConditionForm){loading=ploading;}//不仅包含个人信息表单，也包含条件表单
if(hasPersonalForm&&hasConditionForm){loading=ploading||cloading;}return loading;}//页面中是否包含列表
//页面中是否包含个人信息表单
//页面中是否包含条件表单
},{key:'topButtons',get:function get(){var _this3=this;if(this.cPage!=='main'){return this.tConf.map(function(item,index){var menuFun=item.menuFun,menuName=item.menuName;return React.createElement(_antd.Button,{type:'primary',disabled:_this3.getDisabled(menuFun),onClick:function onClick(){return _this3[menuFun]();}},menuName);});}else{return[];}}},{key:'dropMenuDatas',get:function get(){var _this4=this;if(this.cPage!=='main'){return this.rConf.map(function(item,index){var menuFun=item.menuFun,menuName=item.menuName,menuIcon=item.menuIcon;return{key:index.toString(),disabled:_this4.getDisabled(menuFun),icon:React.createElement('i',{className:''+menuIcon}),content:menuName,onClick:function onClick(){return _this4[menuFun]();}};});}else{return[];}}//编辑、保存个人信息表单CALLBACK
//编辑个人信息表单
//保存个人信息表单
//返回
//新建家庭成员
//上一步
//下一步
//调用弹框内的表单
//接收两个参数：表单的类型、当前编辑表单的ID
//批量删除
//确认是否删除
//接收两个参数：是否是批量删除、确认删除后执行的回调函数
//执行删除任务的具体逻辑
//保存表单分两种情况：保存页面表单、保存弹框内的表单
//参数formType为要保存表单的类型、 callback为这两种情况保存成功后，具体执行的逻辑
//获取顶部按钮组、右键菜单的状态(是否可点击)
//设置即将跳转页面的类型
//**********************NoLinkageForm、CollapseForm**********************
//PF: 个人信息表单 PFDG:弹框内的个人信息 DG:弹框内的表单 CD: 条件表单
//调用表单接口所需的参数
//设置调用表单接口的参数
//判断调用的是否是个人信息表单
//初始化表单
},{key:'isRenderCollapseForm',get:function get(){var conditions=this.dialogForm.conditions;return conditions.length>1;}//控制个人信息表单是否出现下划线
//********************Tab********************
},{key:'searchsBaseValue',get:function get(){if(this.cPage==='main'){return'';}if(this.cPage==='familyMember'){return this.tab.value;}}},{key:'tabDatas',get:function get(){if(this.cPage==='main'){return[{key:'0',title:getLabel(-1,'信息填报')},{key:'1',title:getLabel(-1,'填报记录查询')}];}if(this.cPage==='familyMember'){return[];}}},{key:'searchType',get:function get(){var type=void 0;if(this.cPage==='main'){type=['base','advanced'];}if(this.cPage==='familyMember'){type=['base'];}return type;}//*********************Table*********************
//编辑家庭成员
//删除家庭成员
//*********************Dialog*********************
},{key:'dialogButtons',get:function get(){var _this5=this;var btns=void 0;if(this.cPage==='main'){btns=[React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this5.goToDetailPage();}},getLabel(-1,'准备完毕，进入填报')),React.createElement(_antd.Button,{onClick:function onClick(){return _this5.closeDialog();}},getLabel(-1,'取消'))];}else{btns=[React.createElement(_antd.Button,{type:'primary',onClick:function onClick(){return _this5.saveDialogForm();}},getLabel(30986,'保存'))];}return btns;}},{key:'moreBtn',get:function get(){var btn={};if(this.cPage!=='main'){(0,_assign2.default)(btn,{datas:[]});}return btn;}},{key:'icon',get:function get(){var icon=void 0;if(this.cPage==='main'){icon='icon-coms-Prompt';}else{icon='icon-coms-hrm';}return icon;}},{key:'iconBgcolor',get:function get(){var color=void 0;if(this.cPage==='main'){color='#FF9900';}else{color='#217346';}return color;}},{key:'dialogLoading',get:function get(){return this.dialogForm.loading;}},{key:'dialogStyle',get:function get(){var style=void 0;if(this.cPage==='main'){style={width:560,height:215};}if(this.cPage==='familyMember'){style={width:600,height:350};}if(this.cPage==='childEducation'){style={width:600,height:500};}return style;}//准备完毕、进入填报
//**********************PreInfo**********************
//获取提示信息
//获取提示弹框内的图片地址
//校验表单
//包含两个参数：当前校验表单的类型、校验通过后执行的回调函数
//判断保存弹框内表单后，刷新的是列表还是表单。
//**********************Step**********************
//*********************Title******************
//*****************ButtonIcons*****************
//********************TableUnderSearchGroup********************
},{key:'searchGroupTitle',get:function get(){if(this.cPage==='childEducation'){return getLabel(-1,'子女教育信息');}if(this.cPage==='supportOlder'){return getLabel(-1,'被赡养人信息');}}}]);return HrmTax;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'cPage',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'main';}}),_applyDecoratedDescriptor(_class.prototype,'breadcrumb',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'breadcrumb'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'pageLoading',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'pageLoading'),_class.prototype),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'tConf',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'rConf',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'getRightMenu',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(isEdit){var params={};if(_this6.cPage==='personalInfo'){if(isEdit!==undefined){(0,_assign2.default)(params,{edit:isEdit});}}if(_this6.TAXDEDUCTIONITEMS.includes(_this6.cPage)){(0,_assign2.default)(params,{step:_this6.step.currentIndex+1});}api.getRightMenu(_this6.cPage,params).then(function(data){var btnMenu=data.btnMenu;var _filter=_this6.filter(btnMenu),tConf=_filter.tConf,rConf=_filter.rConf;_this6.tConf=tConf;_this6.rConf=rConf;},function(error){});};}}),_applyDecoratedDescriptor(_class.prototype,'topButtons',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'topButtons'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'dropMenuDatas',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'dropMenuDatas'),_class.prototype),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'changeStepComponentState',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(isIncrease){if(isIncrease){_this7.step.currentIndex++;//切换页面时，需要重置该变量
}else{_this7.step.currentIndex--;}var _step=_this7.step,currentIndex=_step.currentIndex,items=_step.items;items.forEach(function(item,index){if(index<currentIndex){(0,_assign2.default)(item,{status:'finish'});}else if(index===currentIndex){(0,_assign2.default)(item,{status:'process'});}else{(0,_assign2.default)(item,{status:'wait'});}});};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'handleMenuClick',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this8=this;return function(type){if(_this8.BASICINFOITEMS.includes(type)){_this8.cPage=type;}if(type==='personalInfo'){_this8.operatePersonalForm('0');}if(type==='familyMember'){_this8.getRightMenu();_this8.getSearchList();}if(_this8.TAXDEDUCTIONITEMS.includes(type)){_this8.storagePageType(type);_this8.defineDialogTitle(getLabel(-1,'填报前，您需要提前准备以下材料'));_this8.openDialog();_this8.getPreInfo(type);}};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'personalForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{//人员信息表单
form:new _comsMobx.WeaForm(),loading:false,isEdit:'0'};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'dialogForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{//弹框内表单
form:new _comsMobx.WeaForm(),conditions:[],loading:false};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'conditionForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{//提交表单
form:new _comsMobx.WeaForm(),loading:false};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'getForm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this9=this;return function(val){_this9.setParamsToCallFormAPI(val);//判断是否调用个人信息表单
var isCallPersonalForm=_this9.isCallPersonalForm();//判断是否调用弹框内表单
var isCallDialogForm=_this9.isCallDialogForm();//判断是否调用条件表单
var isCallCondtionForm=_this9.isCallCondtionForm();if(isCallPersonalForm){_this9.personalForm.loading=true;}if(isCallDialogForm){_this9.dialogForm.loading=true;}if(isCallCondtionForm){_this9.conditionForm.loading=true;}api.getForm(_this9.cPage,_this9.callFormAPIParams,_this9.step.currentIndex,_this9.formType,_this9.subDialog.visible).then(function(data){var condition=data.condition;if(isCallPersonalForm&&!isCallDialogForm){_this9.initForm('personalForm',condition);}if(isCallDialogForm){//表单上有添加按钮的，在配置数据上添加回调函数。
if(_this9.hasAddBtn(condition)){_this9.addAddBtnEventListener(condition);}_this9.initForm('dialogForm',condition);}if(isCallCondtionForm){_this9.initForm('conditionForm',condition);}},function(error){});};}}),_applyDecoratedDescriptor(_class.prototype,'isRenderCollapseForm',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'isRenderCollapseForm'),_class.prototype),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'tab',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{showSearchAd:false,form:new _comsMobx.WeaForm(),selectedKey:'0',value:''};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'onSearchChange',[_mobx.observable],{enumerable:true,initializer:function initializer(){var _this10=this;return function(val){_this10.tab.value=val;};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'onSearch',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){_this11.getSearchList();};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'onTabChange',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this12=this;return function(key){_this12.tab.selectedKey=key;};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'setShowSearchAd',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this13=this;return function(b){_this13.tab.showSearchAd=b;};}}),_applyDecoratedDescriptor(_class.prototype,'searchsBaseValue',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'searchsBaseValue'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'tabDatas',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'tabDatas'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'searchType',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'searchType'),_class.prototype),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'table',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{comsWeaTableStore:new TableStore()};}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'getSearchList',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this14=this;return function(){var params=_this14.getParamsToCallTableAPI();api.getRecords(_this14.cPage,params).then(function(data){var sessionkey=data.sessionkey;_this14.table.comsWeaTableStore=new TableStore();_this14.table.comsWeaTableStore.getDatas(sessionkey,1);},function(error){});};}}),_applyDecoratedDescriptor(_class.prototype,'dialogButtons',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'dialogButtons'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'moreBtn',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'moreBtn'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'icon',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'icon'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'iconBgcolor',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'iconBgcolor'),_class.prototype),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'dialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{visible:false,title:''};}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'subDialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{visible:false,title:''};}}),_applyDecoratedDescriptor(_class.prototype,'dialogLoading',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'dialogLoading'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'dialogStyle',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'dialogStyle'),_class.prototype),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'openDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this15=this;return function(){if(!_this15.dialog.visible){_this15.dialog.visible=true;}else{_this15.subDialog.visible=true;}};}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'closeDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this16=this;return function(){if(_this16.subDialog.visible){_this16.subDialog.visible=false;}else{_this16.dialog.visible=false;}};}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'defineDialogTitle',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this17=this;return function(title){if(!_this17.dialog.visible){_this17.dialog.title=title;}else{_this17.subDialog.title=title;}};}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'goToDetailPage',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this18=this;return function(){_this18.cPage=_this18.temp;_this18.closeDialog();_this18.getRightMenu();_this18.getStep();_this18.formType='PF';_this18.getForm('0');};}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'preInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'getPreInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this19=this;return function(type){_this19.dialog.loading=true;api.getPreInfo(type).then(function(data){var items=data.items;items.map(function(item,index){(0,_assign2.default)(item,{imgSrc:_this19.getImgSrc(type,index)});});_this19.preInfo=items;_this19.dialog.loading=false;},function(error){});};}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'validateForm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this20=this;return function(formType,callback){_this20[formType].form.validateForm().then(function(f){if(f.isValid){callback&&callback();}else{f.showErrors();}});};}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'step',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{currentIndex:0,items:[]};}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'getStep',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this21=this;return function(){api.getStep(_this21.cPage).then(function(data){var steps=data.steps;steps.map(function(step,index){(0,_assign2.default)(step,{status:index===0?'process':'wait'});});_this21.step.items=steps;},function(error){});};}}),_applyDecoratedDescriptor(_class.prototype,'searchGroupTitle',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'searchGroupTitle'),_class.prototype)),_class);var hrmTax=exports.hrmTax=new HrmTax();

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveDialogForm=exports.getDialogForm=exports.getCondition=exports.getStep=exports.getPreInfo=exports.del=exports.getRecords=exports.getRightMenu=exports.save=exports.getForm=undefined;var _ecCom=__webpack_require__(0);var getForm=exports.getForm=function getForm(cPage){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var currentStepIndex=arguments[2];var formType=arguments[3];var subDialogVisible=arguments[4];if(currentStepIndex===0){switch(cPage){case'personalInfo':case'childEducation':case'continualEducation':case'loan':case'rent':case'supportOlder':return _ecCom.WeaTools.callApi('/api/hrm/pit/personalInfo/getForm','GET',params);break;case'familyMember':return _ecCom.WeaTools.callApi('/api/hrm/pit/familyInfo/getForm','GET',params);break;}}else if(currentStepIndex===1){switch(cPage){case'childEducation':if(formType==='2'){if(subDialogVisible){return _ecCom.WeaTools.callApi('/api/hrm/pit/familyInfo/getForm','GET',params);}else{return _ecCom.WeaTools.callApi('/api/hrm/pit/childrenEdu/getForm','GET',params);}}else{return _ecCom.WeaTools.callApi('/api/hrm/pit/childrenEdu/getCondition','GET',params);}break;}}};var save=exports.save=function save(cPage){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(cPage){case'personalInfo':case'childEducation':case'continualEducation':case'loan':case'rent':case'supportOlder':return _ecCom.WeaTools.callApi('/api/hrm/pit/personalInfo/saveForm','POST',params);break;case'familyMember':return _ecCom.WeaTools.callApi('/api/hrm/pit/familyInfo/saveForm','POST',params);break;}};var getRightMenu=exports.getRightMenu=function getRightMenu(cPage){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(cPage){case'personalInfo':return _ecCom.WeaTools.callApi('/api/hrm/pit/personalInfo/getRightMenu','GET',params);break;case'familyMember':return _ecCom.WeaTools.callApi('/api/hrm/pit/familyInfo/getRightMenu','GET',params);break;case'childEducation':return _ecCom.WeaTools.callApi('/api/hrm/pit/childrenEdu/getRightMenu','GET',params);break;}};var getRecords=exports.getRecords=function getRecords(cPage){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(cPage){case'familyMember':return _ecCom.WeaTools.callApi('/api/hrm/pit/familyInfo/getRecords','GET',params);break;case'childEducation':return _ecCom.WeaTools.callApi('/api/hrm/pit/childrenEdu/getRecords','GET',params);break;}};var del=exports.del=function del(cPage){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(cPage){case'familyMember':return _ecCom.WeaTools.callApi('/api/hrm/pit/familyInfo/delete','POST',params);break;case'childEducation':return _ecCom.WeaTools.callApi('/api/hrm/pit/childrenEdu/delete','POST',params);break;}};var getPreInfo=exports.getPreInfo=function getPreInfo(cPage){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(cPage){case'childEducation':return _ecCom.WeaTools.callApi('/api/hrm/pit/childrenEdu/getInfo','GET',params);break;}};var getStep=exports.getStep=function getStep(cPage){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(cPage){case'childEducation':return _ecCom.WeaTools.callApi('/api/hrm/pit/childrenEdu/getStep','GET',params);break;}};var getCondition=exports.getCondition=function getCondition(cPage){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(cPage){case'childEducation':return _ecCom.WeaTools.callApi('/api/hrm/pit/childrenEdu/getCondition','GET',params);break;}};var getDialogForm=exports.getDialogForm=function getDialogForm(cPage){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(cPage){case'childEducation':return _ecCom.WeaTools.callApi('/api/hrm/pit/childrenEdu/getForm','GET',params);break;}};var saveDialogForm=exports.saveDialogForm=function saveDialogForm(cPage){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(cPage){case'childEducation':return _ecCom.WeaTools.callApi('/api/hrm/pit/childrenEdu/saveForm','POST',params);break;}};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.hrmGroupAdvice=undefined;var _defineProperty=__webpack_require__(14);var _defineProperty2=_interopRequireDefault(_defineProperty);var _extends2=__webpack_require__(12);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(8);var _comsMobx=__webpack_require__(10);var _ecCom=__webpack_require__(0);var _antd=__webpack_require__(6);var _groupAdvice=__webpack_require__(660);var api=_interopRequireWildcard(_groupAdvice);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var HrmGroupAdvice=(_class=function HrmGroupAdvice(){var _this=this;(0,_classCallCheck3.default)(this,HrmGroupAdvice);this.groupId='';this.footerButtons=[React.createElement(_antd.Button,{type:'primary',disabled:this.f.loading,onClick:function onClick(){return _this.submit();}},getLabel(-1,'提交'))];_initDefineProp(this,'f',_descriptor,this);_initDefineProp(this,'getOrgGroupSuggestForm',_descriptor2,this);this.extractParamsFromURL=function(query){var groupId=query.groupId;_this.groupId=groupId;};_initDefineProp(this,'validateForm',_descriptor3,this);this.mail=function(type){var pDialog=top.window.getParentDialog();pDialog&&pDialog.callback(type);};this.saveForm=function(){api.saveOrgGroupSuggest((0,_extends3.default)({groupId:_this.groupId},_this.f.form.getFormParams())).then(function(data){var sign=data.sign;if(sign==='1'){_antd.message.success(data.message);_this.mail('1');}else{_antd.message.warning(data.message);}},function(error){});};this.submit=function(){_this.validateForm(_this.saveForm);};},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'f',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{form:new _comsMobx.WeaForm(),loading:false};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'getOrgGroupSuggestForm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){_this2.f.loading=true;api.getOrgGroupSuggestForm({groupId:_this2.groupId}).then(function(data){var conditions=data.conditions;_this2.f.form=new _comsMobx.WeaForm();_this2.f.form.setCondition(conditions);_this2.f.loading=false;},function(error){});};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'validateForm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(callback){_this3.f.form.validateForm().then(function(f){if(f.isValid){callback&&callback();}else{f.showErrors();}});};}})),_class);var hrmGroupAdvice=exports.hrmGroupAdvice=new HrmGroupAdvice();

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveOrgGroupSuggest=exports.getOrgGroupSuggestForm=undefined;var _ecCom=__webpack_require__(0);var getOrgGroupSuggestForm=exports.getOrgGroupSuggestForm=function getOrgGroupSuggestForm(params){return _ecCom.WeaTools.callApi('/api/hrm/group/getGroupSuggestForm','GET',params);};var saveOrgGroupSuggest=exports.saveOrgGroupSuggest=function saveOrgGroupSuggest(params){return _ecCom.WeaTools.callApi('/api/hrm/group/saveGroupSuggest','POST',params);};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js?v=a818078e